/*! shopify_app_compiler 2026-10-02 */
var requirejs, require, define;

!function(global, setTimeout) {
    var req, s, head, baseElement, dataMain, src, interactiveScript, currentlyAddingScript, mainScript, subPath, version = "2.3.6", commentRegExp = /\/\*[\s\S]*?\*\/|([^:"'=]|^)\/\/.*$/gm, cjsRequireRegExp = /[^.]\s*require\s*\(\s*["']([^'"\s]+)["']\s*\)/g, jsSuffixRegExp = /\.js$/, currDirRegExp = /^\.\//, op = Object.prototype, ostring = op.toString, hasOwn = op.hasOwnProperty, isBrowser = !("undefined" == typeof window || "undefined" == typeof navigator || !window.document), isWebWorker = !isBrowser && "undefined" != typeof importScripts, readyRegExp = isBrowser && "PLAYSTATION 3" === navigator.platform ? /^complete$/ : /^(complete|loaded)$/, defContextName = "_", isOpera = "undefined" != typeof opera && "[object Opera]" === opera.toString(), contexts = {}, cfg = {}, globalDefQueue = [], useInteractive = !1;
    function commentReplace(e, t) {
        return t || "";
    }
    function isFunction(e) {
        return "[object Function]" === ostring.call(e);
    }
    function isArray(e) {
        return "[object Array]" === ostring.call(e);
    }
    function each(e, t) {
        var i;
        if (e) for (i = 0; i < e.length && (!e[i] || !t(e[i], i, e)); i += 1);
    }
    function eachReverse(e, t) {
        var i;
        if (e) for (i = e.length - 1; -1 < i && (!e[i] || !t(e[i], i, e)); i -= 1);
    }
    function hasProp(e, t) {
        return hasOwn.call(e, t);
    }
    function getOwn(e, t) {
        return hasProp(e, t) && e[t];
    }
    function eachProp(e, t) {
        var i;
        for (i in e) if (hasProp(e, i) && t(e[i], i)) break;
    }
    function mixin(i, e, r, n) {
        return e && eachProp(e, function(e, t) {
            !r && hasProp(i, t) || (!n || "object" != typeof e || !e || isArray(e) || isFunction(e) || e instanceof RegExp ? i[t] = e : (i[t] || (i[t] = {}), 
            mixin(i[t], e, r, n)));
        }), i;
    }
    function bind(e, t) {
        return function() {
            return t.apply(e, arguments);
        };
    }
    function scripts() {
        return document.getElementsByTagName("script");
    }
    function defaultOnError(e) {
        throw e;
    }
    function getGlobal(e) {
        if (!e) return e;
        var t = global;
        return each(e.split("."), function(e) {
            t = t[e];
        }), t;
    }
    function makeError(e, t, i, r) {
        var n = new Error(t + "\nhttps://requirejs.org/docs/errors.html#" + e);
        return n.requireType = e, n.requireModules = r, i && (n.originalError = i), 
        n;
    }
    if (void 0 === define) {
        if (void 0 !== requirejs) {
            if (isFunction(requirejs)) return;
            cfg = requirejs, requirejs = void 0;
        }
        void 0 === require || isFunction(require) || (cfg = require, require = void 0), 
        req = requirejs = function(e, t, i, r) {
            var n, o, a = defContextName;
            return isArray(e) || "string" == typeof e || (o = e, isArray(t) ? (e = t, 
            t = i, i = r) : e = []), o && o.context && (a = o.context), (n = getOwn(contexts, a)) || (n = contexts[a] = req.s.newContext(a)), 
            o && n.configure(o), n.require(e, t, i);
        }, req.config = function(e) {
            return req(e);
        }, req.nextTick = void 0 !== setTimeout ? function(e) {
            setTimeout(e, 4);
        } : function(e) {
            e();
        }, require || (require = req), req.version = version, req.jsExtRegExp = /^\/|:|\?|\.js$/, 
        req.isBrowser = isBrowser, s = req.s = {
            contexts: contexts,
            newContext: newContext
        }, req({}), each([ "toUrl", "undef", "defined", "specified" ], function(t) {
            req[t] = function() {
                var e = contexts[defContextName];
                return e.require[t].apply(e, arguments);
            };
        }), isBrowser && (head = s.head = document.getElementsByTagName("head")[0], 
        baseElement = document.getElementsByTagName("base")[0], baseElement && (head = s.head = baseElement.parentNode)), 
        req.onError = defaultOnError, req.createNode = function(e, t, i) {
            var r = e.xhtml ? document.createElementNS("http://www.w3.org/1999/xhtml", "html:script") : document.createElement("script");
            return r.type = e.scriptType || "text/javascript", r.charset = "utf-8", 
            r.async = !0, r;
        }, req.load = function(t, i, r) {
            var e, n = t && t.config || {};
            if (isBrowser) return (e = req.createNode(n, i, r)).setAttribute("data-requirecontext", t.contextName), 
            e.setAttribute("data-requiremodule", i), !e.attachEvent || e.attachEvent.toString && e.attachEvent.toString().indexOf("[native code") < 0 || isOpera ? (e.addEventListener("load", t.onScriptLoad, !1), 
            e.addEventListener("error", t.onScriptError, !1)) : (useInteractive = !0, 
            e.attachEvent("onreadystatechange", t.onScriptLoad)), e.src = r, n.onNodeCreated && n.onNodeCreated(e, n, i, r), 
            currentlyAddingScript = e, baseElement ? head.insertBefore(e, baseElement) : head.appendChild(e), 
            currentlyAddingScript = null, e;
            if (isWebWorker) try {
                setTimeout(function() {}, 0), importScripts(r), t.completeLoad(i);
            } catch (e) {
                t.onError(makeError("importscripts", "importScripts failed for " + i + " at " + r, e, [ i ]));
            }
        }, isBrowser && !cfg.skipDataMain && eachReverse(scripts(), function(e) {
            if (head || (head = e.parentNode), dataMain = e.getAttribute("data-main")) return mainScript = dataMain, 
            cfg.baseUrl || -1 !== mainScript.indexOf("!") || (mainScript = (src = mainScript.split("/")).pop(), 
            subPath = src.length ? src.join("/") + "/" : "./", cfg.baseUrl = subPath), 
            mainScript = mainScript.replace(jsSuffixRegExp, ""), req.jsExtRegExp.test(mainScript) && (mainScript = dataMain), 
            cfg.deps = cfg.deps ? cfg.deps.concat(mainScript) : [ mainScript ], 
            !0;
        }), define = function(e, i, t) {
            var r, n;
            "string" != typeof e && (t = i, i = e, e = null), isArray(i) || (t = i, 
            i = null), !i && isFunction(t) && (i = [], t.length && (t.toString().replace(commentRegExp, commentReplace).replace(cjsRequireRegExp, function(e, t) {
                i.push(t);
            }), i = (1 === t.length ? [ "require" ] : [ "require", "exports", "module" ]).concat(i))), 
            useInteractive && (r = currentlyAddingScript || getInteractiveScript()) && (e || (e = r.getAttribute("data-requiremodule")), 
            n = contexts[r.getAttribute("data-requirecontext")]), n ? (n.defQueue.push([ e, i, t ]), 
            n.defQueueMap[e] = !0) : globalDefQueue.push([ e, i, t ]);
        }, define.amd = {
            jQuery: !0
        }, req.exec = function(text) {
            return eval(text);
        }, req(cfg);
    }
    function newContext(u) {
        var i, e, l, c, d, g = {
            waitSeconds: 7,
            baseUrl: "./",
            paths: {},
            bundles: {},
            pkgs: {},
            shim: {},
            config: {}
        }, p = {}, f = {}, r = {}, h = [], m = {}, n = {}, v = {}, x = 1, b = 1;
        function q(e, t, i) {
            var r, n, o, a, s, u, c, d, p, f, l = t && t.split("/"), h = g.map, m = h && h["*"];
            if (e && (u = (e = e.split("/")).length - 1, g.nodeIdCompat && jsSuffixRegExp.test(e[u]) && (e[u] = e[u].replace(jsSuffixRegExp, "")), 
            "." === e[0].charAt(0) && l && (e = l.slice(0, l.length - 1).concat(e)), 
            function(e) {
                var t, i;
                for (t = 0; t < e.length; t++) if ("." === (i = e[t])) e.splice(t, 1), 
                t -= 1; else if (".." === i) {
                    if (0 === t || 1 === t && ".." === e[2] || ".." === e[t - 1]) continue;
                    0 < t && (e.splice(t - 1, 2), t -= 2);
                }
            }(e), e = e.join("/")), i && h && (l || m)) {
                e: for (o = (n = e.split("/")).length; 0 < o; o -= 1) {
                    if (s = n.slice(0, o).join("/"), l) for (a = l.length; 0 < a; a -= 1) if ((r = getOwn(h, l.slice(0, a).join("/"))) && (r = getOwn(r, s))) {
                        c = r, d = o;
                        break e;
                    }
                    !p && m && getOwn(m, s) && (p = getOwn(m, s), f = o);
                }
                !c && p && (c = p, d = f), c && (n.splice(0, d, c), e = n.join("/"));
            }
            return getOwn(g.pkgs, e) || e;
        }
        function E(t) {
            isBrowser && each(scripts(), function(e) {
                if (e.getAttribute("data-requiremodule") === t && e.getAttribute("data-requirecontext") === l.contextName) return e.parentNode.removeChild(e), 
                !0;
            });
        }
        function w(e) {
            var t = getOwn(g.paths, e);
            if (t && isArray(t) && 1 < t.length) return t.shift(), l.require.undef(e), 
            l.makeRequire(null, {
                skipMap: !0
            })([ e ]), !0;
        }
        function y(e) {
            var t, i = e ? e.indexOf("!") : -1;
            return -1 < i && (t = e.substring(0, i), e = e.substring(i + 1, e.length)), 
            [ t, e ];
        }
        function S(e, t, i, r) {
            var n, o, a, s, u = null, c = t ? t.name : null, d = e, p = !0, f = "";
            return e || (p = !1, e = "_@r" + (x += 1)), u = (s = y(e))[0], e = s[1], 
            u && (u = q(u, c, r), o = getOwn(m, u)), e && (u ? f = i ? e : o && o.normalize ? o.normalize(e, function(e) {
                return q(e, c, r);
            }) : -1 === e.indexOf("!") ? q(e, c, r) : e : (u = (s = y(f = q(e, c, r)))[0], 
            f = s[1], i = !0, n = l.nameToUrl(f))), {
                prefix: u,
                name: f,
                parentMap: t,
                unnormalized: !!(a = !u || o || i ? "" : "_unnormalized" + (b += 1)),
                url: n,
                originalName: d,
                isDefine: p,
                id: (u ? u + "!" + f : f) + a
            };
        }
        function k(e) {
            var t = e.id, i = getOwn(p, t);
            return i || (i = p[t] = new l.Module(e)), i;
        }
        function M(e, t, i) {
            var r = e.id, n = getOwn(p, r);
            !hasProp(m, r) || n && !n.defineEmitComplete ? (n = k(e)).error && "error" === t ? i(n.error) : n.on(t, i) : "defined" === t && i(m[r]);
        }
        function O(i, e) {
            var t = i.requireModules, r = !1;
            e ? e(i) : (each(t, function(e) {
                var t = getOwn(p, e);
                t && (t.error = i, t.events.error && (r = !0, t.emit("error", i)));
            }), r || req.onError(i));
        }
        function j() {
            globalDefQueue.length && (each(globalDefQueue, function(e) {
                var t = e[0];
                "string" == typeof t && (l.defQueueMap[t] = !0), h.push(e);
            }), globalDefQueue = []);
        }
        function P(e) {
            delete p[e], delete f[e];
        }
        function R() {
            var e, r, t = 1e3 * g.waitSeconds, n = t && l.startTime + t < new Date().getTime(), o = [], a = [], s = !1, u = !0;
            if (!i) {
                if (i = !0, eachProp(f, function(e) {
                    var t = e.map, i = t.id;
                    if (e.enabled && (t.isDefine || a.push(e), !e.error)) if (!e.inited && n) w(i) ? s = r = !0 : (o.push(i), 
                    E(i)); else if (!e.inited && e.fetched && t.isDefine && (s = !0, 
                    !t.prefix)) return u = !1;
                }), n && o.length) return (e = makeError("timeout", "Load timeout for modules: " + o, null, o)).contextName = l.contextName, 
                O(e);
                u && each(a, function(e) {
                    !function n(o, a, s) {
                        var e = o.map.id;
                        o.error ? o.emit("error", o.error) : (a[e] = !0, each(o.depMaps, function(e, t) {
                            var i = e.id, r = getOwn(p, i);
                            !r || o.depMatched[t] || s[i] || (getOwn(a, i) ? (o.defineDep(t, m[i]), 
                            o.check()) : n(r, a, s));
                        }), s[e] = !0);
                    }(e, {}, {});
                }), n && !r || !s || !isBrowser && !isWebWorker || d || (d = setTimeout(function() {
                    d = 0, R();
                }, 50)), i = !1;
            }
        }
        function a(e) {
            hasProp(m, e[0]) || k(S(e[0], null, !0)).init(e[1], e[2]);
        }
        function o(e, t, i, r) {
            e.detachEvent && !isOpera ? r && e.detachEvent(r, t) : e.removeEventListener(i, t, !1);
        }
        function s(e) {
            var t = e.currentTarget || e.srcElement;
            return o(t, l.onScriptLoad, "load", "onreadystatechange"), o(t, l.onScriptError, "error"), 
            {
                node: t,
                id: t && t.getAttribute("data-requiremodule")
            };
        }
        function T() {
            var e;
            for (j(); h.length; ) {
                if (null === (e = h.shift())[0]) return O(makeError("mismatch", "Mismatched anonymous define() module: " + e[e.length - 1]));
                a(e);
            }
            l.defQueueMap = {};
        }
        return c = {
            require: function(e) {
                return e.require ? e.require : e.require = l.makeRequire(e.map);
            },
            exports: function(e) {
                if (e.usingExports = !0, e.map.isDefine) return e.exports ? m[e.map.id] = e.exports : e.exports = m[e.map.id] = {};
            },
            module: function(e) {
                return e.module ? e.module : e.module = {
                    id: e.map.id,
                    uri: e.map.url,
                    config: function() {
                        return getOwn(g.config, e.map.id) || {};
                    },
                    exports: e.exports || (e.exports = {})
                };
            }
        }, (e = function(e) {
            this.events = getOwn(r, e.id) || {}, this.map = e, this.shim = getOwn(g.shim, e.id), 
            this.depExports = [], this.depMaps = [], this.depMatched = [], this.pluginMaps = {}, 
            this.depCount = 0;
        }).prototype = {
            init: function(e, t, i, r) {
                r = r || {}, this.inited || (this.factory = t, i ? this.on("error", i) : this.events.error && (i = bind(this, function(e) {
                    this.emit("error", e);
                })), this.depMaps = e && e.slice(0), this.errback = i, this.inited = !0, 
                this.ignore = r.ignore, r.enabled || this.enabled ? this.enable() : this.check());
            },
            defineDep: function(e, t) {
                this.depMatched[e] || (this.depMatched[e] = !0, this.depCount -= 1, 
                this.depExports[e] = t);
            },
            fetch: function() {
                if (!this.fetched) {
                    this.fetched = !0, l.startTime = new Date().getTime();
                    var e = this.map;
                    if (!this.shim) return e.prefix ? this.callPlugin() : this.load();
                    l.makeRequire(this.map, {
                        enableBuildCallback: !0
                    })(this.shim.deps || [], bind(this, function() {
                        return e.prefix ? this.callPlugin() : this.load();
                    }));
                }
            },
            load: function() {
                var e = this.map.url;
                n[e] || (n[e] = !0, l.load(this.map.id, e));
            },
            check: function() {
                if (this.enabled && !this.enabling) {
                    var t, e, i = this.map.id, r = this.depExports, n = this.exports, o = this.factory;
                    if (this.inited) {
                        if (this.error) this.emit("error", this.error); else if (!this.defining) {
                            if (this.defining = !0, this.depCount < 1 && !this.defined) {
                                if (isFunction(o)) {
                                    if (this.events.error && this.map.isDefine || req.onError !== defaultOnError) try {
                                        n = l.execCb(i, o, r, n);
                                    } catch (e) {
                                        t = e;
                                    } else n = l.execCb(i, o, r, n);
                                    if (this.map.isDefine && void 0 === n && ((e = this.module) ? n = e.exports : this.usingExports && (n = this.exports)), 
                                    t) return t.requireMap = this.map, t.requireModules = this.map.isDefine ? [ this.map.id ] : null, 
                                    t.requireType = this.map.isDefine ? "define" : "require", 
                                    O(this.error = t);
                                } else n = o;
                                if (this.exports = n, this.map.isDefine && !this.ignore && (m[i] = n, 
                                req.onResourceLoad)) {
                                    var a = [];
                                    each(this.depMaps, function(e) {
                                        a.push(e.normalizedMap || e);
                                    }), req.onResourceLoad(l, this.map, a);
                                }
                                P(i), this.defined = !0;
                            }
                            this.defining = !1, this.defined && !this.defineEmitted && (this.defineEmitted = !0, 
                            this.emit("defined", this.exports), this.defineEmitComplete = !0);
                        }
                    } else hasProp(l.defQueueMap, i) || this.fetch();
                }
            },
            callPlugin: function() {
                var u = this.map, c = u.id, e = S(u.prefix);
                this.depMaps.push(e), M(e, "defined", bind(this, function(e) {
                    var o, t, i, r = getOwn(v, this.map.id), n = this.map.name, a = this.map.parentMap ? this.map.parentMap.name : null, s = l.makeRequire(u.parentMap, {
                        enableBuildCallback: !0
                    });
                    return this.map.unnormalized ? (e.normalize && (n = e.normalize(n, function(e) {
                        return q(e, a, !0);
                    }) || ""), M(t = S(u.prefix + "!" + n, this.map.parentMap, !0), "defined", bind(this, function(e) {
                        this.map.normalizedMap = t, this.init([], function() {
                            return e;
                        }, null, {
                            enabled: !0,
                            ignore: !0
                        });
                    })), void ((i = getOwn(p, t.id)) && (this.depMaps.push(t), this.events.error && i.on("error", bind(this, function(e) {
                        this.emit("error", e);
                    })), i.enable()))) : r ? (this.map.url = l.nameToUrl(r), void this.load()) : ((o = bind(this, function(e) {
                        this.init([], function() {
                            return e;
                        }, null, {
                            enabled: !0
                        });
                    })).error = bind(this, function(e) {
                        this.inited = !0, (this.error = e).requireModules = [ c ], 
                        eachProp(p, function(e) {
                            0 === e.map.id.indexOf(c + "_unnormalized") && P(e.map.id);
                        }), O(e);
                    }), o.fromText = bind(this, function(e, t) {
                        var i = u.name, r = S(i), n = useInteractive;
                        t && (e = t), n && (useInteractive = !1), k(r), hasProp(g.config, c) && (g.config[i] = g.config[c]);
                        try {
                            req.exec(e);
                        } catch (e) {
                            return O(makeError("fromtexteval", "fromText eval for " + c + " failed: " + e, e, [ c ]));
                        }
                        n && (useInteractive = !0), this.depMaps.push(r), l.completeLoad(i), 
                        s([ i ], o);
                    }), void e.load(u.name, s, o, g));
                })), l.enable(e, this), this.pluginMaps[e.id] = e;
            },
            enable: function() {
                (f[this.map.id] = this).enabled = !0, this.enabling = !0, each(this.depMaps, bind(this, function(e, t) {
                    var i, r, n;
                    if ("string" == typeof e) {
                        if (e = S(e, this.map.isDefine ? this.map : this.map.parentMap, !1, !this.skipMap), 
                        this.depMaps[t] = e, n = getOwn(c, e.id)) return void (this.depExports[t] = n(this));
                        this.depCount += 1, M(e, "defined", bind(this, function(e) {
                            this.undefed || (this.defineDep(t, e), this.check());
                        })), this.errback ? M(e, "error", bind(this, this.errback)) : this.events.error && M(e, "error", bind(this, function(e) {
                            this.emit("error", e);
                        }));
                    }
                    i = e.id, r = p[i], hasProp(c, i) || !r || r.enabled || l.enable(e, this);
                })), eachProp(this.pluginMaps, bind(this, function(e) {
                    var t = getOwn(p, e.id);
                    t && !t.enabled && l.enable(e, this);
                })), this.enabling = !1, this.check();
            },
            on: function(e, t) {
                var i = this.events[e];
                i || (i = this.events[e] = []), i.push(t);
            },
            emit: function(e, t) {
                each(this.events[e], function(e) {
                    e(t);
                }), "error" === e && delete this.events[e];
            }
        }, (l = {
            config: g,
            contextName: u,
            registry: p,
            defined: m,
            urlFetched: n,
            defQueue: h,
            defQueueMap: {},
            Module: e,
            makeModuleMap: S,
            nextTick: req.nextTick,
            onError: O,
            configure: function(e) {
                if (e.baseUrl && "/" !== e.baseUrl.charAt(e.baseUrl.length - 1) && (e.baseUrl += "/"), 
                "string" == typeof e.urlArgs) {
                    var i = e.urlArgs;
                    e.urlArgs = function(e, t) {
                        return (-1 === t.indexOf("?") ? "?" : "&") + i;
                    };
                }
                var r = g.shim, n = {
                    paths: !0,
                    bundles: !0,
                    config: !0,
                    map: !0
                };
                eachProp(e, function(e, t) {
                    n[t] ? (g[t] || (g[t] = {}), mixin(g[t], e, !0, !0)) : g[t] = e;
                }), e.bundles && eachProp(e.bundles, function(e, t) {
                    each(e, function(e) {
                        e !== t && (v[e] = t);
                    });
                }), e.shim && (eachProp(e.shim, function(e, t) {
                    isArray(e) && (e = {
                        deps: e
                    }), !e.exports && !e.init || e.exportsFn || (e.exportsFn = l.makeShimExports(e)), 
                    r[t] = e;
                }), g.shim = r), e.packages && each(e.packages, function(e) {
                    var t;
                    t = (e = "string" == typeof e ? {
                        name: e
                    } : e).name, e.location && (g.paths[t] = e.location), g.pkgs[t] = e.name + "/" + (e.main || "main").replace(currDirRegExp, "").replace(jsSuffixRegExp, "");
                }), eachProp(p, function(e, t) {
                    e.inited || e.map.unnormalized || (e.map = S(t, null, !0));
                }), (e.deps || e.callback) && l.require(e.deps || [], e.callback);
            },
            makeShimExports: function(t) {
                return function() {
                    var e;
                    return t.init && (e = t.init.apply(global, arguments)), e || t.exports && getGlobal(t.exports);
                };
            },
            makeRequire: function(o, a) {
                function s(e, t, i) {
                    var r, n;
                    return a.enableBuildCallback && t && isFunction(t) && (t.__requireJsBuild = !0), 
                    "string" == typeof e ? isFunction(t) ? O(makeError("requireargs", "Invalid require call"), i) : o && hasProp(c, e) ? c[e](p[o.id]) : req.get ? req.get(l, e, o, s) : (r = S(e, o, !1, !0).id, 
                    hasProp(m, r) ? m[r] : O(makeError("notloaded", 'Module name "' + r + '" has not been loaded yet for context: ' + u + (o ? "" : ". Use require([])")))) : (T(), 
                    l.nextTick(function() {
                        T(), (n = k(S(null, o))).skipMap = a.skipMap, n.init(e, t, i, {
                            enabled: !0
                        }), R();
                    }), s);
                }
                return a = a || {}, mixin(s, {
                    isBrowser: isBrowser,
                    toUrl: function(e) {
                        var t, i = e.lastIndexOf("."), r = e.split("/")[0];
                        return -1 !== i && (!("." === r || ".." === r) || 1 < i) && (t = e.substring(i, e.length), 
                        e = e.substring(0, i)), l.nameToUrl(q(e, o && o.id, !0), t, !0);
                    },
                    defined: function(e) {
                        return hasProp(m, S(e, o, !1, !0).id);
                    },
                    specified: function(e) {
                        return e = S(e, o, !1, !0).id, hasProp(m, e) || hasProp(p, e);
                    }
                }), o || (s.undef = function(i) {
                    j();
                    var e = S(i, o, !0), t = getOwn(p, i);
                    t.undefed = !0, E(i), delete m[i], delete n[e.url], delete r[i], 
                    eachReverse(h, function(e, t) {
                        e[0] === i && h.splice(t, 1);
                    }), delete l.defQueueMap[i], t && (t.events.defined && (r[i] = t.events), 
                    P(i));
                }), s;
            },
            enable: function(e) {
                getOwn(p, e.id) && k(e).enable();
            },
            completeLoad: function(e) {
                var t, i, r, n = getOwn(g.shim, e) || {}, o = n.exports;
                for (j(); h.length; ) {
                    if (null === (i = h.shift())[0]) {
                        if (i[0] = e, t) break;
                        t = !0;
                    } else i[0] === e && (t = !0);
                    a(i);
                }
                if (l.defQueueMap = {}, r = getOwn(p, e), !t && !hasProp(m, e) && r && !r.inited) {
                    if (!(!g.enforceDefine || o && getGlobal(o))) return w(e) ? void 0 : O(makeError("nodefine", "No define call for " + e, null, [ e ]));
                    a([ e, n.deps || [], n.exportsFn ]);
                }
                R();
            },
            nameToUrl: function(e, t, i) {
                var r, n, o, a, s, u, c = getOwn(g.pkgs, e);
                if (c && (e = c), u = getOwn(v, e)) return l.nameToUrl(u, t, i);
                if (req.jsExtRegExp.test(e)) a = e + (t || ""); else {
                    for (r = g.paths, o = (n = e.split("/")).length; 0 < o; o -= 1) if (s = getOwn(r, n.slice(0, o).join("/"))) {
                        isArray(s) && (s = s[0]), n.splice(0, o, s);
                        break;
                    }
                    a = n.join("/"), a = ("/" === (a += t || (/^data\:|^blob\:|\?/.test(a) || i ? "" : ".js")).charAt(0) || a.match(/^[\w\+\.\-]+:/) ? "" : g.baseUrl) + a;
                }
                return g.urlArgs && !/^blob\:/.test(a) ? a + g.urlArgs(e, a) : a;
            },
            load: function(e, t) {
                req.load(l, e, t);
            },
            execCb: function(e, t, i, r) {
                return t.apply(r, i);
            },
            onScriptLoad: function(e) {
                if ("load" === e.type || readyRegExp.test((e.currentTarget || e.srcElement).readyState)) {
                    interactiveScript = null;
                    var t = s(e);
                    l.completeLoad(t.id);
                }
            },
            onScriptError: function(e) {
                var i = s(e);
                if (!w(i.id)) {
                    var r = [];
                    return eachProp(p, function(e, t) {
                        0 !== t.indexOf("_@r") && each(e.depMaps, function(e) {
                            if (e.id === i.id) return r.push(t), !0;
                        });
                    }), O(makeError("scripterror", 'Script error for "' + i.id + (r.length ? '", needed by: ' + r.join(", ") : '"'), e, [ i.id ]));
                }
            }
        }).require = l.makeRequire(), l;
    }
    function getInteractiveScript() {
        return interactiveScript && "interactive" === interactiveScript.readyState || eachReverse(scripts(), function(e) {
            if ("interactive" === e.readyState) return interactiveScript = e;
        }), interactiveScript;
    }
}(this, "undefined" == typeof setTimeout ? void 0 : setTimeout);

var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

var __extends = this && this.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || {
            __proto__: []
        } instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, 
        new __());
    };
}();

var __assign = this && this.__assign || function() {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

var __generator = this && this.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        throw: verb(1),
        return: verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([ n, v ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 
            0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [ op[0] & 2, t.value ];
            switch (op[0]) {
              case 0:
              case 1:
                t = op;
                break;

              case 4:
                _.label++;
                return {
                    value: op[1],
                    done: false
                };

              case 5:
                _.label++;
                y = op[1];
                op = [ 0 ];
                continue;

              case 7:
                op = _.ops.pop();
                _.trys.pop();
                continue;

              default:
                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                }
                if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                    _.label = op[1];
                    break;
                }
                if (op[0] === 6 && _.label < t[1]) {
                    _.label = t[1];
                    t = op;
                    break;
                }
                if (t && _.label < t[2]) {
                    _.label = t[2];
                    _.ops.push(op);
                    break;
                }
                if (t[2]) _.ops.pop();
                _.trys.pop();
                continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [ 6, e ];
            y = 0;
        } finally {
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};

define("core/shopify-app/st-modules/_general-methods/dom-loaded", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDOMLoaded = void 0;
    var StDOMLoaded = function() {
        function StDOMLoaded() {
            var _this = this;
            this.className = "DOMLoaded";
            this.domLoaded = false;
            this.domLoadedCallbacks = [];
            this.readyStateChange = function() {
                if (document.readyState === "interactive") {
                    _this.domLoaded = true;
                    _this.fireDOMLoadedCallbacks();
                }
            };
            this.fireDOMLoadedCallbacks = function() {
                for (var i = 0; i < _this.domLoadedCallbacks.length; i++) {
                    _this.domLoadedCallbacks[i]();
                }
            };
            this.subscribeDOMLoaded = function(cb) {
                if (_this.domLoaded) {
                    cb();
                } else {
                    _this.domLoadedCallbacks.push(cb);
                }
            };
        }
        StDOMLoaded.Instance = function() {
            return this._instance || (this._instance = new this());
        };
        StDOMLoaded.prototype.initDOMLoaded = function() {
            if (!StDOMLoaded.initStarted) {
                StDOMLoaded.initStarted = true;
                if (document.readyState === "interactive" || document.readyState === "complete") {
                    this.domLoaded = true;
                    this.fireDOMLoadedCallbacks();
                } else {
                    document.addEventListener("readystatechange", this.readyStateChange, false);
                }
            }
        };
        StDOMLoaded.initStarted = false;
        return StDOMLoaded;
    }();
    exports.StDOMLoaded = StDOMLoaded;
});

define("core/connector-app/_shared/routes.config", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.endpointData = void 0;
    exports.endpointData = {
        webalias: {
            repSite: "||-API-ROOT-||/webalias/sca/repSite"
        },
        webhook: {
            removeAll: "||-API-ROOT-||/webhook/gar/removeAll"
        },
        customer: {
            updatePersonalInfo: "||-API-ROOT-||/customer/sca/updatePersonalInfo",
            updateWebAlias: "||-API-ROOT-||/customer/sca/updateWebAlias",
            updateSponsor: "||-API-ROOT-||/customer/sca/updateSponsor",
            "get-rep-details": "||-API-ROOT-||/customer/gar/get-rep-details",
            "update-consultant-rank-webhook": "||-API-ROOT-||/customer/sca/update-consultant-rank-webhook",
            "customer-login": "||-API-ROOT-||/customer/gar/customer-login",
            "downgrade-consultant-webhook": "||-API-ROOT-||/customer/sca/downgrade-consultant-webhook",
            tags: "||-API-ROOT-||/customer/gar/tags",
            "address-checkout": "||-API-ROOT-||/customer/gar/address-checkout",
            "address-my-account-shipping": "||-API-ROOT-||/customer/gar/address-my-account-shipping",
            "address-my-account-billing": "||-API-ROOT-||/customer/gar/address-my-account-billing",
            "postal-code": "||-API-ROOT-||/customer/gar/postal-code",
            "rep-lookup": "||-API-ROOT-||/customer/gar/rep-lookup"
        },
        auth: {
            sso: "||-API-ROOT-||/auth/sca/sso",
            "get-jwt": "||-API-ROOT-||/auth/sca/get-jwt",
            "refresh-jwt": "||-API-ROOT-||/auth/sca/refresh-jwt"
        },
        order: {
            "order-details": "||-API-ROOT-||/order/gar/order-details",
            "orders-from-bdt": "||-API-ROOT-||/order/gar/orders-from-bdt",
            "orders-details-from-bdt": "||-API-ROOT-||/order/gar/orders-details-from-bdt",
            "order-invoice": "||-API-ROOT-||/order/gar/order-invoice"
        },
        "order-credits": {
            "get-customer-credits": "||-API-ROOT-||/order-credits/sca/get-customer-credits",
            "get-all-customer-ledger": "||-API-ROOT-||/order-credits/sca/get-all-customer-ledger",
            "get-all-credits-for-ledger": "||-API-ROOT-||/order-credits/sca/get-all-credits-for-ledger",
            "add-remove-credits-for-ledger": "||-API-ROOT-||/order-credits/sca/add-remove-credits-for-ledger"
        },
        party: {
            "party-validation": "||-API-ROOT-||/party/sca/party-validation",
            "party-banner-information": "||-API-ROOT-||/party/sca/party-banner-information"
        },
        product: {},
        enrollment: {
            "validate-data": "||-API-ROOT-||/enrollment/sca/validate-data",
            submit: "||-API-ROOT-||/enrollment/sca/submit",
            createAccount: "||-API-ROOT-||/enrollment/sca/createAccount"
        },
        searchSponsor: {
            getSponsorInfo: "||-API-ROOT-||/searchSponsor/sca/getSponsorInfo",
            getSponsorByPersonalInfo: "||-API-ROOT-||/searchSponsor/sca/getSponsorByPersonalInfo"
        },
        "market-type": {
            "get-market-type": "||-API-ROOT-||/market-type/sca/get-market-type"
        },
        mailing: {},
        cart: {
            "save-customer-cart": "||-API-ROOT-||/cart/gar/save-customer-cart",
            "get-customer-cart": "||-API-ROOT-||/cart/gar/get-customer-cart"
        },
        multipass: {
            "generate-link": "||-API-ROOT-||/multipass/sca/generate-link"
        }
    };
});

define("core/shopify-app/st-modules/_static/static", [ "require", "exports", "core/connector-app/_shared/routes.config" ], function(require, exports, routes_config_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StStatic = void 0;
    var StStatic = function() {
        function StStatic() {
            var _this = this;
            var _a, _b;
            this.className = "Static";
            this.shopConfig = window.stAppConfig;
            this.apiRoot = this.shopConfig.apiRoot;
            this.apiRootDev = (_a = this.shopConfig) === null || _a === void 0 ? void 0 : _a.apiRootDev;
            this.apiMode = (_b = this.shopConfig) === null || _b === void 0 ? void 0 : _b.apiMode;
            this.init = function() {};
            this.setup = function() {};
            this.obtainStaticEndpoints = function() {
                return _this.endpoint;
            };
            this.obtainMainScope = function() {
                return window.stApp;
            };
            this.obtainCart = function() {
                return window.shopifyCartData;
            };
            this.injectRootToEndpoints = function(endpoints) {
                var apiRoot = _this.getApiRoot();
                for (var controllerKey in endpoints) {
                    for (var endpoint in endpoints[controllerKey]) {
                        endpoints[controllerKey][endpoint] = endpoints[controllerKey][endpoint].replace(/\|\|-API-ROOT-\|\|/g, apiRoot);
                    }
                }
                return endpoints;
            };
            this.getApiRoot = function() {
                if (!_this.apiMode) {
                    return _this.apiRoot;
                }
                return _this.apiMode === "development" ? _this.apiRootDev : _this.apiRoot;
            };
            this.endpoint = this.injectRootToEndpoints(routes_config_1.endpointData);
        }
        StStatic.Instance = function() {
            return this._instance || (this._instance = new this());
        };
        return StStatic;
    }();
    exports.StStatic = StStatic;
});

define("core/shopify-app/st-modules/_di-container/st.module", [ "require", "exports", "core/shopify-app/st-modules/_general-methods/ajax", "core/shopify-app/st-modules/_static/static", "core/shopify-app/st-modules/_general-methods/dom-loaded" ], function(require, exports, ajax_1, static_1, dom_loaded_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StModule = void 0;
    var StModule = function() {
        function StModule(args) {
            var _this = this;
            this.dependency = [];
            this.init = function() {};
            this.setup = function() {
                if (!_this.setupFlag) {
                    if (_this.hasOwnProperty("init")) {
                        console.log("Init : ", _this.className);
                        _this.setupFlag = true;
                        _this.init();
                        _this.dependency.forEach(function(dependency) {
                            dependency.setup();
                        });
                    }
                }
            };
            this.dependency = args && args.length > 0 ? __spreadArray([], args, true) : [];
            this.Static = static_1.StStatic.Instance();
            this.endpoint = this.Static.obtainStaticEndpoints();
            this.cart = this.Static.obtainCart();
            this.ajax = ajax_1.StAjax.Instance();
            this.subscribeDOMLoaded = dom_loaded_1.StDOMLoaded.Instance().subscribeDOMLoaded;
            this.setupFlag = false;
        }
        return StModule;
    }();
    exports.StModule = StModule;
});

define("core/shopify-app/st-modules/_general-methods/notification", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StNotification = exports.ENotificationType = void 0;
    var ENotificationType;
    (function(ENotificationType) {
        ENotificationType["success"] = "success";
        ENotificationType["error"] = "error";
        ENotificationType["info"] = "info";
    })(ENotificationType = exports.ENotificationType || (exports.ENotificationType = {}));
    var StNotification = function(_super) {
        __extends(StNotification, _super);
        function StNotification() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Notification";
            _this.createNotification = function() {
                var element = document.createElement("div");
                element.setAttribute("class", "st_notification-wrapper");
                element.setAttribute("id", "st_notification");
                var trigger = document.createElement("button");
                trigger.setAttribute("type", "button");
                trigger.dataset.close = "notification";
                trigger.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 40 40"><path d="M23.868 20.015L39.117 4.78c1.11-1.108 1.11-2.77 0-3.877-1.109-1.108-2.773-1.108-3.882 0L19.986 16.137 4.737.904C3.628-.204 1.965-.204.856.904c-1.11 1.108-1.11 2.77 0 3.877l15.249 15.234L.855 35.248c-1.108 1.108-1.108 2.77 0 3.877.555.554 1.248.831 1.942.831s1.386-.277 1.94-.83l15.25-15.234 15.248 15.233c.555.554 1.248.831 1.941.831s1.387-.277 1.941-.83c1.11-1.109 1.11-2.77 0-3.878L23.868 20.015z" /></svg>';
                element.appendChild(trigger);
                var title = document.createElement("div");
                title.setAttribute("class", "st_notification-title");
                element.appendChild(title);
                var desc = document.createElement("div");
                desc.setAttribute("class", "st_notification-description");
                element.appendChild(desc);
                return element;
            };
            _this.assembleNotification = function(type, title, description) {
                if (title === void 0) {
                    title = "";
                }
                if (description === void 0) {
                    description = "";
                }
                var typeClass = "";
                var notification = _this.createNotification();
                if (typeof description === "string") {
                    description = [ description ];
                }
                switch (type) {
                  case "success":
                    typeClass = "st_success";
                    break;

                  case "error":
                    typeClass = "st_error";
                    break;

                  case "info":
                    typeClass = "st_info";
                    break;
                }
                notification.classList.add(typeClass);
                var t = notification.querySelector(".st_notification-title");
                t.innerHTML = title;
                var d = notification.querySelector(".st_notification-description");
                var message = "";
                for (var i = 0; i < description.length; i++) {
                    if (i !== 0) {
                        message += "<hr>";
                    }
                    message += description[i];
                }
                d.innerHTML = message;
                return notification;
            };
            _this.showNotification = function(type, title, description, duration, preventDisappear) {
                if (type === void 0) {
                    type = ENotificationType.error;
                }
                if (title === void 0) {
                    title = "";
                }
                if (description === void 0) {
                    description = "";
                }
                if (duration === void 0) {
                    duration = 5e3;
                }
                if (preventDisappear === void 0) {
                    preventDisappear = false;
                }
                var notif = document.getElementById("st_notification");
                if (notif !== null) {
                    notif.remove();
                }
                var notification = _this.assembleNotification(type, title, description);
                var button = notification.querySelectorAll('button[data-close="notification"]')[0];
                button.addEventListener("click", function(e) {
                    var el = this.closest(".st_notification-wrapper");
                    body.removeChild(el);
                });
                var body = document.getElementsByTagName("body")[0];
                body.appendChild(notification);
                if (!preventDisappear) {
                    clearTimeout(_this.globalShowTimeout);
                    _this.globalShowTimeout = setTimeout(function() {
                        if (notification && notification.parentNode) {
                            notification.parentNode.removeChild(notification);
                        }
                    }, duration);
                }
            };
            return _this;
        }
        return StNotification;
    }(st_module_1.StModule);
    exports.StNotification = StNotification;
});

define("core/connector-app/_shared/models/auth/auth.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.ETokenType = void 0;
    var ETokenType;
    (function(ETokenType) {
        ETokenType["Access"] = "Access";
        ETokenType["Refresh"] = "Refresh";
    })(ETokenType = exports.ETokenType || (exports.ETokenType = {}));
});

define("core/shopify-app/st-modules/auth/auth", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAuth = void 0;
    var StAuth = function(_super) {
        __extends(StAuth, _super);
        function StAuth() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Auth";
            _this.init = function() {
                _this.ajax.tryGetTokens();
            };
            return _this;
        }
        return StAuth;
    }(st_module_2.StModule);
    exports.StAuth = StAuth;
});

define("core/shopify-app/st-modules/_general-methods/ajax", [ "require", "exports", "core/connector-app/_shared/models/auth/auth.request.model", "core/shopify-app/st-modules/_static/static" ], function(require, exports, auth_request_model_1, static_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAjax = void 0;
    var StAjax = function() {
        function StAjax() {
            this.refreshingToken = false;
        }
        StAjax.Instance = function() {
            return this._instance || (this._instance = new this());
        };
        StAjax.prototype.setupFormatting = function(objectToQueryStringFn) {
            this.objectToQueryString = objectToQueryStringFn;
        };
        StAjax.prototype.determineContentType = function(contentType) {
            var output = {
                type: "application/x-www-form-urlencoded",
                prepFn: this.objectToQueryString
            };
            switch (contentType) {
              case "form":
                output.type = "application/x-www-form-urlencoded";
                output.prepFn = this.objectToQueryString;
                break;

              case "json":
                output.type = "application/json";
                output.prepFn = JSON.stringify;
                break;
            }
            return output;
        };
        StAjax.prototype.tokenExists = function() {
            return !!window.localStorage.getItem(auth_request_model_1.ETokenType.Refresh);
        };
        StAjax.prototype.removeTokensFromStorage = function() {
            var token = window.localStorage.getItem(auth_request_model_1.ETokenType.Access);
            if (!!token && token.length > 0) window.localStorage.removeItem(auth_request_model_1.ETokenType.Access);
            token = window.localStorage.getItem(auth_request_model_1.ETokenType.Refresh);
            if (!!token && token.length > 0) window.localStorage.removeItem(auth_request_model_1.ETokenType.Refresh);
        };
        StAjax.prototype.attachTokenToHeader = function(request, tokenType) {
            var token = window.localStorage.getItem(tokenType);
            if (!!token && token.length > 0) request.setRequestHeader("Authorization", token);
        };
        StAjax.prototype.send = function(options, refresh) {
            var _a;
            var fnReference = this;
            if (typeof options == "object") {
                var defaultOptions = {
                    endpoint: "",
                    method: "POST",
                    contentType: "json",
                    data: {},
                    callback: function() {},
                    callbackParams: [],
                    retried: (_a = options.retried) !== null && _a !== void 0 ? _a : false
                };
                var completeOptions_1 = __assign(__assign({}, defaultOptions), options);
                var contentTypeData = this.determineContentType(completeOptions_1.contentType);
                var requestMethod = completeOptions_1.method.toUpperCase();
                var allowedMethods = [ "POST", "GET", "PUT", "DELETE" ];
                completeOptions_1.method = allowedMethods.indexOf(requestMethod) >= 0 ? requestMethod : "POST";
                var request_1 = new XMLHttpRequest();
                request_1.open(completeOptions_1.method, completeOptions_1.endpoint, true);
                request_1.withCredentials = true;
                request_1.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                request_1.setRequestHeader("Content-Type", contentTypeData.type);
                request_1.setRequestHeader("credentials", "include");
                var tokenType = !!refresh ? auth_request_model_1.ETokenType.Refresh : auth_request_model_1.ETokenType.Access;
                this.attachTokenToHeader(request_1, tokenType);
                var _this_1 = this;
                request_1.onreadystatechange = function() {
                    if (request_1.readyState === 4) {
                        if (request_1.status === 401 && !completeOptions_1.retried) {
                            options.retried = true;
                            if (_this_1.refreshingToken) {
                                setTimeout(function() {
                                    if (_this_1.tokenExists()) {
                                        _this_1.send(options);
                                    } else {}
                                }, 3e3);
                            } else {
                                _this_1.refreshTokenAndRetry(options);
                            }
                        } else {
                            completeOptions_1.callbackParams.unshift(request_1);
                            completeOptions_1.callback.apply(fnReference, completeOptions_1.callbackParams);
                        }
                    }
                };
                console.log("request type");
                request_1.send(contentTypeData.prepFn(completeOptions_1.data));
                return request_1;
            }
        };
        StAjax.prototype.refreshTokenAndRetry = function(options) {
            var _this = this;
            this.refreshingToken = true;
            var refreshToken = window.localStorage.getItem(auth_request_model_1.ETokenType.Refresh);
            if (refreshToken == undefined || refreshToken.length === 0) {
                console.error("Authentication required.");
                _this.tryGetTokens(options);
                return;
            }
            this.send({
                endpoint: static_2.StStatic.Instance().obtainStaticEndpoints()["auth"]["get-jwt"],
                method: "POST",
                contentType: "json",
                data: {},
                callback: function(response) {
                    try {
                        if (response.status == 200) {
                            var accessToken = JSON.parse(response.response).data.accessToken;
                            window.localStorage.setItem(auth_request_model_1.ETokenType.Access, accessToken);
                            _this.refreshingToken = false;
                            _this.send(options);
                        } else if (response.status == 401) {
                            _this.removeTokensFromStorage();
                            _this.tryGetTokens(options);
                            throw new Error("Authentication required.");
                        }
                    } catch (error) {
                        console.error(error);
                        _this.refreshingToken = false;
                    }
                }
            }, true);
        };
        StAjax.prototype.tryGetTokens = function(options) {
            if (this.shouldRequestToken()) {
                this.getTokens({
                    id: "".concat(window.customerShopifyId),
                    email: window.customerShopifyEmail
                }, options);
            }
        };
        StAjax.prototype.shouldRequestToken = function() {
            return window.localStorage.getItem(auth_request_model_1.ETokenType.Refresh) === null && !!window.customerShopifyId && !!window.customerShopifyEmail;
        };
        StAjax.prototype.getTokens = function(userInfo, options) {
            console.log("sent -------\x3e ", userInfo, __assign({}, userInfo));
            var _this = this;
            this.send({
                endpoint: window.stAppConfig.apiRoot + "/auth/sca/get-jwt",
                method: "POST",
                contentType: "json",
                data: userInfo,
                callback: function(response) {
                    try {
                        if (response.status == 200) {
                            var res = JSON.parse(response.response);
                            window.localStorage.setItem(auth_request_model_1.ETokenType.Refresh.toString(), res.data.refreshToken);
                            window.localStorage.setItem(auth_request_model_1.ETokenType.Access, res.data.accessToken);
                            if (options !== undefined) {
                                _this.send(options);
                            }
                        }
                    } catch (error) {
                        console.error(error);
                    }
                }
            });
        };
        return StAjax;
    }();
    exports.StAjax = StAjax;
});

define("core/shopify-app/st-modules/_di-container/st.module.interface", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/_di-container/di.container.public", [ "require", "exports", "core/shopify-app/st-modules/_general-methods/dom-loaded" ], function(require, exports, dom_loaded_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.DiContainerPublic = void 0;
    var DiContainerPublic = function() {
        function DiContainerPublic() {
            this.className = "DI";
            this.subscribeDOMLoaded = function(cb) {
                dom_loaded_2.StDOMLoaded.Instance().subscribeDOMLoaded(cb);
            };
            this.init = function() {};
            this.setup = function() {};
        }
        return DiContainerPublic;
    }();
    exports.DiContainerPublic = DiContainerPublic;
});

define("core/shopify-app/st-modules/_di-container/di.container.setup", [ "require", "exports", "core/shopify-app/st-modules/_general-methods/dom-loaded" ], function(require, exports, dom_loaded_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDIContainerSetup = void 0;
    var StDIContainerSetup = function() {
        function StDIContainerSetup(appName, StAppDIConfig) {
            var _this = this;
            this.className = "DI";
            this.getModules = function(appName) {
                return _this.StAppDIConfig.Instance.hierarchy(appName);
            };
            if (!window.stApp) window.stApp = {};
            this.StAppDIConfig = StAppDIConfig;
            this.init(appName);
        }
        StDIContainerSetup.prototype.init = function(appName) {
            document.querySelector("body").classList.add("st_app-".concat(appName));
            this.mainServices = this.getModules(appName);
            this.mainServices.forEach(function(service) {
                if (service.className) {
                    window.stApp[service.className] = service;
                    service.setup();
                } else {
                    console.error("Instance has no className: ", service);
                }
            });
            dom_loaded_3.StDOMLoaded.Instance().initDOMLoaded();
        };
        return StDIContainerSetup;
    }();
    exports.StDIContainerSetup = StDIContainerSetup;
});

define("core/shopify-app/st-modules/_general-methods/cookies/cookies", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCookies = void 0;
    var StCookies = function(_super) {
        __extends(StCookies, _super);
        function StCookies() {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "Cookies";
            _this_1.init = function() {
                var _this = _this_1;
                _this_1.subscribeDOMLoaded(function() {
                    _this.initCookieApi();
                    _this.onPrivacyBannerAction();
                });
            };
            _this_1.initCookieApi = function() {
                var wShopify = window.Shopify;
                if (!!wShopify) {
                    wShopify.loadFeatures([ {
                        name: "consent-tracking-api",
                        version: "0.1"
                    } ], function(error) {
                        if (error) {
                            throw error;
                        }
                        _this_1.showPrivacyBanner();
                    });
                }
            };
            _this_1.showPrivacyBanner = function() {
                var wShopify = window.Shopify;
                var shouldShowBanner = wShopify.customerPrivacy.shouldShowGDPRBanner();
                var banner = document.querySelector(".st_privacy-bar_JS");
                if (!!banner && shouldShowBanner) {
                    banner.removeAttribute("hidden");
                }
            };
            _this_1.hidePrivacyBanner = function() {
                var banner = document.querySelector(".st_privacy-bar_JS");
                if (!!banner) {
                    banner.setAttribute("hidden", "");
                }
            };
            _this_1.onPrivacyBannerAction = function() {
                var _this = _this_1;
                var privacyBannerBtnList = document.querySelectorAll(".st_privacy-banner-btn_JS");
                if ((privacyBannerBtnList === null || privacyBannerBtnList === void 0 ? void 0 : privacyBannerBtnList.length) > 0) {
                    privacyBannerBtnList.forEach(function(btn) {
                        btn.addEventListener("click", function() {
                            var btnDataAction = btn.getAttribute("data-action");
                            var wShopify = window === null || window === void 0 ? void 0 : window.Shopify;
                            wShopify.customerPrivacy.setTrackingConsent(btnDataAction === "accept", _this.hidePrivacyBanner);
                        });
                    });
                }
            };
            _this_1.getCookie = function(cookieKey) {
                return window.localStorage.getItem(cookieKey);
            };
            _this_1.setCookies = function(cookieKey, cookieValue) {
                window.localStorage.setItem(cookieKey, cookieValue);
            };
            _this_1.clearCookie = function(cookieKey) {
                window.localStorage.removeItem(cookieKey);
            };
            _this_1.clearAllCookie = function() {
                window.localStorage.clear();
            };
            return _this_1;
        }
        return StCookies;
    }(st_module_3.StModule);
    exports.StCookies = StCookies;
});

define("_features.config", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.BUILD_AND_SAVE_BUNDLE_DISCOUNT = exports.HALF_PRICED_TARGETED_SOLUTION_DISCOUNT = exports.SHOPIFY_GIFT_CARD_GATEWAY = exports.BDT_GIFT_CARD_PAYMENT_TYPE_ID = exports.BYDESIGN_CREDIT_CARD_PAYMENT_TYPE_ID = exports.allowedPaymentKinds = exports.BDT_CUSTOMER_ID_TAG = exports.DEFAULT_SHIP_METHOD_ID = exports.ReferralMarketTypeInput = exports.ReferralMarketType = exports.ESocialSite = exports.EOrderStatusId = exports.useCommissionEngineIdInRewardCode = exports.rewardItemCollectionId = exports.rewardDiscountMinimum = exports.rewardCodePrefix = exports.rewardAmount = exports.rewardType = exports.shareRefCodeFunctionality = exports.discountUsageLimit = exports.discountCollectionSpend = exports.discountMinimumRequirement = exports.discountSegmentConditionTag = exports.discountNamePrefix = exports.discountAmount = exports.discountType = exports.enrollmentParams = exports.reasonForRefundWhenReturnMoney = exports.availableRechargeUsage = exports.sponsorGenealogyTimeout = exports.downgradeRepresentativeByDesignWebhook = exports.cronJobReSyncOrders = exports.repDiscountWithPromoCode = exports.searchSponsorsMinNumOfResult = exports.searchSponsorsFetchAttemptsLimit = exports.representative = exports.commissionEngine = exports.autoshipItems = exports.STORE_FRONT_API_VERSION = exports.productVolumesConfig = exports.EProductPriceType = exports.createConsultantRankTag = exports.rankConsultantRegEx = exports.ECustomerType = exports.defaultCorporationImage = exports.additionalRepInfo = exports.time_zone_offset = exports.activeLastSponsorFeature = exports.canGoUnderCorporateSite = exports.lockedRepresentativeSite = exports.defaultEmail = exports.corporationName = exports.aliasQueryParam = exports.defaultWebAlias = void 0;
    exports.defaultWebAlias = "400560";
    exports.aliasQueryParam = "als";
    exports.corporationName = "L'BRI";
    exports.defaultEmail = "donotreply@lbri.com";
    exports.lockedRepresentativeSite = true;
    exports.canGoUnderCorporateSite = true;
    exports.activeLastSponsorFeature = true;
    exports.time_zone_offset = ".000-05:00";
    exports.additionalRepInfo = true;
    exports.defaultCorporationImage = "https://lbri.com/lbriweb/assets/img/LBRI-pure-n-natural-logo.png";
    var ECustomerType;
    (function(ECustomerType) {
        ECustomerType["retail"] = "retail";
        ECustomerType["representative"] = "consultant";
        ECustomerType["guest"] = "guest";
        ECustomerType["noType"] = "";
        ECustomerType["seniorConsultant"] = "Senior Consultant";
        ECustomerType["manager"] = "manager";
        ECustomerType["supervisor"] = "Supervisor";
        ECustomerType["executiveManager"] = "Executive Manager";
        ECustomerType["executive"] = "Executive";
        ECustomerType["seniorExecutiveManager"] = "Senior Executive Manager";
        ECustomerType["eliteExecutiveManager"] = "Elite Executive Manager";
        ECustomerType["diamondExecutiveManager"] = "Diamond Executive Manager";
        ECustomerType["doubleExecutiveManager"] = "Double Diamond Executive Manager";
        ECustomerType["lead"] = "lead";
        ECustomerType["prospect"] = "prospect";
    })(ECustomerType = exports.ECustomerType || (exports.ECustomerType = {}));
    exports.rankConsultantRegEx = /^rank\s*\[\s*(.+?)\s*\]$/i;
    exports.createConsultantRankTag = "Rank[consultant]";
    var EProductPriceType;
    (function(EProductPriceType) {
        EProductPriceType["retail"] = "retail";
        EProductPriceType["representative"] = "consultant";
        EProductPriceType["noSpecificType"] = "";
    })(EProductPriceType = exports.EProductPriceType || (exports.EProductPriceType = {}));
    exports.productVolumesConfig = {
        cv: true,
        qv: true,
        bv: false,
        rv: false,
        retailProfit: true,
        cvMetafieldKey: "cvolume",
        qvMetafieldKey: "qvolume",
        bvMetafieldKey: "bvolume",
        rvMetafieldKey: "rvolume",
        retailProfitMetafieldKey: "retailProfit",
        Volume: "cv",
        Volume2: "qv",
        Volume3: "bv",
        Volume4: "rv",
        calculatePriceAsVolume: false,
        generalPriceVolumePercentage: 1,
        retailVolumeAndPricePercentage: 1,
        representativeVolumeAndPricePercentage: 1
    };
    exports.STORE_FRONT_API_VERSION = "2025-07";
    exports.autoshipItems = [ "AUTOSHIP-1", "AUTOSHIP-2", "consultant-kit", "enrollment-bundle" ];
    exports.commissionEngine = "ByDesign";
    exports.representative = "representative";
    exports.searchSponsorsFetchAttemptsLimit = 3;
    exports.searchSponsorsMinNumOfResult = 3;
    exports.repDiscountWithPromoCode = true;
    exports.cronJobReSyncOrders = false;
    exports.downgradeRepresentativeByDesignWebhook = true;
    exports.sponsorGenealogyTimeout = 6e5;
    exports.availableRechargeUsage = false;
    exports.reasonForRefundWhenReturnMoney = "refundmoney";
    exports.enrollmentParams = [ "SSN", "dateOfBirth", "day", "email", "firstName", "lastName", "month", "optionalKitRecurring", "optionalKits", "phoneNumber", "requiredKitRecurring", "requiredKits", "shopifyId", "sponsorWebAlias", "sponsorsWebAlias", "webAlias", "year" ];
    exports.discountType = "fixed_amount";
    exports.discountAmount = 10;
    exports.discountNamePrefix = "Core_";
    exports.discountSegmentConditionTag = "no_order";
    exports.discountMinimumRequirement = "1.00";
    exports.discountCollectionSpend = 405622423800;
    exports.discountUsageLimit = 10;
    exports.shareRefCodeFunctionality = false;
    exports.rewardType = "fixed_amount";
    exports.rewardAmount = 20;
    exports.rewardCodePrefix = "RewardedFrom-";
    exports.rewardDiscountMinimum = 1;
    exports.rewardItemCollectionId = 405622423800;
    exports.useCommissionEngineIdInRewardCode = true;
    var EOrderStatusId;
    (function(EOrderStatusId) {
        EOrderStatusId[EOrderStatusId["entered"] = 1] = "entered";
        EOrderStatusId[EOrderStatusId["posted"] = 2] = "posted";
        EOrderStatusId[EOrderStatusId["shipped"] = 3] = "shipped";
        EOrderStatusId[EOrderStatusId["pbo"] = 4] = "pbo";
        EOrderStatusId[EOrderStatusId["bo"] = 5] = "bo";
        EOrderStatusId[EOrderStatusId["void"] = 6] = "void";
        EOrderStatusId[EOrderStatusId["canceled"] = 7] = "canceled";
        EOrderStatusId[EOrderStatusId["imported"] = 8] = "imported";
        EOrderStatusId[EOrderStatusId["fulfilled"] = 9] = "fulfilled";
        EOrderStatusId[EOrderStatusId["characterValidation"] = 10] = "characterValidation";
        EOrderStatusId[EOrderStatusId["addressLimitValidation"] = 11] = "addressLimitValidation";
        EOrderStatusId[EOrderStatusId["thirdPartyRejected"] = 12] = "thirdPartyRejected";
    })(EOrderStatusId = exports.EOrderStatusId || (exports.EOrderStatusId = {}));
    var ESocialSite;
    (function(ESocialSite) {
        ESocialSite["Facebook"] = "FB";
        ESocialSite["Twitter"] = "X";
        ESocialSite[ESocialSite["LinkedIn"] = 4] = "LinkedIn";
        ESocialSite["Instagram"] = "IG";
        ESocialSite["WhatsUp"] = "WA";
        ESocialSite[ESocialSite["TikTok"] = 6] = "TikTok";
        ESocialSite[ESocialSite["Pinterest"] = 7] = "Pinterest";
    })(ESocialSite = exports.ESocialSite || (exports.ESocialSite = {}));
    exports.ReferralMarketType = 5;
    exports.ReferralMarketTypeInput = "Create new Customer Prospect type";
    exports.DEFAULT_SHIP_METHOD_ID = 1001;
    exports.BDT_CUSTOMER_ID_TAG = "bdtCustomerId-";
    exports.allowedPaymentKinds = [ "CAPTURE", "SALE" ];
    exports.BYDESIGN_CREDIT_CARD_PAYMENT_TYPE_ID = 20;
    exports.BDT_GIFT_CARD_PAYMENT_TYPE_ID = 26;
    exports.SHOPIFY_GIFT_CARD_GATEWAY = "gift_card";
    exports.HALF_PRICED_TARGETED_SOLUTION_DISCOUNT = "half-priced targeted solution";
    exports.BUILD_AND_SAVE_BUNDLE_DISCOUNT = "build & save bundle discount";
});

define("core/shopify-app/st-modules/_general-methods/form/customer-type", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_4, _features_config_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCustomerType = void 0;
    var StCustomerType = function(_super) {
        __extends(StCustomerType, _super);
        function StCustomerType() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "CustomerType";
            _this.init = function() {};
            _this.get = function() {
                var customerType;
                if (!!window.customerInfoMetafields.customerType) {
                    customerType = window.customerInfoMetafields.customerType;
                } else {
                    customerType = _features_config_1.ECustomerType.guest;
                }
                return customerType;
            };
            return _this;
        }
        return StCustomerType;
    }(st_module_4.StModule);
    exports.StCustomerType = StCustomerType;
});

define("core/shopify-app/st-modules/_general-methods/object-formatting", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StObjectFormatting = void 0;
    var StObjectFormatting = function(_super) {
        __extends(StObjectFormatting, _super);
        function StObjectFormatting() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ObjectFormatting";
            _this.convertObjectToQueryString = function(object) {
                var string = "", i = 0;
                for (var j in object) {
                    var s = encodeURIComponent(j) + "=" + encodeURIComponent(object[j]);
                    string += i > 0 ? "&" + s : s;
                    i++;
                }
                return "?" + string;
            };
            _this.convertQueryStringToObject = function(query) {
                query = typeof query != "string" ? "" : query.substr(query.indexOf("?") + 1);
                var query_string = {};
                if (query !== "") {
                    var vars = query.split("&");
                    for (var i = 0; i < vars.length; i++) {
                        var pair = vars[i].split("=");
                        var key = decodeURIComponent(pair[0]);
                        var value = decodeURIComponent(pair[1]);
                        if (typeof query_string[key] === "undefined") {
                            query_string[key] = decodeURIComponent(value);
                        } else if (typeof query_string[key] === "string") {
                            query_string[key] = [ query_string[key], decodeURIComponent(value) ];
                        } else {
                            query_string[key].push(decodeURIComponent(value));
                        }
                    }
                } else {
                    console.warn("Invalid query string supplied to convertQueryStringToObject.");
                }
                return query_string;
            };
            _this.ajax.setupFormatting(_this.convertObjectToQueryString);
            return _this;
        }
        return StObjectFormatting;
    }(st_module_5.StModule);
    exports.StObjectFormatting = StObjectFormatting;
});

define("core/shopify-app/st-modules/_general-methods/browser-history", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_6) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StBrowserHistory = void 0;
    var StBrowserHistory = function(_super) {
        __extends(StBrowserHistory, _super);
        function StBrowserHistory(objectFormatting) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "BrowserHistory";
            _this.pushHistory = function(rootURL, urlParams) {
                var serializedUrlParams = _this.objectFormatting.convertObjectToQueryString(urlParams);
                window.history.replaceState(urlParams, "", rootURL + serializedUrlParams);
            };
            _this.objectFormatting = objectFormatting;
            return _this;
        }
        return StBrowserHistory;
    }(st_module_6.StModule);
    exports.StBrowserHistory = StBrowserHistory;
});

define("core/connector-app/_shared/models/webalias/webalias.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/_general-methods/general-methods", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_7) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StGeneralMethods = void 0;
    var StGeneralMethods = function(_super) {
        __extends(StGeneralMethods, _super);
        function StGeneralMethods() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "GeneralMethods";
            _this.scrollTo = function(element, duration, offset) {
                if (offset === void 0) {
                    offset = 150;
                }
                var startingY = window.scrollY;
                var elementY = window.scrollY + element.getBoundingClientRect().top - offset;
                var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY;
                var diff = targetY - startingY;
                var easing = function(t) {
                    return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
                };
                var start;
                if (!diff) return;
                window.requestAnimationFrame(function step(timestamp) {
                    if (!start) start = timestamp;
                    var time = timestamp - start;
                    var percent = Math.min(time / duration, 1);
                    percent = easing(percent);
                    window.scrollTo(0, startingY + diff * percent);
                    if (time < duration) {
                        window.requestAnimationFrame(step);
                    }
                });
            };
            return _this;
        }
        StGeneralMethods.prototype.getClosestByClass = function(el, cls) {
            var res = el;
            while ((res = res === null || res === void 0 ? void 0 : res.parentElement) && !res.classList.contains(cls));
            return res;
        };
        StGeneralMethods.prototype.getClosestByTag = function(el, tagName) {
            var res = el;
            while ((res = res.parentElement) && !res.tagName === tagName);
            return res;
        };
        return StGeneralMethods;
    }(st_module_7.StModule);
    exports.StGeneralMethods = StGeneralMethods;
});

define("core/shopify-app/st-modules/webalias/webalias-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_8) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StWebAliasClassConfig = void 0;
    var StWebAliasClassConfig = function(_super) {
        __extends(StWebAliasClassConfig, _super);
        function StWebAliasClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StWebAliasClassConfig";
            _this.classNameRepId = "st_representative-id_JS";
            _this.selectorRepId = "." + _this.classNameRepId;
            _this.classNameRepAlias = "st_representative-alias_JS";
            _this.selectorRepAlias = "." + _this.classNameRepAlias;
            _this.classNameRepFullName = "st_representative-fullname_JS";
            _this.selectorRepFullName = "." + _this.classNameRepFullName;
            _this.classNameRepInitials = "st_representative-initials_JS";
            _this.selectorRepInitials = "." + _this.classNameRepInitials;
            _this.classNameRepSite = "st_representative-site_JS";
            _this.selectorRepSite = "." + _this.classNameRepSite;
            _this.classNameRepBio = "st_representative-site-bio_JS";
            _this.selectorRepBio = "." + _this.classNameRepBio;
            _this.classNameRepAddress = "st_representative-address_JS";
            _this.selectorRepAddress = "." + _this.classNameRepAddress;
            _this.classNameNonSponsor = "st_non-sponsor_JS";
            _this.selectorNonSponsor = "." + _this.classNameNonSponsor;
            _this.classRepresentativeBannerWrapper = "st_representative-banner--wrapper_JS";
            _this.selectorRepresentativeBannerWrapper = "." + _this.classRepresentativeBannerWrapper;
            _this.classNameBusinessContentRepName = "st_account-business--rep-name_JS";
            _this.selectorBusinessContentRepName = "." + _this.classNameBusinessContentRepName;
            _this.classNamePersonalInfoForm = "st_personal-info-form_JS";
            _this.selectorPersonalInfoForm = "." + _this.classNamePersonalInfoForm;
            _this.classNamePersonalInfoRepFullName = "st_representative-info-fullname_JS";
            _this.selectorPersonalInfoRepFullName = "." + _this.classNamePersonalInfoRepFullName;
            return _this;
        }
        return StWebAliasClassConfig;
    }(st_module_8.StModule);
    exports.StWebAliasClassConfig = StWebAliasClassConfig;
});

define("core/shopify-app/st-modules/webalias/inject-representative-info", [ "require", "exports", "_features.config", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, _features_config_2, st_module_9) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StInjectRepresentativeInfo = void 0;
    var StInjectRepresentativeInfo = function(_super) {
        __extends(StInjectRepresentativeInfo, _super);
        function StInjectRepresentativeInfo(classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "InjectRepresentativeInfo";
            _this.injectToFields = function(repInfo) {
                var repId = repInfo.repId, webAlias = repInfo.webAlias, firstName = repInfo.firstName, lastName = repInfo.lastName, imageUrl = repInfo.imageUrl;
                if (!!repId) {
                    _this.appendIdToField(repInfo.repId);
                }
                if (!!webAlias) {
                    _this.appendAlsToField(webAlias);
                    _this.appendRepSiteUrlToField(webAlias);
                }
                if (!!firstName || !!lastName) {
                    _this.appendRepFullNameToField(firstName, lastName, webAlias);
                }
                if (!!imageUrl && _features_config_2.additionalRepInfo) {
                    _this.appendRepBioToField(imageUrl);
                }
            };
            _this.injectSponsorInfoToField = function(firstName, lastName) {
                var repNameSelector = document.querySelector(_this.classConfig.selectorBusinessContentRepName);
                if (!!repNameSelector) {
                    repNameSelector.innerHTML = firstName + " " + lastName;
                }
                var personalInformationRep = document.querySelector(_this.classConfig.selectorPersonalInfoRepFullName);
                if (!!personalInformationRep) {
                    personalInformationRep.value = firstName + " " + lastName;
                }
            };
            _this.appendIdToField = function(id) {
                var repAliasFields = document.querySelectorAll(_this.classConfig.selectorRepId);
                if (repAliasFields.length > 0) {
                    _this.appendValueToFields(repAliasFields, id);
                }
            };
            _this.appendAlsToField = function(alias) {
                var repAliasFields = document.querySelectorAll(_this.classConfig.selectorRepAlias);
                if (repAliasFields.length > 0) {
                    _this.appendValueToFields(repAliasFields, alias);
                }
            };
            _this.appendRepSiteUrlToField = function(alias) {
                var repSiteFields = document.querySelectorAll(_this.classConfig.selectorRepSite);
                var repSite = window.location.origin + "/?+" + _features_config_2.aliasQueryParam + "=" + alias;
                if (repSiteFields.length > 0) {
                    _this.appendValueToFields(repSiteFields, repSite);
                }
            };
            _this.appendRepFullNameToField = function(repFirstName, repLastName, webAlias) {
                var repFullNameFields = document.querySelectorAll(_this.classConfig.selectorRepFullName);
                var fullName = _this.getFullName(repFirstName, repLastName, webAlias);
                if (repFullNameFields.length > 0) {
                    _this.appendValueToFields(repFullNameFields, fullName);
                }
            };
            _this.appendRepBioToField = function(imageUrl) {
                var repImages = document.querySelectorAll(_this.classConfig.selectorRepBio);
                var imageString = 'BIO: <img class="" style="width: 50px; height: auto;" alt="representatve image" src="' + imageUrl + '">';
                if (repImages.length > 0) {
                    repImages.forEach(function(field) {
                        return field.innerHTML = imageString;
                    });
                }
            };
            _this.getFullName = function(repFirstName, repLastName, webAlias) {
                var fullName = "";
                if (!!repFirstName) {
                    fullName = repFirstName;
                    if (!!repLastName) {
                        fullName += " " + repLastName;
                    }
                }
                if (webAlias === _features_config_2.defaultWebAlias) {
                    fullName = _features_config_2.corporationName;
                }
                return fullName;
            };
            _this.appendValueToFields = function(fields, value) {
                fields.forEach(function(field) {
                    if (field.tagName.toLowerCase() === "input") {
                        field.value = value;
                    } else if (field.tagName.toLowerCase() === "a") {
                        field.setAttribute("href", value);
                    } else {
                        field.innerHTML = value;
                    }
                });
            };
            _this.classConfig = classConfig;
            return _this;
        }
        return StInjectRepresentativeInfo;
    }(st_module_9.StModule);
    exports.StInjectRepresentativeInfo = StInjectRepresentativeInfo;
});

define("core/shopify-app/st-modules/cart/cart", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_10) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCart = void 0;
    var StCart = function(_super) {
        __extends(StCart, _super);
        function StCart() {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "Cart";
            _this_1.reloadSubscriber = [];
            _this_1.cartInterceptorEndpoints = [ "/cart/add.js", "/cart/add", "/cart/update.js", "/cart/update", "/cart/change.js", "/cart/change", "/cart/clear.js", "/cart/clear", "/wallets/checkouts/" ];
            _this_1.shopifyCartApiEndpoints = {
                "get-cart": "/cart.js",
                "add-to-cart": "/cart/add.js",
                "clear-cart": "/cart/clear.js",
                "change-cart": "/cart/change.js",
                "update-cart": "/cart/update.js"
            };
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.cartFetchInterceptorInit();
                    _this_1.cartBackForwardCacheFixInit();
                });
            };
            _this_1.cartFetchInterceptorInit = function() {
                var originalFetch = window.fetch;
                window.fetch = function() {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    return __awaiter(_this_1, void 0, void 0, function() {
                        var resource, config, response;
                        return __generator(this, function(_a) {
                            switch (_a.label) {
                              case 0:
                                resource = args[0], config = args[1];
                                return [ 4, originalFetch(resource, config) ];

                              case 1:
                                response = _a.sent();
                                if (this.isCartChangeRequest(response.url)) {
                                    this.getCart(this.handleChangeCartInterceptor);
                                }
                                return [ 2, response ];
                            }
                        });
                    });
                };
            };
            _this_1.handleChangeCartInterceptor = function(cartObj) {
                try {
                    _this_1.setShopifyCartData(cartObj);
                    if (!!cartObj.attributes.sponsorWebAlias) {
                        _this_1.addOrEditPropertiesForWebAlias(cartObj.items, cartObj.attributes.sponsorWebAlias);
                    }
                    _this_1.fireAllCallbacks(cartObj);
                } catch (err) {
                    console.error("handleChangeCartInterceptor ---\x3e Error:", err);
                }
            };
            _this_1.initCartSetup = function() {
                _this_1.getCart(function(cartObj) {
                    _this_1.setShopifyCartData(cartObj);
                });
            };
            _this_1.fireAllCallbacks = function(cartObject) {
                _this_1.fireChangeCartCallbacks(cartObject);
                setTimeout(function() {
                    _this_1.fireRenderCartCallbacks();
                }, 1e3);
            };
            _this_1.subscribeChangeCart = function(callback) {
                _this_1.subCallbacks.push(callback);
            };
            _this_1.fireChangeCartCallbacks = function(cartObject) {
                if (_this_1.subCallbacks.length > 0) {
                    _this_1.subCallbacks.forEach(function(callback) {
                        callback(cartObject);
                    });
                }
            };
            _this_1.subscribeRenderCart = function(callback) {
                _this_1.subRenderCartCallbacks.push(callback);
            };
            _this_1.fireRenderCartCallbacks = function() {
                if (_this_1.subRenderCartCallbacks.length > 0) {
                    _this_1.subRenderCartCallbacks.forEach(function(callback) {
                        callback();
                    });
                }
            };
            _this_1.matchUrlSnippet = function(url, urlSnippetArr) {
                for (var i = 0; i < urlSnippetArr.length; i++) {
                    if (url.includes(urlSnippetArr[i])) {
                        return true;
                    }
                }
                return false;
            };
            _this_1.isGetCartRequest = function(url) {
                return url.endsWith("/cart.json");
            };
            _this_1.isCartChangeRequest = function(url) {
                return _this_1.matchUrlSnippet(url, _this_1.cartInterceptorEndpoints);
            };
            _this_1.setShopifyCartData = function(cartObj) {
                window.shopifyCartData = cartObj;
                _this_1.setCartInfo(cartObj);
            };
            _this_1.handleChangeCartResponseGeneric = function(res, handleFunc, cartRefresh) {
                if (handleFunc === void 0) {
                    handleFunc = function() {};
                }
                if (cartRefresh === void 0) {
                    cartRefresh = true;
                }
                try {
                    var cartRes_1 = JSON.parse(res.response);
                    _this_1.getCart(function(cartObj) {
                        _this_1.setShopifyCartData(cartObj);
                        if (cartRefresh) {
                            _this_1.requestCartRefresh(cartObj);
                        }
                        _this_1.fireAllCallbacks(cartObj);
                        handleFunc(cartRes_1);
                    });
                } catch (err) {
                    console.log("handleChangeCartResponseGeneric ---\x3e Error: ", err);
                }
            };
            _this_1.getCart = function(responseHandle) {
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["get-cart"],
                        method: "GET",
                        contentType: "json",
                        callback: function(res) {
                            try {
                                var cartObj = JSON.parse(res.response);
                                responseHandle(cartObj);
                            } catch (err) {
                                console.log("Cart Api Error: ", err);
                            }
                        }
                    });
                } catch (err) {
                    console.log("Get Cart ---\x3e Error:", err);
                }
            };
            _this_1.clearCart = function(responseHandle) {
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["clear-cart"],
                        method: "POST",
                        contentType: "json",
                        callback: function(res) {
                            _this_1.handleChangeCartResponseGeneric(res, responseHandle);
                        }
                    });
                } catch (err) {
                    console.log("Clear Cart ---\x3e Error:", err);
                }
            };
            _this_1.changeCart = function(changeData, responseHandle, cartRefresh) {
                if (cartRefresh === void 0) {
                    cartRefresh = true;
                }
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["change-cart"],
                        method: "POST",
                        contentType: "json",
                        data: changeData,
                        callback: function(res) {
                            _this_1.handleChangeCartResponseGeneric(res, responseHandle, cartRefresh);
                        }
                    });
                } catch (err) {
                    console.log("Change Cart ---\x3e Error:", err);
                }
            };
            _this_1.updateCart = function(updateData, responseHandle) {
                try {
                    var data = Array.isArray(updateData) ? {
                        updates: updateData
                    } : updateData;
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["update-cart"],
                        method: "POST",
                        contentType: "json",
                        data: data,
                        callback: function(res) {
                            _this_1.handleChangeCartResponseGeneric(res, responseHandle);
                        }
                    });
                } catch (err) {
                    console.log("Update Cart ---\x3e Error:", err);
                }
            };
            _this_1.addCart = function(addData, responseHandle) {
                try {
                    var data = Array.isArray(addData) ? {
                        items: addData
                    } : addData;
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["add-to-cart"],
                        method: "POST",
                        contentType: "json",
                        data: data,
                        callback: function(res) {
                            _this_1.handleChangeCartResponseGeneric(res, responseHandle);
                        }
                    });
                } catch (err) {
                    console.log("Add To Cart ---\x3e Error:", err);
                }
            };
            _this_1.requestCartRefresh = function(cart) {
                var isCartPage = location.pathname === "/cart";
                if (isCartPage) {
                    var _this_2 = _this_1;
                    var refreshIndex_1 = _this_1.subscribeCartReload();
                    setTimeout(function() {
                        _this_2.triggerCartReload(refreshIndex_1);
                    }, 500);
                }
                if (!isCartPage) {
                    _this_1.ajax.send({
                        endpoint: "".concat(window.Shopify.routes.root, "?section_id=cart-drawer"),
                        method: "GET",
                        callback: function(request) {
                            var cartDrawerTemplate = request.responseText;
                            _this_1.ajax.send({
                                endpoint: "".concat(window.Shopify.routes.root, "?section_id=variant-added"),
                                method: "GET",
                                callback: function(request) {
                                    var variantAddedTemplate = request.responseText;
                                    _this_1.triggerCartRefresh(cart, {
                                        "cart-drawer": cartDrawerTemplate,
                                        "variant-added": variantAddedTemplate
                                    });
                                }
                            });
                        }
                    });
                }
            };
            _this_1.triggerCartRefresh = function(cart, sections) {
                var addEvt = new CustomEvent("variant:add");
                var cartRefreshEvt = new CustomEvent("cart:refresh");
                var totalQuantity = cart.items.reduce(function(acc, item) {
                    return acc + item.quantity;
                }, 0);
                var cartChangeEvt = new CustomEvent("cart:change", {
                    detail: {
                        cart: __assign(__assign({}, cart), {
                            item_count: totalQuantity,
                            sections: sections
                        })
                    }
                });
                document.dispatchEvent(cartChangeEvt);
                document.dispatchEvent(cartRefreshEvt);
                document.dispatchEvent(addEvt);
            };
            _this_1.setCartInfo = function(shopifyCart) {
                _this_1.cart = __assign(__assign({}, _this_1.cart), shopifyCart);
            };
            _this_1.updateCartItemsProperies = function(alias) {
                _this_1.getCart(function(cartResponse) {
                    var attributes = cartResponse.attributes;
                    attributes = __assign(__assign({}, attributes), {
                        sponsorWebAlias: !!alias ? alias : ""
                    });
                    var updateAttributes = {
                        attributes: attributes
                    };
                    _this_1.updateCartAttributesOrNote(updateAttributes, function(cartRes) {
                        var items = cartRes.items;
                        _this_1.addOrEditPropertiesForWebAlias(items, alias);
                    });
                });
            };
            _this_1.addOrEditPropertiesForWebAlias = function(cartItems, alias) {
                var _a;
                var updateCartProperties = false;
                var item = {};
                var itemWithProperties = cartItems.find(function(item) {
                    var _a;
                    return ((_a = item.properties) === null || _a === void 0 ? void 0 : _a._sponsorWebAlias) !== undefined;
                });
                var duplicateItem = cartItems.find(function(item) {
                    var _a;
                    return item.sku === (itemWithProperties === null || itemWithProperties === void 0 ? void 0 : itemWithProperties.sku) && ((_a = item.properties) === null || _a === void 0 ? void 0 : _a._sponsorWebAlias) === undefined;
                });
                if (!itemWithProperties && cartItems.length > 0) {
                    item = cartItems[cartItems.length - 1];
                    updateCartProperties = true;
                } else if (duplicateItem) {
                    item = duplicateItem;
                    updateCartProperties = true;
                } else if (itemWithProperties && ((_a = itemWithProperties.properties) === null || _a === void 0 ? void 0 : _a._sponsorWebAlias) !== alias) {
                    item = itemWithProperties;
                    updateCartProperties = true;
                }
                var refreshCart = !!duplicateItem;
                if (updateCartProperties) {
                    if (!!alias) {
                        _this_1.updateItemProperties(item, alias, refreshCart);
                    }
                }
            };
            _this_1.updateItemProperties = function(item, alias, refreshCart) {
                var updateData = {
                    id: "".concat(item.key),
                    quantity: item.quantity,
                    properties: __assign(__assign({}, item.properties), {
                        _sponsorWebAlias: alias
                    })
                };
                _this_1.changeCart(updateData, function(updatedCart) {
                    console.log("Updated Cart:", updatedCart);
                }, refreshCart);
            };
            _this_1.updateCartAttributesOrNote = function(updateData, responseHandle) {
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["update-cart"],
                        method: "POST",
                        contentType: "json",
                        data: updateData,
                        callback: function(res) {}
                    });
                } catch (err) {
                    console.log("Update Cart ---\x3e Error:", err);
                }
            };
            _this_1.handleChangeCartResponseGenericNoRefresh = function(res, handleFunc) {
                try {
                    var cartRes = JSON.parse(res.response);
                    handleFunc(cartRes);
                    _this_1.getCart(function(cartObj) {
                        _this_1.setShopifyCartData(cartObj);
                        _this_1.handleChangeCartInterceptor(cartObj);
                    });
                } catch (err) {
                    console.log("handleChangeCartResponseGenericNoRefresh ---\x3e Error: ", err);
                }
            };
            _this_1.subscribeCartReload = function() {
                _this_1.reloadSubscriber.push(false);
                return _this_1.reloadSubscriber.length - 1;
            };
            _this_1.triggerCartReload = function(index) {
                var shouldRefresh = true;
                _this_1.reloadSubscriber[index] = true;
                for (var i = 0; i < _this_1.reloadSubscriber.length; i++) {
                    if (_this_1.reloadSubscriber[i] === false) {
                        shouldRefresh = false;
                        break;
                    }
                }
                if (shouldRefresh) window.location.reload();
            };
            _this_1.cartBackForwardCacheFixInit = function() {
                window.addEventListener("pageshow", function(event) {
                    var navigationEntry = performance.getEntriesByType("navigation")[0];
                    var isBackForwardNavigation = event.persisted || (navigationEntry === null || navigationEntry === void 0 ? void 0 : navigationEntry.type) === "back_forward";
                    if (!isBackForwardNavigation) {
                        return;
                    }
                    console.log("[StCart] Back/forward navigation detected. Refreshing cart...");
                    _this_1.forceCartSyncAfterBackButton();
                });
            };
            _this_1.forceCartSyncAfterBackButton = function() {
                try {
                    _this_1.getCart(function(cartObj) {
                        var _a;
                        _this_1.setShopifyCartData(cartObj);
                        if (!!((_a = cartObj.attributes) === null || _a === void 0 ? void 0 : _a.sponsorWebAlias)) {
                            _this_1.addOrEditPropertiesForWebAlias(cartObj.items, cartObj.attributes.sponsorWebAlias);
                        }
                        _this_1.requestCartRefresh(cartObj);
                        _this_1.fireAllCallbacks(cartObj);
                    });
                } catch (err) {
                    console.log("forceCartSyncAfterBackButton ---\x3e Error:", err);
                }
            };
            _this_1.subCallbacks = [];
            _this_1.subRenderCartCallbacks = [];
            return _this_1;
        }
        Object.defineProperty(StCart.prototype, "getShopifyCartData", {
            get: function() {
                return window.shopifyCartData;
            },
            enumerable: false,
            configurable: true
        });
        return StCart;
    }(st_module_10.StModule);
    exports.StCart = StCart;
});

define("core/shopify-app/st-modules/search-sponsor/sponsor-search-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_11) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsorClassConfig = void 0;
    var StSearchSponsorClassConfig = function(_super) {
        __extends(StSearchSponsorClassConfig, _super);
        function StSearchSponsorClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SearchSponsorClassConfig";
            _this.classNameSponsorId = "st_sponsor-id_JS";
            _this.selectorSponsorId = "." + _this.classNameSponsorId;
            _this.classNameSponsorAlias = "st_sponsor-alias_JS";
            _this.selectorSponsorAlias = "." + _this.classNameSponsorAlias;
            _this.classNameSponsorFullName = "st_sponsor-fullname_JS";
            _this.selectorSponsorFullName = "." + _this.classNameSponsorFullName;
            _this.classNameSponsorInitials = "st_sponsor-initials_JS";
            _this.selectorSponsorInitials = "." + _this.classNameSponsorInitials;
            _this.classNameSponsorAddress = "st_sponsor-address_JS";
            _this.selectorSponsorAddress = "." + _this.classNameSponsorAddress;
            _this.classNameSearchSponsorWrapperPage = "st_search-sponsor--wrapper_JS";
            _this.selectorSearchSponsorWrapperPage = "." + _this.classNameSearchSponsorWrapperPage;
            _this.classNameInputBoxPage = "st_search-sponsor--by-id_JS";
            _this.selectorInputBoxPage = "." + _this.classNameInputBoxPage;
            _this.classNameChangeSponsorWrapperlink = "st_change-sponsor--wrapper_JS";
            _this.selectorChangeSponsorWrapperLink = "." + _this.classNameChangeSponsorWrapperlink;
            _this.classNameChangeSponsorWrapper = "st_change-sponsor_JS";
            _this.selectorChangeSponsorWrapper = "." + _this.classNameChangeSponsorWrapper;
            _this.classNameSearchInput = "st_search-input_JS";
            _this.selectorSearchInput = "." + _this.classNameSearchInput;
            _this.classNameNonSponsor = "st_non-sponsor_JS";
            _this.selectorNonSponsor = "." + _this.classNameNonSponsor;
            _this.classNameChooseSponsor = "st_choose-sponsor_JS";
            _this.selectorChooseSponsor = "." + _this.classNameChooseSponsor;
            _this.classNameSearchResult = "st_search-result_JS";
            _this.selectorSearchResult = "." + _this.classNameSearchResult;
            _this.classNameRepresentativeAlias = "st_representative-alias_JS";
            _this.selectorRepresentativeAlias = "." + _this.classNameRepresentativeAlias;
            _this.classNameRepresentativeFullName = "st_representative-fullname_JS";
            _this.selectorRepresentativeFullName = "." + _this.classNameRepresentativeFullName;
            _this.classNameSponsorData = "st_sponsor-data_JS";
            _this.selectorSponsorData = "." + _this.classNameSponsorData;
            _this.classNameSearchSponsor = "st_search-sponsors_JS";
            _this.selectorSearchSponsor = "." + _this.classNameSearchSponsor;
            _this.classNameFoundSponsor = "st_found-sponsors_JS";
            _this.selectorFoundSponsor = "." + _this.classNameFoundSponsor;
            _this.classNameSearchSponsorBy = "st_search-sponsor-by_JS";
            _this.selectorSearchSponsorBy = "." + _this.classNameSearchSponsorBy;
            _this.classNameRadioText = "st_radio-text";
            _this.selectorRadioText = "." + _this.classNameRadioText;
            _this.classRepresentativeBannerWrapper = "st_representative-banner--wrapper_JS";
            _this.selectorRepresentativeBannerWrapper = "." + _this.classRepresentativeBannerWrapper;
            return _this;
        }
        return StSearchSponsorClassConfig;
    }(st_module_11.StModule);
    exports.StSearchSponsorClassConfig = StSearchSponsorClassConfig;
});

define("core/shopify-app/st-modules/search-sponsor/search-sponsor-guard", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_12, _features_config_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsorGuard = void 0;
    var StSearchSponsorGuard = function(_super) {
        __extends(StSearchSponsorGuard, _super);
        function StSearchSponsorGuard(classConfig, browserHistory, objectFormatting, generalMethods, cartComponent) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SearchSponsorGuard";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.listenForSponsorChange();
                    _this.cartComponent.subscribeRenderCart(function() {
                        var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                        var currentAlias = urlParams[_features_config_3.aliasQueryParam];
                        _this.toggleCantGoUnderCorporateSite(currentAlias === _features_config_3.defaultWebAlias);
                    });
                });
            };
            _this.toggleElementVisibility = function(element, hideElement) {
                if (hideElement) {
                    _this.hideElement(element);
                } else {
                    _this.showElement(element);
                }
            };
            _this.showElement = function(element) {
                if (_this.isElementHidden(element)) {
                    element.classList.remove("st_hidden");
                }
            };
            _this.hideElement = function(element) {
                if (!_this.isElementHidden(element)) {
                    element.classList.add("st_hidden");
                }
            };
            _this.isElementHidden = function(element) {
                return element.classList.contains("st_hidden");
            };
            _this.toggleShoppingWith = function(hideElement) {
                var banner = document.querySelector(_this.classConfig.selectorRepresentativeBannerWrapper);
                _this.toggleElementVisibility(banner, hideElement);
            };
            _this.disableNonSponsor = function() {
                var nonSponsorBtn = document.querySelector(_this.classConfig.selectorNonSponsor);
                nonSponsorBtn === null || nonSponsorBtn === void 0 ? void 0 : nonSponsorBtn.remove();
            };
            _this.toggleBuying = function(hideBuying) {
                _this.toggleCheckoutButtons(hideBuying);
                _this.togglePaymentButtons(hideBuying);
                _this.toggleSearchSponsor(hideBuying);
            };
            _this.toggleSearchSponsor = function(hideElement) {
                var searchSponsorWrappers = document.querySelectorAll(".st_search-sponsor--wrapper_JS");
                searchSponsorWrappers.forEach(function(searchSponsorWrapper) {
                    _this.toggleSearchSponsorInput(searchSponsorWrapper, !hideElement);
                    _this.toggleSearchSponsorResult(searchSponsorWrapper, hideElement);
                });
            };
            _this.toggleSearchSponsorResult = function(container, hideElement) {
                var searchSponsorResultWrapper = container.querySelector(".st_search-result_JS");
                if (!!searchSponsorResultWrapper) {
                    _this.toggleElementVisibility(searchSponsorResultWrapper, hideElement);
                }
            };
            _this.toggleSearchSponsorInput = function(container, hideElement) {
                var searchSponsorInputWrapper = container.querySelector(".st_search-input_JS");
                if (!!searchSponsorInputWrapper) {
                    _this.toggleElementVisibility(searchSponsorInputWrapper, hideElement);
                }
            };
            _this.toggleCheckoutButtons = function(hideElement) {
                var checkoutButtons = document.querySelectorAll('button[name="checkout"]');
                if (checkoutButtons.length > 0) {
                    checkoutButtons.forEach(function(btn) {
                        _this.toggleElementVisibility(btn, hideElement);
                    });
                }
            };
            _this.togglePaymentButtons = function(hideElement) {
                var paymentButtonsWrapper = document.querySelectorAll(".st_product-buy-now-wrapper_JS");
                if (paymentButtonsWrapper.length > 0) {
                    paymentButtonsWrapper.forEach(function(wrp) {
                        _this.toggleElementVisibility(wrp, hideElement);
                    });
                }
            };
            _this.toggleCantGoUnderCorporateSite = function(hideElements) {
                if (!_features_config_3.canGoUnderCorporateSite) {
                    _this.disableNonSponsor();
                    _this.toggleShoppingWith(hideElements);
                    _this.toggleBuying(hideElements);
                }
            };
            _this.listenForSponsorChange = function() {
                window.addEventListener("sponsorChange", function() {
                    var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                    var currentAlias = urlParams[_features_config_3.aliasQueryParam];
                    _this.toggleCantGoUnderCorporateSite(currentAlias === _features_config_3.defaultWebAlias);
                });
            };
            _this.classConfig = classConfig;
            _this.browserHistory = browserHistory;
            _this.objectFormatting = objectFormatting;
            _this.generalMethods = generalMethods;
            _this.cartComponent = cartComponent;
            return _this;
        }
        return StSearchSponsorGuard;
    }(st_module_12.StModule);
    exports.StSearchSponsorGuard = StSearchSponsorGuard;
});

define("core/connector-app/_shared/models/customer/sponsor/customer.update.sponsor.request", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/connector-app/_shared/models/webalias/webalias.response.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/account/_general/account-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_13) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountClassConfig = void 0;
    var StAccountClassConfig = function(_super) {
        __extends(StAccountClassConfig, _super);
        function StAccountClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "AccountClassConfig";
            _this.classNameProvinceSelector = "st_province-selector_JS";
            _this.selectorProvinceSelector = "." + _this.classNameProvinceSelector;
            _this.classNameProvinceSource = "st_province-source_JS";
            _this.selectorProvinceSource = "." + _this.classNameProvinceSource;
            _this.classNameAccountPage = "st_account_JS";
            _this.selectorAccountPage = "." + _this.classNameAccountPage;
            _this.classNameAccountSection = "st_account-page--section_JS";
            _this.selectorAccountSection = "." + _this.classNameAccountSection;
            _this.classNameAccountContent = "st_account-page_JS";
            _this.selectorAccountContent = "." + _this.classNameAccountContent;
            _this.classNameAccountNavWrapper = "st_account-nav--wrapper_JS";
            _this.selectorAccountNavWrapper = "." + _this.classNameAccountNavWrapper;
            _this.classNameAccountNavHolder = "st_account-nav--holder_JS";
            _this.selectorAccountNavHolder = "." + _this.classNameAccountNavHolder;
            _this.classNameAccountNavHolderSingle = "st_account-nav--holder-single_JS";
            _this.selectorAccountNavHolderSingle = "." + _this.classNameAccountNavHolderSingle;
            _this.classNameAccountNavButton = "st_account-button_JS";
            _this.selectorAccountNavButton = "." + _this.classNameAccountNavButton;
            _this.classNameAccountIcon = "st_account--nav-icon_JS";
            _this.selectorAccountIcon = "." + _this.classNameAccountIcon;
            _this.classNameAccountCopyText = "st_copy-repsite_JS";
            _this.selectorAccountIconCopyText = "." + _this.classNameAccountCopyText;
            _this.classNameAccountCopyTextWrapper = "st_copy-repsite--wrapper_JS";
            _this.selectorAccountIconCopyTextWrapper = "." + _this.classNameAccountCopyTextWrapper;
            _this.classNameAccountLogout = "st_account-logout_JS";
            _this.selectorAccountLogout = "." + _this.classNameAccountLogout;
            _this.classNameAccountWebAlias = "st_input-wrapper_JS input";
            _this.selectorAccountWebAlias = "." + _this.classNameAccountWebAlias;
            _this.classNameAccountAddressesDropdown = "st_addresses-dots--button_JS";
            _this.selectorAccountAddressesDropdown = "." + _this.classNameAccountAddressesDropdown;
            _this.classNameAccountAddressesDropdownWrapper = "st_dropdown-address--wrapper";
            _this.selectorAccountAddressesDropdownWrapper = "." + _this.classNameAccountAddressesDropdownWrapper;
            _this.classNameAccountTabButton = "st_button-wrapper_JS";
            _this.selectorAccountTabButton = "." + _this.classNameAccountTabButton;
            _this.classNameAccountBackButton = "st_arrow-back--button_JS";
            _this.selectorAccountBackButton = "." + _this.classNameAccountBackButton;
            _this.classNameSingleOrder = "st_single-order_JS";
            _this.selectorSingleOrder = "." + _this.classNameSingleOrder;
            _this.classNameOpenOrderCSSClass = "st_open-single-order";
            _this.selectorOpenOrderCSSClass = "." + _this.classNameOpenOrderCSSClass;
            _this.classNameOpenSingleOrderButton = "st_open-single-order_JS";
            _this.selectorOpenSingleOrderButton = "." + _this.classNameOpenSingleOrderButton;
            _this.classNameOrderHistory = "st_order-history_JS";
            _this.selectorOrderHistory = "." + _this.classNameOrderHistory;
            _this.classNameBackToHistoryOrders = "st_back-to-history-orders_JS";
            _this.selectorBackToHistoryOrders = "." + _this.classNameBackToHistoryOrders;
            _this.classNameBackOfficeLink = "st_backoffice-link_JS";
            _this.selectorBackOfficeLink = "." + _this.classNameBackOfficeLink;
            _this.classNameWebAliasFormatting = "st_formatting-web-alias_JS";
            _this.selectorWebAliasFormatting = "." + _this.classNameWebAliasFormatting;
            _this.classNameWebAliasWrapper = "st_web-alias-wrapper_JS";
            _this.selectorWebAliasWrapper = "." + _this.classNameWebAliasWrapper;
            _this.classNameWebAliasValue = "st_web-alias-readonly-input_JS";
            _this.selectorWebAliasValue = "." + _this.classNameWebAliasValue;
            _this.classNameAddressesWrapper = "st_addresses--wrapper_JS";
            _this.selectorAddressesWrapper = "." + _this.classNameAddressesWrapper;
            _this.classNameEditWebAliasForm = "st_edit-webalias-form_JS";
            _this.selectorEditWebAliasForm = "." + _this.classNameEditWebAliasForm;
            _this.classNameSubmitButton = "st_submit--btn_JS";
            _this.selectorSubmitButton = "." + _this.classNameSubmitButton;
            _this.classNameProvinceWrapper = "st_province-wrapper_JS";
            _this.selectorProvinceWrapper = "." + _this.classNameProvinceWrapper;
            _this.classNamePersonalInfoForm = "st_personal-info-form_JS";
            _this.selectorPersonalInfoForm = "." + _this.classNamePersonalInfoForm;
            _this.classNameBusinessContent = "st_account-business--content_JS";
            _this.selectorBusinessContent = "." + _this.classNameBusinessContent;
            _this.classNameBusinessContentName = "st_account-business--name_JS";
            _this.selectorBusinessContentName = "." + _this.classNameBusinessContentName;
            _this.classNameBusinessContentRepName = "st_account-business--rep-name_JS";
            _this.selectorBusinessContentRepName = "." + _this.classNameBusinessContentRepName;
            _this.classNameBusinessContentEmail = "st_account-business--email_JS";
            _this.selectorBusinessContentEmail = "." + _this.classNameBusinessContentEmail;
            return _this;
        }
        return StAccountClassConfig;
    }(st_module_13.StModule);
    exports.StAccountClassConfig = StAccountClassConfig;
});

define("core/shopify-app/st-modules/account/blocks/personal-site/personal-site", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_14, _features_config_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountPersonalSite = void 0;
    var StAccountPersonalSite = function(_super) {
        __extends(StAccountPersonalSite, _super);
        function StAccountPersonalSite(classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountPersonalSite";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.copyRefToClipboard(_this_1.classConfig.selectorAccountIconCopyText, ".st_representative-site-link_JS");
                    _this_1.getRefCode();
                });
            };
            _this_1.getRefCode = function() {
                var propertyWrapper = document.querySelector(".st_get-ref-code_JS");
                var customersRef = propertyWrapper === null || propertyWrapper === void 0 ? void 0 : propertyWrapper.getAttribute("data-customer-tag");
                var retailInput = document.querySelectorAll(".st_retail-personal-promo-code-link_JS");
                if (_features_config_4.shareRefCodeFunctionality) {
                    _this_1.copyRefToClipboard(".st_referral-link-copy-clipboard_JS", ".st_retail-personal-promo-code-link_JS");
                    _this_1.createLinkWithRef;
                    _this_1.showIncludePromoCode();
                    _this_1.showPersonalSiteRetailBlock();
                    if (!customersRef) {
                        _this_1.createLinkWithoutRef;
                    }
                } else {
                    _this_1.hideIncludePromoCode();
                    _this_1.hidePersonalSiteRetailBlock();
                    _this_1.createLinkWithoutRef;
                }
            };
            _this_1.createLinkWithRef = function(alias) {
                var propertyWrapper = document.querySelector(".st_get-ref-code_JS");
                var customersRef = propertyWrapper === null || propertyWrapper === void 0 ? void 0 : propertyWrapper.getAttribute("data-customer-tag");
                var retailInput = document.querySelectorAll(".st_retail-personal-promo-code-link_JS");
                retailInput.forEach(function(input) {
                    input.value = window.location.protocol + "//" + window.location.host + "/?" + _features_config_4.aliasQueryParam + "=" + alias + "&" + "ref=" + customersRef;
                });
            };
            _this_1.createLinkWithoutRef = function(als) {
                var inputEl = document.querySelectorAll(".st_representative-site-link_JS");
                if (inputEl) {
                    inputEl.forEach(function(input) {
                        var als = localStorage.getItem("webAlias");
                        input.value = window.location.protocol + "//" + window.location.host + "/?" + _features_config_4.aliasQueryParam + "=" + als;
                    });
                }
            };
            _this_1.hidePersonalSiteRetailBlock = function() {
                var personalSiteRetailBlockWrapper = document.querySelector(".st_personal-site-retail--wrapper_JS");
                if (!!personalSiteRetailBlockWrapper) {
                    personalSiteRetailBlockWrapper.classList.add("st_hidden");
                }
            };
            _this_1.showPersonalSiteRetailBlock = function() {
                var personalSiteRetailBlockWrapper = document.querySelector(".st_personal-site-retail--wrapper_JS");
                if (!!personalSiteRetailBlockWrapper) {
                    personalSiteRetailBlockWrapper.classList.remove("st_hidden");
                }
            };
            _this_1.createLinkWithRefRep = function(alias) {
                var propertyWrapper = document.querySelector(".st_get-ref-code_JS");
                var customersRef = propertyWrapper === null || propertyWrapper === void 0 ? void 0 : propertyWrapper.getAttribute("data-customer-tag");
                var retailInput = document.querySelectorAll(".st_representative-site-link_JS");
                retailInput.forEach(function(input) {
                    var hisAlias = localStorage.getItem("webAlias");
                    input.value = window.location.protocol + "//" + window.location.host + "/?" + "als=" + hisAlias + "&" + "ref=" + customersRef;
                });
            };
            _this_1.createLinkWithoutRefRep = function(als) {
                var inputEl = document.querySelectorAll(".st_representative-site-link_JS");
                if (inputEl) {
                    inputEl.forEach(function(input) {
                        var hisAlias = localStorage.getItem("webAlias");
                        input.value = window.location.protocol + "//" + window.location.host + "/?" + "als=" + hisAlias;
                    });
                }
            };
            _this_1.includePromoCode = function(als) {
                var _this = _this_1;
                var includeInput = document.querySelector(".st_include-promo-code-input_JS");
                if (!!includeInput) {
                    var inputEl_1 = document.querySelectorAll(".st_representative-site-link_JS");
                    if (includeInput.checked) {
                        _this.createLinkWithRefRep(als);
                    } else {
                        _this.createLinkWithoutRefRep(als);
                    }
                    includeInput.addEventListener("change", function(event) {
                        if (!!inputEl_1) {
                            if (includeInput.checked) {
                                _this.createLinkWithRefRep(als);
                            } else {
                                _this.createLinkWithoutRefRep(als);
                            }
                        }
                    });
                }
            };
            _this_1.hideIncludePromoCode = function() {
                var includePromoCodeWrapper = document.querySelector(".st_include-promo-code-wrapper_JS");
                if (!!includePromoCodeWrapper) {
                    includePromoCodeWrapper.classList.add("st_hidden");
                }
            };
            _this_1.showIncludePromoCode = function() {
                var includePromoCodeWrapper = document.querySelector(".st_include-promo-code-wrapper_JS");
                if (!!includePromoCodeWrapper) {
                    includePromoCodeWrapper.classList.remove("st_hidden");
                }
            };
            _this_1.copyRefToClipboard = function(button, input) {
                var copyRepSiteButtonAll = document.querySelectorAll(button);
                if (!!copyRepSiteButtonAll) {
                    copyRepSiteButtonAll.forEach(function(btn) {
                        btn.addEventListener("click", function(e) {
                            e.preventDefault();
                            var copyText = document.querySelectorAll(input);
                            if (!!copyText) {
                                copyText.forEach(function(input) {
                                    if (!!input) {
                                        input.select();
                                        input.setSelectionRange(0, 99999);
                                        navigator.clipboard.writeText(input.value);
                                        input.style.backgroundColor = "rgb(217, 218, 220)";
                                        input.style.transition = "0.2s";
                                        setTimeout(function() {
                                            input.style.backgroundColor = "rgb(249, 249, 249)";
                                        }, 1e3);
                                    }
                                });
                            }
                        });
                    });
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountPersonalSite;
    }(st_module_14.StModule);
    exports.StAccountPersonalSite = StAccountPersonalSite;
});

define("core/shopify-app/st-modules/webalias/webalias", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_15, _features_config_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StWebAlias = void 0;
    var StWebAlias = function(_super) {
        __extends(StWebAlias, _super);
        function StWebAlias(classConfig, browserHistory, objectFormatting, cookies, customerType, generalMethods, injectRepresentativeInfo, cartComponent, searchSponsorGuard, accountPersonalSite) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "WebAlias";
            _this.cookieNameWebAlias = "webAlias";
            _this.cookieNameRepId = "repId";
            _this.cookieNameFirstName = "firstName";
            _this.cookieNameLastName = "lastName";
            _this.cookieNameImageUrl = "imageUrl";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.initWebAliasFlow();
                    console.log("lockedRepresentativeSite: ", _features_config_5.lockedRepresentativeSite);
                    console.log("canGoUnderCorporateSite: ", _features_config_5.canGoUnderCorporateSite);
                    _this.getSponsorInformation();
                });
            };
            _this.initWebAliasFlow = function() {
                if (_this.isCustomerRepresentative) {
                    _this.representativeAliasFlow();
                    return;
                }
                if (_this.isCustomerRetail) {
                    _this.retailAliasFlow();
                    return;
                }
                if (_this.isCustomerGuest) {
                    _this.guestAliasFlow();
                }
            };
            _this.representativeAliasFlow = function() {
                _this.getRepresentativesOwnInfo(_this.customerIdFromMetafields);
            };
            _this.guestAliasFlow = function() {
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_5.aliasQueryParam];
                var urlAliasExists = !!currentAlias;
                var cookieAliasExists = !!_this.cookies.getCookie("webAlias");
                if (urlAliasExists) {
                    _this.getRepresentativesOwnInfo(currentAlias);
                    return;
                }
                if (cookieAliasExists) {
                    _this.injectRepInfoFromCookie();
                    return;
                }
                _this.injectDefaultRepInfo();
            };
            _this.retailAliasFlow = function() {
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_5.aliasQueryParam];
                var urlAliasExists = !!currentAlias;
                var cookieAliasExists = !!_this.cookies.getCookie("webAlias");
                var isLocked = _features_config_5.lockedRepresentativeSite;
                if (isLocked) {
                    var customerIdOrAls = _this.customerIdFromMetafields;
                    _this.getCustomersRepresentativeInfo(customerIdOrAls);
                    return;
                }
                if (!isLocked) {
                    if (urlAliasExists) {
                        _this.getRepresentativesOwnInfo(currentAlias);
                        return;
                    } else {
                        if (cookieAliasExists) {
                            _this.injectRepInfoFromCookie();
                            return;
                        } else {
                            _this.injectDefaultRepInfo();
                            return;
                        }
                    }
                }
            };
            _this.handleRepresentativeInfoResponse = function(response) {
                var data = response.data, status = response.status;
                var webAlias = data.webAlias, repId = data.repId;
                if (status !== 200) {
                    _this.nonExistentRepresentativeFlow();
                    return;
                }
                if (!webAlias && webAlias === "") {
                    data = __assign(__assign({}, data), {
                        webAlias: repId
                    });
                }
                _this.updateCurrentRepInfo(data);
            };
            _this.getRepresentativesOwnInfo = function(customerIdOrAlias) {
                _this.getRepresentativeInfo({
                    customerIdOrAlias: customerIdOrAlias,
                    isOwnInfo: true
                }, _this.handleRepresentativeInfoResponse);
            };
            _this.getCustomersRepresentativeInfo = function(customerIdOrAlias) {
                _this.getRepresentativeInfo({
                    customerIdOrAlias: customerIdOrAlias,
                    isOwnInfo: false
                }, _this.handleRepresentativeInfoResponse);
            };
            _this.getRepresentativeInfo = function(webAliasRequest, handleResponse) {
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["webalias"]["repSite"],
                        method: "post",
                        contentType: "json",
                        data: webAliasRequest,
                        callback: function(response) {
                            try {
                                var representativeInfoRes = JSON.parse(response.response);
                                handleResponse(representativeInfoRes);
                            } catch (error) {
                                _this.nonExistentRepresentativeFlow();
                                console.log("Response Error ------\x3e" + error);
                            }
                        }
                    });
                } catch (error) {
                    console.log("Request Error ------\x3e" + error);
                }
            };
            _this.getSponsorInformation = function() {
                var repIdMetafield = window.customerInfoMetafields.representativeId;
                var webAliasRequestedData = {
                    customerIdOrAlias: repIdMetafield,
                    isOwnInfo: true
                };
                _this.getRepresentativeInfo(webAliasRequestedData, _this.handleSponsorInfoResponse);
            };
            _this.handleSponsorInfoResponse = function(response) {
                if (response.status === 200) {
                    var sponsorInfo = response.data;
                    _this.injectRepresentativeInfo.injectSponsorInfoToField(sponsorInfo.firstName, sponsorInfo.lastName);
                    _this.accountPersonalSite.createLinkWithRef(sponsorInfo.webAlias);
                    _this.accountPersonalSite.includePromoCode(sponsorInfo.webAlias);
                } else {
                    _this.injectRepresentativeInfo.injectSponsorInfoToField("", "");
                }
            };
            _this.isDataEqualToStored = function(repInfo) {
                return repInfo.webAlias === _this.cookies.getCookie("webAlias") && repInfo.firstName === _this.cookies.getCookie("firstName") && repInfo.lastName === _this.cookies.getCookie("lastName");
            };
            _this.updateCurrentRepInfo = function(repInfo) {
                var webAlias = repInfo.webAlias;
                if (!_this.isDataEqualToStored(repInfo)) {
                    _this.setRepresentativeCookies(repInfo);
                }
                if (!_this.isAliasEqualToUrlAlias(webAlias)) {
                    _this.setNewAliasInUrl(webAlias);
                }
                _this.cartComponent.updateCartItemsProperies(webAlias);
                _this.searchSponsorGuard.toggleCantGoUnderCorporateSite(webAlias === _features_config_5.defaultWebAlias);
                _this.injectRepresentativeInfo.injectToFields(repInfo);
            };
            _this.nonExistentRepresentativeFlow = function() {
                if (!_this.isCustomerRetail) {
                    _this.injectDefaultRepInfo();
                    return;
                }
                _this.injectRepInfoFromCookie();
            };
            _this.injectRepInfoFromCookie = function() {
                var repInfo = {
                    firstName: _this.cookies.getCookie(_this.cookieNameFirstName),
                    lastName: _this.cookies.getCookie(_this.cookieNameLastName),
                    webAlias: _this.cookies.getCookie(_this.cookieNameWebAlias),
                    repId: _this.cookies.getCookie(_this.cookieNameRepId)
                };
                var imageUrl = _this.cookies.getCookie(_this.cookieNameImageUrl);
                if (!!imageUrl && _features_config_5.additionalRepInfo) {
                    repInfo = __assign(__assign({}, repInfo), {
                        imageUrl: imageUrl
                    });
                }
                _this.updateCurrentRepInfo(repInfo);
            };
            _this.injectDefaultRepInfo = function() {
                var repInfo = {
                    webAlias: _features_config_5.defaultWebAlias,
                    firstName: _features_config_5.corporationName,
                    lastName: ""
                };
                if (_features_config_5.additionalRepInfo) {
                    repInfo = __assign(__assign({}, repInfo), {
                        imageUrl: _features_config_5.defaultCorporationImage
                    });
                }
                _this.updateCurrentRepInfo(repInfo);
            };
            _this.isAliasEqualToStored = function(alias) {
                return alias === _this.cookies.getCookie("webAlias");
            };
            _this.isAliasEqualToUrlAlias = function(alias) {
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_5.aliasQueryParam];
                return currentAlias === alias;
            };
            _this.setNewAliasInUrl = function(alias) {
                var _a;
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var newUrlParams = __assign(__assign({}, urlParams), (_a = {}, _a[_features_config_5.aliasQueryParam] = alias, 
                _a));
                var newURL = window.location.href.replace(window.location.search, "");
                _this.browserHistory.pushHistory(newURL, newUrlParams);
            };
            _this.setRepresentativeCookies = function(repInfo) {
                _this.cookies.setCookies(_this.cookieNameWebAlias, repInfo.webAlias);
                _this.cookies.setCookies(_this.cookieNameRepId, repInfo.repId);
                _this.cookies.setCookies(_this.cookieNameFirstName, repInfo.firstName);
                _this.cookies.setCookies(_this.cookieNameLastName, repInfo.lastName);
                if (_features_config_5.additionalRepInfo) {
                    _this.cookies.setCookies(_this.cookieNameImageUrl, repInfo.imageUrl);
                }
            };
            _this.initSponsorCheck = function() {
                var shopifyCustomerId = _this.shopifyCustomerId;
                if (_this.isTimeForSponsorCheck() && shopifyCustomerId && shopifyCustomerId !== 0) {
                    _this.updateCustomerSponsor(shopifyCustomerId);
                }
            };
            _this.updateCustomerSponsor = function(shopifyCustomerId) {
                var updateSponsorData = {
                    shopifyCustomerId: shopifyCustomerId
                };
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["customer"]["updateSponsor"],
                        method: "post",
                        contentType: "json",
                        data: updateSponsorData
                    });
                } catch (error) {
                    console.log("Request Error ------\x3e " + error);
                }
            };
            _this.isTimeForSponsorCheck = function() {
                var timestamp = Date.now();
                var lastCheck = _this.customerSponsorLastCheck;
                var timeThreshold = _features_config_5.sponsorGenealogyTimeout ? _features_config_5.sponsorGenealogyTimeout : 9e5;
                return timestamp - lastCheck > timeThreshold;
            };
            _this.classConfig = classConfig;
            _this.browserHistory = browserHistory;
            _this.objectFormatting = objectFormatting;
            _this.cookies = cookies;
            _this.customerType = customerType;
            _this.generalMethods = generalMethods;
            _this.injectRepresentativeInfo = injectRepresentativeInfo;
            _this.cartComponent = cartComponent;
            _this.searchSponsorGuard = searchSponsorGuard;
            _this.accountPersonalSite = accountPersonalSite;
            return _this;
        }
        Object.defineProperty(StWebAlias.prototype, "isCustomerGuest", {
            get: function() {
                return this.customerType.get() === _features_config_5.ECustomerType.guest;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "isCustomerRetail", {
            get: function() {
                return this.customerType.get() === _features_config_5.ECustomerType.retail;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "isCustomerRepresentative", {
            get: function() {
                return this.customerType.get() === _features_config_5.ECustomerType.representative;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "customerIdFromMetafields", {
            get: function() {
                return window.customerInfoMetafields.customerId;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "shopifyCustomerId", {
            get: function() {
                return window.customerShopifyId;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "customerSponsorLastCheck", {
            get: function() {
                return window.customerSponsorLastCheck;
            },
            enumerable: false,
            configurable: true
        });
        return StWebAlias;
    }(st_module_15.StModule);
    exports.StWebAlias = StWebAlias;
});

define("core/shopify-app/st-modules/_general-methods/form/form-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_16) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StFormClassConfig = void 0;
    var StFormClassConfig = function(_super) {
        __extends(StFormClassConfig, _super);
        function StFormClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "FormClassConfig";
            _this.classNameDateWrp = "st_date_JS";
            _this.selectorDateWrp = "." + _this.classNameDateWrp;
            _this.classNameDateYearInput = "st_date--year_JS";
            _this.selectorDateYearInput = "." + _this.classNameDateYearInput;
            _this.classNameDateMonthInput = "st_date--month_JS";
            _this.selectorDateMonthInput = "." + _this.classNameDateMonthInput;
            _this.classNameDateDayInput = "st_date--day_JS";
            _this.selectorDateDayInput = "." + _this.classNameDateDayInput;
            _this.classNameDateCompleteInput = "st_date--complete_JS";
            _this.selectorDateCompleteInput = "." + _this.classNameDateCompleteInput;
            _this.months = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
            return _this;
        }
        return StFormClassConfig;
    }(st_module_16.StModule);
    exports.StFormClassConfig = StFormClassConfig;
});

define("core/shopify-app/st-modules/_general-methods/form/fields/date-input", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_17) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDateInput = void 0;
    var StDateInput = function(_super) {
        __extends(StDateInput, _super);
        function StDateInput(classConfig) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "DateInput";
            _this_1.setupDateFields = function() {
                var dateWraps = document.querySelectorAll(_this_1.classConfig.selectorDateWrp);
                dateWraps.forEach(function(dateWrp) {
                    _this_1.setupDateField(dateWrp);
                });
            };
            _this_1.setupDateField = function(dateWrap) {
                var _a;
                var dateYearInput = dateWrap.querySelector(_this_1.classConfig.selectorDateYearInput);
                var dateMonthInput = dateWrap.querySelector(_this_1.classConfig.selectorDateMonthInput);
                var dateDayInput = dateWrap.querySelector(_this_1.classConfig.selectorDateDayInput);
                var now = new Date();
                var yearNow = now.getUTCFullYear();
                _this_1.generateYears(dateYearInput, 1900, yearNow);
                dateYearInput = dateWrap.querySelector(_this_1.classConfig.selectorDateYearInput);
                var defaultYear = dateYearInput.getAttribute("data-default");
                var defaultYearIndex = !!defaultYear ? parseInt(dateYearInput.querySelector('[value="'.concat(defaultYear, '"]')).getAttribute("data-index")) : 0;
                _this_1.setSelectValue(dateYearInput, defaultYearIndex);
                _this_1.generateMonths(dateMonthInput);
                dateMonthInput = dateWrap.querySelector(_this_1.classConfig.selectorDateMonthInput);
                var defaultMonth = dateMonthInput.getAttribute("data-default");
                var defaultMonthIndex = !!defaultMonth ? parseInt(dateMonthInput.querySelector('[value="'.concat(defaultMonth, '"]')).getAttribute("data-index")) : 0;
                _this_1.setSelectValue(dateMonthInput, defaultMonthIndex);
                _this_1.generateDays(dateDayInput, (_a = parseInt(dateYearInput.value)) !== null && _a !== void 0 ? _a : yearNow, defaultMonthIndex);
                var defaultDay = dateDayInput.getAttribute("data-default");
                var defaultDayIndex = !!defaultDay ? parseInt(dateDayInput.querySelector('[value="'.concat(defaultDay, '"]')).getAttribute("data-index")) : 0;
                dateDayInput = dateWrap.querySelector(_this_1.classConfig.selectorDateDayInput);
                _this_1.setSelectValue(dateDayInput, defaultDayIndex);
                _this_1.setupEvents(dateWrap, dateYearInput, dateMonthInput, dateDayInput);
            };
            _this_1.getDays = function(year, month) {
                return new Date(year, month + 1, 0).getDate();
            };
            _this_1.generateDays = function(holder, year, month) {
                var days = _this_1.getDays(year, month);
                holder.replaceChildren();
                for (var i = 1; i <= days; i++) {
                    var option = _this_1.generateOption(i, undefined, undefined, i - 1);
                    holder.appendChild(option);
                }
                return days;
            };
            _this_1.generateMonths = function(holder) {
                for (var i = 0; i < _this_1.classConfig.months.length; i++) {
                    var option = _this_1.generateOption(i, _this_1.classConfig.months[i], undefined, i);
                    holder.appendChild(option);
                }
            };
            _this_1.generateYears = function(holder, startingYear, endYear) {
                for (var i = 0; i < endYear - startingYear; i++) {
                    var option = _this_1.generateOption(endYear - i, undefined, undefined, i);
                    holder.appendChild(option);
                }
            };
            _this_1.generateOption = function(value, displayValue, selected, elementIndex) {
                if (displayValue === void 0) {
                    displayValue = value;
                }
                if (selected === void 0) {
                    selected = false;
                }
                var option = document.createElement("option");
                option.value = "".concat(value);
                option.setAttribute("value", "".concat(value));
                option.innerHTML = "".concat(displayValue);
                if (selected) {
                    option.setAttribute("selected", "selected");
                }
                if (typeof elementIndex !== "undefined") {
                    option.setAttribute("data-index", "".concat(elementIndex));
                }
                return option;
            };
            _this_1.setSelectValue = function(holder, optionIndex) {
                var options = holder.querySelectorAll("option");
                var selected = options[holder.selectedIndex];
                if (!!selected) {
                    selected.removeAttribute("selected");
                    selected.selected = false;
                }
                optionIndex = optionIndex > options.length - 1 ? options.length - 1 : optionIndex;
                holder.selectedIndex = optionIndex;
                options[optionIndex].selected = true;
                options[optionIndex].setAttribute("selected", "selected");
            };
            _this_1.setInputValue = function(input, value) {
                input.value = value;
                input.setAttribute("value", value);
                input.dispatchEvent(new Event("change", {
                    bubbles: true
                }));
            };
            _this_1.setupEvents = function(dateWrap, yearInput, monthInput, dayInput) {
                var _this = _this_1;
                monthInput.addEventListener("change", function(e) {
                    _this.adaptDaysOnChange(dateWrap);
                    _this.completeDate(dateWrap);
                });
                yearInput.addEventListener("change", function(e) {
                    _this.adaptDaysOnChange(dateWrap);
                    _this.completeDate(dateWrap);
                });
                dayInput.addEventListener("change", function(e) {
                    _this.completeDate(dateWrap);
                });
            };
            _this_1.completeDate = function(dateWrap) {
                var yearInput = dateWrap.querySelector(_this_1.classConfig.selectorDateYearInput);
                var monthInput = dateWrap.querySelector(_this_1.classConfig.selectorDateMonthInput);
                var dayInput = dateWrap.querySelector(_this_1.classConfig.selectorDateDayInput);
                var completeInput = dateWrap.querySelector(_this_1.classConfig.selectorDateCompleteInput);
                var year = parseInt(yearInput.querySelectorAll("option")[yearInput.selectedIndex].value);
                var month = parseInt(monthInput.querySelectorAll("option")[monthInput.selectedIndex].value);
                var day = parseInt(dayInput.querySelectorAll("option")[dayInput.selectedIndex].value);
                var completeDate = "".concat(year, "-").concat(month + 1, "-").concat(day);
                _this_1.setInputValue(completeInput, completeDate);
            };
            _this_1.adaptDaysOnChange = function(dateWrap) {
                var yearInput = dateWrap.querySelector(_this_1.classConfig.selectorDateYearInput);
                var monthInput = dateWrap.querySelector(_this_1.classConfig.selectorDateMonthInput);
                var dayInput = dateWrap.querySelector(_this_1.classConfig.selectorDateDayInput);
                var year = parseInt(yearInput.querySelectorAll("option")[yearInput.selectedIndex].value);
                var month = parseInt(monthInput.querySelectorAll("option")[monthInput.selectedIndex].value);
                var day = parseInt(dayInput.querySelectorAll("option")[dayInput.selectedIndex].value);
                var maxDays = _this_1.generateDays(dayInput, year, month);
                var selectedIndex = day > maxDays ? maxDays : day;
                _this_1.setSelectValue(dayInput, selectedIndex - 1);
            };
            _this_1.classConfig = classConfig;
            return _this_1;
        }
        return StDateInput;
    }(st_module_17.StModule);
    exports.StDateInput = StDateInput;
});

define("core/shopify-app/st-modules/_general-methods/form/form", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_18) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StForm = void 0;
    var StForm = function(_super) {
        __extends(StForm, _super);
        function StForm(classConfig, dateInput) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "Form";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.dateInput.setupDateFields();
                });
            };
            _this_1.liveTrim = function(inputs) {
                inputs = inputs ? inputs : document.querySelectorAll(".st_input");
                var trimOperation = function(trigger) {
                    trigger.value = trigger.value.replace(/  +/g, " ");
                    trigger.value = trigger.value.trimStart();
                };
                inputs.forEach(function(input) {
                    input.addEventListener("keyup", function() {
                        trimOperation(this);
                    });
                    input.addEventListener("change", function() {
                        trimOperation(this);
                    });
                });
            };
            _this_1.collectFormData = function(form) {
                if (form === undefined || form === null) {
                    return false;
                }
                var data = {};
                for (var i = 0; i < form.elements.length; i++) {
                    var field = form.elements[i];
                    data = __assign(__assign({}, data), _this_1.collectField(field));
                }
                return data;
            };
            _this_1.collectField = function(field) {
                var data = {};
                if (!field.name || field.type === "file" || field.type === "reset" || field.type === "submit" || field.type === "button") return data;
                if (field.disabled && field.tagName !== "SELECT") return data;
                if (field.type === "select-multiple") {
                    data[field.name] = [];
                    for (var n = 0; n < field.options.length; n++) {
                        if (!field.options[n].selected) continue;
                        data[field.name].push(field.options[n].value);
                    }
                } else if (field.type !== "checkbox" && field.type !== "radio") {
                    data[field.name] = field.value;
                    if (field.value.toLowerCase() === "true") {
                        data[field.name] = true;
                    } else if (field.value.toLowerCase() === "false") {
                        data[field.name] = false;
                    }
                } else if (field.type === "checkbox") {
                    data[field.name] = !!field.checked;
                }
                if (field.getAttribute("data-parse") === "true") {
                    if (field.getAttribute("data-decode") !== "false") {
                        data[field.name] = decodeURIComponent(data[field.name]);
                    }
                    data[field.name] = JSON.parse(data[field.name]);
                }
                return data;
            };
            _this_1.markValidation = function(page, inputName, isValid, invalidMessage) {
                if (invalidMessage === void 0) {
                    invalidMessage = "";
                }
                page.querySelectorAll('[data-validation-visual="'.concat(inputName, '"]')).forEach(function(validationVisual) {
                    var errorMessage = validationVisual.parentElement.querySelector(".st_message-error_JS");
                    if (isValid) {
                        validationVisual.classList.remove("st_input_invalid");
                        if (!!errorMessage) {
                            errorMessage.remove();
                        }
                    } else {
                        validationVisual.classList.add("st_input_invalid");
                        if (!errorMessage) {
                            var errorMessageBlock = document.createElement("span");
                            errorMessageBlock.className = "st_message-error st_message-error_JS";
                            validationVisual.parentElement.append(errorMessageBlock);
                            errorMessage = validationVisual.parentElement.querySelector(".st_message-error_JS");
                        }
                        errorMessage.innerHTML = invalidMessage;
                    }
                });
            };
            _this_1.markValidationResults = function(page, validationResponse) {
                if (Object.keys(validationResponse).length > 0) {
                    Object.keys(validationResponse).forEach(function(paramName) {
                        _this_1.markValidation(page, paramName, validationResponse[paramName].isValid, validationResponse[paramName].message);
                    });
                }
            };
            _this_1.numbersOnly = function() {
                var numberInputs = document.querySelectorAll(".nuv_only-number_JS");
                if (numberInputs && numberInputs.length > 0) {
                    for (var i = 0; i < numberInputs.length; i++) {
                        var inputSelector = numberInputs[i];
                        inputSelector.addEventListener("keyup", function() {
                            this.value = isNaN(parseInt(this.value)) ? "" : parseInt(this.value);
                        });
                        inputSelector.addEventListener("input", function() {
                            this.value = isNaN(parseInt(this.value)) ? "" : parseInt(this.value);
                        });
                        inputSelector.addEventListener("change", function() {
                            this.value = isNaN(parseInt(this.value)) ? "" : parseInt(this.value);
                        });
                    }
                }
            };
            _this_1.formValidation = function() {
                var _this = _this_1;
                var taxId = document.querySelector('[name="enrollment[tax_id]"]');
                if (taxId && typeof taxId != "undefined") {
                    taxId.addEventListener("input", function(e) {
                        _this.applyFormatting(this);
                    });
                }
                var email = document.querySelector('[name="enrollment[email]"]');
                if (email && typeof email != "undefined") {
                    email.addEventListener("input", function(e) {
                        _this.validateEmail(this);
                    });
                }
                var upgradeEmail = document.querySelector('[name="address[email]"]');
                if (upgradeEmail && typeof upgradeEmail != "undefined") {
                    upgradeEmail.addEventListener("input", function(e) {
                        _this.validateEmail(this);
                    });
                }
            };
            _this_1.validateDateOfBirth = function() {
                var currentYear = new Date().getFullYear();
                var dateOfBirtd = document.querySelector('[name="enrollment[date_of_birtd]"]');
                if (dateOfBirtd && typeof dateOfBirtd != "undefined") {
                    var date = new Date(dateOfBirtd.value);
                    var year = date.getFullYear();
                    return year < currentYear && year > 1900;
                } else {
                    return false;
                }
            };
            _this_1.validateEmail = function(field) {
                var valid = false;
                var val = field.value;
                var at = val.indexOf("@");
                if (at >= 2) {
                    val = val.substr(at);
                    var dot = val.indexOf(".");
                    if (dot >= 2) {
                        val = val.substr(dot);
                        if (val.length >= 2) {
                            valid = true;
                            if (field.classList.contains("st-bds_invalid_input")) {
                                field.classList.remove("st-bds_invalid_input");
                            }
                        }
                    } else {
                        if (!field.classList.contains("st-bds_invalid_input")) {
                            field.classList.add("st-bds_invalid_input");
                        }
                    }
                } else {
                    if (!field.classList.contains("st-bds_invalid_input")) {
                        field.classList.add("st-bds_invalid_input");
                    }
                }
                return valid;
            };
            _this_1.applyFormatting = function(field) {
                var val = field.value;
                var format = "";
                var formatData = {
                    separator: "-",
                    format: "XXX-XX-XXXX",
                    type: "numeric"
                };
                if (formatData.type === "numeric") {
                    val = val.replace(/[^0-9]/g, "");
                }
                if (typeof formatData.format === "object") {
                    format = formatData.format[field.name];
                } else {
                    format = formatData.format;
                    var segments = formatData.separator ? formatData.format.split(formatData.separator) : [ formatData.format ];
                    var disp = [];
                    for (var i = 0; i < segments.length; i++) {
                        var it = val.substr(0, segments[i].length);
                        if (it !== "") {
                            disp.push(it);
                        }
                        val = val.replace(it, "");
                    }
                    val = disp.join(formatData.separator);
                }
                if (format.length > val.length) {
                    field.classList.add("st-bds_invalid_input");
                } else if (format.length === val.length) {
                    field.classList.remove("st-bds_invalid_input");
                } else {
                    val = val.substr(0, format.length);
                }
                field.value = val;
            };
            _this_1.clearFormatting = function(page, inputNames) {
                var _this = _this_1;
                inputNames.forEach(function(inputName) {
                    _this.markValidation(page, inputName, true, "");
                });
            };
            _this_1.dateInput = dateInput;
            _this_1.classConfig = classConfig;
            return _this_1;
        }
        return StForm;
    }(st_module_18.StModule);
    exports.StForm = StForm;
});

define("core/shopify-app/st-modules/account/account", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_19) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccount = void 0;
    var StAccount = function(_super) {
        __extends(StAccount, _super);
        function StAccount(form) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Account";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.form.liveTrim();
                });
            };
            _this.form = form;
            return _this;
        }
        return StAccount;
    }(st_module_19.StModule);
    exports.StAccount = StAccount;
});

define("core/shopify-app/st-modules/enrollment/_general/enrollment-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_20) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentClassConfig = void 0;
    var StEnrollmentClassConfig = function(_super) {
        __extends(StEnrollmentClassConfig, _super);
        function StEnrollmentClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentClassConfig";
            _this.classNameEnrollmentWrapper = "st_enrollment_JS";
            _this.selectorEnrollmentWrapper = "." + _this.classNameEnrollmentWrapper;
            _this.classNameEnrollmentPage = "st_enrollment--page_JS";
            _this.selectorEnrollmentPage = "." + _this.classNameEnrollmentPage;
            _this.classNameEnrollmentPageShow = "st_show";
            _this.selectorEnrollmentPageShow = "." + _this.classNameEnrollmentPageShow;
            _this.classNameEnrollmentForm = "st_enrollment-section--form_JS";
            _this.selectorEnrollmentForm = "." + _this.classNameEnrollmentForm;
            _this.classNameEnrollmentPrev = "st_enrollment--prev_JS";
            _this.selectorEnrollmentPrev = "." + _this.classNameEnrollmentPrev;
            _this.classNameEnrollmentNext = "st_enrollment--next_JS";
            _this.selectorEnrollmentNext = "." + _this.classNameEnrollmentNext;
            _this.classNameEnrollmentNavWrapper = "st_enrollment-nav--wrapper_JS";
            _this.selectorEnrollmentNavWrapper = "." + _this.classNameEnrollmentNavWrapper;
            _this.classNameEnrollmentNavHolder = "st_enrollment-nav--holder_JS";
            _this.selectorEnrollmentNavHolder = "." + _this.classNameEnrollmentNavHolder;
            _this.classNameEnrollmentNavHolderSingle = "st_enrollment-nav--holder-single_JS";
            _this.selectorEnrollmentNavHolderSingle = "." + _this.classNameEnrollmentNavHolderSingle;
            _this.classNameEnrollmentNavButton = "st_enrollment-button_JS";
            _this.selectorEnrollmentNavButton = "." + _this.classNameEnrollmentNavButton;
            _this.classNameInputInvalid = "st_input_invalid";
            _this.selectorInputInvalid = "." + _this.classNameInputInvalid;
            _this.classNameElementShow = "st_show";
            _this.selectorElementShow = "." + _this.classNameElementShow;
            _this.classNameElementHide = "st_hidden";
            _this.selectorElementHide = "." + _this.classNameElementHide;
            _this.textSubmit = "Submit";
            _this.textNext = "Next";
            _this.classNameEnrollmentPrivacyForm = "st_enrollment-section--privacy-form_JS";
            _this.selectorEnrollmentPrivacyForm = "." + _this.classNameEnrollmentPrivacyForm;
            _this.classNameEnrollmentTnCField = "st_enrollment--tnc-field_JS";
            _this.selectorEnrollmentTnCField = "." + _this.classNameEnrollmentTnCField;
            _this.classNameEnrollmentAccountDetailsForm = "st_enrollment-section--account-details-form_JS";
            _this.selectorEnrollmentAccountDetailsForm = "." + _this.classNameEnrollmentAccountDetailsForm;
            _this.classNameEnrollmentAccountDetailsPhone = "st_enrollment-section--account-details-phone_JS";
            _this.selectorEnrollmentAccountDetailsPhone = "." + _this.classNameEnrollmentAccountDetailsPhone;
            _this.classNameEnrollmentBusinessDetailsWebAlias = "st_enrollment-section--business-details-web-alias_JS";
            _this.selectorEnrollmentBusinessDetailsWebAlias = "." + _this.classNameEnrollmentBusinessDetailsWebAlias;
            _this.classNameEnrollmentBusinessDetailsWebAliasPresenter = "st_enrollment-web-alias-preview_JS";
            _this.selectorEnrollmentBusinessDetailsWebAliasPresenter = "." + _this.classNameEnrollmentBusinessDetailsWebAliasPresenter;
            _this.classNameEnrollmentBusinessDetailsSSN = "st_enrollment-section--business-details-ssn_JS";
            _this.selectorEnrollmentBusinessDetailsSSN = "." + _this.classNameEnrollmentBusinessDetailsSSN;
            _this.classEnrollmentRequiredKitVariantSelect = "st_enrollment-required-kits-select_JS";
            _this.selectorEnrollmentRequiredKitVariantSelect = "." + _this.classEnrollmentRequiredKitVariantSelect;
            _this.classEnrollmentRequiredKitVariantHeading = "st_enrollment-required-kit-variant-title_JS";
            _this.selectorEnrollmentRequiredKitVariantHeading = "." + _this.classEnrollmentRequiredKitVariantHeading;
            _this.classEnrollmentRequiredKitVariantPrice = "st_enrollment-required-kit-price_JS";
            _this.selectorEnrollmentRequiredKitVariantPrice = "." + _this.classEnrollmentRequiredKitVariantPrice;
            _this.classEnrollmentRequiredKitSelectedVariantTitle = "st_enrollment-required-kits-selected-variant-title_JS";
            _this.selectorEnrollmentRequiredKitSelectedVariantTitle = "." + _this.classEnrollmentRequiredKitSelectedVariantTitle;
            _this.classEnrollmentHiddenRequiredKitInput = "st_hidden-requiredKitInput_JS";
            _this.selectorEnrollmentHiddenRequiredKitInput = "." + _this.classEnrollmentHiddenRequiredKitInput;
            _this.classEnrollmentRequiredKitWrapper = "st_consultant-kit-order--wrapper";
            _this.selectorEnrollmentRequiredKitWrapper = "." + _this.classEnrollmentRequiredKitWrapper;
            _this.classEnrollmentRequiredKitsOptionsWrapper = "st_enrollment-required-kits-options-wrapper_JS";
            _this.selectorEnrollmentRequiredKitsOptionsWrapper = "." + _this.classEnrollmentRequiredKitsOptionsWrapper;
            _this.classEnrollmentRequiredKitsText = "st_consultant-kit-text_JS";
            _this.selectorEnrollmentRequiredKitsText = "." + _this.classEnrollmentRequiredKitsText;
            _this.classEnrollmentRequiredKitsImg = "st_enrollment-required-kit-img_JS";
            _this.selectorEnrollmentRequiredKitsImg = "." + _this.classEnrollmentRequiredKitsImg;
            _this.classNameEnrollmentOptionalKitsInput = "st_optional-kits--input_JS";
            _this.selectorEnrollmentOptionalKitsInput = "." + _this.classNameEnrollmentOptionalKitsInput;
            _this.classNameEnrollmentOptionalKitsTrigger = "st_enrollment--optional-bundle-trigger_JS";
            _this.selectorEnrollmentOptionalKitsTrigger = "." + _this.classNameEnrollmentOptionalKitsTrigger;
            _this.reviewEditText = "Edit";
            _this.classNameEnrollmentReviewWrapper = "st_enrollment--review-wrapper_JS";
            _this.selectorEnrollmentReviewWrapper = "." + _this.classNameEnrollmentReviewWrapper;
            _this.classNameEnrollmentReviewParamHolder = "st_enrollment--review-param-holder_JS";
            _this.selectorEnrollmentReviewParamHolder = "." + _this.classNameEnrollmentReviewParamHolder;
            _this.classNameEnrollmentReviewCartWrapper = "st_enrollment--review-cart-wrapper_JS";
            _this.selectorEnrollmentReviewCartWrapper = "." + _this.classNameEnrollmentReviewCartWrapper;
            _this.classNameEnrollmentReviewCartContentWrapper = "st_enrollment--review-cart-content-wrapper_JS";
            _this.selectorEnrollmentReviewCartContentWrapper = "." + _this.classNameEnrollmentReviewCartContentWrapper;
            _this.classNameEnrollmentReviewCartTotalWrapper = "st_enrollment--review-cart-total-wrapper_JS";
            _this.selectorEnrollmentReviewCartTotalWrapper = "." + _this.classNameEnrollmentReviewCartTotalWrapper;
            _this.classNameEnrollmentReviewCartTotal = "st_enrollment--review-cart-total_JS";
            _this.selectorEnrollmentReviewCartTotal = "." + _this.classNameEnrollmentReviewCartTotal;
            return _this;
        }
        return StEnrollmentClassConfig;
    }(st_module_20.StModule);
    exports.StEnrollmentClassConfig = StEnrollmentClassConfig;
});

define("core/shopify-app/st-modules/enrollment/enrollment", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_21) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollment = void 0;
    var StEnrollment = function(_super) {
        __extends(StEnrollment, _super);
        function StEnrollment(classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Enrollment";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.preventFormSubmit();
                });
            };
            _this.classConfig = classConfig;
            return _this;
        }
        StEnrollment.prototype.preventFormSubmit = function(forms) {
            forms = forms ? forms : document.querySelectorAll(this.classConfig.selectorEnrollmentForm);
            if (forms.length > 0) {
                forms.forEach(function(form) {
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                    });
                });
            }
        };
        return StEnrollment;
    }(st_module_21.StModule);
    exports.StEnrollment = StEnrollment;
});

define("core/shopify-app/st-modules/_general-methods/form/cart-manipulation", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_22) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCartManipulation = void 0;
    var StCartManipulation = function(_super) {
        __extends(StCartManipulation, _super);
        function StCartManipulation() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "CartManipulation";
            return _this;
        }
        return StCartManipulation;
    }(st_module_22.StModule);
    exports.StCartManipulation = StCartManipulation;
});

define("core/shopify-app/st-modules/_general-methods/form/loader", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_23) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StLoader = void 0;
    var StLoader = function(_super) {
        __extends(StLoader, _super);
        function StLoader() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Loader";
            _this.init = function() {};
            _this.on = function(triggerBtn) {
                if (!!triggerBtn && !triggerBtn.classList.contains("st_loader-active")) {
                    triggerBtn.classList.add("st_loader-active");
                }
            };
            _this.off = function(triggerBtn) {
                if (!!triggerBtn && triggerBtn.classList.contains("st_loader-active")) {
                    triggerBtn.classList.remove("st_loader-active");
                }
            };
            return _this;
        }
        return StLoader;
    }(st_module_23.StModule);
    exports.StLoader = StLoader;
});

define("core/shopify-app/st-modules/_general-methods/button/button-actions", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_24) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StButtonActions = exports.EButtonAction = void 0;
    var EButtonAction;
    (function(EButtonAction) {
        EButtonAction["enable"] = "enable";
        EButtonAction["disable"] = "disable";
        EButtonAction["toggleState"] = "toggleState";
        EButtonAction["prevent"] = "prevent";
        EButtonAction["allow"] = "allow";
        EButtonAction["addLoader"] = "addLoader";
        EButtonAction["removeLoader"] = "removeLoader";
        EButtonAction["toggleLoader"] = "toggleLoader";
    })(EButtonAction = exports.EButtonAction || (exports.EButtonAction = {}));
    var StButtonActions = function(_super) {
        __extends(StButtonActions, _super);
        function StButtonActions() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ButtonActions";
            _this.applyToMultiple = function(buttons, action) {
                buttons.forEach(function(button) {
                    _this[action](button);
                });
            };
            _this.enable = function(button) {
                if (!!button) {
                    button.removeAttribute("disabled");
                    button.classList.remove("st-disabled");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.disable = function(button) {
                if (!!button) {
                    button.setAttribute("disabled", "");
                    button.classList.add("st-disabled");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.addLoader = function(button) {
                if (!!button) {
                    button.classList.add("st-loading");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.removeLoader = function(button) {
                if (!!button) {
                    button.classList.remove("st-loading");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.toggleState = function(button) {
                if (!!button) {
                    if (button.classList.contains("st-disabled")) {
                        _this.enable(button);
                    } else {
                        _this.disable(button);
                    }
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.toggleLoader = function(button) {
                if (!!button) {
                    if (button.classList.contains("st-loading")) {
                        _this.removeLoader(button);
                    } else {
                        _this.addLoader(button);
                    }
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.prevent = function(button) {
                if (!!button) {
                    _this.disable(button);
                    _this.addLoader(button);
                    button.classList.add("st-blocked");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.allow = function(button) {
                if (!!button) {
                    _this.enable(button);
                    _this.removeLoader(button);
                    button.classList.remove("st-blocked");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.isBlocked = function(button) {
                return button.classList.contains("st-blocked");
            };
            _this.isLoading = function(button) {
                return button.classList.contains("st-loading");
            };
            _this.isDisabled = function(button) {
                return button.classList.contains("st-disabled") || button.classList.contains("st-disabled");
            };
            return _this;
        }
        return StButtonActions;
    }(st_module_24.StModule);
    exports.StButtonActions = StButtonActions;
});

define("core/connector-app/_shared/models/enrollment/enrollment-submit/enrollment.submit.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/enrollment/page/enrollment-submit", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_25, notification_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentActions = void 0;
    var StEnrollmentActions = function(_super) {
        __extends(StEnrollmentActions, _super);
        function StEnrollmentActions(classConfig, notification) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentActions";
            _this_1.submit = function(dataToSubmit) {
                var _this = _this_1;
                console.log(dataToSubmit);
                _this_1.ajax.send({
                    endpoint: _this.endpoint["enrollment"]["submit"],
                    method: "post",
                    contentType: "json",
                    data: dataToSubmit,
                    callback: function(response) {
                        try {
                            var submitResponse = JSON.parse(response.response);
                            if (response.status === 200) {
                                if (submitResponse.data.checkoutUrl && submitResponse.data.checkoutUrl !== "") {
                                    console.log(submitResponse.data.checkoutUrl);
                                    window.location.href = submitResponse.data.checkoutUrl;
                                } else {
                                    window.location.href = window.typagehandle;
                                }
                            } else {
                                _this.notification.showNotification(notification_1.ENotificationType.error, "An Error Occurred", submitResponse.message);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_1.ENotificationType.error, "An Error Occurred", error);
                        }
                    }
                });
            };
            _this_1.classConfig = classConfig;
            _this_1.notification = notification;
            return _this_1;
        }
        return StEnrollmentActions;
    }(st_module_25.StModule);
    exports.StEnrollmentActions = StEnrollmentActions;
});

define("core/connector-app/_shared/models/enrollment/enrollment-validation/enrollment.validation.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/connector-app/_shared/models/enrollment/enrollment-validation/enrollment.validation.response.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/enrollment/_general/enrollment-models", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/enrollment/page/enrollment-page", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_26) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentPage = void 0;
    var StEnrollmentPage = function(_super) {
        __extends(StEnrollmentPage, _super);
        function StEnrollmentPage(classConfig, generalMethods) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentPage";
            _this.maxPage = 0;
            _this.currentIndex = 0;
            _this.setMaxPage = function(maxPage) {
                _this.maxPage = maxPage;
            };
            _this.getMaxPage = function() {
                return _this.maxPage;
            };
            _this.setCurrentIndex = function(index) {
                _this.currentIndex = index;
            };
            _this.getCurrentIndex = function() {
                return _this.currentIndex;
            };
            _this.getCurrentPage = function() {
                return _this.getPageByIndex(_this.currentIndex);
            };
            _this.setupPageIndex = function(pages) {
                pages.forEach(function(page, ind) {
                    page.setAttribute("data-page-index", "" + ind);
                });
            };
            _this.getPageByIndex = function(pageIndex) {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var pages = wrp.querySelectorAll(_this.classConfig.selectorEnrollmentPage);
                return pages[pageIndex];
            };
            _this.openPage = function(pageIndex) {
                if (pageIndex === void 0) {
                    pageIndex = 0;
                }
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var alreadyOpen = wrp.querySelector(_this.classConfig.selectorEnrollmentPage + _this.classConfig.selectorEnrollmentPageShow);
                var enrollmentPages = wrp.querySelectorAll(_this.classConfig.selectorEnrollmentPage);
                var navHolder = wrp.querySelector(_this.classConfig.selectorEnrollmentNavHolder);
                var enrollmentNavElements = navHolder.querySelectorAll(_this.classConfig.selectorEnrollmentNavHolderSingle);
                var prevButtons = wrp.querySelectorAll(_this.classConfig.selectorEnrollmentPrev);
                if (!!alreadyOpen) {
                    alreadyOpen.classList.remove(_this.classConfig.classNameElementShow);
                }
                if (enrollmentPages.length > 0) {
                    enrollmentPages[pageIndex].classList.add(_this.classConfig.classNameElementShow);
                } else {
                    console.error("Invalid page index supplied to enrollment openPage method!");
                }
                enrollmentNavElements.forEach(function(navElement, index) {
                    navElement.classList.remove("active");
                    navElement.classList.remove("current");
                    if (index < pageIndex) {
                        navElement.classList.add("active");
                    } else if (index === pageIndex) {
                        navElement.classList.add("current");
                    }
                });
                _this.setCurrentIndex(pageIndex);
                _this.changeButtonText();
                _this.prevButtonVisibility(prevButtons, pageIndex);
                _this.generalMethods.scrollTo(_this.getCurrentPage(), 500);
            };
            _this.changeButtonText = function() {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var selectorEnrollmentNext = wrp.querySelector(_this.classConfig.selectorEnrollmentNext);
                selectorEnrollmentNext.querySelector("span").innerHTML = _this.currentIndex === _this.maxPage - 1 ? _this.classConfig.textSubmit : _this.classConfig.textNext;
            };
            _this.prevButtonVisibility = function(prevButtons, pageIndex) {
                if (pageIndex === 0) {
                    prevButtons.forEach(function(button) {
                        button.classList.add("st_hidden");
                    });
                } else {
                    prevButtons.forEach(function(button) {
                        button.classList.remove("st_hidden");
                    });
                }
            };
            _this.classConfig = classConfig;
            _this.generalMethods = generalMethods;
            return _this;
        }
        return StEnrollmentPage;
    }(st_module_26.StModule);
    exports.StEnrollmentPage = StEnrollmentPage;
});

define("core/shopify-app/st-modules/enrollment/_validation/enrollment-validation", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_27, notification_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentValidation = void 0;
    var StEnrollmentValidation = function(_super) {
        __extends(StEnrollmentValidation, _super);
        function StEnrollmentValidation(classConfig, notification, enrollmentPage) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentValidate";
            _this_1.validationMethods = {};
            _this_1.setupValidation = function(validationClasses) {
                validationClasses.forEach(function(validationClass) {
                    var methods = validationClass.setupValidationMethods();
                    if (!!methods) {
                        _this_1.validationMethods = __assign(__assign({}, _this_1.validationMethods), methods);
                    }
                });
            };
            _this_1.getValidation = function() {
                return __assign({}, _this_1.validationMethods);
            };
            _this_1.markInvalid = function(page, inputName) {
                page.querySelectorAll('[data-validation-visual="'.concat(inputName, '"]')).forEach(function(validationVisual) {
                    validationVisual.classList.add(_this_1.classConfig.classNameInputInvalid);
                });
            };
            _this_1.clearInvalid = function(page, specificElement) {
                if (!!specificElement) {
                    specificElement.classList.remove(_this_1.classConfig.classNameInputInvalid);
                } else {
                    page.querySelectorAll(_this_1.classConfig.selectorInputInvalid).forEach(function(element) {
                        element.classList.remove(_this_1.classConfig.classNameInputInvalid);
                    });
                }
            };
            _this_1.serverValidate = function(dataToValidate, validCB, invalidCB) {
                if (validCB === void 0) {
                    validCB = function() {};
                }
                if (invalidCB === void 0) {
                    invalidCB = function() {};
                }
                var _this = _this_1;
                _this_1.ajax.send({
                    endpoint: _this.endpoint["enrollment"]["validate-data"],
                    method: "post",
                    contentType: "json",
                    data: dataToValidate,
                    callback: function(request) {
                        try {
                            var data = JSON.parse(request.response);
                            if (request.status === 200) {
                                validCB(request, data);
                            } else {
                                invalidCB({
                                    status: request.status,
                                    message: data.message
                                });
                                _this.notification.showNotification(notification_2.ENotificationType.error, "Validation Error", data.message);
                            }
                        } catch (error) {
                            invalidCB({
                                status: 500,
                                message: error.message
                            });
                            console.error(error);
                            _this.notification.showNotification(notification_2.ENotificationType.error, "Validation Error", error);
                        }
                    }
                });
            };
            _this_1.basicValidate = function(pageIndex) {
                var page, forms;
                if (typeof pageIndex !== "undefined" && pageIndex !== -1) {
                    page = _this_1.enrollmentPage.getPageByIndex(pageIndex);
                    forms = page.querySelectorAll(_this_1.classConfig.selectorEnrollmentForm);
                } else {
                    var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                    forms = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentForm);
                }
                for (var i = 0; i < forms.length; i++) {
                    var form = forms[i];
                    var sectionName = form.getAttribute("data-name");
                    var validation = _this_1.getValidation();
                    if (validation[sectionName]) {
                        var basicValidationParams = validation[sectionName].basic();
                        for (var j = 0; j < basicValidationParams.length; j++) {
                            var validationParam = basicValidationParams[j];
                            var input = form.querySelector('[name="'.concat(validationParam, '"]'));
                            if (!!input) {
                                if (typeof input.value === "undefined" || input.value === "") {
                                    return false;
                                }
                            } else {
                                console.warn('Input with name: "'.concat(validationParam, "\" was added to basic validation but doesn't exist in DOM. Skipping this field for validation."));
                            }
                        }
                    }
                }
                return true;
            };
            _this_1.basicValidationDelay = 200;
            _this_1.setupBasicValidationEvents = function(inputSelector, afterValidation) {
                var _this = _this_1;
                afterValidation(_this.runBasicValidation());
                var eventListenerFn = function() {
                    clearTimeout(_this.basicValidationTimeout);
                    _this.basicValidationTimeout = setTimeout(function() {
                        afterValidation(_this.runBasicValidation());
                    }, _this.basicValidationDelay);
                };
                inputSelector.addEventListener("input", eventListenerFn);
                inputSelector.addEventListener("change", eventListenerFn);
                inputSelector.addEventListener("paste", eventListenerFn);
            };
            _this_1.runBasicValidation = function() {
                var pageIndex = _this_1.enrollmentPage.getCurrentIndex();
                return _this_1.basicValidate(pageIndex);
            };
            _this_1.classConfig = classConfig;
            _this_1.notification = notification;
            _this_1.enrollmentPage = enrollmentPage;
            return _this_1;
        }
        return StEnrollmentValidation;
    }(st_module_27.StModule);
    exports.StEnrollmentValidation = StEnrollmentValidation;
});

define("core/shopify-app/st-modules/enrollment/_validation/enrollment-section-validation-base", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_28) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentSectionBase = void 0;
    var StEnrollmentSectionBase = function(_super) {
        __extends(StEnrollmentSectionBase, _super);
        function StEnrollmentSectionBase(args) {
            var _this = _super.call(this, args) || this;
            _this.setupValidationMethods = function() {
                var methods = {};
                methods[_this.validationName] = {
                    site: _this.validateOnSite,
                    server: _this.validateOnServer,
                    basic: _this.addToBasicValidation
                };
                return methods;
            };
            _this.addToBasicValidation = function() {
                return [];
            };
            _this.validateOnServer = function() {
                return [];
            };
            _this.validateOnSite = function() {
                return [];
            };
            return _this;
        }
        StEnrollmentSectionBase.prototype.initFields = function() {};
        StEnrollmentSectionBase.prototype.selectFields = function() {
            return [];
        };
        return StEnrollmentSectionBase;
    }(st_module_28.StModule);
    exports.StEnrollmentSectionBase = StEnrollmentSectionBase;
});

define("core/shopify-app/st-modules/enrollment/blocks/review-privacy/enrollment-section-review-privacy", [ "require", "exports", "core/shopify-app/st-modules/enrollment/_validation/enrollment-section-validation-base" ], function(require, exports, enrollment_section_validation_base_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentSectionPrivacy = void 0;
    var StEnrollmentSectionPrivacy = function(_super) {
        __extends(StEnrollmentSectionPrivacy, _super);
        function StEnrollmentSectionPrivacy(classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentSectionPrivacy";
            _this.validationName = "privacy";
            _this.validateOnSite = function() {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var output = [];
                if (!!wrp) {
                    var inputs = wrp.querySelectorAll(_this.classConfig.selectorEnrollmentTnCField);
                    inputs.forEach(function(input) {
                        var fieldName = input.getAttribute("name");
                        var isChecked = input.checked === true;
                        var isRequired = !!input.getAttribute("required");
                        var isValid = isChecked && isRequired || !isRequired;
                        output[fieldName] = {
                            isValid: isValid,
                            message: !isValid ? "You must accept terms and conditions to continue!" : ""
                        };
                    });
                }
                return output;
            };
            _this.classConfig = classConfig;
            return _this;
        }
        return StEnrollmentSectionPrivacy;
    }(enrollment_section_validation_base_1.StEnrollmentSectionBase);
    exports.StEnrollmentSectionPrivacy = StEnrollmentSectionPrivacy;
});

define("core/shopify-app/st-modules/enrollment/blocks/account-details/enrollment-section-account-details", [ "require", "exports", "core/shopify-app/st-modules/enrollment/_validation/enrollment-section-validation-base" ], function(require, exports, enrollment_section_validation_base_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentSectionAccountDetails = void 0;
    var StEnrollmentSectionAccountDetails = function(_super) {
        __extends(StEnrollmentSectionAccountDetails, _super);
        function StEnrollmentSectionAccountDetails() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentAccountDetails";
            _this.validationName = "account-details";
            _this.addToBasicValidation = function() {
                return [ "firstName", "lastName", "phoneNumber", "dateOfBirth" ];
            };
            _this.validateOnServer = function() {
                return [ "firstName", "lastName", "phoneNumber", "dateOfBirth" ];
            };
            return _this;
        }
        return StEnrollmentSectionAccountDetails;
    }(enrollment_section_validation_base_2.StEnrollmentSectionBase);
    exports.StEnrollmentSectionAccountDetails = StEnrollmentSectionAccountDetails;
});

define("core/shopify-app/st-modules/enrollment/blocks/business-info/enrollment-section-business-details", [ "require", "exports", "core/shopify-app/st-modules/enrollment/_validation/enrollment-section-validation-base" ], function(require, exports, enrollment_section_validation_base_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentSectionBusinessDetails = void 0;
    var StEnrollmentSectionBusinessDetails = function(_super) {
        __extends(StEnrollmentSectionBusinessDetails, _super);
        function StEnrollmentSectionBusinessDetails() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentBusinessDetails";
            _this.validationName = "business-details";
            _this.addToBasicValidation = function() {
                return [ "SSN", "webAlias" ];
            };
            _this.validateOnServer = function() {
                return [ "SSN", "webAlias" ];
            };
            return _this;
        }
        return StEnrollmentSectionBusinessDetails;
    }(enrollment_section_validation_base_3.StEnrollmentSectionBase);
    exports.StEnrollmentSectionBusinessDetails = StEnrollmentSectionBusinessDetails;
});

define("core/shopify-app/st-modules/enrollment/_validation/enrollment-validation-setup", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_29) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentValidationSetup = void 0;
    var StEnrollmentValidationSetup = function(_super) {
        __extends(StEnrollmentValidationSetup, _super);
        function StEnrollmentValidationSetup(enrollmentValidation, sectionPrivacy, sectionAccountDetails, sectionBusinessDetails) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentValidationSetup";
            _this.setupValidation = function() {
                _this.enrollmentValidation.setupValidation([ _this.sectionPrivacy, _this.sectionAccountDetails, _this.sectionBusinessDetails ]);
            };
            _this.enrollmentValidation = enrollmentValidation;
            _this.sectionPrivacy = sectionPrivacy;
            _this.sectionAccountDetails = sectionAccountDetails;
            _this.sectionBusinessDetails = sectionBusinessDetails;
            return _this;
        }
        return StEnrollmentValidationSetup;
    }(st_module_29.StModule);
    exports.StEnrollmentValidationSetup = StEnrollmentValidationSetup;
});

define("core/shopify-app/st-modules/enrollment/_general/enrollment-store", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_30) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentStore = void 0;
    var StEnrollmentStore = function(_super) {
        __extends(StEnrollmentStore, _super);
        function StEnrollmentStore(classConfig, cartHandler) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentStore";
            _this.dataStore = {
                shopifyId: undefined
            };
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                    var shopifyIdHolder = wrp.querySelector('[name="shopifyId"]');
                    var shopifyId = parseInt(shopifyIdHolder.value);
                    _this.saveData({
                        shopifyId: shopifyId
                    });
                });
            };
            _this.saveData = function(dataToSave) {
                _this.dataStore = __assign(__assign({}, _this.dataStore), dataToSave);
                _this.updateCart({
                    attributes: __assign({}, _this.dataStore)
                }, function(cart) {
                    console.log(cart);
                });
            };
            _this.loadData = function() {
                return __assign({}, _this.dataStore);
            };
            _this.updateCart = function(params, callback) {
                _this.ajax.send({
                    endpoint: _this.cartHandler.shopifyCartApiEndpoints["update-cart"],
                    method: "POST",
                    contentType: "json",
                    data: params,
                    callback: function(request) {
                        callback(JSON.parse(request.response));
                    }
                });
            };
            _this.classConfig = classConfig;
            _this.cartHandler = cartHandler;
            return _this;
        }
        return StEnrollmentStore;
    }(st_module_30.StModule);
    exports.StEnrollmentStore = StEnrollmentStore;
});

define("core/shopify-app/st-modules/_general-methods/currency", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_31) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCurrency = exports.EAmountType = exports.ECurrencyFormatType = void 0;
    var ECurrencyFormatType;
    (function(ECurrencyFormatType) {
        ECurrencyFormatType["withCurrency"] = "withCurrency";
        ECurrencyFormatType["withoutCurrency"] = "withoutCurrency";
    })(ECurrencyFormatType = exports.ECurrencyFormatType || (exports.ECurrencyFormatType = {}));
    var EAmountType;
    (function(EAmountType) {
        EAmountType["amount"] = "amount";
        EAmountType["amount_no_decimals"] = "amount_no_decimals";
        EAmountType["unknown"] = "unknown";
    })(EAmountType = exports.EAmountType || (exports.EAmountType = {}));
    var StCurrency = function(_super) {
        __extends(StCurrency, _super);
        function StCurrency() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Currency";
            _this.currencyFormat = window.stCurrencyFormat;
            _this.applyFormat = function(amount, formatType) {
                if (formatType === void 0) {
                    formatType = ECurrencyFormatType.withCurrency;
                }
                var format = _this.currencyFormat[formatType];
                var amountType = _this.determineAmountType(format);
                if (amountType !== EAmountType.unknown) {
                    return format.replace("{{" + amountType + "}}", "" + amount.toFixed(2));
                } else {
                    console.error("Unrecognized price format. Returning price without currency formatting.");
                    return "" + amount;
                }
            };
            _this.determineAmountType = function(format) {
                if (format.indexOf("{{amount}}") > -1) {
                    return EAmountType.amount;
                } else if (format.indexOf("{{amount_no_decimals}}") > -1) {
                    return EAmountType.amount_no_decimals;
                } else {
                    return EAmountType.unknown;
                }
            };
            return _this;
        }
        StCurrency.prototype.commaFormattedPrice = function(amount, decimalDelimiter, thousandsDelimiter) {
            if (decimalDelimiter === void 0) {
                decimalDelimiter = ".";
            }
            if (thousandsDelimiter === void 0) {
                thousandsDelimiter = ",";
            }
            var amountComponents = String(amount).split(".", 2);
            var wholeNumber = parseInt(amountComponents[0]);
            if (isNaN(wholeNumber)) {
                return "";
            }
            var decimal = amountComponents[1];
            var minus = wholeNumber < 0 ? "-" : "";
            wholeNumber = Math.abs(wholeNumber);
            var wholeString = String(wholeNumber);
            var amountSegmented = [];
            while (wholeString.length > 3) {
                amountSegmented.unshift(wholeString.substr(wholeString.length - 3));
                wholeString = wholeString.substr(0, wholeString.length - 3);
            }
            if (wholeString.length > 0) {
                amountSegmented.unshift(wholeString);
            }
            wholeString = amountSegmented.join(thousandsDelimiter);
            decimal = decimal.length < 1 ? "" : decimalDelimiter + decimal;
            return minus + wholeString + decimal;
        };
        return StCurrency;
    }(st_module_31.StModule);
    exports.StCurrency = StCurrency;
});

define("core/shopify-app/st-modules/enrollment/blocks/review-info/enrollment-review-cart", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/currency" ], function(require, exports, st_module_32, currency_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentReviewCart = void 0;
    var StEnrollmentReviewCart = function(_super) {
        __extends(StEnrollmentReviewCart, _super);
        function StEnrollmentReviewCart(classConfig, store, currency) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentReviewCart";
            _this.injectCart = function() {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var cartContent = wrp.querySelector(_this.classConfig.selectorEnrollmentReviewCartContentWrapper);
                var cartWrapper = wrp.querySelector(_this.classConfig.selectorEnrollmentReviewCartWrapper);
                var storeData = _this.store.loadData();
                var reqKits = storeData.requiredKits ? storeData.requiredKits : [];
                var optKits = storeData.optionalKits ? storeData.optionalKits : [];
                var selectedProducts = __spreadArray(__spreadArray([], reqKits, true), optKits, true);
                if (selectedProducts.length > 0) {
                    !!cartWrapper && cartWrapper.classList.remove("st_hidden");
                    !!cartContent && cartContent.classList.remove("st_hidden");
                    !!cartContent && cartContent.replaceChildren();
                    var productPrices_1 = [];
                    selectedProducts.forEach(function(selectedProduct) {
                        var imageEl = wrp.querySelector('[data-image-holder="'.concat(selectedProduct.variantId, '"]'));
                        var titleEl = wrp.querySelector('[data-title-holder="'.concat(selectedProduct.variantId, '"]'));
                        var descriptionEl = wrp.querySelector('[data-description-holder="'.concat(selectedProduct.variantId, '"]'));
                        var priceEl = wrp.querySelector('[data-price-holder="'.concat(selectedProduct.variantId, '"]'));
                        var recurringEl = wrp.querySelector('[data-recurring-holder="'.concat(selectedProduct.variantId, '"]'));
                        var sellingPlanEl = wrp.querySelector('[data-selling-plan-holder="'.concat(selectedProduct.variantId, '"]'));
                        var imageURL = !!imageEl ? imageEl.src : "";
                        var title = !!titleEl ? titleEl.innerHTML : "";
                        var description = !!descriptionEl ? descriptionEl.innerHTML : "";
                        var price = !!priceEl ? priceEl.innerHTML : "";
                        var priceRaw = !!priceEl ? parseInt(priceEl.getAttribute("data-price-raw")) : 0;
                        var recurring = !!recurringEl ? recurringEl.value === "true" : false;
                        var sellingPlan = !!sellingPlanEl ? sellingPlanEl.value : "One Time Payment";
                        var printableReviewProduct = {
                            variantId: selectedProduct.variantId,
                            image: imageURL,
                            title: title,
                            description: description,
                            price: price,
                            recurring: recurring,
                            sellingPlan: sellingPlan
                        };
                        productPrices_1.push(priceRaw);
                        if (!!cartContent) {
                            var cartMember = _this.generateCartMember(printableReviewProduct);
                            cartContent.appendChild(cartMember);
                        }
                    });
                    var cartTotalEl = wrp.querySelector(_this.classConfig.selectorEnrollmentReviewCartTotal);
                    if (!!cartTotalEl) {
                        var total = productPrices_1.reduce(function(accumulator, value) {
                            return accumulator + parseInt("".concat(value));
                        });
                        cartTotalEl.innerHTML = _this.currency.applyFormat(total / 100, currency_1.ECurrencyFormatType.withCurrency);
                    }
                } else {
                    !!cartWrapper && cartWrapper.classList.add("st_hidden");
                    !!cartContent && cartContent.classList.add("st_hidden");
                }
            };
            _this.generateCartMembers = function(products) {
                var output = [];
                products.forEach(function(productInfo) {
                    var cartMember = _this.generateCartMember(productInfo);
                    output.push(cartMember);
                });
                return output;
            };
            _this.generateCartMember = function(productInfo) {
                var wrap = document.createElement("div");
                wrap.classList.add("st_enrollment-checkout-row");
                wrap.classList.add("st_flex");
                wrap.classList.add("st_align");
                var imageWrap = document.createElement("div");
                imageWrap.classList.add("st_enrollment-image--wrapper");
                var image = document.createElement("img");
                image.src = productInfo.image;
                image.alt = productInfo.title;
                var listWrapper = document.createElement("div");
                listWrapper.classList.add("st_enrollment-list--wrapper");
                var title = document.createElement("div");
                title.classList.add("st_title");
                title.innerHTML = productInfo.title;
                var description = document.createElement("div");
                description.innerHTML = productInfo.description;
                var priceWrapper = document.createElement("div");
                priceWrapper.classList.add("st_enrollment-price--wrapper");
                var recurring = document.createElement("div");
                recurring.classList.add("st_subscription");
                recurring.classList.add("st_subscription-review");
                recurring.innerText = productInfo.sellingPlan;
                var price = document.createElement("div");
                price.classList.add("st_price");
                price.innerHTML = productInfo.price;
                imageWrap.appendChild(image);
                listWrapper.appendChild(title);
                listWrapper.appendChild(description);
                priceWrapper.appendChild(recurring);
                priceWrapper.appendChild(price);
                wrap.appendChild(imageWrap);
                wrap.appendChild(listWrapper);
                wrap.appendChild(priceWrapper);
                return wrap;
            };
            _this.classConfig = classConfig;
            _this.store = store;
            _this.currency = currency;
            return _this;
        }
        return StEnrollmentReviewCart;
    }(st_module_32.StModule);
    exports.StEnrollmentReviewCart = StEnrollmentReviewCart;
});

define("core/shopify-app/st-modules/enrollment/blocks/optional-kits/enrollment-section-optional-kits", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_33) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentOptionalKits = void 0;
    var StEnrollmentOptionalKits = function(_super) {
        __extends(StEnrollmentOptionalKits, _super);
        function StEnrollmentOptionalKits(classConfig, store, reviewCart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentOptionalBundle";
            _this_1.setupButtons = function(buttons) {
                var _this = _this_1;
                buttons.forEach(function(button) {
                    button.addEventListener("click", function(e) {
                        e.preventDefault();
                        var variantId = this.getAttribute("data-variant-id");
                        var quantity = parseInt(this.getAttribute("data-quantity"));
                        var sellingPlan = this.getAttribute("data-selling-plan");
                        var selected = this.getAttribute("data-selected") === "true";
                        selected = !selected;
                        var bundleObject = {
                            variantId: "" + variantId,
                            quantity: quantity
                        };
                        if (sellingPlan && sellingPlan !== "") {
                            bundleObject.selling_plan = sellingPlan;
                        }
                        var span = this.querySelector(".st_text");
                        var icon = this.querySelector(".st_check-icon");
                        if (selected) {
                            icon.classList.remove("st_hidden");
                            span.classList.add("st_hidden");
                        } else {
                            icon.classList.add("st_hidden");
                            span.classList.remove("st_hidden");
                        }
                        _this.toggleBundleSelect(selected, bundleObject);
                        this.setAttribute("data-selected", selected);
                    });
                });
            };
            _this_1.toggleBundleSelect = function(makeSelected, bundleObject) {
                try {
                    var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                    var optionalBundlesInput = wrp.querySelector(_this_1.classConfig.selectorEnrollmentOptionalKitsInput);
                    var selectedBundles = JSON.parse(optionalBundlesInput.value);
                    if (makeSelected) {
                        var itemAlreadySelected = false;
                        for (var i = 0; i < selectedBundles.length; i++) {
                            if ("" + selectedBundles[i].variantId === "" + bundleObject.variantId) {
                                itemAlreadySelected = true;
                                break;
                            }
                        }
                        if (!itemAlreadySelected) {
                            selectedBundles.push(bundleObject);
                        }
                    } else {
                        var formattedBundles = [];
                        for (var i = 0; i < selectedBundles.length; i++) {
                            if ("" + selectedBundles[i].variantId !== "" + bundleObject.variantId) {
                                formattedBundles.push(selectedBundles[i]);
                            }
                        }
                        selectedBundles = formattedBundles;
                    }
                    optionalBundlesInput.value = JSON.stringify(selectedBundles);
                    optionalBundlesInput.setAttribute("value", optionalBundlesInput.value);
                    _this_1.store.saveData({
                        optionalKits: selectedBundles
                    });
                    _this_1.reviewCart.injectCart();
                } catch (e) {
                    console.error("An error occurred while processing toggleBundleSelect. Error message: " + e.message);
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.store = store;
            _this_1.reviewCart = reviewCart;
            return _this_1;
        }
        return StEnrollmentOptionalKits;
    }(st_module_33.StModule);
    exports.StEnrollmentOptionalKits = StEnrollmentOptionalKits;
});

define("core/shopify-app/st-modules/enrollment/blocks/required-kits/enrollment-section-required-kits", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_34) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentRequiredKits = void 0;
    var StEnrollmentRequiredKits = function(_super) {
        __extends(StEnrollmentRequiredKits, _super);
        function StEnrollmentRequiredKits(classConfig, store, reviewCart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentRequiredBundle";
            _this_1.init = function() {
                var _this = _this_1;
                _this_1.subscribeDOMLoaded(function() {
                    _this.store.saveData({
                        requiredKits: _this.getRequiredKits()
                    });
                    _this_1.reviewCart.injectCart();
                    _this_1.onRequiredKitVariantSelect();
                });
            };
            _this_1.getRequiredKits = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var requiredKitsHolder = wrp.querySelector('[name="requiredKits"]');
                return requiredKitsHolder ? JSON.parse(decodeURIComponent(requiredKitsHolder.value)) : [];
            };
            _this_1.format = function(sourceData) {
                var formattedData = [];
                sourceData.forEach(function(item) {
                    if (typeof item.variantId !== "undefined") {
                        var formattedItem = {
                            variantId: item.variantId.toString(),
                            quantity: item.quantity
                        };
                        if (item.selling_plan && item.selling_plan !== "") {
                            formattedItem.selling_plan = item.selling_plan + "";
                        }
                        formattedData.push(formattedItem);
                    }
                });
                return formattedData;
            };
            _this_1.onRequiredKitVariantSelect = function() {
                var _this = _this_1;
                var requiredKitWrapperList = document.querySelectorAll(_this_1.classConfig.selectorEnrollmentRequiredKitWrapper);
                if (!!requiredKitWrapperList) {
                    requiredKitWrapperList.forEach(function(requiredKitWrapper) {
                        var variantSelect = requiredKitWrapper.querySelector(_this_1.classConfig.selectorEnrollmentRequiredKitVariantSelect);
                        if (!!variantSelect) {
                            variantSelect.onchange = function() {
                                var variantValue = JSON.parse(decodeURI(variantSelect.value));
                                var optionValue = [];
                                optionValue.push(variantValue);
                                var variantHiddenWrapper = document.querySelector(_this.classConfig.selectorEnrollmentRequiredKitsOptionsWrapper);
                                var requiredKitDescription = document.querySelector(_this.classConfig.selectorEnrollmentRequiredKitsText);
                                var requiredKitImg = requiredKitWrapper.querySelector(_this.classConfig.selectorEnrollmentRequiredKitsImg);
                                var variantTitleHeading = document.querySelector(_this.classConfig.selectorEnrollmentRequiredKitVariantHeading);
                                var variantTitle = requiredKitWrapper.querySelector(_this.classConfig.selectorEnrollmentRequiredKitSelectedVariantTitle);
                                var variantTitleHidden = variantHiddenWrapper.querySelector('input[data-title-holder="'.concat(variantValue.variantId, '"]'));
                                var variantPrice = requiredKitWrapper.querySelector(_this.classConfig.selectorEnrollmentRequiredKitVariantPrice);
                                var variantPriceHidden = variantHiddenWrapper.querySelector('input[data-price-holder="'.concat(variantValue.variantId, '"]'));
                                var variantPriceRawHidden = variantHiddenWrapper.querySelector('input[data-price-raw-holder="'.concat(variantValue.variantId, '"]'));
                                var hiddenVariantInput = document.querySelector(_this.classConfig.selectorEnrollmentHiddenRequiredKitInput);
                                if (!!requiredKitDescription) {
                                    requiredKitDescription.setAttribute("data-description-holder", variantValue.variantId);
                                }
                                if (!!requiredKitImg) {
                                    requiredKitImg.setAttribute("data-image-holder", variantValue.variantId);
                                }
                                if (!!variantTitleHeading) {
                                    variantTitleHeading.innerHTML = variantTitleHidden.value;
                                    variantTitleHeading.setAttribute("data-title-holder", variantValue.variantId);
                                }
                                if (!!variantTitle) {
                                    variantTitle.innerHTML = variantTitleHidden.value;
                                }
                                if (!!variantPrice) {
                                    variantPrice.innerHTML = variantPriceHidden.value;
                                    variantPrice.setAttribute("data-price-holder", variantValue.variantId);
                                    variantPrice.setAttribute("data-price-raw", variantPriceRawHidden.value);
                                }
                                if (!!hiddenVariantInput) {
                                    delete optionValue[optionValue.length - 1].price;
                                    hiddenVariantInput.value = encodeURI(JSON.stringify(optionValue));
                                    hiddenVariantInput.setAttribute("value", JSON.stringify(optionValue));
                                    _this.store.saveData({
                                        requiredKits: optionValue
                                    });
                                    _this_1.reviewCart.injectCart();
                                }
                            };
                        }
                    });
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.store = store;
            _this_1.reviewCart = reviewCart;
            return _this_1;
        }
        return StEnrollmentRequiredKits;
    }(st_module_34.StModule);
    exports.StEnrollmentRequiredKits = StEnrollmentRequiredKits;
});

define("core/shopify-app/st-modules/enrollment/blocks/review-info/enrollment-review", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_35) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentReview = void 0;
    var EFormatType;
    (function(EFormatType) {
        EFormatType["date"] = "date";
    })(EFormatType || (EFormatType = {}));
    var StEnrollmentReview = function(_super) {
        __extends(StEnrollmentReview, _super);
        function StEnrollmentReview(classConfig, store, generalMethods, enrollmentPage, currency, form, reviewCart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentReview";
            _this_1.setupReview = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                if (_this_1.reviewBlockExists(wrp)) {
                    var holder = wrp.querySelector(_this_1.classConfig.selectorEnrollmentReviewParamHolder);
                    if (!!holder) {
                        _this_1.generateReviewParams(holder, _this_1.getParamInfo());
                    }
                    var paramSources = wrp.querySelectorAll("[data-review-param]");
                    _this_1.setupParamChangeEvents(paramSources);
                }
            };
            _this_1.reviewBlockExists = function(wrp) {
                var reviewSection = wrp.querySelector(_this_1.classConfig.selectorEnrollmentReviewWrapper);
                return !!reviewSection;
            };
            _this_1.getParamInfo = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var paramHolders = wrp.querySelectorAll("[data-review-param]");
                var params = [];
                var storedData = _this_1.store.loadData();
                paramHolders.forEach(function(paramHolder) {
                    var pageWrapper = _this_1.generalMethods.getClosestByClass(paramHolder, _this_1.classConfig.classNameEnrollmentPage);
                    var pageIndex = parseInt(pageWrapper.getAttribute("data-page-index"));
                    var inputName = paramHolder.getAttribute("name");
                    var formatName = paramHolder.getAttribute("data-format");
                    var param = {
                        name: paramHolder.getAttribute("data-review-param"),
                        inputName: inputName,
                        value: storedData[inputName] ? storedData[inputName] : "",
                        allowEdit: paramHolder.getAttribute("data-review-edit") !== "false",
                        pageIndex: pageIndex,
                        format: _this_1.getFormatByName(EFormatType[formatName])
                    };
                    params.push(param);
                });
                return params;
            };
            _this_1.getFormatByName = function(name) {
                if (name === EFormatType.date) {
                    return function(value) {
                        if (value && value !== "-") {
                            var dateComponents = value.split("-");
                            var days = dateComponents[2];
                            days = days.length === 1 ? "0".concat(days) : "".concat(days);
                            var months = dateComponents[1];
                            months = months.length === 1 ? "0".concat(months) : "".concat(months);
                            var years = dateComponents[0];
                            return "".concat(months, "/").concat(days, "/").concat(years);
                        } else {
                            return "";
                        }
                    };
                } else {
                    return function(value) {
                        return value;
                    };
                }
            };
            _this_1.generateReviewParams = function(holder, params) {
                var _this = _this_1;
                params.forEach(function(param, ind) {
                    var row = document.createElement("div");
                    row.classList.add("st_enrollment-business-info-row");
                    var col = document.createElement("div");
                    col.classList.add("st_info-column");
                    var colL = document.createElement("div");
                    colL.classList.add("st_col-left");
                    var colName = document.createElement("div");
                    colName.classList.add("st_name");
                    colName.innerText = param.name;
                    colL.appendChild(colName);
                    var value = typeof param.value !== "undefined" && param.value !== "" ? "" + param.value : "-";
                    var colValue = document.createElement("div");
                    colValue.classList.add("st_print-name");
                    if (param.inputName == "email") colValue.classList.add("st_email");
                    colValue.setAttribute("data-field-for", param.inputName);
                    colValue.innerText = param.format(value);
                    colL.appendChild(colValue);
                    col.appendChild(colL);
                    var colR = document.createElement("div");
                    colR.classList.add("st_col-right");
                    if (param.allowEdit) {
                        var editButton = document.createElement("button");
                        editButton.setAttribute("type", "button");
                        editButton.classList.add("st_enrollment-edit");
                        editButton.setAttribute("data-page-index", "" + param.pageIndex);
                        editButton.setAttribute("data-edit-for", param.inputName);
                        editButton.innerText = _this_1.classConfig.reviewEditText;
                        colR.appendChild(editButton);
                        editButton.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.edit(this.getAttribute("data-edit-for"), parseInt(this.getAttribute("data-page-index")));
                        });
                    }
                    col.appendChild(colR);
                    row.appendChild(col);
                    holder.appendChild(row);
                });
            };
            _this_1.setupParamChangeEvents = function(paramSources) {
                var _this = _this_1;
                paramSources.forEach(function(paramHolder) {
                    var fieldObj = _this.form.collectField(paramHolder);
                    var inputName = paramHolder.getAttribute("name");
                    var name = paramHolder.getAttribute("data-review-param");
                    var value = fieldObj[inputName];
                    _this.applyParamChange(name, inputName, value.toString());
                    paramHolder.addEventListener("keyup", function(e) {
                        var fieldObj = _this.form.collectField(this);
                        var inputName = this.getAttribute("name");
                        var name = this.getAttribute("data-review-param");
                        var value = fieldObj[inputName];
                        _this.applyParamChange(name, inputName, value.toString());
                    });
                    paramHolder.addEventListener("input", function(e) {
                        var fieldObj = _this.form.collectField(this);
                        var inputName = this.getAttribute("name");
                        var name = this.getAttribute("data-review-param");
                        var value = fieldObj[inputName];
                        _this.applyParamChange(name, inputName, value.toString());
                    });
                    paramHolder.addEventListener("change", function(e) {
                        var fieldObj = _this.form.collectField(this);
                        var inputName = this.getAttribute("name");
                        var name = this.getAttribute("data-review-param");
                        var value = fieldObj[inputName];
                        _this.applyParamChange(name, inputName, value.toString());
                    });
                });
            };
            _this_1.applyParamChange = function(name, inputName, value) {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var holder = wrp.querySelector('[data-review-param="'.concat(name, '"]'));
                var param = wrp.querySelector('[data-field-for="'.concat(inputName, '"]'));
                var formatName = holder.getAttribute("data-format");
                var format = _this_1.getFormatByName(EFormatType[formatName]);
                if (param) {
                    param.innerText = format(value.toString());
                } else {
                    console.error("Review template error. Couldn't find element to change parameter with name: ".concat(inputName, "."));
                }
            };
            _this_1.edit = function(holderName, pageIndex) {
                _this_1.enrollmentPage.openPage(pageIndex);
                var currentPage = _this_1.enrollmentPage.getCurrentPage();
                var holdersFirstVisual = currentPage.querySelector('[data-validation-visual="'.concat(holderName, '"]'));
                if (!!holdersFirstVisual) {
                    _this_1.generalMethods.scrollTo(holdersFirstVisual, 500);
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.store = store;
            _this_1.generalMethods = generalMethods;
            _this_1.enrollmentPage = enrollmentPage;
            _this_1.currency = currency;
            _this_1.form = form;
            _this_1.reviewCart = reviewCart;
            return _this_1;
        }
        return StEnrollmentReview;
    }(st_module_35.StModule);
    exports.StEnrollmentReview = StEnrollmentReview;
});

define("core/shopify-app/st-modules/enrollment/page-header/nav/enrollment-nav", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification", "core/shopify-app/st-modules/_general-methods/button/button-actions" ], function(require, exports, st_module_36, notification_3, button_actions_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentNav = void 0;
    var StEnrollmentNav = function(_super) {
        __extends(StEnrollmentNav, _super);
        function StEnrollmentNav(classConfig, actions, optionalKits, requiredKits, store, form, buttonActions, enrollmentValidation, enrollmentValidationSetup, notification, enrollmentReview, enrollmentPage) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentNav";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.setupNavPages();
                    _this_1.setupButtons();
                    _this_1.setupOptionalBundles();
                    _this_1.setupBasicValidation();
                });
            };
            _this_1.setupButtons = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var pages = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPage);
                if (pages.length > 0) {
                    _this_1.enrollmentPage.setMaxPage(pages.length);
                    _this_1.enrollmentPage.setupPageIndex(pages);
                    _this_1.enrollmentReview.setupReview();
                    _this_1.openPage(_this_1.enrollmentPage.getCurrentIndex());
                    if (!!wrp) {
                        _this_1.bindEvents(wrp);
                    } else {
                        console.error("Enrollment wrapper does not exist! Cannot setup enrollment nav.");
                    }
                } else {
                    console.error("Enrollment doesn't have a page! Can't init enrollment!");
                }
            };
            _this_1.openPage = function(pageIndex) {
                _this_1.enrollmentPage.openPage(pageIndex);
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                if (pageIndex === 0) {
                    prevButtons.forEach(function(button) {
                        button.classList.add("st_hidden");
                    });
                } else {
                    prevButtons.forEach(function(button) {
                        button.classList.remove("st_hidden");
                    });
                }
            };
            _this_1.bindEvents = function(wrp) {
                var _this = _this_1;
                var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                nextButtons.forEach(function(nextButton) {
                    nextButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        if (!_this.buttonActions.isDisabled(this)) {
                            _this.nextOrSubmit();
                        }
                    });
                });
                prevButtons.forEach(function(prevButton) {
                    prevButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.prev();
                    });
                });
            };
            _this_1.setupOptionalBundles = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var optionalBundleTriggers = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentOptionalKitsTrigger);
                _this_1.optionalKits.setupButtons(optionalBundleTriggers);
            };
            _this_1.nextOrSubmit = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var enrollmentPages = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPage);
                var currentPage = enrollmentPages[_this_1.enrollmentPage.getCurrentIndex()];
                var forms = currentPage.querySelectorAll(_this_1.classConfig.selectorEnrollmentForm);
                var shopifyIdHolder = wrp.querySelector('[name="shopifyId"]');
                var shopifyId = parseInt(shopifyIdHolder.value);
                var serverValidationParams = {
                    shopifyId: shopifyId
                };
                var onSiteValidationFunctions = [];
                var validation = _this_1.enrollmentValidation.getValidation();
                var dataToSave = {};
                _this_1.enrollmentValidation.clearInvalid(currentPage);
                forms.forEach(function(form) {
                    var sectionName = form.getAttribute("data-name");
                    if (!!sectionName && sectionName !== "") {
                        var formData_1 = _this_1.form.collectFormData(form);
                        var paramsToValidate_1 = {};
                        dataToSave = __assign(__assign({}, dataToSave), formData_1);
                        if (validation.hasOwnProperty(sectionName)) {
                            var backendParamNames = validation[sectionName].server();
                            backendParamNames.forEach(function(param) {
                                if (typeof paramsToValidate_1[param] !== "undefined") {
                                    console.error("Duplicate setup of param with name: ".concat(param));
                                }
                                paramsToValidate_1[param] = formData_1[param];
                            });
                            serverValidationParams = __assign(__assign({}, serverValidationParams), paramsToValidate_1);
                            onSiteValidationFunctions.push(validation[sectionName].site);
                        } else {
                            console.log('Enrollment block with name "'.concat(sectionName, '" does not have registered validation class. Skipping validation.'));
                        }
                    }
                });
                var joinedValidationResponse = {};
                var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                _this_1.buttonActions.applyToMultiple(nextButtons, button_actions_1.EButtonAction.prevent);
                _this_1.buttonActions.applyToMultiple(prevButtons, button_actions_1.EButtonAction.prevent);
                if (Object.keys(serverValidationParams).length > 0) {
                    _this_1.enrollmentValidation.serverValidate(serverValidationParams, function(response, validation) {
                        joinedValidationResponse = _this_1.validateOnSite(__assign({}, validation.data), onSiteValidationFunctions);
                        _this_1.afterValidation(joinedValidationResponse, dataToSave, currentPage);
                    }, function(error) {
                        console.error("An error occurred with status: ".concat(error.status, ". Message: ").concat(error.message));
                        _this_1.buttonActions.applyToMultiple(nextButtons, button_actions_1.EButtonAction.allow);
                        _this_1.buttonActions.applyToMultiple(prevButtons, button_actions_1.EButtonAction.allow);
                    });
                } else {
                    joinedValidationResponse = _this_1.validateOnSite(joinedValidationResponse, onSiteValidationFunctions);
                    _this_1.afterValidation(joinedValidationResponse, dataToSave, currentPage);
                }
            };
            _this_1.validateOnSite = function(joinedValidationResponse, onSiteValidationFunctions) {
                if (onSiteValidationFunctions === void 0) {
                    onSiteValidationFunctions = [];
                }
                var output = joinedValidationResponse;
                onSiteValidationFunctions.forEach(function(paramValidationFunction) {
                    output = __assign(__assign({}, output), paramValidationFunction());
                });
                return output;
            };
            _this_1.afterValidation = function(validationResponse, dataToSave, page) {
                if (Object.keys(validationResponse).length > 0) {
                    var hasInvalid_1 = false;
                    var errorMessage_1 = [];
                    Object.keys(validationResponse).forEach(function(paramName) {
                        if (!validationResponse[paramName].isValid) {
                            _this_1.enrollmentValidation.markInvalid(page, paramName);
                            hasInvalid_1 = true;
                            errorMessage_1.push(validationResponse[paramName].message);
                        }
                    });
                    if (hasInvalid_1) {
                        _this_1.notification.showNotification(notification_3.ENotificationType.error, "Some fields are invalid!", errorMessage_1);
                        var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                        var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                        var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                        _this_1.buttonActions.applyToMultiple(nextButtons, button_actions_1.EButtonAction.allow);
                        _this_1.buttonActions.applyToMultiple(prevButtons, button_actions_1.EButtonAction.allow);
                    } else {
                        _this_1.store.saveData(dataToSave);
                        _this_1.next();
                    }
                } else {
                    _this_1.store.saveData(dataToSave);
                    _this_1.next();
                }
            };
            _this_1.setupBasicValidation = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var paramNames = [];
                var validation = _this_1.enrollmentValidation.getValidation();
                var allFormNames = Object.keys(validation);
                allFormNames.forEach(function(formName) {
                    if (validation[formName]) {
                        paramNames = paramNames.concat(validation[formName].basic());
                    }
                });
                for (var i = 0; i < paramNames.length; i++) {
                    var param = paramNames[i];
                    var input = wrp.querySelector('[name="'.concat(param, '"]'));
                    _this_1.enrollmentValidation.setupBasicValidationEvents(input, _this_1.afterBasicValidation);
                }
            };
            _this_1.afterBasicValidation = function(valid) {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                if (valid) {
                    nextButtons.forEach(function(nextButton) {
                        _this_1.buttonActions.enable(nextButton);
                    });
                } else {
                    nextButtons.forEach(function(nextButton) {
                        _this_1.buttonActions.disable(nextButton);
                    });
                }
            };
            _this_1.next = function() {
                var currentIndex = _this_1.enrollmentPage.getCurrentIndex();
                if (currentIndex + 1 < _this_1.enrollmentPage.getMaxPage()) {
                    _this_1.enrollmentPage.setCurrentIndex(currentIndex + 1);
                    _this_1.openPage(currentIndex + 1);
                    var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                    var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                    var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                    _this_1.buttonActions.applyToMultiple(nextButtons, button_actions_1.EButtonAction.allow);
                    _this_1.buttonActions.applyToMultiple(prevButtons, button_actions_1.EButtonAction.allow);
                } else {
                    var data = _this_1.store.loadData();
                    var items = data.requiredKits ? _this_1.requiredKits.format(data.requiredKits) : [];
                    items = data.optionalKits ? items.concat(data.optionalKits) : items;
                    var submit = {
                        shopifyId: data.shopifyId,
                        firstName: data.firstName,
                        lastName: data.lastName,
                        phoneNumber: data.phoneNumber,
                        webAlias: data.webAlias,
                        sponsorsWebAlias: data.sponsorsWebAlias,
                        dateOfBirth: data.dateOfBirth,
                        SSN: data.SSN,
                        items: items
                    };
                    _this_1.actions.submit(submit);
                }
            };
            _this_1.prev = function() {
                var currentIndex = _this_1.enrollmentPage.getCurrentIndex();
                if (currentIndex - 1 >= 0) {
                    _this_1.enrollmentPage.setCurrentIndex(currentIndex - 1);
                    _this_1.openPage(currentIndex - 1);
                }
            };
            _this_1.setupNavPages = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var pages = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPage);
                var navHolder = wrp.querySelector(_this_1.classConfig.selectorEnrollmentNavHolder);
                if (!!navHolder) {
                    if (pages.length > 1) {
                        pages.forEach(function(page, pageIndex) {
                            var templateName = page.getAttribute("data-name");
                            var isActive = pageIndex === 0;
                            navHolder.appendChild(_this_1.navPageTemplate(pageIndex, templateName, isActive));
                        });
                    } else {
                        var navWrp = wrp.querySelector(_this_1.classConfig.selectorEnrollmentNavWrapper);
                        if (navWrp) {
                            navWrp.classList.add(_this_1.classConfig.classNameElementHide);
                        }
                    }
                } else {
                    console.error("Enrollment Nav holder not present! Navigation won't setup");
                }
            };
            _this_1.navPageTemplate = function(pageIndex, templateName, isActive) {
                if (templateName === void 0) {
                    templateName = "";
                }
                var templateNode;
                templateNode = document.createElement("div");
                templateNode.classList.add("st_header-enrollment-single-column");
                templateNode.classList.add(_this_1.classConfig.classNameEnrollmentNavHolderSingle);
                if (isActive) {
                    templateNode.classList.add("active");
                }
                var innerWrapper = document.createElement("div");
                innerWrapper.classList.add("st_flex");
                innerWrapper.classList.add("st_align");
                var button = document.createElement("button");
                button.classList.add("st_header-navigation-enrollment");
                button.classList.add(_this_1.classConfig.selectorEnrollmentNavButton);
                button.setAttribute("data-index", "".concat(pageIndex));
                var text = document.createElement("span");
                text.classList.add("st_header-text");
                text.innerHTML = templateName;
                var pageNumber = document.createElement("span");
                pageNumber.classList.add("st_number");
                pageNumber.innerHTML = "" + (pageIndex + 1);
                button.appendChild(pageNumber);
                innerWrapper.appendChild(button);
                innerWrapper.appendChild(text);
                templateNode.appendChild(innerWrapper);
                return templateNode;
            };
            _this_1.classConfig = classConfig;
            _this_1.actions = actions;
            _this_1.optionalKits = optionalKits;
            _this_1.requiredKits = requiredKits;
            _this_1.store = store;
            _this_1.form = form;
            _this_1.buttonActions = buttonActions;
            _this_1.enrollmentValidation = enrollmentValidation;
            _this_1.enrollmentValidationSetup = enrollmentValidationSetup;
            _this_1.notification = notification;
            _this_1.enrollmentReview = enrollmentReview;
            _this_1.enrollmentPage = enrollmentPage;
            _this_1.enrollmentValidationSetup.setupValidation();
            return _this_1;
        }
        return StEnrollmentNav;
    }(st_module_36.StModule);
    exports.StEnrollmentNav = StEnrollmentNav;
});

define("core/connector-app/_shared/models/search-sponsor/search.sponsor.response.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/search-sponsor/search-sponsor-service", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_37) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsorService = void 0;
    var StSearchSponsorService = function(_super) {
        __extends(StSearchSponsorService, _super);
        function StSearchSponsorService() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SearchSponsorService";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {});
            };
            _this.getSponsorByPersonalInfo = function(inputValue, handleGetSponsorInfo) {
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["searchSponsor"]["getSponsorByPersonalInfo"],
                        method: "post",
                        contentType: "json",
                        data: {
                            query: inputValue
                        },
                        callback: handleGetSponsorInfo
                    });
                } catch (error) {
                    console.log("Error occurred while getting sponsor info ---\x3e", error);
                }
            };
            _this.getSponsorInfo = function(sponsorIdOrAlias, handleGetSponsorInfo) {
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["searchSponsor"]["getSponsorInfo"],
                        method: "post",
                        contentType: "json",
                        data: {
                            query: sponsorIdOrAlias
                        },
                        callback: handleGetSponsorInfo
                    });
                } catch (error) {
                    console.log("Error occurred while getting sponsor info ---\x3e", error);
                }
            };
            return _this;
        }
        return StSearchSponsorService;
    }(st_module_37.StModule);
    exports.StSearchSponsorService = StSearchSponsorService;
});

define("core/shopify-app/st-modules/search-sponsor/search-sponsor", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_38, _features_config_6) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsor = void 0;
    var SponsorRequestType;
    (function(SponsorRequestType) {
        SponsorRequestType[SponsorRequestType["GET_BY_ID_OR_ALIAS"] = 0] = "GET_BY_ID_OR_ALIAS";
        SponsorRequestType[SponsorRequestType["GET_BY_PERSONAL_INFORMATION"] = 1] = "GET_BY_PERSONAL_INFORMATION";
    })(SponsorRequestType || (SponsorRequestType = {}));
    var StSearchSponsor = function(_super) {
        __extends(StSearchSponsor, _super);
        function StSearchSponsor(generalMethods, objectFormatting, browserHistory, classConfig, cookies, cart, sponsorService) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SearchSponsor";
            _this.endpointString = [ "getSponsorInfo", "getSponsorByPersonalInfo" ];
            _this.MIN_CHAR_SEARCH_REQUIREMENT = 2;
            _this.REQUEST_DELAY = 1e3;
            _this.inputValue = "";
            _this.cookieNameWebAlias = "webAlias";
            _this.cookieNameRepId = "repId";
            _this.cookieNameFirstName = "firstName";
            _this.cookieNameLastName = "lastName";
            _this.retryWebAliasFetch = true;
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.initSearchBoxFunctionality();
                    _this.initRadioButtons();
                    _this.windowClick();
                    _this.triggerVisibilityOfSection();
                    _this.cart.subscribeRenderCart(function(callback) {
                        _this.changeCartEvents();
                    });
                });
            };
            _this.loaderOn = function(triggerBtn) {
                var label = _this.generalMethods.getClosestByTag(triggerBtn, "label");
                if (!!label && !label.classList.contains("st_loader-active")) {
                    label.classList.add("st_loader-active");
                }
            };
            _this.loaderOff = function(triggerBtn) {
                var label = _this.generalMethods.getClosestByTag(triggerBtn, "label");
                if (!!label && label.classList.contains("st_loader-active")) {
                    label.classList.remove("st_loader-active");
                }
            };
            _this.changeCartEvents = function() {
                _this.initSearchBoxFunctionality();
                _this.initRadioButtons();
                _this.triggerVisibilityOfSection();
            };
            _this.setRepCookies = function(repInfo) {
                _this.cookies.setCookies(_this.cookieNameWebAlias, repInfo.webAlias);
                _this.cookies.setCookies(_this.cookieNameRepId, repInfo.repId);
                _this.cookies.setCookies(_this.cookieNameFirstName, repInfo.firstName);
                _this.cookies.setCookies(_this.cookieNameLastName, repInfo.lastName);
            };
            _this.triggerVisibilityOfSection = function() {
                var searchSponsorWrappers = document.querySelectorAll(_this.classConfig.selectorSearchSponsorWrapperPage);
                searchSponsorWrappers === null || searchSponsorWrappers === void 0 ? void 0 : searchSponsorWrappers.forEach(function(searchSponsorWrapper) {
                    var customerType = window.customerInfoMetafields.customerType;
                    if (customerType == _features_config_6.ECustomerType.retail && _features_config_6.lockedRepresentativeSite || customerType == _features_config_6.ECustomerType.representative) {
                        var searchSponsorWrapperLink = searchSponsorWrapper.querySelector(_this.classConfig.selectorChangeSponsorWrapperLink);
                        searchSponsorWrapperLink === null || searchSponsorWrapperLink === void 0 ? void 0 : searchSponsorWrapperLink.classList.add("st_hidden");
                    } else {
                        var triggerForOpenSearchInput = searchSponsorWrapper.querySelector(_this.classConfig.selectorChangeSponsorWrapper);
                        triggerForOpenSearchInput === null || triggerForOpenSearchInput === void 0 ? void 0 : triggerForOpenSearchInput.addEventListener("click", function(e) {
                            e.preventDefault();
                            searchSponsorWrappers.forEach(function(wrapper) {
                                _this.defaultVisibility(wrapper);
                            });
                            _this.showSearchInput(searchSponsorWrapper);
                            _this.hideSearchResults(searchSponsorWrapper);
                        });
                        _this.nonSponsors(searchSponsorWrapper);
                    }
                });
            };
            _this.nonSponsors = function(searchSponsorWrapper) {
                var triggerForDefaultSponsorInput = searchSponsorWrapper.querySelector(_this.classConfig.selectorNonSponsor);
                triggerForDefaultSponsorInput === null || triggerForDefaultSponsorInput === void 0 ? void 0 : triggerForDefaultSponsorInput.addEventListener("click", function() {
                    _this.updateUrl(_features_config_6.defaultWebAlias);
                    _this.defaultVisibility(searchSponsorWrapper);
                    _this.getSponsorInfo(_features_config_6.defaultWebAlias);
                    _this.setSponsorWebAliasToForm(_features_config_6.defaultWebAlias);
                    _this.setNewSponsorInfoToHeader(_features_config_6.corporationName, "", _features_config_6.defaultWebAlias);
                });
            };
            _this.updateUrl = function(newAlias) {
                var _a;
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_6.aliasQueryParam];
                if (currentAlias !== newAlias) {
                    urlParams = __assign(__assign({}, urlParams), (_a = {}, _a[_features_config_6.aliasQueryParam] = newAlias, 
                    _a));
                    var newURL = window.location.href.replace(window.location.search, "");
                    _this.cart.updateCartItemsProperies(newAlias);
                    _this.browserHistory.pushHistory(newURL, urlParams);
                }
            };
            _this.windowClick = function() {
                document.addEventListener("click", function(e) {
                    var searchSponsorsResult = document.querySelector(_this.classConfig.selectorChooseSponsor);
                    if (!!searchSponsorsResult) {
                        if (!_this.generalMethods.getClosestByClass(e.target, "st_search-input-and-result")) {
                            var sponsorWrappers = document.querySelectorAll(_this.classConfig.selectorSearchSponsorWrapperPage);
                            sponsorWrappers === null || sponsorWrappers === void 0 ? void 0 : sponsorWrappers.forEach(function(sponsorWrapper) {
                                _this.clearSponsorSuggestions(sponsorWrapper);
                            });
                        }
                    }
                });
            };
            _this.defaultVisibility = function(searchSponsorWrapper) {
                if (!!searchSponsorWrapper) {
                    _this.hideSearchInput(searchSponsorWrapper);
                    _this.showSearchResults(searchSponsorWrapper);
                }
            };
            _this.setSponsorWebAliasToForm = function(alias) {
                if (_features_config_6.canGoUnderCorporateSite || !_features_config_6.canGoUnderCorporateSite && alias !== _features_config_6.defaultWebAlias) {
                    var sponsorWebAliasFields = document.querySelectorAll(_this.classConfig.selectorRepresentativeAlias);
                    sponsorWebAliasFields === null || sponsorWebAliasFields === void 0 ? void 0 : sponsorWebAliasFields.forEach(function(field) {
                        _this.appendValueToField(field, alias);
                    });
                }
            };
            _this.getSponsorInfo = function(sponsorIdOrAlias, retryCount) {
                if (retryCount === void 0) {
                    retryCount = 0;
                }
                if (retryCount >= 5) {
                    console.warn("Sponsor Info call exceeded retry count!");
                    return;
                }
                if (_this.lastSponsorInfo && (_this.lastSponsorInfo.webAlias === sponsorIdOrAlias || _this.lastSponsorInfo.repId === sponsorIdOrAlias)) {
                    _this.injectSponsorInfo(_this.lastSponsorInfo);
                    return;
                }
                _this.loadersOnForSponsorInfo();
                _this.sponsorService.getSponsorInfo(sponsorIdOrAlias, function(request) {
                    try {
                        if (request.status === 200) {
                            var sponsorInfoResponse = JSON.parse(request.response);
                            var sponsorInformation = sponsorInfoResponse.data.sponsors[0];
                            if (!sponsorInformation.webAlias && sponsorInformation.webAlias === "") {
                                sponsorInformation.webAlias = sponsorInformation.repId;
                            }
                            _this.lastSponsorInfo = sponsorInformation;
                            _this.injectSponsorInfo(sponsorInformation);
                            _this.setRepCookies(sponsorInformation);
                        } else {
                            if (_this.retryWebAliasFetch) {
                                _this.retryWebAliasFetch = false;
                                _this.getSponsorInfo(_features_config_6.defaultWebAlias, ++retryCount);
                            }
                        }
                    } catch (error) {
                        console.log(error);
                        console.log("catch --- getSponsorInfo", _features_config_6.defaultWebAlias);
                        _this.getSponsorInfo(_features_config_6.defaultWebAlias, ++retryCount);
                    }
                });
            };
            _this.loadersOnForSponsorInfo = function() {
                var sponsorsData = document.querySelectorAll(_this.classConfig.selectorSponsorData);
                var svg = '<svg width="15" height="15" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#222" class="st_loader">\n                        <g fill="none" fill-rule="evenodd">\n                            <g transform="translate(1 1)" stroke-width="2">\n                                <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>\n                                <path d="M36 18c0-9.94-8.06-18-18-18">\n                                    <animateTransform\n                                            attributeName="transform"\n                                            type="rotate"\n                                            from="0 18 18"\n                                            to="360 18 18"\n                                            dur="1s"\n                                            repeatCount="indefinite"/>\n                                </path>\n                            </g>\n                        </g>\n                    </svg>';
                sponsorsData === null || sponsorsData === void 0 ? void 0 : sponsorsData.forEach(function(sponsorData) {
                    sponsorData.innerHTML = svg;
                });
            };
            _this.injectSponsorInfo = function(sponsorInformation) {
                var sponsorIdFields = document.querySelectorAll(_this.classConfig.selectorSponsorId);
                var sponsorAliasFields = document.querySelectorAll(_this.classConfig.selectorSponsorAlias);
                var sponsorFullNameFields = document.querySelectorAll(_this.classConfig.selectorSponsorFullName);
                var sponsorInitialsFields = document.querySelectorAll(_this.classConfig.selectorSponsorInitials);
                var sponsorAddressFields = document.querySelectorAll(_this.classConfig.selectorSponsorAddress);
                _this.injectTextIntoFields(sponsorIdFields, sponsorInformation.repId);
                _this.injectTextIntoFields(sponsorAliasFields, sponsorInformation.webAlias);
                _this.injectTextIntoFields(sponsorFullNameFields, "".concat(sponsorInformation.firstName, " ").concat(sponsorInformation.lastName));
                _this.injectTextIntoFields(sponsorInitialsFields, "".concat(sponsorInformation.firstName.charAt(0)).concat(sponsorInformation.lastName.charAt(0)));
                var address = sponsorInformation.address.state && sponsorInformation.address.state !== "" ? sponsorInformation.address.state + ", " + sponsorInformation.address.city : sponsorInformation.address.city;
                _this.injectTextIntoFields(sponsorAddressFields, address);
            };
            _this.searchSponsors = function(searchWrapper) {
                var input = searchWrapper.querySelector(_this.classConfig.selectorSearchSponsor);
                if (!!input) {
                    input.addEventListener("keyup", function(e) {
                        _this.getSponsors(input);
                    });
                    input.addEventListener("input", function(e) {
                        _this.getSponsors(input);
                    });
                    input.addEventListener("paste", function(e) {
                        _this.getSponsors(input);
                    });
                }
            };
            _this.getSponsors = function(input) {
                var value = input.value;
                if (_this.inputValue === value) return;
                if (value.length < _this.MIN_CHAR_SEARCH_REQUIREMENT) {
                    var searchSponsorInputWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                    _this.clearSponsorSuggestions(searchSponsorInputWrapper);
                    _this.enableRadioButtons(input);
                    return;
                }
                _this.inputValue = value;
                var requestType = _this.getCurrentRoute(input);
                _this.loaderOn(input);
                _this.disableRadioButtons(input);
                if (requestType === SponsorRequestType.GET_BY_ID_OR_ALIAS) {
                    _this.subscribeToTimeout(input, function() {
                        _this.sponsorService.getSponsorInfo(value, function(request) {
                            return _this.handleGetSponsorsResponse(request, input);
                        });
                    });
                }
                if (requestType === SponsorRequestType.GET_BY_PERSONAL_INFORMATION) {
                    _this.subscribeToTimeout(input, function() {
                        _this.sponsorService.getSponsorByPersonalInfo(value, function(request) {
                            return _this.handleGetSponsorsResponse(request, input);
                        });
                    });
                }
            };
            _this.getCurrentRoute = function(input) {
                var route;
                var sponsorWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                var radioButtons = sponsorWrapper.querySelectorAll(_this.classConfig.selectorSearchSponsorBy);
                radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton, index) {
                    if (radioButton.classList.contains("st_checked")) {
                        route = index;
                    }
                });
                return route;
            };
            _this.enableRadioButtons = function(input) {
                var sponsorWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                var radioButtons = sponsorWrapper.querySelectorAll(_this.classConfig.selectorSearchSponsorBy);
                radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton) {
                    radioButton.removeAttribute("disabled");
                });
            };
            _this.disableRadioButtons = function(input) {
                var sponsorWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                var radioButtons = sponsorWrapper.querySelectorAll(_this.classConfig.selectorSearchSponsorBy);
                radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton) {
                    radioButton.setAttribute("disabled", "disabled");
                });
            };
            _this.initRadioButtons = function() {
                var radioButtonsWrappers = document.querySelectorAll(_this.classConfig.selectorSearchInput);
                radioButtonsWrappers === null || radioButtonsWrappers === void 0 ? void 0 : radioButtonsWrappers.forEach(function(radioButtonsWrapper) {
                    var radioButtons = radioButtonsWrapper.querySelectorAll(_this.classConfig.selectorSearchSponsorBy);
                    radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(input) {
                        input.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.handleRadioButtonStatusChange(radioButtons, radioButtonsWrapper);
                            _this.clearSearchSponsorInputValueAndSuggestions(input);
                        });
                    });
                });
            };
            _this.setChecked = function(element) {
                if (!element.classList.contains("st_checked")) {
                    element.classList.add("st_checked");
                }
                element.setAttribute("checked", "checked");
            };
            _this.removeChecked = function(element) {
                if (element.classList.contains("st_checked")) {
                    element.classList.remove("st_checked");
                }
                element.removeAttribute("checked");
            };
            _this.renderPlaceholderText = function(radioButton, wrapper) {
                var label = _this.generalMethods.getClosestByTag(radioButton, "label");
                var text = label.querySelector(_this.classConfig.selectorRadioText).textContent;
                var placeholder = wrapper.querySelector(".st_search-input .st_placeholder-text");
                placeholder.innerHTML = text;
            };
            _this.clearSearchSponsorInputValueAndSuggestions = function(input) {
                var searchSponsorWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                if (!!searchSponsorWrapper) {
                    _this.clearSearchSponsorInputValue(searchSponsorWrapper);
                    _this.clearSponsorSuggestions(searchSponsorWrapper);
                }
            };
            _this.clearSearchSponsorInputValue = function(searchSponsorWrapper) {
                var searchSponsorInput = searchSponsorWrapper.querySelector(_this.classConfig.selectorSearchSponsor);
                if (!!searchSponsorInput) {
                    searchSponsorInput.value = "";
                    searchSponsorInput.replaceChildren();
                }
            };
            _this.clearSponsorSuggestions = function(searchSponsorWrapper) {
                var searchSponsorResult = searchSponsorWrapper.querySelector(_this.classConfig.selectorFoundSponsor);
                searchSponsorResult === null || searchSponsorResult === void 0 ? void 0 : searchSponsorResult.replaceChildren();
            };
            _this.renderSuggestionsWrapper = function(sponsorsList, input) {
                var sponsorsInputWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                if (!!sponsorsInputWrapper) {
                    var sponsorsWrapper_1 = sponsorsInputWrapper.querySelector(_this.classConfig.selectorFoundSponsor);
                    if (!!sponsorsWrapper_1) {
                        sponsorsWrapper_1.classList.remove("st_hidden");
                        sponsorsWrapper_1.replaceChildren();
                        sponsorsList === null || sponsorsList === void 0 ? void 0 : sponsorsList.forEach(function(sponsor) {
                            var sponsorJson = JSON.stringify(sponsor);
                            var buttonWithSponsorInfo = _this.createDOMElement("button", "st_search-sponsor-button--result st_choose-sponsor_JS", sponsorsWrapper_1);
                            buttonWithSponsorInfo.setAttribute("type", "button");
                            buttonWithSponsorInfo.setAttribute("data-sponsor-info", sponsorJson);
                            var leftPart = _this.createDOMElement("span", "st_result-left-part", buttonWithSponsorInfo);
                            var addressPart = _this.createDOMElement("span", "st_result-address", buttonWithSponsorInfo);
                            var credentialsSection = _this.createDOMElement("span", "st_account-sponsor-credentials-section", leftPart);
                            var sponsorResultName = _this.createDOMElement("span", "st_result-name", leftPart);
                            var addressPartData = _this.createDOMElement("span", "st_sponsor-address_JS", addressPart);
                            var state = sponsor.address.state;
                            var city = sponsor.address.city;
                            var address = state && state !== "" ? state + ", " + city : city;
                            addressPartData.innerHTML = address;
                            var initialsSection = _this.createDOMElement("span", "st_account-sponsor-initials", credentialsSection);
                            var initialsJSSection = _this.createDOMElement("span", "st_sponsor-initials_JS", initialsSection);
                            initialsJSSection.innerHTML = "".concat(sponsor.firstName.charAt(0)).concat(sponsor.lastName.charAt(0));
                            var colWrapper = _this.createDOMElement("span", "st_span-full-width", sponsorResultName);
                            var fullName = _this.createDOMElement("span", "st_sponsor-fullname_JS", colWrapper);
                            fullName.innerHTML = sponsor.firstName + " " + sponsor.lastName;
                            var sponsorIdWrapper = _this.createDOMElement("span", "st_sponsor-id", colWrapper);
                            var sponsorIdNumber = _this.createDOMElement("span", "st_sponsor-id_JS", sponsorIdWrapper);
                            sponsorIdNumber.innerHTML = " (ID: " + sponsor.repId + ")";
                            var aliasWrapper = _this.createDOMElement("span", "st_sponsor-alias", sponsorResultName);
                            var aliasWrapperData = _this.createDOMElement("span", "st_sponsor-alias_JS", aliasWrapper);
                            aliasWrapperData.innerHTML = sponsor.webAlias;
                        });
                    }
                    _this.chooseSponsor(sponsorsInputWrapper);
                }
            };
            _this.createDOMElement = function(element, classNames, parentElement) {
                var newElement = document.createElement(element);
                newElement.className = classNames;
                parentElement.appendChild(newElement);
                return newElement;
            };
            _this.chooseSponsor = function(sponsorsInputWrapper) {
                var sponsorButtons = sponsorsInputWrapper.querySelectorAll(_this.classConfig.selectorChooseSponsor);
                sponsorButtons === null || sponsorButtons === void 0 ? void 0 : sponsorButtons.forEach(function(sponsor) {
                    sponsor.addEventListener("click", function(e) {
                        e.preventDefault();
                        var newSponsorJson = sponsor.getAttribute("data-sponsor-info");
                        var newSponsor = JSON.parse(newSponsorJson);
                        var sponsorWrappers = document.querySelectorAll(_this.classConfig.selectorSearchSponsorWrapperPage);
                        sponsorWrappers === null || sponsorWrappers === void 0 ? void 0 : sponsorWrappers.forEach(function(sponsorWrapper) {
                            _this.defaultVisibility(sponsorWrapper);
                        });
                        _this.updateUrl(newSponsor.webAlias);
                        _this.clearSearchSponsorInputValueAndSuggestions(e.target);
                        _this.injectSponsorInfo(newSponsor);
                        _this.setRepCookies(newSponsor);
                        _this.setSponsorWebAliasToForm(newSponsor.webAlias);
                        _this.setNewSponsorInfoToHeader(newSponsor.firstName, newSponsor.lastName, newSponsor.webAlias);
                        window.dispatchEvent(new Event("sponsorChange"));
                    });
                });
            };
            _this.setNewSponsorInfoToHeader = function(repFirstName, repLastName, webAlias) {
                var repFullNameFields = document.querySelectorAll(_this.classConfig.selectorRepresentativeFullName);
                var fullName = _this.getFullName(repFirstName, repLastName, webAlias);
                repFullNameFields === null || repFullNameFields === void 0 ? void 0 : repFullNameFields.forEach(function(field) {
                    _this.appendValueToField(field, fullName);
                });
            };
            _this.appendValueToField = function(field, value) {
                if (field.tagName.toLowerCase() === "input") {
                    field.value = value;
                } else {
                    field.innerHTML = value;
                }
            };
            _this.hideSuggestionsWrapper = function(input) {
                var sponsorsInputWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                var sponsorsWrapper = sponsorsInputWrapper === null || sponsorsInputWrapper === void 0 ? void 0 : sponsorsInputWrapper.querySelector(_this.classConfig.selectorFoundSponsor);
                sponsorsWrapper === null || sponsorsWrapper === void 0 ? void 0 : sponsorsWrapper.replaceChildren();
                sponsorsWrapper === null || sponsorsWrapper === void 0 ? void 0 : sponsorsWrapper.classList.add("st_hidden");
            };
            _this.generalMethods = generalMethods;
            _this.objectFormatting = objectFormatting;
            _this.browserHistory = browserHistory;
            _this.classConfig = classConfig;
            _this.cookies = cookies;
            _this.cart = cart;
            _this.sponsorService = sponsorService;
            return _this;
        }
        StSearchSponsor.prototype.hideSearchResults = function(searchWrapper) {
            var searchResult = searchWrapper.querySelector(this.classConfig.selectorSearchResult);
            if (!(searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.contains("st_hidden"))) {
                searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.add("st_hidden");
            }
        };
        StSearchSponsor.prototype.showSearchResults = function(searchWrapper) {
            var searchResult = searchWrapper.querySelector(this.classConfig.selectorSearchResult);
            if (searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.contains("st_hidden")) {
                searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.remove("st_hidden");
            }
        };
        StSearchSponsor.prototype.hideSearchInput = function(searchWrapper) {
            var searchInput = searchWrapper.querySelector(this.classConfig.selectorSearchInput);
            if (!(searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.contains("st_hidden"))) {
                searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.add("st_hidden");
            }
        };
        StSearchSponsor.prototype.showSearchInput = function(searchWrapper) {
            var searchInput = searchWrapper.querySelector(this.classConfig.selectorSearchInput);
            if (searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.contains("st_hidden")) {
                searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.remove("st_hidden");
            }
        };
        StSearchSponsor.prototype.initSearchBoxFunctionality = function() {
            var _this = this;
            var searchWrappers = document.querySelectorAll(this.classConfig.selectorSearchSponsorWrapperPage);
            if (searchWrappers.length > 0) {
                var customerID = window.customerInfoMetafields.customerId;
                var sponsorRepID = window.customerInfoMetafields.representativeId;
                var customerType = window.customerInfoMetafields.customerType;
                var repSite = void 0;
                if (!!customerID && _features_config_6.lockedRepresentativeSite && customerType !== _features_config_6.ECustomerType.noType) {
                    repSite = customerType === _features_config_6.ECustomerType.representative ? customerID : sponsorRepID;
                } else {
                    var webAlias = this.objectFormatting.convertQueryStringToObject(window.location.search);
                    if (!!webAlias.als) {
                        repSite = webAlias.als;
                    } else {
                        if (!!this.cookies.getCookie("webAlias")) {
                            repSite = this.cookies.getCookie("webAlias");
                        }
                    }
                }
                this.getSponsorInfo(repSite);
            }
            searchWrappers === null || searchWrappers === void 0 ? void 0 : searchWrappers.forEach(function(wrapper) {
                _this.searchSponsors(wrapper);
            });
        };
        StSearchSponsor.prototype.injectTextIntoFields = function(fields, text) {
            fields === null || fields === void 0 ? void 0 : fields.forEach(function(field) {
                field.innerHTML = text;
            });
        };
        StSearchSponsor.prototype.subscribeToTimeout = function(input, request) {
            var value = input.value;
            if (value.length > 1) {
                clearTimeout(this.requestTimeout);
                this.requestTimeout = setTimeout(request, this.REQUEST_DELAY);
            } else {
                var searchSponsorInputWrapper = this.generalMethods.getClosestByClass(input, this.classConfig.classNameSearchInput);
                this.clearSponsorSuggestions(searchSponsorInputWrapper);
                this.enableRadioButtons(input);
            }
        };
        StSearchSponsor.prototype.handleGetSponsorsResponse = function(request, input) {
            var res = JSON.parse(request.response);
            if (res.status === 200) {
                var sponsorsList = res.data.sponsors;
                if (sponsorsList.length > 0) {
                    this.loaderOff(input);
                    this.enableRadioButtons(input);
                    this.renderSuggestionsWrapper(sponsorsList, input);
                } else {
                    this.loaderOff(input);
                    this.enableRadioButtons(input);
                    this.hideSuggestionsWrapper(input);
                }
            } else {
                this.loaderOff(input);
                this.enableRadioButtons(input);
                this.hideSuggestionsWrapper(input);
            }
        };
        StSearchSponsor.prototype.handleRadioButtonStatusChange = function(radioButtons, radioButtonsWrapper) {
            var _this = this;
            radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton) {
                if (!!radioButton.checked) {
                    _this.setChecked(radioButton);
                    _this.renderPlaceholderText(radioButton, radioButtonsWrapper);
                } else {
                    _this.removeChecked(radioButton);
                }
            });
        };
        StSearchSponsor.prototype.getFullName = function(repFirstName, repLastName, webAlias) {
            var fullName = !!repLastName ? repFirstName : "";
            fullName = !!repLastName ? fullName.concat(" ".concat(repLastName)) : fullName;
            if (webAlias === _features_config_6.defaultWebAlias) fullName = _features_config_6.corporationName;
            return fullName;
        };
        return StSearchSponsor;
    }(st_module_38.StModule);
    exports.StSearchSponsor = StSearchSponsor;
});

define("core/shopify-app/st-modules/enrollment-account/enrollment-account-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_39) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentAccountClassConfig = void 0;
    var StEnrollmentAccountClassConfig = function(_super) {
        __extends(StEnrollmentAccountClassConfig, _super);
        function StEnrollmentAccountClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentAccountClassConfig";
            _this.classNameEnrollmentAccountPageWrp = "st_enrollment-account-page_JS";
            _this.selectorEnrollmentAccountPageWrp = "." + _this.classNameEnrollmentAccountPageWrp;
            _this.classNameEnrollmentLoginForm = "st_enrollment-login_JS";
            _this.selectorEnrollmentLoginForm = "." + _this.classNameEnrollmentLoginForm;
            _this.classNameEnrollmentCreateAccountWrp = "st_enrollment-create-account_JS";
            _this.selectorEnrollmentCreateAccountWrp = "." + _this.classNameEnrollmentCreateAccountWrp;
            _this.classNameEnrollmentCreateAccountForm = "st_enrollment-create-account--form_JS";
            _this.selectorEnrollmentCreateAccountForm = "." + _this.classNameEnrollmentCreateAccountForm;
            _this.classNameEnrollmentCreateAccountOpenButton = "st_enrollment-create-account--open_JS";
            _this.selectorEnrollmentCreateAccountOpenButton = "." + _this.classNameEnrollmentCreateAccountOpenButton;
            _this.classNameEnrollmentCreateAccountSubmit = "st_submit--btn_JS";
            _this.selectorEnrollmentCreateAccountSubmit = "." + _this.classNameEnrollmentCreateAccountSubmit;
            _this.classNameEnrollmentAccountPassword = "st_enrollment-account-create-password_JS";
            _this.selectorEnrollmentAccountPassword = "." + _this.classNameEnrollmentAccountPassword;
            _this.classNameEnrollmentAccountRepeatPassword = "st_enrollment-account-create-repeat-password_JS";
            _this.selectorEnrollmentAccountRepeatPassword = "." + _this.classNameEnrollmentAccountRepeatPassword;
            _this.classNamePrimaryInput = "st_primary-input_JS";
            _this.selectorPrimaryInput = "." + _this.classNamePrimaryInput;
            return _this;
        }
        return StEnrollmentAccountClassConfig;
    }(st_module_39.StModule);
    exports.StEnrollmentAccountClassConfig = StEnrollmentAccountClassConfig;
});

define("core/shopify-app/st-modules/enrollment/enrollment-cleanup", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_40, _features_config_7) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentCleanup = void 0;
    var StEnrollmentCleanup = function(_super) {
        __extends(StEnrollmentCleanup, _super);
        function StEnrollmentCleanup(cart) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StEnrollmentCleanup";
            _this.init = function() {};
            _this.clearCartAttributes = function(callback) {
                if (callback === void 0) {
                    callback = function() {};
                }
                _this.cart.getCart(function(cartData) {
                    var paramsToClear = _features_config_7.enrollmentParams !== null && _features_config_7.enrollmentParams !== void 0 ? _features_config_7.enrollmentParams : [];
                    if (cartData.attributes) {
                        var attributesFormatted_1 = __assign({}, cartData.attributes);
                        Object.keys(attributesFormatted_1).forEach(function(param) {
                            if (paramsToClear.indexOf(param) > -1) {
                                attributesFormatted_1[param] = "";
                            }
                        });
                        _this.cart.updateCart({
                            attributes: attributesFormatted_1
                        }, callback);
                    }
                });
            };
            _this.cart = cart;
            return _this;
        }
        return StEnrollmentCleanup;
    }(st_module_40.StModule);
    exports.StEnrollmentCleanup = StEnrollmentCleanup;
});

define("core/shopify-app/st-modules/enrollment-account/enrollment-account", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_41, notification_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentAccount = void 0;
    var StEnrollmentAccount = function(_super) {
        __extends(StEnrollmentAccount, _super);
        function StEnrollmentAccount(classConfig, buttonActions, notification, form, generalMethod, enrollmentCleanup, cart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentAccount";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.form.liveTrim();
                    _this_1.enrollmentLoginPreventDefault();
                    _this_1.toggleCreateAccount();
                    _this_1.enrollmentCreateAccountForm();
                });
            };
            _this_1.enrollmentLoginPreventDefault = function() {
                var _this = _this_1;
                var enrollmentForms = document.querySelectorAll(_this_1.classConfig.selectorEnrollmentLoginForm);
                enrollmentForms.forEach(function(form) {
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                        _this.enrollmentLogin(form, _this.prepareForLogin(form));
                    });
                });
            };
            _this_1.prepareForLogin = function(form) {
                var formData = _this_1.form.collectFormData(form);
                return {
                    email: formData["customer[email]"],
                    password: formData["customer[password]"]
                };
            };
            _this_1.enrollmentLogin = function(form, formData) {
                var _this = _this_1;
                var redirectUrl = form.getAttribute("data-url");
                var submitBtn = form.querySelector(".st_submit--btn_JS");
                _this.buttonActions.prevent(submitBtn);
                var loginRequest = {};
                loginRequest.form_type = "customer_login";
                loginRequest["customer[email]"] = formData.email;
                loginRequest["customer[password]"] = formData.password;
                _this.ajax.send({
                    endpoint: window.location.protocol + "//" + window.location.hostname + "/account/login",
                    method: "post",
                    contentType: "form",
                    data: loginRequest,
                    callback: function(request) {
                        try {
                            if (request.status == 200) {
                                var redirectUrlResponse = request.responseURL.toString();
                                if (redirectUrlResponse.includes("/account/login")) {
                                    window.location.reload();
                                    _this.buttonActions.allow(submitBtn);
                                    _this.notification.showNotification(notification_4.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
                                } else {
                                    var cartData = _this.stCart.getShopifyCartData;
                                    if (cartData.attributes.email !== formData.email) {
                                        _this.enrollmentCleanup.clearCartAttributes(function() {
                                            window.location.assign(window.location.protocol + "//" + window.location.hostname + redirectUrl);
                                        });
                                    } else {
                                        window.location.assign(window.location.protocol + "//" + window.location.hostname + redirectUrl);
                                    }
                                }
                            } else {
                                window.location.reload();
                                _this.buttonActions.allow(submitBtn);
                                _this.notification.showNotification(notification_4.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.buttonActions.allow(submitBtn);
                            _this.notification.showNotification(notification_4.ENotificationType.error, "Server Error", error);
                        }
                    }
                });
            };
            _this_1.toggleCreateAccount = function() {
                var _this = _this_1;
                var createAccountBtns = document.querySelectorAll(_this_1.classConfig.selectorEnrollmentCreateAccountOpenButton);
                createAccountBtns.forEach(function(btn) {
                    btn.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.showEnrollmentCreateAccount(this);
                    });
                });
            };
            _this_1.showEnrollmentCreateAccount = function(triggerBtn) {
                var enrollmentCreateAccount = document.querySelector(_this_1.classConfig.selectorEnrollmentCreateAccountWrp);
                if (!!enrollmentCreateAccount) {
                    enrollmentCreateAccount.classList.remove("st_visibility-hidden");
                    document.body.scrollTop = 0;
                    document.documentElement.scrollTop = 0;
                    var enrollmentAccountPage = _this_1.generalMethod.getClosestByClass(triggerBtn, _this_1.classConfig.classNameEnrollmentAccountPageWrp);
                    if (!!enrollmentAccountPage) {
                        enrollmentAccountPage.classList.add("st_visibility-hidden");
                    }
                }
            };
            _this_1.enrollmentCreateAccountForm = function() {
                var _this = _this_1;
                var enrollmentCreateAccountForms = document.querySelectorAll(_this_1.classConfig.selectorEnrollmentCreateAccountForm);
                enrollmentCreateAccountForms.forEach(function(form) {
                    _this.onRepeatPassword(form);
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                        _this.enrollmentCreateAccountFormSubmit(form);
                    });
                });
            };
            _this_1.enrollmentCreateAccountFormSubmit = function(form) {
                var _this = _this_1;
                var formData = _this.form.collectFormData(form);
                var submitBtn = form.querySelector(_this_1.classConfig.selectorEnrollmentCreateAccountSubmit);
                _this.form.clearFormatting(form, [ "repeatPassword" ]);
                _this.buttonActions.prevent(submitBtn);
                var passwordInputElement = document.querySelector('input[name="password"]');
                var repeatPasswordInputElement = document.querySelector('input[name="repeatPassword"]');
                if (passwordInputElement.value.length > 40) {
                    _this.notification.showNotification(notification_4.ENotificationType.error, "Validation Error", "Password cannot contain more than 40 characters!");
                    _this.buttonActions.allow(submitBtn);
                } else if (passwordInputElement.value === (repeatPasswordInputElement === null || repeatPasswordInputElement === void 0 ? void 0 : repeatPasswordInputElement.value) || !repeatPasswordInputElement) {
                    _this.ajax.send({
                        endpoint: _this.endpoint["enrollment"]["createAccount"],
                        method: "post",
                        contentType: "json",
                        data: formData,
                        callback: function(response) {
                            try {
                                var createAccountResponse = JSON.parse(response.response);
                                if (createAccountResponse.status === 200) {
                                    _this.buttonActions.allow(submitBtn);
                                    var formDataLogin = {
                                        email: formData.email,
                                        password: formData.password
                                    };
                                    _this.enrollmentLogin(form, formDataLogin);
                                } else if (createAccountResponse.status === 400) {
                                    var validationErrors = _this.prepareErrorArray(createAccountResponse.data);
                                    _this.notification.showNotification(notification_4.ENotificationType.error, "Validation Error", validationErrors);
                                    _this.buttonActions.allow(submitBtn);
                                    var errors = [];
                                    for (var validationParam in createAccountResponse.data) {
                                        var validationResult = createAccountResponse.data[validationParam];
                                        if (!validationResult.isValid) {
                                            errors.push(validationResult.message);
                                        }
                                    }
                                    _this.notification.showNotification(notification_4.ENotificationType.error, "Validation Error", errors);
                                    _this.buttonActions.allow(submitBtn);
                                } else {
                                    _this.notification.showNotification(notification_4.ENotificationType.error, "Validation Error", createAccountResponse.message);
                                    _this.buttonActions.allow(submitBtn);
                                }
                            } catch (error) {
                                console.error(error);
                                _this.notification.showNotification(notification_4.ENotificationType.error, "Server Error", error);
                                _this.buttonActions.allow(submitBtn);
                            }
                        }
                    });
                } else {
                    _this.form.markValidationResults(form, _this.checkPasswordMatch({}));
                    _this.notification.showNotification(notification_4.ENotificationType.error, "Validation Error", "Passwords not matching!");
                    _this.buttonActions.allow(submitBtn);
                }
            };
            _this_1.onRepeatPassword = function(form) {
                var _this = _this_1;
                var passwordInputElement = document.querySelector('input[name="password"]');
                var repeatPasswordInputElement = document.querySelector('input[name="repeatPassword"]');
                passwordInputElement.oninput = function(e) {
                    var validationProperties = _this.checkPasswordMatch({});
                    if (Object.keys(validationProperties).length === 0) {
                        _this.form.clearFormatting(form, [ "repeatPassword" ]);
                    } else {
                        _this.form.markValidationResults(form, validationProperties);
                    }
                };
                if (repeatPasswordInputElement) {
                    repeatPasswordInputElement.oninput = function() {
                        var validationProperties = _this.checkPasswordMatch({});
                        if (Object.keys(validationProperties).length === 0) {
                            _this.form.clearFormatting(form, [ "repeatPassword" ]);
                        } else {
                            _this.form.markValidationResults(form, validationProperties);
                        }
                    };
                }
            };
            _this_1.checkPasswordMatch = function(validationProperties) {
                var passwordInputElement = document.querySelector(_this_1.classConfig.selectorEnrollmentAccountPassword);
                var repeatPasswordInputElement = document.querySelector(_this_1.classConfig.selectorEnrollmentAccountRepeatPassword);
                if (repeatPasswordInputElement) {
                    if (passwordInputElement.value !== repeatPasswordInputElement.value) {
                        return __assign(__assign({}, validationProperties), {
                            repeatPassword: {
                                isValid: false,
                                message: "Passwords not matching!"
                            }
                        });
                    }
                }
                return validationProperties;
            };
            _this_1.prepareErrorArray = function(validationData) {
                var validationDataKeys = Object.keys(validationData);
                var errorArray = [];
                validationDataKeys.forEach(function(key) {
                    if (!validationData[key].isValid) {
                        errorArray.push(validationData[key].message);
                    }
                });
                return errorArray;
            };
            _this_1.classConfig = classConfig;
            _this_1.buttonActions = buttonActions;
            _this_1.notification = notification;
            _this_1.form = form;
            _this_1.generalMethod = generalMethod;
            _this_1.enrollmentCleanup = enrollmentCleanup;
            _this_1.stCart = cart;
            return _this_1;
        }
        return StEnrollmentAccount;
    }(st_module_41.StModule);
    exports.StEnrollmentAccount = StEnrollmentAccount;
});

define("core/shopify-app/st-modules/_general-methods/form/formatting", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_42) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StFormFormatting = void 0;
    var StFormFormatting = function(_super) {
        __extends(StFormFormatting, _super);
        function StFormFormatting() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Formatting";
            _this.setupFormatting = function(collectionToIterate, formattingFn, callbackFn) {
                if (callbackFn === void 0) {
                    callbackFn = function(value) {};
                }
                collectionToIterate.forEach(function(input) {
                    var formattedVal = formattingFn(input.value);
                    input.value = formattedVal;
                    input.setAttribute("value", formattedVal);
                    callbackFn(formattedVal);
                    input.addEventListener("input", function(e) {
                        var formattedVal = formattingFn(this.value);
                        this.value = formattedVal;
                        this.setAttribute("value", formattedVal);
                        callbackFn(this.value);
                    });
                    input.addEventListener("keyup", function(e) {
                        var formattedVal = formattingFn(this.value);
                        this.value = formattedVal;
                        this.setAttribute("value", formattedVal);
                        callbackFn(this.value);
                    });
                    input.addEventListener("paste", function(e) {
                        var formattedVal = formattingFn(this.value);
                        this.value = formattedVal;
                        this.setAttribute("value", formattedVal);
                        callbackFn(this.value);
                    });
                });
            };
            _this.formatPhoneNumber = function(phone) {
                var phoneString = ("" + phone).replace(/\D/g, "");
                var segment1 = phoneString.slice(0, 3);
                var segment2 = phoneString.slice(3, 6);
                var segment3 = phoneString.slice(6, 10);
                return segment1 + (segment2.length > 0 ? "-" + segment2 : "") + (segment3.length > 0 ? "-" + segment3 : "");
            };
            _this.formatWebAlias = function(webAlias) {
                return webAlias.replace(/[^A-Za-z0-9\-_]/g, "");
            };
            _this.formatSSN = function(ssn) {
                var phoneString = ("" + ssn).replace(/\D/g, "");
                var segment1 = phoneString.slice(0, 3);
                var segment2 = phoneString.slice(3, 5);
                var segment3 = phoneString.slice(5, 9);
                return segment1 + (segment2.length > 0 ? "-" + segment2 : "") + (segment3.length > 0 ? "-" + segment3 : "");
            };
            return _this;
        }
        return StFormFormatting;
    }(st_module_42.StModule);
    exports.StFormFormatting = StFormFormatting;
});

define("core/shopify-app/st-modules/enrollment/blocks/account-details/account-details-helpers", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_43) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentAccountDetailsHelpers = void 0;
    var StEnrollmentAccountDetailsHelpers = function(_super) {
        __extends(StEnrollmentAccountDetailsHelpers, _super);
        function StEnrollmentAccountDetailsHelpers(formFormatting, classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentAccountDetailsHelpers";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.setupPhoneFormatting();
                });
            };
            _this.setupPhoneFormatting = function(inputs) {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var collectionToIterate = !!inputs ? inputs : wrp.querySelectorAll(_this.classConfig.selectorEnrollmentAccountDetailsPhone);
                _this.formFormatting.setupFormatting(collectionToIterate, _this.formFormatting.formatPhoneNumber);
            };
            _this.formFormatting = formFormatting;
            _this.classConfig = classConfig;
            return _this;
        }
        return StEnrollmentAccountDetailsHelpers;
    }(st_module_43.StModule);
    exports.StEnrollmentAccountDetailsHelpers = StEnrollmentAccountDetailsHelpers;
});

define("core/shopify-app/st-modules/enrollment/blocks/business-info/business-details-helpers", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_44) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentBusinessDetailsHelpers = void 0;
    var StEnrollmentBusinessDetailsHelpers = function(_super) {
        __extends(StEnrollmentBusinessDetailsHelpers, _super);
        function StEnrollmentBusinessDetailsHelpers(formatting, classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "BusinessDetailsHelpers";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.setupWebAliasFormatting();
                    _this.setupSSNFormatting();
                });
            };
            _this.setupWebAliasFormatting = function(inputs) {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var collectionToIterate = !!inputs ? inputs : wrp.querySelectorAll(_this.classConfig.selectorEnrollmentBusinessDetailsWebAlias);
                _this.formFormatting.setupFormatting(collectionToIterate, _this.formFormatting.formatWebAlias, function(value) {
                    var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                    var webAliasPresenter = wrp.querySelector(_this.classConfig.selectorEnrollmentBusinessDetailsWebAliasPresenter);
                    if (!!webAliasPresenter) {
                        webAliasPresenter.innerText = value;
                    }
                });
            };
            _this.setupSSNFormatting = function(inputs) {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var collectionToIterate = !!inputs ? inputs : wrp.querySelectorAll(_this.classConfig.selectorEnrollmentBusinessDetailsSSN);
                _this.formFormatting.setupFormatting(collectionToIterate, _this.formFormatting.formatSSN);
            };
            _this.formFormatting = formatting;
            _this.classConfig = classConfig;
            return _this;
        }
        return StEnrollmentBusinessDetailsHelpers;
    }(st_module_44.StModule);
    exports.StEnrollmentBusinessDetailsHelpers = StEnrollmentBusinessDetailsHelpers;
});

define("core/shopify-app/st-modules/account/header/nav/account-nav", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/connector-app/_shared/models/auth/auth.request.model" ], function(require, exports, st_module_45, auth_request_model_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountNav = void 0;
    var StAccountNav = function(_super) {
        __extends(StAccountNav, _super);
        function StAccountNav(classConfig, objectFormatting, browserHistory, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountNav";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.setupAccountNavPages();
                    _this_1.openPage();
                    _this_1.bindNavEvents();
                    _this_1.logout();
                });
            };
            _this_1.setupAccountNavPages = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorAccountPage);
                var pageWrappers = wrp.querySelectorAll(_this_1.classConfig.selectorAccountContent);
                var navHolder = wrp.querySelector(_this_1.classConfig.selectorAccountNavHolder);
                var navWrp = wrp.querySelector(_this_1.classConfig.selectorAccountNavWrapper);
                if (!!navHolder) {
                    if (pageWrappers.length > 1) {
                        pageWrappers.forEach(function(pageWrapper, pageIndex) {
                            var templateName = pageWrapper.getAttribute("data-name");
                            var svgIcon = pageWrapper.querySelector(_this_1.classConfig.selectorAccountIcon).innerHTML;
                            var page = _this_1.navPageTemplate(pageIndex, templateName, svgIcon);
                            navHolder.appendChild(page);
                        });
                        if (navWrp) {
                            navWrp.classList.remove("st_hidden");
                        }
                    } else {
                        if (navWrp) {
                            navWrp.classList.add("st_hidden");
                        }
                    }
                } else {
                    console.error("Account Nav holder not present! Navigation won't setup");
                }
            };
            _this_1.navPageTemplate = function(pageIndex, templateName, svgIcon) {
                if (templateName === void 0) {
                    templateName = "";
                }
                if (svgIcon === void 0) {
                    svgIcon = "";
                }
                var templateNode;
                templateNode = document.createElement("div");
                templateNode.classList.add("st_header-account-nav-link");
                templateNode.classList.add(_this_1.classConfig.classNameAccountNavHolderSingle);
                var button = document.createElement("button");
                button.classList.add("st_header-navigation-account", "st_account--button");
                button.classList.add(_this_1.classConfig.classNameAccountNavButton);
                button.setAttribute("data-index", "".concat(pageIndex));
                button.innerHTML = svgIcon;
                var text = document.createElement("span");
                text.classList.add("st_header-text");
                text.innerHTML = templateName.charAt(0).toUpperCase() + templateName.slice(1);
                button.appendChild(text);
                templateNode.appendChild(button);
                return templateNode;
            };
            _this_1.bindNavEvents = function() {
                var _this = _this_1;
                var navLinks = document.querySelectorAll(_this.classConfig.selectorAccountNavButton);
                navLinks.forEach(function(navLink) {
                    navLink.addEventListener("click", function(e) {
                        e.preventDefault();
                        var pageIndex = parseInt(this.getAttribute("data-index"));
                        _this.openPage(pageIndex);
                        _this.closeAddressEdit();
                        _this.closeSingleOrder();
                    });
                });
            };
            _this_1.closeAddressEdit = function() {
                var editAddressButtons = document.querySelectorAll(_this_1.classConfig.selectorAccountBackButton);
                if (!!editAddressButtons) {
                    editAddressButtons.forEach(function(editAddressButton) {
                        var addressWrapper = _this_1.generalMethods.getClosestByClass(editAddressButton, _this_1.classConfig.classNameAddressesWrapper);
                        if (!!addressWrapper) {
                            var buttonDropdown = addressWrapper.querySelector(_this_1.classConfig.selectorAccountAddressesDropdown);
                            var buttonDropdownContent = addressWrapper.querySelector(_this_1.classConfig.selectorAccountAddressesDropdownWrapper);
                            addressWrapper.classList.remove("st_hide");
                            if (!!buttonDropdown && !!buttonDropdownContent) {
                                buttonDropdown.classList.remove("active");
                                buttonDropdownContent.classList.remove("active");
                            }
                        }
                    });
                }
            };
            _this_1.closeSingleOrder = function() {
                var _this = _this_1;
                var orderHistory = document.querySelectorAll(_this.classConfig.selectorBackToHistoryOrders);
                orderHistory.forEach(function(order) {
                    var singleOrderWrapper = document.querySelector(".st_single-order_JS");
                    if (!!singleOrderWrapper) {
                        singleOrderWrapper.style.display = "none";
                    }
                    var orderWrapper = document.querySelector(".st_order-history_JS");
                    if (!!orderWrapper) {
                        orderWrapper.classList.remove(_this.classConfig.classNameOpenOrderCSSClass);
                    }
                });
            };
            _this_1.openPage = function(pageIndex) {
                var wrp = document.querySelector(_this_1.classConfig.selectorAccountPage);
                var alreadyOpen = wrp.querySelector(_this_1.classConfig.selectorAccountSection + ".st_show");
                var accountSections = wrp.querySelectorAll(_this_1.classConfig.selectorAccountSection);
                if (typeof pageIndex === "undefined") {
                    var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                    var maxTab = accountSections.length - 1;
                    var tabIndex = urlParams.tab ? parseInt(urlParams.tab) : 0;
                    pageIndex = isNaN(tabIndex) ? 0 : tabIndex;
                    pageIndex = tabIndex > maxTab ? maxTab : tabIndex;
                }
                var navHolder = wrp.querySelector(_this_1.classConfig.selectorAccountNavHolder);
                var AccountNavElements = navHolder.querySelectorAll(_this_1.classConfig.selectorAccountNavHolderSingle);
                if (!!alreadyOpen) {
                    alreadyOpen.classList.remove("st_show");
                }
                if (accountSections.length > pageIndex) {
                    accountSections[pageIndex].classList.add("st_show");
                } else {
                    console.error("Invalid page index supplied to Account nav openPage method!");
                }
                AccountNavElements.forEach(function(navElement, index) {
                    navElement.classList.remove("current");
                    if (index === pageIndex) {
                        _this_1.updateTabToUrl("" + pageIndex);
                        navElement.classList.add("current");
                    }
                });
            };
            _this_1.updateTabToUrl = function(activeTab) {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                urlParams.tab = "" + activeTab;
                var newURL = window.location.href.replace(window.location.search, "");
                _this_1.browserHistory.pushHistory(newURL, urlParams);
            };
            _this_1.logout = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorAccountPage);
                var logoutBtns = wrp.querySelectorAll(_this_1.classConfig.selectorAccountLogout);
                var _this = _this_1;
                if (!!logoutBtns) {
                    logoutBtns.forEach(function(btn) {
                        btn.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.removeTokens();
                            window.location.assign(window.location.protocol + "//" + window.location.hostname + "/account/logout");
                        });
                    });
                }
            };
            _this_1.removeTokens = function() {
                var token = window.localStorage.getItem(auth_request_model_2.ETokenType.Access);
                if (!!token && token.length > 0) window.localStorage.removeItem(auth_request_model_2.ETokenType.Access);
                token = window.localStorage.getItem(auth_request_model_2.ETokenType.Refresh);
                if (!!token && token.length > 0) window.localStorage.removeItem(auth_request_model_2.ETokenType.Refresh);
            };
            _this_1.classConfig = classConfig;
            _this_1.objectFormatting = objectFormatting;
            _this_1.browserHistory = browserHistory;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountNav;
    }(st_module_45.StModule);
    exports.StAccountNav = StAccountNav;
});

define("core/connector-app/_shared/models/auth/sso.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/connector-app/_shared/models/auth/sso.response.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/account/header/backoffice-sso/backoffice-sso", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_46, notification_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StBackofficeSSO = void 0;
    var StBackofficeSSO = function(_super) {
        __extends(StBackofficeSSO, _super);
        function StBackofficeSSO(classConfig, notification) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "BackofficeSSO";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.getSSOLinkEvent();
                });
            };
            _this_1.getSSOLinkEvent = function() {
                var _this = _this_1;
                var ssoLinks = document.querySelectorAll(_this_1.classConfig.selectorBackOfficeLink);
                for (var i = 0; i < ssoLinks.length; i++) {
                    var ssoLink = ssoLinks[i];
                    ssoLink.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.getSSOLink();
                    });
                }
            };
            _this_1.getSSOLink = function() {
                var _this = _this_1;
                var customerInfoMetafields = window.customerInfoMetafields;
                var ssoLinkRequest = {
                    customerId: customerInfoMetafields.customerId,
                    sponsorId: customerInfoMetafields.representativeId,
                    isAutoship: false,
                    customerType: customerInfoMetafields.customerType
                };
                _this_1.ajax.send({
                    endpoint: _this.endpoint["auth"]["sso"],
                    method: "post",
                    contentType: "json",
                    data: ssoLinkRequest,
                    callback: function(response) {
                        try {
                            var ssoLinkResponse = JSON.parse(response.response);
                            if (ssoLinkResponse.status === 200) {
                                var ssoLinkData = ssoLinkResponse.data;
                                if (!!ssoLinkData.ssoLink && ssoLinkData.ssoLink !== "") {
                                    window.location.href = ssoLinkData.ssoLink;
                                }
                            } else {
                                _this.notification.showNotification(notification_5.ENotificationType.error, "An Error Occurred!", ssoLinkResponse.message);
                            }
                        } catch (error) {
                            _this.notification.showNotification(notification_5.ENotificationType.error, "An Error Occurred!", error);
                        }
                    }
                });
            };
            _this_1.classConfig = classConfig;
            _this_1.notification = notification;
            return _this_1;
        }
        return StBackofficeSSO;
    }(st_module_46.StModule);
    exports.StBackofficeSSO = StBackofficeSSO;
});

define("core/shopify-app/st-modules/account/blocks/web-alias-edit/web-alias-edit", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_47, notification_6) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountWebAliasEdit = void 0;
    var StAccountWebAliasEdit = function(_super) {
        __extends(StAccountWebAliasEdit, _super);
        function StAccountWebAliasEdit(classConfig, generalMethods, notification, buttonActions, form, formFormatting) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountWebAliasEdit";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.setupWebAliasInputEvents();
                    _this_1.editWebAlias();
                });
            };
            _this_1.setupWebAliasInputEvents = function() {
                var _this = _this_1;
                var webAliasInputsFields = document.querySelectorAll(_this_1.classConfig.selectorAccountWebAlias);
                webAliasInputsFields.forEach(function(webAliasInput) {
                    _this.injectWebAlias(webAliasInput);
                    webAliasInput.addEventListener("keyup", function() {
                        this.value = _this.formFormatting.formatWebAlias(this.value);
                        _this.injectWebAlias(this);
                    });
                    webAliasInput.addEventListener("input", function() {
                        this.value = _this.formFormatting.formatWebAlias(this.value);
                        _this.injectWebAlias(this);
                    });
                    webAliasInput.addEventListener("paste", function() {
                        this.value = _this.formFormatting.formatWebAlias(this.value);
                        _this.injectWebAlias(this);
                    });
                });
            };
            _this_1.injectWebAlias = function(webAliasInput) {
                var inputValue = webAliasInput.value;
                var webAliasWrapper = _this_1.generalMethods.getClosestByClass(webAliasInput, _this_1.classConfig.classNameWebAliasWrapper);
                var readOnlyInput = webAliasWrapper.querySelector(_this_1.classConfig.selectorWebAliasValue);
                readOnlyInput.value = inputValue;
            };
            _this_1.editWebAlias = function() {
                var _this = _this_1;
                var form = document.querySelector(_this_1.classConfig.selectorEditWebAliasForm);
                if (!!form) {
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                        _this.submitWebAlias(this);
                    });
                }
            };
            _this_1.submitWebAlias = function(form) {
                var _this = _this_1;
                var formData = _this.form.collectFormData(form);
                var submitBtn = form.querySelector(_this_1.classConfig.selectorSubmitButton);
                _this.buttonActions.prevent(submitBtn);
                _this.ajax.send({
                    endpoint: _this.endpoint["customer"]["updateWebAlias"],
                    method: "post",
                    contentType: "json",
                    data: formData,
                    callback: function(response) {
                        try {
                            var editWebAliasResponse = JSON.parse(response.response);
                            if (editWebAliasResponse.status === 200) {
                                _this.buttonActions.allow(submitBtn);
                                window.location.reload();
                            } else if (editWebAliasResponse.status === 400) {
                                var validationProperties = editWebAliasResponse.data;
                                _this.form.markValidationResults(form, validationProperties);
                                _this.buttonActions.allow(submitBtn);
                                _this.notification.showNotification(notification_6.ENotificationType.error, "An Error Occurred", "Some fields are invalid.");
                            } else {
                                _this.notification.showNotification(notification_6.ENotificationType.error, "An Error Occurred", editWebAliasResponse.message);
                                _this.buttonActions.allow(submitBtn);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_6.ENotificationType.error, "Server Error", error);
                            _this.buttonActions.allow(submitBtn);
                        }
                    }
                });
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            _this_1.notification = notification;
            _this_1.buttonActions = buttonActions;
            _this_1.form = form;
            _this_1.formFormatting = formFormatting;
            return _this_1;
        }
        return StAccountWebAliasEdit;
    }(st_module_47.StModule);
    exports.StAccountWebAliasEdit = StAccountWebAliasEdit;
});

define("core/shopify-app/st-modules/account/blocks/addresses/addresses", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_48) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountAddresses = void 0;
    var StAccountAddresses = function(_super) {
        __extends(StAccountAddresses, _super);
        function StAccountAddresses(classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountAddress";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.openAddressDropDown();
                    _this_1.setupAddressEdit();
                    _this_1.setupAddressProvinceField();
                });
            };
            _this_1.openAddressDropDown = function() {
                var _this = _this_1;
                var dropDownButtons = document.querySelectorAll(_this_1.classConfig.selectorAccountAddressesDropdown);
                dropDownButtons.forEach(function(dropDownButton) {
                    dropDownButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.openAddressActiveState(dropDownButton);
                    });
                });
            };
            _this_1.openAddressActiveState = function(dropDownButton) {
                dropDownButton.classList.toggle("active");
            };
            _this_1.setupAddressEdit = function() {
                var _this = _this_1;
                var addressTabButtons = document.querySelectorAll(_this_1.classConfig.selectorAccountTabButton);
                addressTabButtons.forEach(function(addressTabButton) {
                    addressTabButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.showAddressEdit(addressTabButton);
                    });
                });
                var editAddressButtons = document.querySelectorAll(_this_1.classConfig.selectorAccountBackButton);
                editAddressButtons.forEach(function(editAddressButton) {
                    editAddressButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.hideAddressEdit(editAddressButton);
                    });
                });
            };
            _this_1.showAddressEdit = function(addressTabButton) {
                var addressWrapper = _this_1.generalMethods.getClosestByClass(addressTabButton, _this_1.classConfig.classNameAddressesWrapper);
                if (!!addressWrapper) {
                    addressWrapper.classList.add("st_hide");
                }
            };
            _this_1.hideAddressEdit = function(editAddressButton) {
                var addressWrapper = _this_1.generalMethods.getClosestByClass(editAddressButton, _this_1.classConfig.classNameAddressesWrapper);
                if (!!addressWrapper) {
                    var buttonDropdown = addressWrapper.querySelector(".st_addresses-dots--button_JS");
                    var buttonDropdownContent = addressWrapper.querySelector(".st_dropdown-address--wrapper");
                    addressWrapper.classList.remove("st_hide");
                    buttonDropdown.classList.remove("active");
                    buttonDropdownContent.classList.remove("active");
                }
            };
            _this_1.setupAddressProvinceField = function() {
                var _this = _this_1;
                var provinceSelector = document.querySelector(_this_1.classConfig.selectorProvinceSelector);
                var provinceSource = document.querySelector(_this_1.classConfig.selectorProvinceSource);
                if (!!provinceSelector && !!provinceSource) {
                    _this_1.addProvinceOptions(provinceSelector, provinceSource);
                    provinceSource.addEventListener("change", function(e) {
                        _this.addProvinceOptions(provinceSelector, provinceSource);
                    });
                }
            };
            _this_1.addProvinceOptions = function(provinceSelector, provinceSource) {
                var selectedCountry = (provinceSource === null || provinceSource === void 0 ? void 0 : provinceSource.value) ? provinceSource === null || provinceSource === void 0 ? void 0 : provinceSource.value : provinceSource === null || provinceSource === void 0 ? void 0 : provinceSource.getAttribute("data-default");
                var provinceSelectedOption = provinceSource === null || provinceSource === void 0 ? void 0 : provinceSource.querySelector('option[value="'.concat(selectedCountry, '"]'));
                var provinceWrapper = _this_1.generalMethods.getClosestByClass(provinceSelector, _this_1.classConfig.classNameProvinceWrapper);
                if (!!provinceWrapper) {
                    provinceWrapper.classList.remove("st_hidden");
                }
                try {
                    var provinces = JSON.parse(provinceSelectedOption === null || provinceSelectedOption === void 0 ? void 0 : provinceSelectedOption.getAttribute("data-provinces"));
                    provinceSelector === null || provinceSelector === void 0 ? void 0 : provinceSelector.replaceChildren();
                    for (var i = 0; i < provinces.length; i++) {
                        var opt = document.createElement("option");
                        opt.value = provinces[i][0];
                        opt.innerHTML = provinces[i][1];
                        opt.setAttribute("data-ind", "" + i);
                        provinceSelector.appendChild(opt);
                    }
                    var defaultProvince = provinceSelector.getAttribute("data-default");
                    var defaultProvinceEl = provinceSelector.querySelector('option[value="'.concat(defaultProvince, '"]'));
                    var provinceOptions = provinceSelector === null || provinceSelector === void 0 ? void 0 : provinceSelector.querySelectorAll("option");
                    var selectedOption = defaultProvince ? defaultProvinceEl : provinceOptions[0];
                    provinceSelector.value = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value;
                    provinceSelector.selectedIndex = parseInt(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.getAttribute("data-ind"));
                    provinceOptions === null || provinceOptions === void 0 ? void 0 : provinceOptions.forEach(function(provinceOption) {
                        provinceOption === null || provinceOption === void 0 ? void 0 : provinceOption.removeAttribute("selected");
                    });
                    if (!!selectedOption) {
                        selectedOption.selected = true;
                        selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.setAttribute("selected", "selected");
                    }
                } catch (e) {
                    console.error(e);
                    var provinceWrapper_1 = _this_1.generalMethods.getClosestByClass(provinceSelector, _this_1.classConfig.classNameProvinceWrapper);
                    if (!!provinceWrapper_1) {
                        provinceWrapper_1.classList.add("st_hidden");
                    }
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountAddresses;
    }(st_module_48.StModule);
    exports.StAccountAddresses = StAccountAddresses;
});

define("core/connector-app/_shared/models/customer/account/customer.account.request", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/account/blocks/personal-info/personal-info", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_49, notification_7) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountPersonalInfo = void 0;
    var StAccountPersonalInfo = function(_super) {
        __extends(StAccountPersonalInfo, _super);
        function StAccountPersonalInfo(classConfig, form, formFormatting, buttonActions, notification, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountPersonalInfo";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.editPersonalInfo();
                    _this_1.setupFormatPhoneNumber();
                });
            };
            _this_1.editPersonalInfo = function() {
                var _this = _this_1;
                var form = document.querySelector(_this_1.classConfig.selectorPersonalInfoForm);
                if (!!form) {
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                        _this.submitPersonalInfo(this);
                    });
                }
            };
            _this_1.submitPersonalInfo = function(form) {
                var _this = _this_1;
                var data = _this.form.collectFormData(form);
                var formData = {
                    firstName: data.firstName,
                    lastName: data.lastName,
                    phoneNumber: data.phoneNumber,
                    shopifyId: data.shopifyId,
                    email: data.email
                };
                var submitBtn = form.querySelector(_this_1.classConfig.selectorSubmitButton);
                _this.buttonActions.prevent(submitBtn);
                _this.ajax.send({
                    endpoint: _this.endpoint["customer"]["updatePersonalInfo"],
                    method: "post",
                    contentType: "json",
                    data: formData,
                    callback: function(response) {
                        try {
                            var editPersonalInfoResponse = JSON.parse(response.response);
                            var validationProperties = editPersonalInfoResponse.data;
                            if (editPersonalInfoResponse.status === 200) {
                                _this.buttonActions.allow(submitBtn);
                                _this.form.markValidationResults(form, validationProperties);
                                _this.notification.showNotification(notification_7.ENotificationType.success, "Success", "You have successfully modified your information.");
                                _this.updatePersonalInfoWrapperIfExist(form, formData);
                            } else if (editPersonalInfoResponse.status === 400) {
                                _this.form.markValidationResults(form, validationProperties);
                                _this.buttonActions.allow(submitBtn);
                                _this.notification.showNotification(notification_7.ENotificationType.error, "An Error Occurred", "Some fields are invalid.");
                            } else {
                                _this.buttonActions.allow(submitBtn);
                                _this.notification.showNotification(notification_7.ENotificationType.error, "An Error Occurred", editPersonalInfoResponse.message);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_7.ENotificationType.error, "Server Error", error);
                            _this.buttonActions.allow(submitBtn);
                        }
                    }
                });
            };
            _this_1.updatePersonalInfoWrapperIfExist = function(formSelector, formData) {
                var accountPage = _this_1.generalMethods.getClosestByClass(formSelector, _this_1.classConfig.classNameAccountPage);
                if (!!accountPage) {
                    var selectorBusinessContent = accountPage.querySelector(_this_1.classConfig.selectorBusinessContent);
                    if (!!selectorBusinessContent) {
                        var nameSelector = selectorBusinessContent.querySelector(_this_1.classConfig.selectorBusinessContentName);
                        var emailSelector = selectorBusinessContent.querySelector(_this_1.classConfig.selectorBusinessContentEmail);
                        if (!!emailSelector) {
                            emailSelector.innerHTML = formData.email;
                        }
                        if (!!nameSelector) {
                            nameSelector.innerHTML = formData.firstName + " " + formData.lastName;
                        }
                    }
                }
            };
            _this_1.setupFormatPhoneNumber = function() {
                var phoneNumberInputs = document.querySelectorAll('input[name="phoneNumber"]');
                _this_1.formFormatting.setupFormatting(phoneNumberInputs, _this_1.formFormatting.formatPhoneNumber);
            };
            _this_1.classConfig = classConfig;
            _this_1.form = form;
            _this_1.formFormatting = formFormatting;
            _this_1.buttonActions = buttonActions;
            _this_1.notification = notification;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountPersonalInfo;
    }(st_module_49.StModule);
    exports.StAccountPersonalInfo = StAccountPersonalInfo;
});

define("core/shopify-app/st-modules/account/blocks/order-history/order-history", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_50) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountOrderHistory = void 0;
    var StAccountOrderHistory = function(_super) {
        __extends(StAccountOrderHistory, _super);
        function StAccountOrderHistory(classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountOrderHistory";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.openSingleOrder();
                    _this_1.backToHistoryOrders();
                });
            };
            _this_1.openSingleOrder = function() {
                var _this = _this_1;
                var singleOrderTriggers = document.querySelectorAll(_this.classConfig.selectorOpenSingleOrderButton);
                singleOrderTriggers.forEach(function(order) {
                    order.addEventListener("click", function(e) {
                        e.preventDefault();
                        var orderId = order.getAttribute("data-order-id");
                        var orderWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameOrderHistory);
                        orderWrapper.classList.add(_this.classConfig.classNameOpenOrderCSSClass);
                        var singleOrderWrapper = orderWrapper.querySelector(_this.classConfig.selectorSingleOrder + '[data-order-id="' + orderId + '"]');
                        singleOrderWrapper.style.display = "block";
                    });
                });
            };
            _this_1.backToHistoryOrders = function() {
                var _this = _this_1;
                var orderHistory = document.querySelectorAll(_this.classConfig.selectorBackToHistoryOrders);
                orderHistory.forEach(function(order) {
                    order.addEventListener("click", function(e) {
                        e.preventDefault();
                        var singleOrderWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameSingleOrder);
                        singleOrderWrapper.style.display = "none";
                        var orderWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameOrderHistory);
                        orderWrapper.classList.remove(_this.classConfig.classNameOpenOrderCSSClass);
                    });
                });
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountOrderHistory;
    }(st_module_50.StModule);
    exports.StAccountOrderHistory = StAccountOrderHistory;
});

define("extension/shopify-app/st-modules/share-cart/share-cart-landing", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_51, _features_config_8) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShareCartLanding = void 0;
    var StShareCartLanding = function(_super) {
        __extends(StShareCartLanding, _super);
        function StShareCartLanding(objectFormatting, cartComponent) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StShareCartLanding";
            _this.landOnShareCart = function(cartToken) {
                return __awaiter(_this, void 0, void 0, function() {
                    var cartAfterClear, error_1;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            _a.trys.push([ 0, 5, , 6 ]);
                            this.toggleShareCartOverlayDisplay(true);
                            return [ 4, this.clearCartAsync() ];

                          case 1:
                            _a.sent();
                            return [ 4, this.getCartAsync() ];

                          case 2:
                            cartAfterClear = _a.sent();
                            if (!(cartAfterClear.items.length > 0)) return [ 3, 4 ];
                            console.warn("[ShareCart] Cart not empty after clear:", cartAfterClear.items);
                            return [ 4, this.clearCartAsync() ];

                          case 3:
                            _a.sent();
                            _a.label = 4;

                          case 4:
                            this.injectShareableCart(cartToken, function(responseData) {
                                var parseData = JSON.parse(responseData);
                                var sponsorWebAlias = parseData.sponsorWebAlias;
                                var partyId = parseData.partyId;
                                var isOutOfStock = parseData.isItemOutOfStock;
                                var params = new URLSearchParams();
                                if (sponsorWebAlias) {
                                    params.set(_features_config_8.aliasQueryParam, sponsorWebAlias);
                                }
                                if (partyId) {
                                    params.set("partyId", partyId);
                                }
                                if (isOutOfStock) {
                                    params.set("itemOutOfStock", "true");
                                }
                                window.location.href = "".concat(window.location.origin, "/cart?").concat(params.toString());
                            }, "");
                            return [ 3, 6 ];

                          case 5:
                            error_1 = _a.sent();
                            console.error("[ShareCart] Failed:", error_1);
                            this.shareCartGenerateError();
                            return [ 3, 6 ];

                          case 6:
                            return [ 2 ];
                        }
                    });
                });
            };
            _this.clearCartAsync = function() {
                return new Promise(function(resolve) {
                    _this.cartComponent.clearCart(function() {
                        resolve();
                    });
                });
            };
            _this.getCartAsync = function() {
                return new Promise(function(resolve) {
                    _this.cartComponent.getCart(function(cartObj) {
                        resolve(cartObj);
                    });
                });
            };
            _this.toggleShareCartOverlayDisplay = function(showLoadingPage) {
                var overlayWrapper = document.querySelector(".st_landing_share_cart_overlay_JS");
                if (overlayWrapper) {
                    showLoadingPage ? overlayWrapper.classList.remove("st_hidden") : overlayWrapper.classList.add("st_hidden");
                }
            };
            _this.injectShareableCart = function(cartToken, callback, params) {
                var _a;
                var shopifyCustomerId = window.customerShopifyId;
                var shareCartUrl = ((_a = window === null || window === void 0 ? void 0 : window.stAppConfig) === null || _a === void 0 ? void 0 : _a.shareCartUrl) || "";
                var apiUrl = "".concat(shareCartUrl, "/share-cart/getShareCartByToken/").concat(cartToken, "?shopifyCustomerId=").concat(shopifyCustomerId);
                var requestOptions = {
                    method: "GET",
                    headers: {
                        "x-api-key": _this.shareCartApiKey,
                        "Content-Type": "application/json"
                    }
                };
                fetch(apiUrl, requestOptions).then(function(response) {
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                }).then(function(responseData) {
                    var _a;
                    var itemsToAdd = [];
                    if (responseData.data) {
                        if (responseData.data.line_items && responseData.data.line_items.length > 0) {
                            responseData.data.line_items.forEach(function(lineItem) {
                                if (lineItem.quantity >= 1) {
                                    var addItem = {
                                        quantity: lineItem.quantity,
                                        id: lineItem.shopify_variant_id,
                                        properties: __assign(__assign({}, lineItem.line_item_properties), {
                                            _sharedCartToken: cartToken
                                        })
                                    };
                                    itemsToAdd.push(addItem);
                                }
                            });
                        }
                        var isItemOutOfStock = ((_a = responseData.data.line_item_messages) === null || _a === void 0 ? void 0 : _a.is_out_of_stock) ? responseData.data.line_item_messages.is_out_of_stock : undefined;
                        var updateAttributes = {
                            attributes: __assign(__assign({}, responseData.data.share_cart_attributes), {
                                _sharedCartToken: cartToken
                            })
                        };
                        _this.cartComponent.updateCartAttributesOrNote(updateAttributes, function() {});
                        var paramsToSave = {
                            sponsorWebAlias: responseData.data.share_cart_attributes.sponsorWebAlias ? responseData.data.share_cart_attributes.sponsorWebAlias : undefined,
                            partyId: responseData.data.share_cart_attributes.partyId ? responseData.data.share_cart_attributes.partyId : undefined,
                            isItemOutOfStock: isItemOutOfStock
                        };
                        params = JSON.stringify(paramsToSave);
                        _this.addItems(itemsToAdd, callback, params);
                    } else {
                        _this.shareCartGenerateError();
                    }
                }).catch(function(error) {
                    _this.shareCartGenerateError();
                    console.error(error);
                });
            };
            _this.shareCartGenerateError = function(outOfStockErrorMessage) {
                var loadingOverlay = document.querySelector(".st_landing_share_cart_overlay_JS");
                if (loadingOverlay) {
                    var contentWrapper = loadingOverlay.querySelector(".st_content_wrapper_JS");
                    contentWrapper === null || contentWrapper === void 0 ? void 0 : contentWrapper.classList.add("st_hidden");
                    var errorWrapper = loadingOverlay.querySelector(".st_error_message_wrapper_JS");
                    errorWrapper.classList.remove("st_hidden");
                    if (outOfStockErrorMessage) {
                        var errorEl = errorWrapper.querySelector(".st_error_JS");
                        if (errorEl) {
                            errorEl.innerHTML = outOfStockErrorMessage;
                        }
                    }
                }
            };
            _this.clearCart = function(callback, params) {
                if (params === void 0) {
                    params = [];
                }
                _this.cartComponent.clearCart(function(response) {
                    callback.apply(void 0, params);
                });
            };
            _this.addItems = function(items, cb, params) {
                _this.cartComponent.addCart(items, function(response) {
                    cb(params);
                });
            };
            _this.disableBodyScroll = function() {
                document.body.style.overflow = "hidden";
            };
            _this.objectFormatting = objectFormatting;
            _this.cartComponent = cartComponent;
            return _this;
        }
        Object.defineProperty(StShareCartLanding.prototype, "shareCartApiKey", {
            get: function() {
                var shareCartKey = window.shareCartApiKey;
                return shareCartKey;
            },
            enumerable: false,
            configurable: true
        });
        return StShareCartLanding;
    }(st_module_51.StModule);
    exports.StShareCartLanding = StShareCartLanding;
});

define("extension/shopify-app/st-modules/webalias/webalias.extended", [ "require", "exports", "_features.config", "core/shopify-app/st-modules/webalias/webalias" ], function(require, exports, _features_config_9, webalias_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StWebAliasExtended = void 0;
    var StWebAliasExtended = function(_super) {
        __extends(StWebAliasExtended, _super);
        function StWebAliasExtended(classConfig, browserHistory, objectFormatting, cookies, customerType, generalMethods, injectRepresentativeInfo, cartComponent, searchSponsorGuard, accountPersonalSite, shareCart) {
            var _this = _super.call(this, classConfig, browserHistory, objectFormatting, cookies, customerType, generalMethods, injectRepresentativeInfo, cartComponent, searchSponsorGuard, accountPersonalSite) || this;
            _this.className = "WebAliasExtended";
            _this.cookieNameEmail = "email";
            _this._fallbackTried = false;
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    var queryParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                    _this.initWebAliasFlow();
                    _this.getCustomerInformation();
                    window.setTimeout(function() {
                        _this.getSponsorInformation();
                    }, 300);
                    if (queryParams.share_cart_token) {
                        _this.shareCart.landOnShareCart(queryParams.share_cart_token);
                    }
                });
            };
            _this.isLeadCustomer = function() {
                var _a;
                var win = window;
                var customerTypeFromMeta = (((_a = win === null || win === void 0 ? void 0 : win.customerInfoMetafields) === null || _a === void 0 ? void 0 : _a.customerType) || "").toString().toLowerCase();
                var customerTags = Array.isArray(win === null || win === void 0 ? void 0 : win.customerTags) ? win.customerTags : [];
                return customerTypeFromMeta === "prospect" || customerTags.some(function(tag) {
                    return tag && tag.toLowerCase() === "prospect";
                });
            };
            _this.initWebAliasFlow = function() {
                var _a;
                var win = window;
                var customerTypeFromMeta = (_a = win.customerInfoMetafields) === null || _a === void 0 ? void 0 : _a.customerType;
                var customerTags = win.customerTags;
                var hasRetailTag = Array.isArray(customerTags) ? customerTags.some(function(tag) {
                    return tag && tag.toLowerCase() === "retail";
                }) : false;
                if (customerTypeFromMeta === "consultant" && hasRetailTag) {
                    _this.retailAliasFlow();
                    return;
                }
                if (_this.isCustomerRepresentative) {
                    _this.representativeAliasFlow();
                    return;
                }
                if (_this.isCustomerRetail || _this.isLeadCustomer()) {
                    _this.retailAliasFlow();
                    return;
                }
                if (_this.isCustomerGuest) {
                    _this.guestAliasFlow();
                }
            };
            _this.representativeAliasFlow = function() {
                _this.getRepresentativesOwnInfo(_this.customerIdFromMetafields);
                var retailLine = document.querySelector(".st_retail_JS");
                var consultantLine = document.querySelector(".st_consultant_JS");
                if (retailLine) {
                    retailLine.classList.remove("st_hidden");
                }
                if (consultantLine) {
                    consultantLine.classList.add("st_hidden");
                }
            };
            _this.guestAliasFlow = function() {
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_9.aliasQueryParam];
                var urlAliasExists = !!currentAlias;
                var cookieAliasExists = !!_this.cookies.getCookie("webAlias");
                if (urlAliasExists && _this.isValidAliasOrId(currentAlias)) {
                    _this.getRepresentativesOwnInfo(currentAlias.trim());
                    return;
                }
                if (cookieAliasExists) {
                    _this.injectRepInfoFromCookie();
                    return;
                }
                _this.injectDefaultRepInfo();
            };
            _this.retailAliasFlow = function() {
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_9.aliasQueryParam];
                var urlAliasExists = !!currentAlias;
                var cookieAliasExists = !!_this.cookies.getCookie("webAlias");
                var isLocked = _features_config_9.lockedRepresentativeSite;
                if (isLocked && !_this.isLeadCustomer()) {
                    var customerIdOrAls = _this.customerIdFromMetafields;
                    _this.getCustomersRepresentativeInfo(customerIdOrAls);
                    return;
                }
                if (urlAliasExists && _this.isValidAliasOrId(currentAlias)) {
                    _this.getRepresentativesOwnInfo(currentAlias.trim());
                    return;
                } else {
                    if (cookieAliasExists) {
                        _this.injectRepInfoFromCookie();
                        return;
                    } else {
                        _this.injectDefaultRepInfo();
                        return;
                    }
                }
            };
            _this.handleRepresentativeInfoResponse = function(response) {
                var _a, _b;
                var _c = response || {}, data = _c.data, status = _c.status;
                if (status === 200 && data) {
                    var webAliasRaw = ((_a = data.webAlias) !== null && _a !== void 0 ? _a : "").toString().trim();
                    var repIdRaw = ((_b = data.repId) !== null && _b !== void 0 ? _b : "").toString().trim();
                    var fixedWebAlias = _this.isValidAliasOrId(webAliasRaw) ? webAliasRaw : repIdRaw;
                    if (!_this.isValidAliasOrId(fixedWebAlias)) {
                        _this.fallbackAfterBadRepLookup();
                        return;
                    }
                    _this.updateCurrentRepInfo(__assign(__assign({}, data), {
                        webAlias: fixedWebAlias
                    }));
                    return;
                }
                _this.fallbackAfterBadRepLookup();
            };
            _this.getRepresentativesOwnInfo = function(customerIdOrAlias) {
                _this.getRepresentativeInfo({
                    customerIdOrAlias: customerIdOrAlias,
                    isOwnInfo: true
                }, _this.handleRepresentativeInfoResponse);
                var customerIdOrAls = window.customerInfoMetafields.representativeId;
            };
            _this.handleRepsRepInfo = function(response) {
                var consultantName = document.querySelector(".st_consultant_JS");
                var retailName = document.querySelector(".st_retail_JS");
                if (!!consultantName && !!retailName) {
                    consultantName.classList.remove("st_hidden");
                    retailName.classList.add("st_hidden");
                }
                var data = response.data, status = response.status;
                if (data.firstName == "" && data.lastName == "" || !data.firstName && !data.lastName) {
                    var consultantsRep = document.querySelector(".st_representatives-rep-fullname_JS");
                    if (!!consultantsRep) {
                        consultantsRep.innerHTML = _features_config_9.corporationName;
                    }
                } else {
                    var consultantsRep = document.querySelector(".st_representatives-rep-fullname_JS");
                    if (!!consultantsRep) {
                        consultantsRep.innerHTML = data.firstName + " " + data.lastName;
                    }
                }
            };
            _this.getCustomersRepresentativeInfo = function(customerIdOrAlias) {
                _this.getRepresentativeInfo({
                    customerIdOrAlias: customerIdOrAlias,
                    isOwnInfo: true
                }, _this.handleRepresentativeInfoResponse);
            };
            _this.getRepresentativeInfo = function(webAliasRequest, handleResponse) {
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["webalias"]["repSite"],
                        method: "post",
                        contentType: "json",
                        data: webAliasRequest,
                        callback: function(response) {
                            try {
                                var representativeInfoRes = JSON.parse(response.response);
                                handleResponse(representativeInfoRes);
                            } catch (error) {
                                _this.nonExistentRepresentativeFlow();
                                console.log("Response Error ------\x3e" + error);
                            }
                        }
                    });
                } catch (error) {
                    console.log("Request Error ------\x3e" + error);
                }
            };
            _this.getSponsorInformation = function() {
                var _a;
                if (window.customerShopifyId === 0) return;
                var customerIdOrAlias = (_a = window === null || window === void 0 ? void 0 : window.customerInfoMetafields) === null || _a === void 0 ? void 0 : _a.representativeId;
                if (_this.isCustomerRetail || _this.isLeadCustomer()) {
                    var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                    var currentAlias = urlParams[_features_config_9.aliasQueryParam];
                    var cookieAlias = _this.cookies.getCookie("webAlias");
                    if (_this.isValidAliasOrId(currentAlias)) {
                        customerIdOrAlias = currentAlias.trim();
                    } else if (_this.isValidAliasOrId(cookieAlias)) {
                        customerIdOrAlias = cookieAlias.trim();
                    } else {
                        _this.injectRepresentativeInfo.injectSponsorInfoToField("", "");
                        return;
                    }
                }
                if (!_this.isValidAliasOrId(customerIdOrAlias)) return;
                _this.getRepresentativeInfo({
                    customerIdOrAlias: customerIdOrAlias,
                    isOwnInfo: true
                }, _this.handleSponsorInfoResponse);
            };
            _this.getCustomerInformation = function() {
                var win = window;
                var info = win.customerPublic;
                _this.handleCustomerInfoResponse(info);
            };
            _this.handleCustomerInfoResponse = function(info) {
                var _a, _b;
                var targets = document.querySelectorAll(".st_customer-fullname_JS");
                if (!targets.length) return;
                if (!info) {
                    targets.forEach(function(t) {
                        return t.textContent = "";
                    });
                    return;
                }
                var firstName = info.firstName || info.first_name || info.FirstName || ((_a = info.customer) === null || _a === void 0 ? void 0 : _a.firstName) || "";
                var lastName = info.lastName || info.last_name || info.LastName || ((_b = info.customer) === null || _b === void 0 ? void 0 : _b.lastName) || "";
                var fullName = [ firstName, lastName ].filter(Boolean).join(" ").trim();
                targets.forEach(function(t) {
                    return t.textContent = fullName;
                });
            };
            _this.handleSponsorInfoResponse = function(response) {
                if (response.status === 200) {
                    var sponsorInfo = response.data;
                    _this.injectRepresentativeInfo.injectSponsorInfoToField(sponsorInfo.firstName, sponsorInfo.lastName);
                    _this.accountPersonalSite.createLinkWithRef(sponsorInfo.webAlias);
                    _this.accountPersonalSite.includePromoCode(sponsorInfo.webAlias);
                } else {
                    _this.injectRepresentativeInfo.injectSponsorInfoToField("", "");
                }
            };
            _this.isDataEqualToStored = function(repInfo) {
                return repInfo.webAlias === _this.cookies.getCookie("webAlias") && repInfo.firstName === _this.cookies.getCookie("firstName") && repInfo.lastName === _this.cookies.getCookie("lastName") && (repInfo.email || "") === (_this.cookies.getCookie("email") || "");
            };
            _this.updateCurrentRepInfo = function(repInfo) {
                var webAlias = repInfo.webAlias;
                var shouldUpdateBanner = false;
                if (!_this.isDataEqualToStored(repInfo)) {
                    _this.setRepresentativeCookies(repInfo);
                    shouldUpdateBanner = true;
                }
                if (!_this.isAliasEqualToUrlAlias(webAlias)) {
                    _this.setNewAliasInUrl(webAlias);
                    shouldUpdateBanner = true;
                }
                if (shouldUpdateBanner) {
                    try {
                        _this.injectRepresentativeInfo.injectToFields(repInfo);
                    } catch (e) {
                        console.warn("[WebAlias] injectToFields immediate failed:", e);
                    }
                }
                var callbackFired = false;
                var finalize = function() {
                    _this.searchSponsorGuard.toggleCantGoUnderCorporateSite(webAlias === _features_config_9.defaultWebAlias);
                    try {
                        _this.injectRepresentativeInfo.injectToFields(repInfo);
                    } catch (e) {
                        console.warn("[WebAlias] injectToFields finalize failed:", e);
                    }
                };
                try {
                    _this.cartComponent.updateCartItemsPropertiesCB(repInfo, function() {
                        callbackFired = true;
                        finalize();
                    });
                } catch (e) {
                    console.warn("[WebAlias] updateCartItemsPropertiesCB failed:", e);
                }
                window.setTimeout(function() {
                    if (!callbackFired) finalize();
                }, 1500);
            };
            _this.cartShouldUpdate = function(existingSponsorInfo, sponsorInfo) {
                var existingSponsorInfoObj;
                if (!!existingSponsorInfo) {
                    existingSponsorInfoObj = JSON.parse(existingSponsorInfo);
                }
                return !existingSponsorInfo || !!existingSponsorInfo && existingSponsorInfoObj["firstName"] !== sponsorInfo["firstName"] && existingSponsorInfoObj["lastName"] !== sponsorInfo["lastName"];
            };
            _this.nonExistentRepresentativeFlow = function() {
                if (!_this.isCustomerRetail && !_this.isLeadCustomer()) {
                    _this.injectDefaultRepInfo();
                    return;
                }
                _this.injectRepInfoFromCookie();
            };
            _this.injectRepInfoFromCookie = function() {
                var repInfo = {
                    firstName: _this.cookies.getCookie(_this.cookieNameFirstName),
                    lastName: _this.cookies.getCookie(_this.cookieNameLastName),
                    webAlias: _this.cookies.getCookie(_this.cookieNameWebAlias),
                    repId: _this.cookies.getCookie(_this.cookieNameRepId),
                    email: _this.cookies.getCookie(_this.cookieNameEmail)
                };
                var imageUrl = _this.cookies.getCookie(_this.cookieNameImageUrl);
                if (!!imageUrl && _features_config_9.additionalRepInfo) {
                    repInfo = __assign(__assign({}, repInfo), {
                        imageUrl: imageUrl
                    });
                }
                _this.updateCurrentRepInfo(repInfo);
            };
            _this.injectDefaultRepInfo = function() {
                var repInfo = {
                    webAlias: _features_config_9.defaultWebAlias,
                    firstName: _features_config_9.corporationName,
                    lastName: "",
                    email: _features_config_9.defaultEmail
                };
                if (_features_config_9.additionalRepInfo) {
                    repInfo = __assign(__assign({}, repInfo), {
                        imageUrl: _features_config_9.defaultCorporationImage
                    });
                }
                _this.updateCurrentRepInfo(repInfo);
            };
            _this.setRepresentativeCookies = function(repInfo) {
                _this.cookies.setCookies(_this.cookieNameWebAlias, repInfo.webAlias);
                _this.cookies.setCookies(_this.cookieNameRepId, repInfo.repId);
                _this.cookies.setCookies(_this.cookieNameFirstName, repInfo.firstName);
                _this.cookies.setCookies(_this.cookieNameLastName, repInfo.lastName);
                _this.cookies.setCookies(_this.cookieNameEmail, repInfo.email);
                if (_features_config_9.additionalRepInfo) {
                    _this.cookies.setCookies(_this.cookieNameImageUrl, repInfo.imageUrl);
                }
            };
            _this.applyRepresentativeSelection = function(data) {
                var repId = (data.repId || "").trim();
                var webAlias = (data.webAlias || repId).trim();
                if (!repId || !webAlias) return;
                try {
                    localStorage.setItem("repId", repId);
                } catch (error) {
                    console.warn("[WebAlias] Unable to save repId to localStorage", error);
                }
                var repInfo = {
                    repId: repId,
                    webAlias: webAlias,
                    firstName: data.firstName || "",
                    lastName: data.lastName || "",
                    email: data.email || "",
                    imageUrl: data.imageUrl || ""
                };
                _this.updateCurrentRepInfo(repInfo);
            };
            _this.shareCart = shareCart;
            return _this;
        }
        Object.defineProperty(StWebAliasExtended.prototype, "isOnCartPage", {
            get: function() {
                return window.location.pathname.includes("cart");
            },
            enumerable: false,
            configurable: true
        });
        StWebAliasExtended.prototype.isNonEmptyString = function(v) {
            return typeof v === "string" && v.trim().length > 0;
        };
        StWebAliasExtended.prototype.isValidAliasOrId = function(v) {
            if (!this.isNonEmptyString(v)) return false;
            var s = v.trim().toLowerCase();
            return s !== "null" && s !== "undefined";
        };
        StWebAliasExtended.prototype.fallbackAfterBadRepLookup = function() {
            var _a;
            var repIdMetafield = (_a = window === null || window === void 0 ? void 0 : window.customerInfoMetafields) === null || _a === void 0 ? void 0 : _a.representativeId;
            if (!this._fallbackTried && this.isValidAliasOrId(repIdMetafield)) {
                this._fallbackTried = true;
                this.getRepresentativeInfo({
                    customerIdOrAlias: repIdMetafield,
                    isOwnInfo: true
                }, this.handleRepresentativeInfoResponse);
                return;
            }
            this.nonExistentRepresentativeFlow();
        };
        return StWebAliasExtended;
    }(webalias_1.StWebAlias);
    exports.StWebAliasExtended = StWebAliasExtended;
});

define("extension/shopify-app/st-modules/cart/cart", [ "require", "exports", "core/shopify-app/st-modules/cart/cart" ], function(require, exports, cart_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCart = void 0;
    var StCart = function(_super) {
        __extends(StCart, _super);
        function StCart() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.className = "StCart";
            _this.clearCartDrawerButtonInitialized = false;
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.cartFetchInterceptorInit();
                    _this.cartBackForwardCacheFixInit();
                    _this.initClearCartDrawerButton();
                });
            };
            _this.initClearCartDrawerButton = function() {
                if (_this.clearCartDrawerButtonInitialized) {
                    return;
                }
                _this.clearCartDrawerButtonInitialized = true;
                document.addEventListener("click", function(event) {
                    var target = event.target;
                    var clearButton = target === null || target === void 0 ? void 0 : target.closest(".js-cart-clear");
                    if (!clearButton) {
                        return;
                    }
                    event.preventDefault();
                    clearButton.disabled = true;
                    clearButton.classList.add("is-loading");
                    _this.clearCartDrawerItems(clearButton);
                });
            };
            _this.clearCartDrawerItems = function(clearButton) {
                var _a;
                var cartDrawerItems = clearButton.closest("cart-drawer-items");
                var routes = window.routes;
                var fetchConfig = window.fetchConfig;
                var updates = _this.getClearCartUpdates();
                if (!cartDrawerItems || !(routes === null || routes === void 0 ? void 0 : routes.cart_update_url) || !fetchConfig || Object.keys(updates).length === 0) {
                    _this.clearCart(function(cartObj) {
                        _this.requestCartRefresh(cartObj);
                    });
                    return;
                }
                (_a = cartDrawerItems.enableLoading) === null || _a === void 0 ? void 0 : _a.call(cartDrawerItems, 1);
                _this.sendDrawerUpdateRequest(cartDrawerItems, updates, routes.cart_update_url, fetchConfig).catch(function(err) {
                    console.log("Clear Cart Drawer ---\x3e Error:", err);
                    _this.clearCart(function(cartObj) {
                        _this.requestCartRefresh(cartObj);
                    });
                }).finally(function() {
                    var _a;
                    (_a = cartDrawerItems.disableLoading) === null || _a === void 0 ? void 0 : _a.call(cartDrawerItems, 1);
                });
            };
            _this.getClearCartUpdates = function() {
                var cart = _this.getShopifyCartData;
                var updates = {};
                ((cart === null || cart === void 0 ? void 0 : cart.items) || []).forEach(function(item) {
                    if (item === null || item === void 0 ? void 0 : item.key) {
                        updates[item.key] = 0;
                    }
                });
                return updates;
            };
            _this.sendDrawerUpdateRequest = function(cartDrawerItems, updates, cartUpdateUrl, fetchConfig) {
                return fetch(cartUpdateUrl, __assign(__assign({}, fetchConfig()), {
                    body: JSON.stringify({
                        updates: updates,
                        sections: cartDrawerItems.getSectionsToRender().map(function(section) {
                            return section.section;
                        }),
                        sections_url: window.location.pathname
                    })
                })).then(function(response) {
                    return response.json();
                }).then(function(parsedState) {
                    var _a, _b, _c;
                    _this.renderDrawerSections(cartDrawerItems, parsedState);
                    (_b = (_a = window).publish) === null || _b === void 0 ? void 0 : _b.call(_a, (_c = window.PUB_SUB_EVENTS) === null || _c === void 0 ? void 0 : _c.cartUpdate, {
                        source: "cart-items"
                    });
                });
            };
            _this.renderDrawerSections = function(cartDrawerItems, parsedState) {
                var cartDrawer = document.querySelector("cart-drawer");
                cartDrawerItems.classList.toggle("is-empty", parsedState.item_count === 0);
                cartDrawer === null || cartDrawer === void 0 ? void 0 : cartDrawer.classList.toggle("is-empty", parsedState.item_count === 0);
                cartDrawerItems.getSectionsToRender().forEach(function(section) {
                    var sectionElement = document.getElementById(section.id);
                    var elementToReplace = (sectionElement === null || sectionElement === void 0 ? void 0 : sectionElement.querySelector(section.selector)) || sectionElement;
                    if (elementToReplace) {
                        elementToReplace.innerHTML = cartDrawerItems.getSectionInnerHTML(parsedState.sections[section.section], section.selector) || "";
                    }
                });
            };
            _this.updateCartAttributesWithPartyId = function(updateData, responseHandle) {
                try {
                    _this.ajax.send({
                        endpoint: _this.shopifyCartApiEndpoints["update-cart"],
                        method: "POST",
                        contentType: "json",
                        data: updateData,
                        callback: function(res) {
                            console.log("Party Id added");
                            _this.handleChangeCartResponseGenericNoRefresh(res, responseHandle);
                        }
                    });
                } catch (err) {
                    console.log("Update Cart ---\x3e Error:", err);
                }
            };
            _this.handleChangeCartResponseGenericNoRefresh = function(res, handleFunc) {
                try {
                    _this.getCart(function(cartObj) {
                        _this.handleChangeCartInterceptor(cartObj);
                        handleFunc(cartObj);
                    });
                } catch (err) {
                    console.log("handleChangeCartResponseGenericNoRefresh ---\x3e Error: ", err);
                }
            };
            _this.handleChangeCartResponseGeneric = function(res, handleFunc, cartRefresh) {
                if (handleFunc === void 0) {
                    handleFunc = function() {};
                }
                if (cartRefresh === void 0) {
                    cartRefresh = false;
                }
                try {
                    _this.getCart(function(cartObj) {
                        _this.setShopifyCartData(cartObj);
                        if (cartRefresh) {
                            _this.requestCartRefresh(cartObj);
                        }
                        _this.fireAllCallbacks(cartObj);
                        handleFunc(cartObj);
                    });
                } catch (err) {
                    console.log("handleChangeCartResponseGeneric ---\x3e Error: ", err);
                }
            };
            _this.overrideFreeSamples = function(chosenFreeSamplesList) {
                var freeSampleCollectionProducts = window.freeSampleCollectionProducts;
                var freeSamplesSkuList = [];
                freeSampleCollectionProducts.forEach(function(freeSample) {
                    freeSamplesSkuList.push(freeSample.variants[0].sku);
                });
                var cart = _this.getShopifyCartData;
                var cartItems = cart.items;
                var updateCartData = {
                    updates: {}
                };
                var addCartData = {
                    items: []
                };
                chosenFreeSamplesList.forEach(function(chosenFreeSample) {
                    addCartData.items.push({
                        id: chosenFreeSample.variantId,
                        quantity: chosenFreeSample.quantity,
                        properties: {
                            _isFreeSample: true
                        }
                    });
                });
                cartItems.forEach(function(lineItem, index) {
                    if (!freeSamplesSkuList.includes(lineItem.sku)) {
                        return;
                    }
                    if (lineItem.properties._isFreeSample) {
                        updateCartData.updates["".concat(lineItem.id)] = 0;
                    }
                });
                if (Object.keys(updateCartData.updates).length > 0) {
                    _this.updateCart(updateCartData, function(updatedCart) {
                        setTimeout(function() {
                            _this.addCart(addCartData, function(fullCart) {
                                sessionStorage.setItem("openCartAfterReload", "true");
                                window.location.reload(true);
                            });
                        }, 100);
                    });
                } else {
                    _this.addCart(addCartData, function(fullCart) {
                        sessionStorage.setItem("openCartAfterReload", "true");
                        window.location.reload(true);
                    });
                }
            };
            _this.removeFreeSamplesFromCart = function(shouldReload, afterUpdateCallback) {
                var freeSampleCollectionProducts = window.freeSampleCollectionProducts;
                if (!Array.isArray(freeSampleCollectionProducts) || freeSampleCollectionProducts.length === 0) {
                    if (!!afterUpdateCallback) afterUpdateCallback();
                    return;
                }
                var freeSamplesSkuList = [];
                freeSampleCollectionProducts.forEach(function(freeSample) {
                    freeSamplesSkuList.push(freeSample.variants[0].sku);
                });
                var cart = _this.getShopifyCartData;
                var cartItems = cart.items;
                var preparedItemsData = {
                    updates: {}
                };
                var shouldUpdate = false;
                cartItems.forEach(function(lineItem, index) {
                    if (freeSamplesSkuList.includes(lineItem.sku)) {
                        if (lineItem.properties._isFreeSample) {
                            preparedItemsData.updates["".concat(lineItem.id)] = 0;
                            shouldUpdate = true;
                        }
                    }
                });
                if (shouldUpdate) {
                    _this.updateCart(preparedItemsData, function(updatedCart) {
                        sessionStorage.setItem("openCartAfterReload", "true");
                        if (shouldReload) {
                            window.location.reload(true);
                        } else {
                            if (!!afterUpdateCallback) afterUpdateCallback();
                        }
                    });
                }
            };
            _this.updateCartItemsPropertiesCB = function(repInfo, responseHandle) {
                var attributes = {
                    sponsorInfo: {},
                    sponsorWebAlias: !!repInfo.webAlias ? repInfo.webAlias : ""
                };
                var sponsorInfo = {};
                sponsorInfo["firstName"] = !!repInfo.firstName ? repInfo.firstName : "";
                sponsorInfo["lastName"] = !!repInfo.lastName ? repInfo.lastName : "";
                sponsorInfo["sponsorWebAlias"] = !!repInfo.webAlias ? repInfo.webAlias : "";
                attributes.sponsorInfo = JSON.stringify(sponsorInfo);
                var updateAttributes = {
                    attributes: attributes
                };
                if (_this.doesShopifyCartDataContainNecessaryAttributes(attributes)) {
                    console.log("No update to cart for webAlias");
                    if (!!responseHandle) responseHandle();
                    return;
                }
                console.log("Update to cart for webAlias", updateAttributes);
                _this.updateCart(updateAttributes, function(cartRes) {
                    if (!!responseHandle) responseHandle(cartRes);
                });
            };
            _this.doesShopifyCartDataContainNecessaryAttributes = function(attributes) {
                var isSame = true;
                var currentCart = _this.getShopifyCartData.attributes;
                if (currentCart.sponsorWebAlias !== attributes.sponsorWebAlias) {
                    isSame = false;
                }
                if (currentCart.sponsorInfo !== attributes.sponsorInfo) {
                    isSame = false;
                }
                return isSame;
            };
            _this.addOrEditPropertiesForWebAlias = function(cartItems, alias, responseHandle) {
                var _a;
                var updateCartProperties = false;
                var item = {};
                var eligibleItems = cartItems.filter(function(item) {
                    var _a, _b;
                    if (_this.isManagedFreeItem(item)) {
                        return false;
                    }
                    var finalPrice = Number((_b = (_a = item === null || item === void 0 ? void 0 : item.final_price) !== null && _a !== void 0 ? _a : item === null || item === void 0 ? void 0 : item.price) !== null && _b !== void 0 ? _b : 0);
                    return Number.isFinite(finalPrice) && finalPrice > 0;
                });
                var itemWithProperties = eligibleItems.find(function(item) {
                    var _a;
                    return ((_a = item.properties) === null || _a === void 0 ? void 0 : _a._sponsorWebAlias) !== undefined;
                });
                var duplicateItem = eligibleItems.find(function(item) {
                    var _a;
                    return item.sku === (itemWithProperties === null || itemWithProperties === void 0 ? void 0 : itemWithProperties.sku) && ((_a = item.properties) === null || _a === void 0 ? void 0 : _a._sponsorWebAlias) === undefined;
                });
                if (!itemWithProperties && eligibleItems.length > 0) {
                    item = eligibleItems[eligibleItems.length - 1];
                    updateCartProperties = true;
                } else if (duplicateItem) {
                    item = duplicateItem;
                    updateCartProperties = true;
                } else if (itemWithProperties && ((_a = itemWithProperties.properties) === null || _a === void 0 ? void 0 : _a._sponsorWebAlias) !== alias) {
                    item = itemWithProperties;
                    updateCartProperties = true;
                }
                var refreshCart = !!duplicateItem;
                if (updateCartProperties) {
                    _this.updateItemProperties(item, alias, refreshCart);
                }
                if (!!responseHandle) responseHandle();
            };
            _this.isManagedFreeItem = function(item) {
                var _a, _b, _c, _d, _e, _f, _g;
                var sampleFlag = (_a = item === null || item === void 0 ? void 0 : item.properties) === null || _a === void 0 ? void 0 : _a._isFreeSample;
                var handle = String((item === null || item === void 0 ? void 0 : item.handle) || "").toLowerCase();
                var title = String((_c = (_b = item === null || item === void 0 ? void 0 : item.product_title) !== null && _b !== void 0 ? _b : item === null || item === void 0 ? void 0 : item.title) !== null && _c !== void 0 ? _c : "").trim().toLowerCase();
                var originalLinePrice = Number((_d = item === null || item === void 0 ? void 0 : item.original_line_price) !== null && _d !== void 0 ? _d : 0);
                var finalLinePrice = Number((_f = (_e = item === null || item === void 0 ? void 0 : item.final_line_price) !== null && _e !== void 0 ? _e : item === null || item === void 0 ? void 0 : item.line_price) !== null && _f !== void 0 ? _f : 0);
                var totalDiscount = Number((_g = item === null || item === void 0 ? void 0 : item.total_discount) !== null && _g !== void 0 ? _g : 0);
                return sampleFlag === true || sampleFlag === "true" || handle.includes("docapp-free-gift") || handle.includes("free-gift") || title.startsWith("free ") || originalLinePrice > 0 && finalLinePrice <= 0 || originalLinePrice > 0 && totalDiscount >= originalLinePrice;
            };
            return _this;
        }
        return StCart;
    }(cart_1.StCart);
    exports.StCart = StCart;
});

define("core/shopify-app/st-modules/enrollment-account/enrollment-account-repeat-password-validation", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_52) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentRepeatPasswordValidation = void 0;
    var StEnrollmentRepeatPasswordValidation = function(_super) {
        __extends(StEnrollmentRepeatPasswordValidation, _super);
        function StEnrollmentRepeatPasswordValidation(classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentRepeatPassword";
            _this.validateOnSite = function() {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentAccountPageWrp);
                var output = [];
                if (!!wrp) {
                    var inputs = wrp.querySelectorAll(_this.classConfig.selectorEnrollmentAccountRepeatPassword);
                    inputs.forEach(function(input) {
                        var fieldName = input.getAttribute("name");
                        var isValid = input.value === input.value;
                        output[fieldName] = {
                            isValid: isValid,
                            message: !isValid ? "Your passwords are not matching!" : ""
                        };
                    });
                }
                return output;
            };
            _this.classConfig = classConfig;
            return _this;
        }
        return StEnrollmentRepeatPasswordValidation;
    }(st_module_52.StModule);
    exports.StEnrollmentRepeatPasswordValidation = StEnrollmentRepeatPasswordValidation;
});

define("core/shopify-app/st-modules/account-register/account-register-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_53) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountRegisterClassConfig = void 0;
    var StAccountRegisterClassConfig = function(_super) {
        __extends(StAccountRegisterClassConfig, _super);
        function StAccountRegisterClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentAccountClassConfig";
            _this.classAccountRegisterForm = "st_account-register-form_JS";
            _this.selectorAccountRegisterForm = "." + _this.classAccountRegisterForm;
            _this.classAccountRegisterFormPreventDefault = "st_prevent-form-default_JS";
            _this.selectorAccountRegisterFormPreventDefault = "." + _this.classAccountRegisterFormPreventDefault;
            _this.classRepresentativeAlias = "st_representative-alias_JS";
            _this.selectorRepresentativeAlias = "." + _this.classRepresentativeAlias;
            _this.classRegisterPasswordInput = "st_register-password-input_JS";
            _this.selectorRegisterPasswordInput = "." + _this.classRegisterPasswordInput;
            return _this;
        }
        return StAccountRegisterClassConfig;
    }(st_module_53.StModule);
    exports.StAccountRegisterClassConfig = StAccountRegisterClassConfig;
});

define("core/shopify-app/st-modules/account-register/account-register", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification", "_features.config" ], function(require, exports, st_module_54, notification_8, _features_config_10) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountRegister = void 0;
    var StAccountRegister = function(_super) {
        __extends(StAccountRegister, _super);
        function StAccountRegister(form, notification, buttonActions, classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountRegister";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.form.liveTrim();
                    _this_1.onSubmit();
                    _this_1.formatPhoneNumber();
                });
            };
            _this_1.format = function(value) {
                var digits = value.replace(/\D/g, "").substring(0, 10);
                var len = digits.length;
                if (len <= 3) return digits;
                if (len <= 6) return "".concat(digits.slice(0, 3), "-").concat(digits.slice(3));
                return "".concat(digits.slice(0, 3), "-").concat(digits.slice(3, 6), "-").concat(digits.slice(6));
            };
            _this_1.formatPhoneNumber = function() {
                var phoneInput = document.querySelector(".lbr_crate-account-phone_JS");
                if (!phoneInput) return;
                phoneInput.addEventListener("input", function(e) {
                    var input = e.target;
                    var currentValue = input.value;
                    var formatted = _this_1.format(currentValue);
                    input.value = formatted;
                });
                phoneInput.addEventListener("keypress", function(e) {
                    if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                    }
                });
            };
            _this_1.onSubmit = function() {
                var _this = _this_1;
                var form = document.querySelector(_this_1.classConfig.selectorAccountRegisterForm);
                if (!!form) {
                    form.addEventListener("submit", function(e) {
                        _this.validateAccountCreation(this, e);
                    });
                }
            };
            _this_1.prepareErrorArray = function(validationData) {
                var validationDataKeys = Object.keys(validationData);
                var errorArray = [];
                validationDataKeys.forEach(function(key) {
                    if (!validationData[key].isValid) {
                        errorArray.push(validationData[key].message);
                    }
                });
                return errorArray;
            };
            _this_1.loginCustomer = function(formData) {
                var _this = _this_1;
                var loginPayload = {};
                loginPayload.form_type = "customer_login";
                loginPayload["customer[email]"] = formData.email;
                loginPayload["customer[password]"] = formData.password;
                _this.ajax.send({
                    endpoint: window.location.protocol + "//" + window.location.hostname + "/account/login",
                    method: "post",
                    contentType: "form",
                    data: loginPayload,
                    callback: function(response) {
                        try {
                            if (response.status == 200) {
                                var redirectUrlResponse = response.responseURL.toString();
                                if (redirectUrlResponse.includes("/account/login")) {
                                    window.location.reload();
                                    _this.revertSubmitButtonToDefault();
                                    _this.notification.showNotification(notification_8.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
                                } else {
                                    window.location.assign(redirectUrlResponse);
                                }
                            } else {
                                window.location.reload();
                                _this.revertSubmitButtonToDefault();
                                _this.notification.showNotification(notification_8.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.revertSubmitButtonToDefault();
                            _this.notification.showNotification(notification_8.ENotificationType.error, "Server Error", error);
                        }
                    }
                });
            };
            _this_1.registerCustomer = function(customerPayload) {
                var _this = _this_1;
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["enrollment"]["createAccount"],
                    method: "post",
                    contentType: "json",
                    data: customerPayload,
                    callback: function(response) {
                        try {
                            _this.loginCustomer(customerPayload);
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_8.ENotificationType.error, "Server Error", error);
                            _this.revertSubmitButtonToDefault();
                        }
                    }
                });
            };
            _this_1.validateAccountCreation = function(form, submitEvent) {
                var _this = _this_1;
                if (form.classList.contains(_this_1.classConfig.classAccountRegisterFormPreventDefault)) {
                    submitEvent.preventDefault();
                    var formData = _this.form.collectFormData(form);
                    var hiddenAlsInput = form.querySelector(_this_1.classConfig.selectorRepresentativeAlias);
                    if (!(hiddenAlsInput === null || hiddenAlsInput === void 0 ? void 0 : hiddenAlsInput.value) || !_features_config_10.canGoUnderCorporateSite && (hiddenAlsInput === null || hiddenAlsInput === void 0 ? void 0 : hiddenAlsInput.value) === _features_config_10.defaultWebAlias) {
                        _this.notification.showNotification(notification_8.ENotificationType.error, "Validation Error", "Web alias not entered or invalid");
                        _this.revertSubmitButtonToDefault();
                    } else {
                        var payload_1 = {
                            email: formData["customer[email]"],
                            firstName: formData["customer[first_name]"],
                            lastName: formData["customer[last_name]"],
                            password: formData["customer[password]"],
                            sponsorsWebAlias: formData["customer[note][sponsorWebAlias]"]
                        };
                        var passwordInputElement = document.querySelector('input[name="customer[password]"]');
                        var repeatPasswordInputElement = document.querySelector('input[name="repeatPassword"]');
                        if (passwordInputElement.value.length > 40) {
                            _this.notification.showNotification(notification_8.ENotificationType.error, "Validation Error", "Password cannot contain more than 40 characters!");
                            _this.revertSubmitButtonToDefault();
                        } else if (passwordInputElement.value === (repeatPasswordInputElement === null || repeatPasswordInputElement === void 0 ? void 0 : repeatPasswordInputElement.value) || !repeatPasswordInputElement) {
                            _this.ajax.send({
                                endpoint: _this.endpoint["enrollment"]["validate-data"],
                                method: "post",
                                contentType: "json",
                                data: payload_1,
                                callback: function(response) {
                                    try {
                                        var validationResponse = JSON.parse(response.response);
                                        var validationErrors = _this.prepareErrorArray(validationResponse.data);
                                        if (validationErrors.length !== 0) {
                                            _this.notification.showNotification(notification_8.ENotificationType.error, "Validation Error", validationErrors);
                                            _this.revertSubmitButtonToDefault();
                                        } else {
                                            _this.registerCustomer(payload_1);
                                        }
                                    } catch (error) {
                                        console.error(error);
                                        _this.notification.showNotification(notification_8.ENotificationType.error, "Server Error", error);
                                        _this.revertSubmitButtonToDefault();
                                    }
                                }
                            });
                        } else {
                            _this.notification.showNotification(notification_8.ENotificationType.error, "Validation Error", "Passwords not matching!");
                            _this.revertSubmitButtonToDefault();
                        }
                    }
                } else {
                    form.classList.add(_this.classConfig.classAccountRegisterFormPreventDefault);
                }
            };
            _this_1.revertSubmitButtonToDefault = function() {
                var submitBtn = document.querySelector('[type="submit"]');
                if (!!submitBtn) {
                    submitBtn.removeAttribute("aria-busy");
                }
            };
            _this_1.form = form;
            _this_1.notification = notification;
            _this_1.buttonActions = buttonActions;
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountRegister;
    }(st_module_54.StModule);
    exports.StAccountRegister = StAccountRegister;
});

define("extension/connector-app/market-type/models/generic.market.type.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("extension/shopify-app/st-modules/account-register/zipCodeValidation", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.isFiveDigitZip = exports.normalizeZip = void 0;
    var normalizeZip = function(value) {
        return value !== null && value !== void 0 ? value : "";
    };
    exports.normalizeZip = normalizeZip;
    var isFiveDigitZip = function(value) {
        return /^\d{5}$/.test(value);
    };
    exports.isFiveDigitZip = isFiveDigitZip;
});

define("extension/shopify-app/st-modules/account-register/account-register-extend", [ "require", "exports", "_features.config", "core/shopify-app/st-modules/_general-methods/notification", "core/shopify-app/st-modules/account-register/account-register" ], function(require, exports, _features_config_11, notification_9, account_register_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountRegisterExtended = void 0;
    var StAccountRegisterExtended = function(_super) {
        __extends(StAccountRegisterExtended, _super);
        function StAccountRegisterExtended(form, notification, buttonActions, classConfig, generalMethods) {
            var _this_1 = _super.call(this, form, notification, buttonActions, classConfig, generalMethods) || this;
            _this_1.className = "AccountRegisterExtended";
            _this_1.lastZipQueried = "";
            _this_1.pendingLookup = false;
            _this_1.zipDebounceTimer = null;
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.form.liveTrim();
                    _this_1.cacheAddress();
                    _this_1.disableSelects(true);
                    _this_1.bindZipHandlers();
                    _this_1.onSubmit();
                    _this_1.formatPhoneNumber();
                    _this_1.passwordListener();
                    _this_1.togglePassword();
                    _this_1.bindConfirmPasswordWatcher();
                });
            };
            _this_1.cacheAddress = function() {
                _this_1.zipInput = document.querySelector("#RegisterForm-ZipCode");
                _this_1.street1Input = document.querySelector("#RegisterForm-StreetAddress");
                _this_1.citySelect = document.querySelector("#RegisterForm-City");
                _this_1.stateSelect = document.querySelector("#RegisterForm-State");
                _this_1.countySelect = document.querySelector("#RegisterForm-County");
            };
            _this_1.t = function(key) {
                try {
                    var translations = window.stTranslations || {};
                    var value = translations[key];
                    return typeof value === "string" ? value : "";
                } catch (_a) {
                    return "";
                }
            };
            _this_1.disableSelects = function(hardClear) {
                if (hardClear === void 0) {
                    hardClear = false;
                }
                [ _this_1.stateSelect, _this_1.citySelect, _this_1.countySelect ].forEach(function(selectElement) {
                    if (!selectElement) return;
                    selectElement.disabled = true;
                    if (hardClear) {
                        var placeholderStateLabel = _this_1.t("selectState");
                        var placeholderCityLabel = _this_1.t("selectCity");
                        var placeholderCountyLabel = _this_1.t("selectCounty");
                        selectElement.innerHTML = "";
                        var placeholderOption = document.createElement("option");
                        placeholderOption.value = "";
                        placeholderOption.disabled = true;
                        placeholderOption.selected = true;
                        placeholderOption.textContent = selectElement.id.includes("State") ? placeholderStateLabel : selectElement.id.includes("City") ? placeholderCityLabel : placeholderCountyLabel;
                        selectElement.appendChild(placeholderOption);
                    }
                });
            };
            _this_1.enableSelects = function() {
                [ _this_1.stateSelect, _this_1.citySelect, _this_1.countySelect ].forEach(function(selectElement) {
                    if (!selectElement) return;
                    selectElement.disabled = false;
                });
            };
            _this_1.onZipInputDebounced = function() {
                if (_this_1.zipDebounceTimer) window.clearTimeout(_this_1.zipDebounceTimer);
                _this_1.zipDebounceTimer = window.setTimeout(function() {
                    _this_1.onZipChanged();
                }, 150);
            };
            _this_1.bindZipHandlers = function() {
                if (!_this_1.zipInput) return;
                _this_1.zipInput.addEventListener("change", _this_1.onZipChanged);
                _this_1.zipInput.addEventListener("blur", _this_1.onZipChanged);
                _this_1.zipInput.addEventListener("keyup", function(e) {
                    if (e.key === "Enter") _this_1.onZipChanged();
                });
                _this_1.zipInput.addEventListener("input", _this_1.onZipChanged);
                _this_1.zipInput.addEventListener("paste", function() {
                    setTimeout(_this_1.onZipChanged, 0);
                });
            };
            _this_1.onZipChanged = function() {
                if (!_this_1.zipInput) return;
                var zip = _this_1.getNormalizedZipFromInput();
                if (_this_1.shouldSkipZipLookup(zip)) return;
                _this_1.pendingLookup = true;
                _this_1.disableSelects(false);
                _this_1.performPostalLookup(zip).then(function(data) {
                    return _this_1.applyPostalData(zip, data);
                }).catch(function() {
                    return _this_1.handleZipLookupError();
                }).finally(function() {
                    return _this_1.finalizeZipLookup();
                });
            };
            _this_1.getNormalizedZipFromInput = function() {
                var _a;
                return _this_1.zipInput ? (_a = _this_1.zipInput.value) !== null && _a !== void 0 ? _a : "" : "";
            };
            _this_1.isSelectPopulated = function(sel) {
                return !sel ? true : !sel.disabled && sel.options.length > 1;
            };
            _this_1.areAddressSelectsPopulated = function() {
                return [ _this_1.stateSelect, _this_1.citySelect, _this_1.countySelect ].every(_this_1.isSelectPopulated);
            };
            _this_1.shouldSkipZipLookup = function(zip) {
                if (_this_1.pendingLookup) return true;
                var sameZip = zip === _this_1.lastZipQueried;
                var selectsReady = _this_1.areAddressSelectsPopulated();
                return sameZip && selectsReady;
            };
            _this_1.performPostalLookup = function(zip) {
                return _this_1.getGeoCodeAddresses(zip);
            };
            _this_1.applyPostalData = function(zip, data) {
                _this_1.lastZipQueried = zip;
                _this_1.populateSelect(_this_1.stateSelect, (data === null || data === void 0 ? void 0 : data.States) || [], _this_1.t("selectState"));
                _this_1.populateSelect(_this_1.citySelect, (data === null || data === void 0 ? void 0 : data.Cities) || [], _this_1.t("selectCity"));
                _this_1.populateSelect(_this_1.countySelect, (data === null || data === void 0 ? void 0 : data.Counties) || [], _this_1.t("selectCounty"));
                _this_1.autoSelectIfSingle(_this_1.stateSelect);
                _this_1.autoSelectIfSingle(_this_1.citySelect);
                _this_1.autoSelectIfSingle(_this_1.countySelect);
                _this_1.enableSelects();
            };
            _this_1.handleZipLookupError = function() {
                _this_1.disableSelects(true);
            };
            _this_1.finalizeZipLookup = function() {
                _this_1.pendingLookup = false;
            };
            _this_1.populateSelect = function(selectElement, items, placeholderLabel) {
                if (!selectElement) return;
                var previousValue = selectElement.value;
                selectElement.innerHTML = "";
                var placeholderOption = document.createElement("option");
                placeholderOption.value = "";
                placeholderOption.disabled = true;
                placeholderOption.selected = true;
                placeholderOption.textContent = placeholderLabel;
                selectElement.appendChild(placeholderOption);
                items.forEach(function(itemValue) {
                    var optionElement = document.createElement("option");
                    optionElement.value = itemValue;
                    optionElement.textContent = itemValue;
                    selectElement.appendChild(optionElement);
                });
                var canRestore = Array.from(selectElement.options).some(function(option) {
                    return option.value === previousValue;
                });
                if (canRestore) selectElement.value = previousValue;
            };
            _this_1.autoSelectIfSingle = function(selectElement) {
                if (!selectElement) return;
                var nonEmptyOptions = Array.from(selectElement.options).filter(function(option) {
                    return option.value !== "";
                });
                if (nonEmptyOptions.length === 1) selectElement.value = nonEmptyOptions[0].value;
            };
            _this_1.getGeoCodeAddresses = function(postalCode) {
                return new Promise(function(resolve, reject) {
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["customer"]["postal-code"],
                        method: "post",
                        contentType: "json",
                        data: {
                            postalCode: postalCode
                        },
                        callback: function(response) {
                            try {
                                var parsed = typeof response.response === "string" ? JSON.parse(response.response) : response.response;
                                var payload = (parsed === null || parsed === void 0 ? void 0 : parsed.data) ? parsed.data : parsed;
                                resolve(payload);
                            } catch (e) {
                                reject(e);
                            }
                        }
                    });
                });
            };
            _this_1.setProgress = function(msg) {
                var row = document.querySelector(".lbri_registration_progress_JS");
                var txt = document.querySelector(".lbri_registration_progress_text_JS");
                if (!row || !txt) return;
                txt.textContent = msg;
                row.classList.remove("st_hidden");
            };
            _this_1.clearProgress = function() {
                var row = document.querySelector(".lbri_registration_progress_JS");
                var txt = document.querySelector(".lbri_registration_progress_text_JS");
                if (!row || !txt) return;
                txt.textContent = "";
                row.classList.add("st_hidden");
            };
            _this_1.validateAccountCreation = function(form, submitEvent) {
                var _this = _this_1;
                _this_1.confirmPasswordValidation();
                if (form.classList.contains(_this_1.classConfig.classAccountRegisterFormPreventDefault)) {
                    submitEvent.preventDefault();
                    var validatingMessage = _this_1.t("loaderMsg1");
                    _this_1.setProgress(validatingMessage);
                    _this_1.toggleLoader(true, validatingMessage);
                    var formData = _this.form.collectFormData(form);
                    var hiddenAlsInput = form.querySelector(_this_1.classConfig.selectorRepresentativeAlias);
                    if (!(hiddenAlsInput === null || hiddenAlsInput === void 0 ? void 0 : hiddenAlsInput.value) || !_features_config_11.canGoUnderCorporateSite && (hiddenAlsInput === null || hiddenAlsInput === void 0 ? void 0 : hiddenAlsInput.value) === _features_config_11.defaultWebAlias) {
                        _this.notification.showNotification(notification_9.ENotificationType.error, "Validation Error", "Web alias not entered or invalid");
                        _this.revertSubmitButtonToDefault();
                        _this.clearProgress();
                        _this.toggleLoader(false);
                    } else {
                        var payload_2 = {
                            email: formData["customer[email]"],
                            firstName: formData["customer[first_name]"],
                            lastName: formData["customer[last_name]"],
                            phone: formData["customer[phone]"],
                            password: formData["customer[password]"],
                            repeatPassword: formData["customer[password_confirmation]"],
                            sponsorsWebAlias: formData["customer[note][sponsorWebAlias]"],
                            referralMarketType: formData["customer[note][referralMarketTypeID]"],
                            referralMarketTypeInput: formData["customer[note][referralMarketTypeInput]"],
                            streetAddress: (formData["customer[note][streetAddress]"] || "").toString().trim(),
                            streetAddress2: (formData["customer[note][streetAddress2]"] || "").toString().trim(),
                            city: (formData["customer[note][city]"] || "").toString().trim(),
                            state: (formData["customer[note][state]"] || "").toString().trim(),
                            zipCode: (formData["customer[note][zipCode]"] || "").toString().trim(),
                            county: (formData["customer[note][county]"] || "").toString().trim(),
                            country: (formData["customer[note][country]"] || "").toString().trim()
                        };
                        var passwordInputElement = document.querySelector('input[name="customer[password]"]');
                        var repeatPasswordInputElement = document.querySelector('input[name="repeatPassword"]');
                        if (passwordInputElement.value.length > 40) {
                            _this.notification.showNotification(notification_9.ENotificationType.error, "Validation Error", "Password cannot contain more than 40 characters!");
                            _this.revertSubmitButtonToDefault();
                            _this.clearProgress();
                            _this.toggleLoader(false);
                        } else if (passwordInputElement.value === (repeatPasswordInputElement === null || repeatPasswordInputElement === void 0 ? void 0 : repeatPasswordInputElement.value) || !repeatPasswordInputElement) {
                            _this.ajax.send({
                                endpoint: _this.endpoint["enrollment"]["validate-data"],
                                method: "post",
                                contentType: "json",
                                data: payload_2,
                                callback: function(response) {
                                    try {
                                        var validationResponse = JSON.parse(response.response);
                                        var validationErrors = _this.prepareErrorArray(validationResponse.data);
                                        if (validationErrors.length !== 0) {
                                            _this.notification.showNotification(notification_9.ENotificationType.error, "Validation Error", validationErrors);
                                            _this.toggleLoader(false);
                                            _this.revertSubmitButtonToDefault();
                                            _this.clearProgress();
                                        } else {
                                            var creatingMsg = _this.t("loaderMsg1");
                                            _this.setProgress(creatingMsg);
                                            _this.toggleLoader(true, creatingMsg);
                                            _this.registerCustomer(payload_2);
                                            var msg2 = _this.t("loaderMsg2");
                                            _this.setProgress(msg2);
                                        }
                                    } catch (error) {
                                        console.error(error);
                                        _this.notification.showNotification(notification_9.ENotificationType.error, "Server Error", error);
                                        _this.revertSubmitButtonToDefault();
                                        _this.toggleLoader(false);
                                        _this.clearProgress();
                                    }
                                }
                            });
                        } else {
                            _this.notification.showNotification(notification_9.ENotificationType.error, "Validation Error", "Passwords not matching!");
                            _this.revertSubmitButtonToDefault();
                            _this.toggleLoader(false);
                            _this.clearProgress();
                        }
                    }
                } else {
                    form.classList.add(_this.classConfig.classAccountRegisterFormPreventDefault);
                    _this.toggleLoader(false);
                    _this.clearProgress();
                }
            };
            _this_1.confirmPasswordValidation = function() {
                var password = document.querySelector(".st_register-password-input_JS");
                var confirmation = document.querySelector(".st_register-repeat-password_JS");
                var errorMsg = document.getElementById("error-msg");
                if (!password || !confirmation || !errorMsg) return;
                var pass = (password.value || "").trim();
                var rep = (confirmation.value || "").trim();
                if (rep.length === 0) {
                    errorMsg.textContent = "";
                    errorMsg.classList.add("st_hidden");
                    return;
                }
                if (pass !== rep) {
                    errorMsg.textContent = "Passwords do not match.";
                    errorMsg.classList.remove("st_hidden");
                } else {
                    errorMsg.textContent = "";
                    errorMsg.classList.add("st_hidden");
                }
            };
            _this_1.validatePassword = function(password) {
                var regex = /^.{5,40}$/;
                return regex.test(password);
            };
            _this_1.passwordListener = function() {
                var _this = _this_1;
                var passwordInput = document.querySelector(".st_register-password-input_JS");
                var errorMsg = document.querySelector("#error-msg-pass");
                if (!passwordInput) return;
                passwordInput.addEventListener("input", function() {
                    var currentPassword = passwordInput.value;
                    var isValid = _this.validatePassword(currentPassword);
                    if (!isValid) {
                        errorMsg.innerHTML = '\n                    <div style="display: flex; align-items: center; color: red; font-weight: 500; margin-bottom: 5px; font-size: 16px;">\n                      <span style="margin-right: 5px;">\n                        <svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg">\n                        <path d="M2 21C1.45 21 0.979167 20.8042 0.5875 20.4125C0.195833 20.0208 0 19.55 0 19V9C0 8.45 0.195833 7.97917 0.5875 7.5875C0.979167 7.19583 1.45 7 2 7H3V5C3 3.61667 3.4875 2.4375 4.4625 1.4625C5.4375 0.4875 6.61667 0 8 0C9.38333 0 10.5625 0.4875 11.5375 1.4625C12.5125 2.4375 13 3.61667 13 5V7H14C14.55 7 15.0208 7.19583 15.4125 7.5875C15.8042 7.97917 16 8.45 16 9V19C16 19.55 15.8042 20.0208 15.4125 20.4125C15.0208 20.8042 14.55 21 14 21H2ZM2 19H14V9H2V19ZM8 16C8.55 16 9.02083 15.8042 9.4125 15.4125C9.80417 15.0208 10 14.55 10 14C10 13.45 9.80417 12.9792 9.4125 12.5875C9.02083 12.1958 8.55 12 8 12C7.45 12 6.97917 12.1958 6.5875 12.5875C6.19583 12.9792 6 13.45 6 14C6 14.55 6.19583 15.0208 6.5875 15.4125C6.97917 15.8042 7.45 16 8 16ZM5 7H11V5C11 4.16667 10.7083 3.45833 10.125 2.875C9.54167 2.29167 8.83333 2 8 2C7.16667 2 6.45833 2.29167 5.875 2.875C5.29167 3.45833 5 4.16667 5 5V7Z" fill="#FF0202"/>\n                        </svg>\n                      </span> \n                      Your password:\n                    </div>\n                    \n                    <div style="border: 1px solid red; padding: 10px 15px; display: flex; max-width: 600px;">\n                      <div>\n                        <ul style="padding-left: 14px; margin: 0; font-size: 12px; color: black; text-align: left; list-style-type: disc;">\n                          <li>Must be at least 5 characters, no more than 40.</li>\n                        </ul>\n                      </div>\n                    </div>\n      ';
                    } else {
                        errorMsg.innerHTML = "";
                    }
                });
            };
            _this_1.togglePassword = function() {
                var inputs = Array.from(document.querySelectorAll(".lbri_login-password-input_JS, .st_register-password-input_JS, .st_register-repeat-password_JS"));
                inputs.forEach(function(input) {
                    var wrapper = input.closest("label.form__field.lbri-input") || input.parentElement;
                    if (!wrapper) return;
                    var btn = wrapper.querySelector(".lbri_toggle-password-visibility-button_JS");
                    if (!btn) return;
                    if (btn._lbriBound === "1") return;
                    btn._lbriBound = "1";
                    if (getComputedStyle(wrapper).position === "static") {
                        wrapper.style.position = "relative";
                    }
                    btn.addEventListener("click", function(e) {
                        e.preventDefault();
                        var isPassword = input.getAttribute("type") === "password";
                        input.setAttribute("type", isPassword ? "text" : "password");
                        btn.classList.toggle("lbri_password-visible", isPassword);
                        btn.setAttribute("aria-pressed", isPassword ? "true" : "false");
                        btn.setAttribute("aria-label", isPassword ? "Hide password" : "Show password");
                        input.focus();
                    });
                });
            };
            _this_1.bindConfirmPasswordWatcher = function() {
                var password = document.querySelector(".st_register-password-input_JS");
                var confirmation = document.querySelector(".st_register-repeat-password_JS");
                var errorMsg = document.getElementById("error-msg");
                if (!password || !confirmation || !errorMsg) return;
                var handler = function() {
                    return _this_1.confirmPasswordValidation();
                };
                password.addEventListener("input", handler);
                confirmation.addEventListener("input", handler);
                password.addEventListener("blur", handler);
                confirmation.addEventListener("blur", handler);
            };
            _this_1.loginCustomer = function(formData) {
                var _this = _this_1;
                _this.ajax.send({
                    endpoint: _this.endpoint["customer"]["customer-login"],
                    method: "post",
                    contentType: "json",
                    data: {
                        emailOrId: formData.email,
                        password: formData.password,
                        loginAsRetail: true
                    },
                    callback: function(resp) {
                        var _a;
                        try {
                            var payload = (resp === null || resp === void 0 ? void 0 : resp.responseText) ? JSON.parse(resp.responseText) : resp;
                            if ((payload === null || payload === void 0 ? void 0 : payload.status) === 200 && ((_a = payload === null || payload === void 0 ? void 0 : payload.data) === null || _a === void 0 ? void 0 : _a.url)) {
                                window.location.assign(payload.data.url);
                                return;
                            }
                            _this.revertSubmitButtonToDefault();
                            _this.notification.showNotification(notification_9.ENotificationType.error, "Login failed", (payload === null || payload === void 0 ? void 0 : payload.message) || "Incorrect email or password.", 3e3, false);
                        } catch (e) {
                            console.error(e);
                            _this.revertSubmitButtonToDefault();
                            _this.notification.showNotification(notification_9.ENotificationType.error, "Server Error", "Unexpected response from login endpoint.");
                        }
                    }
                });
            };
            _this_1.form = form;
            _this_1.notification = notification;
            _this_1.buttonActions = buttonActions;
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        StAccountRegisterExtended.prototype.toggleLoader = function(show, message) {
            var loader = document.querySelector(".lbri_registration_loader_JS");
            var submitBtn = loader === null || loader === void 0 ? void 0 : loader.closest("button");
            var createAccountDiv = document.querySelector(".lbri_registration_login_link_JS");
            if (!loader) return;
            if (show) {
                loader === null || loader === void 0 ? void 0 : loader.classList.remove("st_hidden");
                submitBtn && (submitBtn.disabled = true);
                submitBtn === null || submitBtn === void 0 ? void 0 : submitBtn.classList.add("opacity-50", "cursor-not-allowed");
                if (createAccountDiv) {
                    createAccountDiv.style.pointerEvents = "none";
                    createAccountDiv.style.opacity = "0.5";
                }
                if (message) this.setProgress(message);
            } else {
                loader === null || loader === void 0 ? void 0 : loader.classList.add("st_hidden");
                if (createAccountDiv) {
                    createAccountDiv.style.pointerEvents = "auto";
                    createAccountDiv.style.opacity = "1";
                }
                submitBtn && (submitBtn.disabled = false);
                submitBtn === null || submitBtn === void 0 ? void 0 : submitBtn.classList.remove("opacity-50", "cursor-not-allowed");
            }
        };
        return StAccountRegisterExtended;
    }(account_register_1.StAccountRegister);
    exports.StAccountRegisterExtended = StAccountRegisterExtended;
});

define("core/shopify-app/st-modules/main/auto-apply-promo", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config", "_features.config" ], function(require, exports, st_module_55, _features_config_12, _features_config_13) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAutoApplyPromo = void 0;
    var StAutoApplyPromo = function(_super) {
        __extends(StAutoApplyPromo, _super);
        function StAutoApplyPromo() {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AutoApplyPromo";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    var _a, _b;
                    var promoCode = (_b = (_a = window.stAppConfig) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.repPromoCode;
                    if (promoCode) {
                        _this_1.setupRepDiscount(promoCode);
                        _this_1.removeCodeOnLogout(promoCode);
                        if (_features_config_13.shareRefCodeFunctionality) {
                            _this_1.applyRefPromoCode();
                        }
                    }
                });
            };
            _this_1.setupRepDiscount = function(promoCode) {
                var _a, _b;
                document.cookie = "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                var repType = (_b = (_a = window.stAppConfig.options) === null || _a === void 0 ? void 0 : _a.customerType) === null || _b === void 0 ? void 0 : _b.representative;
                var currentCustomerType = window.customerInfoMetafields.customerType;
                if (currentCustomerType === repType && _features_config_12.repDiscountWithPromoCode) {
                    _this_1.applyPromoCodeIfNeeded(promoCode);
                }
            };
            _this_1.applyRefPromoCode = function() {
                document.cookie = "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                var refCode = localStorage.getItem("ref");
                if (!!refCode || refCode !== "null") {
                    _this_1.applyPromoCodeIfNeeded(refCode);
                }
            };
            _this_1.applyPromoCodeIfNeeded = function(promoCode) {
                if (!_this_1.isRepPromoApplied(promoCode)) {
                    var body = document.querySelector("body");
                    var iframeHolder = document.createElement("div");
                    iframeHolder.classList.add("st-autoapply-promocode");
                    var iframe = document.createElement("iframe");
                    iframe.classList.add("st_hidden");
                    iframe.src = "".concat(window.location.origin, "/discount/").concat(promoCode);
                    iframeHolder.appendChild(iframe);
                    body.insertBefore(iframeHolder, body.firstChild);
                }
            };
            _this_1.isRepPromoApplied = function(promoCode) {
                var alreadyApplied = false;
                var x = document.cookie.split("; ");
                for (var i = 0; i < x.length; i++) {
                    var c = x[i].split("=");
                    if (c[0] === "discount_code" || c[0] === "discount_code" && c[1] === promoCode) {
                        alreadyApplied = true;
                        break;
                    }
                }
                return alreadyApplied;
            };
            _this_1.removeCodeOnLogout = function(promoCode) {
                var _this = _this_1;
                var logoutLinks = document.querySelectorAll('[href*="account/logout"]');
                logoutLinks.forEach(function(logoutLink) {
                    logoutLink.addEventListener("click", function(e) {
                        if (_this.isRepPromoApplied(promoCode)) {
                            document.cookie = "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                        }
                    });
                });
            };
            return _this_1;
        }
        return StAutoApplyPromo;
    }(st_module_55.StModule);
    exports.StAutoApplyPromo = StAutoApplyPromo;
});

define("core/shopify-app/st-modules/representative-redirect-page/representative-redirect-page-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_56) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StRepresentativeRedirectClassConfig = void 0;
    var StRepresentativeRedirectClassConfig = function(_super) {
        __extends(StRepresentativeRedirectClassConfig, _super);
        function StRepresentativeRedirectClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "representativeRedirectClassConfig";
            _this.classNameRepRedirectCopyText = "st_copy-repsite_JS";
            _this.selectorRepRedirectIconCopyText = "." + _this.classNameRepRedirectCopyText;
            _this.classNameRepRedirectCopyTextWrapper = "st_copy-repsite--wrapper_JS";
            _this.selectorRepRedirectCopyTextWrapper = "." + _this.classNameRepRedirectCopyTextWrapper;
            _this.classNameRepRedirectLabel = "st_representative-site_JS";
            _this.selectorRepRedirectLabel = "." + _this.classNameRepRedirectLabel;
            return _this;
        }
        return StRepresentativeRedirectClassConfig;
    }(st_module_56.StModule);
    exports.StRepresentativeRedirectClassConfig = StRepresentativeRedirectClassConfig;
});

define("core/shopify-app/st-modules/representative-redirect-page/representative-redirect-page", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_57) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StRepresentativeRedirectPage = void 0;
    var StRepresentativeRedirectPage = function(_super) {
        __extends(StRepresentativeRedirectPage, _super);
        function StRepresentativeRedirectPage(classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "RepresentativeRedirectPage";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.copyToClipboard();
                });
            };
            _this_1.copyToClipboard = function() {
                var _this = _this_1;
                var copyRepSiteButtonAll = document.querySelectorAll(_this_1.classConfig.selectorRepRedirectIconCopyText);
                if (copyRepSiteButtonAll && copyRepSiteButtonAll.length > 0) {
                    for (var i = 0; i < copyRepSiteButtonAll.length; i++) {
                        var copyRepSiteButton = copyRepSiteButtonAll[i];
                        copyRepSiteButton.addEventListener("click", function(e) {
                            e.preventDefault();
                            var copyText = document.querySelector(_this.classConfig.selectorRepRedirectLabel);
                            if (!!copyText) {
                                var copyText_1 = document.querySelector(_this.classConfig.selectorRepRedirectLabel);
                                copyText_1.select();
                                copyText_1.setSelectionRange(0, 99999);
                                navigator.clipboard.writeText(copyText_1.value);
                                copyText_1.style.backgroundColor = "rgb(217, 218, 220)";
                                copyText_1.style.transition = "0.5s";
                                setTimeout(function() {
                                    copyText_1.style.backgroundColor = "rgb(249, 249, 249)";
                                    copyText_1.style.transition = "0.5s";
                                }, 1e3);
                            }
                        });
                    }
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StRepresentativeRedirectPage;
    }(st_module_57.StModule);
    exports.StRepresentativeRedirectPage = StRepresentativeRedirectPage;
});

define("core/shopify-app/st-modules/account-login/account-login-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_58) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountLoginClassConfig = void 0;
    var StAccountLoginClassConfig = function(_super) {
        __extends(StAccountLoginClassConfig, _super);
        function StAccountLoginClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentAccountClassConfig";
            _this.classLoginPasswordInput = "st_login-password-input_JS";
            _this.selectorLoginPasswordInput = "." + _this.classLoginPasswordInput;
            _this.classLoginPasswordFormControl = "st_login-password-form-control_JS";
            _this.selectorLoginPasswordFormControl = "." + _this.classLoginPasswordFormControl;
            return _this;
        }
        return StAccountLoginClassConfig;
    }(st_module_58.StModule);
    exports.StAccountLoginClassConfig = StAccountLoginClassConfig;
});

define("core/shopify-app/st-modules/account-login/account-login", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_59) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountLogin = void 0;
    var StAccountLogin = function(_super) {
        __extends(StAccountLogin, _super);
        function StAccountLogin(form, notification, buttonActions, classConfig, generalMethods) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "AccountLogin";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.form.liveTrim();
                });
            };
            _this.form = form;
            _this.notification = notification;
            _this.buttonActions = buttonActions;
            _this.classConfig = classConfig;
            _this.generalMethods = generalMethods;
            return _this;
        }
        return StAccountLogin;
    }(st_module_59.StModule);
    exports.StAccountLogin = StAccountLogin;
});

define("core/shopify-app/st-modules/reset-password/reset-password-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_60) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StResetPasswordClassConfig = void 0;
    var StResetPasswordClassConfig = function(_super) {
        __extends(StResetPasswordClassConfig, _super);
        function StResetPasswordClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ResetPasswordClassConfig";
            _this.classLoginPasswordInput = "st_reset-password-input_JS";
            _this.selectorLoginPasswordInput = "." + _this.classLoginPasswordInput;
            return _this;
        }
        return StResetPasswordClassConfig;
    }(st_module_60.StModule);
    exports.StResetPasswordClassConfig = StResetPasswordClassConfig;
});

define("core/shopify-app/st-modules/reset-password/reset-password", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_61) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StResetPassword = void 0;
    var StResetPassword = function(_super) {
        __extends(StResetPassword, _super);
        function StResetPassword(form, notification, buttonActions, classConfig, generalMethods) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ResetPassword";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.form.liveTrim();
                });
            };
            _this.form = form;
            _this.notification = notification;
            _this.buttonActions = buttonActions;
            _this.classConfig = classConfig;
            _this.generalMethods = generalMethods;
            return _this;
        }
        return StResetPassword;
    }(st_module_61.StModule);
    exports.StResetPassword = StResetPassword;
});

define("core/shopify-app/st-modules/referral/referral", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification", "_features.config" ], function(require, exports, st_module_62, notification_10, _features_config_14) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StReferral = void 0;
    var StReferral = function(_super) {
        __extends(StReferral, _super);
        function StReferral(generalMethods, objectFormatting, notification) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "Referral";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.checkTags();
                    _this_1.handlerRefBanner();
                });
            };
            _this_1.checkTags = function() {
                if (_features_config_14.shareRefCodeFunctionality) {
                    var customerTagsWrapper = document.querySelector(".st_customer-tags");
                    if (!!customerTagsWrapper) {
                        var tags = customerTagsWrapper.getAttribute("data-tags");
                        var isLogged = customerTagsWrapper.getAttribute("data-customer-id");
                        var splitStr = tags.split(",");
                        var retail = splitStr.find(function(ret) {
                            return ret.includes("retail");
                        });
                        var noOrder = splitStr.find(function(el) {
                            return el.includes("no_order");
                        });
                        if (isLogged) {
                            if (retail && noOrder) {
                                _this_1.getRefFromLink();
                                _this_1.setRefInLink();
                            } else {
                                _this_1.deleteRefCode();
                            }
                        } else {
                            _this_1.getRefFromLink();
                            _this_1.setRefInLink();
                        }
                    }
                } else {
                    _this_1.deleteRefCode();
                    _this_1.hideRef();
                }
            };
            _this_1.getRefFromLink = function() {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var ref = urlParams.ref;
                if (!!ref) {
                    localStorage.setItem("ref", ref);
                }
            };
            _this_1.getCode = function() {
                var tagFromNav = document.querySelector(".st_referral-code-div_JS");
                if (!!tagFromNav) {
                    return tagFromNav.getAttribute("data-customer-tags");
                }
            };
            _this_1.setRefInLink = function() {
                var refCode = localStorage.getItem("ref");
                var refCodeFromTag = _this_1.getCode();
                if (!refCode || refCode === "null" || refCode === " " || refCode === "undefined" || refCode === "") {
                    _this_1.deleteRefCode();
                } else {
                    if (refCode === refCodeFromTag) {
                        _this_1.deleteRefCode();
                    } else {
                        var params = new URLSearchParams(window.location.search);
                        if (!params.get("ref")) {
                            params.append("ref", refCode);
                        }
                        var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + params;
                        window.history.replaceState({
                            path: newUrl
                        }, "", newUrl);
                    }
                }
            };
            _this_1.deleteRefCode = function() {
                var params = new URLSearchParams(window.location.search);
                params.delete("ref");
                var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
                if (!!params.toString()) {
                    newUrl += "?" + params;
                }
                window.history.replaceState({
                    path: newUrl
                }, "", newUrl);
                localStorage.removeItem("ref");
            };
            _this_1.handlerRefBanner = function() {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var ref = urlParams.ref;
                if (_features_config_14.shareRefCodeFunctionality) {
                    if (!!ref) {
                        _this_1.getReferralsData();
                    } else {
                        _this_1.hideRef();
                    }
                } else {
                    _this_1.hideRef();
                }
            };
            _this_1.showRef = function() {
                var refWrapper = document.querySelector(".st_referred-by-banner_JS");
                if (!!refWrapper) {
                    if (refWrapper.classList.contains("st_hidden")) {
                        refWrapper.classList.remove("st_hidden");
                    }
                }
            };
            _this_1.hideRef = function() {
                var refWrapper = document.querySelector(".st_referred-by-banner_JS");
                if (!!refWrapper) {
                    if (!refWrapper.classList.contains("st_hidden")) {
                        refWrapper.classList.add("st_hidden");
                    }
                }
            };
            _this_1.getReferralsData = function() {
                var _this = _this_1;
                var referralCode = localStorage.getItem("ref");
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_14.aliasQueryParam];
                var refCode = {
                    promoCode: referralCode,
                    webAlias: currentAlias
                };
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["customer"]["getReferralInfo"],
                    method: "post",
                    contentType: "json",
                    data: refCode,
                    callback: function(response) {
                        try {
                            var getReferralInfo = JSON.parse(response.response);
                            if (getReferralInfo.status === 200) {
                                var refType = getReferralInfo.data.customerType;
                                if (refType === "retail") {
                                    _this.showRef();
                                    var fullname = getReferralInfo.data.firstName + " " + getReferralInfo.data.lastName;
                                    _this.writeRefName(fullname);
                                    if (getReferralInfo.data.customerSponsorMatch === false) {
                                        _this.deleteRefCode();
                                        _this.hideRef();
                                    }
                                }
                                if (refType === "representative") {
                                    if (getReferralInfo.data.customerSponsorMatch === false) {
                                        _this.deleteRefCode();
                                        _this.hideRef();
                                    }
                                }
                                if (refType === "") {
                                    console.log("INVALID REF CODE !!!!!!!!!!!");
                                    _this.deleteRefCode();
                                    _this.hideRef();
                                }
                            } else {
                                _this.notification.showNotification(notification_10.ENotificationType.error, "An Error Occurred", getReferralInfo.message);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_10.ENotificationType.error, "Server Error", error);
                        }
                    }
                });
            };
            _this_1.writeRefName = function(fullname) {
                var refNameSpan = document.querySelector(".st_referral-fullname_JS");
                if (!!refNameSpan) {
                    refNameSpan.innerHTML = fullname;
                }
            };
            _this_1.generalMethods = generalMethods;
            _this_1.objectFormatting = objectFormatting;
            _this_1.notification = notification;
            return _this_1;
        }
        return StReferral;
    }(st_module_62.StModule);
    exports.StReferral = StReferral;
});

define("core/shopify-app/st-modules/account/blocks/coupon-codes/coupon-codes", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_63, _features_config_15) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCouponCodes = void 0;
    var StCouponCodes = function(_super) {
        __extends(StCouponCodes, _super);
        function StCouponCodes() {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "CouponCodes";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.blockHandle();
                });
            };
            _this_1.blockHandle = function() {
                var mainWrapper = document.querySelector(".st_account-coupon-codes_wrapper_JS");
                if (!!mainWrapper) {
                    if (_features_config_15.shareRefCodeFunctionality) {
                        mainWrapper.classList.remove("st_hidden");
                        _this_1.toggleInputs();
                        _this_1.copyCode();
                        _this_1.earnedCouponCodes();
                        _this_1.redeemedCouponCodes();
                        var showInactive = false;
                        _this_1.filterStatus(showInactive);
                    } else {
                        mainWrapper.classList.add("st_hidden");
                    }
                }
            };
            _this_1.toggleInputs = function() {
                var _this = _this_1;
                var showCodeBtnField = document.querySelectorAll(".st_coupon-codes-table-codes_JS");
                if (!!showCodeBtnField) {
                    showCodeBtnField.forEach(function(el) {
                        var showCodeBtn = el.querySelector(".st_table-show-coupon_JS");
                        showCodeBtn.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.showCode(el);
                        });
                    });
                }
            };
            _this_1.showCode = function(el) {
                var showCodeBtnWrapper = el.querySelector(".st_table-coupon-code-show-wrapper_JS");
                var codeWrapper = el.querySelector(".st_table-coupon-code-input-wrapper_JS");
                if (!!showCodeBtnWrapper && !!codeWrapper) {
                    showCodeBtnWrapper.classList.add("st_hidden");
                    codeWrapper.classList.remove("st_hidden");
                }
            };
            _this_1.copyCode = function() {
                var showCodeBtnField = document.querySelectorAll(".st_coupon-codes-table-codes_JS");
                if (!!showCodeBtnField) {
                    showCodeBtnField.forEach(function(el) {
                        var copyCodeBtn = el.querySelector(".st_table-copy-coupon_JS");
                        if (!!copyCodeBtn) {
                            copyCodeBtn.addEventListener("click", function() {
                                var input = el.querySelector(".st_table-coupon-code_JS");
                                if (!!input) {
                                    input.select();
                                    input.setSelectionRange(0, 99999);
                                    navigator.clipboard.writeText(input.value);
                                    input.style.backgroundColor = "rgb(217, 218, 220)";
                                    input.style.transition = "0.2s";
                                    setTimeout(function() {
                                        input.style.backgroundColor = "rgb(249, 249, 249)";
                                    }, 1e3);
                                }
                            });
                        }
                    });
                }
            };
            _this_1.earnedCouponCodes = function() {
                var _this = _this_1;
                var earnedBtn = document.querySelector(".st_earned-coupon-codes_JS");
                if (!!earnedBtn) {
                    earnedBtn.addEventListener("click", function(e) {
                        e.preventDefault();
                        var flag = false;
                        _this.filterStatus(flag);
                    });
                }
            };
            _this_1.redeemedCouponCodes = function() {
                var _this = _this_1;
                var redeemedBtn = document.querySelector(".st_redeemed-coupon-codes_JS");
                if (!!redeemedBtn) {
                    redeemedBtn.addEventListener("click", function(e) {
                        e.preventDefault();
                        var flag = true;
                        _this.filterStatus(flag);
                    });
                }
            };
            _this_1.filterStatus = function(flag) {
                var _this = _this_1;
                var tableRows = document.querySelectorAll(".st_coupon-codes-table-row_JS");
                if (!!tableRows) {
                    tableRows.forEach(function(el) {
                        var couponStatusEl = el.querySelector(".st_coupon-codes-table-status_JS");
                        var status = couponStatusEl.getAttribute("data-status");
                        if (flag) {
                            if (status === "Active") {
                                el.classList.add("st_hidden");
                            } else {
                                el.classList.remove("st_hidden");
                            }
                        } else {
                            if (status === "Active") {
                                el.classList.remove("st_hidden");
                            } else {
                                el.classList.add("st_hidden");
                            }
                        }
                        _this.adjustTableHeader(flag);
                        _this.adjustTableForInactive(status, el);
                    });
                }
            };
            _this_1.adjustTableForInactive = function(status, el) {
                var copyBtn = el.querySelector(".st_table-copy-coupon_JS");
                var columnNameEl = document.querySelector(".st_table-head-actions_JS");
                if (!!columnNameEl) {
                    if (status === "Active") {
                        copyBtn.classList.remove("st_hidden");
                    } else {
                        copyBtn.classList.add("st_hidden");
                        _this_1.showCode(el);
                    }
                }
            };
            _this_1.adjustTableHeader = function(flag) {
                var columnNameEl = document.querySelector(".st_table-head-actions_JS");
                if (!!columnNameEl) {
                    if (flag) {
                        columnNameEl.innerHTML = "Used Promo Code";
                    } else {
                        columnNameEl.innerHTML = "Actions";
                    }
                }
            };
            return _this_1;
        }
        return StCouponCodes;
    }(st_module_63.StModule);
    exports.StCouponCodes = StCouponCodes;
});

define("extension/shopify-app/st-modules/webalias/webalias-class-config.extended", [ "require", "exports", "core/shopify-app/st-modules/webalias/webalias-class-config" ], function(require, exports, webalias_class_config_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StWebAliasClassConfigExtended = void 0;
    var StWebAliasClassConfigExtended = function(_super) {
        __extends(StWebAliasClassConfigExtended, _super);
        function StWebAliasClassConfigExtended() {
            var _this = _super.call(this) || this;
            _this.className = "StWebAliasClassConfigExtended";
            _this.classNameRepId = "st_representative-id_JS";
            _this.selectorRepId = "." + _this.classNameRepId;
            _this.classNameRepAlias = "st_representative-alias_JS";
            _this.selectorRepAlias = "." + _this.classNameRepAlias;
            _this.classNameRepFullName = "st_representative-fullname_JS";
            _this.selectorRepFullName = "." + _this.classNameRepFullName;
            _this.classNameRepInitials = "st_representative-initials_JS";
            _this.selectorRepInitials = "." + _this.classNameRepInitials;
            _this.classNameRepSite = "st_representative-site_JS";
            _this.selectorRepSite = "." + _this.classNameRepSite;
            _this.classNameRepBio = "st_representative-site-bio_JS";
            _this.selectorRepBio = "." + _this.classNameRepBio;
            _this.classNameRepAddress = "st_representative-address_JS";
            _this.selectorRepAddress = "." + _this.classNameRepAddress;
            _this.classNameNonSponsor = "st_non-sponsor_JS";
            _this.selectorNonSponsor = "." + _this.classNameNonSponsor;
            _this.classRepresentativeBannerWrapper = "st_representative-banner--wrapper_JS";
            _this.selectorRepresentativeBannerWrapper = "." + _this.classRepresentativeBannerWrapper;
            _this.classNameBusinessContentRepName = "st_account-business--rep-name_JS";
            _this.selectorBusinessContentRepName = "." + _this.classNameBusinessContentRepName;
            _this.classNamePersonalInfoForm = "st_personal-info-form_JS";
            _this.selectorPersonalInfoForm = "." + _this.classNamePersonalInfoForm;
            _this.classNamePersonalInfoRepFullName = "st_representative-info-fullname_JS";
            _this.selectorPersonalInfoRepFullName = "." + _this.classNamePersonalInfoRepFullName;
            _this.classNameRepBannerImage = "st_representative_image_JS";
            _this.selectorRepBannerImage = "." + _this.classNameRepBannerImage;
            _this.classNameRepDefaultImage = "st_representative_image_default_JS";
            _this.selectorRepDefaultImage = "." + _this.classNameRepDefaultImage;
            _this.classNameRepEmail = "st_representative_email_JS";
            _this.selectorRepEmail = "." + _this.classNameRepEmail;
            _this.classNameRepAboutMe = "st_representative_about_me_JS";
            _this.selectorRepAboutMe = "." + _this.classNameRepAboutMe;
            _this.classNameRepJoinMyTeam = "st_representative_join_my_team_JS";
            _this.selectorRepJoinMyTeam = "." + _this.classNameRepJoinMyTeam;
            _this.classNameRepBannerWrapper = "st_representative-banner--wrapper_JS";
            _this.selectorRepBannerWrapper = "." + _this.classNameRepBannerWrapper;
            _this.classNameRepSponsorField = "st_print-sponsor-field_JS";
            _this.selectorRepSponsorField = "." + _this.classNameRepSponsorField;
            return _this;
        }
        return StWebAliasClassConfigExtended;
    }(webalias_class_config_1.StWebAliasClassConfig);
    exports.StWebAliasClassConfigExtended = StWebAliasClassConfigExtended;
});

define("extension/shopify-app/st-modules/rep-site-detail/rep-site-detail-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_64) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StReplicatedSiteDetailClassConfig = void 0;
    var StReplicatedSiteDetailClassConfig = function(_super) {
        __extends(StReplicatedSiteDetailClassConfig, _super);
        function StReplicatedSiteDetailClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "replicatedSiteDetailClassConfig";
            _this.classNameRepRedirectCopyText = "st_copy-repsite_JS";
            _this.selectorRepRedirectIconCopyText = "." + _this.classNameRepRedirectCopyText;
            _this.classNameRepRedirectCopyTextWrapper = "st_copy-repsite--wrapper_JS";
            _this.selectorRepRedirectCopyTextWrapper = "." + _this.classNameRepRedirectCopyTextWrapper;
            _this.classNameRepRedirectLabel = "st_representative-site_JS";
            _this.selectorRepRedirectLabel = "." + _this.classNameRepRedirectLabel;
            _this.classNameRepFullName = "st_rep-site-detail-full-name_JS";
            _this.selectorRepFullName = "." + _this.classNameRepFullName;
            _this.classNameRepDetailRank = "st_rep-site-detail-rank_JS";
            _this.selectorRepDetailRank = "." + _this.classNameRepDetailRank;
            _this.classNameRepDetailDetails = "st_rep-site-detail-details_JS";
            _this.selectorRepDetailDetails = "." + _this.classNameRepDetailDetails;
            _this.classNameRepDetailEmail = "st_rep-site-detail-email_JS";
            _this.selectorRepDetailEmail = "." + _this.classNameRepDetailEmail;
            _this.classNameRepDetailPhone = "st_rep-site-detail-phone_JS";
            _this.selectorRepDetailPhone = "." + _this.classNameRepDetailPhone;
            _this.classNameRepFacebookSN = "st_rep-site-sn-facebook_JS";
            _this.selectorRepFacebookSN = "." + _this.classNameRepFacebookSN;
            _this.classNameRepXSN = "st_rep-site-sn-X_JS";
            _this.selectorRepXSN = "." + _this.classNameRepXSN;
            _this.classNameRepInstagramSN = "st_rep-site-sn-Instagram_JS";
            _this.selectorRepInstagramSN = "." + _this.classNameRepInstagramSN;
            _this.classNameRepWhatsAppSN = "st_rep-site-sn-WhatsApp_JS";
            _this.selectorRepWhatsAppSN = "." + _this.classNameRepWhatsAppSN;
            _this.classNameLinkedInXSN = "st_rep-site-sn-LinkedIn_JS";
            _this.selectorRepLinkedInSN = "." + _this.classNameLinkedInXSN;
            _this.classNameRepTikTokSN = "st_rep-site-sn-TikTok_JS";
            _this.selectorRepTikTokSN = "." + _this.classNameRepTikTokSN;
            _this.classNameRepPinterestSN = "st_rep-site-sn-Pinterest_JS";
            _this.selectorRepPinterestSN = "." + _this.classNameRepPinterestSN;
            return _this;
        }
        return StReplicatedSiteDetailClassConfig;
    }(st_module_64.StModule);
    exports.StReplicatedSiteDetailClassConfig = StReplicatedSiteDetailClassConfig;
});

define("extension/shopify-app/st-modules/webalias/inject-representative-info", [ "require", "exports", "core/shopify-app/st-modules/webalias/inject-representative-info", "_features.config" ], function(require, exports, inject_representative_info_1, _features_config_16) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StInjectRepresentativeInfoExtended = void 0;
    var StInjectRepresentativeInfoExtended = function(_super) {
        __extends(StInjectRepresentativeInfoExtended, _super);
        function StInjectRepresentativeInfoExtended(classConfig, generalMethods) {
            var _this = _super.call(this, classConfig) || this;
            _this.className = "InjectRepresentativeInfoExtended";
            _this.injectToFields = function(repInfo) {
                var repId = repInfo.repId, webAlias = repInfo.webAlias, firstName = repInfo.firstName, lastName = repInfo.lastName, imageUrl = repInfo.imageUrl, email = repInfo.email;
                if (!!repId) {
                    _this.appendIdToField(repInfo.repId);
                }
                if (!!webAlias) {
                    _this.appendAlsToField(webAlias);
                    _this.appendRepSiteUrlToField(webAlias);
                }
                if (!!firstName || !!lastName) {
                    _this.appendRepFullNameToFieldV2(repInfo);
                }
                if (!!imageUrl && _features_config_16.additionalRepInfo) {
                    _this.appendRepBioToField(imageUrl);
                }
            };
            _this.appendRepFullNameToFieldV2 = function(repInfo) {
                var repFullNameFields = document.querySelectorAll(_this.classConfig.selectorRepFullName);
                var fullName = _this.getFullNameV2(repInfo);
                var repImage = document.querySelector(_this.classConfig.selectorRepBannerImage);
                var repImages = document.querySelectorAll(_this.classConfig.selectorRepBannerImage);
                var repImagesDefault = document.querySelectorAll(_this.classConfig.selectorRepDefaultImage);
                repImage === null || repImage === void 0 ? void 0 : repImage.classList.add("st_hidden");
                if (repFullNameFields.length > 0) {
                    _this.appendValueToFields(repFullNameFields, fullName);
                }
                if (repInfo.imageUrl) {
                    repImages.forEach(function(repImageTemp) {
                        repImageTemp === null || repImageTemp === void 0 ? void 0 : repImageTemp.setAttribute("src", repInfo.imageUrl);
                        repImageTemp === null || repImageTemp === void 0 ? void 0 : repImageTemp.classList.remove("st_hidden");
                        repImageTemp === null || repImageTemp === void 0 ? void 0 : repImageTemp.setAttribute("srcset", "");
                    });
                    repImagesDefault.forEach(function(repImageDefaultTemp) {
                        repImageDefaultTemp === null || repImageDefaultTemp === void 0 ? void 0 : repImageDefaultTemp.classList.add("st_hidden");
                    });
                }
                _this.showBannerContent(repImage);
                var emailField = document.querySelector(_this.classConfig.selectorRepEmail);
                if (!!emailField) {
                    emailField.innerText = repInfo.email;
                }
                var aboutMeField = document.querySelector(_this.classConfig.selectorRepAboutMe);
                if (!!aboutMeField) {
                    aboutMeField.addEventListener("click", function(e) {
                        window.location.href = window.location.origin + "/pages/replicated-site-detail-page";
                    });
                }
                var joinMyTeamField = document.querySelector(_this.classConfig.selectorRepJoinMyTeam);
                if (!!joinMyTeamField) {
                    joinMyTeamField.addEventListener("click", function(e) {
                        var repId = window.localStorage.getItem("repId");
                        console.log(repId, typeof repId);
                        if (repId != "undefined") {
                            window.location.href = "https://extranet.lbri.com/lbri/Personal/Signup/EnrollNew_Custom.asp?RepID=" + repId;
                        } else {
                            window.location.href = "https://extranet.lbri.com/lbri/Personal/Signup/EnrollNew_Custom.asp?RepID=400560";
                        }
                    });
                }
            };
            _this.showBannerContent = function(repImage) {
                var _a, _b;
                repImage.onerror = function() {
                    console.warn("Representative image not found → fallback to SVG");
                    var wrapper = repImage.closest(".st_repbar_avatar");
                    if (!wrapper) return;
                    var defaultSvg = wrapper.querySelector(".st_representative_image_default_JS");
                    repImage.classList.add("st_hidden");
                    defaultSvg === null || defaultSvg === void 0 ? void 0 : defaultSvg.classList.remove("st_hidden");
                };
                var innerWrapper = _this.generalMethods.getClosestByClass(repImage, _this.classConfig.classNameRepBannerWrapper);
                if (innerWrapper) {
                    (_a = innerWrapper.querySelector(".st_loader")) === null || _a === void 0 ? void 0 : _a.classList.add("st_hidden");
                    (_b = innerWrapper.querySelector(_this.classConfig.selectorRepSponsorField)) === null || _b === void 0 ? void 0 : _b.classList.remove("st_hidden");
                }
            };
            _this.getFullNameV2 = function(repInfo) {
                var fullName = "";
                if (!!repInfo.firstName) {
                    fullName = repInfo.firstName;
                    if (!!repInfo.lastName) {
                        fullName += " " + repInfo.lastName;
                    }
                }
                if (repInfo.webAlias === _features_config_16.defaultWebAlias || repInfo.repId === _features_config_16.defaultWebAlias) {
                    fullName = _features_config_16.corporationName;
                }
                return fullName;
            };
            _this.generalMethods = generalMethods;
            _this.classConfig = classConfig;
            return _this;
        }
        return StInjectRepresentativeInfoExtended;
    }(inject_representative_info_1.StInjectRepresentativeInfo);
    exports.StInjectRepresentativeInfoExtended = StInjectRepresentativeInfoExtended;
});

define("extension/shopify-app/st-modules/rep-site-detail/rep-site-detail", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_65, _features_config_17, notification_11) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StReplicatedSiteDetail = void 0;
    var StReplicatedSiteDetail = function(_super) {
        __extends(StReplicatedSiteDetail, _super);
        function StReplicatedSiteDetail(classConfig, generalMethods, objectFormatting, notification) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StReplicatedSiteDetail";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.getRepSiteData();
                });
            };
            _this_1.getRepSiteData = function() {
                var _this = _this_1;
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_17.aliasQueryParam];
                if (!currentAlias) {
                    currentAlias = window.localStorage.getItem("webAlias");
                }
                var refCode = {
                    customerIdOrAlias: currentAlias,
                    isOwnInfo: true
                };
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["customer"]["get-rep-details"],
                    method: "post",
                    contentType: "json",
                    data: refCode,
                    callback: function(response) {
                        try {
                            var getRepDetails = JSON.parse(response.response);
                            if (getRepDetails.status === 200) {
                                _this.setDataToPage(getRepDetails);
                            } else {
                                _this.notification.showNotification(notification_11.ENotificationType.error, "An Error Occurred", getRepDetails.message);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_11.ENotificationType.error, "Server Error", error);
                        }
                    }
                });
            };
            _this_1.setDataToPage = function(getRepDetails) {
                var _a, _b, _c, _d, _e, _f, _g;
                var t = window.stTranslations || {};
                var setupElements = [ {
                    function: "setElementInnerHTML",
                    selector: _this_1.classConfig.selectorRepFullName,
                    data: getRepDetails.data.firstName + " " + getRepDetails.data.lastName
                }, {
                    function: "setElementInnerHTML",
                    selector: _this_1.classConfig.selectorRepDetailRank,
                    data: getRepDetails.data.repRank.rankDescription
                }, {
                    function: "setElementInnerHTML",
                    selector: ".st_rep-site-detail-stat-rank_JS",
                    data: getRepDetails.data.repRank.rankDescription
                }, {
                    function: "setElementInnerHTML",
                    selector: ".st_rep-site-detail-experience_JS",
                    data: _this_1.getExperienceFromJoinDate(getRepDetails.data.joinDate)
                }, {
                    function: "setElementInnerHTML",
                    selector: _this_1.classConfig.selectorRepDetailDetails,
                    data: getRepDetails.data.replicatedSiteText || t.defaultMyStoryText
                }, {
                    function: "setElementInnerHTML",
                    selector: _this_1.classConfig.selectorRepDetailEmail,
                    data: getRepDetails.data.email
                }, {
                    function: "setPhone",
                    selector: _this_1.classConfig.selectorRepDetailPhone,
                    data: getRepDetails.data
                }, {
                    function: "setSocialMediaIcon",
                    selector: _this_1.classConfig.selectorRepFacebookSN,
                    data: (_a = getRepDetails.data.socialNetworks) === null || _a === void 0 ? void 0 : _a.facebook
                }, {
                    function: "setSocialMediaIcon",
                    selector: _this_1.classConfig.selectorRepXSN,
                    data: (_b = getRepDetails.data.socialNetworks) === null || _b === void 0 ? void 0 : _b.twitter
                }, {
                    function: "setSocialMediaIcon",
                    selector: _this_1.classConfig.selectorRepInstagramSN,
                    data: (_c = getRepDetails.data.socialNetworks) === null || _c === void 0 ? void 0 : _c.instagram
                }, {
                    function: "setSocialMediaIcon",
                    selector: _this_1.classConfig.selectorRepWhatsAppSN,
                    data: (_d = getRepDetails.data.socialNetworks) === null || _d === void 0 ? void 0 : _d.whatsup
                }, {
                    function: "setSocialMediaIcon",
                    selector: _this_1.classConfig.selectorRepLinkedInSN,
                    data: (_e = getRepDetails.data.socialNetworks) === null || _e === void 0 ? void 0 : _e.linkedIn
                }, {
                    function: "setSocialMediaIcon",
                    selector: _this_1.classConfig.selectorRepTikTokSN,
                    data: (_f = getRepDetails.data.socialNetworks) === null || _f === void 0 ? void 0 : _f.tikTok
                }, {
                    function: "setSocialMediaIcon",
                    selector: _this_1.classConfig.selectorRepPinterestSN,
                    data: (_g = getRepDetails.data.socialNetworks) === null || _g === void 0 ? void 0 : _g.pinterest
                } ];
                setupElements.forEach(function(el) {
                    _this_1[el.function](document.querySelector(el.selector), el.data);
                });
                var repImages = document.querySelectorAll(".st_rep-site-detail-image_JS");
                if (repImages === null || repImages === void 0 ? void 0 : repImages.length) {
                    repImages.forEach(function(img) {
                        if (!img) return;
                        _this_1.bindRepImageFallback(img);
                        img.setAttribute("src", getRepDetails.data.imageUrl || "");
                        img.removeAttribute("srcset");
                    });
                }
                var mainLoader = document.querySelector(".st_rep-site-detail-main-loader_JS");
                mainLoader === null || mainLoader === void 0 ? void 0 : mainLoader.classList.add("st_hidden");
                var mainContainer = document.querySelector(".st_rep-site-detail-wrapper");
                mainContainer === null || mainContainer === void 0 ? void 0 : mainContainer.classList.remove("st_hidden");
            };
            _this_1.setElementInnerHTML = function(SNElement, SNdata) {
                if (SNElement && SNdata) {
                    SNElement.innerHTML = SNdata;
                }
            };
            _this_1.setSocialMediaIcon = function(SNElement, SNdata) {
                if (SNElement && SNdata && SNdata.isValid) {
                    SNElement.href = SNdata.url;
                    SNElement === null || SNElement === void 0 ? void 0 : SNElement.classList.remove("st_hidden");
                }
            };
            _this_1.setPhone = function(SNElement, SNdata) {
                var determinedPhone = "/";
                if (SNElement && SNdata) {
                    if (!!SNdata.phone1) {
                        determinedPhone = SNdata.phone1;
                    } else if (!!SNdata.phone2) {
                        determinedPhone = SNdata.phone2;
                    } else if (!!SNdata.phone3) {
                        determinedPhone = SNdata.phone3;
                    } else if (!!SNdata.phone4) {
                        determinedPhone = SNdata.phone4;
                    } else if (!!SNdata.phone5) {
                        determinedPhone = SNdata.phone5;
                    } else if (!!SNdata.phone6) {
                        determinedPhone = SNdata.phone6;
                    }
                    SNElement.innerHTML = determinedPhone;
                }
            };
            _this_1.getExperienceFromJoinDate = function(joinDateRaw) {
                var t = window.stTranslations || {};
                if (!joinDateRaw) return "";
                var joinDate = new Date(joinDateRaw);
                var today = new Date();
                var years = today.getFullYear() - joinDate.getFullYear();
                var hasNotReachedAnniversary = today.getMonth() < joinDate.getMonth() || today.getMonth() === joinDate.getMonth() && today.getDate() < joinDate.getDate();
                if (hasNotReachedAnniversary) {
                    years--;
                }
                if (years <= 0) {
                    return t.experienceMonths || "Less than 1 year with L’BRI";
                }
                var text = t.experienceYears || "{count}+ Years with L’BRI";
                return text.replace("{count}", years);
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            _this_1.objectFormatting = objectFormatting;
            _this_1.notification = notification;
            return _this_1;
        }
        StReplicatedSiteDetail.prototype.bindRepImageFallback = function(repImage) {
            if (repImage.__fallbackBound) return;
            repImage.__fallbackBound = true;
            var wrapper = repImage.closest(".st_repbar_avatar") || repImage.parentElement;
            var defaultSvg = wrapper === null || wrapper === void 0 ? void 0 : wrapper.querySelector(".st_representative_image_default_JS");
            repImage.classList.add("st_hidden");
            defaultSvg === null || defaultSvg === void 0 ? void 0 : defaultSvg.classList.remove("st_hidden");
            repImage.onload = function() {
                defaultSvg === null || defaultSvg === void 0 ? void 0 : defaultSvg.classList.add("st_hidden");
                repImage.classList.remove("st_hidden");
            };
            repImage.onerror = function() {
                repImage.classList.add("st_hidden");
                defaultSvg === null || defaultSvg === void 0 ? void 0 : defaultSvg.classList.remove("st_hidden");
                repImage.removeAttribute("srcset");
            };
        };
        return StReplicatedSiteDetail;
    }(st_module_65.StModule);
    exports.StReplicatedSiteDetail = StReplicatedSiteDetail;
});

define("extension/shopify-app/st-modules/webalias/shopining-with/party-banner-info", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_66) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StPartyBannerInfo = void 0;
    var StPartyBannerInfo = function(_super) {
        __extends(StPartyBannerInfo, _super);
        function StPartyBannerInfo(objectFormatting) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "PartyBannerInfo";
            _this_1.init = function() {
                _this_1.checkIfPartyExist();
                _this_1.listenForPageChanges();
                _this_1.handleMobileRepMenu();
            };
            _this_1.checkIfPartyExist = function() {
                var _this = _this_1;
                var queryParams = _this_1.objectFormatting.convertQueryStringToObject(location.search);
                var als = queryParams.als, partyId = queryParams.partyId;
                if (!!partyId) {
                    _this_1.getPartyBannerInformation(partyId, als);
                } else {
                    _this.renderNoParty();
                }
            };
            _this_1.getPartyBannerInformation = function(party, webAlias) {
                var _this = _this_1;
                var partyBannerWrapper = document.querySelector(".st_representative-party-name_JS");
                if (!!partyBannerWrapper) {
                    var partyBannerInformationEndpoint = _this.endpoint["party"]["party-banner-information"];
                    try {
                        _this_1.ajax.send({
                            endpoint: partyBannerInformationEndpoint,
                            method: "POST",
                            contentType: "json",
                            data: {
                                sponsorAlias: webAlias,
                                partyId: party
                            },
                            callback: function(res) {
                                var resp = JSON.parse(res.response);
                                if (resp.status === 200) {
                                    var partyName = resp.data.partyName;
                                    var partyHostName = resp.data.partyHostName;
                                    _this.renderHostName(partyHostName);
                                    _this.renderPartyName(partyName, partyHostName);
                                } else {
                                    console.log(resp.message);
                                }
                            }
                        });
                    } catch (err) {
                        console.log("getPartyBannerInformation---\x3e Error:", err);
                    }
                }
            };
            _this_1.renderHostName = function(hostName) {
                var hostNameEls = document.querySelectorAll(".st_referral-party-host-name_JS");
                if (!!hostNameEls) {
                    hostNameEls.forEach(function(el) {
                        el.textContent = hostName;
                    });
                }
            };
            _this_1.renderPartyName = function(partyName, hostName) {
                var partyNameEls = document.querySelectorAll(".st_representative-party-name_JS");
                if (!!partyNameEls) {
                    var trimmedHost = hostName.trim();
                    var lastChar = trimmedHost.charAt(trimmedHost.length - 1);
                    var possessive = lastChar === "s" ? "".concat(trimmedHost, "'") : "".concat(trimmedHost, "'s");
                    var fullPartyName_1 = "".concat(possessive, " ").concat(partyName.trim());
                    partyNameEls.forEach(function(el) {
                        el.textContent = fullPartyName_1;
                    });
                }
            };
            _this_1.renderNoParty = function() {
                var hostEls = document.querySelectorAll(".st_referral-party-host-name_JS");
                var nameEls = document.querySelectorAll(".st_representative-party-name_JS");
                hostEls.forEach(function(el) {
                    return el.textContent = "";
                });
                nameEls.forEach(function(el) {
                    return el.textContent = "";
                });
            };
            _this_1.listenForPageChanges = function() {
                var _this = _this_1;
                window.addEventListener("popstate", function() {
                    _this.checkIfPartyExist();
                });
                (function(history) {
                    var pushState = history.pushState;
                    var replaceState = history.replaceState;
                    history.pushState = function() {
                        var result = pushState.apply(history, arguments);
                        window.dispatchEvent(new Event("pushstate"));
                        window.dispatchEvent(new Event("locationchange"));
                        return result;
                    };
                    history.replaceState = function() {
                        var result = replaceState.apply(history, arguments);
                        window.dispatchEvent(new Event("replacestate"));
                        window.dispatchEvent(new Event("locationchange"));
                        return result;
                    };
                })(window.history);
                window.addEventListener("locationchange", function() {
                    _this.checkIfPartyExist();
                });
            };
            _this_1.handleMobileRepMenu = function() {
                var repMenuWrapper = document.querySelector(".st_repbar_top");
                if (!repMenuWrapper) return;
                repMenuWrapper.addEventListener("click", function(event) {
                    event.stopPropagation();
                    repMenuWrapper.classList.toggle("is-open");
                });
                document.addEventListener("click", function() {
                    repMenuWrapper.classList.remove("is-open");
                });
            };
            _this_1.objectFormatting = objectFormatting;
            return _this_1;
        }
        return StPartyBannerInfo;
    }(st_module_66.StModule);
    exports.StPartyBannerInfo = StPartyBannerInfo;
});

define("extension/connector-app/_shared/models/party/party.validation.request", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("extension/connector-app/_shared/models/party/party.validataion.response", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("extension/shopify-app/st-modules/party/party-service", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_67) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StPartyService = void 0;
    var StPartyService = function(_super) {
        __extends(StPartyService, _super);
        function StPartyService(objectFormatting) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "PartyService";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {});
            };
            _this_1.partyValidation = function(partyValidationReq, responseHandle) {
                var _this = _this_1;
                var partyValidationEndpoint = _this.endpoint["party"]["party-validation"];
                _this_1.ajax.send({
                    endpoint: partyValidationEndpoint,
                    method: "POST",
                    contentType: "json",
                    data: partyValidationReq,
                    callback: function(res) {
                        try {
                            res = JSON.parse(res.response);
                            responseHandle(res);
                        } catch (err) {
                            console.log("Error: partyValidation --\x3e", err);
                        }
                    }
                });
            };
            _this_1.objectFormatting = objectFormatting;
            return _this_1;
        }
        return StPartyService;
    }(st_module_67.StModule);
    exports.StPartyService = StPartyService;
});

define("extension/shopify-app/st-modules/party/party", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_68) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StParty = void 0;
    var StParty = function(_super) {
        __extends(StParty, _super);
        function StParty(objectFormatting, partyService, cartComponent) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StParty";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.initPersistParty();
                });
            };
            _this.initPersistParty = function() {
                var partyFromUrl = _this.getPartyFromQuery;
                if (_this.isConsultantCustomer()) {
                    console.log("[PARTY] Consultant customer is not allowed to access party. Clearing only partyId.");
                    _this.clearOnlyPartyIdEverywhere();
                    return;
                }
                _this.cartComponent.getCart(function(cartRes) {
                    var attrs = cartRes && cartRes.attributes ? cartRes.attributes : {};
                    var cartPartyId = attrs.partyId ? String(attrs.partyId).trim() : "";
                    var partyAllow = attrs.party_allow;
                    var isPartyExplicitlyDisabled = partyAllow !== undefined && partyAllow !== null && String(partyAllow).toLowerCase().trim() === "false";
                    if (isPartyExplicitlyDisabled && (!partyFromUrl || partyFromUrl === cartPartyId)) {
                        console.log("[PARTY] party_allow=false for current party. Clearing only partyId.");
                        _this.clearOnlyPartyIdEverywhere(cartRes);
                        return;
                    }
                    if (partyFromUrl) {
                        console.log("[PARTY] partyId found in URL. Validating explicit party link:", partyFromUrl);
                        _this.validatePartyFromUrl(partyFromUrl);
                        return;
                    }
                    _this.persistPartyAfterAllowCheck();
                });
            };
            _this.persistPartyAfterAllowCheck = function() {
                if (_this.isConsultantCustomer()) {
                    console.log("[PARTY] Consultant customer is not allowed to access party. Clearing only partyId.");
                    _this.clearOnlyPartyIdEverywhere();
                    return;
                }
                _this.cartComponent.getCart(function(cartRes) {
                    var attrs = cartRes && cartRes.attributes ? cartRes.attributes : {};
                    var partyAllow = attrs.party_allow;
                    var isPartyExplicitlyDisabled = partyAllow !== undefined && partyAllow !== null && String(partyAllow).toLowerCase().trim() === "false";
                    if (isPartyExplicitlyDisabled) {
                        console.log("[PARTY] party_allow=false in cart. Clearing existing partyId.");
                        _this.clearOnlyPartyIdEverywhere(cartRes);
                        return;
                    }
                    var partyFromUrl = _this.getPartyFromQuery;
                    var lsParty = localStorage.getItem("partyId");
                    var als = localStorage.getItem("webAlias");
                    var partyId = lsParty || partyFromUrl || null;
                    if (partyId !== null && partyId !== "") {
                        var safePartyId_1 = partyId;
                        _this.validateParty(safePartyId_1, function(isPartyOpen) {
                            if (isPartyOpen) {
                                var currentLsParty = localStorage.getItem("partyId");
                                if (!currentLsParty || currentLsParty === safePartyId_1) {
                                    localStorage.setItem("partyId", safePartyId_1);
                                    _this.insertPartyInQuery();
                                }
                            } else {
                                _this.clearOnlyPartyIdEverywhere();
                            }
                        });
                        return;
                    }
                    partyId = localStorage.getItem("partyId");
                    if (partyId && als) {
                        _this.validateParty(partyId, function(isOpen) {
                            if (isOpen) {
                                var currentLsParty = localStorage.getItem("partyId");
                                if (!currentLsParty || currentLsParty === partyId) {
                                    localStorage.setItem("partyId", partyId);
                                    _this.insertPartyInQuery();
                                }
                            } else {
                                _this.clearOnlyPartyIdEverywhere();
                            }
                        });
                    }
                });
            };
            _this.getCustomerTags = function() {
                var rawTags = window.customerTags;
                if (Array.isArray(rawTags)) {
                    return rawTags.map(function(tag) {
                        return String(tag).trim();
                    }).filter(Boolean);
                }
                if (typeof rawTags === "string") {
                    return rawTags.split(",").map(function(tag) {
                        return tag.trim();
                    }).filter(Boolean);
                }
                return [];
            };
            _this.isConsultantCustomer = function() {
                var tags = _this.getCustomerTags();
                return tags.some(function(tag) {
                    return tag.toLowerCase() === "consultant";
                });
            };
            _this.isPartyAllowedFromCart = function(_cartRes) {
                return !_this.isConsultantCustomer();
            };
            _this.clearOnlyPartyIdEverywhere = function(cartRes) {
                _this.removeOnlyPartyIdFromLocalStorage();
                _this.removePartyFromQuery();
                _this.hidePartyBanner();
                if (cartRes && cartRes.attributes) {
                    _this.clearOnlyPartyIdFromCart(cartRes);
                    return;
                }
                _this.cartComponent.getCart(function(cart) {
                    _this.clearOnlyPartyIdFromCart(cart);
                });
            };
            _this.removeOnlyPartyIdFromLocalStorage = function() {
                try {
                    if (localStorage.getItem("partyId")) {
                        localStorage.removeItem("partyId");
                        console.log("[PARTY] partyId removed from localStorage");
                    }
                } catch (e) {
                    console.warn("[PARTY] Failed to remove partyId from localStorage:", e);
                }
            };
            _this.clearOnlyPartyIdFromCart = function(cart) {
                var attributes = cart && cart.attributes ? cart.attributes : {};
                if (!attributes.partyId) {
                    console.log("[PARTY] No partyId in cart attributes");
                    return;
                }
                var updatedAttributes = __assign(__assign({}, attributes), {
                    partyId: ""
                });
                fetch("/cart/update.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        attributes: updatedAttributes
                    })
                }).then(function(response) {
                    return response.json();
                }).then(function() {
                    _this.hidePartyBanner();
                    console.log("[PARTY] partyId removed from cart attributes only");
                }).catch(function(error) {
                    console.error("[PARTY] Error removing partyId from cart:", error);
                });
            };
            _this.validateParty = function(partyId, handleFunc) {
                if (_this.isConsultantCustomer()) {
                    console.log("[PARTY] Consultant customer cannot validate party.");
                    _this.clearOnlyPartyIdEverywhere();
                    handleFunc(false);
                    return;
                }
                var validationReqObj = {
                    partyId: parseInt(partyId)
                };
                _this.partyService.partyValidation(validationReqObj, function(response) {
                    try {
                        var isPartyOpen = response.data.isPartyOpen;
                        if (isPartyOpen) {
                            var lsParty = localStorage.getItem("partyId") || "";
                            if (lsParty && lsParty !== partyId) {
                                handleFunc(true);
                                return;
                            }
                            _this.addPartyIdToCart(partyId);
                            handleFunc(true);
                        } else {
                            _this.clearOnlyPartyIdEverywhere();
                            handleFunc(false);
                        }
                    } catch (e) {
                        _this.clearOnlyPartyIdEverywhere();
                        handleFunc(false);
                    }
                });
            };
            _this.insertPartyInQuery = function() {
                var partyIdLS = localStorage.getItem("partyId");
                var alsLS = localStorage.getItem("webAlias");
                if (!partyIdLS || !alsLS) return;
                var currentUrl = new URL(window.location.href);
                var partyFromUrl = (currentUrl.searchParams.get("partyId") || "").trim();
                var alsFromUrl = (currentUrl.searchParams.get("als") || "").trim();
                if (partyFromUrl && partyFromUrl !== partyIdLS) {
                    return;
                }
                if (!partyFromUrl) {
                    currentUrl.searchParams.set("partyId", partyIdLS);
                }
                if (!alsFromUrl) {
                    currentUrl.searchParams.set("als", alsLS);
                }
                var newUrl = currentUrl.toString();
                window.history.replaceState({
                    path: newUrl
                }, "", newUrl);
            };
            _this.addPartyToCart = function() {
                if (_this.isConsultantCustomer()) {
                    console.log("[PARTY] Consultant customer cannot add party to cart.");
                    _this.clearOnlyPartyIdEverywhere();
                    return;
                }
                var partyId = _this.getPartyFromQuery;
                var sponsorAlias = localStorage.getItem("webAlias");
                _this.cartComponent.getCart(function(cartRes) {
                    var attributes = cartRes.attributes;
                    attributes = __assign(__assign({}, attributes), {
                        partyId: !!partyId ? partyId : "",
                        sponsorWebAlias: !!sponsorAlias ? sponsorAlias : attributes.sponsorWebAlias
                    });
                    _this.cartComponent.updateCartAttributesWithPartyId({
                        attributes: attributes
                    }, function() {});
                });
            };
            _this.addPartyIdToCart = function(partyId, forcePartyAllow) {
                if (forcePartyAllow === void 0) {
                    forcePartyAllow = false;
                }
                if (_this.isConsultantCustomer()) {
                    console.log("[PARTY] Consultant customer cannot add partyId to cart.");
                    _this.clearOnlyPartyIdEverywhere();
                    return Promise.resolve(null);
                }
                var sponsorAlias = localStorage.getItem("webAlias");
                return fetch("/cart.js").then(function(response) {
                    return response.json();
                }).then(function(cart) {
                    var currentAttributes = cart && cart.attributes ? cart.attributes : {};
                    var updatedAttributes = __assign(__assign({}, currentAttributes), {
                        partyId: partyId
                    });
                    if (forcePartyAllow) {
                        updatedAttributes.party_allow = "true";
                    }
                    if (sponsorAlias) {
                        updatedAttributes.sponsorWebAlias = sponsorAlias;
                    }
                    return fetch("/cart/update.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            attributes: updatedAttributes
                        })
                    });
                }).then(function(response) {
                    return response.json();
                }).then(function(data) {
                    console.log("[PARTY] partyId added to cart", {
                        partyId: partyId,
                        forcePartyAllow: forcePartyAllow
                    });
                    _this.showPartyBannerWrapper();
                    try {
                        window.dispatchEvent(new Event("PartyBannerEvent"));
                        console.log("[PARTY] PartyBannerEvent dispatched after cart update");
                    } catch (e) {
                        console.warn("[PARTY] PartyBannerEvent dispatch failed:", e);
                    }
                    return data;
                }).catch(function(error) {
                    console.error("Error adding Party ID to cart:", error);
                    return Promise.reject(error);
                });
            };
            _this.removePartyFromQuery = function() {
                try {
                    var currentUrl = new URL(window.location.href);
                    if (!currentUrl.searchParams.has("partyId")) {
                        return;
                    }
                    currentUrl.searchParams.delete("partyId");
                    history.replaceState({}, "", currentUrl.toString());
                    console.log("[PARTY] partyId removed from URL");
                } catch (e) {
                    console.warn("[PARTY] Failed to remove partyId from URL:", e);
                }
            };
            _this.validatePartyFromUrl = function(partyId) {
                if (_this.isConsultantCustomer()) {
                    console.log("[PARTY] Consultant customer cannot access party from URL.");
                    _this.clearOnlyPartyIdEverywhere();
                    return;
                }
                _this.validateParty(partyId, function(isPartyOpen) {
                    if (!isPartyOpen) {
                        console.log("[PARTY] URL party is not open/valid. Clearing partyId.");
                        _this.clearOnlyPartyIdEverywhere();
                        return;
                    }
                    console.log("[PARTY] URL party is valid. Saving partyId from URL:", partyId);
                    localStorage.setItem("partyId", partyId);
                    _this.addPartyIdToCart(partyId, true).then(function() {
                        _this.insertPartyInQuery();
                        _this.showPartyBannerWrapper();
                        try {
                            window.dispatchEvent(new Event("PartyBannerEvent"));
                            console.log("[PARTY] PartyBannerEvent dispatched from validatePartyFromUrl");
                        } catch (e) {
                            console.warn("[PARTY] PartyBannerEvent dispatch failed:", e);
                        }
                    }).catch(function() {
                        console.warn("[PARTY] party valid but failed to save to cart");
                    });
                });
            };
            _this.hidePartyBanner = function() {
                var partyBanner = document.querySelector(".lbri-party-banner_JS");
                if (!partyBanner) {
                    return;
                }
                partyBanner.classList.add("st_hidden");
                partyBanner.style.display = "none";
                console.log("[PARTY] party banner hidden");
            };
            _this.showPartyBannerWrapper = function() {
                var partyBanner = document.querySelector(".lbri-party-banner_JS");
                if (!partyBanner) {
                    return;
                }
                partyBanner.classList.remove("st_hidden");
                partyBanner.style.display = "";
                console.log("[PARTY] party banner wrapper prepared for showing");
            };
            _this.objectFormatting = objectFormatting;
            _this.partyService = partyService;
            _this.cartComponent = cartComponent;
            return _this;
        }
        Object.defineProperty(StParty.prototype, "getPartyFromQuery", {
            get: function() {
                var queryParams = this.objectFormatting.convertQueryStringToObject(location.search);
                var partyId = queryParams.partyId;
                return !!partyId && partyId !== "undefined" ? partyId : "";
            },
            enumerable: false,
            configurable: true
        });
        StParty.prototype.removePartyId = function() {
            this.clearOnlyPartyIdEverywhere();
        };
        StParty.prototype.clearPartyAttributesFromCart = function() {
            var _this = this;
            fetch("/cart.js").then(function(response) {
                return response.json();
            }).then(function(cart) {
                var updatedAttributes = __assign(__assign({}, cart && cart.attributes ? cart.attributes : {}), {
                    partyId: ""
                });
                return fetch("/cart/update.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        attributes: updatedAttributes
                    })
                });
            }).then(function(res) {
                return res.json();
            }).then(function() {
                _this.hidePartyBanner();
                console.log("[PARTY] partyId removed from cart only");
            }).catch(function(error) {
                console.error("error cleaning partyId from cart attributes", error);
            });
        };
        return StParty;
    }(st_module_68.StModule);
    exports.StParty = StParty;
});

define("extension/shopify-app/st-modules/party/party-check", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_69) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StPartyCheck = void 0;
    var StPartyCheck = function(_super) {
        __extends(StPartyCheck, _super);
        function StPartyCheck(objectFormatting) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "PartyCheck";
            _this_1.init = function() {
                window.addEventListener("PartyBannerEvent", _this_1.onPartyBannerEvent);
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.checkIfPartyExist();
                    _this_1.sharePartyLink();
                });
            };
            _this_1.onPartyBannerEvent = function() {
                console.log("[PARTY CHECK] PartyBannerEvent received");
                _this_1.checkIfPartyExist();
                setTimeout(function() {
                    _this_1.checkIfPartyExist();
                }, 300);
                setTimeout(function() {
                    _this_1.checkIfPartyExist();
                }, 800);
            };
            _this_1.getCustomerTags = function() {
                var rawTags = window.customerTags;
                if (Array.isArray(rawTags)) {
                    return rawTags.map(function(tag) {
                        return String(tag).trim();
                    }).filter(Boolean);
                }
                if (typeof rawTags === "string") {
                    return rawTags.split(",").map(function(tag) {
                        return tag.trim();
                    }).filter(Boolean);
                }
                return [];
            };
            _this_1.isConsultantCustomer = function() {
                var tags = _this_1.getCustomerTags();
                return tags.some(function(tag) {
                    return tag.toLowerCase() === "consultant";
                });
            };
            _this_1.hidePartyBanner = function() {
                var partyBannerWrapper = document.querySelector(".lbri-party-banner_JS");
                if (!partyBannerWrapper) return;
                partyBannerWrapper.classList.add("st_hidden");
                partyBannerWrapper.style.display = "none";
            };
            _this_1.showPartyBanner = function() {
                var partyBannerWrapper = document.querySelector(".lbri-party-banner_JS");
                if (!partyBannerWrapper) return;
                partyBannerWrapper.classList.remove("st_hidden");
                partyBannerWrapper.style.display = "";
            };
            _this_1.clearOnlyPartyId = function() {
                try {
                    localStorage.removeItem("partyId");
                } catch (e) {
                    console.warn("[PARTY CHECK] Failed to remove partyId from localStorage:", e);
                }
                try {
                    var currentUrl = new URL(window.location.href);
                    currentUrl.searchParams.delete("partyId");
                    window.history.replaceState({}, "", currentUrl.toString());
                } catch (e) {
                    console.warn("[PARTY CHECK] Failed to remove partyId from URL:", e);
                }
                fetch("/cart.js").then(function(response) {
                    return response.json();
                }).then(function(cart) {
                    var attrs = cart && cart.attributes ? cart.attributes : {};
                    if (!attrs.partyId) return;
                    var updatedAttributes = __assign(__assign({}, attrs), {
                        partyId: ""
                    });
                    return fetch("/cart/update.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            attributes: updatedAttributes
                        })
                    });
                }).catch(function(error) {
                    console.warn("[PARTY CHECK] Failed to clear partyId from cart:", error);
                });
                _this_1.hidePartyBanner();
            };
            _this_1.checkIfPartyExist = function() {
                if (_this_1.isConsultantCustomer()) {
                    console.log("[PARTY CHECK] Consultant customer is not allowed to access party.");
                    _this_1.clearOnlyPartyId();
                    return;
                }
                var queryParams = _this_1.objectFormatting.convertQueryStringToObject(location.search);
                var _a = queryParams, als = _a.als, partyId = _a.partyId;
                fetch("/cart.js").then(function(response) {
                    return response.json();
                }).then(function(cart) {
                    var attrs = cart && cart.attributes ? cart.attributes : {};
                    var cartPartyId = attrs.partyId ? String(attrs.partyId).trim() : "";
                    var partyAllow = attrs.party_allow;
                    var isPartyExplicitlyDisabled = partyAllow !== undefined && partyAllow !== null && String(partyAllow).toLowerCase().trim() === "false";
                    if (isPartyExplicitlyDisabled && (!partyId || partyId === cartPartyId)) {
                        console.log("[PARTY CHECK] party_allow=false for current party. Clearing partyId.");
                        _this_1.clearOnlyPartyId();
                        return;
                    }
                    if (partyId && als) {
                        var lsParty_1 = localStorage.getItem("partyId") || "";
                        if (lsParty_1 !== partyId) {
                            localStorage.setItem("partyId", partyId);
                            localStorage.setItem("webAlias", als);
                        }
                        _this_1.showPartyBanner();
                        console.log("[PARTY CHECK] loading banner from URL party:", partyId, "als:", als);
                        _this_1.getPartyBannerInformation(partyId, als);
                        return;
                    }
                    var lsParty = localStorage.getItem("partyId") || "";
                    var lsAls = localStorage.getItem("webAlias") || "";
                    partyId = lsParty || undefined;
                    als = lsAls || undefined;
                    if (partyId && als) {
                        _this_1.showPartyBanner();
                        console.log("[PARTY CHECK] loading banner from localStorage party:", partyId, "als:", als);
                        _this_1.getPartyBannerInformation(partyId, als);
                    }
                }).catch(function(error) {
                    console.warn("[PARTY CHECK] Failed to check cart party_allow:", error);
                });
            };
            _this_1.getPartyBannerInformation = function(party, webAlias) {
                var _this = _this_1;
                if (_this_1.isConsultantCustomer()) {
                    console.log("[PARTY CHECK] Consultant customer cannot see party banner.");
                    _this_1.clearOnlyPartyId();
                    return;
                }
                var partyBannerWrapper = document.querySelector(".lbri-party-banner_JS");
                if (!partyBannerWrapper) return;
                partyBannerWrapper.classList.remove("st_hidden");
                var loader = partyBannerWrapper.querySelector(".lbri_party_banner_loader_JS");
                loader === null || loader === void 0 ? void 0 : loader.classList.remove("st_hidden");
                try {
                    _this_1.ajax.send({
                        endpoint: _this.endpoint["party"]["party-validation"],
                        method: "POST",
                        contentType: "json",
                        data: {
                            partyId: party
                        },
                        callback: function(res) {
                            var _a;
                            var resp = JSON.parse(res.response);
                            if (((_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.isPartyOpen) === true) {
                                var partyBannerInformationEndpoint = _this.endpoint["party"]["party-banner-information"];
                                partyBannerWrapper.classList.remove("st_hidden");
                                partyBannerWrapper.style.display = "grid";
                                try {
                                    _this_1.ajax.send({
                                        endpoint: partyBannerInformationEndpoint,
                                        method: "POST",
                                        contentType: "json",
                                        data: {
                                            sponsorAlias: webAlias,
                                            partyId: party
                                        },
                                        callback: function(res) {
                                            var resp = JSON.parse(res.response);
                                            loader === null || loader === void 0 ? void 0 : loader.classList.add("st_hidden");
                                            if (resp.status !== 200) {
                                                if (partyBannerWrapper) {
                                                    partyBannerWrapper.classList.add("st_hidden");
                                                    partyBannerWrapper.style.display = "none";
                                                }
                                                return;
                                            }
                                            var hostName = resp.data.partyHostName;
                                            _this.renderHostName(hostName);
                                            _this.renderPartyConsultant(resp.data.partySponsorName);
                                            _this.renderPartyConsultantImage(resp.data.imageUrl);
                                        }
                                    });
                                } catch (err) {
                                    console.log("PartyCheck show banner ---\x3e Error:", err);
                                    loader === null || loader === void 0 ? void 0 : loader.classList.add("st_hidden");
                                }
                            } else {
                                _this_1.clearOnlyPartyId();
                                var partyErrorText = window.stTranslations.partyErrorText;
                                loader === null || loader === void 0 ? void 0 : loader.classList.add("st_hidden");
                                partyBannerWrapper.classList.remove("st_hidden");
                                partyBannerWrapper.style.display = "grid";
                                var hostNameEl = document.querySelector(".lbri-party-banner__center");
                                var partyHostEl = document.querySelector(".lbri-party-banner__left");
                                var partyshareEl = document.querySelector(".lbri-party-banner__right");
                                if (hostNameEl && partyHostEl && partyshareEl) {
                                    partyHostEl.style.display = "none";
                                    partyshareEl.style.display = "none";
                                    hostNameEl.innerText = partyErrorText;
                                }
                            }
                        }
                    });
                } catch (err) {
                    console.log("PartyCheck Validation party ---\x3e Error:", err);
                    loader === null || loader === void 0 ? void 0 : loader.classList.add("st_hidden");
                }
            };
            _this_1.renderHostName = function(hostName) {
                var hostNameEl = document.querySelectorAll(".lbri_cart_party_id--host_JS");
                if (!!hostNameEl) {
                    hostNameEl.forEach(function(host) {
                        if (hostName !== " ") {
                            var lastChar = hostName.substring(hostName.length - 1);
                            if (lastChar === "s") {
                                host.innerHTML = hostName + "'";
                            } else {
                                host.innerHTML = hostName + "'s";
                            }
                        } else {
                            host.innerHTML = hostName;
                        }
                    });
                }
            };
            _this_1.renderPartyConsultant = function(partyConsultant) {
                var partyConslutantEl = document.querySelector(".st_representative-fullname_JS");
                if (partyConslutantEl) {
                    partyConslutantEl.innerHTML = partyConsultant;
                }
            };
            _this_1.renderPartyConsultantImage = function(imageUrl) {
                var cleanImageUrl = imageUrl ? imageUrl.trim() : "";
                console.log("[Party Consultant Image] cleanImageUrl:", cleanImageUrl);
                var avatarWrappers = document.querySelectorAll(".st_repbar_avatar");
                console.log("[Party Consultant Image] avatarWrappers found:", avatarWrappers.length);
                if (avatarWrappers.length === 0) {
                    console.warn("[Party Consultant Image] .st_repbar_avatar not found.");
                    return;
                }
                if (!cleanImageUrl) {
                    console.warn("[Party Consultant Image] Empty imageUrl, keeping default/customer image.");
                    avatarWrappers.forEach(function(avatarWrapper) {
                        var oldPartyImage = avatarWrapper.querySelector(".st_party_representative_image_JS");
                        if (oldPartyImage) {
                            oldPartyImage.remove();
                        }
                        var defaultImage = avatarWrapper.querySelector(".st_representative_image_default_JS");
                        var customerImage = avatarWrapper.querySelector(".st_representative_image_JS");
                        if (customerImage && customerImage.src) {
                            customerImage.style.display = "";
                            customerImage.classList.remove("st_hidden");
                            if (defaultImage) {
                                defaultImage.style.display = "none";
                            }
                        } else if (defaultImage) {
                            defaultImage.style.display = "";
                            defaultImage.classList.remove("st_hidden");
                        }
                    });
                    return;
                }
                var testImg = new Image();
                testImg.onload = function() {
                    console.log("[Party Consultant Image] Image loaded successfully:", cleanImageUrl);
                    avatarWrappers.forEach(function(avatarWrapper) {
                        var oldPartyImage = avatarWrapper.querySelector(".st_party_representative_image_JS");
                        if (oldPartyImage) {
                            oldPartyImage.remove();
                        }
                        var customerImage = avatarWrapper.querySelector(".st_representative_image_JS");
                        if (customerImage) {
                            customerImage.classList.add("st_hidden");
                            customerImage.style.display = "none";
                        }
                        var defaultImage = avatarWrapper.querySelector(".st_representative_image_default_JS");
                        if (defaultImage) {
                            defaultImage.classList.add("st_hidden");
                            defaultImage.style.display = "none";
                        }
                        var imageEl = document.createElement("img");
                        imageEl.className = "st_representative_image st_party_representative_image_JS";
                        imageEl.style.width = "50px";
                        imageEl.style.height = "50px";
                        imageEl.style.objectFit = "cover";
                        imageEl.style.display = "block";
                        imageEl.alt = "representative image";
                        imageEl.src = cleanImageUrl;
                        avatarWrapper.appendChild(imageEl);
                    });
                };
                testImg.onerror = function() {
                    console.warn("[Party Consultant Image] Image failed to load, keeping default/customer image:", cleanImageUrl);
                };
                testImg.src = cleanImageUrl;
            };
            _this_1.sharePartyLink = function() {
                var shareLink = document.getElementById("share-party-link");
                var copiedMessage = document.querySelector(".lbri-party-banner__copied-message");
                if (shareLink && copiedMessage) {
                    shareLink.addEventListener("click", function(e) {
                        e.preventDefault();
                        navigator.clipboard.writeText(window.location.href).then(function() {
                            copiedMessage.classList.add("is-visible");
                            setTimeout(function() {
                                copiedMessage.classList.remove("is-visible");
                            }, 2e3);
                        }).catch(function(err) {
                            console.error("Failed to copy party link:", err);
                        });
                    });
                }
            };
            _this_1.objectFormatting = objectFormatting;
            return _this_1;
        }
        return StPartyCheck;
    }(st_module_69.StModule);
    exports.StPartyCheck = StPartyCheck;
});

define("extension/shopify-app/st-modules/header/header", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_70) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StHeader = void 0;
    var StHeader = function(_super) {
        __extends(StHeader, _super);
        function StHeader(objectFormatting) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StHeader";
            _this_1.init = function() {
                _this_1.getCreditsAmount();
                _this_1.handleLogoAlsParam();
            };
            _this_1.getCreditsAmount = function() {
                var _this = _this_1;
                var customerId = window === null || window === void 0 ? void 0 : window.customerShopifyId;
                if (!customerId) return;
                var getAllCustomerLedger = _this.endpoint["order-credits"]["get-all-customer-ledger"];
                try {
                    _this_1.ajax.send({
                        endpoint: getAllCustomerLedger,
                        method: "POST",
                        contentType: "json",
                        data: {
                            customerId: customerId
                        },
                        callback: function(res) {
                            var resp = JSON.parse(res.response);
                            if (resp.status === 200) {
                                var totalAmount = resp.data.reduce(function(sum, ledger) {
                                    return sum + ledger.Amount;
                                }, 0).toFixed(2);
                                _this.renderTotalAmount(totalAmount);
                            } else {
                                console.log(resp.message);
                            }
                        }
                    });
                } catch (err) {
                    console.log("getCreditsAmount---\x3e Error:", err);
                }
            };
            _this_1.renderTotalAmount = function(totalAmount) {
                var totalAmountEl = document.querySelectorAll(".lbri_header_credit_display--JS");
                if (!!totalAmountEl) {
                    totalAmountEl.forEach(function(el) {
                        var htmlElement = el;
                        htmlElement.classList.remove("st_hidden");
                        htmlElement.innerHTML += totalAmount > 0 ? totalAmount : 0;
                        htmlElement.style.display = "block";
                    });
                }
            };
            _this_1.getCustomerIdFromShopifyAnalytics = function() {
                var _a, _b, _c;
                if ((_c = (_b = (_a = window.ShopifyAnalytics) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.page) === null || _c === void 0 ? void 0 : _c.customerId) {
                    return window.ShopifyAnalytics.meta.page.customerId.toString();
                }
                return null;
            };
            _this_1.handleLogoAlsParam = function() {
                var logoLink = document.querySelector(".wt-header__logo__link");
                if (!logoLink) return;
                var currentUrl;
                try {
                    currentUrl = new URL(window.location.href);
                } catch (_a) {
                    return;
                }
                var als = currentUrl.searchParams.get("als");
                if (!als) {
                    try {
                        als = localStorage.getItem("repId") || localStorage.getItem("RepId") || "";
                    } catch (_b) {
                        als = "";
                    }
                }
                if (!als) return;
                var targetUrl = new URL(logoLink.getAttribute("href") || "/", window.location.origin);
                currentUrl.searchParams.forEach(function(value, key) {
                    targetUrl.searchParams.set(key, value);
                });
                targetUrl.searchParams.set("als", als);
                logoLink.setAttribute("href", targetUrl.toString());
            };
            _this_1.objectFormatting = objectFormatting;
            return _this_1;
        }
        return StHeader;
    }(st_module_70.StModule);
    exports.StHeader = StHeader;
});

define("extension/shopify-app/st-modules/free-sample/free-sample-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_71) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StFreeSampleClassConfig = void 0;
    var StFreeSampleClassConfig = function(_super) {
        __extends(StFreeSampleClassConfig, _super);
        function StFreeSampleClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "FreeSampleClassConfig";
            _this.classNameHidden = "st_hidden";
            _this.classNameEnrollmentPage = "st_enrollment--page_JS";
            _this.selectorEnrollmentPage = "." + _this.classNameEnrollmentPage;
            _this.classNameUpsaleEnrollmentDropdown = "lbri_upsale-dropdown-button_JS";
            _this.selectorUpsaleEnrollmentDropdown = "." + _this.classNameUpsaleEnrollmentDropdown;
            _this.classNameUpsaleEnrollmentCollection = "lbri_upsale-enrollment-collection_JS";
            _this.selectorUpsaleEnrollmentCollection = "." + _this.classNameUpsaleEnrollmentCollection;
            _this.classNameOuterDropdownWrapper = "lbri_upsale-outer-wrapper_JS";
            _this.selectorOuterDropdownWrapper = "." + _this.classNameOuterDropdownWrapper;
            _this.classNameInnerDropdownWrapper = "lbri_upsale-inner-wrapper_JS";
            _this.selectorInnerDropdownWrapper = "." + _this.classNameInnerDropdownWrapper;
            _this.classNameConfirmButton = "lbri_choose_samples-popup-confirm-button_JS";
            _this.selectorConfirmButton = "." + _this.classNameConfirmButton;
            _this.classNameConfirmButtonDisabled = "lbri_choose_samples-popup-confirm-button-disabled";
            _this.classNameConfirmLoader = "lbri_choose_samples-popup-confirm-loader_JS";
            _this.selectorConfirmLoader = "." + _this.classNameConfirmLoader;
            _this.classNameConfirmText = "lbri_choose_samples-popup-confirm-text_JS";
            _this.selectorConfirmText = "." + _this.classNameConfirmText;
            return _this;
        }
        return StFreeSampleClassConfig;
    }(st_module_71.StModule);
    exports.StFreeSampleClassConfig = StFreeSampleClassConfig;
});

define("extension/shopify-app/st-modules/free-sample/free-sample", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_72) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StFreeSample = void 0;
    var StFreeSample = function(_super) {
        __extends(StFreeSample, _super);
        function StFreeSample(classConfig, form, generalMethods, cartComponent) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "FreeSample";
            _this_1.guardBypass = false;
            _this_1.reminderOverlayEl = null;
            _this_1.reminderWrapperEl = null;
            _this_1.chooserOverlaySelector = '.lbri_free-sample-popup-overlay_JS[data-modal="samples-chooser"]';
            _this_1.chooserWrapperSelector = '.lbri_free-sample-wrapper_JS[data-modal="samples-chooser"]';
            _this_1.chooserEventsInitialized = false;
            _this_1.restoreDrawerAfterChooser = false;
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    if (_this_1.isConsultantCustomer()) {
                        return;
                    }
                    var currentCart = _this_1.cartComponent.getShopifyCartData;
                    _this_1.initialization();
                    _this_1.populateInputsFromCart(currentCart);
                    _this_1.attachChangeSamplesOnCart();
                    _this_1.cacheReminder();
                    _this_1.wireCheckoutGuard();
                    _this_1.cartComponent.subscribeChangeCart(function(newCart) {
                        var chooseSponsorPopupWrapper = document.querySelector(_this_1.chooserWrapperSelector);
                        if (!chooseSponsorPopupWrapper) return;
                        if (!chooseSponsorPopupWrapper.classList.contains("active")) {
                            _this_1.populateInputsFromCart(newCart);
                        }
                        _this_1.attachChangeSamplesOnCart();
                        _this_1.wireCheckoutGuard();
                    });
                    if (sessionStorage.getItem("openCartAfterReload") === "true") {
                        sessionStorage.removeItem("openCartAfterReload");
                        _this_1.openCartDrawer();
                    }
                    setTimeout(function() {
                        _this_1.removeHiddenSetup();
                    }, 1e3);
                    _this_1.initGiftSample();
                });
            };
            _this_1.openCartDrawer = function() {
                _this_1.setCartDrawerOpen(true);
            };
            _this_1.initialization = function() {
                _this_1.initChooserEvents();
                _this_1.initFreeSampleFiltersDragScroll();
            };
            _this_1.setCartDrawerOpen = function(shouldOpen) {
                if (window.location.pathname === "/cart" || window.location.pathname === "/account/login") return;
                var drawer = _this_1.cartDrawer();
                if (!drawer || typeof drawer.toggleDrawerClasses !== "function") return;
                if (drawer.hasAttribute("open") !== shouldOpen) {
                    drawer.toggleDrawerClasses();
                }
            };
            _this_1.initChooserEvents = function() {
                if (_this_1.chooserEventsInitialized) return;
                _this_1.chooserEventsInitialized = true;
                document.addEventListener("click", function(event) {
                    var target = event.target;
                    if (!(target instanceof Element)) return;
                    if (target.closest(".lbri_free_samples_change_samples_JS")) {
                        event.preventDefault();
                        _this_1.openChooseSponsorPopup();
                        return;
                    }
                    var chooser = target.closest(_this_1.chooserWrapperSelector);
                    if (target.closest(_this_1.chooserOverlaySelector)) {
                        event.preventDefault();
                        _this_1.closeChooseSponsorPopup();
                        return;
                    }
                    if (!chooser) return;
                    if (target.closest(".lbri_choose_samples-popup_close_JS, .lbri_choose_samples-popup_cancel-button_JS")) {
                        event.preventDefault();
                        _this_1.closeChooseSponsorPopup();
                        return;
                    }
                    var quantityButton = target.closest(".lbri_increment_JS, .lbri_decrement_JS");
                    if (quantityButton) {
                        event.preventDefault();
                        _this_1.quantitySetup(quantityButton);
                        return;
                    }
                    var dropdownButton = target.closest(".lbri_upsale-dropdown-button_JS");
                    if (dropdownButton) {
                        event.preventDefault();
                        _this_1.upsaleEnrollmentDropDownManipulation(dropdownButton);
                        return;
                    }
                    var filterButton = target.closest(".lbri_free-sample-filter-btn_JS");
                    if (filterButton) {
                        event.preventDefault();
                        chooser.querySelectorAll(".lbri_free-sample-filter-btn_JS").forEach(function(button) {
                            button.classList.remove("is-active");
                        });
                        filterButton.classList.add("is-active");
                        _this_1.filterSampleProducts();
                        return;
                    }
                    var confirmButton = target.closest(_this_1.classConfig.selectorConfirmButton);
                    if (confirmButton && !confirmButton.disabled && !confirmButton.classList.contains(_this_1.classConfig.classNameConfirmButtonDisabled)) {
                        event.preventDefault();
                        confirmButton.disabled = true;
                        confirmButton.classList.add(_this_1.classConfig.classNameConfirmButtonDisabled);
                        _this_1.toggleSearchingBtnLoader(true);
                        _this_1.updateCartWithFreeSamples();
                    }
                });
                document.addEventListener("input", function(event) {
                    var target = event.target;
                    if (!(target instanceof HTMLInputElement) || !target.closest(_this_1.chooserWrapperSelector)) return;
                    if (target.matches(".lbri_quantity-input_JS")) {
                        _this_1.quantityPickerRegexValidation(target);
                        _this_1.quantitySetup(target);
                        return;
                    }
                    if (target.matches(".lbri_free-sample-search_JS")) {
                        _this_1.filterSampleProducts();
                    }
                });
            };
            _this_1.removeHiddenSetup = function() {
                var chooseSponsorPopupOverlay = document.querySelector(_this_1.chooserOverlaySelector);
                var chooseSponsorPopupWrapper = document.querySelector(_this_1.chooserWrapperSelector);
                if (!chooseSponsorPopupWrapper) return;
                if (chooseSponsorPopupOverlay && chooseSponsorPopupWrapper) {
                    chooseSponsorPopupOverlay.classList.remove("st_hidden");
                    chooseSponsorPopupWrapper.classList.remove("st_hidden");
                }
            };
            _this_1.openChooseSponsorPopup = function() {
                var _a;
                var chooseSponsorPopupOverlay = document.querySelector(_this_1.chooserOverlaySelector);
                var chooseSponsorPopupWrapper = document.querySelector(_this_1.chooserWrapperSelector);
                if (!chooseSponsorPopupWrapper) return;
                if (chooseSponsorPopupOverlay && chooseSponsorPopupWrapper) {
                    var isAlreadyOpen = chooseSponsorPopupWrapper.classList.contains("active");
                    if (!isAlreadyOpen) {
                        _this_1.restoreDrawerAfterChooser = Boolean((_a = _this_1.cartDrawer()) === null || _a === void 0 ? void 0 : _a.hasAttribute("open"));
                    }
                    _this_1.populateInputsFromCart(_this_1.cartComponent.getShopifyCartData);
                    chooseSponsorPopupOverlay.classList.remove("st_hidden");
                    chooseSponsorPopupWrapper.classList.remove("st_hidden");
                    chooseSponsorPopupOverlay.classList.add("active");
                    chooseSponsorPopupWrapper.classList.add("active");
                    _this_1.setCartDrawerOpen(false);
                    setTimeout(function() {
                        _this_1.initFreeSampleFiltersDragScroll();
                    }, 100);
                }
            };
            _this_1.closeChooseSponsorPopup = function() {
                var chooseSponsorPopupOverlay = document.querySelector(_this_1.chooserOverlaySelector);
                var chooseSponsorPopupWrapper = document.querySelector(_this_1.chooserWrapperSelector);
                if (!chooseSponsorPopupWrapper) return;
                if (chooseSponsorPopupOverlay && chooseSponsorPopupWrapper) {
                    chooseSponsorPopupOverlay.classList.remove("active");
                    chooseSponsorPopupWrapper.classList.remove("active");
                    _this_1.setCartDrawerOpen(_this_1.restoreDrawerAfterChooser);
                    _this_1.restoreDrawerAfterChooser = false;
                }
            };
            _this_1.attachChangeSamplesOnCart = function() {
                _this_1.initChooserEvents();
            };
            _this_1.closeChooseSamplesPopupEventHandle = function() {
                var _this = _this_1;
                var closePopupButtons = document.querySelectorAll(".lbri_choose_samples-popup_close_JS");
                if (closePopupButtons && closePopupButtons.length > 0) {
                    closePopupButtons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            _this.closeChooseSponsorPopup();
                        });
                    });
                }
                var innerPopupOverlay = document.querySelector(".lbri_free-sample-popup-overlay_JS");
                if (innerPopupOverlay) {
                    innerPopupOverlay.addEventListener("click", function() {
                        _this.closeChooseSponsorPopup();
                    });
                }
                var cancelButtons = document.querySelectorAll(".lbri_choose_samples-popup_cancel-button_JS");
                if (cancelButtons && cancelButtons.length > 0) {
                    cancelButtons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            _this.closeChooseSponsorPopup();
                        });
                    });
                }
            };
            _this_1.dropDownHandle = function() {
                var _this = _this_1;
                var buttons = document.querySelectorAll(".lbri_upsale-dropdown-button_JS");
                buttons.forEach(function(button) {
                    button.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.upsaleEnrollmentDropDownManipulation(button);
                    });
                });
            };
            _this_1.upsaleEnrollmentDropDownManipulation = function(button) {
                var closestCollection = _this_1.generalMethods.getClosestByClass(button, _this_1.classConfig.classNameUpsaleEnrollmentCollection);
                var currentOuterWrapper = closestCollection.querySelector(_this_1.classConfig.selectorOuterDropdownWrapper);
                var isOpen = button.getAttribute("aria-expanded");
                if (isOpen === "false") {
                    _this_1.toggleClass(currentOuterWrapper);
                    button.setAttribute("aria-expanded", "true");
                } else {
                    _this_1.toggleClass(currentOuterWrapper);
                    button.setAttribute("aria-expanded", "false");
                }
            };
            _this_1.toggleClass = function(el) {
                if (el.classList.contains("active")) {
                    el.classList.add("inactive");
                    el.classList.remove("active");
                } else {
                    el.classList.remove("inactive");
                    el.classList.add("active");
                }
            };
            _this_1.populateInputsFromCart = function(currentCart) {
                var cartItems = (currentCart === null || currentCart === void 0 ? void 0 : currentCart.items) || [];
                var freeSamplesFromCar = [];
                cartItems.forEach(function(cartItem) {
                    var _a;
                    if ((_a = cartItem === null || cartItem === void 0 ? void 0 : cartItem.properties) === null || _a === void 0 ? void 0 : _a._isFreeSample) {
                        freeSamplesFromCar["".concat(cartItem.variant_id)] = cartItem.quantity;
                    }
                });
                var chooseSamplesSectionWrapper = document.querySelector(".lbri_choose_samples-section-wrapper");
                if (!!chooseSamplesSectionWrapper) {
                    var allInputWrappers = chooseSamplesSectionWrapper.querySelectorAll('div[name="inputs-wrapper"]');
                    if (!!allInputWrappers) {
                        allInputWrappers.forEach(function(inputWrappers, index) {
                            var input = inputWrappers.querySelector('input[name="quantity"]');
                            if (!input) return;
                            var variantId = inputWrappers.getAttribute("current-variant-id");
                            var quantity = freeSamplesFromCar[variantId];
                            input.value = quantity !== null && quantity !== void 0 ? quantity : 0;
                            _this_1.quantitySetup(input);
                        });
                    }
                }
            };
            _this_1.quantitySetup = function(button) {
                var closestWrapper = button.closest(".lbri_quantity_JS");
                if (!closestWrapper) return;
                var inputField = closestWrapper.querySelector(".lbri_quantity-input_JS");
                if (!inputField) return;
                var inputFieldValue = parseInt(inputField.value);
                _this_1.incrementOrDecrement(button, inputField, inputFieldValue);
                _this_1.handleQuantityCases(button, inputField);
            };
            _this_1.incrementOrDecrement = function(button, inputField, inputFieldValue) {
                if (button.classList.contains("lbri_increment_JS")) {
                    var newValue = parseInt(inputFieldValue) > 0 ? 0 : 1;
                    inputField.setAttribute("value", "" + newValue);
                    inputField.value = "" + newValue;
                }
                if (button.classList.contains("lbri_decrement_JS")) {
                    var newValue = parseInt(inputFieldValue) - 1;
                    inputField.setAttribute("value", "" + newValue);
                    inputField.value = "" + newValue;
                }
            };
            _this_1.handleQuantityCases = function(button, inputField) {
                var mainWrapper = button.closest(".lbri_upsale-enrollment-dropdown-content_JS");
                if (!mainWrapper) return;
                var decrementButton = mainWrapper.querySelector(".lbri_decrement_JS");
                if (!decrementButton) return;
                var parsedValue = parseInt(inputField.value);
                if (parsedValue < 0) {
                    inputField.value = "0";
                }
                if (parsedValue === 0) {
                    inputField.setAttribute("value", "0");
                    inputField.value = String(parsedValue);
                    decrementButton.disabled = true;
                    inputField.disabled = false;
                }
                if (parsedValue > 0) {
                    inputField.value = "" + parsedValue;
                    button.disabled = false;
                    inputField.setAttribute("value", "" + parsedValue);
                    decrementButton.disabled = false;
                } else {
                    decrementButton.disabled = true;
                    inputField.setAttribute("value", "" + parsedValue);
                }
                if (inputField.value === "" || isNaN(parseInt(inputField.value))) {
                    inputField.value = "0";
                    inputField.setAttribute("value", "0");
                    inputField.disabled = false;
                }
                var freeSamplesLimit = window.freeShippingLimit.free_samples_limit;
                var sumSampleQuantities = 0;
                var chooseSamplesSectionWrapper = document.querySelector(".lbri_choose_samples-section-wrapper");
                if (!chooseSamplesSectionWrapper) {
                    return;
                }
                var allInputWrappers = chooseSamplesSectionWrapper.querySelectorAll('div[name="inputs-wrapper"]');
                if (!allInputWrappers) {
                    return;
                }
                allInputWrappers.forEach(function(inputWrappers) {
                    var input = inputWrappers.querySelector('input[name="quantity"]');
                    sumSampleQuantities = sumSampleQuantities + parseInt(input.value);
                });
                allInputWrappers.forEach(function(inputWrappers) {
                    var input = inputWrappers.querySelector('input[name="quantity"]');
                    var incrementButton = inputWrappers.querySelector(".lbri_increment_JS");
                    var productWrapper = inputWrappers.closest(".lbri_free-sample-product_JS");
                    var currentValue = parseInt(input.value);
                    var isSelected = currentValue > 0;
                    var variantId = inputWrappers.getAttribute("current-variant-id");
                    var isSampleAlreadyInCart = _this_1.isFreeSampleVariantInCart(variantId);
                    var isPendingRemove = !isSelected && isSampleAlreadyInCart;
                    productWrapper === null || productWrapper === void 0 ? void 0 : productWrapper.classList.toggle("is-selected", isSelected);
                    productWrapper === null || productWrapper === void 0 ? void 0 : productWrapper.classList.toggle("is-pending-remove", isPendingRemove);
                    if (sumSampleQuantities >= freeSamplesLimit && !isSelected && !isPendingRemove) {
                        incrementButton.disabled = true;
                    } else {
                        incrementButton.disabled = false;
                    }
                });
                var allRemainingCounters = document.querySelectorAll(".lbri_choose_samples-remaining-counter_JS");
                allRemainingCounters.forEach(function(remainingCounters) {
                    remainingCounters.innerHTML = " " + (freeSamplesLimit - sumSampleQuantities).toString();
                });
                _this_1.updateFreeSampleConfirmButtonState(sumSampleQuantities);
                var closestWrapper = _this_1.generalMethods.getClosestByClass(inputField, "lbri_upsale-enrollment-dropdown-content_JS");
                var continueSellingOutOfStock = closestWrapper === null || closestWrapper === void 0 ? void 0 : closestWrapper.getAttribute("out-of-stock");
                if (!!continueSellingOutOfStock) {
                    var maxAvailableQuantity = closestWrapper.getAttribute("product-available-quantity");
                    if (parsedValue > Number(maxAvailableQuantity) && continueSellingOutOfStock === "deny") {
                        inputField.value = maxAvailableQuantity;
                        inputField.setAttribute("value", maxAvailableQuantity);
                    }
                }
            };
            _this_1.updateFreeSampleConfirmButtonState = function(sumSampleQuantities) {
                var confirmButton = document.querySelector(_this_1.classConfig.selectorConfirmButton);
                var confirmText = document.querySelector(_this_1.classConfig.selectorConfirmText);
                if (!confirmButton) {
                    return;
                }
                var hasSelectedSamplesInPopup = sumSampleQuantities > 0;
                var hasSamplesAlreadyInCart = _this_1.countSamplesInCart() > 0;
                var shouldEnableButton = hasSelectedSamplesInPopup || hasSamplesAlreadyInCart;
                var isRemoveMode = sumSampleQuantities === 0 && hasSamplesAlreadyInCart;
                if (confirmText) {
                    confirmText.textContent = isRemoveMode ? "REMOVE" : "ADD TO CART";
                }
                confirmButton.classList.toggle("is-remove-mode", isRemoveMode);
                if (shouldEnableButton) {
                    confirmButton.classList.remove(_this_1.classConfig.classNameConfirmButtonDisabled);
                    confirmButton.classList.remove("lbri_disable_JS");
                    confirmButton.disabled = false;
                } else {
                    confirmButton.classList.add(_this_1.classConfig.classNameConfirmButtonDisabled);
                    confirmButton.classList.add("lbri_disable_JS");
                    confirmButton.disabled = true;
                }
            };
            _this_1.inputEvents = function() {
                var _this = _this_1;
                var quantityInputs = document.querySelectorAll(".lbri_quantity-input_JS");
                quantityInputs.forEach(function(quantityInput) {
                    _this.quantitySetup(quantityInput);
                    quantityInput.addEventListener("input", function() {
                        _this.quantitySetup(this);
                        _this.quantityPickerRegexValidation(this);
                    });
                });
            };
            _this_1.quantityPickerRegexValidation = function(inputField) {
                var validStringMatchArray = inputField.value.match(new RegExp(/(^[0-9]*$)/));
                inputField.value = validStringMatchArray && validStringMatchArray.length > 0 ? validStringMatchArray[0] : "";
                inputField.setAttribute("value", String(parseInt(inputField.value)));
                var inputValue = parseInt(inputField.value);
                return inputValue;
            };
            _this_1.incrementButton = function() {
                var _this = _this_1;
                var incrementButtons = document.querySelectorAll(".lbri_increment_JS");
                incrementButtons.forEach(function(btn) {
                    btn.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.quantitySetup(this);
                    });
                });
            };
            _this_1.decrementButton = function() {
                var _this = _this_1;
                var decrementButtons = document.querySelectorAll(".lbri_decrement_JS");
                decrementButtons.forEach(function(btn) {
                    btn.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.quantitySetup(this);
                    });
                });
            };
            _this_1.updateCartWithFreeSamples = function() {
                if (_this_1.isConsultantCustomer()) {
                    console.warn("CONSULTANT CAN NOT ADD FREE SAMPLES");
                    return;
                }
                var freeSampleList = [];
                var freeSampleTotalQuantity = 0;
                var chooseSamplesSectionWrapper = document.querySelector(".lbri_choose_samples-section-wrapper");
                var allInputWrappers = chooseSamplesSectionWrapper.querySelectorAll('div[name="inputs-wrapper"]');
                allInputWrappers.forEach(function(inputWrapper) {
                    var input = inputWrapper.querySelector('input[name="quantity"]');
                    if (parseInt(input.value) > 0) {
                        freeSampleTotalQuantity += parseInt(input.value);
                        freeSampleList.push({
                            variantId: inputWrapper.getAttribute("current-variant-id"),
                            sku: inputWrapper.getAttribute("current-variant-sku"),
                            quantity: parseInt(input.value)
                        });
                    }
                });
                var confirmButton = document.querySelector(_this_1.classConfig.selectorConfirmButton);
                var freeSamplesLimit = window.freeShippingLimit.free_samples_limit;
                var isInvalidAmountOfFreeSamples = freeSampleTotalQuantity > freeSamplesLimit;
                if (isInvalidAmountOfFreeSamples) {
                    var allRemainingCounters = document.querySelectorAll(".lbri_choose_samples-remaining-counter_JS");
                    allRemainingCounters.forEach(function(remainingCounters, index) {
                        remainingCounters.classList.add("lbri_choose_samples-remaining-counter-error");
                        setTimeout(function() {
                            remainingCounters.classList.remove("lbri_choose_samples-remaining-counter-error");
                            confirmButton.classList.remove(_this_1.classConfig.classNameConfirmButtonDisabled);
                            _this_1.toggleSearchingBtnLoader(false);
                        }, 3e3);
                    });
                    var chooseSamplesTexts = document.querySelectorAll(".lbri_choose_samples-popup-text_JS");
                    chooseSamplesTexts.forEach(function(chooseSamplesText, index) {
                        chooseSamplesText.classList.add("lbri_choose_samples-popup-text-error");
                        setTimeout(function() {
                            chooseSamplesText.classList.remove("lbri_choose_samples-popup-text-error");
                            confirmButton.classList.remove(_this_1.classConfig.classNameConfirmButtonDisabled);
                            _this_1.toggleSearchingBtnLoader(false);
                        }, 3e3);
                    });
                } else {
                    _this_1.cartComponent.overrideFreeSamples(freeSampleList);
                }
            };
            _this_1.buttonClickButtons = function() {
                var buttonChooseSamples = document.querySelectorAll(_this_1.classConfig.selectorConfirmButton);
                buttonChooseSamples.forEach(function(button) {
                    button.addEventListener("click", function(e) {
                        e.preventDefault();
                        console.log("CLICKED buttonClickButtons");
                        console.log("button.classList.contains(this.classConfig.classNameConfirmButtonDisabled)", button.classList.contains(_this_1.classConfig.classNameConfirmButtonDisabled));
                        if (!button.classList.contains(_this_1.classConfig.classNameConfirmButtonDisabled)) {
                            button.classList.add(_this_1.classConfig.classNameConfirmButtonDisabled);
                            console.log("button.classList.contains(this.classConfig.classNameConfirmButtonDisabled)", button.classList.contains(_this_1.classConfig.classNameConfirmButtonDisabled));
                            console.log("CLICKED buttonClickButtons does not contain disabled");
                            _this_1.toggleSearchingBtnLoader(true);
                            _this_1.updateCartWithFreeSamples();
                        }
                    });
                });
            };
            _this_1.removeFreeSamplesFromCart = function() {
                _this_1.cartComponent.removeFreeSamplesFromCart(true, function() {});
            };
            _this_1.toggleSearchingBtnLoader = function(isLoading) {
                var btnLoader = document.querySelector(_this_1.classConfig.selectorConfirmLoader);
                if (!btnLoader) return;
                var btnLabel = document.querySelector(_this_1.classConfig.selectorConfirmText);
                if (!btnLabel) return;
                var chooseSamplesSectionWrapper = document.querySelector(".lbri_choose_samples-section-wrapper");
                if (!chooseSamplesSectionWrapper) {
                    return;
                }
                var allInputWrappers = chooseSamplesSectionWrapper.querySelectorAll('div[name="inputs-wrapper"]');
                if (!allInputWrappers) {
                    return;
                }
                if (isLoading) {
                    btnLoader.classList.remove(_this_1.classConfig.classNameHidden);
                    btnLabel.classList.add(_this_1.classConfig.classNameHidden);
                    allInputWrappers === null || allInputWrappers === void 0 ? void 0 : allInputWrappers.forEach(function(inputWrappers) {
                        var incrementButton = inputWrappers.querySelector(".lbri_increment_JS");
                        incrementButton.disabled = true;
                        var decrementButton = inputWrappers.querySelector(".lbri_decrement_JS");
                        decrementButton.disabled = true;
                    });
                } else {
                    btnLoader.classList.add(_this_1.classConfig.classNameHidden);
                    btnLabel.classList.remove(_this_1.classConfig.classNameHidden);
                }
            };
            _this_1.wireCheckoutGuard = function() {
                var buttons = Array.from(document.querySelectorAll(".wt-cart__cta_JS"));
                buttons.forEach(function(btn) {
                    btn.removeEventListener("click", _this_1.checkoutHandler);
                    btn.addEventListener("click", _this_1.checkoutHandler, {
                        passive: false
                    });
                });
                _this_1.cacheReminder();
            };
            _this_1.checkoutHandler = function(e) {
                if (_this_1.guardBypass) return;
                _this_1.cacheReminder();
                if (!_this_1.reminderOverlayEl || !_this_1.reminderWrapperEl) {
                    return;
                }
                if (_this_1.shouldShowReminder()) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                    _this_1.showReminder();
                }
            };
            _this_1.handleReminderKeydown = function(e) {
                var _a;
                if (e.key === "Enter") {
                    e.preventDefault();
                    (_a = _this_1.noBtnEl) === null || _a === void 0 ? void 0 : _a.click();
                } else if (e.key === "Escape") {
                    e.preventDefault();
                    _this_1.hideReminder();
                }
            };
            _this_1.initGiftSample = function() {
                var wrapper = document.querySelector(".lbri-gift-sample_JS");
                var button = document.querySelector(".lbri-gift-sample__button_JS");
                var closeBtn = document.querySelector(".lbri-gift-sample__close_JS");
                if (!wrapper || !button) return;
                button.addEventListener("click", function(e) {
                    e.stopPropagation();
                    wrapper.classList.add("is-open");
                });
                closeBtn === null || closeBtn === void 0 ? void 0 : closeBtn.addEventListener("click", function(e) {
                    e.stopPropagation();
                    wrapper.classList.remove("is-open");
                });
                document.addEventListener("click", function(e) {
                    if (!wrapper.contains(e.target)) {
                        wrapper.classList.remove("is-open");
                    }
                });
            };
            _this_1.initSampleSearchAndFilters = function() {
                var searchInput = document.querySelector(".lbri_free-sample-search_JS");
                var filterButtons = document.querySelectorAll(".lbri_free-sample-filter-btn_JS");
                searchInput === null || searchInput === void 0 ? void 0 : searchInput.addEventListener("input", function() {
                    _this_1.filterSampleProducts();
                });
                filterButtons.forEach(function(button) {
                    button.addEventListener("click", function() {
                        filterButtons.forEach(function(btn) {
                            return btn.classList.remove("is-active");
                        });
                        button.classList.add("is-active");
                        _this_1.filterSampleProducts();
                    });
                });
            };
            _this_1.filterSampleProducts = function() {
                var _a;
                var searchInput = document.querySelector(".lbri_free-sample-search_JS");
                var activeFilterButton = document.querySelector(".lbri_free-sample-filter-btn_JS.is-active");
                var sampleProducts = document.querySelectorAll(".lbri_free-sample-product_JS");
                var emptyState = document.querySelector(".lbri_free-sample-empty-state_JS");
                var searchValue = (searchInput === null || searchInput === void 0 ? void 0 : searchInput.value.trim().toLowerCase()) || "";
                var activeTag = ((_a = activeFilterButton === null || activeFilterButton === void 0 ? void 0 : activeFilterButton.dataset.tag) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || "all";
                var visibleProductsCount = 0;
                sampleProducts.forEach(function(product) {
                    var _a, _b;
                    var productTitle = ((_a = product.dataset.title) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || "";
                    var productTags = ((_b = product.dataset.tags) === null || _b === void 0 ? void 0 : _b.toLowerCase()) || "";
                    var matchesSearch = productTitle.includes(searchValue);
                    var matchesTag = activeTag === "all" || productTags.includes(activeTag);
                    var shouldShow = matchesSearch && matchesTag;
                    product.classList.toggle("st_hidden", !shouldShow);
                    if (shouldShow) {
                        visibleProductsCount += 1;
                    }
                });
                emptyState === null || emptyState === void 0 ? void 0 : emptyState.classList.toggle("st_hidden", visibleProductsCount > 0);
            };
            _this_1.isConsultantCustomer = function() {
                var _a, _b, _c, _d;
                if (document.querySelector(".lbr_consultant-discount-main-wrp_JS")) {
                    return true;
                }
                var customerInfo = window.customerInfoMetafields;
                var customerType = String((_c = (_b = (_a = customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.value) === null || _a === void 0 ? void 0 : _a.customerType) !== null && _b !== void 0 ? _b : customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.customerType) !== null && _c !== void 0 ? _c : "").trim().toLowerCase();
                if (customerType === "consultant") {
                    return true;
                }
                var cart = _this_1.cartComponent.getShopifyCartData;
                var tagsFromCart = (_d = cart === null || cart === void 0 ? void 0 : cart.attributes) === null || _d === void 0 ? void 0 : _d._customerTags;
                if (Array.isArray(tagsFromCart)) {
                    if (tagsFromCart.some(function(tag) {
                        return String(tag).toLowerCase().includes("consultant");
                    })) {
                        return true;
                    }
                }
                var windowTags = window.customerTags;
                if (Array.isArray(windowTags)) {
                    return windowTags.some(function(tag) {
                        return String(tag).toLowerCase().includes("consultant");
                    });
                }
                return false;
            };
            _this_1.isFreeSampleVariantInCart = function(variantId) {
                if (!variantId) {
                    return false;
                }
                var cart = _this_1.cartComponent.getShopifyCartData;
                var items = (cart === null || cart === void 0 ? void 0 : cart.items) || [];
                return items.some(function(item) {
                    var _a;
                    return ((_a = item === null || item === void 0 ? void 0 : item.properties) === null || _a === void 0 ? void 0 : _a._isFreeSample) && String(item.variant_id) === String(variantId);
                });
            };
            _this_1.initFreeSampleFiltersDragScroll = function() {
                var slider = document.querySelector(".lbri_free-sample-filter-list");
                var scrollbar = document.querySelector(".lbri_free-sample-scrollbar_JS");
                var thumb = document.querySelector(".lbri_free-sample-scrollbar-thumb_JS");
                if (!slider || !scrollbar || !thumb) return;
                if (slider.dataset.lbrDragScrollInitialized === "true") {
                    window.dispatchEvent(new Event("resize"));
                    return;
                }
                slider.dataset.lbrDragScrollInitialized = "true";
                var isDown = false;
                var startX = 0;
                var scrollLeft = 0;
                var updateScrollbarThumb = function() {
                    var maxScrollLeft = slider.scrollWidth - slider.clientWidth;
                    if (maxScrollLeft <= 0) {
                        scrollbar.classList.add("st_hidden");
                        return;
                    }
                    scrollbar.classList.remove("st_hidden");
                    var scrollbarWidth = scrollbar.clientWidth;
                    var thumbWidth = Math.max(slider.clientWidth / slider.scrollWidth * scrollbarWidth, 48);
                    var maxThumbMove = scrollbarWidth - thumbWidth;
                    var scrollPercentage = slider.scrollLeft / maxScrollLeft;
                    thumb.style.width = "".concat(thumbWidth, "px");
                    thumb.style.transform = "translateX(".concat(scrollPercentage * maxThumbMove, "px)");
                };
                updateScrollbarThumb();
                setTimeout(function() {
                    updateScrollbarThumb();
                }, 100);
                slider.addEventListener("scroll", updateScrollbarThumb);
                window.addEventListener("resize", updateScrollbarThumb);
                slider.addEventListener("mousedown", function(e) {
                    isDown = true;
                    slider.classList.add("is-dragging");
                    startX = e.pageX - slider.offsetLeft;
                    scrollLeft = slider.scrollLeft;
                });
                slider.addEventListener("mouseleave", function() {
                    isDown = false;
                    slider.classList.remove("is-dragging");
                });
                slider.addEventListener("mouseup", function() {
                    isDown = false;
                    slider.classList.remove("is-dragging");
                });
                slider.addEventListener("mousemove", function(e) {
                    if (!isDown) return;
                    e.preventDefault();
                    var x = e.pageX - slider.offsetLeft;
                    var walk = x - startX;
                    slider.scrollLeft = scrollLeft - walk;
                });
            };
            _this_1.classConfig = classConfig;
            _this_1.form = form;
            _this_1.generalMethods = generalMethods;
            _this_1.cartComponent = cartComponent;
            _this_1.cartDrawer = function() {
                return document.body.querySelector("cart-drawer");
            };
            return _this_1;
        }
        StFreeSample.prototype.shouldShowReminder = function() {
            return this.qualifiesForFreeSamples() && this.countSamplesInCart() === 0;
        };
        StFreeSample.prototype.qualifiesForFreeSamples = function() {
            var _a;
            var windowLimit = (_a = window === null || window === void 0 ? void 0 : window.freeShippingLimit) === null || _a === void 0 ? void 0 : _a.free_shipping_limit;
            var threshold = typeof windowLimit === "number" ? windowLimit : undefined;
            if (threshold === undefined) {
                var progressEl = document.querySelector(".lbr_free-shipping-main-wrp .progress-done");
                threshold = Number((progressEl === null || progressEl === void 0 ? void 0 : progressEl.getAttribute("data-limit")) || 0);
            }
            var cart = this.cartComponent.getShopifyCartData;
            var items = (cart === null || cart === void 0 ? void 0 : cart.items) || [];
            var total = 0;
            items.forEach(function(it) {
                var _a;
                if (!((_a = it === null || it === void 0 ? void 0 : it.properties) === null || _a === void 0 ? void 0 : _a._isFreeSample)) {
                    total += (it.quantity || 0) * ((it.price || 0) / 100);
                }
            });
            return threshold > 0 && total >= threshold;
        };
        StFreeSample.prototype.countSamplesInCart = function() {
            var cart = this.cartComponent.getShopifyCartData;
            var items = (cart === null || cart === void 0 ? void 0 : cart.items) || [];
            return items.reduce(function(acc, it) {
                var _a;
                return acc + (((_a = it === null || it === void 0 ? void 0 : it.properties) === null || _a === void 0 ? void 0 : _a._isFreeSample) ? it.quantity || 0 : 0);
            }, 0);
        };
        StFreeSample.prototype.cacheReminder = function() {
            var _this_1 = this;
            var _a;
            this.reminderOverlayEl = document.querySelector('.lbri_free-sample-popup-overlay_JS[data-modal="samples-reminder"]');
            this.reminderWrapperEl = document.querySelector('.lbri_free-sample-wrapper_JS[data-modal="samples-reminder"]');
            if (!this.reminderOverlayEl || !this.reminderWrapperEl) return;
            if (this.reminderWrapperEl.dataset.lbrReminderInitialized === "true") {
                this.noBtnEl = this.reminderWrapperEl.querySelector(".lbri_reminder-no_JS, .lbri_cancel-button") || undefined;
                this.yesBtnEl = this.reminderWrapperEl.querySelector('[data-role="samples-reminder-yes"]') || undefined;
                return;
            }
            this.reminderWrapperEl.dataset.lbrReminderInitialized = "true";
            this.reminderOverlayEl.addEventListener("click", function() {
                return _this_1.hideReminder();
            });
            this.reminderWrapperEl.querySelectorAll('[data-close="true"]').forEach(function(el) {
                el.addEventListener("click", function() {
                    return _this_1.hideReminder();
                });
            });
            this.noBtnEl = this.reminderWrapperEl.querySelector(".lbri_reminder-no_JS, .lbri_cancel-button") || undefined;
            this.yesBtnEl = this.reminderWrapperEl.querySelector('[data-role="samples-reminder-yes"]') || undefined;
            (_a = this.noBtnEl) === null || _a === void 0 ? void 0 : _a.addEventListener("click", function(e) {
                e.preventDefault();
                e.stopPropagation();
                _this_1.hideReminder();
                _this_1.openChooseSponsorPopup();
            });
            if (this.yesBtnEl) {
                this.yesBtnEl.disabled = false;
                this.yesBtnEl.removeAttribute("disabled");
                this.yesBtnEl.removeAttribute("tabindex");
                this.yesBtnEl.addEventListener("click", function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    _this_1.guardBypass = true;
                    _this_1.hideReminder();
                    var explicitCta = document.querySelector('#CartDrawer-Checkout, [name="checkout"][form="CartDrawer-Form"]');
                    if (explicitCta) {
                        explicitCta.removeAttribute("disabled");
                        explicitCta.dispatchEvent(new MouseEvent("click", {
                            bubbles: true,
                            cancelable: true
                        }));
                        setTimeout(function() {
                            return _this_1.guardBypass = false;
                        }, 1500);
                        return;
                    }
                    var form = document.getElementById("CartDrawer-Form");
                    if (form) {
                        var hidden = document.createElement("input");
                        hidden.type = "hidden";
                        hidden.name = "checkout";
                        hidden.value = "Checkout";
                        form.appendChild(hidden);
                        try {
                            form.requestSubmit ? form.requestSubmit() : form.submit();
                        } catch (_a) {
                            form.submit();
                        }
                        setTimeout(function() {
                            return _this_1.guardBypass = false;
                        }, 1500);
                        return;
                    }
                    window.location.assign("/checkout");
                    setTimeout(function() {
                        return _this_1.guardBypass = false;
                    }, 1500);
                });
            }
        };
        StFreeSample.prototype.showReminder = function() {
            var _this_1 = this;
            var _a, _b, _c, _d, _e;
            if (!this.reminderOverlayEl || !this.reminderWrapperEl) this.cacheReminder();
            (_a = this.reminderOverlayEl) === null || _a === void 0 ? void 0 : _a.classList.remove("st_hidden");
            (_b = this.reminderWrapperEl) === null || _b === void 0 ? void 0 : _b.classList.remove("st_hidden");
            (_c = this.reminderOverlayEl) === null || _c === void 0 ? void 0 : _c.classList.add("active");
            (_d = this.reminderWrapperEl) === null || _d === void 0 ? void 0 : _d.classList.add("active");
            document.body.classList.add("lbri-modal-open");
            this.yesBtnEl && (this.yesBtnEl.disabled = false);
            (_e = this.reminderWrapperEl) === null || _e === void 0 ? void 0 : _e.addEventListener("keydown", this.handleReminderKeydown, {
                once: true
            });
            setTimeout(function() {
                var _a;
                return (_a = _this_1.noBtnEl) === null || _a === void 0 ? void 0 : _a.focus();
            }, 0);
        };
        StFreeSample.prototype.hideReminder = function() {
            var _a, _b, _c, _d, _e;
            (_a = this.reminderOverlayEl) === null || _a === void 0 ? void 0 : _a.classList.add("st_hidden");
            (_b = this.reminderWrapperEl) === null || _b === void 0 ? void 0 : _b.classList.add("st_hidden");
            (_c = this.reminderOverlayEl) === null || _c === void 0 ? void 0 : _c.classList.remove("active");
            (_d = this.reminderWrapperEl) === null || _d === void 0 ? void 0 : _d.classList.remove("active");
            document.body.classList.remove("lbri-modal-open");
            (_e = this.reminderWrapperEl) === null || _e === void 0 ? void 0 : _e.removeEventListener("keydown", this.handleReminderKeydown);
        };
        return StFreeSample;
    }(st_module_72.StModule);
    exports.StFreeSample = StFreeSample;
});

define("extension/shopify-app/st-modules/samples-set/samples-set-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_73) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSampleSetClassConfig = void 0;
    var StSampleSetClassConfig = function(_super) {
        __extends(StSampleSetClassConfig, _super);
        function StSampleSetClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SampleSetClassConfig";
            _this.classNameSampleButton = "sample-button";
            _this.selectorSampleButton = "." + _this.classNameSampleButton;
            _this.modalBackdropId = "sample-modal";
            _this.modalContinueId = "sample-modal-continue";
            _this.classNameNotAllowed = "not-allowed";
            _this.classNameAlreadyPurchased = "already-purchased";
            _this.classNameSelected = "selected";
            return _this;
        }
        return StSampleSetClassConfig;
    }(st_module_73.StModule);
    exports.StSampleSetClassConfig = StSampleSetClassConfig;
});

define("extension/shopify-app/st-modules/samples-set/samples-set", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_74) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSampleSet = void 0;
    var StSampleSet = function(_super) {
        __extends(StSampleSet, _super);
        function StSampleSet(config, cartComponent) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SampleSet";
            _this.selectedVariantId = null;
            _this.selectedButton = null;
            _this.sampleVariants = [];
            _this.customerTags = [];
            _this.customerType = "unknown";
            _this.isLoggedIn = false;
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.sampleVariants = window.SAMPLE_VARIANTS || [];
                    _this.customerTags = window.CUSTOMER_TAGS || [];
                    _this.customerType = window.CUSTOMER_TYPE || "unknown";
                    _this.isLoggedIn = !!window.IS_LOGGED_IN;
                    _this.fetchCartAndSetupButtons();
                    _this.bindModalConfirm();
                });
            };
            _this.config = config;
            _this.cartComponent = cartComponent;
            return _this;
        }
        StSampleSet.prototype.fetchCartAndSetupButtons = function() {
            var cart = this.cartComponent.getShopifyCartData;
            this.setupButtons(cart);
        };
        StSampleSet.prototype.setupButtons = function(cart) {
            var _this = this;
            var sampleInCart = cart.items.find(function(item) {
                return _this.sampleVariants.includes(item.variant_id);
            });
            var buttons = document.querySelectorAll(this.config.selectorSampleButton);
            var userInfo = window.customerInfoMetafields;
            if (userInfo === null || userInfo === void 0 ? void 0 : userInfo.customerType) {
                this.customerType = userInfo.customerType;
            }
            buttons.forEach(function(btn) {
                var variantId = parseInt(btn.dataset.variantId || "0");
                var sku = btn.dataset.sku || "";
                var isSampleInSession = sessionStorage.getItem("sampleInCart") === "true";
                if (isSampleInSession && !_this.sampleVariants.includes(variantId)) {
                    btn.disabled = true;
                    btn.innerText = "NOT ALLOWED";
                    btn.classList.add(_this.config.classNameNotAllowed);
                    return;
                }
                if (!_this.isLoggedIn || _this.customerType !== "retail") {
                    btn.innerText = "ADD SAMPLE";
                    btn.disabled = true;
                    btn.classList.add(_this.config.classNameNotAllowed);
                    return;
                }
                var alreadyPurchased = sku && _this.customerTags.some(function(tag) {
                    return tag.startsWith("LSSF-") && tag.includes(sku);
                });
                if (alreadyPurchased) {
                    btn.innerText = "ALREADY PURCHASED";
                    btn.disabled = true;
                    btn.classList.add(_this.config.classNameAlreadyPurchased);
                    return;
                }
                var newBtn = btn.cloneNode(true);
                btn.replaceWith(newBtn);
                if (sampleInCart && variantId === sampleInCart.variant_id) {
                    _this.transformButtonToRemove(newBtn);
                    newBtn.addEventListener("click", _this.wrapAsyncButton(newBtn, function() {
                        return _this.removeSample(variantId);
                    }));
                } else if (sampleInCart) {
                    newBtn.disabled = true;
                } else {
                    newBtn.innerText = "ADD SAMPLE";
                    newBtn.addEventListener("click", function() {
                        return _this.openModal(variantId, newBtn);
                    });
                }
            });
        };
        StSampleSet.prototype.openModal = function(variantId, button) {
            if (button.classList.contains(this.config.classNameSelected)) return;
            this.selectedVariantId = variantId;
            this.selectedButton = button;
            var modal = document.getElementById(this.config.modalBackdropId);
            if (modal) modal.style.display = "flex";
        };
        StSampleSet.prototype.closeModal = function() {
            var modal = document.getElementById(this.config.modalBackdropId);
            if (modal) modal.style.display = "none";
            this.selectedVariantId = null;
            this.selectedButton = null;
        };
        StSampleSet.prototype.bindModalConfirm = function() {
            var _this = this;
            var _a;
            (_a = document.getElementById(this.config.modalContinueId)) === null || _a === void 0 ? void 0 : _a.addEventListener("click", function() {
                return _this.confirmSample();
            });
        };
        StSampleSet.prototype.confirmSample = function() {
            var _this = this;
            if (!this.selectedVariantId || !this.selectedButton) return;
            this.toggleLoader(true);
            fetch("/cart/clear.js", {
                method: "POST"
            }).then(function() {
                sessionStorage.setItem("sampleInCart", "true");
                return fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        items: [ {
                            id: _this.selectedVariantId,
                            quantity: 1,
                            properties: {
                                _is_sample: "true"
                            }
                        } ]
                    })
                });
            }).then(function() {
                return fetch("/cart/update.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        attributes: {
                            sampleSetAllowed: "true"
                        }
                    })
                });
            }).then(function() {
                if (_this.selectedButton instanceof HTMLButtonElement) {
                    _this.transformButtonToRemove(_this.selectedButton);
                }
                _this.toggleLoader(false);
                window.location.reload();
            });
        };
        StSampleSet.prototype.removeSample = function(variantId) {
            return __awaiter(this, void 0, void 0, function() {
                var cart, item;
                return __generator(this, function(_a) {
                    switch (_a.label) {
                      case 0:
                        cart = this.cartComponent.getShopifyCartData;
                        item = cart.items.find(function(i) {
                            return i.variant_id === variantId;
                        });
                        if (!item) throw new Error("Item not found in cart");
                        return [ 4, fetch("/cart/change.js", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                id: item.key,
                                quantity: 0
                            })
                        }) ];

                      case 1:
                        _a.sent();
                        return [ 4, fetch("/cart/update.js", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                attributes: {
                                    sampleSetAllowed: ""
                                }
                            })
                        }) ];

                      case 2:
                        _a.sent();
                        sessionStorage.removeItem("sampleInCart");
                        window.location.reload();
                        return [ 2 ];
                    }
                });
            });
        };
        StSampleSet.prototype.transformButtonToRemove = function(button) {
            if (!button) return;
            button.innerHTML = '\n      <span class="selected-label">✓ SELECTED</span>\n      <span class="remove-label">✕ REMOVE</span>\n    ';
            button.classList.add("selected");
            button.setAttribute("data-role", "remove-sample");
        };
        StSampleSet.prototype.transformButtonToAdd = function(button) {
            if (!button) return;
            button.innerText = "ADD SAMPLE";
            button.classList.remove("selected");
            button.removeAttribute("data-role");
        };
        StSampleSet.prototype.toggleLoader = function(show) {
            var btn = document.getElementById(this.config.modalContinueId);
            var loader = document.querySelector(".continue_btn_loader_JS");
            if (!btn || !loader) return;
            if (show) {
                btn.disabled = true;
                loader === null || loader === void 0 ? void 0 : loader.classList.remove("st_hidden");
            } else {
                btn.disabled = false;
                loader === null || loader === void 0 ? void 0 : loader.classList.add("st_hidden");
            }
        };
        StSampleSet.prototype.setBtnLoading = function(btn, on) {
            if (!btn) return;
            if (on) {
                btn.disabled = true;
                btn.setAttribute("aria-busy", "true");
                btn.classList.add("is-loading");
            } else {
                btn.disabled = false;
                btn.removeAttribute("aria-busy");
                btn.classList.remove("is-loading");
            }
        };
        StSampleSet.prototype.wrapAsyncButton = function(btn, fn) {
            var _this = this;
            return function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var err_1;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            if (!btn || btn.disabled) return [ 2 ];
                            this.setBtnLoading(btn, true);
                            _a.label = 1;

                          case 1:
                            _a.trys.push([ 1, 3, , 4 ]);
                            return [ 4, fn() ];

                          case 2:
                            _a.sent();
                            return [ 3, 4 ];

                          case 3:
                            err_1 = _a.sent();
                            console.error(err_1);
                            this.setBtnLoading(btn, false);
                            alert("Error removing Item");
                            return [ 3, 4 ];

                          case 4:
                            return [ 2 ];
                        }
                    });
                });
            };
        };
        return StSampleSet;
    }(st_module_74.StModule);
    exports.StSampleSet = StSampleSet;
});

define("extension/shopify-app/st-modules/free-shipping/free-shipping", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_75) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StFreeShipping = void 0;
    var StFreeShipping = function(_super) {
        __extends(StFreeShipping, _super);
        function StFreeShipping(generalMethods, cart, freeSamples) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StFreeShipping";
            _this.cartChangeTimer = null;
            _this.postRenderFallbackTimer = null;
            _this.lastCartChangeAt = 0;
            _this.cleanupTimer = null;
            _this.isCleanupRunning = false;
            _this.freeShippingObserver = null;
            _this.freeShippingRefreshFrame = null;
            _this.chooseSamplesEventInitialized = false;
            _this.isOpeningSamplesPopup = false;
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    if (_this.isConsultantCustomer()) {
                        return;
                    }
                    _this.openChooseSamplesPopupEventHandle();
                    _this.progressBar();
                    _this.updateChooseSamplesButtonText();
                    _this.cart.subscribeChangeCart(function() {
                        _this.lastCartChangeAt = Date.now();
                        if (_this.cartChangeTimer) {
                            window.clearTimeout(_this.cartChangeTimer);
                        }
                        if (_this.postRenderFallbackTimer) {
                            window.clearTimeout(_this.postRenderFallbackTimer);
                        }
                        _this.cartChangeTimer = window.setTimeout(function() {
                            _this.progressBar();
                            _this.updateChooseSamplesButtonText();
                        }, 200);
                        _this.postRenderFallbackTimer = window.setTimeout(function() {
                            _this.progressBar(false);
                        }, 1300);
                    });
                    _this.cart.subscribeRenderCart(function() {
                        _this.progressBar(false);
                    });
                    _this.observeFreeShippingMarkup();
                });
            };
            _this.observeFreeShippingMarkup = function() {
                if (_this.freeShippingObserver || !document.body) {
                    return;
                }
                _this.freeShippingObserver = new MutationObserver(function(mutations) {
                    var freeShippingMarkupInserted = mutations.some(function(mutation) {
                        return Array.from(mutation.addedNodes).some(function(node) {
                            if (!(node instanceof Element)) {
                                return false;
                            }
                            return node.matches(".lbr_free-shipping-main-wrp") || Boolean(node.querySelector(".lbr_free-shipping-main-wrp"));
                        });
                    });
                    if (!freeShippingMarkupInserted) {
                        return;
                    }
                    if (_this.freeShippingRefreshFrame !== null) {
                        window.cancelAnimationFrame(_this.freeShippingRefreshFrame);
                    }
                    _this.freeShippingRefreshFrame = window.requestAnimationFrame(function() {
                        _this.freeShippingRefreshFrame = null;
                        _this.progressBar(false);
                    });
                });
                _this.freeShippingObserver.observe(document.body, {
                    childList: true,
                    subtree: true
                });
            };
            _this.progressBar = function(allowSampleCleanup) {
                if (allowSampleCleanup === void 0) {
                    allowSampleCleanup = true;
                }
                var totalPrice = _this.getCartItems();
                var giftEligibleTotal = _this.isGiftEnabled() ? _this.getGiftEligibleCartTotal() : totalPrice;
                var progress_percentage = _this.calculateProgress(giftEligibleTotal, totalPrice);
                if (!progress_percentage || isNaN(progress_percentage)) {
                    progress_percentage = 0;
                }
                _this.progressBarPercentage(progress_percentage, allowSampleCleanup);
            };
            _this.progressBarPercentage = function(progress_percentage, allowSampleCleanup) {
                if (allowSampleCleanup === void 0) {
                    allowSampleCleanup = true;
                }
                var progresses = document.querySelectorAll(".lbr_free-shipping-main-wrp .progress-done");
                if (progresses.length > 0) {
                    var width_1 = Math.min(progress_percentage, 100);
                    progresses.forEach(function(progress) {
                        progress.setAttribute("data-done", width_1.toString());
                        progress.style.width = width_1 + "%";
                        progress.style.opacity = "1";
                    });
                    _this.displayPercentage(progress_percentage);
                    _this.updateFreeShippingTitle(progress_percentage);
                    _this.displayProgressBar(progress_percentage);
                    _this.updateRewardMarkers();
                    _this.updateNextRewardMessage();
                }
                _this.displayChooseSamplerButton(progress_percentage, allowSampleCleanup);
                _this.updateChooseSamplesButtonText();
            };
            _this.displayChooseSamplerButton = function(progress_percentage, allowSampleCleanup) {
                if (allowSampleCleanup === void 0) {
                    allowSampleCleanup = true;
                }
                var btnWrps = document.querySelectorAll(".lbr_free-shipping-sample_JS");
                var drawerSamplesBtnWrps = document.querySelectorAll(".lbr_free-shipping-drawer-samples-btn_JS");
                var progressBarWrps = document.querySelectorAll(".lbr_free-shipping-progress-bar_JS");
                var totalPrice = _this.getCartItems();
                var shippingLimit = _this.getShippingLimit();
                var showElements = function(elements) {
                    elements.forEach(function(element) {
                        element.classList.remove("st_hidden");
                    });
                };
                var hideElements = function(elements) {
                    elements.forEach(function(element) {
                        element.classList.add("st_hidden");
                    });
                };
                var isConsultant = _this.isConsultantCustomer();
                if (isConsultant) {
                    hideElements(btnWrps);
                    hideElements(drawerSamplesBtnWrps);
                    showElements(progressBarWrps);
                    return;
                }
                if (shippingLimit > 0 && totalPrice >= shippingLimit) {
                    showElements(btnWrps);
                    showElements(drawerSamplesBtnWrps);
                    hideElements(progressBarWrps);
                    return;
                }
                hideElements(btnWrps);
                hideElements(drawerSamplesBtnWrps);
                showElements(progressBarWrps);
                if (!allowSampleCleanup) {
                    return;
                }
                if (_this.cleanupTimer) window.clearTimeout(_this.cleanupTimer);
                _this.cleanupTimer = window.setTimeout(function() {
                    var _a, _b;
                    if (Date.now() - _this.lastCartChangeAt < 450) return;
                    var items = ((_b = (_a = _this.cart) === null || _a === void 0 ? void 0 : _a.getShopifyCartData) === null || _b === void 0 ? void 0 : _b.items) || [];
                    var hasFreeSample = items.some(function(it) {
                        var _a;
                        return (_a = it === null || it === void 0 ? void 0 : it.properties) === null || _a === void 0 ? void 0 : _a._isFreeSample;
                    });
                    if (!hasFreeSample || _this.isCleanupRunning) return;
                    _this.isCleanupRunning = true;
                    try {
                        _this.freeSamples.removeFreeSamplesFromCart();
                    } finally {
                        setTimeout(function() {
                            _this.isCleanupRunning = false;
                        }, 800);
                    }
                }, 500);
            };
            _this.isConsultantCustomer = function() {
                var _a, _b, _c, _d, _e;
                if (document.querySelector(".lbr_consultant-discount-main-wrp_JS")) {
                    return true;
                }
                var customerInfo = window.customerInfoMetafields;
                var customerType = String((_c = (_b = (_a = customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.value) === null || _a === void 0 ? void 0 : _a.customerType) !== null && _b !== void 0 ? _b : customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.customerType) !== null && _c !== void 0 ? _c : "").trim().toLowerCase();
                if (customerType === "consultant") {
                    return true;
                }
                var customerShopifyId = Number(window.customerShopifyId || 0);
                if (customerShopifyId === 0) {
                    return false;
                }
                var normalizeTags = function(value) {
                    if (Array.isArray(value)) {
                        return value.map(function(tag) {
                            return String(tag).toLowerCase();
                        });
                    }
                    if (typeof value === "string") {
                        try {
                            var parsed = JSON.parse(value);
                            if (Array.isArray(parsed)) {
                                return parsed.map(function(tag) {
                                    return String(tag).toLowerCase();
                                });
                            }
                        } catch (e) {
                            return value.split(",").map(function(tag) {
                                return tag.trim().toLowerCase();
                            }).filter(Boolean);
                        }
                    }
                    return [];
                };
                var windowTags = normalizeTags(window.customerTags);
                if (windowTags.some(function(tag) {
                    return tag.includes("consultant");
                })) {
                    return true;
                }
                var cart = (_d = _this.cart) === null || _d === void 0 ? void 0 : _d.getShopifyCartData;
                var cartTags = normalizeTags((_e = cart === null || cart === void 0 ? void 0 : cart.attributes) === null || _e === void 0 ? void 0 : _e._customerTags);
                return cartTags.some(function(tag) {
                    return tag.includes("consultant");
                });
            };
            _this.displayProgressBar = function(progress_percentage) {
                var progressBarWrps = document.querySelectorAll(".lbr_free-shipping-progress-bar_JS");
                if (progressBarWrps.length === 0) return;
                progressBarWrps.forEach(function(progressBarWrp) {
                    var shippingLimit = _this.getShippingLimit();
                    if (shippingLimit > 0 && _this.getCartItems() >= shippingLimit) {
                        progressBarWrp.classList.add("st_hidden");
                    } else {
                        progressBarWrp.classList.remove("st_hidden");
                    }
                });
            };
            _this.displayPercentage = function(percentage) {
                var percentageSpans = document.querySelectorAll(".lbr_free-shipping-num_JS");
                if (percentageSpans.length === 0) return;
                var totalPrice = _this.getCartItems();
                var giftEnabled = _this.isGiftEnabled();
                var giftEligibleTotal = giftEnabled ? _this.getGiftEligibleCartTotal() : totalPrice;
                percentageSpans.forEach(function(percentageSpan) {
                    var _a;
                    percentageSpan.innerHTML = percentage;
                    if (percentage <= 100) {
                        var progress = ((_a = percentageSpan.closest(".lbr_free-shipping-progress-bar_JS")) === null || _a === void 0 ? void 0 : _a.querySelector(".progress-done")) || document.querySelector(".lbr_free-shipping-main-wrp .progress-done");
                        if (!progress) return;
                        var shippingLimit = _this.getShippingLimit(progress);
                        var giftLimit = _this.getGiftLimit(progress);
                        var amountLeft = !giftEnabled || totalPrice < shippingLimit ? shippingLimit - totalPrice : giftLimit - giftEligibleTotal;
                        var num = Math.max(amountLeft, 0).toFixed(2);
                        percentageSpan.innerHTML = "".concat(num);
                    }
                    if (percentage >= 100) {
                        percentageSpan.innerHTML = "0";
                    }
                });
            };
            _this.getCartItems = function() {
                var _a, _b;
                var items = ((_b = (_a = _this.cart) === null || _a === void 0 ? void 0 : _a.getShopifyCartData) === null || _b === void 0 ? void 0 : _b.items) || [];
                var totalPrice = 0;
                items.forEach(function(item) {
                    var _a;
                    if (_this.excludedCheck(item.id) == false) {
                        if (!((_a = item === null || item === void 0 ? void 0 : item.properties) === null || _a === void 0 ? void 0 : _a._isFreeSample)) {
                            totalPrice += item.quantity * (item.price / 100);
                        }
                    }
                });
                totalPrice = Number(totalPrice.toFixed(2));
                return totalPrice;
            };
            _this.isGiftEnabled = function(progress) {
                var _a, _b;
                var progressElement = progress || document.querySelector(".lbr_free-shipping-main-wrp .progress-done");
                var value = (_a = progressElement === null || progressElement === void 0 ? void 0 : progressElement.getAttribute("data-gift-enabled")) !== null && _a !== void 0 ? _a : (_b = window === null || window === void 0 ? void 0 : window.freeShippingLimit) === null || _b === void 0 ? void 0 : _b.free_gift_enabled;
                return value === true || String(value).toLowerCase() === "true";
            };
            _this.getGiftEligibleCartTotal = function() {
                var _a, _b;
                var items = ((_b = (_a = _this.cart) === null || _a === void 0 ? void 0 : _a.getShopifyCartData) === null || _b === void 0 ? void 0 : _b.items) || [];
                var totalPrice = 0;
                items.forEach(function(item) {
                    var _a;
                    if (_this.isExcludedFromGiftThreshold(item === null || item === void 0 ? void 0 : item.id)) return;
                    if ((_a = item === null || item === void 0 ? void 0 : item.properties) === null || _a === void 0 ? void 0 : _a._isFreeSample) return;
                    var finalLinePrice = Number(item === null || item === void 0 ? void 0 : item.final_line_price);
                    if (Number.isFinite(finalLinePrice)) {
                        totalPrice += finalLinePrice / 100;
                        return;
                    }
                    totalPrice += Number((item === null || item === void 0 ? void 0 : item.quantity) || 0) * (Number((item === null || item === void 0 ? void 0 : item.price) || 0) / 100);
                });
                return Number(totalPrice.toFixed(2));
            };
            _this.isExcludedFromGiftThreshold = function(id) {
                var _a;
                if (id === undefined || id === null) return false;
                if (_this.excludedCheck(id)) return true;
                var progress = document.querySelector(".lbr_free-shipping-main-wrp .progress-done");
                var excludedVariantIds = ((_a = progress === null || progress === void 0 ? void 0 : progress.getAttribute("data-gift-excluded-variants")) === null || _a === void 0 ? void 0 : _a.split(",").map(function(value) {
                    return value.trim();
                }).filter(Boolean)) || [];
                return excludedVariantIds.includes(String(id));
            };
            _this.excludedCheck = function(id) {
                var _a;
                var progress = document.querySelector(".lbr_free-shipping-main-wrp .progress-done");
                var excludedMetafield = progress === null || progress === void 0 ? void 0 : progress.getAttribute("data-excluded");
                if (!excludedMetafield) {
                    var excludedFromWindow = (_a = window === null || window === void 0 ? void 0 : window.freeShippingLimit) === null || _a === void 0 ? void 0 : _a.excluded;
                    if (Array.isArray(excludedFromWindow)) {
                        return excludedFromWindow.map(String).includes(id.toString());
                    }
                    return false;
                }
                excludedMetafield = excludedMetafield.replace(/ /g, ",");
                var arrOfExcludedIds = excludedMetafield.split(",").map(function(item) {
                    return item.trim();
                }).filter(Boolean);
                return arrOfExcludedIds.includes(id.toString());
            };
            _this.getShippingLimit = function(progress) {
                var _a;
                var shippingLimit = progress === null || progress === void 0 ? void 0 : progress.getAttribute("data-shipping-limit");
                if (!shippingLimit) {
                    shippingLimit = String(((_a = window === null || window === void 0 ? void 0 : window.freeShippingLimit) === null || _a === void 0 ? void 0 : _a.free_shipping_limit) || 0);
                }
                return Number(shippingLimit) || 0;
            };
            _this.getGiftLimit = function(progress) {
                var _a;
                var giftLimit = progress === null || progress === void 0 ? void 0 : progress.getAttribute("data-gift-limit");
                if (!giftLimit) {
                    giftLimit = String(((_a = window === null || window === void 0 ? void 0 : window.freeShippingLimit) === null || _a === void 0 ? void 0 : _a.free_gift_limit) || 99);
                }
                return Number(giftLimit) || 99;
            };
            _this.calculateProgress = function(giftEligibleTotal, totalPrice) {
                if (totalPrice === void 0) {
                    totalPrice = giftEligibleTotal;
                }
                var progress = document.querySelector(".lbr_free-shipping-main-wrp .progress-done");
                var limitFromMetafield = (progress === null || progress === void 0 ? void 0 : progress.getAttribute("data-limit")) || String(_this.getGiftLimit(progress));
                var giftLimit = Number(limitFromMetafield);
                if (!giftLimit) {
                    return 0;
                }
                var shippingLimit = _this.getShippingLimit(progress);
                if (!_this.isGiftEnabled(progress)) {
                    if (shippingLimit <= 0) return 0;
                    return Number(totalPrice) * 100 / shippingLimit;
                }
                var giftProgress = Number(giftEligibleTotal) * 100 / giftLimit;
                if (shippingLimit > 0 && Number(totalPrice) >= shippingLimit) {
                    var shippingMilestone = shippingLimit * 100 / giftLimit;
                    return Math.max(giftProgress, shippingMilestone);
                }
                return Number(totalPrice) * 100 / giftLimit;
            };
            _this.openChooseSamplesPopupEventHandle = function() {
                if (_this.chooseSamplesEventInitialized) {
                    return;
                }
                _this.chooseSamplesEventInitialized = true;
                document.addEventListener("click", function(event) {
                    var target = event.target;
                    var button = target === null || target === void 0 ? void 0 : target.closest(".lbr_free-shipping-samples-btn_JS");
                    if (!button) {
                        return;
                    }
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    if (_this.isOpeningSamplesPopup) {
                        return;
                    }
                    _this.isOpeningSamplesPopup = true;
                    try {
                        _this.freeSamples.openChooseSponsorPopup();
                    } finally {
                        window.setTimeout(function() {
                            _this.isOpeningSamplesPopup = false;
                        }, 500);
                    }
                }, true);
            };
            _this.updateChooseSamplesButtonText = function() {
                var _a, _b;
                var buttons = document.querySelectorAll(".lbr_free-shipping-samples-btn_JS");
                if (!buttons || buttons.length === 0) {
                    return;
                }
                var translations = window.stTranslations || {};
                var chooseText = translations.freeShippingChooseSamples || "";
                var changeText = translations.freeShippingChangeSamples || "";
                var items = ((_b = (_a = _this.cart) === null || _a === void 0 ? void 0 : _a.getShopifyCartData) === null || _b === void 0 ? void 0 : _b.items) || [];
                var hasFreeSample = items.some(function(item) {
                    var _a;
                    return (_a = item === null || item === void 0 ? void 0 : item.properties) === null || _a === void 0 ? void 0 : _a._isFreeSample;
                });
                buttons.forEach(function(button) {
                    var span = button.querySelector("span");
                    if (!span) {
                        return;
                    }
                    span.innerHTML = hasFreeSample ? changeText : chooseText;
                });
            };
            _this.updateFreeShippingTitle = function(progressPercentage) {
                var titles = document.querySelectorAll(".lbr_free-shipping-title_JS");
                if (titles.length === 0) return;
                var translations = window.stTranslations || {};
                var totalPrice = _this.getCartItems();
                var progress = document.querySelector(".lbr_free-shipping-main-wrp .progress-done");
                var giftEnabled = _this.isGiftEnabled(progress);
                var giftEligibleTotal = giftEnabled ? _this.getGiftEligibleCartTotal() : totalPrice;
                var shippingLimit = _this.getShippingLimit(progress);
                var giftLimit = _this.getGiftLimit(progress);
                var amountLeft = Math.max(!giftEnabled || totalPrice < shippingLimit ? shippingLimit - totalPrice : giftLimit - giftEligibleTotal, 0);
                var formattedAmount = amountLeft % 1 === 0 ? amountLeft.toFixed(0) : amountLeft.toFixed(2);
                titles.forEach(function(title) {
                    if (!giftEnabled) {
                        if (totalPrice >= shippingLimit) {
                            title.innerHTML = translations.freeShippingUnlocked || "";
                            return;
                        }
                        title.innerHTML = "".concat(translations.freeShippingReach || "", " ") + "<strong>$".concat(formattedAmount, "</strong> ") + "".concat(translations.freeShippingReachSuffix || "");
                        return;
                    }
                    if (giftEligibleTotal >= giftLimit) {
                        title.innerHTML = translations.freeShippingAllRewardsUnlocked || "";
                        return;
                    }
                    if (totalPrice >= shippingLimit) {
                        var spendMoreForGift = _this.formatTranslation(translations.freeShippingSpendMoreForGift || "", formattedAmount);
                        title.innerHTML = "".concat(translations.freeShippingUnlocked || "", " ") + '<span class="lbr_free-shipping-next-reward">'.concat(spendMoreForGift, "</span>");
                        return;
                    }
                    title.innerHTML = "".concat(translations.freeShippingReach || "", " ") + "<strong>$".concat(formattedAmount, "</strong> ") + "".concat(translations.freeShippingReachSuffix || "");
                });
            };
            _this.formatTranslation = function(translation, amount) {
                return translation.replace("{{ amount }}", String(amount));
            };
            _this.updateRewardMarkers = function() {
                var totalPrice = _this.getCartItems();
                var giftEnabled = _this.isGiftEnabled();
                var giftEligibleTotal = giftEnabled ? _this.getGiftEligibleCartTotal() : totalPrice;
                var sampleMarkers = document.querySelectorAll(".lbr_free-shipping-marker--sample");
                var giftMarkers = document.querySelectorAll(".lbr_free-shipping-marker--gift");
                var shippingLimit = _this.getShippingLimit();
                var giftLimit = _this.getGiftLimit();
                sampleMarkers.forEach(function(marker) {
                    marker.classList.toggle("is-unlocked", shippingLimit > 0 && totalPrice >= shippingLimit);
                });
                giftMarkers.forEach(function(marker) {
                    marker.classList.toggle("is-unlocked", giftEnabled && giftEligibleTotal >= giftLimit);
                });
            };
            _this.updateNextRewardMessage = function() {
                if (!_this.isGiftEnabled()) return;
                var messages = document.querySelectorAll(".lbr_free-shipping-next-reward-message_JS");
                var giftEligibleTotal = _this.getGiftEligibleCartTotal();
                var giftLimit = _this.getGiftLimit();
                var translations = window.stTranslations || {};
                messages.forEach(function(message) {
                    if (giftEligibleTotal >= giftLimit) {
                        message.innerHTML = translations.freeShippingFreeGiftUnlocked || "";
                        return;
                    }
                    message.innerHTML = _this.formatTranslation(translations.freeShippingNextRewardAt || "", giftLimit);
                });
            };
            _this.generalMethods = generalMethods;
            _this.cart = cart;
            _this.freeSamples = freeSamples;
            return _this;
        }
        return StFreeShipping;
    }(st_module_75.StModule);
    exports.StFreeShipping = StFreeShipping;
});

define("extension/shopify-app/st-modules/samples-set/cart-guard", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_76) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCartGuard = void 0;
    var StCartGuard = function(_super) {
        __extends(StCartGuard, _super);
        function StCartGuard(cartComponent) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "CartGuard";
            _this_1._logoutInProgress = false;
            _this_1.init = function() {
                var logoutBtn = document.querySelector("button.st_logout");
                if (logoutBtn) {
                    logoutBtn.disabled = true;
                    logoutBtn.classList.add("st_hidden");
                }
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.resetClearCartFlagIfLoggedIn();
                    _this_1.injectModalHtml();
                    _this_1.interceptFetch();
                    _this_1.interceptXMLHttpRequest();
                    _this_1.interceptAddToCartButtons();
                    _this_1.attachModalEvents();
                    _this_1.watchCartDrawerSamples();
                    _this_1.setupSampleRemoveInterceptor();
                    _this_1.setupSampleQuantityDecreaseInterceptor();
                    _this_1.autoRemoveSamplesOnLogoutClick();
                    if (logoutBtn) {
                        setTimeout(function() {
                            logoutBtn.disabled = false;
                            logoutBtn.classList.remove("st_hidden");
                        }, 1500);
                    }
                });
            };
            _this_1.watchCartDrawerSamples = function() {
                var observer = new MutationObserver(function() {
                    _this_1.disableSampleControlsImmediately();
                    _this_1.disableSampleQuantityControls();
                });
                var cartDrawer = document.querySelector("cart-drawer");
                if (cartDrawer) {
                    observer.observe(cartDrawer, {
                        childList: true,
                        subtree: true
                    });
                    _this_1.disableSampleControlsImmediately();
                    _this_1.disableSampleQuantityControls();
                } else {
                    console.warn("[SampleGuard] cart-drawer not found.");
                }
            };
            _this_1.disableSampleQuantityControls = function() {
                var cart = _this_1.cartComponent.getShopifyCartData;
                cart.items.forEach(function(item) {
                    var _a, _b;
                    if (((_a = item.properties) === null || _a === void 0 ? void 0 : _a._is_sample) === "true") {
                        var input_1 = document.querySelector('input[data-quantity-variant-id="'.concat(item.variant_id, '"]'));
                        if (input_1) {
                            input_1.setAttribute("readonly", "true");
                            input_1.classList.add("readonly-sample");
                            var plusBtn = (_b = input_1.closest(".counter")) === null || _b === void 0 ? void 0 : _b.querySelector("button.js-counter-increase");
                            if (plusBtn) {
                                plusBtn.disabled = true;
                                plusBtn.classList.add("disabled-sample");
                            }
                            var currentQty = parseInt(input_1.value);
                            if (currentQty > 1) {
                                fetch("/cart/change.js", {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json"
                                    },
                                    body: JSON.stringify({
                                        id: item.key,
                                        quantity: 1
                                    })
                                }).then(function() {
                                    input_1.value = "1";
                                });
                            }
                        }
                    }
                });
            };
            _this_1.setupSampleRemoveInterceptor = function() {
                document.addEventListener("click", function(e) {
                    return __awaiter(_this_1, void 0, void 0, function() {
                        var target, removeBtn, itemEl, input, variantId, sampleIds;
                        return __generator(this, function(_a) {
                            target = e.target;
                            removeBtn = target.closest(".wt-cart__item__remove");
                            if (!removeBtn) return [ 2 ];
                            itemEl = removeBtn.closest("li.cart-item");
                            input = itemEl === null || itemEl === void 0 ? void 0 : itemEl.querySelector("input[data-quantity-variant-id]");
                            variantId = input === null || input === void 0 ? void 0 : input.dataset.quantityVariantId;
                            if (!variantId) return [ 2 ];
                            sampleIds = window.SAMPLE_VARIANTS || [];
                            if (sampleIds.includes(parseInt(variantId))) {
                                sessionStorage.removeItem("sampleInCart");
                                if (window.location.pathname.includes("/pages/samples")) {
                                    setTimeout(function() {
                                        return window.location.reload();
                                    }, 300);
                                }
                            }
                            return [ 2 ];
                        });
                    });
                });
            };
            _this_1.setupSampleQuantityDecreaseInterceptor = function() {
                document.addEventListener("click", function(e) {
                    return __awaiter(_this_1, void 0, void 0, function() {
                        var target, minusBtn, counter, input, variantId, sampleIds;
                        var _this_1 = this;
                        return __generator(this, function(_a) {
                            target = e.target;
                            minusBtn = target.closest(".js-counter-decrease");
                            if (!minusBtn) return [ 2 ];
                            counter = minusBtn.closest(".counter");
                            input = counter === null || counter === void 0 ? void 0 : counter.querySelector("input[data-quantity-variant-id]");
                            variantId = input === null || input === void 0 ? void 0 : input.dataset.quantityVariantId;
                            if (!variantId) return [ 2 ];
                            sampleIds = window.SAMPLE_VARIANTS || [];
                            if (sampleIds.includes(parseInt(variantId))) {
                                setTimeout(function() {
                                    return __awaiter(_this_1, void 0, void 0, function() {
                                        var cart, stillInCart;
                                        return __generator(this, function(_a) {
                                            cart = this.cartComponent.getShopifyCartData;
                                            stillInCart = cart.items.find(function(item) {
                                                return item.variant_id === parseInt(variantId);
                                            });
                                            if (!stillInCart) {
                                                sessionStorage.removeItem("sampleInCart");
                                                if (window.location.pathname.includes("/pages/samples")) {
                                                    window.location.reload();
                                                }
                                            }
                                            return [ 2 ];
                                        });
                                    });
                                }, 500);
                            }
                            return [ 2 ];
                        });
                    });
                });
            };
            _this_1.disableSampleControlsImmediately = function() {
                var sampleIds = window.SAMPLE_VARIANTS || [];
                document.querySelectorAll("input[data-quantity-variant-id]").forEach(function(input) {
                    var _a;
                    var variantId = parseInt(input.dataset.quantityVariantId || "0");
                    if (sampleIds.includes(variantId)) {
                        input.setAttribute("readonly", "true");
                        input.classList.add("readonly-sample");
                        var plusBtn = (_a = input.closest(".counter")) === null || _a === void 0 ? void 0 : _a.querySelector("button.js-counter-increase");
                        if (plusBtn) {
                            plusBtn.disabled = true;
                            plusBtn.classList.add("disabled-sample");
                        }
                    }
                });
            };
            _this_1.autoRemoveSamplesIfLoggedOut = function() {
                if (!window.IS_LOGGED_IN) {
                    var cart = _this_1.cartComponent.getShopifyCartData;
                    var updates_1 = {};
                    cart.items.forEach(function(item) {
                        var _a;
                        if (((_a = item.properties) === null || _a === void 0 ? void 0 : _a._is_sample) === "true") {
                            updates_1[item.key] = 0;
                        }
                    });
                    if (Object.keys(updates_1).length > 0) {
                        fetch("/cart/update.js", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                updates: updates_1
                            })
                        }).then(function() {
                            sessionStorage.removeItem("sampleInCart");
                            window.location.reload();
                        });
                    }
                }
            };
            _this_1.autoRemoveSamplesOnLogoutClick = function() {
                if (_this_1._logoutListenerAttached) return;
                _this_1._logoutListenerAttached = true;
                document.addEventListener("click", function(e) {
                    return __awaiter(_this_1, void 0, void 0, function() {
                        var target, logoutBtn, DEBUG, hasSampleFlag, getCartAsync, changeCartAsync, updateCartAsync, wait, normalizeSkuList, removeSkuList, removeSkuSet_1, shouldRemoveLine_1, collectKeysToRemove, cart, keysToRemove, _i, keysToRemove_1, key, verify, stillThere, _a, stillThere_1, key, err_2;
                        var _this_1 = this;
                        return __generator(this, function(_b) {
                            switch (_b.label) {
                              case 0:
                                target = e.target;
                                logoutBtn = target === null || target === void 0 ? void 0 : target.closest(".st_logout");
                                if (!logoutBtn) return [ 2 ];
                                e.preventDefault();
                                e.stopPropagation();
                                if (typeof e.stopImmediatePropagation === "function") {
                                    e.stopImmediatePropagation();
                                }
                                if (this._logoutInProgress) return [ 2 ];
                                this._logoutInProgress = true;
                                DEBUG = false;
                                _b.label = 1;

                              case 1:
                                _b.trys.push([ 1, 20, 21, 22 ]);
                                hasSampleFlag = sessionStorage.getItem("sampleInCart") === "true";
                                getCartAsync = function() {
                                    return new Promise(function(resolve) {
                                        return _this_1.cartComponent.getCart(function(cartObj) {
                                            return resolve(cartObj);
                                        });
                                    });
                                };
                                changeCartAsync = function(changeData, cartRefresh) {
                                    if (cartRefresh === void 0) {
                                        cartRefresh = true;
                                    }
                                    return new Promise(function(resolve) {
                                        return _this_1.cartComponent.changeCart(changeData, function() {
                                            return resolve();
                                        }, cartRefresh);
                                    });
                                };
                                updateCartAsync = function(updateData) {
                                    return new Promise(function(resolve) {
                                        return _this_1.cartComponent.updateCart(updateData, function() {
                                            return resolve();
                                        });
                                    });
                                };
                                wait = function(ms) {
                                    return new Promise(function(r) {
                                        return setTimeout(r, ms);
                                    });
                                };
                                normalizeSkuList = function(raw) {
                                    try {
                                        if (Array.isArray(raw)) return raw.map(String);
                                        if (typeof raw === "string") {
                                            var s = raw.trim();
                                            if (!s) return [];
                                            if (s.startsWith("[") && s.endsWith("]")) {
                                                var parsed = JSON.parse(s);
                                                return Array.isArray(parsed) ? parsed.map(String) : [];
                                            }
                                            return s.split(",").map(function(x) {
                                                return x.trim();
                                            });
                                        }
                                    } catch (_a) {}
                                    return [];
                                };
                                removeSkuList = normalizeSkuList(window.removeProductOnLogoutSku);
                                removeSkuSet_1 = new Set(removeSkuList.map(function(s) {
                                    return s.trim().toUpperCase();
                                }));
                                shouldRemoveLine_1 = function(item) {
                                    var _a;
                                    var props = (item === null || item === void 0 ? void 0 : item.properties) || {};
                                    var isSample = (props === null || props === void 0 ? void 0 : props._is_sample) === "true" || (props === null || props === void 0 ? void 0 : props._is_sample) === true || (props === null || props === void 0 ? void 0 : props._isFreeSample) === "true" || (props === null || props === void 0 ? void 0 : props._isFreeSample) === true;
                                    var sku = ((_a = item === null || item === void 0 ? void 0 : item.sku) !== null && _a !== void 0 ? _a : "").toString().trim().toUpperCase();
                                    var skuHit = sku && removeSkuSet_1.has(sku);
                                    var should = Boolean(isSample || skuHit);
                                    if (DEBUG) {
                                        console.log("[logout-remove:inspect]", {
                                            title: item === null || item === void 0 ? void 0 : item.title,
                                            key: item === null || item === void 0 ? void 0 : item.key,
                                            sku: sku,
                                            isSample: isSample,
                                            skuHit: skuHit,
                                            should: should,
                                            props: props
                                        });
                                    }
                                    return should;
                                };
                                collectKeysToRemove = function(cart) {
                                    var keys = [];
                                    ((cart === null || cart === void 0 ? void 0 : cart.items) || []).forEach(function(item) {
                                        if ((item === null || item === void 0 ? void 0 : item.key) && shouldRemoveLine_1(item)) keys.push(item.key);
                                    });
                                    return keys;
                                };
                                return [ 4, getCartAsync() ];

                              case 2:
                                cart = _b.sent();
                                keysToRemove = collectKeysToRemove(cart);
                                if (!(keysToRemove.length === 0 && (hasSampleFlag || removeSkuSet_1.size > 0))) return [ 3, 7 ];
                                return [ 4, wait(150) ];

                              case 3:
                                _b.sent();
                                return [ 4, getCartAsync() ];

                              case 4:
                                cart = _b.sent();
                                keysToRemove = collectKeysToRemove(cart);
                                if (!(keysToRemove.length === 0)) return [ 3, 7 ];
                                return [ 4, wait(150) ];

                              case 5:
                                _b.sent();
                                return [ 4, getCartAsync() ];

                              case 6:
                                cart = _b.sent();
                                keysToRemove = collectKeysToRemove(cart);
                                _b.label = 7;

                              case 7:
                                if (DEBUG) console.log("[logout-remove:keys]", keysToRemove);
                                _i = 0, keysToRemove_1 = keysToRemove;
                                _b.label = 8;

                              case 8:
                                if (!(_i < keysToRemove_1.length)) return [ 3, 11 ];
                                key = keysToRemove_1[_i];
                                return [ 4, changeCartAsync({
                                    id: key,
                                    quantity: 0
                                }, false) ];

                              case 9:
                                _b.sent();
                                _b.label = 10;

                              case 10:
                                _i++;
                                return [ 3, 8 ];

                              case 11:
                                if (!(keysToRemove.length > 0)) return [ 3, 17 ];
                                return [ 4, wait(50) ];

                              case 12:
                                _b.sent();
                                return [ 4, getCartAsync() ];

                              case 13:
                                verify = _b.sent();
                                stillThere = collectKeysToRemove(verify);
                                if (DEBUG) console.log("[logout-remove:verify]", stillThere);
                                _a = 0, stillThere_1 = stillThere;
                                _b.label = 14;

                              case 14:
                                if (!(_a < stillThere_1.length)) return [ 3, 17 ];
                                key = stillThere_1[_a];
                                return [ 4, changeCartAsync({
                                    id: key,
                                    quantity: 0
                                }, false) ];

                              case 15:
                                _b.sent();
                                _b.label = 16;

                              case 16:
                                _a++;
                                return [ 3, 14 ];

                              case 17:
                                sessionStorage.removeItem("sampleInCart");
                                return [ 4, updateCartAsync({
                                    attributes: {
                                        sampleSetAllowed: "",
                                        clearCartOnGuest: ""
                                    }
                                }) ];

                              case 18:
                                _b.sent();
                                return [ 4, wait(60) ];

                              case 19:
                                _b.sent();
                                window.location.assign("/account/logout");
                                return [ 3, 22 ];

                              case 20:
                                err_2 = _b.sent();
                                console.error("[logout-remove] unexpected error:", err_2);
                                window.location.assign("/account/logout");
                                return [ 3, 22 ];

                              case 21:
                                this._logoutInProgress = false;
                                return [ 7 ];

                              case 22:
                                return [ 2 ];
                            }
                        });
                    });
                }, {
                    capture: true,
                    passive: false
                });
            };
            _this_1.autoClearCartOnGuest = function() {
                var _a;
                var cart = _this_1.cartComponent.getShopifyCartData;
                var shouldClear = ((_a = cart.attributes) === null || _a === void 0 ? void 0 : _a.clearCartOnGuest) === "true";
                if (!shouldClear) return;
                var updates = {};
                cart.items.forEach(function(item) {
                    updates[item.key] = 0;
                });
                if (Object.keys(updates).length === 0) return;
                fetch("/cart/update.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        updates: updates
                    })
                }).then(function() {
                    return fetch("/cart/update.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            attributes: {
                                clearCartOnGuest: "",
                                sampleSetAllowed: "",
                                sponsorWebAlias: ""
                            }
                        })
                    });
                }).then(function() {
                    window.location.reload();
                });
            };
            _this_1.resetClearCartFlagIfLoggedIn = function() {
                var _a;
                var isLoggedIn = window.IS_LOGGED_IN;
                if (!isLoggedIn) return;
                var cart = _this_1.cartComponent.getShopifyCartData;
                var flagSet = ((_a = cart.attributes) === null || _a === void 0 ? void 0 : _a.clearCartOnGuest) === "true";
                if (!flagSet) return;
                fetch("/cart/update.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        attributes: {
                            clearCartOnGuest: ""
                        }
                    })
                });
            };
            _this_1.cartComponent = cartComponent;
            return _this_1;
        }
        StCartGuard.prototype.interceptFetch = function() {
            var _this_1 = this;
            var originalFetch = window.fetch;
            window.fetch = function(input, init) {
                return __awaiter(_this_1, void 0, void 0, function() {
                    var allow;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            if (!(typeof input === "string" && input.includes("/cart/add") && !input.includes("/cart/change"))) return [ 3, 2 ];
                            return [ 4, this.canAddProduct() ];

                          case 1:
                            allow = _a.sent();
                            if (!allow) {
                                this.openSampleModal();
                                throw new Error("Blocked adding product because sample is in cart.");
                            }
                            _a.label = 2;

                          case 2:
                            return [ 2, originalFetch(input, init) ];
                        }
                    });
                });
            };
        };
        StCartGuard.prototype.interceptXMLHttpRequest = function() {
            var _this = this;
            var originalOpen = XMLHttpRequest.prototype.open;
            XMLHttpRequest.prototype.open = function(method, url) {
                if (typeof url === "string") {
                    var urlString = url.toString();
                    if (urlString.includes("/cart/change")) {
                        return originalOpen.apply(this, arguments);
                    }
                    if (urlString.includes("/cart/add")) {
                        var xhr_1 = this;
                        xhr_1.addEventListener("readystatechange", function() {
                            return __awaiter(this, void 0, void 0, function() {
                                var allow;
                                return __generator(this, function(_a) {
                                    switch (_a.label) {
                                      case 0:
                                        if (!(xhr_1.readyState === 1)) return [ 3, 2 ];
                                        return [ 4, _this.checkCartBeforeAdd() ];

                                      case 1:
                                        allow = _a.sent();
                                        if (!allow) {
                                            _this.openStaticSampleModal();
                                            xhr_1.abort();
                                        }
                                        _a.label = 2;

                                      case 2:
                                        return [ 2 ];
                                    }
                                });
                            });
                        });
                    }
                }
                return originalOpen.apply(this, arguments);
            };
        };
        StCartGuard.prototype.interceptAddToCartButtons = function() {
            var _this_1 = this;
            document.addEventListener("click", function(e) {
                return __awaiter(_this_1, void 0, void 0, function() {
                    var target, allow;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            target = e.target;
                            if (target.closest('[data-role="remove-sample"]')) {
                                return [ 2 ];
                            }
                            if (!(target.closest('form[action^="/cart/add"]') || target.closest("button[data-variant-id]"))) return [ 3, 2 ];
                            return [ 4, this.canAddProduct() ];

                          case 1:
                            allow = _a.sent();
                            if (!allow) {
                                e.preventDefault();
                                e.stopImmediatePropagation();
                                this.openSampleModal();
                            }
                            _a.label = 2;

                          case 2:
                            return [ 2 ];
                        }
                    });
                });
            }, true);
        };
        StCartGuard.prototype.canAddProduct = function() {
            return __awaiter(this, void 0, void 0, function() {
                var cart, sampleInCart_1;
                return __generator(this, function(_a) {
                    try {
                        cart = this.cartComponent.getShopifyCartData;
                        sampleInCart_1 = cart.items.some(function(item) {
                            if (sampleInCart_1) {
                                sessionStorage.setItem("sampleInCart", "true");
                            }
                            return item.properties && item.properties._is_sample === "true";
                        });
                        return [ 2, !sampleInCart_1 ];
                    } catch (_b) {
                        return [ 2, true ];
                    }
                    return [ 2 ];
                });
            });
        };
        StCartGuard.prototype.checkCartBeforeAdd = function() {
            return __awaiter(this, void 0, void 0, function() {
                var cart, sampleInCart;
                return __generator(this, function(_a) {
                    try {
                        cart = this.cartComponent.getShopifyCartData;
                        sampleInCart = cart.items.some(function(item) {
                            return item.properties && item.properties._is_sample === "true";
                        });
                        return [ 2, !sampleInCart ];
                    } catch (_b) {
                        return [ 2, true ];
                    }
                    return [ 2 ];
                });
            });
        };
        StCartGuard.prototype.injectModalHtml = function() {
            var modalHtml = '\n    <div id="sample-guard-modal" class="sample-guard-modal-backdrop" style="display:none;">\n        <div class="sample-guard-modal">\n            <h3>Important Notice</h3>\n            <p>You cannot purchase regular products while a sample set is in your cart.<br>Please complete your sample set checkout or remove the sample set from your cart to continue shopping.</p>\n            <div class="sample-guard-modal-actions">\n            <button id="sample-modal-go-cart" class="sample-btn confirm">GO TO CART</button>\n            <button id="sample-modal-cancel" class="sample-btn cancel">CONTINUE SHOPPING</button>\n            </div>\n        </div>\n    </div>\n    ';
            document.body.insertAdjacentHTML("beforeend", modalHtml);
        };
        StCartGuard.prototype.attachModalEvents = function() {
            var _this_1 = this;
            var _a, _b;
            (_a = document.getElementById("sample-modal-go-cart")) === null || _a === void 0 ? void 0 : _a.addEventListener("click", function() {
                window.location.href = "/cart";
            });
            (_b = document.getElementById("sample-modal-cancel")) === null || _b === void 0 ? void 0 : _b.addEventListener("click", function() {
                _this_1.closeSampleModal();
            });
            document.addEventListener("keydown", function(e) {
                if (e.key === "Escape") {
                    _this_1.closeSampleModal();
                }
            });
        };
        StCartGuard.prototype.openSampleModal = function() {
            var modal = document.getElementById("sample-guard-modal");
            if (modal) modal.style.display = "flex";
        };
        StCartGuard.prototype.closeSampleModal = function() {
            var modal = document.getElementById("sample-guard-modal");
            if (modal) modal.style.display = "none";
        };
        StCartGuard.prototype.openStaticSampleModal = function() {
            var modal = document.getElementById("sample-guard-modal");
            if (modal) modal.style.display = "flex";
        };
        return StCartGuard;
    }(st_module_76.StModule);
    exports.StCartGuard = StCartGuard;
});

define("extension/shopify-app/st-modules/account-register/st-market-type", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_77) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StMarketTypeLoader = void 0;
    var StMarketTypeLoader = function(_super) {
        __extends(StMarketTypeLoader, _super);
        function StMarketTypeLoader() {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "MarketTypeLoader";
            _this_1.selectId = "marketTypeSelect";
            _this_1.wrapperId = "marketTypeExtraInputWrapper";
            _this_1.inputId = "marketTypeExtraInput";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    var _this = _this_1;
                    var marketTypeSelect = document.getElementById(_this_1.selectId);
                    var inputWrapper = document.getElementById(_this_1.wrapperId);
                    var inputField = document.getElementById(_this_1.inputId);
                    var labelField = inputWrapper === null || inputWrapper === void 0 ? void 0 : inputWrapper.querySelector(".form__field__label");
                    if (!marketTypeSelect || !inputWrapper || !inputField || !labelField) return;
                    marketTypeSelect.required = true;
                    inputWrapper.style.display = "none";
                    inputField.required = false;
                    inputField.value = "";
                    labelField.textContent = "";
                    fetch(_this.endpoint["market-type"]["get-market-type"]).then(function(res) {
                        return res.json();
                    }).then(function(resData) {
                        if (!resData || !Array.isArray(resData.data)) {
                            console.error("[MarketTypeLoader] Invalid response:", resData);
                            return;
                        }
                        var activeItems = resData.data.filter(function(item) {
                            return item.isActive;
                        });
                        var marketTypeMap = {};
                        activeItems.forEach(function(item) {
                            marketTypeMap[item.id] = item;
                            var option = document.createElement("option");
                            var isPlaceholder = /^-?\s*--\s*select\s*one\s*--\s*$/i.test(item.description);
                            option.value = isPlaceholder ? "" : String(item.id);
                            option.textContent = item.description;
                            if (isPlaceholder) {
                                option.disabled = true;
                                option.selected = true;
                            }
                            marketTypeSelect.appendChild(option);
                        });
                        marketTypeSelect.addEventListener("change", function() {
                            var val = this.value;
                            if (!val) {
                                inputWrapper.style.display = "none";
                                inputField.required = false;
                                inputField.value = "";
                                labelField.textContent = "";
                                return;
                            }
                            var selectedItem = marketTypeMap[val];
                            if (selectedItem && selectedItem.inputLabel) {
                                inputWrapper.style.display = "block";
                                inputField.required = true;
                                labelField.textContent = selectedItem.inputLabel || "";
                            } else {
                                inputWrapper.style.display = "none";
                                inputField.required = false;
                                inputField.value = "";
                                labelField.textContent = "";
                            }
                        });
                        marketTypeSelect.dispatchEvent(new Event("change"));
                        var formEl = marketTypeSelect.closest("form");
                        if (formEl) {
                            formEl.addEventListener("submit", function(e) {
                                if (!marketTypeSelect.value) {
                                    e.preventDefault();
                                    marketTypeSelect.reportValidity();
                                } else if (inputField.required && !inputField.value.trim()) {
                                    e.preventDefault();
                                    inputField.reportValidity();
                                }
                            });
                        }
                    }).catch(function(err) {
                        console.error("[MarketTypeLoader] Fetch error:", err);
                    });
                });
            };
            return _this_1;
        }
        return StMarketTypeLoader;
    }(st_module_77.StModule);
    exports.StMarketTypeLoader = StMarketTypeLoader;
});

define("extension/shopify-app/st-modules/cart/cartSaveLoginInterceptor", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_78) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCartInterceptor = void 0;
    var StCartInterceptor = function(_super) {
        __extends(StCartInterceptor, _super);
        function StCartInterceptor() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StCartInterceptor";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {});
            };
            _this.interceptLogoutButton = function() {
                document.addEventListener("click", function(e) {
                    return __awaiter(_this, void 0, void 0, function() {
                        var target, logoutBtn;
                        return __generator(this, function(_a) {
                            target = e.target;
                            logoutBtn = target.closest("button.st_logout");
                            if (!logoutBtn) return [ 2 ];
                            console.log("[StCartInterceptor] Logout button clicked, resetting flag. sessionStorage");
                            sessionStorage.removeItem("cartRestoredOnce");
                            window.location.replace("/cart/clear?return_to=/account/logout");
                            return [ 2 ];
                        });
                    });
                });
            };
            return _this;
        }
        return StCartInterceptor;
    }(st_module_78.StModule);
    exports.StCartInterceptor = StCartInterceptor;
});

define("extension/shopify-app/st-modules/cart/prefilCartOnLogin", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_79) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StPrefilCart = void 0;
    var StPrefilCart = function(_super) {
        __extends(StPrefilCart, _super);
        function StPrefilCart() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StPrefilCart";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {});
            };
            return _this;
        }
        StPrefilCart.prototype.trySaveCartAfterCheckoutReturn = function() {
            return __awaiter(this, void 0, void 0, function() {
                var ref, fromCheckoutRef, customerId, cart, cartId, saveUrl;
                return __generator(this, function(_a) {
                    switch (_a.label) {
                      case 0:
                        console.log("[StPrefilCart] trySaveCartAfterCheckoutReturn");
                        if (location.pathname.indexOf("/checkouts/") === 0) {
                            console.log("[StPrefilCart] on /checkouts/* => skip");
                            return [ 2 ];
                        }
                        if (this.wasAlreadySaved()) {
                            console.log("[StPrefilCart] already saved in this session => skip");
                            return [ 2 ];
                        }
                        ref = document.referrer || "";
                        fromCheckoutRef = ref.includes("/checkouts/");
                        console.log("[StPrefilCart] referrer:", ref, "fromCheckoutRef:", fromCheckoutRef);
                        if (!fromCheckoutRef) {
                            console.log("[StPrefilCart] not coming from checkout => skip");
                            return [ 2 ];
                        }
                        customerId = window === null || window === void 0 ? void 0 : window.customerShopifyId;
                        console.log("[StPrefilCart] customerShopifyId:", customerId);
                        if (!customerId || customerId === "0") {
                            console.log("[StPrefilCart] customer not logged => skip");
                            return [ 2 ];
                        }
                        return [ 4, this.ajaxGetJson("/cart.js") ];

                      case 1:
                        cart = _a.sent();
                        cartId = String((cart === null || cart === void 0 ? void 0 : cart.token) || (cart === null || cart === void 0 ? void 0 : cart.id) || "").split("?")[0];
                        console.log("[StPrefilCart] cartId:", cartId);
                        if (!cartId) {
                            console.log("[StPrefilCart] missing cartId => skip");
                            return [ 2 ];
                        }
                        saveUrl = this.endpoint["cart"]["save-customer-cart"];
                        console.log("[StPrefilCart] calling save endpoint:", saveUrl);
                        return [ 4, this.ajaxPostJson(saveUrl, {
                            cartId: cartId,
                            customerShopifyId: customerId,
                            customerCartSaved: true
                        }) ];

                      case 2:
                        _a.sent();
                        this.markSaved();
                        console.log("[StPrefilCart] Saved cart after checkout return", {
                            cartId: cartId,
                            customerId: customerId
                        });
                        return [ 2 ];
                    }
                });
            });
        };
        StPrefilCart.prototype.wasAlreadySaved = function() {
            return sessionStorage.getItem("saved_after_checkout") === "1";
        };
        StPrefilCart.prototype.markSaved = function() {
            sessionStorage.setItem("saved_after_checkout", "1");
        };
        StPrefilCart.prototype.ajaxPostJson = function(endpoint, data) {
            var _this = this;
            return new Promise(function(resolve, reject) {
                _this.ajax.send({
                    endpoint: endpoint,
                    method: "POST",
                    contentType: "json",
                    data: data,
                    callback: function(request) {
                        try {
                            if (request.status < 200 || request.status >= 300) {
                                return reject(new Error("HTTP ".concat(request.status)));
                            }
                            resolve(JSON.parse(request.responseText || "{}"));
                        } catch (e) {
                            reject(e);
                        }
                    }
                });
            });
        };
        StPrefilCart.prototype.ajaxGetJson = function(endpoint) {
            var _this = this;
            return new Promise(function(resolve, reject) {
                _this.ajax.send({
                    endpoint: endpoint,
                    method: "GET",
                    contentType: "json",
                    callback: function(request) {
                        try {
                            if (request.status < 200 || request.status >= 300) {
                                return reject(new Error("HTTP ".concat(request.status)));
                            }
                            resolve(JSON.parse(request.responseText || "{}"));
                        } catch (e) {
                            reject(e);
                        }
                    }
                });
            });
        };
        return StPrefilCart;
    }(st_module_79.StModule);
    exports.StPrefilCart = StPrefilCart;
});

define("extension/shopify-app/st-modules/account-login/customers-login", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_80, notification_12) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StOverideLogin = void 0;
    var StOverideLogin = function(_super) {
        __extends(StOverideLogin, _super);
        function StOverideLogin(generalMethods, notification) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StOverideLogin";
            _this.loginAsRetail = true;
            _this.init = function() {
                _this.clickedButtons();
                _this.toggleLoginType(true);
                _this.clickOnSubmit();
                _this.setupFormSwitch();
                _this.bindBecomeConsultant();
                _this.togglePassword();
            };
            _this.setupFormSwitch = function() {
                var loginWrapper = document.getElementById("lbri-login-wrapper");
                var recoveryWrapper = document.getElementById("lbri-recovery-wrapper");
                var recoverLinks = document.querySelectorAll('a[href="#recover"]');
                var cancelLink = document.querySelector('a[href="#login"]');
                var showRecovery = function() {
                    if (loginWrapper) loginWrapper.style.display = "none";
                    if (recoveryWrapper) recoveryWrapper.style.display = "block";
                };
                var showLogin = function() {
                    if (recoveryWrapper) recoveryWrapper.style.display = "none";
                    if (loginWrapper) loginWrapper.style.display = "flex";
                };
                recoverLinks.forEach(function(link) {
                    link.addEventListener("click", function(e) {
                        e.preventDefault();
                        showRecovery();
                        window.location.hash = "#recover";
                    });
                });
                if (cancelLink) {
                    cancelLink.addEventListener("click", function(e) {
                        e.preventDefault();
                        showLogin();
                        window.location.hash = "#login";
                    });
                }
            };
            _this.clickedButtons = function() {
                var customerBtn = document.querySelector(".lbri-retail-login");
                var consultantBtn = document.querySelector(".lbri-consultant-login");
                if (customerBtn && consultantBtn) {
                    customerBtn.addEventListener("click", function() {
                        return _this.toggleLoginType(true);
                    });
                    consultantBtn.addEventListener("click", function() {
                        return _this.toggleLoginType(false);
                    });
                }
            };
            _this.toggleLoginType = function(isRetail) {
                _this.loginAsRetail = isRetail;
                var customerBtn = document.querySelector(".lbri-retail-login");
                var consultantBtn = document.querySelector(".lbri-consultant-login");
                var customerHeader = document.querySelector(".lbri-login-header__customer");
                var consultantHeader = document.querySelector(".lbri-login-header__consultant");
                var signInButton = document.querySelector(".lbri-signin-button");
                var createAccLink = document.querySelector(".lbri-create-account");
                var consultantLink = document.querySelector(".lbri-become-consultant");
                var image = document.querySelector(".lbri_login-image");
                if (isRetail) {
                    customerBtn === null || customerBtn === void 0 ? void 0 : customerBtn.classList.add("active");
                    consultantBtn === null || consultantBtn === void 0 ? void 0 : consultantBtn.classList.remove("active");
                    customerHeader.style.display = "block";
                    consultantHeader.style.display = "none";
                    signInButton.style.backgroundColor = "#4F8643";
                    signInButton.style.color = "white";
                    createAccLink.style.display = "flex";
                    consultantLink.style.display = "none";
                    image === null || image === void 0 ? void 0 : image.setAttribute("src", "https://cdn.shopify.com/s/files/1/0694/4892/5370/files/customer.png?v=1749737985");
                } else {
                    customerBtn === null || customerBtn === void 0 ? void 0 : customerBtn.classList.remove("active");
                    consultantBtn === null || consultantBtn === void 0 ? void 0 : consultantBtn.classList.add("active");
                    customerHeader.style.display = "none";
                    consultantHeader.style.display = "block";
                    signInButton.style.backgroundColor = "#C89A60";
                    signInButton.style.color = "white";
                    createAccLink.style.display = "none";
                    consultantLink.style.display = "flex";
                    image === null || image === void 0 ? void 0 : image.setAttribute("src", "https://cdn.shopify.com/s/files/1/0694/4892/5370/files/consultant.png?v=1749738237");
                }
            };
            _this.clickOnSubmit = function() {
                var submitButton = document.querySelector(".lbri_login-submit-btn_JS");
                if (submitButton) {
                    submitButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.loginOveride();
                    });
                }
            };
            _this.getRequestData = function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var emailInput, passwordInput, cart, cartId;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            emailInput = document.querySelector(".lbri_login-email-input_JS");
                            passwordInput = document.querySelector(".lbri_login-password-input_JS");
                            console.log("document referrer ", document.referrer);
                            return [ 4, this.ajaxGetJson("/cart.js") ];

                          case 1:
                            cart = _a.sent();
                            cartId = cart.token || cart.id;
                            cartId = String(cartId || "").split("?")[0];
                            return [ 2, {
                                emailOrId: emailInput === null || emailInput === void 0 ? void 0 : emailInput.value,
                                password: passwordInput === null || passwordInput === void 0 ? void 0 : passwordInput.value,
                                loginAsRetail: this.loginAsRetail,
                                url: document.referrer,
                                SHOPIFY_DOMAIN_NAME: window.location.hostname,
                                cartId: cartId
                            } ];
                        }
                    });
                });
            };
            _this.loginOveride = function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var requestData, errorBox;
                    var _this = this;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            return [ 4, this.getRequestData() ];

                          case 1:
                            requestData = _a.sent();
                            errorBox = document.querySelector(".lbri-login-error-message");
                            this.toggleLoader(true);
                            this.ajax.send({
                                endpoint: this.endpoint["customer"]["customer-login"],
                                method: "post",
                                contentType: "json",
                                data: requestData,
                                callback: function(response) {
                                    return __awaiter(_this, void 0, void 0, function() {
                                        var loginResponse, customerShopifyId, error_2;
                                        var _a, _b, _c, _d, _e;
                                        return __generator(this, function(_f) {
                                            switch (_f.label) {
                                              case 0:
                                                _f.trys.push([ 0, 4, , 5 ]);
                                                loginResponse = JSON.parse(response.response);
                                                console.log("response ", response);
                                                if (!(loginResponse.status === 200)) return [ 3, 3 ];
                                                if (errorBox) {
                                                    errorBox.style.display = "none";
                                                    errorBox.innerText = "";
                                                }
                                                customerShopifyId = (_a = loginResponse === null || loginResponse === void 0 ? void 0 : loginResponse.data) === null || _a === void 0 ? void 0 : _a.id;
                                                console.log("Customer Login get Cart Data from response  ", (_b = loginResponse === null || loginResponse === void 0 ? void 0 : loginResponse.data) === null || _b === void 0 ? void 0 : _b.cartInfo);
                                                if (!((_c = loginResponse === null || loginResponse === void 0 ? void 0 : loginResponse.data) === null || _c === void 0 ? void 0 : _c.cartInfo)) return [ 3, 2 ];
                                                return [ 4, this.restoreCart((_e = (_d = loginResponse === null || loginResponse === void 0 ? void 0 : loginResponse.data) === null || _d === void 0 ? void 0 : _d.cartInfo) === null || _e === void 0 ? void 0 : _e.items) ];

                                              case 1:
                                                _f.sent();
                                                console.log("Customer Login get Cart Data ");
                                                _f.label = 2;

                                              case 2:
                                                this.toggleLoader(false);
                                                window.location.assign(loginResponse.data.url);
                                                return [ 2 ];

                                              case 3:
                                                if (errorBox) {
                                                    errorBox.innerText = loginResponse.message || "Invalid credentials or server error.";
                                                    errorBox.style.display = "block";
                                                }
                                                this.toggleLoader(false);
                                                this.notification.showNotification(notification_12.ENotificationType.error, "Login Failed", loginResponse.message || "Invalid credentials.");
                                                return [ 3, 5 ];

                                              case 4:
                                                error_2 = _f.sent();
                                                if (errorBox) {
                                                    errorBox.innerText = "Unexpected error occurred.";
                                                    errorBox.style.display = "block";
                                                }
                                                this.toggleLoader(false);
                                                this.notification.showNotification(notification_12.ENotificationType.error, "Server Error", error_2 instanceof Error ? error_2.message : String(error_2));
                                                return [ 3, 5 ];

                                              case 5:
                                                return [ 2 ];
                                            }
                                        });
                                    });
                                }
                            });
                            return [ 2 ];
                        }
                    });
                });
            };
            _this.getRepIdFromLocalStorage = function() {
                var raw = window.localStorage.getItem("repId");
                if (!raw) return null;
                var val = raw.trim();
                return val || null;
            };
            _this.getRepIdFromUrl = function() {
                var params = new URLSearchParams(window.location.search);
                var raw = params.get("repId");
                var val = raw && raw.trim();
                return val || null;
            };
            _this.buildBdtEnrollUrl = function() {
                var _a;
                var base = "https://extranet.lbri.com/Lbri/Signup/EnrollNew.asp?sponsordid=434475";
                var url = new URL(base);
                var repId = (_a = _this.getRepIdFromLocalStorage()) !== null && _a !== void 0 ? _a : _this.getRepIdFromUrl();
                if (repId) {
                    url.searchParams.set("sponsordid", repId);
                }
                return url.toString();
            };
            _this.bindBecomeConsultant = function() {
                var btn = document.querySelector(".lbri-become-consultant_JS");
                if (!btn) return;
                var el = btn;
                if (el.dataset.bound === "1") return;
                el.dataset.bound = "1";
                btn.addEventListener("click", function(e) {
                    e.preventDefault();
                    var url = _this.buildBdtEnrollUrl();
                    window.location.assign(url);
                });
            };
            _this.togglePassword = function() {
                var inputs = Array.from(document.querySelectorAll(".lbri_login-password-input_JS, .st_reset-password-input_JS"));
                inputs.forEach(function(input) {
                    var wrapper = input.closest("label.form__field.lbri-input") || input.parentElement;
                    if (!wrapper) return;
                    var btn = wrapper.querySelector(".lbri_toggle-password-visibility-button_JS");
                    if (!btn) return;
                    if (btn._lbriBound === "1") return;
                    btn._lbriBound = "1";
                    if (getComputedStyle(wrapper).position === "static") {
                        wrapper.style.position = "relative";
                    }
                    btn.addEventListener("click", function(e) {
                        e.preventDefault();
                        var isPassword = input.getAttribute("type") === "password";
                        input.setAttribute("type", isPassword ? "text" : "password");
                        btn.classList.toggle("lbri_password-visible", isPassword);
                        btn.setAttribute("aria-pressed", isPassword ? "true" : "false");
                        btn.setAttribute("aria-label", isPassword ? "Hide password" : "Show password");
                        input.focus();
                    });
                });
            };
            _this.generalMethods = generalMethods;
            _this.notification = notification;
            return _this;
        }
        StOverideLogin.prototype.toggleLoader = function(show) {
            var loader = document.querySelector(".lbri_login_loader_JS");
            var submitBtn = loader === null || loader === void 0 ? void 0 : loader.closest("button");
            var createAccountDiv = document.querySelector(".lbri-create-account-wrapper");
            if (!loader) return;
            if (show) {
                loader === null || loader === void 0 ? void 0 : loader.classList.remove("st_hidden");
                submitBtn && (submitBtn.disabled = true);
                submitBtn === null || submitBtn === void 0 ? void 0 : submitBtn.classList.add("opacity-50", "cursor-not-allowed");
                if (createAccountDiv) {
                    createAccountDiv.style.pointerEvents = "none";
                    createAccountDiv.style.opacity = "0.5";
                }
            } else {
                loader === null || loader === void 0 ? void 0 : loader.classList.add("st_hidden");
                if (createAccountDiv) {
                    createAccountDiv.style.pointerEvents = "auto";
                    createAccountDiv.style.opacity = "1";
                }
                submitBtn && (submitBtn.disabled = false);
                submitBtn === null || submitBtn === void 0 ? void 0 : submitBtn.classList.remove("opacity-50", "cursor-not-allowed");
            }
        };
        StOverideLogin.prototype.restoreCart = function(cartData) {
            return __awaiter(this, void 0, void 0, function() {
                var items, clearRes, addRes, addText, cartRes, cart;
                return __generator(this, function(_a) {
                    switch (_a.label) {
                      case 0:
                        items = this.normalizeCartItems(cartData);
                        console.log("[restoreCart] items payload", items);
                        return [ 4, fetch("/cart/clear.js", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            credentials: "same-origin"
                        }) ];

                      case 1:
                        clearRes = _a.sent();
                        console.log("[restoreCart] clear status", clearRes.status);
                        return [ 4, clearRes.text() ];

                      case 2:
                        _a.sent();
                        return [ 4, fetch("/cart/add.js", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            credentials: "same-origin",
                            body: JSON.stringify({
                                items: items
                            })
                        }) ];

                      case 3:
                        addRes = _a.sent();
                        return [ 4, addRes.text() ];

                      case 4:
                        addText = _a.sent();
                        console.log("[restoreCart] add status", addRes.status, "body", addText);
                        return [ 4, fetch("/cart.js", {
                            credentials: "same-origin"
                        }) ];

                      case 5:
                        cartRes = _a.sent();
                        return [ 4, cartRes.json() ];

                      case 6:
                        cart = _a.sent();
                        console.log("[restoreCart] final cart items", cart === null || cart === void 0 ? void 0 : cart.items);
                        return [ 2 ];
                    }
                });
            });
        };
        StOverideLogin.prototype.normalizeCartItems = function(items) {
            return items.map(function(item) {
                var _a;
                var rawId = item.id;
                var variantId = Number((_a = rawId.split("/").pop()) === null || _a === void 0 ? void 0 : _a.split("?")[0]);
                if (!variantId || Number.isNaN(variantId)) return null;
                return {
                    id: variantId,
                    quantity: Number(item.quantity || 0)
                };
            }).filter(Boolean);
        };
        StOverideLogin.prototype.ajaxGetJson = function(endpoint) {
            var _this = this;
            return new Promise(function(resolve, reject) {
                _this.ajax.send({
                    endpoint: endpoint,
                    method: "GET",
                    contentType: "json",
                    callback: function(request) {
                        try {
                            if (request.status < 200 || request.status >= 300) {
                                return reject(new Error("HTTP ".concat(request.status)));
                            }
                            resolve(JSON.parse(request.responseText || "{}"));
                        } catch (e) {
                            reject(e);
                        }
                    }
                });
            });
        };
        StOverideLogin.prototype.ajaxPostJson = function(endpoint, data) {
            var _this = this;
            return new Promise(function(resolve, reject) {
                _this.ajax.send({
                    endpoint: endpoint,
                    method: "POST",
                    contentType: "json",
                    data: data,
                    callback: function(request) {
                        try {
                            if (request.status < 200 || request.status >= 300) {
                                return reject(new Error("HTTP ".concat(request.status)));
                            }
                            resolve(JSON.parse(request.responseText || "{}"));
                        } catch (e) {
                            reject(e);
                        }
                    }
                });
            });
        };
        return StOverideLogin;
    }(st_module_80.StModule);
    exports.StOverideLogin = StOverideLogin;
});

define("extension/shopify-app/st-modules/shopping-on-behalf/shopping-on-behalf", [ "require", "exports", "core/connector-app/_shared/models/auth/auth.request.model", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, auth_request_model_3, st_module_81) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShoppingOnBehalf = void 0;
    var StShoppingOnBehalf = function(_super) {
        __extends(StShoppingOnBehalf, _super);
        function StShoppingOnBehalf() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StShoppingOnBehalf";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.logout();
                });
            };
            _this.logout = function() {
                var wrp = document.querySelector(".lbri_shopping-on-behalf-wrapper");
                if (!wrp) return;
                var logoutBtns = wrp.querySelectorAll(".lbri_onbehalf-btn");
                if (!!logoutBtns) {
                    logoutBtns.forEach(function(btn) {
                        btn.addEventListener("click", function(e) {
                            e.preventDefault();
                            window.location.assign(window.location.protocol + "//" + window.location.hostname + "/account/logout");
                        });
                    });
                }
            };
            _this.removeTokens = function() {
                var token = window.localStorage.getItem(auth_request_model_3.ETokenType.Access);
                if (!!token && token.length > 0) window.localStorage.removeItem(auth_request_model_3.ETokenType.Access);
                token = window.localStorage.getItem(auth_request_model_3.ETokenType.Refresh);
                if (!!token && token.length > 0) window.localStorage.removeItem(auth_request_model_3.ETokenType.Refresh);
            };
            return _this;
        }
        return StShoppingOnBehalf;
    }(st_module_81.StModule);
    exports.StShoppingOnBehalf = StShoppingOnBehalf;
});

define("extension/shopify-app/st-modules/account/blocks/credit-ledger/credit-ledger", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/currency" ], function(require, exports, st_module_82, currency_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCreditLedger = void 0;
    var StCreditLedger = function(_super) {
        __extends(StCreditLedger, _super);
        function StCreditLedger(currency) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StCreditLedger";
            _this_1.creditResponseList = [];
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.getCreditsAmount();
                });
            };
            _this_1.getCreditsAmount = function() {
                var _this = _this_1;
                var customerId = window === null || window === void 0 ? void 0 : window.customerShopifyId;
                _this.toggleLoader(true);
                var getAllCustomerLedger = _this.endpoint["order-credits"]["get-all-customer-ledger"];
                try {
                    _this_1.ajax.send({
                        endpoint: getAllCustomerLedger,
                        method: "POST",
                        contentType: "json",
                        data: {
                            customerId: customerId
                        },
                        callback: function(res) {
                            return __awaiter(_this_1, void 0, void 0, function() {
                                var resp, _a;
                                return __generator(this, function(_b) {
                                    switch (_b.label) {
                                      case 0:
                                        resp = JSON.parse(res.response);
                                        if (!(resp.status === 200)) return [ 3, 2 ];
                                        _a = _this;
                                        return [ 4, _this.enrichLedgerWithDetails(resp.data, customerId) ];

                                      case 1:
                                        _a.creditResponseList = _b.sent();
                                        _this.toggleLoader(false);
                                        _this.renderCreditTableBody(_this.creditResponseList);
                                        return [ 3, 3 ];

                                      case 2:
                                        console.log("Error fetching credit ledgers", resp.message);
                                        _this.toggleLoader(false);
                                        _b.label = 3;

                                      case 3:
                                        return [ 2 ];
                                    }
                                });
                            });
                        }
                    });
                } catch (err) {
                    console.log("getCreditsAmount---\x3e Error:", err);
                }
            };
            _this_1.getCreditsAmountForLedger = function(customerId, creditAccountID) {
                var _this = _this_1;
                var getAllCustomerLedger = _this.endpoint["order-credits"]["get-all-credits-for-ledger"];
                return new Promise(function(resolve, reject) {
                    try {
                        _this.ajax.send({
                            endpoint: getAllCustomerLedger,
                            method: "POST",
                            contentType: "json",
                            data: {
                                customerShopifyId: customerId,
                                creditAccountID: creditAccountID
                            },
                            callback: function(res) {
                                try {
                                    var resp = JSON.parse(res.response);
                                    if (resp.status === 200) {
                                        resolve(resp);
                                    } else {
                                        console.error("Error fetching ledger for credit id = ".concat(creditAccountID, " "), resp.message);
                                        resolve({
                                            data: []
                                        });
                                    }
                                } catch (parseErr) {
                                    reject(parseErr);
                                }
                            }
                        });
                    } catch (err) {
                        reject(err);
                    }
                });
            };
            _this_1.currency = currency;
            return _this_1;
        }
        StCreditLedger.prototype.enrichLedgerWithDetails = function(ledgerList, customerId) {
            return __awaiter(this, void 0, void 0, function() {
                var ids, blockedIds, filtered, enriched;
                var _this_1 = this;
                return __generator(this, function(_a) {
                    switch (_a.label) {
                      case 0:
                        ids = window.creditNotForRetail;
                        blockedIds = ids.map(function(n) {
                            return Number(n);
                        });
                        filtered = ledgerList.filter(function(item) {
                            var id = Number(item.CreditAccountId);
                            return blockedIds.indexOf(id) === -1;
                        });
                        console.log("filtered ", filtered);
                        return [ 4, Promise.all(filtered.map(function(item) {
                            return __awaiter(_this_1, void 0, void 0, function() {
                                var response, firstExpired;
                                return __generator(this, function(_a) {
                                    switch (_a.label) {
                                      case 0:
                                        return [ 4, this.getCreditsAmountForLedger(customerId, item.CreditAccountId) ];

                                      case 1:
                                        response = _a.sent();
                                        firstExpired = this.getNextExpiringCredit(response.data);
                                        return [ 2, __assign(__assign({}, item), {
                                            creditDetails: response.data,
                                            firstNextCreditExpired: firstExpired
                                        }) ];
                                    }
                                });
                            });
                        })) ];

                      case 1:
                        enriched = _a.sent();
                        return [ 2, enriched ];
                    }
                });
            });
        };
        StCreditLedger.prototype.getNextExpiringCredit = function(credits) {
            var today = new Date();
            var upcoming = credits.filter(function(credit) {
                return new Date(credit.dateExpires) >= today;
            }).sort(function(a, b) {
                return new Date(a.dateExpires).getTime() - new Date(b.dateExpires).getTime();
            });
            return upcoming.length > 0 ? upcoming[0] : null;
        };
        StCreditLedger.prototype.renderCreditTableBody = function(creditList) {
            var _this_1 = this;
            var creditBody = document.querySelector(".lbri_credits_table_body_JS");
            if (!creditBody) return;
            var hideDefautlTitleEl = document.querySelectorAll(".st_main-title");
            var creditLedgerMainTitleSt = hideDefautlTitleEl[hideDefautlTitleEl.length - 1];
            if (creditLedgerMainTitleSt) {
                creditLedgerMainTitleSt.classList.add("st_hidden");
            }
            this.renderSumForCredit(creditList);
            creditList.forEach(function(credit, index) {
                var _a, _b, _c, _d;
                var row = document.createElement("tr");
                row.innerHTML = "\n                <td>".concat(credit.Description, "</td>\n                <td>").concat(_this_1.currency.applyFormat(((_a = credit === null || credit === void 0 ? void 0 : credit.firstNextCreditExpired) === null || _a === void 0 ? void 0 : _a.amount) ? (_b = credit === null || credit === void 0 ? void 0 : credit.firstNextCreditExpired) === null || _b === void 0 ? void 0 : _b.amount : 0, currency_2.ECurrencyFormatType.withoutCurrency), "</td>\n                <td>").concat(_this_1.formatDate(((_c = credit === null || credit === void 0 ? void 0 : credit.firstNextCreditExpired) === null || _c === void 0 ? void 0 : _c.dateExpires) ? (_d = credit === null || credit === void 0 ? void 0 : credit.firstNextCreditExpired) === null || _d === void 0 ? void 0 : _d.dateExpires : "N/A"), "</td>\n                <td>").concat(_this_1.currency.applyFormat(credit.Amount, currency_2.ECurrencyFormatType.withoutCurrency), '</td>\n                <td>\n                 <svg class="open-ledger-modal-btn" data-index="').concat(index, '" width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">\n            <path d="M2.58333 16.75C2.07917 16.75 1.64757 16.5705 1.28854 16.2115C0.929514 15.8524 0.75 15.4208 0.75 14.9167V2.08333C0.75 1.57917 0.929514 1.14757 1.28854 0.788542C1.64757 0.429514 2.07917 0.25 2.58333 0.25H9V2.08333H2.58333V14.9167H15.4167V8.5H17.25V14.9167C17.25 15.4208 17.0705 15.8524 16.7115 16.2115C16.3524 16.5705 15.9208 16.75 15.4167 16.75H2.58333ZM6.89167 11.8917L5.60833 10.6083L14.1333 2.08333H10.8333V0.25H17.25V6.66667H15.4167V3.36667L6.89167 11.8917Z" fill="black"/>\n        </svg>\n                </td>\n            ');
                creditBody.appendChild(row);
            });
            this.bindModalEvents();
        };
        StCreditLedger.prototype.renderSumForCredit = function(creditList) {
            var totalAmount = creditList.reduce(function(sum, ledger) {
                return sum + ledger.Amount;
            }, 0);
            var totalAmountEl = document.querySelector(".lbri_credit_sum_JS");
            if (!totalAmountEl) return;
            totalAmountEl.textContent = this.currency.applyFormat(totalAmount, currency_2.ECurrencyFormatType.withoutCurrency);
        };
        StCreditLedger.prototype.toggleLoader = function(show) {
            var loader = document.querySelector(".lbri_load_credit_data_JS");
            if (!loader) return;
            if (show) {
                loader === null || loader === void 0 ? void 0 : loader.classList.remove("st_hidden");
            } else {
                loader === null || loader === void 0 ? void 0 : loader.classList.add("st_hidden");
            }
        };
        StCreditLedger.prototype.bindModalEvents = function() {
            var _this_1 = this;
            var overlay = document.querySelector(".credit-ledger-modal-overlay");
            var closeBtn = document.querySelector(".modal-close-btn");
            var tbody = overlay.querySelector(".lbri_credit_details_modal_JS");
            var footerBalance = overlay.querySelector(".lbri_current_total_balance_ledger_JS");
            document.querySelectorAll(".open-ledger-modal-btn").forEach(function(btn) {
                btn.addEventListener("click", function(e) {
                    var index = parseInt(e.currentTarget.getAttribute("data-index") || "");
                    var ledger = _this_1.creditResponseList[index];
                    if (!ledger || !ledger.creditDetails) return;
                    var titleLedgerEl = document.querySelector(".lbri_modal_title_ledger_JS");
                    if (titleLedgerEl) {
                        titleLedgerEl.innerHTML = ledger.Description;
                    }
                    tbody.innerHTML = "";
                    ledger.creditDetails.forEach(function(item) {
                        var inflow = item.amount > 0 ? "".concat(item.amount) : "/";
                        var outflow = item.amount < 0 ? "".concat(item.amount) : "/";
                        var expiration = item.dateExpires || "/";
                        var row = document.createElement("tr");
                        row.innerHTML = "\n                        <td>".concat(_this_1.formatDate(item.dateCreated), "</td>\n                        <td>").concat(item.description, '</td>\n                        <td style="color: ').concat(outflow === "/" ? "green" : "inherit", ';">').concat(inflow !== "/" ? _this_1.currency.applyFormat(Number(inflow), currency_2.ECurrencyFormatType.withoutCurrency) : "/", '</td>\n                        <td style="color: ').concat(inflow === "/" ? "red" : "inherit", '; font-weight: 400">').concat(outflow !== "/" ? _this_1.fixNegativeCurrencyFormat(_this_1.currency.applyFormat(Number(outflow), currency_2.ECurrencyFormatType.withoutCurrency)) : "/", "</td>\n                        <td>").concat(_this_1.formatDate(expiration), "</td>\n                        <td>").concat(_this_1.currency.applyFormat(item.balance, currency_2.ECurrencyFormatType.withoutCurrency), "</td>\n                    ");
                        tbody.appendChild(row);
                    });
                    footerBalance.textContent = "".concat(_this_1.currency.applyFormat(ledger.Amount, currency_2.ECurrencyFormatType.withoutCurrency));
                    overlay === null || overlay === void 0 ? void 0 : overlay.classList.remove("hidden");
                });
            });
            closeBtn === null || closeBtn === void 0 ? void 0 : closeBtn.addEventListener("click", function() {
                overlay === null || overlay === void 0 ? void 0 : overlay.classList.add("hidden");
            });
            overlay === null || overlay === void 0 ? void 0 : overlay.addEventListener("click", function(e) {
                if (e.target === overlay) {
                    overlay.classList.add("hidden");
                }
            });
        };
        StCreditLedger.prototype.formatDate = function(dateStr) {
            if (!dateStr || dateStr.trim().toUpperCase() === "N/A") return "/";
            var date = new Date(dateStr);
            if (isNaN(date.getTime())) return "/";
            var day = String(date.getDate()).padStart(2, "0");
            var month = String(date.getMonth() + 1).padStart(2, "0");
            var year = date.getFullYear();
            return "".concat(month, "/").concat(day, "/").concat(year);
        };
        StCreditLedger.prototype.fixNegativeCurrencyFormat = function(value) {
            var match = value.match(/^(.)(-)([\d.,]+)/);
            if (match) {
                var currency = match[1];
                var amount = match[3];
                return "-".concat(currency).concat(amount);
            }
            return value;
        };
        return StCreditLedger;
    }(st_module_82.StModule);
    exports.StCreditLedger = StCreditLedger;
});

define("extension/shopify-app/st-modules/consultant-discount-banner/consultant-discount-banner", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_83, _features_config_18) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StConsultantDiscountBanner = void 0;
    var StConsultantDiscountBanner = function(_super) {
        __extends(StConsultantDiscountBanner, _super);
        function StConsultantDiscountBanner(generalMethods, cart) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StConsultantDiscountBanner";
            _this.variantCvCache = new Map();
            _this._observer = null;
            _this._isRefreshing = false;
            _this._refreshQueued = false;
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.observeBannerContainer();
                    _this.safeRefresh();
                    _this.cart.subscribeChangeCart(function() {
                        _this.safeRefresh();
                    });
                });
            };
            _this.observeBannerContainer = function() {
                if (_this._observer) return;
                var root = document.body;
                if (!root) return;
                _this._observer = new MutationObserver(function(mutations) {
                    var bannerWasInserted = mutations.some(function(mutation) {
                        return Array.from(mutation.addedNodes).some(function(node) {
                            if (!(node instanceof Element)) return false;
                            return node.matches(".lbr_consultant-discount-main-wrp_JS") || Boolean(node.querySelector(".lbr_consultant-discount-main-wrp_JS"));
                        });
                    });
                    if (bannerWasInserted && _this.hasPlaceholders()) {
                        _this.safeRefresh();
                    }
                });
                _this._observer.observe(root, {
                    childList: true,
                    subtree: true
                });
            };
            _this.hasPlaceholders = function() {
                var isPlaceholder = function(el) {
                    if (!el) return false;
                    var text = el.innerText.trim();
                    return text === "_" || text === "" || text === "$_" || text === "$";
                };
                return Array.from(document.querySelectorAll(".lbr_consultant-discount-main-wrp_JS")).some(function(wrapper) {
                    var reach = wrapper.querySelector(".lbr_consultant-discount-reach_JS");
                    var get = wrapper.querySelector(".lbr_consultant-discount-get_JS");
                    var missing = wrapper.querySelector(".lbr_consultant-discount-missing_JS");
                    return !reach || !get || isPlaceholder(reach) || isPlaceholder(get) || isPlaceholder(missing);
                });
            };
            _this.progressBarPercentage = function(progress_percentage) {
                var width = Math.max(0, Math.min(progress_percentage, 100));
                var widthValue = width + "%";
                document.querySelectorAll(".lbr_consultant-discount-progress-done").forEach(function(progress) {
                    if (progress.getAttribute("data-done") !== String(width)) {
                        progress.setAttribute("data-done", String(width));
                    }
                    if (progress.style.width !== widthValue) {
                        progress.style.width = widthValue;
                    }
                    if (progress.style.opacity !== "1") {
                        progress.style.opacity = "1";
                    }
                });
            };
            _this.calculateProgress = function(totalCV) {
                var limit = _this.getDiscountLimit();
                if (!Number.isFinite(limit) || limit <= 0) return 0;
                return Number(totalCV) * 100 / limit;
            };
            _this.getDiscountLimit = function() {
                var _a, _b, _c, _d;
                var root = document.querySelector(".lbr_consultant-discount-main-wrp_JS");
                var progress = root === null || root === void 0 ? void 0 : root.querySelector(".lbr_consultant-discount-progress-done");
                return Number((_d = (_c = (_b = (_a = window.rankLevels) === null || _a === void 0 ? void 0 : _a.discounfOver) !== null && _b !== void 0 ? _b : root === null || root === void 0 ? void 0 : root.getAttribute("data-discount-limit")) !== null && _c !== void 0 ? _c : progress === null || progress === void 0 ? void 0 : progress.getAttribute("data-limit")) !== null && _d !== void 0 ? _d : 150);
            };
            _this.getCustomersRank = function() {
                var rank = "";
                var wrapperEl = document.querySelectorAll(".lbr_consultant-discount-main-wrp_JS");
                var rankLevels = window.rankLevels;
                if (!rankLevels || !Array.isArray(rankLevels.ranks)) {
                    return rank;
                }
                if (wrapperEl === null || wrapperEl === void 0 ? void 0 : wrapperEl.length) {
                    wrapperEl.forEach(function(wrp) {
                        var tagsString = (wrp === null || wrp === void 0 ? void 0 : wrp.getAttribute("data-customer-tags")) || "";
                        var tagArray = tagsString.split(",").map(function(tag) {
                            return tag.trim();
                        }).filter(Boolean);
                        var matches = _this.findMatchingRanks(tagArray, rankLevels);
                        var match = matches.length > 0 ? matches[matches.length - 1] : null;
                        if (match === null || match === void 0 ? void 0 : match.title) {
                            rank = match.title;
                        }
                    });
                }
                return rank;
            };
            _this.findMatchingRanks = function(titlesToCheck, rankData) {
                if (!rankData || !Array.isArray(rankData.ranks)) {
                    return [];
                }
                var titleArray = Array.isArray(titlesToCheck) ? titlesToCheck : [ titlesToCheck ];
                var normalizedSet = new Set(titleArray.map(function(t) {
                    return String(t || "").toLowerCase().trim();
                }).filter(Boolean));
                return rankData.ranks.filter(function(r) {
                    var lcTitle = String(r.title || "").toLowerCase().trim();
                    return normalizedSet.has(lcTitle) || normalizedSet.has("rank[".concat(lcTitle, "]"));
                });
            };
            _this.getDataByRankName = function(data, rankName) {
                var _a;
                var match = (_a = data === null || data === void 0 ? void 0 : data.ranks) === null || _a === void 0 ? void 0 : _a.find(function(r) {
                    return r.title === rankName;
                });
                if (!match) {
                    console.warn('Rank "'.concat(rankName, '" not found.'));
                    return null;
                }
                var id = match.id, title = match.title, personallySponsoredQualifiedLines = match.personallySponsoredQualifiedLines, groupVolume = match.groupVolume, commission = match.commission, discountOn150Plus = match.discountOn150Plus, sponsoringBonus = match.sponsoringBonus, cashPromotionBonus = match.cashPromotionBonus;
                return {
                    id: id,
                    title: title,
                    personallySponsoredQualifiedLines: personallySponsoredQualifiedLines,
                    groupVolume: groupVolume,
                    commission: commission,
                    discountOn150Plus: discountOn150Plus,
                    sponsoringBonus: sponsoringBonus,
                    cashPromotionBonus: cashPromotionBonus
                };
            };
            _this.safeRefresh = function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var bannerRoot, totalCV, e_1;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            if (this._isRefreshing) {
                                this._refreshQueued = true;
                                return [ 2 ];
                            }
                            this._isRefreshing = true;
                            _a.label = 1;

                          case 1:
                            _a.trys.push([ 1, 3, 4, 5 ]);
                            bannerRoot = document.querySelector(".lbr_consultant-discount-main-wrp_JS");
                            if (!bannerRoot) return [ 2 ];
                            return [ 4, this.getCartCVTotal() ];

                          case 2:
                            totalCV = _a.sent();
                            this.progressBarPercentage(this.calculateProgress(totalCV));
                            this.writeIntoBanner(totalCV);
                            return [ 3, 5 ];

                          case 3:
                            e_1 = _a.sent();
                            console.error("[ConsultantDiscountBanner] Failed to refresh banner", e_1);
                            return [ 3, 5 ];

                          case 4:
                            this._isRefreshing = false;
                            if (this._refreshQueued) {
                                this._refreshQueued = false;
                                window.setTimeout(this.safeRefresh, 0);
                            }
                            return [ 7 ];

                          case 5:
                            return [ 2 ];
                        }
                    });
                });
            };
            _this.generalMethods = generalMethods;
            _this.cart = cart;
            return _this;
        }
        Object.defineProperty(StConsultantDiscountBanner.prototype, "storefrontToken", {
            get: function() {
                var storefrontKey = window.storefrontKey;
                return storefrontKey;
            },
            enumerable: false,
            configurable: true
        });
        StConsultantDiscountBanner.prototype.getCartCVTotal = function() {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function() {
                var items, cvItems, variantIds, total;
                var _this = this;
                return __generator(this, function(_c) {
                    switch (_c.label) {
                      case 0:
                        items = (_b = (_a = this.cart.getShopifyCartData) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : [];
                        if (!Array.isArray(items) || items.length === 0) {
                            return [ 2, 0 ];
                        }
                        cvItems = items.filter(function(item) {
                            if (!item) return false;
                            if (_this.isSampleItem(item)) return false;
                            if (_this.isFreeGift(item)) return false;
                            return _this.getVariantId(item) !== null;
                        });
                        if (cvItems.length === 0) {
                            return [ 2, 0 ];
                        }
                        variantIds = Array.from(new Set(cvItems.map(function(item) {
                            return _this.getVariantId(item);
                        })));
                        return [ 4, this.ensureVariantCVsLoaded(variantIds) ];

                      case 1:
                        _c.sent();
                        total = cvItems.reduce(function(sum, item) {
                            var _a;
                            var vid = _this.getVariantId(item);
                            if (vid === null) return sum;
                            var cvPerUnit = (_a = _this.variantCvCache.get(vid)) !== null && _a !== void 0 ? _a : 0;
                            var qty = Number(item.quantity || 0);
                            return sum + cvPerUnit * qty;
                        }, 0);
                        return [ 2, Number(total.toFixed(2)) ];
                    }
                });
            });
        };
        StConsultantDiscountBanner.prototype.ensureVariantCVsLoaded = function(variantIds) {
            var _a, _b, _c, _d;
            return __awaiter(this, void 0, void 0, function() {
                var idsToFetch, ids, query, res, _e, _f, _g, json, nodes, _i, nodes_1, node, rawId, cv, e_2;
                var _this = this;
                return __generator(this, function(_h) {
                    switch (_h.label) {
                      case 0:
                        idsToFetch = variantIds.filter(function(id) {
                            return Number.isFinite(id) && !_this.variantCvCache.has(id);
                        });
                        if (idsToFetch.length === 0) return [ 2 ];
                        ids = idsToFetch.map(function(id) {
                            return "gid://shopify/ProductVariant/".concat(id);
                        });
                        query = "\n          query VariantCV($ids: [ID!]!, $ns: String!, $key: String!) {\n            nodes(ids: $ids) {\n              ... on ProductVariant {\n                id\n                metafield(namespace: $ns, key: $key) { value }\n              }\n            }\n          }\n        ";
                        _h.label = 1;

                      case 1:
                        _h.trys.push([ 1, 6, , 7 ]);
                        return [ 4, fetch("/api/".concat(StConsultantDiscountBanner.SF_API_VERSION, "/graphql.json"), {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "X-Shopify-Storefront-Access-Token": this.storefrontToken || ""
                            },
                            body: JSON.stringify({
                                query: query,
                                variables: {
                                    ids: ids,
                                    ns: StConsultantDiscountBanner.CV_META_NAMESPACE,
                                    key: StConsultantDiscountBanner.CV_META_KEY
                                }
                            })
                        }) ];

                      case 2:
                        res = _h.sent();
                        if (!!res.ok) return [ 3, 4 ];
                        _f = (_e = console).error;
                        _g = [ "[CV] Storefront GraphQL error:", res.status ];
                        return [ 4, res.text() ];

                      case 3:
                        _f.apply(_e, _g.concat([ _h.sent() ]));
                        idsToFetch.forEach(function(id) {
                            return _this.variantCvCache.set(id, 0);
                        });
                        return [ 2 ];

                      case 4:
                        return [ 4, res.json() ];

                      case 5:
                        json = _h.sent();
                        nodes = (_b = (_a = json === null || json === void 0 ? void 0 : json.data) === null || _a === void 0 ? void 0 : _a.nodes) !== null && _b !== void 0 ? _b : [];
                        if (!Array.isArray(nodes)) {
                            console.warn("[CV] Unexpected nodes format", nodes);
                            idsToFetch.forEach(function(id) {
                                return _this.variantCvCache.set(id, 0);
                            });
                            return [ 2 ];
                        }
                        for (_i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++) {
                            node = nodes_1[_i];
                            if (!node) continue;
                            rawId = Number(String((node === null || node === void 0 ? void 0 : node.id) || "").split("/").pop());
                            cv = Number.parseFloat((_d = (_c = node === null || node === void 0 ? void 0 : node.metafield) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : "0");
                            if (Number.isFinite(rawId)) this.variantCvCache.set(rawId, Number.isFinite(cv) ? cv : 0);
                        }
                        return [ 3, 7 ];

                      case 6:
                        e_2 = _h.sent();
                        console.error("[CV] Failed to load variant CVs:", e_2);
                        idsToFetch.forEach(function(id) {
                            return _this.variantCvCache.set(id, 0);
                        });
                        return [ 3, 7 ];

                      case 7:
                        return [ 2 ];
                    }
                });
            });
        };
        StConsultantDiscountBanner.prototype.writeIntoBanner = function(totalCV) {
            var _a, _b, _c;
            var rankLevels = window.rankLevels;
            var reachCV = this.getDiscountLimit();
            (_a = document.querySelectorAll(".lbr_consultant-discount-reach_JS")) === null || _a === void 0 ? void 0 : _a.forEach(function(el) {
                var value = "$" + reachCV;
                if (el.textContent !== value) el.textContent = value;
            });
            var rankName = this.getCustomersRank();
            var rankData = this.getDataByRankName(rankLevels, rankName);
            var percentage = rankData === null || rankData === void 0 ? void 0 : rankData.discountOn150Plus;
            (_b = document.querySelectorAll(".lbr_consultant-discount-get_JS")) === null || _b === void 0 ? void 0 : _b.forEach(function(el) {
                var value = "".concat(percentage !== null && percentage !== void 0 ? percentage : 0, "%");
                if (el.textContent !== value) el.textContent = value;
            });
            var need = Math.max(0, reachCV - totalCV);
            var consultantAchieved = (_c = window.stTranslations) === null || _c === void 0 ? void 0 : _c.consultant_achieved;
            document.querySelectorAll(".lbr_consultant-discount-subtitle-wrp").forEach(function(subtitleEl) {
                if (totalCV >= reachCV) {
                    if (consultantAchieved && subtitleEl.innerHTML !== consultantAchieved) {
                        subtitleEl.innerHTML = consultantAchieved;
                    }
                    return;
                }
                var missingEl = subtitleEl.querySelector(".lbr_consultant-discount-missing_JS");
                var missingValue = "$".concat(need.toFixed(2));
                if (missingEl && missingEl.textContent !== missingValue) {
                    missingEl.textContent = missingValue;
                }
            });
        };
        StConsultantDiscountBanner.prototype.isSampleItem = function(item) {
            var _a;
            var flag = (_a = item === null || item === void 0 ? void 0 : item.properties) === null || _a === void 0 ? void 0 : _a._isFreeSample;
            return flag === true || flag === "true";
        };
        StConsultantDiscountBanner.prototype.isFreeGift = function(item) {
            var _a, _b, _c, _d, _e, _f;
            var handle = String((item === null || item === void 0 ? void 0 : item.handle) || "").toLowerCase();
            var title = String((_b = (_a = item === null || item === void 0 ? void 0 : item.product_title) !== null && _a !== void 0 ? _a : item === null || item === void 0 ? void 0 : item.title) !== null && _b !== void 0 ? _b : "").trim().toLowerCase();
            var originalLinePrice = Number((_c = item === null || item === void 0 ? void 0 : item.original_line_price) !== null && _c !== void 0 ? _c : 0);
            var finalLinePrice = Number((_e = (_d = item === null || item === void 0 ? void 0 : item.final_line_price) !== null && _d !== void 0 ? _d : item === null || item === void 0 ? void 0 : item.line_price) !== null && _e !== void 0 ? _e : 0);
            var totalDiscount = Number((_f = item === null || item === void 0 ? void 0 : item.total_discount) !== null && _f !== void 0 ? _f : 0);
            return handle.includes("docapp-free-gift") || handle.includes("free-gift") || title.startsWith("free ") || originalLinePrice > 0 && finalLinePrice <= 0 || originalLinePrice > 0 && totalDiscount >= originalLinePrice;
        };
        StConsultantDiscountBanner.prototype.getVariantId = function(item) {
            var _a;
            var id = Number((_a = item === null || item === void 0 ? void 0 : item.id) !== null && _a !== void 0 ? _a : item === null || item === void 0 ? void 0 : item.variant_id);
            return Number.isFinite(id) ? id : null;
        };
        StConsultantDiscountBanner.CV_META_NAMESPACE = "global";
        StConsultantDiscountBanner.CV_META_KEY = _features_config_18.productVolumesConfig.cvMetafieldKey;
        StConsultantDiscountBanner.SF_API_VERSION = _features_config_18.STORE_FRONT_API_VERSION;
        return StConsultantDiscountBanner;
    }(st_module_83.StModule);
    exports.StConsultantDiscountBanner = StConsultantDiscountBanner;
});

define("extension/shopify-app/st-modules/newsletter-popup/newsletter-popup", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_84) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StNewsletterPopup = void 0;
    var StNewsletterPopup = function(_super) {
        __extends(StNewsletterPopup, _super);
        function StNewsletterPopup() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StNewsletterPopup";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this._handlePopup();
                });
            };
            _this._handlePopup = function() {
                var popup = document.querySelector(".newsletter-popup_JS");
                var closeBtn = document.querySelector(".close-popup_JS");
                var form = document.querySelector(".newsletter-form_JS");
                var formWrapper = document.querySelector(".popup-form-wrapper_JS");
                var thankYouMessage = document.querySelector(".thank-you-message_JS");
                var urlParams = new URLSearchParams(window.location.search);
                var als = urlParams.get("als");
                var alreadySubscribed = localStorage.getItem("newsletterPopupShown");
                if (!als || als === "400560" || als.toLowerCase() === "lbricorp") {
                    if (alreadySubscribed === "true") {
                        popup === null || popup === void 0 ? void 0 : popup.classList.add("st_hidden");
                        return;
                    }
                    popup === null || popup === void 0 ? void 0 : popup.classList.remove("st_hidden");
                    closeBtn === null || closeBtn === void 0 ? void 0 : closeBtn.addEventListener("click", function() {
                        localStorage.setItem("newsletterPopupShown", "true");
                        popup.classList.add("st_hidden");
                        formWrapper.classList.remove("st_hidden");
                        thankYouMessage.classList.add("st_hidden");
                    });
                    form === null || form === void 0 ? void 0 : form.addEventListener("submit", function(e) {
                        e.preventDefault();
                        var emailInput = form.querySelector("input[name='contact[email]']");
                        var email = emailInput.value.trim();
                        if (!email || !email.includes("@")) {
                            alert("Please enter a valid email address.");
                            return;
                        }
                        var formData = new FormData(form);
                        fetch("/contact", {
                            method: "POST",
                            body: formData
                        }).then(function() {
                            localStorage.setItem("newsletterPopupShown", "true");
                            formWrapper.classList.add("st_hidden");
                            thankYouMessage.classList.remove("st_hidden");
                            form.reset();
                            history.replaceState(null, "", window.location.pathname + window.location.search);
                        }).catch(function() {
                            alert("Something went wrong. Please try again.");
                        });
                    });
                }
            };
            return _this;
        }
        return StNewsletterPopup;
    }(st_module_84.StModule);
    exports.StNewsletterPopup = StNewsletterPopup;
});

define("extension/shopify-app/st-modules/catalog-page/product-category", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_85) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCatalogPage = void 0;
    var StCatalogPage = function(_super) {
        __extends(StCatalogPage, _super);
        function StCatalogPage(objectFormatting) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "CatalogPage";
            _this.wiredHosts = new WeakSet();
            _this.rememberedHosts = new WeakSet();
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.configureAllCategoryMenus();
                });
            };
            _this.configureAllCategoryMenus = function() {
                _this.getHosts().forEach(function(host) {
                    _this.rememberOpenOnLink(host);
                    _this.wireCollapsible(host);
                    _this.restoreOpenState(host);
                    _this.ensureOpenWhenActive(host);
                });
            };
            _this.objectFormatting = objectFormatting;
            return _this;
        }
        StCatalogPage.prototype.getHosts = function() {
            return Array.from(document.querySelectorAll(".lbri-cat-sidebar, .lbri-mobile-cat"));
        };
        StCatalogPage.prototype.getGroups = function(host) {
            return host.querySelectorAll(".lbri-cat-group[data-handle]");
        };
        StCatalogPage.prototype.open = function(group, yes) {
            group.classList.toggle("is-open", yes);
            var btn = group.querySelector(".lbri-cat-group__toggle");
            if (btn) {
                btn.setAttribute("aria-expanded", yes ? "true" : "false");
            }
        };
        StCatalogPage.prototype.wireCollapsible = function(host) {
            var _this = this;
            if (this.wiredHosts.has(host)) return;
            this.wiredHosts.add(host);
            host.addEventListener("click", function(ev) {
                var toggle = ev.target.closest(".lbri-cat-group__toggle");
                if (!toggle) return;
                ev.preventDefault();
                ev.stopPropagation();
                var group = toggle.closest(".lbri-cat-group");
                if (!group) return;
                var groups = _this.getGroups(host);
                var willOpen = !group.classList.contains("is-open");
                if (willOpen) {
                    groups.forEach(function(g) {
                        if (g !== group) {
                            _this.open(g, false);
                            try {
                                localStorage.setItem("lbriCatOpen:".concat(g.dataset.handle || ""), "0");
                            } catch (_a) {}
                        }
                    });
                }
                _this.open(group, willOpen);
                try {
                    localStorage.setItem("lbriCatOpen:".concat(group.dataset.handle || ""), willOpen ? "1" : "0");
                } catch (_a) {}
            });
        };
        StCatalogPage.prototype.rememberOpenOnLink = function(host) {
            var _this = this;
            if (this.rememberedHosts.has(host)) return;
            this.rememberedHosts.add(host);
            var links = host.querySelectorAll(".lbri-cat-group__link, .lbri-cat-group__head--link, .lbri-cat-sub__link");
            links.forEach(function(a) {
                a.addEventListener("click", function() {
                    var parent = a.closest(".lbri-cat-group");
                    if (!parent) return;
                    _this.getGroups(host).forEach(function(g) {
                        try {
                            localStorage.setItem("lbriCatOpen:".concat(g.dataset.handle || ""), "0");
                        } catch (_a) {}
                    });
                    var handle = parent.dataset.handle || "";
                    var hasSubs = parent.dataset.hasSubs === "1";
                    try {
                        localStorage.setItem("lbriCatOpen:".concat(handle), hasSubs ? "1" : "0");
                    } catch (_a) {}
                });
            });
        };
        StCatalogPage.prototype.restoreOpenState = function(host) {
            var _this = this;
            var groups = Array.from(this.getGroups(host));
            var forced = groups.find(function(g) {
                return g.dataset.forceOpen === "1";
            });
            if (forced) {
                groups.forEach(function(g) {
                    return _this.open(g, g === forced);
                });
                try {
                    localStorage.setItem("lbriCatOpen:".concat(forced.dataset.handle || ""), "1");
                } catch (_a) {}
                return;
            }
            var opened = false;
            groups.forEach(function(g) {
                var wantOpen = false;
                try {
                    wantOpen = localStorage.getItem("lbriCatOpen:".concat(g.dataset.handle || "")) === "1";
                } catch (_a) {}
                if (wantOpen && !opened) {
                    _this.open(g, true);
                    opened = true;
                } else {
                    _this.open(g, false);
                }
            });
        };
        StCatalogPage.prototype.ensureOpenWhenActive = function(host) {
            var _this = this;
            var groups = Array.from(this.getGroups(host));
            var withActiveChild = groups.find(function(g) {
                return !!g.querySelector(".lbri-cat-sub__item.is-active");
            });
            if (withActiveChild) {
                groups.forEach(function(g) {
                    return _this.open(g, g === withActiveChild);
                });
                try {
                    localStorage.setItem("lbriCatOpen:".concat(withActiveChild.dataset.handle || ""), "1");
                } catch (_a) {}
            }
        };
        return StCatalogPage;
    }(st_module_85.StModule);
    exports.StCatalogPage = StCatalogPage;
});

define("extension/shopify-app/st-modules/account/header/nav/account-nav.extended", [ "require", "exports", "core/shopify-app/st-modules/account/header/nav/account-nav", "core/connector-app/_shared/models/auth/auth.request.model" ], function(require, exports, account_nav_1, auth_request_model_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountNavExtended = void 0;
    var StAccountNavExtended = function(_super) {
        __extends(StAccountNavExtended, _super);
        function StAccountNavExtended(classConfig, objectFormatting, browserHistory, generalMethods, cartComponent) {
            var _this_1 = _super.call(this, classConfig, objectFormatting, browserHistory, generalMethods) || this;
            _this_1.className = "AccountNavExtended";
            _this_1.logout = function() {
                var _this = _this_1;
                var wrp = document.querySelector(_this_1.classConfig.selectorAccountPage);
                if (!wrp) return;
                var logoutBtns = wrp.querySelectorAll(_this_1.classConfig.selectorAccountLogout);
                _this_1.removeTokens();
                try {
                    window.localStorage.setItem("customerCartSaved", "false");
                } catch (err) {
                    console.warn("Failed to reset customerCartSaved flag", err);
                }
                if (!!logoutBtns) {
                    logoutBtns.forEach(function(btn) {
                        btn.addEventListener("click", function(e) {
                            e.preventDefault();
                            try {
                                localStorage.setItem("customerCartSaved", "false");
                            } catch (err) {
                                console.warn("Failed to reset customerCartSaved flag", err);
                            }
                            _this.cartComponent.removeFreeSamplesFromCart(false, function() {
                                fetch("/cart/update.js", {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                        Accept: "application/json"
                                    },
                                    body: JSON.stringify({
                                        attributes: {
                                            _customerTags: "",
                                            _loggedInId: ""
                                        }
                                    })
                                }).catch(function(err) {
                                    console.warn("Failed to clear customer cart attributes on logout", err);
                                }).finally(function() {
                                    window.location.assign(window.location.protocol + "//" + window.location.hostname + "/account/logout");
                                });
                            });
                        });
                    });
                }
            };
            _this_1.openPage = function(pageIndex) {
                var wrp = document.querySelector(_this_1.classConfig.selectorAccountPage);
                var alreadyOpen = wrp.querySelector(_this_1.classConfig.selectorAccountSection + ".st_show");
                var accountSections = wrp.querySelectorAll(_this_1.classConfig.selectorAccountSection);
                if (typeof pageIndex === "undefined") {
                    var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                    var maxTab = accountSections.length - 1;
                    var tabIndex = urlParams.tab ? parseInt(urlParams.tab) : 0;
                    pageIndex = isNaN(tabIndex) ? 0 : tabIndex;
                    pageIndex = tabIndex > maxTab ? maxTab : tabIndex;
                }
                var navHolder = wrp.querySelector(_this_1.classConfig.selectorAccountNavHolder);
                var AccountNavElements = navHolder.querySelectorAll(_this_1.classConfig.selectorAccountNavHolderSingle);
                if (!!alreadyOpen) {
                    alreadyOpen.classList.remove("st_show");
                }
                if (accountSections.length > pageIndex) {
                    accountSections[pageIndex].classList.add("st_show");
                } else {
                    console.error("Invalid page index supplied to Account nav openPage method!");
                }
                var activeSection = accountSections[pageIndex];
                if (activeSection) {
                    _this_1.scrollToTarget(activeSection);
                }
                AccountNavElements.forEach(function(navElement, index) {
                    navElement.classList.remove("current");
                    if (index === pageIndex) {
                        _this_1.updateTabToUrl("" + pageIndex);
                        navElement.classList.add("current");
                    }
                });
            };
            _this_1.getStickyHeaderOffset = function() {
                var selectors = [ ".shopify-section-header-sticky", ".site-header", "header.sticky-header", ".header--sticky" ];
                for (var _i = 0, selectors_1 = selectors; _i < selectors_1.length; _i++) {
                    var sel = selectors_1[_i];
                    var el = document.querySelector(sel);
                    if (el) return el.offsetHeight || 0;
                }
                return 0;
            };
            _this_1.scrollToTarget = function(el, extraOffset) {
                if (extraOffset === void 0) {
                    extraOffset = 0;
                }
                if (!el) return;
                var rect = el.getBoundingClientRect();
                var pageY = window.pageYOffset + rect.top;
                var offset = _this_1.getStickyHeaderOffset() + extraOffset;
                window.scrollTo({
                    top: Math.max(0, pageY - offset - 8),
                    behavior: "smooth"
                });
            };
            _this_1.removeTokens = function() {
                var token = window.localStorage.getItem(auth_request_model_4.ETokenType.Access);
                if (!!token && token.length > 0) window.localStorage.removeItem(auth_request_model_4.ETokenType.Access);
                token = window.localStorage.getItem(auth_request_model_4.ETokenType.Refresh);
                if (!!token && token.length > 0) window.localStorage.removeItem(auth_request_model_4.ETokenType.Refresh);
            };
            _this_1.classConfig = classConfig;
            _this_1.objectFormatting = objectFormatting;
            _this_1.browserHistory = browserHistory;
            _this_1.generalMethods = generalMethods;
            _this_1.cartComponent = cartComponent;
            return _this_1;
        }
        return StAccountNavExtended;
    }(account_nav_1.StAccountNav);
    exports.StAccountNavExtended = StAccountNavExtended;
});

define("extension/shopify-app/st-modules/account/blocks/order-history/order-params", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("extension/shopify-app/st-modules/account/blocks/order-history/order-history-extend", [ "require", "exports", "core/shopify-app/st-modules/account/blocks/order-history/order-history" ], function(require, exports, order_history_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountOrderHistoryExtended = void 0;
    var StAccountOrderHistoryExtended = function(_super) {
        __extends(StAccountOrderHistoryExtended, _super);
        function StAccountOrderHistoryExtended(cfg, gm) {
            var _this_1 = _super.call(this, cfg, gm) || this;
            _this_1.className = "AccountOrderHistoryExtended";
            _this_1.bdtOrders = [];
            _this_1.downloadHandlerBound = false;
            _this_1.pageSize = 5;
            _this_1.currentPage = 1;
            _this_1.paginationBound = false;
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.getOrdersFromBDT();
                    _this_1.downloadInvoice();
                    _this_1.observeOrdersSectionVisibility();
                });
            };
            _this_1.getOrdersFromBDT = function() {
                var _a;
                var _this = _this_1;
                var customerId = Number((_a = window === null || window === void 0 ? void 0 : window.customerInfoMetafields) === null || _a === void 0 ? void 0 : _a.customerId);
                if (!customerId) {
                    console.error("Missing customerId in window.customerInfoMetafields");
                    return;
                }
                var shopifyCustomerId = Number(window === null || window === void 0 ? void 0 : window.customerShopifyId);
                if (!shopifyCustomerId) {
                    console.error("Missing shopifyCustomerId in window");
                    return;
                }
                var consultantRetailId = window === null || window === void 0 ? void 0 : window.consultantRetailId;
                if (consultantRetailId) {
                    customerId = consultantRetailId;
                }
                var listEndpoint = _this.endpoint["order"]["orders-from-bdt"];
                if (!listEndpoint) {
                    console.error("orders-from-bdt endpoint not found");
                    return;
                }
                _this_1.toggleOrdersLoader(true);
                _this_1.ajax.send({
                    endpoint: listEndpoint,
                    method: "POST",
                    contentType: "json",
                    data: {
                        customerId: customerId,
                        shopifyCustomerId: shopifyCustomerId
                    },
                    callback: function(res) {
                        var _a;
                        try {
                            var resp = JSON.parse(res.response);
                            if (resp.status === 200) {
                                _this_1.bdtOrders = ((_a = resp.data) !== null && _a !== void 0 ? _a : []).slice();
                                _this_1.currentPage = 1;
                                _this_1.renderOrdersFromBDT(_this_1.getPagedOrders());
                                _this_1.renderPagination();
                                _this_1.bindPaginationHandlers();
                                _this_1.openSingleOrder();
                                _this_1.backToHistoryOrders();
                            } else {
                                _this_1.renderOrdersFromBDT([]);
                                _this_1.renderPagination();
                            }
                        } catch (e) {
                            console.error("Parse error:", e);
                            _this_1.renderOrdersFromBDT([]);
                        } finally {
                            _this_1.toggleOrdersLoader(false);
                        }
                    }
                });
            };
            _this_1.openSingleOrder = function() {
                var _this = _this_1;
                var triggers = document.querySelectorAll(_this.classConfig.selectorOpenSingleOrderButton);
                triggers.forEach(function(el) {
                    el.addEventListener("click", function(e) {
                        e.preventDefault();
                        var orderIdStr = el.getAttribute("data-order-id") || "0";
                        var orderId = Number(orderIdStr);
                        var totalPrice = Number(el.getAttribute("data-total-price") || "0");
                        var description = el.getAttribute("data-description") || "";
                        var orderWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameOrderHistory);
                        orderWrapper.classList.add(_this.classConfig.classNameOpenOrderCSSClass);
                        var single = orderWrapper.querySelector(_this.classConfig.selectorSingleOrder + '[data-order-id="'.concat(orderIdStr, '"]'));
                        if (single) {
                            single.style.display = "block";
                            var singleOrder = single.querySelector(".bdt-order-status");
                            if (singleOrder) singleOrder.textContent = description || "";
                            var t = single.querySelector(".bdt-total");
                            if (t) t.textContent = _this.formatMoney(totalPrice || 0);
                            _this.fetchAndFillOrderDetails(orderId, single, totalPrice, description);
                        }
                    });
                });
            };
            _this_1.backToHistoryOrders = function() {
                var _this = _this_1;
                var backs = document.querySelectorAll(_this.classConfig.selectorBackToHistoryOrders);
                backs.forEach(function(btn) {
                    btn.addEventListener("click", function(e) {
                        e.preventDefault();
                        var single = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameSingleOrder);
                        if (single) single.style.display = "none";
                        var wrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameOrderHistory);
                        wrapper === null || wrapper === void 0 ? void 0 : wrapper.classList.remove(_this.classConfig.classNameOpenOrderCSSClass);
                    });
                });
            };
            _this_1.downloadInvoice = function() {
                if (_this_1.downloadHandlerBound) return;
                _this_1.downloadHandlerBound = true;
                document.addEventListener("click", function(e) {
                    return _this_1.handleInvoiceClick(e);
                });
            };
            _this_1.classConfig = cfg;
            _this_1.generalMethods = gm;
            return _this_1;
        }
        StAccountOrderHistoryExtended.prototype.renderOrdersFromBDT = function(bdtOrders) {
            var _this_1 = this;
            var _a;
            var content = document.querySelector(".st_orders--content");
            if (!content) return;
            content.querySelectorAll(".st_orders--row, .st_single-order_JS, .st_single-order").forEach(function(n) {
                return n.remove();
            });
            if (!bdtOrders || !bdtOrders.length) {
                var empty = content.querySelector(".st_order-title");
                if (!empty) {
                    empty = document.createElement("div");
                    empty.className = "st_order-title";
                    content.appendChild(empty);
                }
                empty.innerHTML = "<i>".concat(this.translateNone(), "</i>");
                return;
            } else {
                (_a = content.querySelector(".st_order-title")) === null || _a === void 0 ? void 0 : _a.remove();
            }
            var tpl = document.getElementById("bdt-single-order-template");
            if (!tpl) {
                console.error("bdt-single-order-template missing");
                return;
            }
            var frag = document.createDocumentFragment();
            bdtOrders.forEach(function(o) {
                var _a, _b, _c;
                var btn = document.createElement("button");
                btn.className = "st_orders--row st_orders--main-row st_flex st_align " + _this_1.classConfig.classNameOpenSingleOrderButton;
                btn.type = "button";
                btn.setAttribute("data-order-id", String(o.orderId));
                btn.setAttribute("data-total-price", String((_a = o.totalPrice) !== null && _a !== void 0 ? _a : 0));
                btn.setAttribute("data-description", (_b = o.description) !== null && _b !== void 0 ? _b : "");
                btn.innerHTML = '\n        <span class="st_col st_id">#'.concat(o.orderId, '</span>\n        <span class="st_col">').concat(_this_1.formatMMMddYYYY(o.orderDate), '</span>\n        <span class="st_col st_order-change">').concat(o.description || "", '</span>\n        <span class="st_col st_align-variation"><span class="money">').concat(_this_1.formatMoney(o.totalPrice), "</span></span>\n      ");
                var node = ((_c = tpl.content) !== null && _c !== void 0 ? _c : tpl).cloneNode(true);
                var single = node.querySelector(".st_single-order");
                single.setAttribute("data-order-id", String(o.orderId));
                var idEl = single.querySelector(".bdt-order-id");
                if (idEl) idEl.textContent = "#".concat(o.orderId);
                var dateEl = single.querySelector(".bdt-order-date");
                if (dateEl) dateEl.textContent = _this_1.formatMMMddYYYY(o.orderDate);
                var singleOrderStatus = single.querySelector(".bdt-order-status");
                if (singleOrderStatus) singleOrderStatus.textContent = o.description || "";
                var singleOrderTotal = single.querySelector(".bdt-total");
                if (singleOrderTotal) singleOrderTotal.textContent = _this_1.formatMoney(o.totalPrice);
                var contentFrag = document.createDocumentFragment();
                contentFrag.appendChild(btn);
                contentFrag.appendChild(single);
                frag.appendChild(contentFrag);
            });
            content.appendChild(frag);
        };
        StAccountOrderHistoryExtended.prototype.fetchAndFillOrderDetails = function(orderId, container, totalPrice, description) {
            var _this_1 = this;
            var _this = this;
            var detailsEndpoint = _this.endpoint["order"]["orders-details-from-bdt"];
            if (!detailsEndpoint) {
                console.error("orders-details-from-bdt endpoint not found");
                return;
            }
            var shopifyCustomerId = Number(window === null || window === void 0 ? void 0 : window.customerShopifyId);
            if (!shopifyCustomerId) {
                console.error("Missing shopifyCustomerId in window");
                return;
            }
            this.toggleSingleOrderLoading(container, true);
            this.ajax.send({
                endpoint: detailsEndpoint,
                method: "POST",
                contentType: "json",
                data: {
                    orderId: orderId,
                    totalPrice: totalPrice,
                    description: description,
                    shopifyCustomerId: shopifyCustomerId
                },
                callback: function(res) {
                    try {
                        var resp = JSON.parse(res.response);
                        if (resp.status === 200 && resp.data) {
                            var data = resp.data;
                            var idEl = container.querySelector(".bdt-order-id");
                            if (idEl) idEl.textContent = "#".concat(data.orderId);
                            var dateEl = container.querySelector(".bdt-order-date");
                            if (dateEl && data.orderDate) dateEl.textContent = _this_1.formatMMMddYYYY(data.orderDate);
                            var shipName = container.querySelector(".bdt-ship-name");
                            if (shipName) shipName.textContent = data.shipName || "";
                            var shipStreet = container.querySelector(".bdt-ship-street");
                            if (shipStreet) shipStreet.textContent = data.shipStreet || "";
                            var shipCity = container.querySelector(".bdt-ship-city");
                            if (shipCity) shipCity.textContent = data.shipCity || "";
                            var shipState = container.querySelector(".bdt-ship-state");
                            if (shipState) shipState.textContent = data.shipState || "";
                            var shipPostal = container.querySelector(".bdt-ship-postal");
                            if (shipPostal) shipPostal.textContent = data.shipPostalCode || "";
                            var shipCountry = container.querySelector(".bdt-ship-country");
                            if (shipCountry) shipCountry.textContent = data.shipCountry || "";
                            var consultant = container.querySelector(".bdt-consultant");
                            if (consultant) {
                                var first = data.repFirstName || "";
                                var last = data.repLastName || "";
                                var full = [ first, last ].filter(Boolean).join(" ");
                                consultant.textContent = full;
                            }
                            var subEl = container.querySelector(".bdt-subtotal");
                            if (subEl) subEl.textContent = _this_1.formatMoney(data.subtotal || 0);
                            var shipEl = container.querySelector(".bdt-shipping");
                            if (shipEl) shipEl.textContent = _this_1.formatMoney(data.shippingPrice || 0);
                            var totalEl = container.querySelector(".bdt-total");
                            if (totalEl) totalEl.textContent = _this_1.formatMoney(data.totalPrice);
                            var taxEl = container.querySelector(".bdt-total-tax");
                            if (taxEl) taxEl.textContent = _this_1.formatMoney(data.totalTax || 0);
                            var itemsWrap_1 = container.querySelector(".bdt-lineitems");
                            var rowTpl_1 = document.getElementById("bdt-lineitem-template");
                            if (itemsWrap_1) {
                                itemsWrap_1.innerHTML = "";
                                if (rowTpl_1 && Array.isArray(data.lineItems)) {
                                    data.lineItems.forEach(function(li) {
                                        var _a;
                                        var frag = ((_a = rowTpl_1.content) !== null && _a !== void 0 ? _a : rowTpl_1).cloneNode(true);
                                        var nameElement = frag.querySelector(".bdt-li-name");
                                        if (nameElement) nameElement.textContent = li.productName || "";
                                        var sku = frag.querySelector(".bdt-li-sku");
                                        if (sku) sku.textContent = li.sku || "";
                                        var price = frag.querySelector(".bdt-li-price");
                                        if (price) price.textContent = _this_1.formatMoney(li.price || 0);
                                        var qty = frag.querySelector(".bdt-li-qty");
                                        if (qty) qty.textContent = String(li.quantity || 0);
                                        var tot = frag.querySelector(".bdt-li-total");
                                        if (tot) tot.textContent = _this_1.formatMoney(li.total || 0);
                                        itemsWrap_1.appendChild(frag);
                                    });
                                }
                            }
                            _this_1.fillPartyInfo(container, data.partyId, data.partyHostName);
                        } else {
                            _this_1.showSingleOrderError(container, "Failed to load order details.");
                        }
                    } catch (e) {
                        _this_1.showSingleOrderError(container, "Failed to parse order details.");
                    } finally {
                        _this_1.toggleSingleOrderLoading(container, false);
                    }
                }
            });
        };
        StAccountOrderHistoryExtended.prototype.fillPartyInfo = function(container, partyId, partyHostName) {
            var wrap = container.querySelector(".st_party-info");
            if (!wrap) return;
            var isValidId = typeof partyId === "number" && partyId !== 0;
            var hasHost = false;
            if (Array.isArray(partyHostName)) {
                hasHost = partyHostName.filter(Boolean).length > 0;
            } else if (typeof partyHostName === "string") {
                hasHost = partyHostName.trim().length > 0;
            }
            var shouldShow = isValidId || hasHost;
            if (!shouldShow) {
                wrap.classList.add("st_hidden");
                return;
            }
            var idEl = container.querySelector(".bdt-party-id");
            var hostEl = container.querySelector(".bdt-party-host");
            if (idEl) {
                idEl.textContent = isValidId ? String(partyId) : "";
            }
            if (hostEl) {
                if (Array.isArray(partyHostName)) {
                    hostEl.textContent = partyHostName.join(", ");
                } else {
                    hostEl.textContent = hasHost ? String(partyHostName) : "";
                }
            }
            wrap.classList.remove("st_hidden");
        };
        StAccountOrderHistoryExtended.prototype.toggleOrdersLoader = function(show) {
            var el = document.querySelector(".lbri_load_orders_JS");
            if (el) el.classList.toggle("st_hidden", !show);
        };
        StAccountOrderHistoryExtended.prototype.toggleSingleOrderLoading = function(container, show) {
            var singleOrder = container.querySelector(".st_single-order__loading");
            if (!singleOrder) {
                singleOrder = document.createElement("div");
                singleOrder.className = "st_single-order__loading";
                singleOrder.innerHTML = "<em>Loading…</em>";
                container.appendChild(singleOrder);
            }
            singleOrder.classList.toggle("st_hidden", !show);
        };
        StAccountOrderHistoryExtended.prototype.formatMMMddYYYY = function(dateStr) {
            var date = new Date(dateStr);
            if (isNaN(date.getTime())) return "";
            return date.toLocaleDateString(undefined, {
                month: "short",
                day: "2-digit",
                year: "numeric"
            });
        };
        StAccountOrderHistoryExtended.prototype.formatMoney = function(n) {
            var sign = n < 0 ? "-" : "";
            var abs = Math.abs(n);
            return "".concat(sign, "$").concat(abs.toFixed(2));
        };
        StAccountOrderHistoryExtended.prototype.translateNone = function() {
            return "You haven't placed any orders yet.";
        };
        StAccountOrderHistoryExtended.prototype.showSingleOrderError = function(container, message) {
            container.innerHTML = '<div class="st_order-title"><i>'.concat(message, "</i></div>");
        };
        StAccountOrderHistoryExtended.prototype.saveBlob = function(blob, fileName) {
            var url = URL.createObjectURL(blob);
            var a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        };
        StAccountOrderHistoryExtended.prototype.parseFilename = function(cd) {
            if (!cd) return null;
            var match1 = cd.match(/filename\*=(?:UTF-8''|)([^;]+)/i);
            if (match1 === null || match1 === void 0 ? void 0 : match1[1]) return decodeURIComponent(match1[1].replace(/["']/g, ""));
            var match2 = cd.match(/filename="?([^";]+)"?/i);
            return (match2 === null || match2 === void 0 ? void 0 : match2[1]) || null;
        };
        StAccountOrderHistoryExtended.prototype.getOrderContextFromTarget = function(target) {
            var _a;
            var btn = (_a = target === null || target === void 0 ? void 0 : target.closest) === null || _a === void 0 ? void 0 : _a.call(target, ".st_download_invoice_JS");
            if (!btn) return null;
            var container = this.generalMethods.getClosestByClass(btn, this.classConfig.classNameSingleOrder);
            var orderIdStr = (container === null || container === void 0 ? void 0 : container.getAttribute("data-order-id")) || "";
            var orderId = Number(orderIdStr);
            if (!orderId || !container) return null;
            return {
                container: container,
                orderId: orderId
            };
        };
        StAccountOrderHistoryExtended.prototype.ajaxPostPdfBlob = function(endpoint, data) {
            var _this_1 = this;
            return new Promise(function(resolve, reject) {
                var req = _this_1.ajax.send({
                    endpoint: endpoint,
                    method: "POST",
                    contentType: "json",
                    data: data,
                    callback: function(request) {
                        try {
                            if (request.status !== 200) {
                                return reject(new Error("HTTP ".concat(request.status)));
                            }
                            var blob = request.response;
                            if (!(blob instanceof Blob)) {
                                return reject(new Error("Expected Blob response (check responseType timing)."));
                            }
                            resolve({
                                blob: blob,
                                xhr: request
                            });
                        } catch (e) {
                            reject(e);
                        }
                    }
                });
                try {
                    req.responseType = "blob";
                    req.setRequestHeader("Accept", "application/pdf");
                } catch (e) {
                    console.error("Error download Invoice ", e);
                }
            });
        };
        StAccountOrderHistoryExtended.prototype.handleInvoiceClick = function(e) {
            return __awaiter(this, void 0, void 0, function() {
                var endpoint, shopifyCustomerId, target, ctx, container, orderId, _a, blob, xhr, contentType, disposition, fileName, err_3;
                return __generator(this, function(_b) {
                    switch (_b.label) {
                      case 0:
                        endpoint = this.endpoint["order"]["order-invoice"];
                        if (!endpoint) {
                            console.error("order-invoice endpoint not found");
                            return [ 2 ];
                        }
                        shopifyCustomerId = Number(window === null || window === void 0 ? void 0 : window.customerShopifyId);
                        if (!shopifyCustomerId) {
                            console.error("Missing shopifyCustomerId in window");
                            return [ 2 ];
                        }
                        target = e.target;
                        ctx = this.getOrderContextFromTarget(target);
                        if (!ctx) return [ 2 ];
                        e.preventDefault();
                        container = ctx.container, orderId = ctx.orderId;
                        this.toggleSingleOrderLoading(container, true);
                        _b.label = 1;

                      case 1:
                        _b.trys.push([ 1, 3, 4, 5 ]);
                        this.toggleSingleOrderLoading(container, true);
                        return [ 4, this.ajaxPostPdfBlob(endpoint, {
                            orderId: orderId,
                            shopifyCustomerId: shopifyCustomerId
                        }) ];

                      case 2:
                        _a = _b.sent(), blob = _a.blob, xhr = _a.xhr;
                        contentType = xhr.getResponseHeader("content-type") || "";
                        if (!contentType.includes("application/pdf")) {
                            throw new Error("Unexpected content-type: ".concat(contentType));
                        }
                        disposition = xhr.getResponseHeader("Content-Disposition") || "";
                        fileName = this.parseFilename(disposition) || "invoice_".concat(orderId, ".pdf");
                        this.saveBlob(blob, fileName);
                        return [ 3, 5 ];

                      case 3:
                        err_3 = _b.sent();
                        console.error("Invoice download failed:", err_3);
                        this.showSingleOrderError(container, "Failed to download invoice.");
                        return [ 3, 5 ];

                      case 4:
                        this.toggleSingleOrderLoading(container, false);
                        return [ 7 ];

                      case 5:
                        return [ 2 ];
                    }
                });
            });
        };
        Object.defineProperty(StAccountOrderHistoryExtended.prototype, "totalPages", {
            get: function() {
                var _a, _b;
                return Math.max(1, Math.ceil(((_b = (_a = this.bdtOrders) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) / this.pageSize));
            },
            enumerable: false,
            configurable: true
        });
        StAccountOrderHistoryExtended.prototype.getPagedOrders = function() {
            var _a;
            var start = (this.currentPage - 1) * this.pageSize;
            return ((_a = this.bdtOrders) !== null && _a !== void 0 ? _a : []).slice(start, start + this.pageSize);
        };
        StAccountOrderHistoryExtended.prototype.goToPage = function(n) {
            var max = this.totalPages;
            var next = Math.min(max, Math.max(1, n));
            if (next === this.currentPage) return;
            this.currentPage = next;
            this.renderOrdersFromBDT(this.getPagedOrders());
            this.renderPagination();
            this.openSingleOrder();
            this.backToHistoryOrders();
        };
        StAccountOrderHistoryExtended.prototype.renderPagination = function() {
            var root = document.querySelector(".st_pagination") || function() {
                var _a;
                var divElement = document.createElement("div");
                divElement.className = "st_pagination";
                (_a = document.querySelector(".st_orders--wrapper")) === null || _a === void 0 ? void 0 : _a.appendChild(divElement);
                return divElement;
            }();
            root.innerHTML = "";
            var total = this.totalPages;
            if (total <= 1) {
                root.style.display = "none";
                return;
            }
            root.style.display = "";
            var mkBtn = function(label, role, disabled) {
                var buttonElement = document.createElement("button");
                buttonElement.type = "button";
                buttonElement.className = "st_pag-btn";
                buttonElement.setAttribute("data-role", role);
                buttonElement.disabled = disabled;
                buttonElement.textContent = label;
                return buttonElement;
            };
            var first = mkBtn("«", "first", this.currentPage === 1);
            var prev = mkBtn("‹", "prev", this.currentPage === 1);
            var indicator = document.createElement("span");
            indicator.className = "st_pag-indicator";
            indicator.setAttribute("aria-live", "polite");
            indicator.textContent = String(this.currentPage);
            indicator.title = "of ".concat(total);
            var next = mkBtn("›", "next", this.currentPage === total);
            var last = mkBtn("»", "last", this.currentPage === total);
            root.appendChild(first);
            root.appendChild(prev);
            root.appendChild(indicator);
            root.appendChild(next);
            root.appendChild(last);
        };
        StAccountOrderHistoryExtended.prototype.bindPaginationHandlers = function() {
            var _this_1 = this;
            if (this.paginationBound) return;
            this.paginationBound = true;
            document.addEventListener("click", function(e) {
                var targetElement = e.target;
                if (!(targetElement === null || targetElement === void 0 ? void 0 : targetElement.closest)) return;
                var btn = targetElement.closest(".st_pagination .st_pag-btn");
                if (!btn) return;
                var role = btn.getAttribute("data-role");
                if (!role) return;
                e.preventDefault();
                switch (role) {
                  case "first":
                    _this_1.goToPage(1);
                    break;

                  case "prev":
                    _this_1.goToPage(_this_1.currentPage - 1);
                    break;

                  case "next":
                    _this_1.goToPage(_this_1.currentPage + 1);
                    break;

                  case "last":
                    _this_1.goToPage(_this_1.totalPages);
                    break;
                }
            });
        };
        StAccountOrderHistoryExtended.prototype.resetOrdersView = function(section) {
            var scope = section || document;
            var wrapper = scope.querySelector ? scope.querySelector(".st_orders-main--wrapper") : document.querySelector(".st_orders-main--wrapper");
            if (!wrapper) return;
            wrapper.classList.remove(this.classConfig.classNameOpenOrderCSSClass);
            wrapper.querySelectorAll(this.classConfig.selectorSingleOrder).forEach(function(el) {
                el.style.display = "none";
            });
        };
        StAccountOrderHistoryExtended.prototype.findOrdersSection = function() {
            var wrapper = document.querySelector(".st_orders-main--wrapper");
            if (!wrapper) return null;
            var p = wrapper.parentElement;
            while (p) {
                if (p.matches && p.matches(this.classConfig.selectorAccountSection)) return p;
                p = p.parentElement;
            }
            return null;
        };
        StAccountOrderHistoryExtended.prototype.observeOrdersSectionVisibility = function() {
            var _this_1 = this;
            var section = this.findOrdersSection();
            if (!section) return;
            var obs = new MutationObserver(function(muts) {
                for (var _i = 0, muts_1 = muts; _i < muts_1.length; _i++) {
                    var m = muts_1[_i];
                    if (m.type === "attributes" && m.attributeName === "class") {
                        if (section.classList.contains("st_show")) _this_1.resetOrdersView(section);
                    }
                }
            });
            obs.observe(section, {
                attributes: true,
                attributeFilter: [ "class" ]
            });
        };
        return StAccountOrderHistoryExtended;
    }(order_history_1.StAccountOrderHistory);
    exports.StAccountOrderHistoryExtended = StAccountOrderHistoryExtended;
});

define("extension/shopify-app/st-modules/account/blocks/personal-info/personal-info-extend", [ "require", "exports", "core/shopify-app/st-modules/account/blocks/personal-info/personal-info" ], function(require, exports, personal_info_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountPersonalInfoExtended = void 0;
    var StAccountPersonalInfoExtended = function(_super) {
        __extends(StAccountPersonalInfoExtended, _super);
        function StAccountPersonalInfoExtended(classConfig, form, formFormatting, buttonActions, notification, generalMethods) {
            var _this = _super.call(this, classConfig, form, formFormatting, buttonActions, notification, generalMethods) || this;
            _this.className = "AccountPersonalInfoExtended";
            _this.representativeInputSelector = ".st_representative-info-fullname_JS";
            _this.representativeBannerSelector = ".st_representative-fullname_JS";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.editPersonalInfo();
                    _this.setupFormatPhoneNumber();
                    _this.setupRepresentativeInfoUpdate();
                });
            };
            _this.setupRepresentativeInfoUpdate = function() {
                _this.updateRepresentativeInfoFromBanner();
                var representativeBanner = document.querySelector(_this.representativeBannerSelector);
                if (!representativeBanner) {
                    return;
                }
                new MutationObserver(_this.updateRepresentativeInfoFromBanner).observe(representativeBanner, {
                    childList: true,
                    characterData: true,
                    subtree: true
                });
            };
            _this.updateRepresentativeInfoFromBanner = function() {
                var representativeInput = document.querySelector(_this.representativeInputSelector);
                var representativeBanner = document.querySelector(_this.representativeBannerSelector);
                if (!representativeInput || !representativeBanner) {
                    return;
                }
                var representativeName = representativeBanner.innerText.trim();
                if (!representativeName) {
                    return;
                }
                representativeInput.value = representativeName;
                representativeInput.setAttribute("value", representativeName);
            };
            return _this;
        }
        return StAccountPersonalInfoExtended;
    }(personal_info_1.StAccountPersonalInfo);
    exports.StAccountPersonalInfoExtended = StAccountPersonalInfoExtended;
});

define("extension/shopify-app/st-modules/account/blocks/addresses/addresses-extend", [ "require", "exports", "core/shopify-app/st-modules/_general-methods/notification", "core/shopify-app/st-modules/account/blocks/addresses/addresses" ], function(require, exports, notification_13, addresses_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountAddressesExtended = void 0;
    var StAccountAddressesExtended = function(_super) {
        __extends(StAccountAddressesExtended, _super);
        function StAccountAddressesExtended(classConfig, generalMethods, buttonActions, notification) {
            var _this = _super.call(this, classConfig, generalMethods) || this;
            _this.className = "StAccountAddressesExtended";
            _this.shippingEndpoint = _this.endpoint["customer"]["address-my-account-shipping"];
            _this.billingEndpoint = _this.endpoint["customer"]["address-my-account-billing"];
            _this.shippingCurr = {
                address1: "",
                address2: "",
                city: "",
                state: "",
                zip: "",
                id: "",
                county: "",
                country: "USA"
            };
            _this.shippingView = {
                line1: null,
                line2: null,
                zipCityState: null
            };
            _this.billingView = {
                line1: null,
                line2: null,
                zipCityState: null,
                select: null
            };
            _this.lastShipZip = "";
            _this.lastBillZip = "";
            _this.pendingShipLookup = false;
            _this.pendingBillLookup = false;
            _this.addressActionsInitialized = false;
            _this.billingSubmitting = false;
            _this.shippingSubmitting = false;
            _this.uspsSubmitListenerInitialized = false;
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.openAddressDropDown();
                    _this.setupAddressEdit();
                    _this.setupAddressProvinceField();
                    _this.initShippingModal();
                    _this.initBillingModal();
                    _this.initReadonlyView();
                    _this.initZipLookups();
                    _this.initDelegatedAddressActions();
                    _this.initUspsValidatedSubmitListener();
                    _this.setMastheadOffset();
                    window.addEventListener("load", _this.setMastheadOffset);
                    window.addEventListener("resize", _this.setMastheadOffset);
                    window.addEventListener("scroll", _this.setMastheadOffset);
                });
            };
            _this.openModal = function(modal) {
                if (!modal) return;
                modal.setAttribute("aria-hidden", "false");
                _this.lockScroll(true);
                var dialog = modal.querySelector(".st_modal__dialog");
                if (dialog) {
                    dialog.scrollTop = 0;
                }
            };
            _this.closeModal = function(modal) {
                if (!modal) return;
                modal.setAttribute("aria-hidden", "true");
                _this.lockScroll(false);
            };
            _this.setMastheadOffset = function() {
                var header = document.querySelector(".shopify-section-header") || document.querySelector("header.site-header") || document.querySelector(".st_header");
                var offset = header ? header.getBoundingClientRect().bottom + window.scrollY : 0;
                document.documentElement.style.setProperty("--masthead-offset", "".concat(offset, "px"));
            };
            _this.getTranslate = function(key) {
                try {
                    var translations = window.stTranslations || {};
                    var value = translations[key];
                    return typeof value === "string" ? value : "";
                } catch (_a) {
                    return "";
                }
            };
            _this.getGeoCodeAddresses = function(postalCode) {
                return new Promise(function(resolve, reject) {
                    _this.ajax.send({
                        endpoint: _this.endpoint["customer"]["postal-code"],
                        method: "post",
                        contentType: "json",
                        data: {
                            postalCode: postalCode
                        },
                        callback: function(response) {
                            try {
                                var parsed = typeof response.response === "string" ? JSON.parse(response.response) : response.response;
                                var payload = (parsed === null || parsed === void 0 ? void 0 : parsed.data) ? parsed.data : parsed;
                                resolve(payload);
                            } catch (e) {
                                reject(e);
                            }
                        }
                    });
                });
            };
            _this.buttonActions = buttonActions;
            _this.notification = notification;
            return _this;
        }
        StAccountAddressesExtended.prototype.initDelegatedAddressActions = function() {
            var _this = this;
            if (this.addressActionsInitialized) {
                return;
            }
            this.addressActionsInitialized = true;
            document.addEventListener("click", function(event) {
                var _a, _b;
                var target = event.target;
                if (!target) {
                    return;
                }
                var billingOpenButton = target.closest(".st_open-billing_JS");
                if (billingOpenButton) {
                    event.preventDefault();
                    _this.refreshBillingReferences();
                    var selectedOption = (_b = (_a = _this.billingSelect) === null || _a === void 0 ? void 0 : _a.selectedOptions) === null || _b === void 0 ? void 0 : _b[0];
                    if (selectedOption) {
                        _this.fillBillingFromOption(selectedOption);
                    }
                    _this.syncFloatingLabels(_this.billingForm);
                    _this.openModal(_this.modalBilling);
                    return;
                }
                var shippingOpenButton = target.closest(".st_open-shipping_JS");
                if (shippingOpenButton) {
                    event.preventDefault();
                    _this.refreshShippingReferences();
                    _this.prefillForm(_this.shippingForm, _this.shippingCurr);
                    _this.syncFloatingLabels(_this.shippingForm);
                    _this.openModal(_this.modalShipping);
                    return;
                }
                var closeButton = target.closest(".st_close-modal_JS");
                if (closeButton) {
                    event.preventDefault();
                    var modal = closeButton.closest(".st_modal");
                    _this.closeModal(modal);
                }
            });
        };
        StAccountAddressesExtended.prototype.refreshBillingReferences = function() {
            var _a;
            this.modalBilling = document.querySelector(".st_modal-billing_JS");
            this.billingForm = document.querySelector(".st_billing-form_JS");
            this.billingSaveBtn = document.querySelector(".st_save-billing_JS");
            this.billingSelect = document.querySelector(".st_billing-select_JS");
            this.billZipInput = ((_a = this.billingForm) === null || _a === void 0 ? void 0 : _a.querySelector('[name="zip"]')) || null;
            this.billCitySelect = document.querySelector("#BillingForm-City");
            this.billStateSelect = document.querySelector("#BillingForm-State");
            this.billCountySelect = document.querySelector("#BillingForm-County");
        };
        StAccountAddressesExtended.prototype.refreshShippingReferences = function() {
            var _a;
            this.dataEl = document.getElementById("st-address-data_JS");
            this.modalShipping = document.querySelector(".st_modal-shipping_JS");
            this.shippingForm = document.querySelector(".st_shipping-form_JS");
            this.shippingSaveBtn = document.querySelector(".st_save-shipping_JS");
            this.shipZipInput = ((_a = this.shippingForm) === null || _a === void 0 ? void 0 : _a.querySelector('[name="zip"]')) || null;
            this.shipCitySelect = document.querySelector("#ShippingForm-City");
            this.shipStateSelect = document.querySelector("#ShippingForm-State");
            this.shipCountySelect = document.querySelector("#ShippingForm-County");
        };
        StAccountAddressesExtended.prototype.initShippingModal = function() {
            var _this = this;
            this.dataEl = document.getElementById("st-address-data_JS");
            if (!this.dataEl) return;
            this.shippingCurr = {
                address1: this.attr("shippingAddress1"),
                address2: this.attr("shippingAddress2"),
                city: this.attr("shippingCity"),
                state: (this.attr("shippingState") || "").toUpperCase().slice(0, 2),
                zip: this.attr("shippingZip"),
                id: this.attr("shippingId"),
                county: this.attr("shippingCounty") || "",
                country: this.normalizeCountry(this.attr("shippingCountry"))
            };
            this.modalShipping = document.querySelector(".st_modal-shipping_JS");
            this.shippingForm = document.querySelector(".st_shipping-form_JS");
            this.shippingSaveBtn = document.querySelector(".st_save-shipping_JS");
            var openBtn = document.querySelector(".st_open-shipping_JS");
            if (openBtn) {
                openBtn.addEventListener("click", function() {
                    _this.prefillForm(_this.shippingForm, _this.shippingCurr);
                    _this.syncFloatingLabels(_this.shippingForm);
                    _this.openModal(_this.modalShipping);
                });
            }
            document.querySelectorAll(".st_close-modal_JS").forEach(function(el) {
                el.addEventListener("click", function() {
                    return _this.closeModal(_this.modalShipping);
                });
            });
            if (this.shippingForm) {
                this.shippingForm.setAttribute("novalidate", "");
                this.shippingForm.addEventListener("submit", function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    _this.submitShipping();
                }, true);
                this.shippingForm.addEventListener("keydown", function(e) {
                    var _a;
                    if (e.key !== "Enter") {
                        return;
                    }
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    (_a = _this.shippingSaveBtn) === null || _a === void 0 ? void 0 : _a.click();
                });
            }
        };
        StAccountAddressesExtended.prototype.submitShipping = function() {
            return __awaiter(this, void 0, void 0, function() {
                var error_3, customerId, customerContext, address, payload, err_4;
                var _this = this;
                return __generator(this, function(_a) {
                    switch (_a.label) {
                      case 0:
                        _a.trys.push([ 0, 2, , 3 ]);
                        return [ 4, this.waitForPostalLookup("shipping") ];

                      case 1:
                        _a.sent();
                        return [ 3, 3 ];

                      case 2:
                        error_3 = _a.sent();
                        this.notification.showNotification(notification_13.ENotificationType.error, "Address Error", (error_3 === null || error_3 === void 0 ? void 0 : error_3.message) || "Address information is still being loaded.");
                        return [ 2 ];

                      case 3:
                        if (this.shippingSubmitting) {
                            return [ 2 ];
                        }
                        this.refreshShippingReferences();
                        if (!this.shippingForm) {
                            console.error("[Shipping save] Shipping form is missing");
                            return [ 2 ];
                        }
                        if (this.pendingShipLookup) {
                            this.notification.showNotification(notification_13.ENotificationType.error, "Please wait", "Address information is still being loaded.");
                            return [ 2 ];
                        }
                        customerId = window === null || window === void 0 ? void 0 : window.customerShopifyId;
                        if (!customerId) {
                            console.error("[Shipping save] Shopify customer ID is missing");
                            this.notification.showNotification(notification_13.ENotificationType.error, "An Error Occurred", "Customer information is missing. Please refresh the page and try again.");
                            return [ 2 ];
                        }
                        customerContext = {
                            customerId: customerId,
                            customerBdtId: null
                        };
                        address = this.collectShippingPayload();
                        if (!address) {
                            return [ 2 ];
                        }
                        payload = {
                            StreetAddress: address.address1,
                            StreetAddress2: address.address2 || "",
                            City: address.city,
                            State: address.state,
                            ZIPCode: address.zip,
                            County: address.county || "",
                            Country: address.country || "USA",
                            addressId: address.id,
                            customerId: customerContext.customerId,
                            customerBdtId: customerContext.customerBdtId
                        };
                        if (!payload) return [ 2 ];
                        this.shippingSubmitting = true;
                        if (this.shippingSaveBtn) {
                            this.buttonActions.prevent(this.shippingSaveBtn);
                        }
                        _a.label = 4;

                      case 4:
                        _a.trys.push([ 4, 6, 7, 8 ]);
                        return [ 4, new Promise(function(resolve, reject) {
                            _this.ajax.send({
                                endpoint: _this.shippingEndpoint,
                                method: "post",
                                contentType: "json",
                                data: payload,
                                callback: function(resp) {
                                    try {
                                        var json = JSON.parse(resp.response || "{}");
                                        var ok = json.status === 200;
                                        if (ok) {
                                            _this.notification.showNotification(notification_13.ENotificationType.success, "Saved", "Address has been successfully updated.");
                                            _this.paintShipping(address);
                                            if (_this.dataEl) {
                                                _this.dataEl.setAttribute("data-shipping-address1", address.address1);
                                                _this.dataEl.setAttribute("data-shipping-address2", address.address2 || "");
                                                _this.dataEl.setAttribute("data-shipping-city", address.city);
                                                _this.dataEl.setAttribute("data-shipping-state", address.state);
                                                _this.dataEl.setAttribute("data-shipping-zip", address.zip);
                                                if (address.id) _this.dataEl.setAttribute("data-shipping-id", address.id);
                                            }
                                            _this.setButtonMode(document.querySelector(".st_open-shipping_JS"), "edit");
                                            resolve();
                                        } else {
                                            var msg = (json === null || json === void 0 ? void 0 : json.message) || "Unable to save address.";
                                            _this.notification.showNotification(notification_13.ENotificationType.error, "Address Error", msg);
                                            reject(new Error(msg));
                                        }
                                    } catch (e) {
                                        _this.notification.showNotification(notification_13.ENotificationType.error, "An Error Occurred", (e === null || e === void 0 ? void 0 : e.message) || "Unable to save address.");
                                        reject(e);
                                    }
                                }
                            });
                        }) ];

                      case 5:
                        _a.sent();
                        this.shippingCurr = address;
                        this.closeModal(this.modalShipping);
                        return [ 3, 8 ];

                      case 6:
                        err_4 = _a.sent();
                        console.error("[Shipping save] error:", err_4);
                        this.notification.showNotification(notification_13.ENotificationType.error, "An Error Occurred", (err_4 === null || err_4 === void 0 ? void 0 : err_4.message) || "Unable to save address.");
                        return [ 3, 8 ];

                      case 7:
                        this.shippingSubmitting = false;
                        if (this.shippingSaveBtn) {
                            this.buttonActions.allow(this.shippingSaveBtn);
                        }
                        return [ 7 ];

                      case 8:
                        return [ 2 ];
                    }
                });
            });
        };
        StAccountAddressesExtended.prototype.collectShippingPayload = function() {
            if (!this.shippingForm) return null;
            var fd = new FormData(this.shippingForm);
            var payload = {
                address1: String(fd.get("address1") || "").trim(),
                address2: String(fd.get("address2") || "").trim(),
                city: String(fd.get("city") || "").trim(),
                state: this.normalizeState(String(fd.get("state") || "")),
                zip: String(fd.get("zip") || "").trim(),
                id: String(fd.get("id") || this.shippingCurr.id || "").trim(),
                county: String(fd.get("county") || "").trim(),
                country: String(fd.get("country") || "").trim() || "USA"
            };
            if (!payload.address1 || !payload.city || payload.state.length !== 2 || !this.isValidZip(payload.zip)) {
                this.notification.showNotification(notification_13.ENotificationType.error, "Invalid address", "Please enter a valid address (2-letter state and 5-digit ZIP).");
                return null;
            }
            return payload;
        };
        StAccountAddressesExtended.prototype.prefillForm = function(form, data) {
            if (!form) return;
            [ "address1", "address2", "city", "state", "zip", "id", "county", "country" ].forEach(function(n) {
                var el = form.querySelector('[name="'.concat(n, '"]'));
                if (!el) return;
                var rawVal = data[n];
                if ((n === "country" || n === "county") && (!rawVal || String(rawVal).trim() === "")) {
                    return;
                }
                var val = rawVal || "";
                if (n === "city" && el instanceof HTMLSelectElement) {
                    el.setAttribute("data-original-value", val);
                }
                el.value = val;
                el.dispatchEvent(new Event("input", {
                    bubbles: true
                }));
                el.dispatchEvent(new Event("change", {
                    bubbles: true
                }));
            });
            this.syncFloatingLabels(form);
        };
        StAccountAddressesExtended.prototype.attr = function(key) {
            if (!this.dataEl) return "";
            var k = key.replace(/[A-Z]/g, function(m) {
                return "-".concat(m.toLowerCase());
            });
            var v = this.dataEl.getAttribute("data-".concat(k));
            return (v || "").trim();
        };
        StAccountAddressesExtended.prototype.lockScroll = function(onScroll) {
            document.documentElement.style.overflow = onScroll ? "hidden" : "";
            document.body.style.overflow = onScroll ? "hidden" : "";
        };
        StAccountAddressesExtended.prototype.normalizeState = function(state) {
            return (state || "").toUpperCase().slice(0, 2);
        };
        StAccountAddressesExtended.prototype.isValidZip = function(zipCode) {
            return /^\d{5}(-\d{4})?$/.test(zipCode || "");
        };
        StAccountAddressesExtended.prototype.initBillingModal = function() {
            var _this = this;
            var _a;
            this.modalBilling = document.querySelector(".st_modal-billing_JS");
            this.billingForm = document.querySelector(".st_billing-form_JS");
            this.billingSaveBtn = document.querySelector(".st_save-billing_JS");
            this.billingSelect = document.querySelector(".st_billing-select_JS");
            var openBtn = document.querySelector(".st_open-billing_JS");
            if (openBtn) openBtn.addEventListener("click", function() {
                var _a, _b;
                var openModal = (_b = (_a = _this.billingSelect) === null || _a === void 0 ? void 0 : _a.selectedOptions) === null || _b === void 0 ? void 0 : _b[0];
                if (openModal) _this.fillBillingFromOption(openModal);
                _this.syncFloatingLabels(_this.billingForm);
                _this.openModal(_this.modalBilling);
            });
            (_a = this.billingSelect) === null || _a === void 0 ? void 0 : _a.addEventListener("change", function() {
                var openModal = _this.billingSelect.selectedOptions[0];
                if (openModal) _this.fillBillingFromOption(openModal);
            });
            if (this.billingForm) {
                this.billingForm.setAttribute("novalidate", "");
                this.billingForm.addEventListener("keydown", function(event) {
                    var _a;
                    if (event.key !== "Enter") {
                        return;
                    }
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    (_a = _this.billingSaveBtn) === null || _a === void 0 ? void 0 : _a.click();
                });
            }
            document.querySelectorAll(".st_close-modal_JS").forEach(function(el) {
                el.addEventListener("click", function() {
                    return _this.closeModal(_this.modalBilling);
                });
            });
        };
        StAccountAddressesExtended.prototype.fillBillingFromOption = function(o) {
            var _this = this;
            if (!this.billingForm) return;
            var id = this.normalizeShopifyAddressId(o.value || "");
            var addr1 = o.getAttribute("data-address1") || "";
            var addr2 = o.getAttribute("data-address2") || "";
            var city = o.getAttribute("data-city") || "";
            var state = (o.getAttribute("data-state") || "").toUpperCase().slice(0, 2);
            var zip = o.getAttribute("data-zip") || "";
            var county = o.getAttribute("data-county") || "";
            var countryRaw = o.getAttribute("data-country") || "";
            var country = this.normalizeCountry(countryRaw);
            var set = function(elName, elValue) {
                var el = _this.billingForm.querySelector('[name="'.concat(elName, '"]'));
                if (!el) return;
                if ((elName === "country" || elName === "county") && (!elValue || elValue.trim() === "")) {
                    return;
                }
                if (elName === "city" && el instanceof HTMLSelectElement) {
                    el.setAttribute("data-original-value", elValue);
                }
                el.value = elValue;
                el.dispatchEvent(new Event("input", {
                    bubbles: true
                }));
                el.dispatchEvent(new Event("change", {
                    bubbles: true
                }));
            };
            set("id", id);
            set("address1", addr1);
            set("address2", addr2);
            set("city", city);
            set("state", state);
            set("zip", zip);
            set("county", county);
            set("country", country);
        };
        StAccountAddressesExtended.prototype.collectBillingPayload = function() {
            if (!this.billingForm) return null;
            var formData = new FormData(this.billingForm);
            var payload = {
                addressId: String(formData.get("id") || "").trim(),
                address1: String(formData.get("address1") || "").trim(),
                address2: String(formData.get("address2") || "").trim(),
                city: String(formData.get("city") || "").trim(),
                state: this.normalizeState(String(formData.get("state") || "")),
                zip: String(formData.get("zip") || "").trim(),
                customerId: window === null || window === void 0 ? void 0 : window.customerShopifyId,
                county: String(formData.get("county") || "").trim(),
                country: String(formData.get("country") || "").trim() || "USA"
            };
            if (!payload.address1 || !payload.city || payload.state.length !== 2 || !this.isValidZip(payload.zip)) {
                this.notification.showNotification(notification_13.ENotificationType.error, "Invalid address", "Please enter a valid address.");
                return null;
            }
            payload.id = payload.addressId;
            return payload;
        };
        StAccountAddressesExtended.prototype.submitBilling = function() {
            return __awaiter(this, void 0, void 0, function() {
                var error_4, address, customerId, customerContext, payload, error_5;
                var _this = this;
                return __generator(this, function(_a) {
                    switch (_a.label) {
                      case 0:
                        _a.trys.push([ 0, 2, , 3 ]);
                        return [ 4, this.waitForPostalLookup("billing") ];

                      case 1:
                        _a.sent();
                        return [ 3, 3 ];

                      case 2:
                        error_4 = _a.sent();
                        this.notification.showNotification(notification_13.ENotificationType.error, "Address Error", (error_4 === null || error_4 === void 0 ? void 0 : error_4.message) || "Address information is still being loaded.");
                        return [ 2 ];

                      case 3:
                        if (this.billingSubmitting) {
                            return [ 2 ];
                        }
                        this.refreshBillingReferences();
                        if (!this.billingForm) {
                            console.error("[Billing save] Billing form is missing");
                            return [ 2 ];
                        }
                        return [ 4, this.waitForPostalLookup("billing") ];

                      case 4:
                        _a.sent();
                        address = this.collectBillingPayload();
                        if (!address) {
                            return [ 2 ];
                        }
                        customerId = window === null || window === void 0 ? void 0 : window.customerShopifyId;
                        if (!customerId) {
                            console.error("[Billing save] Shopify customer ID is missing");
                            this.notification.showNotification(notification_13.ENotificationType.error, "An Error Occurred", "Customer information is missing. Please refresh the page and try again.");
                            return [ 2 ];
                        }
                        customerContext = {
                            customerId: customerId,
                            customerBdtId: null
                        };
                        payload = {
                            StreetAddress: address.address1,
                            StreetAddress2: address.address2 || "",
                            City: address.city,
                            State: address.state,
                            ZIPCode: address.zip,
                            County: address.county || "",
                            Country: address.country || "USA",
                            addressId: address.addressId,
                            customerId: customerContext.customerId,
                            customerBdtId: customerContext.customerBdtId
                        };
                        this.billingSubmitting = true;
                        if (this.billingSaveBtn) {
                            this.buttonActions.prevent(this.billingSaveBtn);
                        }
                        _a.label = 5;

                      case 5:
                        _a.trys.push([ 5, 7, 8, 9 ]);
                        return [ 4, new Promise(function(resolve, reject) {
                            _this.ajax.send({
                                endpoint: _this.billingEndpoint,
                                method: "post",
                                contentType: "json",
                                data: payload,
                                callback: function(response) {
                                    var _a, _b;
                                    try {
                                        var json = typeof response.response === "string" ? JSON.parse(response.response || "{}") : response.response;
                                        if ((json === null || json === void 0 ? void 0 : json.status) !== 200) {
                                            reject(new Error((json === null || json === void 0 ? void 0 : json.message) || "Unable to save address."));
                                            return;
                                        }
                                        var newId = ((_a = json === null || json === void 0 ? void 0 : json.data) === null || _a === void 0 ? void 0 : _a.addressId) || (json === null || json === void 0 ? void 0 : json.addressId) || ((_b = json === null || json === void 0 ? void 0 : json.data) === null || _b === void 0 ? void 0 : _b.id) || (json === null || json === void 0 ? void 0 : json.id);
                                        _this.notification.showNotification(notification_13.ENotificationType.success, "Saved", "Address has been successfully updated.");
                                        _this.updateSelectedBillingOption(address, newId);
                                        var normalized = {
                                            addressId: String(newId || address.addressId),
                                            address1: address.address1,
                                            address2: address.address2,
                                            city: address.city,
                                            state: address.state,
                                            zip: address.zip,
                                            county: address.county,
                                            country: address.country
                                        };
                                        _this.upsertBillingOption(normalized);
                                        _this.syncBillingViewOption(normalized);
                                        _this.setButtonMode(document.querySelector(".st_open-billing_JS"), "edit");
                                        resolve();
                                    } catch (error) {
                                        reject(error);
                                    }
                                }
                            });
                        }) ];

                      case 6:
                        _a.sent();
                        this.closeModal(this.modalBilling);
                        return [ 3, 9 ];

                      case 7:
                        error_5 = _a.sent();
                        console.error("[Billing save] error:", error_5);
                        this.notification.showNotification(notification_13.ENotificationType.error, "An Error Occurred", (error_5 === null || error_5 === void 0 ? void 0 : error_5.message) || "Unable to save address.");
                        return [ 3, 9 ];

                      case 8:
                        this.billingSubmitting = false;
                        if (this.billingSaveBtn) {
                            this.buttonActions.allow(this.billingSaveBtn);
                        }
                        return [ 7 ];

                      case 9:
                        return [ 2 ];
                    }
                });
            });
        };
        StAccountAddressesExtended.prototype.updateSelectedBillingOption = function(addr, newId) {
            var _a, _b;
            if (!this.billingSelect) return;
            var opt = (_a = this.billingSelect.selectedOptions) === null || _a === void 0 ? void 0 : _a[0];
            if (!opt) return;
            var id = String(newId || addr.addressId || opt.value || "");
            opt.value = id;
            opt.setAttribute("data-address1", addr.address1);
            opt.setAttribute("data-address2", addr.address2 || "");
            opt.setAttribute("data-city", addr.city);
            opt.setAttribute("data-state", this.normalizeState(addr.state));
            opt.setAttribute("data-zip", addr.zip);
            opt.setAttribute("data-county", addr.county || "");
            opt.setAttribute("data-country", addr.country || "");
            var parts = [ [ addr.address1, addr.address2 ].filter(Boolean).join(" ").trim(), addr.city, this.normalizeState(addr.state), addr.zip ].filter(Boolean);
            opt.textContent = parts.join(", ");
            var hiddenId = (_b = this.billingForm) === null || _b === void 0 ? void 0 : _b.querySelector('[name="id"]');
            if (hiddenId) hiddenId.value = id;
        };
        StAccountAddressesExtended.prototype.setButtonMode = function(btn, mode) {
            if (!btn) return;
            var addText = btn.getAttribute("data-text-add") || "Add";
            var editText = btn.getAttribute("data-text-edit") || "Edit";
            btn.textContent = mode === "edit" ? editText : addText;
        };
        StAccountAddressesExtended.prototype.ensureBillingSelect = function() {
            var _this = this;
            var _a, _b;
            if (this.billingSelect) return this.billingSelect;
            var row = document.createElement("div");
            row.className = "st_form__row st_mb-12 st_billing-select-row_JS";
            var label = document.createElement("label");
            label.className = "st_form__field";
            label.style.width = "100%";
            var span = document.createElement("span");
            span.textContent = (window === null || window === void 0 ? void 0 : window.i18nChooseAddress) || "Choose address";
            var sel = document.createElement("select");
            sel.className = "st_billing-select_JS";
            label.appendChild(span);
            label.appendChild(sel);
            row.appendChild(label);
            (_b = (_a = this.billingForm) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.insertBefore(row, this.billingForm);
            this.billingSelect = sel;
            this.billingSelect.addEventListener("change", function() {
                var option = _this.billingSelect.selectedOptions[0];
                if (option) _this.fillBillingFromOption(option);
            });
            return this.billingSelect;
        };
        StAccountAddressesExtended.prototype.upsertBillingOption = function(addr) {
            var sel = this.ensureBillingSelect();
            if (!sel) return;
            var id = String(addr.addressId);
            var opt = Array.from(sel.options).find(function(o) {
                return o.value === id;
            });
            if (!opt) {
                opt = document.createElement("option");
                opt.value = id;
                sel.appendChild(opt);
            }
            opt.setAttribute("data-address1", addr.address1);
            opt.setAttribute("data-address2", addr.address2 || "");
            opt.setAttribute("data-city", addr.city);
            opt.setAttribute("data-state", this.normalizeState(addr.state));
            opt.setAttribute("data-zip", addr.zip);
            opt.setAttribute("data-county", addr.county || "");
            opt.setAttribute("data-country", addr.country || "");
            opt.textContent = [ [ addr.address1, addr.address2 ].filter(Boolean).join(" ").trim(), addr.city, this.normalizeState(addr.state), addr.zip ].filter(Boolean).join(", ");
            opt.selected = true;
        };
        StAccountAddressesExtended.prototype.normalizeShopifyAddressId = function(id) {
            var searchString = String(id || "");
            var matchId = searchString.match(/\d{5,}/);
            return matchId ? matchId[0] : searchString;
        };
        StAccountAddressesExtended.prototype.initReadonlyView = function() {
            var _this = this;
            var _a, _b;
            this.shippingView.line1 = document.querySelector(".st_shipping-line1_JS");
            this.shippingView.zipCityState = document.querySelector(".st_shipping-zipcitystate_JS");
            this.billingView.line1 = document.querySelector(".st_billing-line1_JS");
            this.billingView.zipCityState = document.querySelector(".st_billing-zipcitystate_JS");
            this.billingView.select = document.querySelector(".st_billing-view-select_JS");
            this.shippingView.line2 = document.querySelector(".st_shipping-line2_JS");
            this.billingView.line2 = document.querySelector(".st_billing-line2_JS");
            if (this.dataEl) {
                this.paintShipping({
                    address1: this.attr("shippingAddress1"),
                    address2: this.attr("shippingAddress2"),
                    city: this.attr("shippingCity"),
                    state: (this.attr("shippingState") || "").toUpperCase().slice(0, 2),
                    zip: this.attr("shippingZip")
                });
            }
            if ((_a = this.billingView.select) === null || _a === void 0 ? void 0 : _a.selectedOptions[0]) this.paintBillingFromOption(this.billingView.select.selectedOptions[0]);
            (_b = this.billingView.select) === null || _b === void 0 ? void 0 : _b.addEventListener("change", function() {
                var opt = _this.billingView.select.selectedOptions[0];
                if (opt) _this.paintBillingFromOption(opt);
            });
        };
        StAccountAddressesExtended.prototype.paintShipping = function(address) {
            var _a;
            if (this.shippingView.line1) this.shippingView.line1.textContent = address.address1 || "—";
            if (this.shippingView.line2) this.shippingView.line2.textContent = address.address2 || "—";
            var combo = [ (_a = address.zip) === null || _a === void 0 ? void 0 : _a.toUpperCase(), address.city ? " ".concat(address.city, ",") : "", address.state ].filter(Boolean).join("");
            if (this.shippingView.zipCityState) this.shippingView.zipCityState.textContent = combo || "—";
        };
        StAccountAddressesExtended.prototype.paintBilling = function(address) {
            var _a;
            if (this.billingView.line1) this.billingView.line1.textContent = address.address1 || "—";
            if (this.billingView.line2) this.billingView.line2.textContent = address.address2 || "—";
            var combo = [ (_a = address.zip) === null || _a === void 0 ? void 0 : _a.toUpperCase(), address.city ? " ".concat(address.city, ",") : "", address.state ].filter(Boolean).join("");
            if (this.billingView.zipCityState) this.billingView.zipCityState.textContent = combo || "—";
        };
        StAccountAddressesExtended.prototype.paintBillingFromOption = function(optionData) {
            var addr1 = optionData.getAttribute("data-address1") || "";
            var addr2 = optionData.getAttribute("data-address2") || "";
            var city = optionData.getAttribute("data-city") || "";
            var state = (optionData.getAttribute("data-state") || "").toUpperCase().slice(0, 2);
            var zip = optionData.getAttribute("data-zip") || "";
            this.paintBilling({
                address1: addr1,
                address2: addr2,
                city: city,
                state: state,
                zip: zip
            });
        };
        StAccountAddressesExtended.prototype.initZipLookups = function() {
            var _a, _b;
            this.shipZipInput = ((_a = this.shippingForm) === null || _a === void 0 ? void 0 : _a.querySelector('[name="zip"]')) || null;
            this.shipCitySelect = document.querySelector("#ShippingForm-City");
            this.shipStateSelect = document.querySelector("#ShippingForm-State");
            this.shipCountySelect = document.querySelector("#ShippingForm-County");
            this.billZipInput = ((_b = this.billingForm) === null || _b === void 0 ? void 0 : _b.querySelector('[name="zip"]')) || null;
            this.billCitySelect = document.querySelector("#BillingForm-City");
            this.billStateSelect = document.querySelector("#BillingForm-State");
            this.billCountySelect = document.querySelector("#BillingForm-County");
            this.disableSelects(true, "shipping");
            this.disableSelects(true, "billing");
            this.bindZipHandlers("shipping");
            this.bindZipHandlers("billing");
        };
        StAccountAddressesExtended.prototype.disableSelects = function(hardClear, scope) {
            var _this = this;
            if (hardClear === void 0) {
                hardClear = false;
            }
            var selects = scope === "shipping" ? [ this.shipStateSelect, this.shipCitySelect, this.shipCountySelect ] : [ this.billStateSelect, this.billCitySelect, this.billCountySelect ];
            selects.forEach(function(selectElement) {
                if (!selectElement) return;
                selectElement.disabled = true;
                if (hardClear) {
                    selectElement.removeAttribute("data-original-value");
                    var placeholderStateLabel = _this.getTranslate("selectState") || "-- Select State --";
                    var placeholderCityLabel = _this.getTranslate("selectCity") || "-- Select City --";
                    var placeholderCountyLabel = _this.getTranslate("selectCounty") || "-- Select County --";
                    selectElement.innerHTML = "";
                    var placeholderOption = document.createElement("option");
                    placeholderOption.value = "";
                    placeholderOption.disabled = true;
                    placeholderOption.selected = true;
                    placeholderOption.textContent = selectElement.id.includes("State") ? placeholderStateLabel : selectElement.id.includes("City") ? placeholderCityLabel : placeholderCountyLabel;
                    selectElement.appendChild(placeholderOption);
                    var wrapper = selectElement.closest(".form__field");
                    if (wrapper) wrapper.classList.remove("form__field--filled");
                }
            });
        };
        StAccountAddressesExtended.prototype.enableSelects = function(scope) {
            var selects = scope === "shipping" ? [ this.shipStateSelect, this.shipCitySelect, this.shipCountySelect ] : [ this.billStateSelect, this.billCitySelect, this.billCountySelect ];
            selects.forEach(function(selectElement) {
                if (!selectElement) return;
                selectElement.disabled = false;
            });
        };
        StAccountAddressesExtended.prototype.bindZipHandlers = function(scope) {
            var _this = this;
            var zipInput = scope === "shipping" ? this.shipZipInput : this.billZipInput;
            if (!zipInput) return;
            var handler = function() {
                return _this.onZipChanged(scope);
            };
            zipInput.addEventListener("change", handler);
            zipInput.addEventListener("blur", handler);
            zipInput.addEventListener("keyup", function(e) {
                if (e.key === "Enter") handler();
            });
            zipInput.addEventListener("input", handler);
            zipInput.addEventListener("paste", function() {
                setTimeout(handler, 0);
            });
        };
        StAccountAddressesExtended.prototype.onZipChanged = function(scope) {
            var _this = this;
            var zipInput = scope === "shipping" ? this.shipZipInput : this.billZipInput;
            if (!zipInput) return;
            var zip = (zipInput.value || "").trim();
            if (!zip || !this.isValidZip(zip)) {
                this.disableSelects(true, scope);
                if (scope === "shipping") {
                    this.syncFloatingLabels(this.shippingForm);
                } else {
                    this.syncFloatingLabels(this.billingForm);
                }
                return;
            }
            var lastZip = scope === "shipping" ? this.lastShipZip : this.lastBillZip;
            var pending = scope === "shipping" ? this.pendingShipLookup : this.pendingBillLookup;
            if (pending || zip === lastZip) return;
            if (scope === "shipping") {
                this.pendingShipLookup = true;
            } else {
                this.pendingBillLookup = true;
            }
            this.disableSelects(false, scope);
            this.getGeoCodeAddresses(zip).then(function(data) {
                return _this.applyPostalData(scope, zip, data);
            }).catch(function() {
                return _this.handleZipLookupError(scope);
            }).finally(function() {
                return _this.finalizeZipLookup(scope);
            });
        };
        StAccountAddressesExtended.prototype.applyPostalData = function(scope, zip, data) {
            if (scope === "shipping") this.lastShipZip = zip; else this.lastBillZip = zip;
            var stateSelect = scope === "shipping" ? this.shipStateSelect : this.billStateSelect;
            var citySelect = scope === "shipping" ? this.shipCitySelect : this.billCitySelect;
            var countySelect = scope === "shipping" ? this.shipCountySelect : this.billCountySelect;
            this.populateSelect(stateSelect, (data === null || data === void 0 ? void 0 : data.States) || [], this.getTranslate("selectState") || "-- Select State --");
            this.populateSelect(citySelect, (data === null || data === void 0 ? void 0 : data.Cities) || [], this.getTranslate("selectCity") || "-- Select City --");
            this.populateSelect(countySelect, (data === null || data === void 0 ? void 0 : data.Counties) || [], this.getTranslate("selectCounty") || "-- Select County --");
            this.autoSelectIfSingle(stateSelect);
            this.autoSelectIfSingle(citySelect);
            this.autoSelectIfSingle(countySelect);
            this.enableSelects(scope);
            if (scope === "shipping") {
                this.syncFloatingLabels(this.shippingForm);
            } else {
                this.syncFloatingLabels(this.billingForm);
            }
        };
        StAccountAddressesExtended.prototype.handleZipLookupError = function(scope) {
            this.disableSelects(true, scope);
            if (scope === "shipping") {
                this.syncFloatingLabels(this.shippingForm);
            } else {
                this.syncFloatingLabels(this.billingForm);
            }
        };
        StAccountAddressesExtended.prototype.finalizeZipLookup = function(scope) {
            if (scope === "shipping") this.pendingShipLookup = false; else this.pendingBillLookup = false;
        };
        StAccountAddressesExtended.prototype.populateSelect = function(selectElement, items, placeholderLabel) {
            if (!selectElement) return;
            var desiredRaw = (selectElement.getAttribute("data-original-value") || "").trim();
            var previousValue = desiredRaw || (selectElement.value || "").trim();
            selectElement.innerHTML = "";
            var placeholderOption = document.createElement("option");
            placeholderOption.value = "";
            placeholderOption.disabled = true;
            placeholderOption.selected = true;
            placeholderOption.textContent = placeholderLabel;
            selectElement.appendChild(placeholderOption);
            items.forEach(function(itemValue) {
                var optionElement = document.createElement("option");
                optionElement.value = itemValue;
                optionElement.textContent = itemValue;
                selectElement.appendChild(optionElement);
            });
            if (!previousValue) return;
            var options = Array.from(selectElement.options).filter(function(option) {
                return option.value !== "";
            });
            var match;
            match = options.find(function(option) {
                return option.value === previousValue;
            });
            var prevLower = previousValue.toLowerCase();
            if (!match) {
                match = options.find(function(option) {
                    return option.value.toLowerCase() === prevLower;
                });
            }
            if (!match) {
                match = options.find(function(option) {
                    return option.value.toLowerCase().startsWith(prevLower);
                });
            }
            if (match) {
                selectElement.value = match.value;
                selectElement.setAttribute("data-original-value", match.value);
            }
        };
        StAccountAddressesExtended.prototype.autoSelectIfSingle = function(selectElement) {
            if (!selectElement) return;
            var nonEmptyOptions = Array.from(selectElement.options).filter(function(option) {
                return option.value !== "";
            });
            if (nonEmptyOptions.length === 1) selectElement.value = nonEmptyOptions[0].value;
        };
        StAccountAddressesExtended.prototype.syncFloatingLabels = function(form) {
            var root = form || document;
            var fields = Array.from(root.querySelectorAll(".form__field__input, .form__field__select"));
            fields.forEach(function(el) {
                var wrapper = el.closest(".form__field");
                if (!wrapper) return;
                if (el instanceof HTMLSelectElement) {
                    wrapper.classList.add("form__field--filled");
                    return;
                }
                var hasValue = !!(el.value || "").trim();
                if (hasValue) {
                    wrapper.classList.add("form__field--filled");
                } else {
                    wrapper.classList.remove("form__field--filled");
                }
            });
        };
        StAccountAddressesExtended.prototype.normalizeCountry = function(country) {
            var valueCountry = (country || "").trim();
            if (!valueCountry) return "";
            var up = valueCountry.toUpperCase();
            if (up === "UNITED STATES" || up === "UNITED STATES OF AMERICA") return "USA";
            return valueCountry;
        };
        StAccountAddressesExtended.prototype.syncBillingViewOption = function(addr) {
            var sel = this.billingView.select;
            var id = String(addr.addressId);
            if (!sel) {
                this.paintBilling({
                    address1: addr.address1,
                    address2: addr.address2,
                    city: addr.city,
                    state: addr.state,
                    zip: addr.zip
                });
                return;
            }
            var opt = Array.from(sel.options).find(function(option) {
                return option.value === id;
            });
            if (!opt) {
                opt = sel.selectedOptions[0] || sel.options[0];
            }
            if (!opt) {
                opt = document.createElement("option");
                sel.appendChild(opt);
            }
            opt.value = id;
            opt.setAttribute("data-address1", addr.address1);
            opt.setAttribute("data-address2", addr.address2 || "");
            opt.setAttribute("data-city", addr.city);
            opt.setAttribute("data-state", this.normalizeState(addr.state));
            opt.setAttribute("data-zip", addr.zip);
            opt.setAttribute("data-county", addr.county || "");
            opt.setAttribute("data-country", addr.country || "");
            opt.textContent = [ [ addr.address1, addr.address2 ].filter(Boolean).join(" ").trim(), addr.city, this.normalizeState(addr.state), addr.zip ].filter(Boolean).join(", ");
            opt.selected = true;
            this.paintBillingFromOption(opt);
        };
        StAccountAddressesExtended.prototype.initUspsValidatedSubmitListener = function() {
            var _this = this;
            if (this.uspsSubmitListenerInitialized) {
                return;
            }
            this.uspsSubmitListenerInitialized = true;
            document.addEventListener("usps:validated-submit", function(event) {
                var _a;
                var customEvent = event;
                var form = customEvent.target;
                if (!(form instanceof HTMLFormElement)) {
                    return;
                }
                console.log("[Address save] USPS validation completed", {
                    formClass: form.className,
                    uspsFailed: !!((_a = customEvent.detail) === null || _a === void 0 ? void 0 : _a.uspsFailed)
                });
                if (form.matches(".st_billing-form_JS")) {
                    _this.refreshBillingReferences();
                    void _this.submitBilling();
                    return;
                }
                if (form.matches(".st_shipping-form_JS")) {
                    _this.refreshShippingReferences();
                    void _this.submitShipping();
                }
            });
        };
        StAccountAddressesExtended.prototype.waitForPostalLookup = function(scope, timeoutMs) {
            var _this = this;
            if (timeoutMs === void 0) {
                timeoutMs = 6e3;
            }
            return new Promise(function(resolve, reject) {
                var startedAt = Date.now();
                var check = function() {
                    var pending = scope === "shipping" ? _this.pendingShipLookup : _this.pendingBillLookup;
                    if (!pending) {
                        resolve();
                        return;
                    }
                    if (Date.now() - startedAt >= timeoutMs) {
                        reject(new Error("Address information could not be loaded from the ZIP code."));
                        return;
                    }
                    window.setTimeout(check, 50);
                };
                check();
            });
        };
        return StAccountAddressesExtended;
    }(addresses_1.StAccountAddresses);
    exports.StAccountAddressesExtended = StAccountAddressesExtended;
});

define("extension/shopify-app/st-modules/share-cart/share-cart-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_86) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShareCartClassConfig = void 0;
    var StShareCartClassConfig = function(_super) {
        __extends(StShareCartClassConfig, _super);
        function StShareCartClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StShareCartClassConfig";
            _this.classNameShareCartWrapper = "st-share-cart";
            _this.selectorShareCartWrapper = "." + _this.classNameShareCartWrapper;
            _this.classNameShareCartToggle = "st-share-cart__toggle_JS";
            _this.selectorShareCartToggle = "." + _this.classNameShareCartToggle;
            _this.classNameShareCartContent = "st-share-cart__content_JS";
            _this.selectorShareCartContent = "." + _this.classNameShareCartContent;
            _this.classNameShareCartForm = "st-share-cart__form_JS";
            _this.selectorShareCartForm = "." + _this.classNameShareCartForm;
            _this.classNameShareCartSuccess = "st-share-cart__success_JS";
            _this.selectorShareCartSuccess = "." + _this.classNameShareCartSuccess;
            _this.classNameShareCartInput = "st-share-cart__input_JS";
            _this.selectorShareCartInput = "." + _this.classNameShareCartInput;
            _this.classNameShareCartSwitchInput = "st-share-cart__switch-input_JS";
            _this.selectorShareCartSwitchInput = "." + _this.classNameShareCartSwitchInput;
            _this.classNameShareCartPartySwitchInput = "st-share-cart__party-switch-input_JS";
            _this.selectorShareCartPartySwitchInput = "." + _this.classNameShareCartPartySwitchInput;
            _this.classNameShareCartPartyField = "st-share-cart__party-field_JS";
            _this.selectorShareCartPartyField = "." + _this.classNameShareCartPartyField;
            _this.classNameShareCartPartyInput = "st-share-cart__party-input_JS";
            _this.selectorShareCartPartyInput = "." + _this.classNameShareCartPartyInput;
            _this.classNameShareCartGenerateLink = "st-share-cart__generate-link_JS";
            _this.selectorShareCartGenerateLink = "." + _this.classNameShareCartGenerateLink;
            _this.classNameShareCartCopyInput = "st-share-cart__copy-input_JS";
            _this.selectorShareCartCopyInput = "." + _this.classNameShareCartCopyInput;
            _this.classNameShareCartCopyButton = "st-share-cart__copy-button_JS";
            _this.selectorShareCartCopyButton = "." + _this.classNameShareCartCopyButton;
            _this.classNameShareCartReset = "st-share-cart__reset_JS";
            _this.selectorShareCartReset = "." + _this.classNameShareCartReset;
            _this.classNameShareCartViewAllLink = "st-share-cart__view-all-link";
            _this.selectorShareCartViewAllLink = "." + _this.classNameShareCartViewAllLink;
            _this.classNameShareCartOpenState = "is-open";
            _this.cartDrawer = function() {
                return document.querySelector("#cart-drawer") || document.querySelector(".wt-cart__wrapper");
            };
            _this.shareCartMainWrapper = function() {
                return document.querySelector(_this.selectorShareCartWrapper);
            };
            _this.shareCartWrappers = function() {
                return document.querySelectorAll(_this.selectorShareCartWrapper);
            };
            _this.shareCartToggle = function(wrapper) {
                return (wrapper || document).querySelector(_this.selectorShareCartToggle);
            };
            _this.shareCartContent = function(wrapper) {
                return (wrapper || document).querySelector(_this.selectorShareCartContent);
            };
            _this.shareCartForm = function(wrapper) {
                return (wrapper || document).querySelector(_this.selectorShareCartForm);
            };
            _this.shareCartSuccess = function(wrapper) {
                return (wrapper || document).querySelector(_this.selectorShareCartSuccess);
            };
            _this.shareCartNameInput = function(wrapper) {
                return (wrapper || document).querySelector(_this.selectorShareCartInput);
            };
            _this.shareCartSaveSwitch = function(wrapper) {
                return (wrapper || document).querySelector(_this.selectorShareCartSwitchInput);
            };
            _this.shareCartPartySwitch = function(wrapper) {
                return (wrapper || document).querySelector(_this.selectorShareCartPartySwitchInput);
            };
            _this.shareCartPartyField = function(wrapper) {
                return (wrapper || document).querySelector(_this.selectorShareCartPartyField);
            };
            _this.shareCartPartyInput = function(wrapper) {
                return (wrapper || document).querySelector(_this.selectorShareCartPartyInput);
            };
            _this.shareCartGenerateButton = function(wrapper) {
                return (wrapper || document).querySelector(_this.selectorShareCartGenerateLink);
            };
            _this.shareCartCopyInput = function(wrapper) {
                return (wrapper || document).querySelector(_this.selectorShareCartCopyInput);
            };
            _this.shareCartCopyButton = function(wrapper) {
                return (wrapper || document).querySelector(_this.selectorShareCartCopyButton);
            };
            _this.shareCartResetButton = function(wrapper) {
                return (wrapper || document).querySelector(_this.selectorShareCartReset);
            };
            _this.shareCartViewAllLink = function(wrapper) {
                return (wrapper || document).querySelector(_this.selectorShareCartViewAllLink);
            };
            return _this;
        }
        return StShareCartClassConfig;
    }(st_module_86.StModule);
    exports.StShareCartClassConfig = StShareCartClassConfig;
});

define("extension/shopify-app/st-modules/share-cart/share-cart-types", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.isShareCartCreateSuccessResponse = exports.isShareCartCreateResponse = void 0;
    var isShareCartCreateResponse = function(data) {
        if (!data || typeof data !== "object") {
            return false;
        }
        var response = data;
        return typeof response.statusCode === "number" && typeof response.message === "string";
    };
    exports.isShareCartCreateResponse = isShareCartCreateResponse;
    var isShareCartCreateSuccessResponse = function(data) {
        return (data.statusCode === 200 || data.statusCode === 201) && "data" in data && typeof data.data === "string";
    };
    exports.isShareCartCreateSuccessResponse = isShareCartCreateSuccessResponse;
});

define("extension/shopify-app/st-modules/share-cart/sharecart.feature.config", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.shareCartCartEditingEnabled = exports.shareCartShortLinkEnabled = exports.shareCartPromoCodeEnabled = exports.shareCartNameEnabled = exports.shareCartPartyEnabled = exports.shareCartDeleteEnabled = exports.shareCartEditEnabled = exports.shareCartCopyEnabled = exports.shareCartViewEnabled = exports.shareCartCreateEnabled = exports.shareCartStatisticsEnabled = exports.shareCartAccountDetailsPageEnabled = exports.shareCartAccountDashboardEnabled = exports.shareCartLandingEnabled = exports.shareCartDrawerEnabled = exports.shareCartEnabled = void 0;
    exports.shareCartEnabled = true;
    exports.shareCartDrawerEnabled = true;
    exports.shareCartLandingEnabled = true;
    exports.shareCartAccountDashboardEnabled = true;
    exports.shareCartAccountDetailsPageEnabled = true;
    exports.shareCartStatisticsEnabled = true;
    exports.shareCartCreateEnabled = true;
    exports.shareCartViewEnabled = true;
    exports.shareCartCopyEnabled = true;
    exports.shareCartEditEnabled = true;
    exports.shareCartDeleteEnabled = true;
    exports.shareCartPartyEnabled = true;
    exports.shareCartNameEnabled = true;
    exports.shareCartPromoCodeEnabled = true;
    exports.shareCartShortLinkEnabled = true;
    exports.shareCartCartEditingEnabled = true;
});

define("extension/shopify-app/st-modules/share-cart/share-cart-drawer", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification", "extension/shopify-app/st-modules/share-cart/share-cart-types", "_features.config", "extension/shopify-app/st-modules/share-cart/sharecart.feature.config" ], function(require, exports, st_module_87, notification_14, share_cart_types_1, _features_config_19, sharecart_feature_config_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShareCartDrawer = void 0;
    var StShareCartDrawer = function(_super) {
        __extends(StShareCartDrawer, _super);
        function StShareCartDrawer(classConfig, generalMethods, cartComponent, objectFormatting, notification) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StShareCartDrawer";
            _this.init = function() {
                if (!sharecart_feature_config_1.shareCartEnabled || !sharecart_feature_config_1.shareCartDrawerEnabled) {
                    return;
                }
                _this.subscribeDOMLoaded(function() {
                    _this.tryToSetupDrawer();
                    _this.cartComponent.subscribeChangeCart(function(cartObject) {
                        _this.tryToSetupDrawer();
                        var wrappers = _this.classConfig.shareCartWrappers();
                        wrappers.forEach(function(wrapper) {
                            var partyValidationStatus = wrapper.getAttribute("data-party-validation-status") || "idle";
                            _this.updateGenerateButtonState(wrapper, partyValidationStatus, cartObject);
                        });
                    });
                });
            };
            _this.tryToSetupDrawer = function() {
                if (!sharecart_feature_config_1.shareCartEnabled || !sharecart_feature_config_1.shareCartDrawerEnabled) {
                    return;
                }
                var shareCartWrapper = _this.classConfig.shareCartMainWrapper();
                if (!!shareCartWrapper) {
                    _this.setupConditionalRender();
                    _this.handleSaveSwitchPersistence();
                    if (sharecart_feature_config_1.shareCartPartyEnabled) {
                        _this.handlePartyToggle();
                    }
                    _this.handleClickOnShareCart();
                    _this.handleViewAllSharedCarts();
                } else {
                    var cartDrawer = _this.classConfig.cartDrawer();
                    if (!cartDrawer) {
                        return;
                    }
                    _this.onElementLoaded(cartDrawer, function() {
                        var newShareCartWrapper = _this.classConfig.shareCartMainWrapper();
                        if (!!newShareCartWrapper) {
                            _this.setupConditionalRender();
                            _this.handleSaveSwitchPersistence();
                            if (sharecart_feature_config_1.shareCartPartyEnabled) {
                                _this.handlePartyToggle();
                            }
                            _this.handleClickOnShareCart();
                            _this.handleViewAllSharedCarts();
                        }
                    }, {
                        childList: true,
                        subtree: true,
                        attributeOldValue: true,
                        attributes: true
                    });
                }
            };
            _this.onElementLoaded = function(elementToObserve, callback, options) {
                var MutationObserverRef = window.MutationObserver;
                if (!elementToObserve || elementToObserve.nodeType !== 1 || !MutationObserverRef) {
                    return;
                }
                var observer = new MutationObserverRef(callback);
                observer.observe(elementToObserve, options || {
                    childList: true,
                    attributeFilter: [ "innerHTML" ]
                });
                return observer;
            };
            _this.setupConditionalRender = function() {
                var wrappers = _this.classConfig.shareCartWrappers();
                if (!wrappers.length) {
                    return;
                }
                wrappers.forEach(function(wrapper) {
                    var shareCartToggle = _this.classConfig.shareCartToggle(wrapper);
                    var shareCartContent = _this.classConfig.shareCartContent(wrapper);
                    var shareCartResetButton = _this.classConfig.shareCartResetButton(wrapper);
                    if (shareCartToggle && shareCartContent) {
                        shareCartToggle.onclick = function(event) {
                            event.preventDefault();
                            var isExpanded = shareCartToggle.getAttribute("aria-expanded") === "true";
                            var nextExpandedState = !isExpanded;
                            shareCartToggle.setAttribute("aria-expanded", String(nextExpandedState));
                            shareCartContent.hidden = !nextExpandedState;
                            wrapper.classList.toggle(_this.classConfig.classNameShareCartOpenState, nextExpandedState);
                        };
                    }
                    if (shareCartResetButton) {
                        shareCartResetButton.onclick = function() {
                            _this.newShareCartState(wrapper);
                            if (shareCartToggle && shareCartContent) {
                                shareCartToggle.setAttribute("aria-expanded", "true");
                                shareCartContent.hidden = false;
                                wrapper.classList.add(_this.classConfig.classNameShareCartOpenState);
                            }
                        };
                    }
                    var partyValidationStatus = wrapper.getAttribute("data-party-validation-status") || "idle";
                    _this.cartComponent.getCart(function(cartObject) {
                        _this.updateGenerateButtonState(wrapper, partyValidationStatus, cartObject);
                    });
                });
            };
            _this.handleSaveSwitchPersistence = function() {
                var wrappers = _this.classConfig.shareCartWrappers();
                if (!wrappers.length) {
                    return;
                }
                wrappers.forEach(function(wrapper) {
                    var saveSwitch = _this.classConfig.shareCartSaveSwitch(wrapper);
                    if (!saveSwitch) {
                        return;
                    }
                    var persistedValue = localStorage.getItem("saveShareCart") === "true";
                    saveSwitch.checked = persistedValue;
                    saveSwitch.onchange = function() {
                        localStorage.setItem("saveShareCart", saveSwitch.checked ? "true" : "false");
                    };
                });
            };
            _this.handlePartyToggle = function() {
                if (!sharecart_feature_config_1.shareCartPartyEnabled) {
                    return;
                }
                var wrappers = _this.classConfig.shareCartWrappers();
                if (!wrappers.length) {
                    return;
                }
                wrappers.forEach(function(wrapper) {
                    var partySwitch = _this.classConfig.shareCartPartySwitch(wrapper);
                    var partyField = _this.classConfig.shareCartPartyField(wrapper);
                    var partyInput = _this.classConfig.shareCartPartyInput(wrapper);
                    if (!partySwitch || !partyField || !partyInput) {
                        return;
                    }
                    var togglePartyFieldVisibility = function() {
                        var isChecked = !!partySwitch.checked;
                        partyField.hidden = !isChecked;
                        if (!isChecked) {
                            partyInput.value = "";
                            wrapper.removeAttribute("data-party-validation-request-id");
                            _this.setPartyValidationState(wrapper, "idle");
                        } else if (!partyInput.value.trim()) {
                            _this.setPartyValidationState(wrapper, "idle");
                        }
                    };
                    togglePartyFieldVisibility();
                    partySwitch.onchange = togglePartyFieldVisibility;
                    if (partyInput.dataset.stPartyValidationBound === "true") {
                        return;
                    }
                    partyInput.dataset.stPartyValidationBound = "true";
                    var debounceTimer = null;
                    partyInput.addEventListener("input", function() {
                        var partyValue = partyInput.value.trim();
                        if (debounceTimer) {
                            clearTimeout(debounceTimer);
                        }
                        if (!partySwitch.checked) {
                            _this.setPartyValidationState(wrapper, "idle");
                            return;
                        }
                        if (!partyValue) {
                            _this.setPartyValidationState(wrapper, "idle");
                            return;
                        }
                        _this.setPartyValidationState(wrapper, "checking");
                        debounceTimer = setTimeout(function() {
                            var requestId = "".concat(Date.now(), "-").concat(partyValue);
                            wrapper.setAttribute("data-party-validation-request-id", requestId);
                            _this.validatePartyId(partyValue, function(partyDetails) {
                                var activeRequestId = wrapper.getAttribute("data-party-validation-request-id");
                                if (activeRequestId !== requestId) {
                                    return;
                                }
                                var isValid = (partyDetails === null || partyDetails === void 0 ? void 0 : partyDetails.isPartyOpen) === true;
                                _this.setPartyValidationState(wrapper, isValid ? "valid" : "invalid", isValid ? partyDetails : null);
                            });
                        }, 500);
                    });
                });
            };
            _this.handleClickOnShareCart = function() {
                var wrappers = _this.classConfig.shareCartWrappers();
                if (!wrappers.length) {
                    return;
                }
                wrappers.forEach(function(wrapper) {
                    var generateButton = _this.classConfig.shareCartGenerateButton(wrapper);
                    var copyButton = _this.classConfig.shareCartCopyButton(wrapper);
                    if (generateButton) {
                        generateButton.onclick = function() {
                            var partyValidationStatus = wrapper.getAttribute("data-party-validation-status");
                            var partySwitch = _this.classConfig.shareCartPartySwitch(wrapper);
                            _this.cartComponent.getCart(function(cartObj) {
                                var isCartEmpty = !(cartObj === null || cartObj === void 0 ? void 0 : cartObj.items) || cartObj.items.length === 0;
                                if (isCartEmpty) {
                                    _this.updateGenerateButtonState(wrapper, partyValidationStatus || "idle", cartObj);
                                    return;
                                }
                                if (sharecart_feature_config_1.shareCartPartyEnabled && (partySwitch === null || partySwitch === void 0 ? void 0 : partySwitch.checked) && (partyValidationStatus === "checking" || partyValidationStatus === "invalid")) {
                                    return;
                                }
                                _this.generateShareCartState(wrapper);
                                var createShareCartData = _this.assembleSCData(cartObj, wrapper);
                                _this.generateShareCartURL(createShareCartData, function(shareCartInfo) {
                                    var _a, _b, _c;
                                    if (shareCartInfo && "data" in shareCartInfo && typeof shareCartInfo.data === "string") {
                                        _this.successShareCartState(wrapper);
                                        _this.handleCopyToClipboard(shareCartInfo.data, createShareCartData.share_cart_attributes || {}, wrapper);
                                    } else {
                                        _this.failureShareCartState(wrapper);
                                        (_b = (_a = _this.notification) === null || _a === void 0 ? void 0 : _a.showNotification) === null || _b === void 0 ? void 0 : _b.call(_a, notification_14.ENotificationType.error, "Share Cart Error", (shareCartInfo === null || shareCartInfo === void 0 ? void 0 : shareCartInfo.message) || ((_c = window === null || window === void 0 ? void 0 : window.stTranslations) === null || _c === void 0 ? void 0 : _c.generateShareCartError) || "Unable to generate share cart.");
                                    }
                                });
                            });
                        };
                    }
                    if (copyButton) {
                        copyButton.onclick = function() {
                            return __awaiter(_this, void 0, void 0, function() {
                                var copyInput, error_6;
                                var _a, _b;
                                return __generator(this, function(_c) {
                                    switch (_c.label) {
                                      case 0:
                                        copyInput = this.classConfig.shareCartCopyInput(wrapper);
                                        if (!copyInput) {
                                            return [ 2 ];
                                        }
                                        _c.label = 1;

                                      case 1:
                                        _c.trys.push([ 1, 3, , 4 ]);
                                        return [ 4, navigator.clipboard.writeText(copyInput.value) ];

                                      case 2:
                                        _c.sent();
                                        copyInput.select();
                                        copyInput.setSelectionRange(0, 99999);
                                        (_b = (_a = this.notification) === null || _a === void 0 ? void 0 : _a.showNotification) === null || _b === void 0 ? void 0 : _b.call(_a, notification_14.ENotificationType.success, "Copied to clipboard");
                                        return [ 3, 4 ];

                                      case 3:
                                        error_6 = _c.sent();
                                        return [ 3, 4 ];

                                      case 4:
                                        return [ 2 ];
                                    }
                                });
                            });
                        };
                    }
                });
            };
            _this.handleViewAllSharedCarts = function() {
                var wrappers = _this.classConfig.shareCartWrappers();
                if (!wrappers.length) {
                    return;
                }
                wrappers.forEach(function(wrapper) {
                    var viewAllLink = wrapper.querySelector(".st-share-cart__view-all-link_JS");
                    if (!viewAllLink || viewAllLink.dataset.stViewAllBound === "true") {
                        return;
                    }
                    viewAllLink.dataset.stViewAllBound = "true";
                    viewAllLink.onclick = function(event) {
                        event.preventDefault();
                        var currentUrl = new URL(window.location.href);
                        var als = currentUrl.searchParams.get(_features_config_19.aliasQueryParam) || localStorage.getItem("webAlias") || "";
                        var redirectUrl = new URL("".concat(window.location.origin, "/account"));
                        redirectUrl.searchParams.set("tab", "4");
                        if (als) {
                            redirectUrl.searchParams.set(_features_config_19.aliasQueryParam, als);
                        }
                        window.location.href = redirectUrl.toString();
                    };
                });
            };
            _this.updateGenerateButtonState = function(wrapper, status, cartObject) {
                var generateButton = _this.classConfig.shareCartGenerateButton(wrapper);
                var partySwitch = _this.classConfig.shareCartPartySwitch(wrapper);
                if (!generateButton) {
                    return;
                }
                var cartItems = (cartObject === null || cartObject === void 0 ? void 0 : cartObject.items) || [];
                var isCartEmpty = cartItems.length === 0;
                var shouldDisable = isCartEmpty || !!sharecart_feature_config_1.shareCartPartyEnabled && !!(partySwitch === null || partySwitch === void 0 ? void 0 : partySwitch.checked) && (status === "checking" || status === "invalid");
                generateButton.disabled = shouldDisable;
                generateButton.setAttribute("aria-disabled", String(shouldDisable));
            };
            _this.setPartyValidationState = function(wrapper, status, partyDetails) {
                var _a, _b;
                if (partyDetails === void 0) {
                    partyDetails = null;
                }
                var feedback = wrapper.querySelector(".st-share-cart__party-feedback_JS");
                var successEl = wrapper.querySelector(".st-share-cart__party-feedback-success_JS");
                var errorEl = wrapper.querySelector(".st-share-cart__party-feedback-error_JS");
                var successText = wrapper.querySelector(".st-share-cart__party-feedback-text-success_JS");
                var errorText = wrapper.querySelector(".st-share-cart__party-feedback-text-error_JS");
                var partyInput = _this.classConfig.shareCartPartyInput(wrapper);
                var partyInputWrapper = partyInput === null || partyInput === void 0 ? void 0 : partyInput.closest(".st_label-primary");
                var loader = partyInputWrapper === null || partyInputWrapper === void 0 ? void 0 : partyInputWrapper.querySelector(".st_input-loader");
                var successMessage = (_a = window.stTranslations) === null || _a === void 0 ? void 0 : _a.shareCartPartySuccessText;
                var errorMessage = (_b = window.stTranslations) === null || _b === void 0 ? void 0 : _b.shareCartPartyErrorText;
                if (loader) {
                    loader.style.display = status === "checking" ? "inline-flex" : "none";
                }
                if (feedback) {
                    feedback.hidden = true;
                    feedback.style.display = "none";
                }
                if (successEl) {
                    successEl.hidden = true;
                    successEl.style.display = "none";
                }
                if (errorEl) {
                    errorEl.hidden = true;
                    errorEl.style.display = "none";
                }
                if (successText) {
                    successText.innerText = successMessage;
                }
                if (errorText) {
                    errorText.innerText = errorMessage;
                }
                if (status === "valid") {
                    if (feedback) {
                        feedback.hidden = false;
                        feedback.style.display = "block";
                    }
                    if (successEl) {
                        successEl.hidden = false;
                        successEl.style.display = "flex";
                    }
                }
                if (status === "invalid") {
                    if (feedback) {
                        feedback.hidden = false;
                        feedback.style.display = "block";
                    }
                    if (errorEl) {
                        errorEl.hidden = false;
                        errorEl.style.display = "block";
                    }
                }
                if (partyInput) {
                    partyInput.classList.remove("is-valid", "is-invalid");
                    if (status === "valid") {
                        partyInput.classList.add("is-valid");
                    }
                    if (status === "invalid") {
                        partyInput.classList.add("is-invalid");
                    }
                }
                _this.updatePartyInfo(wrapper, status === "valid" ? partyDetails : null);
                wrapper.setAttribute("data-party-validation-status", status);
                _this.cartComponent.getCart(function(cartObject) {
                    _this.updateGenerateButtonState(wrapper, status, cartObject);
                });
            };
            _this.updatePartyInfo = function(wrapper, partyDetails) {
                var _a, _b;
                var partyInfo = wrapper.querySelector(".st-share-cart__party-info_JS");
                var name = wrapper.querySelector(".st-share-cart__party-info-name_JS");
                var host = wrapper.querySelector(".st-share-cart__party-info-host_JS");
                var date = wrapper.querySelector(".st-share-cart__party-info-date_JS");
                if (!partyInfo) {
                    return;
                }
                partyInfo.hidden = !partyDetails;
                if (name) {
                    name.textContent = ((_a = partyDetails === null || partyDetails === void 0 ? void 0 : partyDetails.name) === null || _a === void 0 ? void 0 : _a.trim()) || "—";
                }
                if (host) {
                    host.textContent = ((_b = partyDetails === null || partyDetails === void 0 ? void 0 : partyDetails.host) === null || _b === void 0 ? void 0 : _b.trim()) || "—";
                }
                if (date) {
                    date.textContent = (partyDetails === null || partyDetails === void 0 ? void 0 : partyDetails.date) ? _this.formatPartyDate(partyDetails.date) : "—";
                }
            };
            _this.formatPartyDate = function(dateValue) {
                var value = dateValue.trim();
                if (!value) {
                    return "—";
                }
                var dateParts = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
                var partyDate = dateParts ? new Date(Date.UTC(Number(dateParts[1]), Number(dateParts[2]) - 1, Number(dateParts[3]))) : new Date(value);
                if (Number.isNaN(partyDate.getTime())) {
                    return value;
                }
                try {
                    var locale = document.documentElement.lang || "en-US";
                    var weekday = new Intl.DateTimeFormat(locale, {
                        weekday: "long",
                        timeZone: "UTC"
                    }).format(partyDate);
                    var formattedDate = new Intl.DateTimeFormat(locale, {
                        month: "short",
                        day: "numeric",
                        year: "numeric",
                        timeZone: "UTC"
                    }).format(partyDate);
                    return "".concat(weekday, " ").concat(formattedDate);
                } catch (error) {
                    return value;
                }
            };
            _this.validatePartyId = function(partyId, callback) {
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["party"]["party-validation"],
                        method: "POST",
                        contentType: "json",
                        data: {
                            partyId: partyId
                        },
                        callback: function(res) {
                            try {
                                var response = JSON.parse(res.response);
                                var partyDetails = response === null || response === void 0 ? void 0 : response.data;
                                callback(partyDetails && typeof partyDetails.isPartyOpen === "boolean" ? partyDetails : null);
                            } catch (error) {
                                callback(null);
                            }
                        }
                    });
                } catch (error) {
                    callback(null);
                }
            };
            _this.generateShareCartState = function(wrapper) {
                var form = _this.classConfig.shareCartForm(wrapper);
                var success = _this.classConfig.shareCartSuccess(wrapper);
                var loading = wrapper.querySelector(".st-share-cart__loading_JS");
                if (form) {
                    form.hidden = true;
                }
                if (success) {
                    success.hidden = true;
                }
                if (loading) {
                    loading.hidden = false;
                }
            };
            _this.successShareCartState = function(wrapper) {
                var form = _this.classConfig.shareCartForm(wrapper);
                var success = _this.classConfig.shareCartSuccess(wrapper);
                var loading = wrapper.querySelector(".st-share-cart__loading_JS");
                if (form) {
                    form.hidden = true;
                }
                if (success) {
                    success.hidden = false;
                }
                if (loading) {
                    loading.hidden = true;
                }
            };
            _this.failureShareCartState = function(wrapper) {
                var form = _this.classConfig.shareCartForm(wrapper);
                var success = _this.classConfig.shareCartSuccess(wrapper);
                var loading = wrapper.querySelector(".st-share-cart__loading_JS");
                if (form) {
                    form.hidden = false;
                }
                if (success) {
                    success.hidden = true;
                }
                if (loading) {
                    loading.hidden = true;
                }
            };
            _this.newShareCartState = function(wrapper) {
                var form = _this.classConfig.shareCartForm(wrapper);
                var success = _this.classConfig.shareCartSuccess(wrapper);
                var input = _this.classConfig.shareCartNameInput(wrapper);
                var saveSwitch = _this.classConfig.shareCartSaveSwitch(wrapper);
                var partySwitch = _this.classConfig.shareCartPartySwitch(wrapper);
                var partyField = _this.classConfig.shareCartPartyField(wrapper);
                var partyInput = _this.classConfig.shareCartPartyInput(wrapper);
                var copyInput = _this.classConfig.shareCartCopyInput(wrapper);
                var loading = wrapper.querySelector(".st-share-cart__loading_JS");
                if (form) {
                    form.hidden = false;
                }
                if (success) {
                    success.hidden = true;
                }
                if (loading) {
                    loading.hidden = true;
                }
                if (input) {
                    input.value = "";
                }
                if (saveSwitch) {
                    saveSwitch.checked = false;
                    localStorage.setItem("saveShareCart", "false");
                }
                if (partySwitch) {
                    partySwitch.checked = false;
                }
                if (partyField) {
                    partyField.hidden = true;
                }
                if (partyInput) {
                    partyInput.value = "";
                    partyInput.classList.remove("is-valid", "is-invalid");
                }
                if (copyInput) {
                    copyInput.value = "";
                }
                wrapper.removeAttribute("data-party-validation-request-id");
                _this.setPartyValidationState(wrapper, "idle");
            };
            _this.assembleSCData = function(cartObj, wrapper) {
                var _a, _b, _c, _d, _e, _f;
                var appWindow = window;
                var nameInput = _this.classConfig.shareCartNameInput(wrapper);
                var saveSwitch = _this.classConfig.shareCartSaveSwitch(wrapper);
                var partySwitch = _this.classConfig.shareCartPartySwitch(wrapper);
                var partyInput = _this.classConfig.shareCartPartyInput(wrapper);
                var isSaved = (saveSwitch === null || saveSwitch === void 0 ? void 0 : saveSwitch.checked) === true;
                var partyId = sharecart_feature_config_1.shareCartPartyEnabled && (partySwitch === null || partySwitch === void 0 ? void 0 : partySwitch.checked) ? ((_a = partyInput === null || partyInput === void 0 ? void 0 : partyInput.value) === null || _a === void 0 ? void 0 : _a.trim()) || "" : "";
                var firstName = ((_b = window.customerPublic) === null || _b === void 0 ? void 0 : _b.first_name) || "";
                var lastName = ((_c = window.customerPublic) === null || _c === void 0 ? void 0 : _c.last_name) || "";
                var createShareCartData = {
                    owner_shopify_id: appWindow.customerShopifyId || "",
                    owner_shopify_email: appWindow.customerShopifyEmail || "",
                    expiration_date: "9999-12-31",
                    share_cart_attributes: __assign(__assign({}, (cartObj === null || cartObj === void 0 ? void 0 : cartObj.attributes) || {}), sharecart_feature_config_1.shareCartPartyEnabled && partyId ? {
                        partyId: partyId
                    } : {}),
                    discount_codes: (cartObj === null || cartObj === void 0 ? void 0 : cartObj.discount_codes) || [],
                    line_items: [],
                    share_cart_miscfields: {},
                    name: sharecart_feature_config_1.shareCartNameEnabled ? ((_d = nameInput === null || nameInput === void 0 ? void 0 : nameInput.value) === null || _d === void 0 ? void 0 : _d.trim()) || "" : "",
                    is_saved: isSaved,
                    is_active: true,
                    party_id: sharecart_feature_config_1.shareCartPartyEnabled ? partyId : "",
                    customer_type: (_e = window.customerInfoMetafields) === null || _e === void 0 ? void 0 : _e.customerType,
                    first_name: firstName,
                    last_name: lastName
                };
                if (sharecart_feature_config_1.shareCartPartyEnabled && ((_f = cartObj === null || cartObj === void 0 ? void 0 : cartObj.attributes) === null || _f === void 0 ? void 0 : _f.partyId)) {
                    var pamperStorage = localStorage.getItem("pamper");
                    if (pamperStorage) {
                        try {
                            var pamperAttributes = JSON.parse(pamperStorage);
                            if (pamperAttributes === null || pamperAttributes === void 0 ? void 0 : pamperAttributes.partyName) {
                                createShareCartData.share_cart_miscfields = __assign(__assign({}, createShareCartData.share_cart_miscfields), {
                                    partyName: pamperAttributes.partyName
                                });
                            }
                        } catch (error) {
                            console.error("Share cart pamper storage failed. ".concat(error));
                        }
                    }
                }
                var lineItems = ((cartObj === null || cartObj === void 0 ? void 0 : cartObj.items) || []).map(function(item) {
                    var properties = __assign({}, item.properties || {});
                    delete properties._sharedCartToken;
                    return {
                        sku: item.sku,
                        shopify_variant_id: item.variant_id,
                        quantity: item.quantity,
                        line_item_properties: properties
                    };
                });
                createShareCartData.line_items = lineItems;
                return createShareCartData;
            };
            _this.handleCopyToClipboard = function(cartToken, shareCartAttributes, wrapper) {
                var shareCartCopyInput = _this.classConfig.shareCartCopyInput(wrapper);
                if (!shareCartCopyInput) {
                    return;
                }
                var sponsorWebAlias = (shareCartAttributes === null || shareCartAttributes === void 0 ? void 0 : shareCartAttributes.sponsorWebAlias) || (shareCartAttributes === null || shareCartAttributes === void 0 ? void 0 : shareCartAttributes.webAlias) || "";
                var shareCartLink = sponsorWebAlias ? "".concat(location.origin, "?").concat(_features_config_19.aliasQueryParam, "=").concat(sponsorWebAlias, "&share_cart_token=").concat(cartToken) : "".concat(location.origin, "?share_cart_token=").concat(cartToken);
                shareCartCopyInput.value = shareCartLink;
                shareCartCopyInput.setAttribute("value", shareCartLink);
            };
            _this.handleShortendURLClick = function() {};
            _this.generateShareCartURL = function(data, handleResponse) {
                var _a;
                var appWindow = window;
                var shareCartUrl = (_a = appWindow === null || appWindow === void 0 ? void 0 : appWindow.stAppConfig) === null || _a === void 0 ? void 0 : _a.shareCartUrl;
                var apiUrl = "".concat(shareCartUrl, "/share-cart/createShareCart");
                var requestOptions = {
                    method: "POST",
                    headers: {
                        "x-api-key": _this.shareCartApiKey,
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                };
                fetch(apiUrl, requestOptions).then(function(response) {
                    return __awaiter(_this, void 0, void 0, function() {
                        var data;
                        return __generator(this, function(_a) {
                            switch (_a.label) {
                              case 0:
                                if (!response.ok) {
                                    throw new Error("Network response was not ok");
                                }
                                return [ 4, response.json() ];

                              case 1:
                                data = _a.sent();
                                if (!(0, share_cart_types_1.isShareCartCreateResponse)(data)) {
                                    throw new Error("Invalid response format");
                                }
                                return [ 2, data ];
                            }
                        });
                    });
                }).then(function(responseData) {
                    var _a, _b;
                    if (responseData.statusCode !== 200 && responseData.statusCode !== 201) {
                        (_b = (_a = _this.notification) === null || _a === void 0 ? void 0 : _a.showNotification) === null || _b === void 0 ? void 0 : _b.call(_a, notification_14.ENotificationType.error, "Share Cart Error", responseData.message || "Unable to generate share cart.");
                    }
                    handleResponse(responseData);
                }).catch(function(error) {
                    var _a, _b, _c;
                    console.error(error);
                    (_b = (_a = _this.notification) === null || _a === void 0 ? void 0 : _a.showNotification) === null || _b === void 0 ? void 0 : _b.call(_a, notification_14.ENotificationType.error, "Share Cart Error", ((_c = appWindow === null || appWindow === void 0 ? void 0 : appWindow.stTranslations) === null || _c === void 0 ? void 0 : _c.generateShareCartError) || "Unable to generate share cart.");
                    handleResponse(null);
                });
            };
            _this.classConfig = classConfig;
            _this.generalMethods = generalMethods;
            _this.cartComponent = cartComponent;
            _this.objectFormatting = objectFormatting;
            _this.notification = notification;
            return _this;
        }
        Object.defineProperty(StShareCartDrawer.prototype, "shareCartApiKey", {
            get: function() {
                var shareCartKey = window.shareCartApiKey;
                return shareCartKey;
            },
            enumerable: false,
            configurable: true
        });
        return StShareCartDrawer;
    }(st_module_87.StModule);
    exports.StShareCartDrawer = StShareCartDrawer;
});

define("extension/shopify-app/st-modules/account/blocks/account-share-cart/account-share-cart-utils", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_88, _features_config_20) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountShareCartUtils = void 0;
    var StAccountShareCartUtils = function(_super) {
        __extends(StAccountShareCartUtils, _super);
        function StAccountShareCartUtils(generalMethods, objectFormatting) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StAccountShareCartUtils";
            _this.padNumbers = function(num) {
                return num < 10 ? "0".concat(num) : "".concat(num);
            };
            _this.formatShareCartDate = function(isoDate) {
                if (!isoDate) {
                    return "-";
                }
                var date = new Date(isoDate);
                if (Number.isNaN(date.getTime())) {
                    return "-";
                }
                var day = _this.padNumbers(date.getUTCDate());
                var month = _this.padNumbers(date.getUTCMonth() + 1);
                var year = date.getUTCFullYear();
                return "".concat(month, "/").concat(day, "/").concat(year);
            };
            _this.escapeHtml = function(value) {
                var stringValue = "".concat(value !== null && value !== void 0 ? value : "");
                return stringValue.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
            };
            _this.getWrapper = function() {
                return document.querySelector(".st-account-share-cart_JS");
            };
            _this.getListWrapper = function() {
                return document.querySelector(".st-account-share-cart__list_JS");
            };
            _this.getShareCartId = function(targetButton) {
                var shareCartCard = _this.generalMethods.getClosestByClass(targetButton, "st-account-share-cart-card_JS");
                return (shareCartCard === null || shareCartCard === void 0 ? void 0 : shareCartCard.getAttribute("data-share-cart-id")) || "";
            };
            _this.getShareCartTitle = function(shareCart) {
                var name = shareCart === null || shareCart === void 0 ? void 0 : shareCart.name;
                if (typeof name === "string" && name.trim() !== "") {
                    return name.trim();
                }
                var cartId = (shareCart === null || shareCart === void 0 ? void 0 : shareCart.cartId) || (shareCart === null || shareCart === void 0 ? void 0 : shareCart.id) || "";
                return cartId ? "Cart ".concat(cartId) : "Shared Cart";
            };
            _this.getPartyName = function(shareCart) {
                var shareCartAttributes = (shareCart === null || shareCart === void 0 ? void 0 : shareCart.share_cart_attributes) || {};
                var shareCartMiscFields = (shareCart === null || shareCart === void 0 ? void 0 : shareCart.share_cart_miscfields) || {};
                return shareCartMiscFields.partyName || shareCartAttributes.partyName || shareCartAttributes.party_id || shareCartAttributes.partyId || (shareCart === null || shareCart === void 0 ? void 0 : shareCart.party_id) || "-";
            };
            _this.getLinkUsedCount = function(shareCart) {
                var _a, _b, _c;
                return Number((_c = (_b = (_a = shareCart === null || shareCart === void 0 ? void 0 : shareCart.impressions) !== null && _a !== void 0 ? _a : shareCart === null || shareCart === void 0 ? void 0 : shareCart.link_used) !== null && _b !== void 0 ? _b : shareCart === null || shareCart === void 0 ? void 0 : shareCart.linkUsed) !== null && _c !== void 0 ? _c : 0);
            };
            _this.getOrdersCount = function(shareCart) {
                var _a, _b, _c;
                return Number((_c = (_b = (_a = shareCart === null || shareCart === void 0 ? void 0 : shareCart.completed_purchases) !== null && _a !== void 0 ? _a : shareCart === null || shareCart === void 0 ? void 0 : shareCart.orders_count) !== null && _b !== void 0 ? _b : shareCart === null || shareCart === void 0 ? void 0 : shareCart.number_of_orders) !== null && _c !== void 0 ? _c : 0);
            };
            _this.shareCartLink = function(cartToken, shareCartAttributes) {
                if (shareCartAttributes === void 0) {
                    shareCartAttributes = {};
                }
                if (!cartToken) {
                    return "";
                }
                var sponsorWebAlias = (shareCartAttributes === null || shareCartAttributes === void 0 ? void 0 : shareCartAttributes.sponsorWebAlias) || (shareCartAttributes === null || shareCartAttributes === void 0 ? void 0 : shareCartAttributes.webAlias) || "";
                return sponsorWebAlias ? "".concat(location.origin, "?").concat(_features_config_20.aliasQueryParam, "=").concat(sponsorWebAlias, "&share_cart_token=").concat(cartToken) : "".concat(location.origin, "?share_cart_token=").concat(cartToken);
            };
            _this.getTranslation = function(key, fallback) {
                var _a;
                if (fallback === void 0) {
                    fallback = "";
                }
                return ((_a = window === null || window === void 0 ? void 0 : window.stTranslations) === null || _a === void 0 ? void 0 : _a[key]) || fallback;
            };
            _this.copyShareCartLink = function(copyButton) {
                return __awaiter(_this, void 0, void 0, function() {
                    var shareCartUrl, error_7;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            shareCartUrl = copyButton.getAttribute("data-share-cart-url") || "";
                            if (!shareCartUrl) {
                                return [ 2 ];
                            }
                            _a.label = 1;

                          case 1:
                            _a.trys.push([ 1, 3, , 4 ]);
                            return [ 4, navigator.clipboard.writeText(shareCartUrl) ];

                          case 2:
                            _a.sent();
                            copyButton.setAttribute("disabled", "disabled");
                            setTimeout(function() {
                                copyButton.removeAttribute("disabled");
                            }, 1200);
                            return [ 3, 4 ];

                          case 3:
                            error_7 = _a.sent();
                            console.error(error_7);
                            return [ 3, 4 ];

                          case 4:
                            return [ 2 ];
                        }
                    });
                });
            };
            _this.toggleMenu = function(menuTrigger) {
                var menuWrapper = _this.generalMethods.getClosestByClass(menuTrigger, "st-account-share-cart-card__menu_JS");
                if (!menuWrapper) {
                    return;
                }
                var isOpen = menuWrapper.classList.contains("is-open");
                _this.closeAllMenus();
                menuWrapper.classList.toggle("is-open", !isOpen);
                menuTrigger.setAttribute("aria-expanded", (!isOpen).toString());
            };
            _this.closeAllMenus = function() {
                var menus = document.querySelectorAll(".st-account-share-cart-card__menu_JS");
                menus.forEach(function(menu) {
                    menu.classList.remove("is-open");
                    var trigger = menu.querySelector(".st-account-share-cart-card__menu-trigger_JS");
                    if (trigger) {
                        trigger.setAttribute("aria-expanded", "false");
                    }
                });
            };
            _this.normalizeLineItems = function(shareCartDetail) {
                var _a, _b;
                if (Array.isArray(shareCartDetail === null || shareCartDetail === void 0 ? void 0 : shareCartDetail.line_items)) {
                    return shareCartDetail.line_items;
                }
                if (Array.isArray(shareCartDetail === null || shareCartDetail === void 0 ? void 0 : shareCartDetail.items)) {
                    return shareCartDetail.items;
                }
                if (Array.isArray((_a = shareCartDetail === null || shareCartDetail === void 0 ? void 0 : shareCartDetail.cart) === null || _a === void 0 ? void 0 : _a.items)) {
                    return shareCartDetail.cart.items;
                }
                if (Array.isArray((_b = shareCartDetail === null || shareCartDetail === void 0 ? void 0 : shareCartDetail.cart) === null || _b === void 0 ? void 0 : _b.line_items)) {
                    return shareCartDetail.cart.line_items;
                }
                return [];
            };
            _this.getLineItemTitle = function(lineItem) {
                return (lineItem === null || lineItem === void 0 ? void 0 : lineItem.title) || (lineItem === null || lineItem === void 0 ? void 0 : lineItem.product_title) || (lineItem === null || lineItem === void 0 ? void 0 : lineItem.variant_title) || (lineItem === null || lineItem === void 0 ? void 0 : lineItem.name) || "Product";
            };
            _this.getLineItemImage = function(lineItem) {
                var _a, _b;
                return (lineItem === null || lineItem === void 0 ? void 0 : lineItem.thumbnail) || (lineItem === null || lineItem === void 0 ? void 0 : lineItem.image) || ((_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.variant) === null || _a === void 0 ? void 0 : _a.image) || ((_b = lineItem === null || lineItem === void 0 ? void 0 : lineItem.product) === null || _b === void 0 ? void 0 : _b.thumbnail) || "";
            };
            _this.getLineItemQty = function(lineItem) {
                var _a, _b;
                return Number((_b = (_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.quantity) !== null && _a !== void 0 ? _a : lineItem === null || lineItem === void 0 ? void 0 : lineItem.qty) !== null && _b !== void 0 ? _b : 0);
            };
            _this.getLineItemUnitPrice = function(lineItem) {
                var _a, _b, _c, _d;
                return Number((_d = (_b = (_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.unit_price) !== null && _a !== void 0 ? _a : lineItem === null || lineItem === void 0 ? void 0 : lineItem.price) !== null && _b !== void 0 ? _b : (_c = lineItem === null || lineItem === void 0 ? void 0 : lineItem.variant) === null || _c === void 0 ? void 0 : _c.price) !== null && _d !== void 0 ? _d : 0);
            };
            _this.getLineItemTotal = function(lineItem) {
                var _a, _b;
                return Number((_b = (_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.line_total) !== null && _a !== void 0 ? _a : lineItem === null || lineItem === void 0 ? void 0 : lineItem.total) !== null && _b !== void 0 ? _b : _this.getLineItemUnitPrice(lineItem) * _this.getLineItemQty(lineItem));
            };
            _this.getShareCartTotal = function(shareCartDetail) {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                var directTotal = Number((_h = (_f = (_d = (_c = (_b = (_a = shareCartDetail === null || shareCartDetail === void 0 ? void 0 : shareCartDetail.total) !== null && _a !== void 0 ? _a : shareCartDetail === null || shareCartDetail === void 0 ? void 0 : shareCartDetail.cart_total) !== null && _b !== void 0 ? _b : shareCartDetail === null || shareCartDetail === void 0 ? void 0 : shareCartDetail.grand_total) !== null && _c !== void 0 ? _c : shareCartDetail === null || shareCartDetail === void 0 ? void 0 : shareCartDetail.total_price) !== null && _d !== void 0 ? _d : (_e = shareCartDetail === null || shareCartDetail === void 0 ? void 0 : shareCartDetail.cart) === null || _e === void 0 ? void 0 : _e.total) !== null && _f !== void 0 ? _f : (_g = shareCartDetail === null || shareCartDetail === void 0 ? void 0 : shareCartDetail.cart) === null || _g === void 0 ? void 0 : _g.total_price) !== null && _h !== void 0 ? _h : 0);
                if (directTotal) {
                    return directTotal;
                }
                return _this.normalizeLineItems(shareCartDetail).reduce(function(sum, lineItem) {
                    return sum + _this.getLineItemTotal(lineItem);
                }, 0);
            };
            _this.formatMoney = function(value) {
                var _a, _b;
                if (typeof value === "string" && /[£$€]/.test(value)) {
                    return value;
                }
                var numericValue = Number(value !== null && value !== void 0 ? value : 0);
                var currencyCode = ((_b = (_a = window === null || window === void 0 ? void 0 : window.Shopify) === null || _a === void 0 ? void 0 : _a.currency) === null || _b === void 0 ? void 0 : _b.active) || "GBP";
                return new Intl.NumberFormat(undefined, {
                    style: "currency",
                    currency: currencyCode,
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }).format(Number.isNaN(numericValue) ? 0 : numericValue);
            };
            _this.generalMethods = generalMethods;
            _this.objectFormatting = objectFormatting;
            return _this;
        }
        return StAccountShareCartUtils;
    }(st_module_88.StModule);
    exports.StAccountShareCartUtils = StAccountShareCartUtils;
});

define("extension/shopify-app/st-modules/account/blocks/account-share-cart/account-share-cart", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "extension/shopify-app/st-modules/share-cart/sharecart.feature.config" ], function(require, exports, st_module_89, sharecart_feature_config_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountShareCart = void 0;
    var StAccountShareCart = function(_super) {
        __extends(StAccountShareCart, _super);
        function StAccountShareCart(objectFormatting, generalMethods, cartComponent, accountShareCartUtils) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StAccountShareCart";
            _this.currentPage = 1;
            _this.itemsPerPage = 5;
            _this.backendItemsPerPage = 25;
            _this.paginationBound = false;
            _this.hasNextPage = false;
            _this.lastLoadedCount = 0;
            _this.editNameModalBound = false;
            _this.activeEditShareCartId = "";
            _this.isSubmittingEditName = false;
            _this.deleteModalBound = false;
            _this.activeDeleteShareCartId = "";
            _this.isSubmittingDeleteShareCart = false;
            _this.shareCartDetailsCache = {};
            _this.init = function() {
                if (!sharecart_feature_config_2.shareCartEnabled || !sharecart_feature_config_2.shareCartAccountDashboardEnabled) {
                    return;
                }
                _this.subscribeDOMLoaded(function() {
                    var wrapper = _this.accountShareCartUtils.getWrapper();
                    var listWrapper = _this.accountShareCartUtils.getListWrapper();
                    if (!wrapper || !listWrapper) {
                        return;
                    }
                    _this.ensureSingleShareCartExists();
                    _this.ensureEditNameModalExists();
                    _this.ensureDeleteModalExists();
                    _this.fetchAndRenderShareCarts(1);
                    _this.bindPaginationHandlers();
                    _this.bindCreateNewCartButton();
                    _this.bindOutsideClick();
                    _this.bindSingleShareCartOutsideClick();
                    _this.handleMenuCloseClick();
                    _this.backToHistoryShareCarts();
                    _this.bindEditNameModalEvents();
                    _this.bindDeleteModalEvents();
                });
            };
            _this.ensureSingleShareCartExists = function() {
                var _a;
                var wrapper = _this.accountShareCartUtils.getWrapper();
                if (!wrapper) {
                    return;
                }
                var existingSingle = wrapper.querySelector(".st-account-single-share-cart_JS");
                if (existingSingle) {
                    return;
                }
                var template = document.getElementById("st-account-single-share-cart-template");
                if (!template) {
                    return;
                }
                var fragment = ((_a = template.content) !== null && _a !== void 0 ? _a : template).cloneNode(true);
                wrapper.appendChild(fragment);
            };
            _this.ensureEditNameModalExists = function() {
                var _a;
                var wrapper = _this.accountShareCartUtils.getWrapper();
                if (!wrapper) {
                    return;
                }
                var existingModal = wrapper.querySelector(".st-account-share-cart-edit-modal_JS");
                if (existingModal) {
                    return;
                }
                var template = document.getElementById("st-account-share-cart-edit-name-modal-template");
                if (!template) {
                    return;
                }
                var fragment = ((_a = template.content) !== null && _a !== void 0 ? _a : template).cloneNode(true);
                wrapper.appendChild(fragment);
            };
            _this.ensureDeleteModalExists = function() {
                var _a;
                var wrapper = _this.accountShareCartUtils.getWrapper();
                if (!wrapper) {
                    return;
                }
                var existingModal = wrapper.querySelector(".st-account-share-cart-delete-modal_JS");
                if (existingModal) {
                    return;
                }
                var template = document.getElementById("st-account-share-cart-delete-modal-template");
                if (!template) {
                    return;
                }
                var fragment = ((_a = template.content) !== null && _a !== void 0 ? _a : template).cloneNode(true);
                wrapper.appendChild(fragment);
            };
            _this.fetchAndRenderShareCarts = function(page) {
                if (page === void 0) {
                    page = _this.currentPage;
                }
                return __awaiter(_this, void 0, void 0, function() {
                    var listWrapper, responseData, allShareCarts, savedShareCarts, start, end, shareCarts, error_8;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            listWrapper = this.accountShareCartUtils.getListWrapper();
                            if (!listWrapper) {
                                return [ 2 ];
                            }
                            _a.label = 1;

                          case 1:
                            _a.trys.push([ 1, 6, , 7 ]);
                            listWrapper.innerHTML = this.generateLoadingState();
                            return [ 4, this.fetchShareCarts() ];

                          case 2:
                            responseData = _a.sent();
                            allShareCarts = this.normalizeShareCartsResponse(responseData);
                            savedShareCarts = allShareCarts.filter(function(shareCart) {
                                return (shareCart === null || shareCart === void 0 ? void 0 : shareCart.is_saved) === true;
                            });
                            this.currentPage = Math.max(1, page);
                            start = (this.currentPage - 1) * this.itemsPerPage;
                            end = start + this.itemsPerPage;
                            shareCarts = savedShareCarts.slice(start, end);
                            this.lastLoadedCount = shareCarts.length;
                            this.hasNextPage = end < savedShareCarts.length;
                            if (!(!shareCarts.length && this.currentPage > 1)) return [ 3, 4 ];
                            return [ 4, this.fetchAndRenderShareCarts(this.currentPage - 1) ];

                          case 3:
                            _a.sent();
                            return [ 2 ];

                          case 4:
                            if (!shareCarts.length) {
                                listWrapper.innerHTML = this.generateEmptyState();
                                this.renderPagination();
                                return [ 2 ];
                            }
                            return [ 4, this.renderShareCartCards(shareCarts) ];

                          case 5:
                            _a.sent();
                            this.renderPagination();
                            return [ 3, 7 ];

                          case 6:
                            error_8 = _a.sent();
                            console.error("[StAccountShareCart] fetch share carts error:", error_8);
                            listWrapper.innerHTML = this.generateErrorState();
                            this.renderPagination();
                            return [ 3, 7 ];

                          case 7:
                            return [ 2 ];
                        }
                    });
                });
            };
            _this.fetchShareCarts = function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var appWindow, shareCartUrl, shopifyCustomerId, apiUrl, response;
                    var _a;
                    return __generator(this, function(_b) {
                        switch (_b.label) {
                          case 0:
                            appWindow = window;
                            shareCartUrl = ((_a = appWindow === null || appWindow === void 0 ? void 0 : appWindow.stAppConfig) === null || _a === void 0 ? void 0 : _a.shareCartUrl) || "";
                            shopifyCustomerId = (appWindow === null || appWindow === void 0 ? void 0 : appWindow.customerShopifyId) || "";
                            if (!shareCartUrl || !shopifyCustomerId) {
                                return [ 2, [] ];
                            }
                            apiUrl = "".concat(shareCartUrl, "/share-cart/getAllShareCarts/").concat(shopifyCustomerId, "?page=1&itemsPerPage=").concat(this.backendItemsPerPage);
                            return [ 4, fetch(apiUrl, {
                                method: "GET",
                                headers: {
                                    "x-api-key": this.shareCartApiKey || "",
                                    "Content-Type": "application/json"
                                }
                            }) ];

                          case 1:
                            response = _b.sent();
                            if (!response.ok) {
                                throw new Error("Failed to fetch share carts. Status: ".concat(response.status));
                            }
                            return [ 2, response.json() ];
                        }
                    });
                });
            };
            _this.fetchShareCartById = function(shareCartId) {
                return __awaiter(_this, void 0, void 0, function() {
                    var appWindow, shareCartUrl, shopifyCustomerId, apiUrl, response;
                    var _a;
                    return __generator(this, function(_b) {
                        switch (_b.label) {
                          case 0:
                            appWindow = window;
                            shareCartUrl = ((_a = appWindow === null || appWindow === void 0 ? void 0 : appWindow.stAppConfig) === null || _a === void 0 ? void 0 : _a.shareCartUrl) || "";
                            shopifyCustomerId = (appWindow === null || appWindow === void 0 ? void 0 : appWindow.customerShopifyId) || "";
                            if (!shareCartUrl || !shareCartId) {
                                return [ 2, {} ];
                            }
                            apiUrl = "".concat(shareCartUrl, "/share-cart/getShareCartById/").concat(shareCartId, "?shopifyCustomerId=").concat(shopifyCustomerId);
                            return [ 4, fetch(apiUrl, {
                                method: "GET",
                                headers: {
                                    "x-api-key": this.shareCartApiKey || "",
                                    "Content-Type": "application/json"
                                }
                            }) ];

                          case 1:
                            response = _b.sent();
                            if (!response.ok) {
                                throw new Error("Failed to fetch share cart detail. Status: ".concat(response.status));
                            }
                            return [ 2, response.json() ];
                        }
                    });
                });
            };
            _this.updateShareCartName = function(shareCartId, shareCart, nextName) {
                return __awaiter(_this, void 0, void 0, function() {
                    var appWindow, shareCartUrl, shopifyCustomerId, body, apiUrl, response, responseData;
                    var _a;
                    return __generator(this, function(_b) {
                        switch (_b.label) {
                          case 0:
                            appWindow = window;
                            shareCartUrl = ((_a = appWindow === null || appWindow === void 0 ? void 0 : appWindow.stAppConfig) === null || _a === void 0 ? void 0 : _a.shareCartUrl) || "";
                            shopifyCustomerId = (appWindow === null || appWindow === void 0 ? void 0 : appWindow.customerShopifyId) || "";
                            if (!shareCartUrl || !shopifyCustomerId || !shareCartId) {
                                throw new Error("Missing share cart configuration.");
                            }
                            body = {
                                optional: {
                                    name: nextName
                                }
                            };
                            apiUrl = "".concat(shareCartUrl, "/share-cart/updateShareCart/").concat(shareCartId, "/").concat(shopifyCustomerId);
                            return [ 4, fetch(apiUrl, {
                                method: "PATCH",
                                headers: {
                                    "x-api-key": this.shareCartApiKey || "",
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify(body)
                            }) ];

                          case 1:
                            response = _b.sent();
                            return [ 4, response.json() ];

                          case 2:
                            responseData = _b.sent();
                            if (!response.ok) {
                                throw new Error((responseData === null || responseData === void 0 ? void 0 : responseData.message) || "Failed to update share cart. Status: ".concat(response.status));
                            }
                            if (Number(responseData === null || responseData === void 0 ? void 0 : responseData.statusCode) >= 400) {
                                throw new Error((responseData === null || responseData === void 0 ? void 0 : responseData.message) || "Failed to update share cart.");
                            }
                            return [ 2, responseData ];
                        }
                    });
                });
            };
            _this.deleteShareCart = function(shareCartId) {
                return __awaiter(_this, void 0, void 0, function() {
                    var appWindow, shareCartUrl, shopifyCustomerId, apiUrl, response, responseData;
                    var _a;
                    return __generator(this, function(_b) {
                        switch (_b.label) {
                          case 0:
                            appWindow = window;
                            shareCartUrl = ((_a = appWindow === null || appWindow === void 0 ? void 0 : appWindow.stAppConfig) === null || _a === void 0 ? void 0 : _a.shareCartUrl) || "";
                            shopifyCustomerId = (appWindow === null || appWindow === void 0 ? void 0 : appWindow.customerShopifyId) || "";
                            if (!shareCartUrl || !shopifyCustomerId || !shareCartId) {
                                throw new Error("Missing share cart configuration.");
                            }
                            apiUrl = "".concat(shareCartUrl, "/share-cart/deleteShareCart/").concat(shareCartId, "?shopifyCustomerId=").concat(shopifyCustomerId);
                            return [ 4, fetch(apiUrl, {
                                method: "DELETE",
                                headers: {
                                    "x-api-key": this.shareCartApiKey || ""
                                }
                            }) ];

                          case 1:
                            response = _b.sent();
                            return [ 4, response.json() ];

                          case 2:
                            responseData = _b.sent();
                            if (!response.ok) {
                                throw new Error((responseData === null || responseData === void 0 ? void 0 : responseData.message) || "Failed to delete share cart. Status: ".concat(response.status));
                            }
                            if (Number(responseData === null || responseData === void 0 ? void 0 : responseData.statusCode) >= 400) {
                                throw new Error((responseData === null || responseData === void 0 ? void 0 : responseData.message) || "Failed to delete share cart.");
                            }
                            return [ 2, responseData ];
                        }
                    });
                });
            };
            _this.normalizeShareCartsResponse = function(responseData) {
                if (Array.isArray(responseData)) {
                    return responseData;
                }
                if (Array.isArray(responseData === null || responseData === void 0 ? void 0 : responseData.orderList)) {
                    return responseData.orderList;
                }
                if (Array.isArray(responseData === null || responseData === void 0 ? void 0 : responseData.shareCarts)) {
                    return responseData.shareCarts;
                }
                if (Array.isArray(responseData === null || responseData === void 0 ? void 0 : responseData.carts)) {
                    return responseData.carts;
                }
                if (Array.isArray(responseData === null || responseData === void 0 ? void 0 : responseData.items)) {
                    return responseData.items;
                }
                if (Array.isArray(responseData === null || responseData === void 0 ? void 0 : responseData.data)) {
                    return responseData.data;
                }
                if ((responseData === null || responseData === void 0 ? void 0 : responseData.data) && !Array.isArray(responseData.data)) {
                    if (Array.isArray(responseData.data.data)) {
                        return responseData.data.data;
                    }
                    if (Array.isArray(responseData.data.items)) {
                        return responseData.data.items;
                    }
                }
                return [];
            };
            _this.normalizePaginationResponse = function(responseData) {
                var _a;
                if (!responseData || Array.isArray(responseData)) {
                    return {};
                }
                if (responseData === null || responseData === void 0 ? void 0 : responseData.pagination) {
                    return responseData.pagination;
                }
                if ((responseData === null || responseData === void 0 ? void 0 : responseData.data) && !Array.isArray(responseData.data) && ((_a = responseData.data) === null || _a === void 0 ? void 0 : _a.pagination)) {
                    return responseData.data.pagination;
                }
                return {};
            };
            _this.normalizeSingleShareCartResponse = function(responseData) {
                if (!responseData) {
                    return {};
                }
                if (responseData === null || responseData === void 0 ? void 0 : responseData.shareCart) {
                    return responseData.shareCart;
                }
                if (responseData === null || responseData === void 0 ? void 0 : responseData.cart) {
                    return responseData.cart;
                }
                if (responseData === null || responseData === void 0 ? void 0 : responseData.item) {
                    return responseData.item;
                }
                if (responseData === null || responseData === void 0 ? void 0 : responseData.data) {
                    return responseData.data;
                }
                return responseData;
            };
            _this.generateLoadingState = function() {
                return '\n            <div class="st-account-share-cart__message st-account-share-cart__message--loading">\n                '.concat(_this.accountShareCartUtils.escapeHtml(_this.accountShareCartUtils.getTranslation("loadingText", "Loading...")), "\n            </div>\n        ");
            };
            _this.generateEmptyState = function() {
                return '\n            <div class="st-account-share-cart__message st-account-share-cart__message--empty">\n                '.concat(_this.accountShareCartUtils.escapeHtml(_this.accountShareCartUtils.getTranslation("noSharedCartsText", "No shared carts found.")), "\n            </div>\n        ");
            };
            _this.generateErrorState = function() {
                return '\n            <div class="st-account-share-cart__message st-account-share-cart__message--error">\n                '.concat(_this.accountShareCartUtils.escapeHtml(_this.accountShareCartUtils.getTranslation("shareCartViewError", "Something went wrong while loading shared carts.")), "\n            </div>\n        ");
            };
            _this.renderShareCartCards = function(shareCarts) {
                return __awaiter(_this, void 0, void 0, function() {
                    var listWrapper, cards;
                    var _this = this;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            listWrapper = this.accountShareCartUtils.getListWrapper();
                            if (!listWrapper) {
                                return [ 2 ];
                            }
                            listWrapper.innerHTML = "";
                            return [ 4, Promise.all(shareCarts.map(function(shareCart) {
                                return _this.createShareCartCardElement(shareCart);
                            })) ];

                          case 1:
                            cards = _a.sent();
                            cards.forEach(function(card) {
                                if (card) {
                                    listWrapper.appendChild(card);
                                }
                            });
                            this.bindCardEvents();
                            return [ 2 ];
                        }
                    });
                });
            };
            _this.resolveShareCartCardSubtotal = function(shareCart) {
                return __awaiter(_this, void 0, void 0, function() {
                    var cartId, subtotalFromList, response, shareCartDetail;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            cartId = (shareCart === null || shareCart === void 0 ? void 0 : shareCart.shareCartId) || (shareCart === null || shareCart === void 0 ? void 0 : shareCart.cartId) || (shareCart === null || shareCart === void 0 ? void 0 : shareCart._id) || (shareCart === null || shareCart === void 0 ? void 0 : shareCart.id) || "";
                            subtotalFromList = this.getShareCartTotal(shareCart);
                            if (subtotalFromList > 0) {
                                return [ 2, subtotalFromList ];
                            }
                            if (!cartId) {
                                return [ 2, 0 ];
                            }
                            if (this.shareCartDetailsCache[String(cartId)]) {
                                return [ 2, this.getShareCartTotal(this.shareCartDetailsCache[String(cartId)]) ];
                            }
                            return [ 4, this.fetchShareCartById(String(cartId)) ];

                          case 1:
                            response = _a.sent();
                            shareCartDetail = this.normalizeSingleShareCartResponse(response);
                            this.shareCartDetailsCache[String(cartId)] = shareCartDetail;
                            return [ 2, this.getShareCartTotal(shareCartDetail) ];
                        }
                    });
                });
            };
            _this.createShareCartCardElement = function(shareCart) {
                return __awaiter(_this, void 0, void 0, function() {
                    var template, fragment, card, cartId, title, date, partyName, linkUsed, ordersCount, subtotal, publicLink, titleEl, dateEl, linkUsedEl, ordersEl, partyNameEl, subtotalEl, linkEl, copyBtn, viewBtn, editBtn, deleteBtn;
                    var _a;
                    return __generator(this, function(_b) {
                        switch (_b.label) {
                          case 0:
                            template = document.getElementById("st-account-share-cart-card-template");
                            if (!template) {
                                return [ 2, null ];
                            }
                            fragment = ((_a = template.content) !== null && _a !== void 0 ? _a : template).cloneNode(true);
                            card = fragment.querySelector(".st-account-share-cart-card_JS");
                            if (!card) {
                                return [ 2, null ];
                            }
                            cartId = (shareCart === null || shareCart === void 0 ? void 0 : shareCart.shareCartId) || (shareCart === null || shareCart === void 0 ? void 0 : shareCart.cartId) || (shareCart === null || shareCart === void 0 ? void 0 : shareCart._id) || (shareCart === null || shareCart === void 0 ? void 0 : shareCart.id) || "";
                            title = this.accountShareCartUtils.getShareCartTitle(shareCart);
                            date = this.accountShareCartUtils.formatShareCartDate(shareCart === null || shareCart === void 0 ? void 0 : shareCart.created_at);
                            partyName = this.accountShareCartUtils.getPartyName(shareCart);
                            linkUsed = this.accountShareCartUtils.getLinkUsedCount(shareCart);
                            ordersCount = this.accountShareCartUtils.getOrdersCount(shareCart);
                            return [ 4, this.resolveShareCartCardSubtotal(shareCart) ];

                          case 1:
                            subtotal = _b.sent();
                            publicLink = this.accountShareCartUtils.shareCartLink((shareCart === null || shareCart === void 0 ? void 0 : shareCart.cart_token) || "", (shareCart === null || shareCart === void 0 ? void 0 : shareCart.share_cart_attributes) || {});
                            card.setAttribute("data-share-cart-id", String(cartId));
                            card.setAttribute("data-share-cart-url", publicLink || "");
                            card.setAttribute("data-share-cart-title", title || "");
                            titleEl = card.querySelector(".st-account-share-cart-card__title_JS");
                            dateEl = card.querySelector(".st-account-share-cart-card__date-value_JS");
                            linkUsedEl = card.querySelector(".st-account-share-cart-card__link-used_JS");
                            ordersEl = card.querySelector(".st-account-share-cart-card__orders_JS");
                            partyNameEl = card.querySelector(".st-account-share-cart-card__party-name_JS");
                            subtotalEl = card.querySelector(".st-account-share-cart-card__subtotal_JS");
                            linkEl = card.querySelector(".st-account-share-cart-card__link_JS");
                            copyBtn = card.querySelector(".st-account-share-cart-card__copy-btn_JS");
                            viewBtn = card.querySelector(".st-account-share-cart-card__view-btn_JS");
                            editBtn = card.querySelector(".st-account-share-cart-card__menu-item--edit_JS");
                            deleteBtn = card.querySelector(".st-account-share-cart-card__menu-item--delete_JS");
                            if (titleEl) {
                                titleEl.textContent = title || "";
                            }
                            if (dateEl) {
                                dateEl.textContent = date || "";
                            }
                            if (linkUsedEl) {
                                linkUsedEl.textContent = String(linkUsed || "0");
                            }
                            if (ordersEl) {
                                ordersEl.textContent = String(ordersCount);
                            }
                            if (partyNameEl) {
                                partyNameEl.textContent = partyName || "-";
                            }
                            if (subtotalEl) {
                                subtotalEl.textContent = this.formatMoney(subtotal);
                            }
                            if (linkEl) {
                                linkEl.textContent = publicLink || "";
                            }
                            if (copyBtn) {
                                copyBtn.setAttribute("data-share-cart-url", publicLink || "");
                            }
                            if (viewBtn) {
                                viewBtn.setAttribute("data-share-cart-id", String(cartId));
                            }
                            if (editBtn) {
                                editBtn.setAttribute("data-share-cart-id", String(cartId));
                            }
                            if (deleteBtn) {
                                deleteBtn.setAttribute("data-share-cart-id", String(cartId));
                            }
                            return [ 2, card ];
                        }
                    });
                });
            };
            _this.bindCardEvents = function() {
                _this.bindCopyButtons();
                _this.bindMenuTriggers();
                _this.bindEditButtons();
                _this.bindDeleteButtons();
                _this.bindViewButtons();
                _this.bindMobileToggleButtons();
            };
            _this.bindMobileToggleButtons = function() {
                var buttons = document.querySelectorAll(".st-account-share-cart-card__mobile-toggle_JS");
                buttons.forEach(function(button) {
                    var btn = button;
                    if (btn.__shareCartBound) {
                        return;
                    }
                    btn.__shareCartBound = true;
                    btn.addEventListener("click", function(event) {
                        event.preventDefault();
                        if (window.innerWidth > 767) {
                            return;
                        }
                        var card = _this.generalMethods.getClosestByClass(btn, "st-account-share-cart-card");
                        if (!card) {
                            return;
                        }
                        var isExpanded = card.classList.contains("is-expanded");
                        _this.closeAllMobileExpandedCards();
                        if (!isExpanded) {
                            _this.setMobileCardExpanded(card, true);
                        }
                    });
                });
            };
            _this.closeAllMobileExpandedCards = function() {
                var cards = document.querySelectorAll(".st-account-share-cart-card_JS");
                cards.forEach(function(cardElement) {
                    var card = cardElement;
                    _this.setMobileCardExpanded(card, false);
                });
            };
            _this.setMobileCardExpanded = function(card, isExpanded) {
                card.classList.toggle("is-expanded", isExpanded);
                var toggleBtn = card.querySelector(".st-account-share-cart-card__mobile-toggle_JS");
                var toggleLabel = card.querySelector(".st-account-share-cart-card__mobile-toggle-label_JS");
                if (toggleBtn) {
                    toggleBtn.setAttribute("aria-expanded", String(isExpanded));
                    var moreLabel = toggleBtn.getAttribute("data-more-label") || "View more";
                    var lessLabel = toggleBtn.getAttribute("data-less-label") || "Show less";
                    if (toggleLabel) {
                        toggleLabel.textContent = isExpanded ? lessLabel : moreLabel;
                    }
                }
            };
            _this.bindCopyButtons = function() {
                if (!sharecart_feature_config_2.shareCartCopyEnabled) {
                    return;
                }
                var buttons = document.querySelectorAll(".st-account-share-cart-card__copy-btn_JS");
                buttons.forEach(function(button) {
                    var btn = button;
                    if (btn.__shareCartBound) {
                        return;
                    }
                    btn.__shareCartBound = true;
                    btn.addEventListener("click", function() {
                        _this.accountShareCartUtils.copyShareCartLink(btn);
                    });
                });
            };
            _this.bindMenuTriggers = function() {
                var buttons = document.querySelectorAll(".st-account-share-cart-card__menu-trigger_JS");
                buttons.forEach(function(button) {
                    var btn = button;
                    if (btn.__shareCartBound) {
                        return;
                    }
                    btn.__shareCartBound = true;
                    btn.addEventListener("click", function(event) {
                        event.stopPropagation();
                        _this.accountShareCartUtils.toggleMenu(btn);
                    });
                });
            };
            _this.bindEditButtons = function() {
                if (!sharecart_feature_config_2.shareCartEditEnabled) {
                    return;
                }
                var buttons = document.querySelectorAll(".st-account-share-cart-card__menu-item--edit_JS");
                buttons.forEach(function(button) {
                    var btn = button;
                    if (btn.__shareCartBound) {
                        return;
                    }
                    btn.__shareCartBound = true;
                    btn.addEventListener("click", function() {
                        return __awaiter(_this, void 0, void 0, function() {
                            var shareCartId;
                            return __generator(this, function(_a) {
                                switch (_a.label) {
                                  case 0:
                                    shareCartId = this.accountShareCartUtils.getShareCartId(btn);
                                    this.accountShareCartUtils.closeAllMenus();
                                    return [ 4, this.openEditNameModal(shareCartId) ];

                                  case 1:
                                    _a.sent();
                                    return [ 2 ];
                                }
                            });
                        });
                    });
                });
            };
            _this.bindDeleteButtons = function() {
                if (!sharecart_feature_config_2.shareCartDeleteEnabled) {
                    return;
                }
                var buttons = document.querySelectorAll(".st-account-share-cart-card__menu-item--delete_JS");
                buttons.forEach(function(button) {
                    var btn = button;
                    if (btn.__shareCartBound) {
                        return;
                    }
                    btn.__shareCartBound = true;
                    btn.addEventListener("click", function() {
                        var shareCartId = _this.accountShareCartUtils.getShareCartId(btn);
                        _this.accountShareCartUtils.closeAllMenus();
                        _this.openDeleteModal(shareCartId);
                    });
                });
            };
            _this.bindViewButtons = function() {
                if (!sharecart_feature_config_2.shareCartViewEnabled) {
                    return;
                }
                var buttons = document.querySelectorAll(".st-account-share-cart-card__view-btn_JS");
                buttons.forEach(function(button) {
                    var btn = button;
                    if (btn.__shareCartBound) {
                        return;
                    }
                    btn.__shareCartBound = true;
                    btn.addEventListener("click", function(e) {
                        e.preventDefault();
                        var shareCartId = _this.accountShareCartUtils.getShareCartId(btn);
                        _this.openSingleShareCart(shareCartId);
                    });
                });
            };
            _this.openSingleShareCart = function(shareCartId) {
                return __awaiter(_this, void 0, void 0, function() {
                    var wrapper, single, response, shareCart, error_9;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            if (!sharecart_feature_config_2.shareCartAccountDetailsPageEnabled || !sharecart_feature_config_2.shareCartViewEnabled) {
                                return [ 2 ];
                            }
                            wrapper = this.accountShareCartUtils.getWrapper();
                            single = wrapper === null || wrapper === void 0 ? void 0 : wrapper.querySelector(".st-account-single-share-cart_JS");
                            if (!wrapper || !single || !shareCartId) {
                                return [ 2 ];
                            }
                            wrapper.classList.add("st-account-share-cart--single-open");
                            single.style.display = "block";
                            single.setAttribute("data-share-cart-id", shareCartId);
                            this.toggleSingleShareCartLoading(single, true);
                            _a.label = 1;

                          case 1:
                            _a.trys.push([ 1, 3, 4, 5 ]);
                            return [ 4, this.fetchShareCartById(shareCartId) ];

                          case 2:
                            response = _a.sent();
                            shareCart = this.normalizeSingleShareCartResponse(response);
                            this.shareCartDetailsCache[String(shareCartId)] = shareCart;
                            this.fillSingleShareCart(single, shareCart);
                            this.bindSingleShareCartEvents(single);
                            return [ 3, 5 ];

                          case 3:
                            error_9 = _a.sent();
                            console.error("[StAccountShareCart] single share cart error:", error_9);
                            this.showSingleShareCartError(single, "Failed to load share cart details.");
                            return [ 3, 5 ];

                          case 4:
                            this.toggleSingleShareCartLoading(single, false);
                            return [ 7 ];

                          case 5:
                            return [ 2 ];
                        }
                    });
                });
            };
            _this.backToHistoryShareCarts = function() {
                document.addEventListener("click", function(e) {
                    var target = e.target;
                    var btn = target === null || target === void 0 ? void 0 : target.closest(".st-account-single-share-cart__back-btn_JS");
                    if (!btn) {
                        return;
                    }
                    e.preventDefault();
                    var single = _this.generalMethods.getClosestByClass(btn, "st-account-single-share-cart");
                    var wrapper = _this.generalMethods.getClosestByClass(btn, "st-account-share-cart");
                    if (single) {
                        single.style.display = "none";
                    }
                    wrapper === null || wrapper === void 0 ? void 0 : wrapper.classList.remove("st-account-share-cart--single-open");
                });
            };
            _this.bindSingleShareCartEvents = function(single) {
                var copyBtn = single.querySelector(".st-account-single-share-cart__copy-btn_JS");
                if (copyBtn && sharecart_feature_config_2.shareCartCopyEnabled) {
                    copyBtn.onclick = function() {
                        _this.accountShareCartUtils.copyShareCartLink(copyBtn);
                    };
                }
                var editBtn = single.querySelector(".st-account-single-share-cart__edit-btn_JS");
                if (editBtn && sharecart_feature_config_2.shareCartEditEnabled) {
                    editBtn.onclick = function() {
                        return __awaiter(_this, void 0, void 0, function() {
                            var shareCartId;
                            return __generator(this, function(_a) {
                                switch (_a.label) {
                                  case 0:
                                    shareCartId = single.getAttribute("data-share-cart-id") || "";
                                    this.closeSingleShareCartMenus();
                                    return [ 4, this.openEditNameModal(shareCartId) ];

                                  case 1:
                                    _a.sent();
                                    return [ 2 ];
                                }
                            });
                        });
                    };
                }
                var deleteBtn = single.querySelector(".st-account-single-share-cart__delete-btn_JS");
                if (deleteBtn && sharecart_feature_config_2.shareCartDeleteEnabled) {
                    deleteBtn.onclick = function() {
                        var shareCartId = single.getAttribute("data-share-cart-id") || "";
                        _this.closeSingleShareCartMenus();
                        _this.openDeleteModal(shareCartId);
                    };
                }
                _this.bindSingleShareCartMenuTriggers(single);
                _this.bindSingleShareCartMenuClose(single);
            };
            _this.bindSingleShareCartMenuTriggers = function(scope) {
                var root = scope || document;
                var buttons = root.querySelectorAll(".st-account-single-share-cart__menu-trigger_JS");
                buttons.forEach(function(button) {
                    var btn = button;
                    if (btn.__singleShareCartMenuBound) {
                        return;
                    }
                    btn.__singleShareCartMenuBound = true;
                    btn.addEventListener("click", function(event) {
                        event.preventDefault();
                        event.stopPropagation();
                        var menu = _this.generalMethods.getClosestByClass(btn, "st-account-single-share-cart__menu");
                        if (!menu) {
                            return;
                        }
                        var isOpen = menu.classList.contains("is-open");
                        _this.closeSingleShareCartMenus();
                        if (!isOpen) {
                            menu.classList.add("is-open");
                            btn.setAttribute("aria-expanded", "true");
                        }
                    });
                });
            };
            _this.bindSingleShareCartMenuClose = function(scope) {
                var root = scope || document;
                var buttons = root.querySelectorAll(".st-account-single-share-cart__menu-close_JS");
                buttons.forEach(function(button) {
                    var btn = button;
                    if (btn.__singleShareCartMenuCloseBound) {
                        return;
                    }
                    btn.__singleShareCartMenuCloseBound = true;
                    btn.addEventListener("click", function(event) {
                        event.preventDefault();
                        event.stopPropagation();
                        _this.closeSingleShareCartMenus();
                    });
                });
            };
            _this.closeSingleShareCartMenus = function() {
                var menus = document.querySelectorAll(".st-account-single-share-cart__menu_JS");
                menus.forEach(function(menuElement) {
                    var menu = menuElement;
                    menu.classList.remove("is-open");
                    var trigger = menu.querySelector(".st-account-single-share-cart__menu-trigger_JS");
                    if (trigger) {
                        trigger.setAttribute("aria-expanded", "false");
                    }
                });
            };
            _this.bindSingleShareCartOutsideClick = function() {
                document.addEventListener("click", function(event) {
                    var target = event.target;
                    if (!target) {
                        return;
                    }
                    var clickedInsideSingleMenu = target.closest(".st-account-single-share-cart__menu_JS");
                    var clickedSingleTrigger = target.closest(".st-account-single-share-cart__menu-trigger_JS");
                    if (!clickedInsideSingleMenu && !clickedSingleTrigger) {
                        _this.closeSingleShareCartMenus();
                    }
                });
            };
            _this.fillSingleShareCart = function(single, shareCart) {
                var titleEl = single.querySelector(".st-account-single-share-cart__title_JS");
                var dateEl = single.querySelector(".st-account-single-share-cart__date_JS");
                var linkUsedEl = single.querySelector(".st-account-single-share-cart__link-used_JS");
                var ordersEl = single.querySelector(".st-account-single-share-cart__orders_JS");
                var partyNameEl = single.querySelector(".st-account-single-share-cart__party-name_JS");
                var subtotalEl = single.querySelector(".st-account-single-share-cart__subtotal_JS");
                var linkEl = single.querySelector(".st-account-single-share-cart__link_JS");
                var totalEl = single.querySelector(".st-account-single-share-cart__total_JS");
                var lineItemsEl = single.querySelector(".st-account-single-share-cart__line-items_JS");
                var copyBtn = single.querySelector(".st-account-single-share-cart__copy-btn_JS");
                var title = _this.accountShareCartUtils.getShareCartTitle(shareCart);
                var date = _this.accountShareCartUtils.formatShareCartDate(shareCart === null || shareCart === void 0 ? void 0 : shareCart.created_at);
                var linkUsed = _this.accountShareCartUtils.getLinkUsedCount(shareCart);
                var ordersCount = _this.accountShareCartUtils.getOrdersCount(shareCart);
                var partyName = _this.accountShareCartUtils.getPartyName(shareCart);
                var publicLink = _this.accountShareCartUtils.shareCartLink((shareCart === null || shareCart === void 0 ? void 0 : shareCart.cart_token) || "", (shareCart === null || shareCart === void 0 ? void 0 : shareCart.share_cart_attributes) || {});
                var total = _this.getShareCartTotal(shareCart);
                var items = _this.normalizeLineItems(shareCart);
                if (titleEl) {
                    titleEl.textContent = title || "";
                }
                if (dateEl) {
                    dateEl.textContent = date || "";
                }
                if (linkUsedEl) {
                    linkUsedEl.textContent = String(linkUsed || "0");
                }
                if (ordersEl) {
                    ordersEl.textContent = String(ordersCount);
                }
                if (partyNameEl) {
                    partyNameEl.textContent = partyName || "-";
                }
                if (subtotalEl) {
                    subtotalEl.textContent = _this.formatMoney(total);
                }
                if (linkEl) {
                    linkEl.textContent = publicLink || "";
                }
                if (copyBtn) {
                    copyBtn.setAttribute("data-share-cart-url", publicLink || "");
                }
                if (totalEl) {
                    totalEl.textContent = _this.formatMoney(total);
                }
                if (lineItemsEl) {
                    lineItemsEl.innerHTML = "";
                    var template_1 = document.getElementById("st-account-single-share-cart-line-item-template");
                    if (template_1 && items.length) {
                        items.forEach(function(item) {
                            var _a;
                            var fragment = ((_a = template_1.content) !== null && _a !== void 0 ? _a : template_1).cloneNode(true);
                            var imageEl = fragment.querySelector(".st-account-single-share-cart-line-item__image_JS");
                            var titleItemEl = fragment.querySelector(".st-account-single-share-cart-line-item__title_JS");
                            var qtyEl = fragment.querySelector(".st-account-single-share-cart-line-item__qty_JS");
                            var priceEl = fragment.querySelector(".st-account-single-share-cart-line-item__price_JS");
                            var totalItemEl = fragment.querySelector(".st-account-single-share-cart-line-item__total_JS");
                            var image = _this.getLineItemImage(item);
                            var itemTitle = _this.getLineItemTitle(item);
                            var qty = _this.getLineItemQty(item);
                            var price = _this.getLineItemPrice(item);
                            var itemTotal = _this.getLineItemTotal(item);
                            if (imageEl) {
                                imageEl.src = image || "";
                                imageEl.alt = itemTitle || "";
                            }
                            if (titleItemEl) {
                                titleItemEl.textContent = itemTitle || "";
                            }
                            if (qtyEl) {
                                qtyEl.textContent = String(qty || 0);
                            }
                            if (priceEl) {
                                priceEl.textContent = _this.formatMoney(price);
                            }
                            if (totalItemEl) {
                                totalItemEl.textContent = _this.formatMoney(itemTotal);
                            }
                            lineItemsEl.appendChild(fragment);
                        });
                    }
                }
            };
            _this.normalizeLineItems = function(shareCart) {
                var _a;
                if (Array.isArray(shareCart === null || shareCart === void 0 ? void 0 : shareCart.line_items)) {
                    return shareCart.line_items;
                }
                if (Array.isArray(shareCart === null || shareCart === void 0 ? void 0 : shareCart.items)) {
                    return shareCart.items;
                }
                if (Array.isArray(shareCart === null || shareCart === void 0 ? void 0 : shareCart.cart_items)) {
                    return shareCart.cart_items;
                }
                if (Array.isArray(shareCart === null || shareCart === void 0 ? void 0 : shareCart.products)) {
                    return shareCart.products;
                }
                if (Array.isArray((_a = shareCart === null || shareCart === void 0 ? void 0 : shareCart.data) === null || _a === void 0 ? void 0 : _a.line_items)) {
                    return shareCart.data.line_items;
                }
                return [];
            };
            _this.getLineItemsForUpdate = function(shareCart) {
                var _a;
                if (Array.isArray(shareCart === null || shareCart === void 0 ? void 0 : shareCart.line_items)) {
                    return shareCart.line_items;
                }
                if (Array.isArray(shareCart === null || shareCart === void 0 ? void 0 : shareCart.items)) {
                    return shareCart.items;
                }
                if (Array.isArray(shareCart === null || shareCart === void 0 ? void 0 : shareCart.cart_items)) {
                    return shareCart.cart_items;
                }
                if (Array.isArray(shareCart === null || shareCart === void 0 ? void 0 : shareCart.products)) {
                    return shareCart.products;
                }
                if (Array.isArray((_a = shareCart === null || shareCart === void 0 ? void 0 : shareCart.data) === null || _a === void 0 ? void 0 : _a.line_items)) {
                    return shareCart.data.line_items;
                }
                return [];
            };
            _this.getLineItemTitle = function(item) {
                var _a, _b, _c;
                return ((_b = (_a = item === null || item === void 0 ? void 0 : item.shopify_details) === null || _a === void 0 ? void 0 : _a.product) === null || _b === void 0 ? void 0 : _b.title) || ((_c = item === null || item === void 0 ? void 0 : item.shopify_details) === null || _c === void 0 ? void 0 : _c.displayName) || (item === null || item === void 0 ? void 0 : item.title) || (item === null || item === void 0 ? void 0 : item.product_title) || (item === null || item === void 0 ? void 0 : item.productName) || (item === null || item === void 0 ? void 0 : item.name) || (item === null || item === void 0 ? void 0 : item.variant_title) || "";
            };
            _this.getLineItemImage = function(item) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
                return ((_g = (_f = (_e = (_d = (_c = (_b = (_a = item === null || item === void 0 ? void 0 : item.shopify_details) === null || _a === void 0 ? void 0 : _a.product) === null || _b === void 0 ? void 0 : _b.media) === null || _c === void 0 ? void 0 : _c.nodes) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.preview) === null || _f === void 0 ? void 0 : _f.image) === null || _g === void 0 ? void 0 : _g.url) || ((_k = (_j = (_h = item === null || item === void 0 ? void 0 : item.shopify_details) === null || _h === void 0 ? void 0 : _h.product) === null || _j === void 0 ? void 0 : _j.featuredImage) === null || _k === void 0 ? void 0 : _k.url) || ((_m = (_l = item === null || item === void 0 ? void 0 : item.shopify_details) === null || _l === void 0 ? void 0 : _l.image) === null || _m === void 0 ? void 0 : _m.url) || (item === null || item === void 0 ? void 0 : item.thumbnail) || (item === null || item === void 0 ? void 0 : item.image) || (item === null || item === void 0 ? void 0 : item.image_url) || (item === null || item === void 0 ? void 0 : item.featured_image) || ((_o = item === null || item === void 0 ? void 0 : item.variant) === null || _o === void 0 ? void 0 : _o.image) || ((_p = item === null || item === void 0 ? void 0 : item.product) === null || _p === void 0 ? void 0 : _p.thumbnail) || "";
            };
            _this.getLineItemQty = function(item) {
                return Number((item === null || item === void 0 ? void 0 : item.quantity) || (item === null || item === void 0 ? void 0 : item.qty) || (item === null || item === void 0 ? void 0 : item.count) || 0);
            };
            _this.getLineItemPrice = function(item) {
                var _a;
                return Number((item === null || item === void 0 ? void 0 : item.price) || ((_a = item === null || item === void 0 ? void 0 : item.shopify_details) === null || _a === void 0 ? void 0 : _a.price) || (item === null || item === void 0 ? void 0 : item.unit_price) || (item === null || item === void 0 ? void 0 : item.final_price) || (item === null || item === void 0 ? void 0 : item.amount) || 0);
            };
            _this.getLineItemTotal = function(item) {
                var explicitTotals = [ item === null || item === void 0 ? void 0 : item.total, item === null || item === void 0 ? void 0 : item.line_total, item === null || item === void 0 ? void 0 : item.total_price, item === null || item === void 0 ? void 0 : item.subtotal ];
                for (var _i = 0, explicitTotals_1 = explicitTotals; _i < explicitTotals_1.length; _i++) {
                    var candidate = explicitTotals_1[_i];
                    if (candidate === null || typeof candidate === "undefined" || candidate === "") {
                        continue;
                    }
                    var parsed = Number(candidate);
                    if (!Number.isNaN(parsed) && parsed > 0) {
                        return parsed;
                    }
                }
                return _this.getLineItemPrice(item) * _this.getLineItemQty(item);
            };
            _this.getShareCartTotal = function(shareCart) {
                var items = _this.normalizeLineItems(shareCart);
                if (Array.isArray(items) && items.length) {
                    var itemsTotal = items.reduce(function(sum, item) {
                        return sum + _this.getLineItemTotal(item);
                    }, 0);
                    if (!Number.isNaN(itemsTotal) && itemsTotal > 0) {
                        return itemsTotal;
                    }
                }
                var directTotals = [ shareCart === null || shareCart === void 0 ? void 0 : shareCart.totalPrice, shareCart === null || shareCart === void 0 ? void 0 : shareCart.total_price, shareCart === null || shareCart === void 0 ? void 0 : shareCart.total, shareCart === null || shareCart === void 0 ? void 0 : shareCart.subtotal, shareCart === null || shareCart === void 0 ? void 0 : shareCart.cart_total ];
                for (var _i = 0, directTotals_1 = directTotals; _i < directTotals_1.length; _i++) {
                    var candidate = directTotals_1[_i];
                    if (candidate === null || typeof candidate === "undefined" || candidate === "") {
                        continue;
                    }
                    var parsed = Number(candidate);
                    if (!Number.isNaN(parsed)) {
                        return parsed;
                    }
                }
                return 0;
            };
            _this.toggleSingleShareCartLoading = function(single, show) {
                var loading = single.querySelector(".st-account-single-share-cart__loading");
                if (!loading) {
                    return;
                }
                loading.classList.toggle("st_hidden", !show);
            };
            _this.showSingleShareCartError = function(single, message) {
                var lineItemsEl = single.querySelector(".st-account-single-share-cart__line-items_JS");
                if (lineItemsEl) {
                    lineItemsEl.innerHTML = '<div class="st-account-share-cart__message st-account-share-cart__message--error"><i>'.concat(message, "</i></div>");
                }
            };
            _this.formatMoney = function(value) {
                var amount = Number(value || 0);
                return "$".concat(amount.toFixed(2));
            };
            _this.bindCreateNewCartButton = function() {
                if (!sharecart_feature_config_2.shareCartCreateEnabled) {
                    return;
                }
                var button = document.querySelector(".st-account-share-cart__redirect-to-btn_JS");
                if (!button) {
                    return;
                }
                if (button.__shareCartCreateBound) {
                    return;
                }
                button.__shareCartCreateBound = true;
                button.addEventListener("click", function() {
                    var currentUrl = new URL(window.location.href);
                    var alias = currentUrl.searchParams.get("als");
                    var params = new URLSearchParams();
                    if (alias) {
                        params.set("als", alias);
                    }
                    window.location.href = "".concat(window.location.origin, "/collections/all").concat(params.toString() ? "?".concat(params.toString()) : "");
                });
            };
            _this.bindOutsideClick = function() {
                document.addEventListener("click", function(event) {
                    var target = event.target;
                    if (!target) {
                        return;
                    }
                    var clickedInsideMenu = target.closest(".st-account-share-cart-card__menu_JS");
                    var clickedMenuTrigger = target.closest(".st-account-share-cart-card__menu-trigger_JS");
                    if (!clickedInsideMenu && !clickedMenuTrigger) {
                        _this.accountShareCartUtils.closeAllMenus();
                    }
                });
            };
            _this.bindEditNameModalEvents = function() {
                if (!sharecart_feature_config_2.shareCartEditEnabled) {
                    return;
                }
                if (_this.editNameModalBound) {
                    return;
                }
                _this.editNameModalBound = true;
                document.addEventListener("click", function(event) {
                    return __awaiter(_this, void 0, void 0, function() {
                        var target, cancelBtn, backdrop, saveBtn;
                        return __generator(this, function(_a) {
                            switch (_a.label) {
                              case 0:
                                target = event.target;
                                if (!target) {
                                    return [ 2 ];
                                }
                                cancelBtn = target.closest(".st-account-share-cart-edit-modal__cancel_JS");
                                backdrop = target.closest(".st-account-share-cart-edit-modal__backdrop_JS");
                                saveBtn = target.closest(".st-account-share-cart-edit-modal__save_JS");
                                if (cancelBtn || backdrop) {
                                    event.preventDefault();
                                    this.closeEditNameModal();
                                    return [ 2 ];
                                }
                                if (!saveBtn) return [ 3, 2 ];
                                event.preventDefault();
                                return [ 4, this.handleEditNameSubmit() ];

                              case 1:
                                _a.sent();
                                _a.label = 2;

                              case 2:
                                return [ 2 ];
                            }
                        });
                    });
                });
                document.addEventListener("keydown", function(event) {
                    return __awaiter(_this, void 0, void 0, function() {
                        var modal, target, isInput;
                        return __generator(this, function(_a) {
                            switch (_a.label) {
                              case 0:
                                modal = this.getEditNameModal();
                                if (!modal || !this.isEditNameModalOpen()) {
                                    return [ 2 ];
                                }
                                if (event.key === "Escape") {
                                    event.preventDefault();
                                    this.closeEditNameModal();
                                }
                                if (!(event.key === "Enter")) return [ 3, 2 ];
                                target = event.target;
                                isInput = !!(target === null || target === void 0 ? void 0 : target.closest(".st-account-share-cart-edit-modal__input_JS"));
                                if (!isInput) return [ 3, 2 ];
                                event.preventDefault();
                                return [ 4, this.handleEditNameSubmit() ];

                              case 1:
                                _a.sent();
                                _a.label = 2;

                              case 2:
                                return [ 2 ];
                            }
                        });
                    });
                });
            };
            _this.getEditNameModal = function() {
                var _a;
                return (_a = _this.accountShareCartUtils.getWrapper()) === null || _a === void 0 ? void 0 : _a.querySelector(".st-account-share-cart-edit-modal_JS");
            };
            _this.isEditNameModalOpen = function() {
                var modal = _this.getEditNameModal();
                return !!(modal === null || modal === void 0 ? void 0 : modal.classList.contains("is-visible"));
            };
            _this.openEditNameModal = function(shareCartId) {
                return __awaiter(_this, void 0, void 0, function() {
                    var modal, input, shareCart, currentName, error_10;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            if (!sharecart_feature_config_2.shareCartEditEnabled) {
                                return [ 2 ];
                            }
                            if (!shareCartId) {
                                return [ 2 ];
                            }
                            modal = this.getEditNameModal();
                            if (!modal) {
                                return [ 2 ];
                            }
                            input = modal.querySelector(".st-account-share-cart-edit-modal__input_JS");
                            if (!input) {
                                return [ 2 ];
                            }
                            this.activeEditShareCartId = String(shareCartId);
                            this.setEditNameModalError("");
                            this.setEditNameModalSubmitting(false);
                            _a.label = 1;

                          case 1:
                            _a.trys.push([ 1, 3, , 4 ]);
                            return [ 4, this.getShareCartDetailForEdit(shareCartId) ];

                          case 2:
                            shareCart = _a.sent();
                            currentName = this.accountShareCartUtils.getShareCartTitle(shareCart);
                            input.value = currentName || "";
                            modal.classList.add("is-visible");
                            modal.setAttribute("aria-hidden", "false");
                            document.body.classList.add("st-share-cart-modal-open");
                            setTimeout(function() {
                                input.focus();
                                input.setSelectionRange(input.value.length, input.value.length);
                            }, 0);
                            return [ 3, 4 ];

                          case 3:
                            error_10 = _a.sent();
                            console.error("[StAccountShareCart] open edit name modal error:", error_10);
                            return [ 3, 4 ];

                          case 4:
                            return [ 2 ];
                        }
                    });
                });
            };
            _this.closeEditNameModal = function(force) {
                if (force === void 0) {
                    force = false;
                }
                if (_this.isSubmittingEditName && !force) {
                    return;
                }
                var modal = _this.getEditNameModal();
                if (!modal) {
                    return;
                }
                var input = modal.querySelector(".st-account-share-cart-edit-modal__input_JS");
                modal.classList.remove("is-visible");
                modal.setAttribute("aria-hidden", "true");
                document.body.classList.remove("st-share-cart-modal-open");
                _this.activeEditShareCartId = "";
                _this.setEditNameModalError("");
                if (input) {
                    input.value = "";
                    input.disabled = false;
                }
            };
            _this.getShareCartDetailForEdit = function(shareCartId) {
                return __awaiter(_this, void 0, void 0, function() {
                    var cacheKey, response, shareCart;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            cacheKey = String(shareCartId);
                            if (this.shareCartDetailsCache[cacheKey]) {
                                return [ 2, this.shareCartDetailsCache[cacheKey] ];
                            }
                            return [ 4, this.fetchShareCartById(shareCartId) ];

                          case 1:
                            response = _a.sent();
                            shareCart = this.normalizeSingleShareCartResponse(response);
                            this.shareCartDetailsCache[cacheKey] = shareCart;
                            return [ 2, shareCart ];
                        }
                    });
                });
            };
            _this.handleEditNameSubmit = function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var shareCartId, modal, input, nextName, shareCartNameLength, isValidCartName, shareCart, response, updatedShareCart, error_11;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            if (!sharecart_feature_config_2.shareCartEditEnabled) {
                                return [ 2 ];
                            }
                            if (this.isSubmittingEditName) {
                                return [ 2 ];
                            }
                            shareCartId = this.activeEditShareCartId;
                            modal = this.getEditNameModal();
                            if (!modal || !shareCartId) {
                                return [ 2 ];
                            }
                            input = modal.querySelector(".st-account-share-cart-edit-modal__input_JS");
                            if (!input) {
                                return [ 2 ];
                            }
                            nextName = (input.value || "").trim();
                            shareCartNameLength = window.stTranslations.shareCartNameLength;
                            if (!nextName) {
                                this.setEditNameModalError(this.accountShareCartUtils.getTranslation("cart_name_required"));
                                return [ 2 ];
                            }
                            isValidCartName = /^.{6,}$/.test(nextName);
                            if (!isValidCartName) {
                                this.setEditNameModalError(shareCartNameLength);
                                return [ 2 ];
                            }
                            _a.label = 1;

                          case 1:
                            _a.trys.push([ 1, 5, , 6 ]);
                            this.setEditNameModalError("");
                            this.setEditNameModalSubmitting(true);
                            return [ 4, this.getShareCartDetailForEdit(shareCartId) ];

                          case 2:
                            shareCart = _a.sent();
                            return [ 4, this.updateShareCartName(shareCartId, shareCart, nextName) ];

                          case 3:
                            response = _a.sent();
                            updatedShareCart = this.normalizeSingleShareCartResponse(response);
                            this.shareCartDetailsCache[String(shareCartId)] = updatedShareCart;
                            return [ 4, this.fetchAndRenderShareCarts(this.currentPage) ];

                          case 4:
                            _a.sent();
                            this.updateVisibleSingleShareCartAfterEdit(shareCartId, updatedShareCart);
                            this.setEditNameModalSubmitting(false);
                            this.closeEditNameModal(true);
                            return [ 3, 6 ];

                          case 5:
                            error_11 = _a.sent();
                            console.error("[StAccountShareCart] update share cart name error:", error_11);
                            this.setEditNameModalSubmitting(false);
                            this.setEditNameModalError((error_11 === null || error_11 === void 0 ? void 0 : error_11.message) || this.accountShareCartUtils.getTranslation("cart_name_save_failed", "Failed to save cart name."));
                            return [ 3, 6 ];

                          case 6:
                            return [ 2 ];
                        }
                    });
                });
            };
            _this.setEditNameModalError = function(message) {
                var modal = _this.getEditNameModal();
                var errorEl = modal === null || modal === void 0 ? void 0 : modal.querySelector(".st-account-share-cart-edit-modal__error_JS");
                if (!errorEl) {
                    return;
                }
                errorEl.textContent = message || "";
                errorEl.classList.toggle("st_hidden", !message);
            };
            _this.setEditNameModalSubmitting = function(isSubmitting) {
                _this.isSubmittingEditName = isSubmitting;
                var modal = _this.getEditNameModal();
                if (!modal) {
                    return;
                }
                var input = modal.querySelector(".st-account-share-cart-edit-modal__input_JS");
                var saveBtn = modal.querySelector(".st-account-share-cart-edit-modal__save_JS");
                var cancelBtn = modal.querySelector(".st-account-share-cart-edit-modal__cancel_JS");
                if (input) {
                    input.disabled = isSubmitting;
                }
                if (saveBtn) {
                    saveBtn.disabled = isSubmitting;
                    saveBtn.textContent = isSubmitting ? _this.accountShareCartUtils.getTranslation("saving", "Saving...") : _this.accountShareCartUtils.getTranslation("save", "Save");
                }
                if (cancelBtn) {
                    cancelBtn.disabled = isSubmitting;
                }
            };
            _this.updateVisibleSingleShareCartAfterEdit = function(shareCartId, updatedShareCart) {
                var wrapper = _this.accountShareCartUtils.getWrapper();
                var single = wrapper === null || wrapper === void 0 ? void 0 : wrapper.querySelector(".st-account-single-share-cart_JS");
                if (!single) {
                    return;
                }
                var currentSingleId = single.getAttribute("data-share-cart-id") || "";
                if (currentSingleId && String(currentSingleId) === String(shareCartId)) {
                    _this.fillSingleShareCart(single, updatedShareCart);
                    _this.bindSingleShareCartEvents(single);
                }
            };
            _this.getDeleteModal = function() {
                var _a;
                return (_a = _this.accountShareCartUtils.getWrapper()) === null || _a === void 0 ? void 0 : _a.querySelector(".st-account-share-cart-delete-modal_JS");
            };
            _this.isDeleteModalOpen = function() {
                var modal = _this.getDeleteModal();
                return !!(modal === null || modal === void 0 ? void 0 : modal.classList.contains("is-visible"));
            };
            _this.openDeleteModal = function(shareCartId) {
                if (!sharecart_feature_config_2.shareCartDeleteEnabled) {
                    return;
                }
                if (!shareCartId) {
                    return;
                }
                var modal = _this.getDeleteModal();
                if (!modal) {
                    return;
                }
                _this.activeDeleteShareCartId = String(shareCartId);
                _this.setDeleteModalError("");
                _this.setDeleteModalSubmitting(false);
                modal.classList.add("is-visible");
                modal.setAttribute("aria-hidden", "false");
                document.body.classList.add("st-share-cart-modal-open");
            };
            _this.closeDeleteModal = function(force) {
                if (force === void 0) {
                    force = false;
                }
                if (_this.isSubmittingDeleteShareCart && !force) {
                    return;
                }
                var modal = _this.getDeleteModal();
                if (!modal) {
                    return;
                }
                modal.classList.remove("is-visible");
                modal.setAttribute("aria-hidden", "true");
                document.body.classList.remove("st-share-cart-modal-open");
                _this.activeDeleteShareCartId = "";
                _this.setDeleteModalError("");
            };
            _this.bindDeleteModalEvents = function() {
                if (!sharecart_feature_config_2.shareCartDeleteEnabled) {
                    return;
                }
                if (_this.deleteModalBound) {
                    return;
                }
                _this.deleteModalBound = true;
                document.addEventListener("click", function(event) {
                    return __awaiter(_this, void 0, void 0, function() {
                        var target, cancelBtn, backdrop, confirmBtn;
                        return __generator(this, function(_a) {
                            switch (_a.label) {
                              case 0:
                                target = event.target;
                                if (!target) {
                                    return [ 2 ];
                                }
                                cancelBtn = target.closest(".st-account-share-cart-delete-modal__cancel_JS");
                                backdrop = target.closest(".st-account-share-cart-delete-modal__backdrop_JS");
                                confirmBtn = target.closest(".st-account-share-cart-delete-modal__confirm_JS");
                                if (cancelBtn || backdrop) {
                                    event.preventDefault();
                                    this.closeDeleteModal();
                                    return [ 2 ];
                                }
                                if (!confirmBtn) return [ 3, 2 ];
                                event.preventDefault();
                                return [ 4, this.handleDeleteSubmit() ];

                              case 1:
                                _a.sent();
                                _a.label = 2;

                              case 2:
                                return [ 2 ];
                            }
                        });
                    });
                });
                document.addEventListener("keydown", function(event) {
                    return __awaiter(_this, void 0, void 0, function() {
                        return __generator(this, function(_a) {
                            switch (_a.label) {
                              case 0:
                                if (!this.isDeleteModalOpen()) {
                                    return [ 2 ];
                                }
                                if (event.key === "Escape") {
                                    event.preventDefault();
                                    this.closeDeleteModal();
                                }
                                if (!(event.key === "Enter")) return [ 3, 2 ];
                                event.preventDefault();
                                return [ 4, this.handleDeleteSubmit() ];

                              case 1:
                                _a.sent();
                                _a.label = 2;

                              case 2:
                                return [ 2 ];
                            }
                        });
                    });
                });
            };
            _this.setDeleteModalError = function(message) {
                var modal = _this.getDeleteModal();
                var errorEl = modal === null || modal === void 0 ? void 0 : modal.querySelector(".st-account-share-cart-delete-modal__error_JS");
                if (!errorEl) {
                    return;
                }
                errorEl.textContent = message || "";
                errorEl.classList.toggle("st_hidden", !message);
            };
            _this.setDeleteModalSubmitting = function(isSubmitting) {
                _this.isSubmittingDeleteShareCart = isSubmitting;
                var modal = _this.getDeleteModal();
                if (!modal) {
                    return;
                }
                var confirmBtn = modal.querySelector(".st-account-share-cart-delete-modal__confirm_JS");
                var cancelBtn = modal.querySelector(".st-account-share-cart-delete-modal__cancel_JS");
                var deletingText = window.stTranslations.deleting;
                if (confirmBtn) {
                    confirmBtn.disabled = isSubmitting;
                    confirmBtn.textContent = isSubmitting ? deletingText || "Deleting..." : _this.accountShareCartUtils.getTranslation("yes", "Yes");
                }
                if (cancelBtn) {
                    cancelBtn.disabled = isSubmitting;
                }
            };
            _this.handleDeleteSubmit = function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var shareCartId, wrapper, single, currentSingleId, error_12;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            if (!sharecart_feature_config_2.shareCartDeleteEnabled) {
                                return [ 2 ];
                            }
                            if (this.isSubmittingDeleteShareCart) {
                                return [ 2 ];
                            }
                            shareCartId = this.activeDeleteShareCartId;
                            if (!shareCartId) {
                                return [ 2 ];
                            }
                            _a.label = 1;

                          case 1:
                            _a.trys.push([ 1, 7, , 8 ]);
                            this.setDeleteModalError("");
                            this.setDeleteModalSubmitting(true);
                            return [ 4, this.deleteShareCart(shareCartId) ];

                          case 2:
                            _a.sent();
                            delete this.shareCartDetailsCache[String(shareCartId)];
                            wrapper = this.accountShareCartUtils.getWrapper();
                            single = wrapper === null || wrapper === void 0 ? void 0 : wrapper.querySelector(".st-account-single-share-cart_JS");
                            currentSingleId = (single === null || single === void 0 ? void 0 : single.getAttribute("data-share-cart-id")) || "";
                            if (single && String(currentSingleId) === String(shareCartId)) {
                                single.style.display = "none";
                                wrapper === null || wrapper === void 0 ? void 0 : wrapper.classList.remove("st-account-share-cart--single-open");
                            }
                            this.closeDeleteModal(true);
                            if (!(this.currentPage > 1 && this.lastLoadedCount === 1)) return [ 3, 4 ];
                            return [ 4, this.fetchAndRenderShareCarts(this.currentPage - 1) ];

                          case 3:
                            _a.sent();
                            return [ 3, 6 ];

                          case 4:
                            return [ 4, this.fetchAndRenderShareCarts(this.currentPage) ];

                          case 5:
                            _a.sent();
                            _a.label = 6;

                          case 6:
                            return [ 3, 8 ];

                          case 7:
                            error_12 = _a.sent();
                            console.error("[StAccountShareCart] delete share cart error:", error_12);
                            this.setDeleteModalSubmitting(false);
                            this.setDeleteModalError((error_12 === null || error_12 === void 0 ? void 0 : error_12.message) || this.accountShareCartUtils.getTranslation("delete_share_cart_failed", "Failed to delete share cart."));
                            return [ 3, 8 ];

                          case 8:
                            return [ 2 ];
                        }
                    });
                });
            };
            _this.goToPage = function(page) {
                return __awaiter(_this, void 0, void 0, function() {
                    var nextPage;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            nextPage = Math.max(1, page);
                            if (nextPage === this.currentPage && nextPage !== 1) {
                                return [ 2 ];
                            }
                            return [ 4, this.fetchAndRenderShareCarts(nextPage) ];

                          case 1:
                            _a.sent();
                            return [ 2 ];
                        }
                    });
                });
            };
            _this.handleMenuCloseClick = function() {
                document.addEventListener("click", function(event) {
                    var target = event.target;
                    var closeBtn = target.closest(".st-account-share-cart-card__menu-close_JS");
                    if (!closeBtn) {
                        return;
                    }
                    var menu = closeBtn.closest(".st-account-share-cart-card__menu_JS");
                    var trigger = menu === null || menu === void 0 ? void 0 : menu.querySelector(".st-account-share-cart-card__menu-trigger_JS");
                    menu === null || menu === void 0 ? void 0 : menu.classList.remove("is-open");
                    trigger === null || trigger === void 0 ? void 0 : trigger.setAttribute("aria-expanded", "false");
                });
            };
            _this.objectFormatting = objectFormatting;
            _this.generalMethods = generalMethods;
            _this.cartComponent = cartComponent;
            _this.accountShareCartUtils = accountShareCartUtils;
            return _this;
        }
        StAccountShareCart.prototype.renderPagination = function() {
            var root = document.querySelector(".st-account-share-cart__pagination_JS") || document.querySelector(".st_pagination");
            if (!root) {
                return;
            }
            root.innerHTML = "";
            var shouldHide = this.currentPage === 1 && !this.hasNextPage;
            if (shouldHide) {
                root.style.display = "none";
                return;
            }
            root.style.display = "";
            var mkBtn = function(label, role, disabled) {
                var buttonElement = document.createElement("button");
                buttonElement.type = "button";
                buttonElement.className = "st_pag-btn";
                buttonElement.setAttribute("data-role", role);
                buttonElement.disabled = disabled;
                buttonElement.textContent = label;
                return buttonElement;
            };
            var first = mkBtn("«", "first", this.currentPage === 1);
            var prev = mkBtn("‹", "prev", this.currentPage === 1);
            var indicator = document.createElement("span");
            indicator.className = "st_pag-indicator";
            indicator.setAttribute("aria-live", "polite");
            indicator.textContent = String(this.currentPage);
            var next = mkBtn("›", "next", !this.hasNextPage);
            root.appendChild(first);
            root.appendChild(prev);
            root.appendChild(indicator);
            root.appendChild(next);
        };
        StAccountShareCart.prototype.bindPaginationHandlers = function() {
            var _this = this;
            if (this.paginationBound) {
                return;
            }
            this.paginationBound = true;
            document.addEventListener("click", function(e) {
                return __awaiter(_this, void 0, void 0, function() {
                    var targetElement, btn, role, _a;
                    return __generator(this, function(_b) {
                        switch (_b.label) {
                          case 0:
                            targetElement = e.target;
                            if (!(targetElement === null || targetElement === void 0 ? void 0 : targetElement.closest)) {
                                return [ 2 ];
                            }
                            btn = targetElement.closest(".st-account-share-cart__pagination_JS .st_pag-btn, .st_pagination .st_pag-btn");
                            if (!btn) {
                                return [ 2 ];
                            }
                            role = btn.getAttribute("data-role");
                            if (!role) {
                                return [ 2 ];
                            }
                            e.preventDefault();
                            _a = role;
                            switch (_a) {
                              case "first":
                                return [ 3, 1 ];

                              case "prev":
                                return [ 3, 3 ];

                              case "next":
                                return [ 3, 5 ];
                            }
                            return [ 3, 8 ];

                          case 1:
                            return [ 4, this.goToPage(1) ];

                          case 2:
                            _b.sent();
                            return [ 3, 8 ];

                          case 3:
                            return [ 4, this.goToPage(this.currentPage - 1) ];

                          case 4:
                            _b.sent();
                            return [ 3, 8 ];

                          case 5:
                            if (!this.hasNextPage) return [ 3, 7 ];
                            return [ 4, this.goToPage(this.currentPage + 1) ];

                          case 6:
                            _b.sent();
                            _b.label = 7;

                          case 7:
                            return [ 3, 8 ];

                          case 8:
                            return [ 2 ];
                        }
                    });
                });
            });
        };
        Object.defineProperty(StAccountShareCart.prototype, "shareCartApiKey", {
            get: function() {
                var shareCartKey = window.shareCartApiKey;
                return shareCartKey;
            },
            enumerable: false,
            configurable: true
        });
        return StAccountShareCart;
    }(st_module_89.StModule);
    exports.StAccountShareCart = StAccountShareCart;
});

define("extension/shopify-app/st-modules/rep-lookup/rep-lookup", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_90) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StRepLookup = void 0;
    var USER_ICON = '\n<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <path d="M12.6667 14V12.6667C12.6667 11.9594 12.3858 11.2811 11.8857 10.781C11.3856 10.281 10.7073 10 10 10H6.00004C5.2928 10 4.61452 10.281 4.11442 10.781C3.61433 11.2811 3.33337 11.9594 3.33337 12.6667V14" stroke="#6A7282" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>\n    <path d="M8.00004 7.33333C9.4728 7.33333 10.6667 6.13943 10.6667 4.66667C10.6667 3.19391 9.4728 2 8.00004 2C6.52728 2 5.33337 3.19391 5.33337 4.66667C5.33337 6.13943 6.52728 7.33333 8.00004 7.33333Z" stroke="#6A7282" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>\n</svg>\n';
    var LOCATION_ICON = '\n<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <path d="M13.3333 6.66659C13.3333 9.99525 9.64063 13.4619 8.40063 14.5326C8.28511 14.6194 8.14449 14.6664 7.99996 14.6664C7.85543 14.6664 7.71481 14.6194 7.59929 14.5326C6.35929 13.4619 2.66663 9.99525 2.66663 6.66659C2.66663 5.2521 3.22853 3.89554 4.22872 2.89535C5.22892 1.89516 6.58547 1.33325 7.99996 1.33325C9.41445 1.33325 10.771 1.89516 11.7712 2.89535C12.7714 3.89554 13.3333 5.2521 13.3333 6.66659Z" stroke="#6A7282" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>\n    <path d="M8 8.66675C9.10457 8.66675 10 7.77132 10 6.66675C10 5.56218 9.10457 4.66675 8 4.66675C6.89543 4.66675 6 5.56218 6 6.66675C6 7.77132 6.89543 8.66675 8 8.66675Z" stroke="#6A7282" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>\n</svg>\n';
    var StRepLookup = function(_super) {
        __extends(StRepLookup, _super);
        function StRepLookup(webAliasExtended) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StRepLookup";
            _this.defaultBrandName = "L'BRI";
            _this.searchDebounceMs = 400;
            _this.debounceTimer = null;
            _this.observer = null;
            _this.requestId = 0;
            _this.isLoading = false;
            _this.hasNextPage = false;
            _this.endCursor = null;
            _this.selectedMode = "name";
            _this.results = [];
            _this.representative = null;
            _this.failedAvatarUrls = new Set();
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    if (!document.querySelector(".st_rep_lookup_cart_JS")) return;
                    _this.bindEvents();
                    _this.bindDynamicInputs();
                    _this.observeCartDrawerChanges();
                    _this.bindSponsorChangeListener();
                    _this.removeDuplicateCartLookupBlocks();
                    _this.renderInitialState();
                    _this.refreshUI();
                });
            };
            _this.handleInputChange = function() {
                _this.clearError();
                if (_this.debounceTimer !== null) {
                    window.clearTimeout(_this.debounceTimer);
                }
                _this.debounceTimer = window.setTimeout(function() {
                    _this.triggerSearch(false);
                }, _this.searchDebounceMs);
            };
            _this.webAliasExtended = webAliasExtended;
            return _this;
        }
        StRepLookup.prototype.t = function(key, fallback) {
            if (fallback === void 0) {
                fallback = "";
            }
            var t = window.stTranslations || {};
            return t[key] || fallback;
        };
        StRepLookup.prototype.bindSponsorChangeListener = function() {
            var _this = this;
            window.addEventListener("sponsorChange", function() {
                _this.refreshUI();
            });
        };
        StRepLookup.prototype.bindEvents = function() {
            var _this = this;
            document.addEventListener("click", function(e) {
                var target = e.target;
                if (!(target instanceof Element)) return;
                var openButton = target.closest(".st_rep_lookup_open_JS");
                if (openButton) {
                    e.preventDefault();
                    _this.openModal();
                    return;
                }
                var closeButton = target.closest(".st_rep_lookup_close_JS");
                if (closeButton) {
                    e.preventDefault();
                    _this.closeModal();
                    return;
                }
                var modeButton = target.closest(".st_rep_lookup_mode_JS");
                if (modeButton) {
                    e.preventDefault();
                    _this.changeMode(modeButton);
                    return;
                }
                var showMoreButton = target.closest(".st_rep_lookup_show_more_JS");
                if (showMoreButton) {
                    e.preventDefault();
                    if (_this.isLoading || !_this.hasNextPage || !_this.endCursor) return;
                    _this.fetchResults(false);
                    return;
                }
                var card = target.closest(".st_rep_lookup_card_select_JS");
                if (card) {
                    e.preventDefault();
                    _this.selectRepresentative(card);
                }
            });
            document.addEventListener("keydown", function(e) {
                var target = e.target;
                var element = target instanceof Element ? target : null;
                if (e.key === "Escape") {
                    _this.closeModal();
                    return;
                }
                var card = element === null || element === void 0 ? void 0 : element.closest(".st_rep_lookup_card_select_JS");
                if (card && (e.key === "Enter" || e.key === " ")) {
                    e.preventDefault();
                    _this.selectRepresentative(card);
                }
            });
        };
        StRepLookup.prototype.bindDynamicInputs = function() {
            var _this = this;
            var input = this.getInput();
            var form = this.getElement(".st_rep-lookup-form_JS");
            if (input && !input.dataset.repLookupBound) {
                input.addEventListener("input", this.handleInputChange);
                input.dataset.repLookupBound = "true";
            }
            if (form && !form.dataset.repLookupBound) {
                form.addEventListener("submit", function(e) {
                    e.preventDefault();
                    _this.triggerSearch(true);
                });
                form.dataset.repLookupBound = "true";
            }
        };
        StRepLookup.prototype.observeCartDrawerChanges = function() {
            var _this = this;
            var drawer = document.querySelector("#CartDrawer");
            if (!drawer || this.observer) return;
            var frameRequested = false;
            this.observer = new MutationObserver(function() {
                if (frameRequested) return;
                frameRequested = true;
                window.requestAnimationFrame(function() {
                    frameRequested = false;
                    _this.syncModalWithBody(false);
                    _this.bindDynamicInputs();
                    _this.removeDuplicateCartLookupBlocks();
                    _this.refreshUI();
                });
            });
            this.observer.observe(drawer, {
                childList: true,
                subtree: true
            });
        };
        StRepLookup.prototype.refreshUI = function() {
            this.updateSearchModeUI();
            this.syncRepresentative();
            this.renderRepresentative();
        };
        StRepLookup.prototype.changeMode = function(button) {
            var _a;
            var mode = button.dataset.value;
            if (!mode || mode === this.selectedMode) return;
            this.selectedMode = mode;
            this.clearInput();
            this.resetResultsState();
            this.renderInitialState();
            this.updateSearchModeUI();
            (_a = this.getInput()) === null || _a === void 0 ? void 0 : _a.focus();
        };
        StRepLookup.prototype.openModal = function() {
            var _this = this;
            var modal = this.syncModalWithBody(true);
            if (!modal) return;
            modal.classList.remove("st_hidden");
            document.body.classList.add("st_prevent_scroll");
            this.setOpenButtonsExpanded(true);
            this.bindDynamicInputs();
            this.updateSearchModeUI();
            window.setTimeout(function() {
                var _a;
                return (_a = _this.getInput()) === null || _a === void 0 ? void 0 : _a.focus();
            }, 50);
        };
        StRepLookup.prototype.closeModal = function() {
            var modal = this.getModalElement();
            if (!modal || modal.classList.contains("st_hidden")) return;
            modal.classList.add("st_hidden");
            document.body.classList.remove("st_prevent_scroll");
            this.setOpenButtonsExpanded(false);
        };
        StRepLookup.prototype.setOpenButtonsExpanded = function(isExpanded) {
            this.getElements(".st_rep_lookup_open_JS").forEach(function(button) {
                return button.setAttribute("aria-expanded", String(isExpanded));
            });
        };
        StRepLookup.prototype.triggerSearch = function(force) {
            var searchValue = this.getSearchValue();
            if (!force && searchValue && this.selectedMode === "name" && searchValue.length < 2) {
                this.resetResultsState();
                this.renderInitialState();
                return;
            }
            this.results = [];
            this.endCursor = null;
            this.hasNextPage = false;
            this.fetchResults(true);
        };
        StRepLookup.prototype.fetchResults = function(replace) {
            var _this = this;
            if (this.isLoading) return;
            var requestId = ++this.requestId;
            this.isLoading = true;
            this.clearError();
            this.toggleEmpty(false);
            this.updateShowMore(false, false);
            if (replace) {
                this.toggleLoader(true);
            } else {
                this.updateShowMore(true, true);
            }
            try {
                this.ajax.send({
                    endpoint: this.endpoint["customer"]["rep-lookup"],
                    method: "POST",
                    contentType: "json",
                    data: {
                        searchTerm: this.getSearchValue(),
                        searchByRepId: this.selectedMode === "repId",
                        after: replace ? null : this.endCursor
                    },
                    callback: function(res) {
                        return _this.handleFetchResponse(res.response, requestId, replace);
                    }
                });
            } catch (_a) {
                this.finishLoading();
                this.showError(this.t("repLookupErrorLoad", "Unable to load representatives."));
            }
        };
        StRepLookup.prototype.handleFetchResponse = function(responseText, requestId, replace) {
            var _a, _b, _c;
            if (requestId !== this.requestId) return;
            this.finishLoading();
            try {
                var response = JSON.parse(responseText);
                var status_1 = (_a = response.status) !== null && _a !== void 0 ? _a : response.statusCode;
                if (status_1 !== 200) {
                    this.showError(response.message || this.t("repLookupErrorGeneric", "Something went wrong while loading representatives."));
                    return;
                }
                var items = ((_b = response.data) === null || _b === void 0 ? void 0 : _b.items) || [];
                var pageInfo = ((_c = response.data) === null || _c === void 0 ? void 0 : _c.pageInfo) || {
                    hasNextPage: false,
                    endCursor: null
                };
                this.results = replace ? items : __spreadArray(__spreadArray([], this.results, true), items, true);
                this.hasNextPage = Boolean(pageInfo.hasNextPage);
                this.endCursor = pageInfo.endCursor || null;
                this.renderResults();
            } catch (_d) {
                this.showError(this.t("repLookupErrorParse", "Unable to parse response."));
            }
        };
        StRepLookup.prototype.finishLoading = function() {
            this.isLoading = false;
            this.toggleLoader(false);
            this.updateShowMore(this.hasNextPage, false);
        };
        StRepLookup.prototype.renderResults = function() {
            var _this = this;
            var wrapper = this.getElement(".st_rep_lookup_results_wrapper_JS");
            var list = this.getElement(".st_rep_lookup_results_JS");
            if (!wrapper || !list) return;
            list.innerHTML = "";
            if (!this.results.length) {
                wrapper.classList.add("st_hidden");
                this.toggleEmpty(true, true);
                this.updateShowMore(false, false);
                return;
            }
            wrapper.classList.remove("st_hidden");
            this.toggleEmpty(false);
            list.appendChild(this.createSummaryBar());
            this.results.forEach(function(item) {
                return list.appendChild(_this.createCard(item));
            });
            this.updateShowMore(this.hasNextPage, false);
        };
        StRepLookup.prototype.createSummaryBar = function() {
            var summary = document.createElement("div");
            var count = this.results.length;
            summary.className = "rep-lookup-results__summary";
            summary.textContent = count === 1 ? this.t("repLookupFoundOne", "Found {count} consultant").replace("{count}", String(count)) : this.t("repLookupFoundMany", "Found {count} consultants").replace("{count}", String(count));
            return summary;
        };
        StRepLookup.prototype.createCard = function(item) {
            var card = document.createElement("div");
            var fullName = this.getFullName(item);
            var location = this.buildLocation(item);
            card.className = "rep-lookup-card st_rep_lookup_card_select_JS";
            card.setAttribute("role", "button");
            card.setAttribute("tabindex", "0");
            card.dataset.repId = item.repId || "";
            card.dataset.webAlias = item.webAlias || item.repId || "";
            card.dataset.firstName = item.firstName || "";
            card.dataset.lastName = item.lastName || "";
            card.dataset.fullName = fullName;
            card.dataset.photoUrl = item.photoUrl || "";
            card.dataset.email = item.email || "";
            card.innerHTML = '\n            <div class="rep-lookup-card__info">\n                <div class="rep-lookup-card__avatar">\n                    '.concat(this.buildAvatarHtml(item.photoUrl, fullName), '\n                </div>\n\n                <div class="rep-lookup-card__content">\n                    <span class="rep-lookup-card__name">').concat(this.escapeHtml(fullName), '</span>\n\n                    <div class="rep-lookup-card__meta-row">\n                        ').concat(item.repId ? '\n                            <div class="rep-lookup-card__repid">\n                                <span class="rep-lookup-card__meta-icon">'.concat(USER_ICON, "</span>\n                                <span>").concat(this.formatRepId(item.repId), "</span>\n                            </div>\n                        ") : "", "\n\n                        ").concat(location ? '\n                            <div class="rep-lookup-card__meta">\n                                <span class="rep-lookup-card__meta-icon">'.concat(LOCATION_ICON, "</span>\n                                <span>").concat(this.escapeHtml(location), "</span>\n                            </div>\n                        ") : "", "\n                    </div>\n                </div>\n            </div>\n        ");
            return card;
        };
        StRepLookup.prototype.selectRepresentative = function(element) {
            var _this = this;
            var repId = (element.dataset.repId || "").trim();
            var email = (element.dataset.email || "").trim();
            if (!repId) return;
            var representative = {
                repId: repId,
                webAlias: (element.dataset.webAlias || repId).trim(),
                firstName: (element.dataset.firstName || "").trim(),
                lastName: (element.dataset.lastName || "").trim(),
                fullName: (element.dataset.fullName || "".concat(element.dataset.firstName || "", " ").concat(element.dataset.lastName || "")).trim(),
                photoUrl: (element.dataset.photoUrl || "").trim()
            };
            this.representative = representative;
            this.renderRepresentative();
            this.webAliasExtended.applyRepresentativeSelection({
                repId: representative.repId,
                firstName: representative.firstName,
                lastName: representative.lastName,
                webAlias: representative.webAlias || representative.repId,
                email: email
            });
            this.updateLineItemSponsorWebAlias(representative.webAlias || representative.repId).then(function() {
                window.dispatchEvent(new CustomEvent("sponsorChange"));
                _this.refreshUI();
            }).catch(function(error) {
                console.warn("[RepLookup] Unable to update line item sponsor alias", error);
            });
            this.closeModal();
        };
        StRepLookup.prototype.updateLineItemSponsorWebAlias = function(sponsorWebAlias) {
            var _a;
            return __awaiter(this, void 0, void 0, function() {
                var cartResponse, cart, _i, _b, item, currentProperties;
                return __generator(this, function(_c) {
                    switch (_c.label) {
                      case 0:
                        if (!sponsorWebAlias) return [ 2 ];
                        return [ 4, fetch("/cart.js", {
                            method: "GET",
                            headers: {
                                Accept: "application/json"
                            }
                        }) ];

                      case 1:
                        cartResponse = _c.sent();
                        if (!cartResponse.ok) {
                            throw new Error("Unable to fetch cart");
                        }
                        return [ 4, cartResponse.json() ];

                      case 2:
                        cart = _c.sent();
                        if (!((_a = cart.items) === null || _a === void 0 ? void 0 : _a.length)) return [ 2 ];
                        _i = 0, _b = cart.items;
                        _c.label = 3;

                      case 3:
                        if (!(_i < _b.length)) return [ 3, 6 ];
                        item = _b[_i];
                        currentProperties = item.properties || {};
                        if (currentProperties._sponsorWebAlias === sponsorWebAlias) {
                            return [ 3, 5 ];
                        }
                        return [ 4, fetch("/cart/change.js", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                Accept: "application/json"
                            },
                            body: JSON.stringify({
                                id: item.key,
                                quantity: item.quantity,
                                properties: __assign(__assign({}, currentProperties), {
                                    _sponsorWebAlias: sponsorWebAlias
                                })
                            })
                        }) ];

                      case 4:
                        _c.sent();
                        _c.label = 5;

                      case 5:
                        _i++;
                        return [ 3, 3 ];

                      case 6:
                        return [ 2 ];
                    }
                });
            });
        };
        StRepLookup.prototype.syncRepresentative = function() {
            var firstName = "";
            var lastName = "";
            var photoUrl = "";
            var repId = "";
            var webAlias = "";
            try {
                firstName = (localStorage.getItem("firstName") || "").trim();
                lastName = (localStorage.getItem("lastName") || "").trim();
                photoUrl = (localStorage.getItem("imageUrl") || "").trim();
                repId = (localStorage.getItem("repId") || "").trim();
                webAlias = (localStorage.getItem("webAlias") || "").trim();
            } catch (error) {
                console.warn("[RepLookup] Unable to read representative from localStorage", error);
            }
            var fullName = "".concat(firstName, " ").concat(lastName).trim();
            if (fullName || repId || webAlias) {
                var currentRep = {
                    firstName: firstName,
                    lastName: lastName,
                    fullName: fullName,
                    photoUrl: photoUrl,
                    repId: repId,
                    webAlias: webAlias
                };
                if (!this.isDefaultBrandRepresentative(currentRep)) {
                    this.representative = currentRep;
                    return;
                }
            }
            this.representative = null;
        };
        StRepLookup.prototype.isDefaultBrandRepresentative = function(rep) {
            if (!rep) return true;
            return (rep.fullName || "").trim().toLowerCase() === this.defaultBrandName.toLowerCase();
        };
        StRepLookup.prototype.renderRepresentative = function() {
            var defaultState = document.querySelector(".st_rep_lookup_default_state_JS");
            var selectedState = document.querySelector(".st_rep_lookup_selected_state_JS");
            var selectedName = document.querySelector(".st_rep_lookup_selected_name_JS");
            var selectedAvatar = document.querySelector(".st_rep_lookup_selected_avatar_JS");
            var selectedInitials = document.querySelector(".st_rep_lookup_selected_initials_JS");
            if (!defaultState || !selectedState || !selectedName || !selectedAvatar || !selectedInitials) {
                return;
            }
            if (!this.representative || this.isDefaultBrandRepresentative(this.representative)) {
                this.resetSelectedAvatar(selectedAvatar, selectedInitials);
                defaultState.classList.remove("st_hidden");
                selectedState.classList.add("st_hidden");
                return;
            }
            selectedName.textContent = this.representative.fullName;
            selectedInitials.textContent = this.getInitials(this.representative.fullName);
            if (this.representative.photoUrl) {
                this.setSelectedAvatar(selectedAvatar, selectedInitials, this.representative.photoUrl, this.representative.fullName);
            } else {
                this.resetSelectedAvatar(selectedAvatar, selectedInitials);
            }
            defaultState.classList.add("st_hidden");
            selectedState.classList.remove("st_hidden");
        };
        StRepLookup.prototype.setSelectedAvatar = function(avatar, initials, photoUrl, fullName) {
            var _this = this;
            if (this.failedAvatarUrls.has(photoUrl)) {
                this.resetSelectedAvatar(avatar, initials);
                return;
            }
            if (avatar.dataset.currentPhotoUrl === photoUrl) {
                avatar.alt = fullName;
                return;
            }
            avatar.onload = function() {
                avatar.classList.remove("st_hidden");
                initials.classList.add("st_hidden");
            };
            avatar.onerror = function() {
                _this.failedAvatarUrls.add(photoUrl);
                _this.resetSelectedAvatar(avatar, initials);
            };
            avatar.dataset.currentPhotoUrl = photoUrl;
            avatar.src = photoUrl;
            avatar.alt = fullName;
        };
        StRepLookup.prototype.resetSelectedAvatar = function(avatar, initials) {
            avatar.onload = null;
            avatar.onerror = null;
            avatar.removeAttribute("src");
            avatar.removeAttribute("data-current-photo-url");
            avatar.alt = "";
            avatar.classList.add("st_hidden");
            initials.classList.remove("st_hidden");
        };
        StRepLookup.prototype.resetResultsState = function() {
            this.results = [];
            this.hasNextPage = false;
            this.endCursor = null;
            this.clearError();
            this.toggleLoader(false);
            this.updateShowMore(false, false);
            this.toggleEmpty(false);
        };
        StRepLookup.prototype.renderInitialState = function() {
            var _a;
            (_a = this.getElement(".st_rep_lookup_results_wrapper_JS")) === null || _a === void 0 ? void 0 : _a.classList.add("st_hidden");
            this.resetResultsState();
            this.toggleEmpty(true, false);
        };
        StRepLookup.prototype.showError = function(message) {
            var _a;
            var error = this.getElement(".st_rep_lookup_error_JS");
            if (!error) return;
            error.textContent = message;
            error.classList.remove("st_hidden");
            (_a = this.getElement(".st_rep_lookup_results_wrapper_JS")) === null || _a === void 0 ? void 0 : _a.classList.add("st_hidden");
            this.toggleEmpty(false);
            this.updateShowMore(false, false);
        };
        StRepLookup.prototype.clearError = function() {
            var error = this.getElement(".st_rep_lookup_error_JS");
            if (!error) return;
            error.textContent = "";
            error.classList.add("st_hidden");
        };
        StRepLookup.prototype.toggleLoader = function(show) {
            var _a;
            (_a = this.getElement(".st_rep_lookup_loader_JS")) === null || _a === void 0 ? void 0 : _a.classList.toggle("st_hidden", !show);
        };
        StRepLookup.prototype.updateShowMore = function(show, loading) {
            var button = this.getElement(".st_rep_lookup_show_more_JS");
            var footer = this.getElement(".rep-lookup-results__footer");
            if (!button) return;
            footer === null || footer === void 0 ? void 0 : footer.classList.toggle("st_hidden", !show);
            button.classList.toggle("st_hidden", !show);
            if (!button.dataset.defaultText) {
                button.dataset.defaultText = this.t("repLookupViewMore", "View More");
            }
            button.classList.toggle("is-loading", loading);
            button.disabled = loading;
            button.textContent = loading ? this.t("repLookupLoadingMore", "Loading more") : button.dataset.defaultText;
        };
        StRepLookup.prototype.toggleEmpty = function(show, isNoResults) {
            if (isNoResults === void 0) {
                isNoResults = false;
            }
            var empty = this.getElement(".st_rep_lookup_empty_JS");
            var title = empty === null || empty === void 0 ? void 0 : empty.querySelector(".st-rep-lookup-empty-state__title");
            var text = empty === null || empty === void 0 ? void 0 : empty.querySelector(".st-rep-lookup-empty-state__text");
            if (!empty) return;
            empty.classList.toggle("st_hidden", !show);
            if (show && title && text) {
                title.textContent = isNoResults ? this.t("repLookupNoResultsTitle", "No Results Found") : this.t("repLookupSearchResultsTitle", "Search Results");
                text.textContent = isNoResults ? this.t("repLookupNoResultsText", "Try a different search option or value.") : this.t("repLookupSearchResultsText", "Results will appear here.");
            }
        };
        StRepLookup.prototype.getInput = function() {
            return this.getElement(".st_rep_lookup_single_input_JS");
        };
        StRepLookup.prototype.getSearchValue = function() {
            var _a;
            return ((_a = this.getInput()) === null || _a === void 0 ? void 0 : _a.value.trim()) || "";
        };
        StRepLookup.prototype.clearInput = function() {
            var input = this.getInput();
            if (input) input.value = "";
        };
        StRepLookup.prototype.updateSearchModeUI = function() {
            var _this = this;
            this.getElements(".st_rep_lookup_mode_JS").forEach(function(button) {
                var isActive = button.dataset.value === _this.selectedMode;
                button.classList.toggle("is-active", isActive);
                button.setAttribute("aria-pressed", String(isActive));
            });
            var input = this.getInput();
            if (!input) return;
            input.placeholder = this.selectedMode === "name" ? this.t("repLookupSearchPlaceholderName", "Search by Name/ID") : this.t("repLookupSearchPlaceholderId", "Search by BDT ID");
            input.setAttribute("inputmode", this.selectedMode === "repId" ? "numeric" : "text");
        };
        StRepLookup.prototype.getModalElement = function() {
            return document.body.querySelector(".st_rep_lookup_modal_JS") || document.querySelector(".st_rep_lookup_modal_JS");
        };
        StRepLookup.prototype.syncModalWithBody = function(keepOpenState) {
            var modals = Array.from(document.querySelectorAll(".st_rep_lookup_modal_JS"));
            if (!modals.length) return null;
            var latest = modals[modals.length - 1];
            var wasOpen = !latest.classList.contains("st_hidden");
            modals.forEach(function(node, index) {
                if (index !== modals.length - 1) node.remove();
            });
            if (latest.parentElement !== document.body) {
                document.body.appendChild(latest);
            }
            if (keepOpenState && wasOpen) {
                latest.classList.remove("st_hidden");
            }
            return latest;
        };
        StRepLookup.prototype.getElement = function(selector) {
            var modal = this.getModalElement();
            return (modal === null || modal === void 0 ? void 0 : modal.querySelector(selector)) || document.querySelector(selector);
        };
        StRepLookup.prototype.getElements = function(selector) {
            var modal = this.getModalElement();
            return Array.from((modal === null || modal === void 0 ? void 0 : modal.querySelectorAll(selector)) || document.querySelectorAll(selector));
        };
        StRepLookup.prototype.getFullName = function(item) {
            return item.fullName || "".concat(item.firstName || "", " ").concat(item.lastName || "").trim();
        };
        StRepLookup.prototype.buildAvatarHtml = function(photoUrl, fullName) {
            if (photoUrl) {
                return '<img src="'.concat(this.escapeAttribute(photoUrl), '" alt="').concat(this.escapeAttribute(fullName), '">');
            }
            return '<div class="rep-lookup-card__avatar-fallback" aria-hidden="true">'.concat(this.escapeHtml(this.getInitials(fullName)), "</div>");
        };
        StRepLookup.prototype.buildLocation = function(item) {
            return [ item.city, item.stateOrProvince ].filter(Boolean).join(", ");
        };
        StRepLookup.prototype.formatRepId = function(repId) {
            var value = String(repId || "").trim();
            if (!value) return "";
            var prefix = this.t("repLookupRepIdPrefix", "BDT-");
            return value.toUpperCase().startsWith(prefix.toUpperCase()) ? value : "".concat(prefix).concat(value);
        };
        StRepLookup.prototype.getInitials = function(name) {
            var value = (name || "").trim();
            if (!value) return "R";
            return value.split(" ").filter(Boolean).slice(0, 2).map(function(part) {
                return part.charAt(0).toUpperCase();
            }).join("");
        };
        StRepLookup.prototype.escapeHtml = function(value) {
            var div = document.createElement("div");
            div.textContent = value || "";
            return div.innerHTML;
        };
        StRepLookup.prototype.escapeAttribute = function(value) {
            return this.escapeHtml(value).replace(/"/g, "&quot;");
        };
        StRepLookup.prototype.removeDuplicateCartLookupBlocks = function() {
            var containers = [ document.querySelector("#CartDrawer"), document.querySelector("#main-cart-items") ].filter(Boolean);
            containers.forEach(function(container) {
                var lookupBlocks = Array.from(container.querySelectorAll(".st_rep_lookup_cart_JS"));
                if (lookupBlocks.length <= 1) {
                    return;
                }
                lookupBlocks.forEach(function(block, index) {
                    if (index > 0) {
                        block.remove();
                    }
                });
            });
        };
        return StRepLookup;
    }(st_module_90.StModule);
    exports.StRepLookup = StRepLookup;
});

define("extension/shopify-app/st-modules/product/product", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_91) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StProduct = void 0;
    var StProduct = function(_super) {
        __extends(StProduct, _super);
        function StProduct() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StProduct";
            _this.syncTimeout = null;
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this._syncInCartBadges();
                    _this._watchCartRequests();
                    _this._watchCartForms();
                });
            };
            _this._watchCartForms = function() {
                document.addEventListener("submit", function(event) {
                    var form = event.target;
                    if (!form || !form.matches('form[action*="/cart/add"]')) {
                        return;
                    }
                    _this._scheduleSync();
                });
            };
            _this._watchCartRequests = function() {
                var originalFetch = window.fetch;
                window.fetch = function() {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    return __awaiter(_this, void 0, void 0, function() {
                        var response, requestUrl;
                        return __generator(this, function(_a) {
                            switch (_a.label) {
                              case 0:
                                return [ 4, originalFetch.apply(void 0, args) ];

                              case 1:
                                response = _a.sent();
                                requestUrl = this._getFetchUrl(args[0]);
                                if (this._isCartMutationUrl(requestUrl)) {
                                    this._scheduleSync();
                                }
                                return [ 2, response ];
                            }
                        });
                    });
                };
            };
            _this._getFetchUrl = function(input) {
                if (typeof input === "string") {
                    return input;
                }
                if (input instanceof URL) {
                    return input.pathname;
                }
                return input.url;
            };
            _this._isCartMutationUrl = function(url) {
                return url.includes("/cart/add") || url.includes("/cart/change") || url.includes("/cart/update") || url.includes("/cart/clear");
            };
            _this._scheduleSync = function() {
                if (_this.syncTimeout) {
                    window.clearTimeout(_this.syncTimeout);
                }
                _this.syncTimeout = window.setTimeout(function() {
                    _this._syncInCartBadges();
                }, 600);
            };
            _this._syncInCartBadges = function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var response, cart_2, error_13;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            _a.trys.push([ 0, 3, , 4 ]);
                            return [ 4, fetch("/cart.js") ];

                          case 1:
                            response = _a.sent();
                            return [ 4, response.json() ];

                          case 2:
                            cart_2 = _a.sent();
                            document.querySelectorAll(".card__container").forEach(function(card) {
                                var form = card.querySelector('form[action*="/cart/add"]');
                                var badge = card.querySelector(".lbri-card-added-toast_JS");
                                if (!form || !badge) {
                                    return;
                                }
                                var input = form.querySelector('input[name="id"]');
                                var variantId = Number(input === null || input === void 0 ? void 0 : input.value);
                                if (!variantId) {
                                    badge.hidden = true;
                                    badge.textContent = "";
                                    return;
                                }
                                var cartItem = cart_2.items.find(function(item) {
                                    return item.variant_id === variantId;
                                });
                                if (!cartItem || cartItem.quantity <= 0) {
                                    badge.hidden = true;
                                    badge.textContent = "";
                                    return;
                                }
                                badge.hidden = false;
                                badge.textContent = "".concat(cartItem.quantity, " in cart");
                            });
                            return [ 3, 4 ];

                          case 3:
                            error_13 = _a.sent();
                            console.error("[StProduct] Failed to sync in-cart badges", error_13);
                            return [ 3, 4 ];

                          case 4:
                            return [ 2 ];
                        }
                    });
                });
            };
            return _this;
        }
        return StProduct;
    }(st_module_91.StModule);
    exports.StProduct = StProduct;
});

define("extension/shopify-app/st-modules/bundle-builder/bundle-builder", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_92, _features_config_21) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StBundleBuilder = void 0;
    var STEP_KEYS = [ "trios", "eyeProducts", "exfoliators", "serums" ];
    var ADD_ON_STEP_KEYS = [ "eyeProducts", "exfoliators" ];
    var SELECTION_ANIMATION_DURATION = 360;
    var DEFAULT_DISCOUNTS = {
        trioEyeAmount: 5,
        trioExfoliatorAmount: 5,
        trioEyeExfoliatorAmount: 15,
        serumPercent: 50
    };
    var STEPS = [ {
        key: "trios",
        titleKey: "bundleBuilderStepTrioTitle",
        title: "Select your TRIO",
        descriptionKey: "bundleBuilderStepTrioDescription",
        description: "Select one of our six TRIO collections to start building your routine",
        required: true
    }, {
        key: "eyeProducts",
        titleKey: "bundleBuilderStepEyeTitle",
        title: "Select your eye product",
        descriptionKey: "bundleBuilderStepAddOnDescription",
        description: "Add an Eye Product or Exfoliator to unlock $5 off. Add one of each to unlock $15 off.",
        required: false
    }, {
        key: "exfoliators",
        titleKey: "bundleBuilderStepExfoliatorTitle",
        title: "Select your exfoliator",
        descriptionKey: "bundleBuilderStepAddOnDescription",
        description: "Add an Eye Product or Exfoliator to unlock $5 off. Add one of each to unlock $15 off.",
        required: false
    }, {
        key: "serums",
        titleKey: "bundleBuilderStepSerumTitle",
        title: "Add your half-priced targeted solution",
        descriptionKey: "bundleBuilderStepSerumDescription",
        description: "Choose one Serum and get {percent}% off as part of your Trio offer.",
        required: false
    } ];
    var isStepKey = function(value) {
        return Boolean(value) && STEP_KEYS.includes(value);
    };
    var StBundleBuilder = function(_super) {
        __extends(StBundleBuilder, _super);
        function StBundleBuilder() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StBundleBuilder";
            _this.root = null;
            _this.config = null;
            _this.currentStep = 0;
            _this.productsBySku = new Map();
            _this.selected = {};
            _this.addingToCart = false;
            _this.animatingSelectionStep = null;
            _this.automaticAdvanceTimer = null;
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    var _a;
                    _this.root = document.querySelector("[data-bundle-builder]");
                    if (!_this.root) {
                        return;
                    }
                    _this.config = _this.readConfig();
                    if (!((_a = _this.config) === null || _a === void 0 ? void 0 : _a.enabled)) {
                        _this.root.hidden = true;
                        return;
                    }
                    _this.bindEvents();
                    _this.loadProducts();
                });
            };
            _this.readConfig = function() {
                var _a;
                var configElement = (_a = _this.root) === null || _a === void 0 ? void 0 : _a.querySelector("[data-bundle-builder-config]");
                if (!(configElement === null || configElement === void 0 ? void 0 : configElement.textContent)) {
                    console.error("[StBundleBuilder] Bundle builder metafield configuration is missing");
                    return null;
                }
                try {
                    return JSON.parse(configElement.textContent);
                } catch (error) {
                    console.error("[StBundleBuilder] Invalid bundle builder metafield JSON", error);
                    return null;
                }
            };
            _this.t = function(key, fallback, replacements) {
                if (replacements === void 0) {
                    replacements = {};
                }
                var translations = window.stTranslations;
                var text = (translations === null || translations === void 0 ? void 0 : translations[key]) || fallback;
                Object.entries(replacements).forEach(function(_a) {
                    var name = _a[0], value = _a[1];
                    text = text.split("{".concat(name, "}")).join(String(value));
                });
                return text;
            };
            _this.forEachElement = function(selector, callback) {
                var _a;
                (_a = _this.root) === null || _a === void 0 ? void 0 : _a.querySelectorAll(selector).forEach(callback);
            };
            _this.bindEvents = function() {
                var _a;
                (_a = _this.root) === null || _a === void 0 ? void 0 : _a.addEventListener("click", function(event) {
                    var target = event.target;
                    if (!target) {
                        return;
                    }
                    var selectButton = target.closest("[data-select-bundle-sku]");
                    if (selectButton && !selectButton.disabled) {
                        _this.selectProduct(selectButton.dataset.selectBundleSku || "");
                        return;
                    }
                    var removeButton = target.closest("[data-remove-bundle-step]");
                    var removeStep = removeButton === null || removeButton === void 0 ? void 0 : removeButton.dataset.removeBundleStep;
                    if (isStepKey(removeStep)) {
                        _this.removeSelection(removeStep);
                        return;
                    }
                    if (target.closest("[data-bundle-clear]")) {
                        _this.clearSelections();
                        return;
                    }
                    if (target.closest("[data-bundle-back]")) {
                        _this.goBack();
                        return;
                    }
                    if (target.closest("[data-bundle-next]")) {
                        _this.goNext();
                        return;
                    }
                    var mobileToggle = target.closest("[data-mobile-routine-toggle]");
                    if (mobileToggle) {
                        _this.toggleMobileRoutine(mobileToggle);
                    }
                });
            };
            _this.getAllConfiguredSkus = function() {
                var config = _this.config;
                if (!config) {
                    return [];
                }
                var skus = [];
                STEP_KEYS.forEach(function(key) {
                    skus.push.apply(skus, config[key]);
                });
                return Array.from(new Set(skus.map(function(sku) {
                    return String(sku).trim();
                }).filter(Boolean)));
            };
            _this.loadProducts = function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var skus, storefrontToken, variableDefinitions, productQueries, query, variables, response, payload_3, error_14;
                    var _this = this;
                    var _a;
                    return __generator(this, function(_b) {
                        switch (_b.label) {
                          case 0:
                            skus = this.getAllConfiguredSkus();
                            if (!skus.length) {
                                this.finishLoading();
                                return [ 2 ];
                            }
                            storefrontToken = window.storefrontKey;
                            if (!storefrontToken) {
                                this.showStatus(this.t("bundleBuilderErrorStorefrontConfig", "Bundle products could not be loaded. Storefront access is not configured."), true);
                                this.finishLoading();
                                return [ 2 ];
                            }
                            variableDefinitions = skus.map(function(_, index) {
                                return "$query".concat(index, ": String!");
                            }).join(", ");
                            productQueries = skus.map(function(_, index) {
                                return "\n            search".concat(index, ": predictiveSearch(\n                query: $query").concat(index, "\n                limit: 10\n                types: [PRODUCT]\n                searchableFields: [VARIANTS_SKU]\n            ) {\n                products {\n                    title\n                    handle\n                    featuredImage {\n                        url\n                        altText\n                    }\n                    variants(first: 50) {\n                        nodes {\n                            id\n                            sku\n                            availableForSale\n                            price {\n                                amount\n                            }\n                            compareAtPrice {\n                                amount\n                            }\n                            image {\n                                url\n                                altText\n                            }\n                        }\n                    }\n                }\n            }\n        ");
                            }).join("\n");
                            query = "\n            query BundleBuilderProducts(".concat(variableDefinitions, ") {\n                ").concat(productQueries, "\n            }\n        ");
                            variables = skus.reduce(function(result, sku, index) {
                                result["query".concat(index)] = sku;
                                return result;
                            }, {});
                            _b.label = 1;

                          case 1:
                            _b.trys.push([ 1, 4, 5, 6 ]);
                            return [ 4, fetch("/api/".concat(_features_config_21.STORE_FRONT_API_VERSION, "/graphql.json"), {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    "X-Shopify-Storefront-Access-Token": storefrontToken
                                },
                                body: JSON.stringify({
                                    query: query,
                                    variables: variables
                                })
                            }) ];

                          case 2:
                            response = _b.sent();
                            if (!response.ok) {
                                throw new Error("Storefront API responded with ".concat(response.status));
                            }
                            return [ 4, response.json() ];

                          case 3:
                            payload_3 = _b.sent();
                            if ((_a = payload_3 === null || payload_3 === void 0 ? void 0 : payload_3.errors) === null || _a === void 0 ? void 0 : _a.length) {
                                throw new Error(payload_3.errors.map(function(_a) {
                                    var message = _a.message;
                                    return message;
                                }).join(", "));
                            }
                            skus.forEach(function(sku, index) {
                                var _a, _b, _c;
                                var product = _this.toBundleProduct((_c = (_b = (_a = payload_3.data) === null || _a === void 0 ? void 0 : _a["search".concat(index)]) === null || _b === void 0 ? void 0 : _b.products) !== null && _c !== void 0 ? _c : [], sku);
                                if (product) _this.productsBySku.set(sku, product);
                            });
                            return [ 3, 6 ];

                          case 4:
                            error_14 = _b.sent();
                            console.error("[StBundleBuilder] Failed to load bundle products", error_14);
                            this.showStatus(this.t("bundleBuilderErrorLoadProducts", "Bundle products could not be loaded. Please refresh the page and try again."), true);
                            return [ 3, 6 ];

                          case 5:
                            this.finishLoading();
                            return [ 7 ];

                          case 6:
                            return [ 2 ];
                        }
                    });
                });
            };
            _this.toBundleProduct = function(products, sku) {
                var _a, _b, _c;
                var normalizedSku = sku.toLowerCase();
                var storefrontProduct = products.find(function(_a) {
                    var variants = _a.variants;
                    return variants.nodes.some(function(variant) {
                        var _a;
                        return String((_a = variant.sku) !== null && _a !== void 0 ? _a : "").toLowerCase() === normalizedSku;
                    });
                });
                var variant = storefrontProduct === null || storefrontProduct === void 0 ? void 0 : storefrontProduct.variants.nodes.find(function(node) {
                    var _a;
                    return String((_a = node.sku) !== null && _a !== void 0 ? _a : "").toLowerCase() === normalizedSku;
                });
                if (!storefrontProduct || !(variant === null || variant === void 0 ? void 0 : variant.availableForSale)) return null;
                var price = Number.parseFloat(variant.price.amount);
                if (!Number.isFinite(price)) return null;
                var rawComparePrice = (_a = variant.compareAtPrice) === null || _a === void 0 ? void 0 : _a.amount;
                var compareAtPrice = rawComparePrice ? Number.parseFloat(rawComparePrice) : null;
                var image = (_b = variant.image) !== null && _b !== void 0 ? _b : storefrontProduct.featuredImage;
                return {
                    sku: sku,
                    variantId: _this.getLegacyId(variant.id),
                    title: storefrontProduct.title,
                    handle: storefrontProduct.handle,
                    imageUrl: (_c = image === null || image === void 0 ? void 0 : image.url) !== null && _c !== void 0 ? _c : "",
                    imageAlt: (image === null || image === void 0 ? void 0 : image.altText) || storefrontProduct.title,
                    price: price,
                    compareAtPrice: compareAtPrice !== null && Number.isFinite(compareAtPrice) ? compareAtPrice : null
                };
            };
            _this.getLegacyId = function(gid) {
                return String(gid || "").split("/").pop() || "";
            };
            _this.finishLoading = function() {
                var _a, _b;
                (_b = (_a = _this.root) === null || _a === void 0 ? void 0 : _a.querySelector("[data-bundle-loading]")) === null || _b === void 0 ? void 0 : _b.setAttribute("hidden", "");
                _this.render();
            };
            _this.render = function() {
                _this.renderStep();
                _this.renderRoutine();
                _this.renderProgress();
                _this.renderTotals();
                _this.renderNavigation();
            };
            _this.renderStep = function() {
                if (!_this.root || !_this.config) {
                    return;
                }
                var step = STEPS[_this.currentStep];
                var title = _this.root.querySelector("[data-bundle-step-title]");
                var description = _this.root.querySelector("[data-bundle-step-description]");
                var required = _this.root.querySelector("[data-bundle-required]");
                var grid = _this.root.querySelector("[data-bundle-product-grid]");
                var empty = _this.root.querySelector("[data-bundle-empty]");
                if (title) title.textContent = _this.t(step.titleKey, step.title);
                if (description) description.textContent = _this.getStepDescription(step);
                if (required) required.hidden = !step.required;
                if (!grid || !empty) {
                    return;
                }
                var products = _this.config[step.key].map(function(sku) {
                    return _this.productsBySku.get(String(sku));
                }).filter(function(product) {
                    return Boolean(product);
                });
                var currentSelection = _this.selected[step.key];
                grid.innerHTML = products.map(function(product) {
                    var isSelected = (currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.sku) === product.sku;
                    var isLocked = Boolean(currentSelection && !isSelected);
                    var isSelectionEntering = isSelected && _this.animatingSelectionStep === step.key;
                    return '\n                <article class="bundle-builder__product-card'.concat(isSelected ? " is-selected" : "").concat(isLocked ? " is-locked" : "").concat(isSelectionEntering ? " is-selection-entering" : "", '">\n                    <a class="bundle-builder__product-image-wrap" href="/products/').concat(_this.escapeHtml(product.handle), '" tabindex="-1">\n                        ').concat(product.imageUrl ? '\n                            <img\n                                class="bundle-builder__product-image"\n                                src="'.concat(_this.escapeHtml(product.imageUrl), '"\n                                alt="').concat(_this.escapeHtml(product.imageAlt), '"\n                                loading="lazy"\n                            >\n                        ') : "", '\n                    </a>\n                    <h3 class="bundle-builder__product-title">').concat(_this.escapeHtml(product.title), '</h3>\n                    <div class="bundle-builder__product-price">\n                        ').concat(_this.renderProductPrice(product), '\n                    </div>\n                    <button\n                        type="button"\n                        class="bundle-builder__product-button"\n                        data-select-bundle-sku="').concat(_this.escapeHtml(product.sku), '"\n                        ').concat(currentSelection ? "disabled" : "", "\n                    >\n                        ").concat(_this.escapeHtml(isSelected ? _this.t("bundleBuilderProductInRoutine", "IN YOUR ROUTINE") : _this.t("bundleBuilderAddToRoutine", "ADD TO ROUTINE")), "\n                    </button>\n                </article>\n            ");
                }).join("");
                grid.hidden = products.length === 0;
                empty.hidden = products.length > 0;
            };
            _this.renderProductPrice = function(product) {
                if (_this.isDiscountedSerum(product) || _this.isDiscountedTrio(product)) {
                    return "\n                <s>".concat(_this.formatMoney(product.price), "</s>\n                <strong>").concat(_this.formatMoney(_this.getPreviewProductPrice(product)), "</strong>\n            ");
                }
                var compareAtPrice = product.compareAtPrice;
                var hasComparePrice = compareAtPrice !== null && compareAtPrice > product.price;
                return "\n            ".concat(hasComparePrice ? "<s>".concat(_this.formatMoney(compareAtPrice), "</s>") : "", "\n            <strong>").concat(_this.formatMoney(product.price), "</strong>\n        ");
            };
            _this.isDiscountedSerum = function(product) {
                if (!_this.config || !_this.isSerumUnlocked()) {
                    return false;
                }
                var serumDiscountPercent = Number(_this.discounts.serumPercent || 0);
                return serumDiscountPercent > 0 && _this.config.serums.some(function(sku) {
                    return String(sku) === String(product.sku);
                });
            };
            _this.isDiscountedTrio = function(product) {
                var _a;
                return Boolean(((_a = _this.selected.trios) === null || _a === void 0 ? void 0 : _a.sku) === product.sku && _this.getFixedBundleDiscount() > 0);
            };
            _this.getPreviewProductPrice = function(product) {
                var serumPercent = _this.isDiscountedSerum(product) ? Math.min(100, Math.max(0, Number(_this.discounts.serumPercent || 0))) : 0;
                var fixedDiscount = _this.isDiscountedTrio(product) ? _this.getFixedBundleDiscount() : 0;
                return Math.max(0, product.price * (1 - serumPercent / 100) - fixedDiscount);
            };
            _this.getStepDescription = function(step) {
                return _this.t(step.descriptionKey, step.description, {
                    percent: _this.discounts.serumPercent
                });
            };
            _this.selectProduct = function(sku) {
                var step = STEPS[_this.currentStep];
                var product = _this.productsBySku.get(sku);
                if (!step || !product || _this.selected[step.key] || step.key === "serums" && !_this.isSerumUnlocked()) {
                    return;
                }
                _this.cancelAutomaticAdvance();
                var selectedStepIndex = _this.currentStep;
                var routineRowIndex = _this.getRoutineRowIndexForSelection(step.key);
                var routineSnapshots = _this.captureRoutineRowSnapshots(routineRowIndex);
                _this.animatingSelectionStep = step.key;
                _this.selected[step.key] = product;
                _this.clearStatus();
                _this.render();
                _this.animateRoutineRowSelection(routineRowIndex, routineSnapshots);
                _this.animatingSelectionStep = null;
                _this.scheduleAutomaticAdvance(selectedStepIndex, step.key, product.sku);
            };
            _this.scheduleAutomaticAdvance = function(selectedStepIndex, stepKey, selectedSku) {
                var nextStep = STEPS[selectedStepIndex + 1];
                if (!nextStep || nextStep.key === "serums" && !_this.isSerumUnlocked()) {
                    return;
                }
                var delay = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : SELECTION_ANIMATION_DURATION;
                _this.automaticAdvanceTimer = window.setTimeout(function() {
                    var _a;
                    _this.automaticAdvanceTimer = null;
                    if (_this.addingToCart || _this.currentStep !== selectedStepIndex || ((_a = _this.selected[stepKey]) === null || _a === void 0 ? void 0 : _a.sku) !== selectedSku) {
                        return;
                    }
                    _this.changeStep(selectedStepIndex + 1);
                }, delay);
            };
            _this.cancelAutomaticAdvance = function() {
                if (_this.automaticAdvanceTimer === null) {
                    return;
                }
                window.clearTimeout(_this.automaticAdvanceTimer);
                _this.automaticAdvanceTimer = null;
            };
            _this.removeSelection = function(stepKey) {
                var _a, _b;
                _this.cancelAutomaticAdvance();
                if (stepKey === "trios") {
                    _this.selected = {};
                    _this.currentStep = 0;
                } else {
                    delete _this.selected[stepKey];
                    if (stepKey === "eyeProducts" || stepKey === "exfoliators") {
                        delete _this.selected.serums;
                        if (((_a = STEPS[_this.currentStep]) === null || _a === void 0 ? void 0 : _a.key) === "serums") {
                            _this.currentStep = STEPS.findIndex(function(step) {
                                return step.key === stepKey;
                            });
                        }
                    }
                }
                _this.changeStep(_this.currentStep, stepKey === "trios" || ((_b = STEPS[_this.currentStep]) === null || _b === void 0 ? void 0 : _b.key) === stepKey);
            };
            _this.clearSelections = function() {
                _this.cancelAutomaticAdvance();
                _this.selected = {};
                _this.changeStep(0, false);
            };
            _this.goBack = function() {
                if (_this.currentStep <= 0 || _this.addingToCart) {
                    return;
                }
                _this.cancelAutomaticAdvance();
                _this.changeStep(_this.currentStep - 1);
            };
            _this.goNext = function() {
                if (_this.addingToCart) {
                    return;
                }
                _this.cancelAutomaticAdvance();
                if (_this.currentStep === 0 && !_this.selected.trios) {
                    _this.showStatus(_this.t("bundleBuilderErrorSelectTrio", "Please select a TRIO to continue."), true);
                    return;
                }
                var nextStep = STEPS[_this.currentStep + 1];
                if ((nextStep === null || nextStep === void 0 ? void 0 : nextStep.key) === "serums" && !_this.isSerumUnlocked()) {
                    _this.addBundleToCart();
                    return;
                }
                if (_this.currentStep < STEPS.length - 1) {
                    _this.changeStep(_this.currentStep + 1);
                    return;
                }
                _this.addBundleToCart();
            };
            _this.changeStep = function(stepIndex, shouldScroll) {
                if (shouldScroll === void 0) {
                    shouldScroll = true;
                }
                _this.currentStep = stepIndex;
                _this.clearStatus();
                _this.render();
                if (shouldScroll) _this.scrollToBuilderContent();
            };
            _this.scrollToBuilderContent = function() {
                var _a, _b;
                if (!window.matchMedia("(max-width: 749px)").matches) {
                    return;
                }
                (_b = (_a = _this.root) === null || _a === void 0 ? void 0 : _a.querySelector(".bundle-builder__mobile-progress")) === null || _b === void 0 ? void 0 : _b.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            };
            _this.getRoutinePlaceholders = function() {
                var discounts = _this.discounts;
                return {
                    trios: {
                        title: _this.t("bundleBuilderPlaceholderTrioTitle", "Add Trio"),
                        description: _this.t("bundleBuilderPlaceholderTrioDescription", "A Trio is required to qualify for this promotion."),
                        action: _this.t("bundleBuilderRequired", "Required")
                    },
                    eyeProducts: {
                        title: _this.t("bundleBuilderPlaceholderAddOnTitle", "Trio + one add-on"),
                        description: _this.t("bundleBuilderPlaceholderAddOnDescription", "Add an eye product or exfoliator"),
                        action: _this.t("bundleBuilderUnlockAmountOff", "Unlock {amount} off", {
                            amount: "$".concat(discounts.trioEyeAmount)
                        })
                    },
                    exfoliators: {
                        title: _this.t("bundleBuilderPlaceholderBothTitle", "+ Eye & exfoliator"),
                        description: _this.t("bundleBuilderPlaceholderBothDescription", "Add both add-ons"),
                        action: _this.t("bundleBuilderUnlockAmountOff", "Unlock {amount} off", {
                            amount: "$".concat(discounts.trioEyeExfoliatorAmount)
                        })
                    },
                    serums: {
                        title: _this.t("bundleBuilderPlaceholderSerumTitle", "Add a targeted solution"),
                        description: _this.t("bundleBuilderPlaceholderSerumDescription", "Fill both add-ons first"),
                        action: _this.isSerumUnlocked() ? _this.t("bundleBuilderOfferUnlocked", "Offer unlocked!") : _this.t("bundleBuilderUnlockPercentOff", "Unlock {percent}% off", {
                            percent: discounts.serumPercent
                        })
                    }
                };
            };
            _this.renderRoutine = function() {
                var routineHtml = _this.getRoutineHtml();
                _this.forEachElement("[data-bundle-routine-items], [data-mobile-routine-items]", function(items) {
                    return items.innerHTML = routineHtml;
                });
            };
            _this.getRoutineRowIndexForSelection = function(stepKey) {
                if (stepKey === "trios") return 0;
                if (stepKey === "serums") return 3;
                if (stepKey === "eyeProducts") return 1;
                return _this.selected.eyeProducts ? 2 : 1;
            };
            _this.captureRoutineRowSnapshots = function(rowIndex) {
                if (!_this.root || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
                    return [];
                }
                var snapshots = [];
                _this.root.querySelectorAll("[data-bundle-routine-items], [data-mobile-routine-items]").forEach(function(container) {
                    if (container.getClientRects().length === 0) {
                        return;
                    }
                    var row = container.children.item(rowIndex);
                    if (!row) {
                        return;
                    }
                    snapshots.push({
                        container: container,
                        clone: row.cloneNode(true),
                        top: row.offsetTop,
                        left: row.offsetLeft,
                        width: row.offsetWidth,
                        height: row.offsetHeight
                    });
                });
                return snapshots;
            };
            _this.animateRoutineRowSelection = function(rowIndex, snapshots) {
                snapshots.forEach(function(snapshot) {
                    var newRow = snapshot.container.children.item(rowIndex);
                    if (!newRow) {
                        return;
                    }
                    snapshot.clone.classList.add("bundle-builder__routine-transition-old");
                    snapshot.clone.setAttribute("aria-hidden", "true");
                    snapshot.clone.querySelectorAll("a, button, input, select, textarea, [tabindex]").forEach(function(element) {
                        element.tabIndex = -1;
                    });
                    Object.assign(snapshot.clone.style, {
                        top: "".concat(snapshot.top, "px"),
                        left: "".concat(snapshot.left, "px"),
                        width: "".concat(snapshot.width, "px"),
                        height: "".concat(snapshot.height, "px")
                    });
                    snapshot.container.appendChild(snapshot.clone);
                    window.setTimeout(function() {
                        snapshot.clone.remove();
                        newRow.classList.remove("is-selection-entering");
                    }, SELECTION_ANIMATION_DURATION);
                });
            };
            _this.getSelectedAddOns = function() {
                var selectedAddOns = [];
                ADD_ON_STEP_KEYS.forEach(function(stepKey) {
                    var product = _this.selected[stepKey];
                    if (product) {
                        selectedAddOns.push({
                            stepKey: stepKey,
                            product: product
                        });
                    }
                });
                return selectedAddOns;
            };
            _this.getRoutineHtml = function() {
                var _a, _b, _c, _d;
                var placeholders = _this.getRoutinePlaceholders();
                var selectedAddOns = _this.getSelectedAddOns();
                var rows = [ {
                    stepKey: "trios",
                    placeholderKey: "trios",
                    product: _this.selected.trios
                }, {
                    stepKey: ((_a = selectedAddOns[0]) === null || _a === void 0 ? void 0 : _a.stepKey) || "eyeProducts",
                    placeholderKey: "eyeProducts",
                    product: (_b = selectedAddOns[0]) === null || _b === void 0 ? void 0 : _b.product
                }, {
                    stepKey: ((_c = selectedAddOns[1]) === null || _c === void 0 ? void 0 : _c.stepKey) || "exfoliators",
                    placeholderKey: "exfoliators",
                    product: (_d = selectedAddOns[1]) === null || _d === void 0 ? void 0 : _d.product
                }, {
                    stepKey: "serums",
                    placeholderKey: "serums",
                    product: _this.selected.serums
                } ];
                return rows.map(function(row) {
                    var product = row.product;
                    if (!product) {
                        var placeholder = placeholders[row.placeholderKey];
                        var isMutedSerum = row.placeholderKey === "serums" && !_this.isSerumUnlocked();
                        return '\n                    <div class="bundle-builder__routine-placeholder'.concat(isMutedSerum ? " is-muted" : "", '">\n                        <span class="bundle-builder__placeholder-plus" aria-hidden="true">+</span>\n                        <span class="bundle-builder__placeholder-copy">\n                            <strong>').concat(_this.escapeHtml(placeholder.title), "</strong>\n                            <small>").concat(_this.escapeHtml(placeholder.description), '</small>\n                        </span>\n                        <span class="bundle-builder__placeholder-action">').concat(_this.escapeHtml(placeholder.action), "</span>\n                    </div>\n                ");
                    }
                    var isSelectionEntering = row.stepKey === _this.animatingSelectionStep;
                    return '\n                <div class="bundle-builder__routine-product'.concat(isSelectionEntering ? " is-selection-entering" : "", '">\n                    <span class="bundle-builder__routine-image-wrap">\n                        ').concat(product.imageUrl ? '\n                            <img\n                                class="bundle-builder__routine-image"\n                                src="'.concat(_this.escapeHtml(product.imageUrl), '"\n                                alt=""\n                                loading="lazy"\n                            >\n                        ') : "", '\n                    </span>\n                    <span class="bundle-builder__routine-title">').concat(_this.escapeHtml(product.title), '</span>\n                    <span class="bundle-builder__routine-price">').concat(_this.renderProductPrice(product), '</span>\n                    <button\n                        type="button"\n                        class="bundle-builder__remove"\n                        data-remove-bundle-step="').concat(row.stepKey, '"\n                        aria-label="').concat(_this.escapeHtml(_this.t("bundleBuilderRemoveProductAria", "Remove {product} from your routine", {
                        product: product.title
                    })), '">\n                        <svg\n                            class="bundle-builder__remove-icon"\n                            viewBox="0 0 14 14"\n                            aria-hidden="true"\n                            focusable="false"\n                        >\n                            <path d="M3 3L11 11M11 3L3 11"></path>\n                        </svg>\n                    </button>\n                </div>\n            ');
                }).join("");
            };
            _this.renderProgress = function() {
                var completedLevel = _this.getCompletedLevel();
                var progressLabels = [ _this.t("bundleBuilderProgressStart", "Start"), _this.formatMoney(_this.discounts.trioEyeAmount, 0), _this.formatMoney(_this.discounts.trioEyeExfoliatorAmount, 0), "".concat(_this.discounts.serumPercent, "%") ];
                _this.forEachElement("[data-bundle-progress]", function(progress) {
                    progress.querySelectorAll("[data-progress-step]").forEach(function(step) {
                        var index = Number(step.dataset.progressStep);
                        var isComplete = completedLevel >= 0 && index <= completedLevel;
                        var isCurrent = index === _this.currentStep && !isComplete;
                        var label = step.querySelector(".bundle-builder__progress-label");
                        step.classList.toggle("is-complete", isComplete);
                        step.classList.toggle("is-current", isCurrent);
                        if (label) label.textContent = progressLabels[index] || "";
                    });
                });
            };
            _this.getCompletedLevel = function() {
                if (!_this.selected.trios) return -1;
                var hasEye = Boolean(_this.selected.eyeProducts);
                var hasExfoliator = Boolean(_this.selected.exfoliators);
                return Number(hasEye || hasExfoliator) + Number(hasEye && hasExfoliator) + Number(hasEye && hasExfoliator && Boolean(_this.selected.serums));
            };
            _this.isSerumUnlocked = function() {
                return Boolean(_this.selected.trios && _this.selected.eyeProducts && _this.selected.exfoliators);
            };
            _this.getSelectedProducts = function() {
                return STEPS.map(function(step) {
                    return _this.selected[step.key];
                }).filter(function(product) {
                    return Boolean(product);
                });
            };
            _this.renderTotals = function() {
                if (!_this.config) return;
                var products = _this.getSelectedProducts();
                var compareTotal = products.reduce(function(sum, product) {
                    if (_this.isDiscountedSerum(product)) {
                        return sum + product.price;
                    }
                    var comparePrice = product.compareAtPrice && product.compareAtPrice > product.price ? product.compareAtPrice : product.price;
                    return sum + comparePrice;
                }, 0);
                var previewTotal = products.reduce(function(sum, product) {
                    return sum + _this.getPreviewProductPrice(product);
                }, 0);
                var fixedDiscount = _this.getFixedBundleDiscount();
                var shouldShowCompare = compareTotal > previewTotal;
                _this.forEachElement("[data-bundle-total]", function(element) {
                    element.textContent = _this.formatMoney(previewTotal);
                });
                _this.forEachElement("[data-bundle-compare-total]", function(element) {
                    element.hidden = !shouldShowCompare;
                    element.textContent = shouldShowCompare ? _this.formatMoney(compareTotal) : "";
                });
                _this.forEachElement("[data-bundle-discount-badge]", function(element) {
                    element.hidden = fixedDiscount <= 0;
                    element.textContent = fixedDiscount > 0 ? _this.t("bundleBuilderDiscountOff", "{amount} off", {
                        amount: _this.formatMoney(fixedDiscount, 0)
                    }) : "";
                });
            };
            _this.getFixedBundleDiscount = function() {
                if (!_this.selected.trios) return 0;
                if (_this.selected.eyeProducts && _this.selected.exfoliators) {
                    return Number(_this.discounts.trioEyeExfoliatorAmount || 0);
                }
                if (_this.selected.eyeProducts) return Number(_this.discounts.trioEyeAmount || 0);
                if (_this.selected.exfoliators) return Number(_this.discounts.trioExfoliatorAmount || 0);
                return 0;
            };
            _this.renderNavigation = function() {
                var isLastStep = _this.currentStep === STEPS.length - 1;
                var hasRequiredTrio = Boolean(_this.selected.trios);
                var nextStep = STEPS[_this.currentStep + 1];
                var skipsLockedSerum = (nextStep === null || nextStep === void 0 ? void 0 : nextStep.key) === "serums" && !_this.isSerumUnlocked();
                var isCartAction = isLastStep || skipsLockedSerum;
                var showBackButton = _this.currentStep > 0;
                _this.forEachElement("[data-bundle-back]", function(button) {
                    button.hidden = false;
                    button.classList.toggle("is-visible", showBackButton);
                    button.setAttribute("aria-hidden", String(!showBackButton));
                    button.tabIndex = showBackButton ? 0 : -1;
                    button.disabled = !showBackButton || _this.addingToCart;
                });
                _this.forEachElement("[data-bundle-next]", function(button) {
                    var isMobileAction = Boolean(button.closest("[data-mobile-routine]"));
                    button.textContent = _this.addingToCart ? _this.t("bundleBuilderAdding", "ADDING...") : isCartAction ? isMobileAction ? _this.t("bundleBuilderAddToCart", "ADD TO CART") : _this.t("bundleBuilderAddBundleToCart", "ADD BUNDLE TO CART") : _this.t("bundleBuilderNext", "NEXT");
                    button.disabled = _this.addingToCart || isCartAction && !hasRequiredTrio;
                });
            };
            _this.addBundleToCart = function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var products, response, payload, error_15;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            if (this.addingToCart) {
                                return [ 2 ];
                            }
                            if (!this.selected.trios) {
                                this.changeStep(0, false);
                                this.showStatus(this.t("bundleBuilderErrorSelectTrio", "Please select a TRIO to continue."), true);
                                this.scrollToBuilderContent();
                                return [ 2 ];
                            }
                            if (!this.isSerumUnlocked()) {
                                delete this.selected.serums;
                            }
                            products = this.getSelectedProducts();
                            this.addingToCart = true;
                            this.clearStatus();
                            this.renderNavigation();
                            _a.label = 1;

                          case 1:
                            _a.trys.push([ 1, 5, , 6 ]);
                            return [ 4, fetch("/cart/add.js", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({
                                    items: products.map(function(product) {
                                        return {
                                            id: product.variantId,
                                            quantity: 1
                                        };
                                    })
                                })
                            }) ];

                          case 2:
                            response = _a.sent();
                            if (!!response.ok) return [ 3, 4 ];
                            return [ 4, response.json().catch(function() {
                                return null;
                            }) ];

                          case 3:
                            payload = _a.sent();
                            throw new Error((payload === null || payload === void 0 ? void 0 : payload.description) || (payload === null || payload === void 0 ? void 0 : payload.message) || this.t("bundleBuilderErrorAddToCart", "Products could not be added to cart. Please try again."));

                          case 4:
                            window.location.assign("/cart");
                            return [ 3, 6 ];

                          case 5:
                            error_15 = _a.sent();
                            console.error("[StBundleBuilder] Failed to add bundle to cart", error_15);
                            this.showStatus(error_15 instanceof Error ? error_15.message : this.t("bundleBuilderErrorAddToCart", "Products could not be added to cart. Please try again."), true);
                            this.addingToCart = false;
                            this.renderNavigation();
                            return [ 3, 6 ];

                          case 6:
                            return [ 2 ];
                        }
                    });
                });
            };
            _this.toggleMobileRoutine = function(button) {
                var _a;
                var items = (_a = _this.root) === null || _a === void 0 ? void 0 : _a.querySelector("[data-mobile-routine-items]");
                var mobileRoutine = button.closest("[data-mobile-routine]");
                var isExpanded = button.getAttribute("aria-expanded") === "true";
                button.setAttribute("aria-expanded", String(!isExpanded));
                button.classList.toggle("is-expanded", !isExpanded);
                mobileRoutine === null || mobileRoutine === void 0 ? void 0 : mobileRoutine.classList.toggle("is-expanded", !isExpanded);
                if (items) {
                    items.hidden = isExpanded;
                }
            };
            _this.showStatus = function(message, isError) {
                if (isError === void 0) {
                    isError = false;
                }
                _this.forEachElement("[data-bundle-status]", function(element) {
                    element.textContent = message;
                    element.classList.toggle("is-error", isError);
                });
            };
            _this.clearStatus = function() {
                _this.showStatus("");
            };
            _this.formatMoney = function(amount, fractionDigits) {
                if (fractionDigits === void 0) {
                    fractionDigits = 2;
                }
                var safeAmount = Number.isFinite(amount) ? amount : 0;
                return "$".concat(safeAmount.toFixed(fractionDigits));
            };
            _this.escapeHtml = function(value) {
                return String(value).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
            };
            return _this;
        }
        Object.defineProperty(StBundleBuilder.prototype, "discounts", {
            get: function() {
                var _a, _b;
                return (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.discounts) !== null && _b !== void 0 ? _b : DEFAULT_DISCOUNTS;
            },
            enumerable: false,
            configurable: true
        });
        return StBundleBuilder;
    }(st_module_92.StModule);
    exports.StBundleBuilder = StBundleBuilder;
});

define("_shopify.app.di.container", [ "require", "exports", "core/shopify-app/st-modules/_static/static", "core/shopify-app/st-modules/account/account", "core/shopify-app/st-modules/enrollment/enrollment", "core/shopify-app/st-modules/_general-methods/browser-history", "core/shopify-app/st-modules/_general-methods/form/cart-manipulation", "core/shopify-app/st-modules/_general-methods/cookies/cookies", "core/shopify-app/st-modules/_general-methods/form/customer-type", "core/shopify-app/st-modules/_general-methods/form/loader", "core/shopify-app/st-modules/_general-methods/general-methods", "core/shopify-app/st-modules/_general-methods/button/button-actions", "core/shopify-app/st-modules/_general-methods/form/form", "core/shopify-app/st-modules/_general-methods/notification", "core/shopify-app/st-modules/_general-methods/object-formatting", "core/shopify-app/st-modules/_di-container/di.container.public", "core/shopify-app/st-modules/enrollment/page-header/nav/enrollment-nav", "core/shopify-app/st-modules/enrollment/page/enrollment-submit", "core/shopify-app/st-modules/enrollment/_general/enrollment-class-config", "core/shopify-app/st-modules/_general-methods/form/fields/date-input", "core/shopify-app/st-modules/_general-methods/form/form-class-config", "core/shopify-app/st-modules/enrollment/_validation/enrollment-validation", "core/shopify-app/st-modules/enrollment/blocks/review-privacy/enrollment-section-review-privacy", "core/shopify-app/st-modules/enrollment/blocks/account-details/enrollment-section-account-details", "core/shopify-app/st-modules/enrollment/blocks/business-info/enrollment-section-business-details", "core/shopify-app/st-modules/enrollment/_validation/enrollment-validation-setup", "core/shopify-app/st-modules/account/_general/account-class-config", "core/shopify-app/st-modules/search-sponsor/search-sponsor", "core/shopify-app/st-modules/search-sponsor/sponsor-search-class-config", "core/shopify-app/st-modules/enrollment-account/enrollment-account", "core/shopify-app/st-modules/enrollment-account/enrollment-account-class-config", "core/shopify-app/st-modules/enrollment/blocks/optional-kits/enrollment-section-optional-kits", "core/shopify-app/st-modules/enrollment/blocks/required-kits/enrollment-section-required-kits", "core/shopify-app/st-modules/enrollment/_general/enrollment-store", "core/shopify-app/st-modules/enrollment/blocks/review-info/enrollment-review", "core/shopify-app/st-modules/enrollment/page/enrollment-page", "core/shopify-app/st-modules/_general-methods/currency", "core/shopify-app/st-modules/enrollment/blocks/review-info/enrollment-review-cart", "core/shopify-app/st-modules/_general-methods/form/formatting", "core/shopify-app/st-modules/enrollment/blocks/account-details/account-details-helpers", "core/shopify-app/st-modules/enrollment/blocks/business-info/business-details-helpers", "core/shopify-app/st-modules/account/header/backoffice-sso/backoffice-sso", "core/shopify-app/st-modules/account/blocks/web-alias-edit/web-alias-edit", "core/shopify-app/st-modules/account/blocks/personal-site/personal-site", "core/shopify-app/st-modules/account/blocks/order-history/order-history", "extension/shopify-app/st-modules/cart/cart", "core/shopify-app/st-modules/enrollment-account/enrollment-account-repeat-password-validation", "extension/shopify-app/st-modules/account-register/account-register-extend", "core/shopify-app/st-modules/main/auto-apply-promo", "core/shopify-app/st-modules/representative-redirect-page/representative-redirect-page", "core/shopify-app/st-modules/representative-redirect-page/representative-redirect-page-class-config", "core/shopify-app/st-modules/account-register/account-register-class-config", "core/shopify-app/st-modules/account-login/account-login", "core/shopify-app/st-modules/account-login/account-login-class-config", "core/shopify-app/st-modules/search-sponsor/search-sponsor-guard", "core/shopify-app/st-modules/search-sponsor/search-sponsor-service", "core/shopify-app/st-modules/reset-password/reset-password-class-config", "core/shopify-app/st-modules/reset-password/reset-password", "core/shopify-app/st-modules/enrollment/enrollment-cleanup", "core/shopify-app/st-modules/referral/referral", "core/shopify-app/st-modules/account/blocks/coupon-codes/coupon-codes", "core/shopify-app/st-modules/auth/auth", "extension/shopify-app/st-modules/webalias/inject-representative-info", "extension/shopify-app/st-modules/rep-site-detail/rep-site-detail", "extension/shopify-app/st-modules/rep-site-detail/rep-site-detail-class-config", "extension/shopify-app/st-modules/webalias/webalias-class-config.extended", "extension/shopify-app/st-modules/webalias/webalias.extended", "extension/shopify-app/st-modules/webalias/shopining-with/party-banner-info", "extension/shopify-app/st-modules/party/party", "extension/shopify-app/st-modules/party/party-check", "extension/shopify-app/st-modules/party/party-service", "extension/shopify-app/st-modules/header/header", "extension/shopify-app/st-modules/free-sample/free-sample", "extension/shopify-app/st-modules/free-sample/free-sample-class-config", "extension/shopify-app/st-modules/samples-set/samples-set", "extension/shopify-app/st-modules/samples-set/samples-set-class-config", "extension/shopify-app/st-modules/free-shipping/free-shipping", "extension/shopify-app/st-modules/samples-set/cart-guard", "extension/shopify-app/st-modules/account-register/st-market-type", "extension/shopify-app/st-modules/cart/cartSaveLoginInterceptor", "extension/shopify-app/st-modules/cart/prefilCartOnLogin", "extension/shopify-app/st-modules/account-login/customers-login", "extension/shopify-app/st-modules/shopping-on-behalf/shopping-on-behalf", "extension/shopify-app/st-modules/account/blocks/credit-ledger/credit-ledger", "extension/shopify-app/st-modules/consultant-discount-banner/consultant-discount-banner", "extension/shopify-app/st-modules/newsletter-popup/newsletter-popup", "extension/shopify-app/st-modules/catalog-page/product-category", "extension/shopify-app/st-modules/account/header/nav/account-nav.extended", "extension/shopify-app/st-modules/account/blocks/order-history/order-history-extend", "extension/shopify-app/st-modules/account/blocks/personal-info/personal-info-extend", "extension/shopify-app/st-modules/account/blocks/addresses/addresses-extend", "extension/shopify-app/st-modules/share-cart/share-cart-class-config", "extension/shopify-app/st-modules/share-cart/share-cart-drawer", "extension/shopify-app/st-modules/share-cart/share-cart-landing", "extension/shopify-app/st-modules/account/blocks/account-share-cart/account-share-cart-utils", "extension/shopify-app/st-modules/account/blocks/account-share-cart/account-share-cart", "extension/shopify-app/st-modules/rep-lookup/rep-lookup", "extension/shopify-app/st-modules/product/product", "extension/shopify-app/st-modules/bundle-builder/bundle-builder" ], function(require, exports, static_3, account_1, enrollment_1, browser_history_1, cart_manipulation_1, cookies_1, customer_type_1, loader_1, general_methods_1, button_actions_2, form_1, notification_15, object_formatting_1, di_container_public_1, enrollment_nav_1, enrollment_submit_1, enrollment_class_config_1, date_input_1, form_class_config_1, enrollment_validation_1, enrollment_section_review_privacy_1, enrollment_section_account_details_1, enrollment_section_business_details_1, enrollment_validation_setup_1, account_class_config_1, search_sponsor_1, sponsor_search_class_config_1, enrollment_account_1, enrollment_account_class_config_1, enrollment_section_optional_kits_1, enrollment_section_required_kits_1, enrollment_store_1, enrollment_review_1, enrollment_page_1, currency_3, enrollment_review_cart_1, formatting_1, account_details_helpers_1, business_details_helpers_1, backoffice_sso_1, web_alias_edit_1, personal_site_1, order_history_2, cart_3, enrollment_account_repeat_password_validation_1, account_register_extend_1, auto_apply_promo_1, representative_redirect_page_1, representative_redirect_page_class_config_1, account_register_class_config_1, account_login_1, account_login_class_config_1, search_sponsor_guard_1, search_sponsor_service_1, reset_password_class_config_1, reset_password_1, enrollment_cleanup_1, referral_1, coupon_codes_1, auth_1, inject_representative_info_2, rep_site_detail_1, rep_site_detail_class_config_1, webalias_class_config_extended_1, webalias_extended_1, party_banner_info_1, party_1, party_check_1, party_service_1, header_1, free_sample_1, free_sample_class_config_1, samples_set_1, samples_set_class_config_1, free_shipping_1, cart_guard_1, st_market_type_1, cartSaveLoginInterceptor_1, prefilCartOnLogin_1, customers_login_1, shopping_on_behalf_1, credit_ledger_1, consultant_discount_banner_1, newsletter_popup_1, product_category_1, account_nav_extended_1, order_history_extend_1, personal_info_extend_1, addresses_extend_1, share_cart_class_config_1, share_cart_drawer_1, share_cart_landing_1, account_share_cart_utils_1, account_share_cart_1, rep_lookup_1, product_1, bundle_builder_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAppDIConfig = void 0;
    var StAppDIConfig = function() {
        function StAppDIConfig() {
            var _this = this;
            this.className = "AppDIConfig";
            this.init = function() {};
            this.components = function() {
                _this.StStaticComponent = static_3.StStatic.Instance();
                _this.StAuthComponent = new auth_1.StAuth();
                _this.DiContainerPublicComponent = new di_container_public_1.DiContainerPublic();
                _this.StObjectFormattingComponent = new object_formatting_1.StObjectFormatting();
                _this.StBrowserHistoryComponent = new browser_history_1.StBrowserHistory(_this.StObjectFormattingComponent);
                _this.StCartManipulationComponent = new cart_manipulation_1.StCartManipulation();
                _this.StCookiesComponent = new cookies_1.StCookies();
                _this.StCustomerTypeComponent = new customer_type_1.StCustomerType();
                _this.StLoaderComponent = new loader_1.StLoader();
                _this.StButtonActionsComponent = new button_actions_2.StButtonActions();
                _this.StNotificationComponent = new notification_15.StNotification();
                _this.StFormConfigComponent = new form_class_config_1.StFormClassConfig();
                _this.StGeneralMethodsComponent = new general_methods_1.StGeneralMethods();
                _this.StCurrencyComponent = new currency_3.StCurrency();
                _this.StFormattingComponent = new formatting_1.StFormFormatting();
                _this.StAutoApplyPromoComponent = new auto_apply_promo_1.StAutoApplyPromo();
                _this.StCartComponent = new cart_3.StCart();
                _this.StEnrollmentClassConfigComponent = new enrollment_class_config_1.StEnrollmentClassConfig();
                _this.StEnrollmentAccountClassConfigComponent = new enrollment_account_class_config_1.StEnrollmentAccountClassConfig();
                _this.StEnrollmentSectionPrivacyComponent = new enrollment_section_review_privacy_1.StEnrollmentSectionPrivacy(_this.StEnrollmentClassConfigComponent);
                _this.StEnrollmentAccountDetailsHelpersComponent = new account_details_helpers_1.StEnrollmentAccountDetailsHelpers(_this.StFormattingComponent, _this.StEnrollmentClassConfigComponent);
                _this.StEnrollmentBusinessDetailsHelpersComponent = new business_details_helpers_1.StEnrollmentBusinessDetailsHelpers(_this.StFormattingComponent, _this.StEnrollmentClassConfigComponent);
                _this.StEnrollmentSectionAccountDetailsComponent = new enrollment_section_account_details_1.StEnrollmentSectionAccountDetails();
                _this.StEnrollmentSectionBusinessDetailsComponent = new enrollment_section_business_details_1.StEnrollmentSectionBusinessDetails();
                _this.StEnrollmentStoreComponent = new enrollment_store_1.StEnrollmentStore(_this.StEnrollmentClassConfigComponent, _this.StCartComponent);
                _this.StEnrollmentPageComponent = new enrollment_page_1.StEnrollmentPage(_this.StEnrollmentClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StAccountClassConfigComponent = new account_class_config_1.StAccountClassConfig();
                _this.StSearchSponsorClassConfigComponent = new sponsor_search_class_config_1.StSearchSponsorClassConfig();
                _this.StDateInputComponent = new date_input_1.StDateInput(_this.StFormConfigComponent);
                _this.StFormComponent = new form_1.StForm(_this.StFormConfigComponent, _this.StDateInputComponent);
                _this.StWebAliasClassConfigComponent = new webalias_class_config_extended_1.StWebAliasClassConfigExtended();
                _this.StInjectRepresentativeInfoComponent = new inject_representative_info_2.StInjectRepresentativeInfoExtended(_this.StWebAliasClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StSearchSponsorGuardComponent = new search_sponsor_guard_1.StSearchSponsorGuard(_this.StSearchSponsorClassConfigComponent, _this.StBrowserHistoryComponent, _this.StObjectFormattingComponent, _this.StGeneralMethodsComponent, _this.StCartComponent);
                _this.StAccountPersonalSiteComponent = new personal_site_1.StAccountPersonalSite(_this.StAccountClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StShareCartLandingComponent = new share_cart_landing_1.StShareCartLanding(_this.StObjectFormattingComponent, _this.StCartComponent);
                _this.StWebAliasComponent = new webalias_extended_1.StWebAliasExtended(_this.StWebAliasClassConfigComponent, _this.StBrowserHistoryComponent, _this.StObjectFormattingComponent, _this.StCookiesComponent, _this.StCustomerTypeComponent, _this.StGeneralMethodsComponent, _this.StInjectRepresentativeInfoComponent, _this.StCartComponent, _this.StSearchSponsorGuardComponent, _this.StAccountPersonalSiteComponent, _this.StShareCartLandingComponent);
                _this.StSearchSponsorService = new search_sponsor_service_1.StSearchSponsorService();
                _this.StSearchSponsorComponent = new search_sponsor_1.StSearchSponsor(_this.StGeneralMethodsComponent, _this.StObjectFormattingComponent, _this.StBrowserHistoryComponent, _this.StSearchSponsorClassConfigComponent, _this.StCookiesComponent, _this.StCartComponent, _this.StSearchSponsorService);
                _this.StEnrollmentValidationComponent = new enrollment_validation_1.StEnrollmentValidation(_this.StEnrollmentClassConfigComponent, _this.StNotificationComponent, _this.StEnrollmentPageComponent);
                _this.StEnrollmentValidationSetupComponent = new enrollment_validation_setup_1.StEnrollmentValidationSetup(_this.StEnrollmentValidationComponent, _this.StEnrollmentSectionPrivacyComponent, _this.StEnrollmentSectionAccountDetailsComponent, _this.StEnrollmentSectionBusinessDetailsComponent);
                _this.StEnrollmentReviewCartComponent = new enrollment_review_cart_1.StEnrollmentReviewCart(_this.StEnrollmentClassConfigComponent, _this.StEnrollmentStoreComponent, _this.StCurrencyComponent);
                _this.StEnrollmentOptionalKitsComponent = new enrollment_section_optional_kits_1.StEnrollmentOptionalKits(_this.StEnrollmentClassConfigComponent, _this.StEnrollmentStoreComponent, _this.StEnrollmentReviewCartComponent);
                _this.StEnrollmentRequiredKitsComponent = new enrollment_section_required_kits_1.StEnrollmentRequiredKits(_this.StEnrollmentClassConfigComponent, _this.StEnrollmentStoreComponent, _this.StEnrollmentReviewCartComponent);
                _this.StEnrollmentReviewComponent = new enrollment_review_1.StEnrollmentReview(_this.StEnrollmentClassConfigComponent, _this.StEnrollmentStoreComponent, _this.StGeneralMethodsComponent, _this.StEnrollmentPageComponent, _this.StCurrencyComponent, _this.StFormComponent, _this.StEnrollmentReviewCartComponent);
                _this.StEnrollmentActionsComponent = new enrollment_submit_1.StEnrollmentActions(_this.StEnrollmentClassConfigComponent, _this.StNotificationComponent);
                _this.StEnrollmentNavComponent = new enrollment_nav_1.StEnrollmentNav(_this.StEnrollmentClassConfigComponent, _this.StEnrollmentActionsComponent, _this.StEnrollmentOptionalKitsComponent, _this.StEnrollmentRequiredKitsComponent, _this.StEnrollmentStoreComponent, _this.StFormComponent, _this.StButtonActionsComponent, _this.StEnrollmentValidationComponent, _this.StEnrollmentValidationSetupComponent, _this.StNotificationComponent, _this.StEnrollmentReviewComponent, _this.StEnrollmentPageComponent);
                _this.StEnrollmentComponent = new enrollment_1.StEnrollment(_this.StEnrollmentClassConfigComponent);
                _this.StEnrollmentCleanupComponent = new enrollment_cleanup_1.StEnrollmentCleanup(_this.StCartComponent);
                _this.StEnrollmentAccountComponent = new enrollment_account_1.StEnrollmentAccount(_this.StEnrollmentAccountClassConfigComponent, _this.StButtonActionsComponent, _this.StNotificationComponent, _this.StFormComponent, _this.StGeneralMethodsComponent, _this.StEnrollmentCleanupComponent, _this.StCartComponent);
                _this.StAccountNavComponent = new account_nav_extended_1.StAccountNavExtended(_this.StAccountClassConfigComponent, _this.StObjectFormattingComponent, _this.StBrowserHistoryComponent, _this.StGeneralMethodsComponent, _this.StCartComponent);
                _this.StBackofficeSSOComponent = new backoffice_sso_1.StBackofficeSSO(_this.StAccountClassConfigComponent, _this.StNotificationComponent);
                _this.StAccountWebAliasEditComponent = new web_alias_edit_1.StAccountWebAliasEdit(_this.StAccountClassConfigComponent, _this.StGeneralMethodsComponent, _this.StNotificationComponent, _this.StButtonActionsComponent, _this.StFormComponent, _this.StFormattingComponent);
                _this.StAccountAddressesComponent = new addresses_extend_1.StAccountAddressesExtended(_this.StAccountClassConfigComponent, _this.StGeneralMethodsComponent, _this.StButtonActionsComponent, _this.StNotificationComponent);
                _this.StAccountPersonalInfoComponent = new personal_info_extend_1.StAccountPersonalInfoExtended(_this.StAccountClassConfigComponent, _this.StFormComponent, _this.StFormattingComponent, _this.StButtonActionsComponent, _this.StNotificationComponent, _this.StGeneralMethodsComponent);
                _this.StAccountOrderHistoryComponent = new order_history_2.StAccountOrderHistory(_this.StAccountClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StOrderHistoryComponent = new order_history_extend_1.StAccountOrderHistoryExtended(_this.StAccountClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StAccountComponent = new account_1.StAccount(_this.StFormComponent);
                _this.StFreeSampleClassConfig = new free_sample_class_config_1.StFreeSampleClassConfig();
                _this.StFreeSampleComponent = new free_sample_1.StFreeSample(_this.StFreeSampleClassConfig, _this.StFormComponent, _this.StGeneralMethodsComponent, _this.StCartComponent);
                _this.StSampleSetClassConfig = new samples_set_class_config_1.StSampleSetClassConfig();
                _this.StSampleSetComponent = new samples_set_1.StSampleSet(_this.StSampleSetClassConfig, _this.StCartComponent);
                _this.StCartGuardComponent = new cart_guard_1.StCartGuard(_this.StCartComponent);
                _this.StMarketTypeLoader = new st_market_type_1.StMarketTypeLoader();
                _this.StCartInterceptor = new cartSaveLoginInterceptor_1.StCartInterceptor();
                _this.StPrefilCart = new prefilCartOnLogin_1.StPrefilCart();
                _this.StAccountLoginClassConfigComponent = new account_login_class_config_1.StAccountLoginClassConfig();
                _this.StAccountLoginComponent = new account_login_1.StAccountLogin(_this.StFormComponent, _this.StNotificationComponent, _this.StButtonActionsComponent, _this.StAccountLoginClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StAccountRegisterClassConfigComponent = new account_register_class_config_1.StAccountRegisterClassConfig();
                _this.StAccountRegisterComponent = new account_register_extend_1.StAccountRegisterExtended(_this.StFormComponent, _this.StNotificationComponent, _this.StButtonActionsComponent, _this.StAccountRegisterClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StResetPasswordClassConfigComponent = new reset_password_class_config_1.StResetPasswordClassConfig();
                _this.StResetPasswordComponent = new reset_password_1.StResetPassword(_this.StFormComponent, _this.StNotificationComponent, _this.StButtonActionsComponent, _this.StResetPasswordClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StEnrollmentRepeatPasswordValidationComponent = new enrollment_account_repeat_password_validation_1.StEnrollmentRepeatPasswordValidation(_this.StEnrollmentAccountClassConfigComponent);
                _this.StRepresentativeRedirectClassConfigComponent = new representative_redirect_page_class_config_1.StRepresentativeRedirectClassConfig();
                _this.StRepresentativeRedirectComponent = new representative_redirect_page_1.StRepresentativeRedirectPage(_this.StRepresentativeRedirectClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StReferralComponent = new referral_1.StReferral(_this.StGeneralMethodsComponent, _this.StObjectFormattingComponent, _this.StNotificationComponent);
                _this.StCouponCodesComponent = new coupon_codes_1.StCouponCodes();
                _this.StReplicatedSiteDetailClassConfig = new rep_site_detail_class_config_1.StReplicatedSiteDetailClassConfig();
                _this.StReplicatedSiteDetail = new rep_site_detail_1.StReplicatedSiteDetail(_this.StReplicatedSiteDetailClassConfig, _this.StGeneralMethodsComponent, _this.StObjectFormattingComponent, _this.StNotificationComponent);
                _this.StPartyBannerInfoComponent = new party_banner_info_1.StPartyBannerInfo(_this.StObjectFormattingComponent);
                _this.StPartyService = new party_service_1.StPartyService(_this.StObjectFormattingComponent);
                _this.StPartyComponent = new party_1.StParty(_this.StObjectFormattingComponent, _this.StPartyService, _this.StCartComponent);
                _this.StPartyCheckComponent = new party_check_1.StPartyCheck(_this.StObjectFormattingComponent);
                _this.StHeaderComponent = new header_1.StHeader(_this.StObjectFormattingComponent);
                _this.StFreeShippingComponent = new free_shipping_1.StFreeShipping(_this.StGeneralMethodsComponent, _this.StCartComponent, _this.StFreeSampleComponent);
                _this.StOverideLoginComponent = new customers_login_1.StOverideLogin(_this.StGeneralMethodsComponent, _this.StNotificationComponent);
                _this.StShoppingOnBehalfComponent = new shopping_on_behalf_1.StShoppingOnBehalf();
                _this.StCreditLedger = new credit_ledger_1.StCreditLedger(_this.StCurrencyComponent);
                _this.StConsultantDiscountBannerComponent = new consultant_discount_banner_1.StConsultantDiscountBanner(_this.StGeneralMethodsComponent, _this.StCartComponent);
                _this.StNewsLetterComponent = new newsletter_popup_1.StNewsletterPopup();
                _this.StCatalogPageComponent = new product_category_1.StCatalogPage(_this.StObjectFormattingComponent);
                _this.StProductComponent = new product_1.StProduct();
                _this.StShareCartClassConfigComponent = new share_cart_class_config_1.StShareCartClassConfig();
                _this.StShareCartDrawerComponent = new share_cart_drawer_1.StShareCartDrawer(_this.StShareCartClassConfigComponent, _this.StGeneralMethodsComponent, _this.StCartComponent, _this.StObjectFormattingComponent, _this.StNotificationComponent);
                _this.StShareCartUtilsComponent = new account_share_cart_utils_1.StAccountShareCartUtils(_this.StGeneralMethodsComponent, _this.StObjectFormattingComponent);
                _this.StAccountShareCartComponent = new account_share_cart_1.StAccountShareCart(_this.StObjectFormattingComponent, _this.StGeneralMethodsComponent, _this.StCartComponent, _this.StShareCartUtilsComponent);
                _this.StBundleBuilderComponent = new bundle_builder_1.StBundleBuilder();
                _this.StRepLookup = new rep_lookup_1.StRepLookup(_this.StWebAliasComponent);
            };
            this.hierarchy = function(appName) {
                var hierarchy = [ _this.DiContainerPublicComponent, _this.StStaticComponent ];
                switch (appName) {
                  case "main":
                    hierarchy = hierarchy.concat([ _this.StBackofficeSSOComponent, _this.StAuthComponent, _this.StAutoApplyPromoComponent, _this.StWebAliasComponent, _this.StSearchSponsorGuardComponent, _this.StSearchSponsorComponent, _this.StReferralComponent, _this.StPartyComponent, _this.StPartyService, _this.StPartyCheckComponent, _this.StPartyBannerInfoComponent, _this.StHeaderComponent, _this.StFreeShippingComponent, _this.StFreeSampleComponent, _this.StSampleSetComponent, _this.StCartGuardComponent, _this.StCartInterceptor, _this.StPrefilCart, _this.StMarketTypeLoader, _this.StShoppingOnBehalfComponent, _this.StConsultantDiscountBannerComponent, _this.StNewsLetterComponent, _this.StCatalogPageComponent, _this.StProductComponent, _this.StShoppingOnBehalfComponent, _this.StShareCartClassConfigComponent, _this.StShareCartDrawerComponent, _this.StShareCartLandingComponent, _this.StRepLookup, _this.StBundleBuilderComponent ]);
                    break;

                  case "account":
                    hierarchy = hierarchy.concat([ _this.StAccountComponent, _this.StAccountNavComponent, _this.StAccountWebAliasEditComponent, _this.StAccountPersonalSiteComponent, _this.StAccountAddressesComponent, _this.StAccountPersonalInfoComponent, _this.StAccountOrderHistoryComponent, _this.StCouponCodesComponent, _this.StCreditLedger, _this.StOrderHistoryComponent, _this.StAccountShareCartComponent ]);
                    break;

                  case "account-login":
                    hierarchy = hierarchy.concat([ _this.StAccountLoginComponent, _this.StOverideLoginComponent ]);
                    break;

                  case "account-register":
                    hierarchy = hierarchy.concat([ _this.StAccountRegisterComponent ]);
                    break;

                  case "reset-password":
                    hierarchy = hierarchy.concat([ _this.StResetPasswordComponent ]);
                    break;

                  case "enrollment":
                    hierarchy = hierarchy.concat([ _this.StEnrollmentComponent, _this.StEnrollmentReviewComponent, _this.StEnrollmentNavComponent, _this.StEnrollmentAccountDetailsHelpersComponent, _this.StEnrollmentBusinessDetailsHelpersComponent ]);
                    break;

                  case "enrollment-account":
                    hierarchy = hierarchy.concat([ _this.StEnrollmentAccountComponent, _this.StEnrollmentRepeatPasswordValidationComponent ]);
                    break;

                  case "checkout":
                    hierarchy = hierarchy.concat([]);
                    break;

                  case "representative-redirect-page":
                    hierarchy = hierarchy.concat([ _this.StRepresentativeRedirectComponent, _this.StRepresentativeRedirectClassConfigComponent, _this.StGeneralMethodsComponent ]);
                    break;

                  case "enrollment-thank-you":
                    hierarchy = hierarchy.concat([]);
                    break;

                  case "rep-site-detail":
                    hierarchy = hierarchy.concat([ _this.StReplicatedSiteDetail, _this.StReplicatedSiteDetailClassConfig ]);
                    break;

                  default:
                    console.error("Unrecognized app provided to st-app. App name: " + appName);
                }
                return hierarchy;
            };
            this.components();
        }
        Object.defineProperty(StAppDIConfig, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        return StAppDIConfig;
    }();
    exports.StAppDIConfig = StAppDIConfig;
});

define("core/shopify-app/st-modules/_di-container/di.container", [ "require", "exports", "_shopify.app.di.container", "core/shopify-app/st-modules/_di-container/di.container.setup" ], function(require, exports, _shopify_app_di_container_1, di_container_setup_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDIContainer = void 0;
    var StDIContainer = function() {
        function StDIContainer() {
            this.className = "DI";
        }
        StDIContainer.run = function(appName) {
            new di_container_setup_1.StDIContainerSetup(appName, _shopify_app_di_container_1.StAppDIConfig);
        };
        return StDIContainer;
    }();
    exports.StDIContainer = StDIContainer;
});

define("core/shopify-app/st-modules/_general-methods/init-retry", [ "require", "exports", "core/shopify-app/st-modules/_static/static" ], function(require, exports, static_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StInitRetry = void 0;
    var StInitRetry = function() {
        function StInitRetry() {
            var _this_1 = this;
            this.className = "InitRetry";
            this.recursiveInitRetry = 0;
            this.timeout = 200;
            this.init = function() {};
            this.initWithCondition = function(params) {
                var _this = _this_1;
                var def = {
                    conditionGeneratorParams: [],
                    callbackParams: [],
                    noOfRetries: 6
                };
                var completeParams = __assign(__assign({}, def), params);
                var initCondition = completeParams.conditionGenerator.apply(_this, completeParams.conditionGeneratorParams);
                if (initCondition) {
                    completeParams.callback.apply(_this, completeParams.callbackParams);
                } else {
                    setTimeout(function() {
                        if (_this.recursiveInitRetry < completeParams.noOfRetries) {
                            _this.recursiveInitRetry++;
                            _this.initWithCondition(completeParams);
                        }
                    }, _this_1.timeout);
                }
            };
            this.endpoint = static_4.StStatic.Instance().obtainStaticEndpoints();
        }
        StInitRetry.Instance = function() {
            return this._instance || (this._instance = new this());
        };
        return StInitRetry;
    }();
    exports.StInitRetry = StInitRetry;
});

define("core/shopify-app/st-modules/_general-methods/shopify-ajax", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_93) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShopifyAjax = void 0;
    var StShopifyAjax = function(_super) {
        __extends(StShopifyAjax, _super);
        function StShopifyAjax() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ShopifyAjax";
            _this.updateCartAttributes = function(attributes, callback, callbackParams) {
                if (callback === void 0) {
                    callback = function() {};
                }
                if (callbackParams === void 0) {
                    callbackParams = [];
                }
                if (!!attributes) {
                    var fnReference_1 = _this;
                    var request_2 = new XMLHttpRequest();
                    request_2.open("POST", "/cart/update.js", true);
                    request_2.withCredentials = true;
                    request_2.setRequestHeader("Content-Type", "application/json");
                    request_2.onreadystatechange = function() {
                        if (request_2.readyState === 4) {
                            try {
                                var resp = JSON.parse(request_2.response);
                                callbackParams.unshift(resp);
                                callback.apply(fnReference_1, callbackParams);
                            } catch (e) {
                                console.error(e);
                                console.error("Failed to update shopify cart attributes!");
                            }
                        }
                    };
                    request_2.send(JSON.stringify({
                        attributes: attributes
                    }));
                }
            };
            return _this;
        }
        return StShopifyAjax;
    }(st_module_93.StModule);
    exports.StShopifyAjax = StShopifyAjax;
});

define("core/shopify-app/st-modules/enrollment/enrollment-cleanup-checkout", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_94) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentCleanupCheckout = void 0;
    var StEnrollmentCleanupCheckout = function(_super) {
        __extends(StEnrollmentCleanupCheckout, _super);
        function StEnrollmentCleanupCheckout(enrollmentCleanup) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StEnrollmentCleanupCheckout";
            _this.init = function() {
                _this.enrollmentCleanup.clearCartAttributes();
            };
            _this.enrollmentCleanup = enrollmentCleanup;
            return _this;
        }
        return StEnrollmentCleanupCheckout;
    }(st_module_94.StModule);
    exports.StEnrollmentCleanupCheckout = StEnrollmentCleanupCheckout;
});

(function() {
    "use strict";
    class StApp extends HTMLElement {
        static get observedAttributes() {
            return [ "app" ];
        }
        constructor() {
            super();
        }
        attributeChangedCallback(name, oldValue, newValue) {
            if (name === "app" && oldValue !== newValue) {
                this.initApp(newValue);
            }
        }
        initApp(appName) {
            require([ "core/shopify-app/st-modules/_di-container/di.container" ], function(module) {
                module.StDIContainer.run(appName);
            });
        }
    }
    customElements.define("st-app", StApp);
})();

window.define = null;